// Chart.js bundled for PhoenixKit email dashboard charts
// Guard: skip if Chart.js already provided by the parent app
if (typeof window.Chart === "undefined") {
/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).Chart=e()}(this,(function(){"use strict";var t=Object.freeze({__proto__:null,get Colors(){return Jo},get Decimation(){return ta},get Filler(){return ba},get Legend(){return Ma},get SubTitle(){return Pa},get Title(){return ka},get Tooltip(){return Na}});function e(){}const i=(()=>{let t=0;return()=>t++})();function s(t){return null==t}function n(t){if(Array.isArray&&Array.isArray(t))return!0;const e=Object.prototype.toString.call(t);return"[object"===e.slice(0,7)&&"Array]"===e.slice(-6)}function o(t){return null!==t&&"[object Object]"===Object.prototype.toString.call(t)}function a(t){return("number"==typeof t||t instanceof Number)&&isFinite(+t)}function r(t,e){return a(t)?t:e}function l(t,e){return void 0===t?e:t}const h=(t,e)=>"string"==typeof t&&t.endsWith("%")?parseFloat(t)/100:+t/e,c=(t,e)=>"string"==typeof t&&t.endsWith("%")?parseFloat(t)/100*e:+t;function d(t,e,i){if(t&&"function"==typeof t.call)return t.apply(i,e)}function u(t,e,i,s){let a,r,l;if(n(t))if(r=t.length,s)for(a=r-1;a>=0;a--)e.call(i,t[a],a);else for(a=0;a<r;a++)e.call(i,t[a],a);else if(o(t))for(l=Object.keys(t),r=l.length,a=0;a<r;a++)e.call(i,t[l[a]],l[a])}function f(t,e){let i,s,n,o;if(!t||!e||t.length!==e.length)return!1;for(i=0,s=t.length;i<s;++i)if(n=t[i],o=e[i],n.datasetIndex!==o.datasetIndex||n.index!==o.index)return!1;return!0}function g(t){if(n(t))return t.map(g);if(o(t)){const e=Object.create(null),i=Object.keys(t),s=i.length;let n=0;for(;n<s;++n)e[i[n]]=g(t[i[n]]);return e}return t}function p(t){return-1===["__proto__","prototype","constructor"].indexOf(t)}function m(t,e,i,s){if(!p(t))return;const n=e[t],a=i[t];o(n)&&o(a)?x(n,a,s):e[t]=g(a)}function x(t,e,i){const s=n(e)?e:[e],a=s.length;if(!o(t))return t;const r=(i=i||{}).merger||m;let l;for(let e=0;e<a;++e){if(l=s[e],!o(l))continue;const n=Object.keys(l);for(let e=0,s=n.length;e<s;++e)r(n[e],t,l,i)}return t}function b(t,e){return x(t,e,{merger:_})}function _(t,e,i){if(!p(t))return;const s=e[t],n=i[t];o(s)&&o(n)?b(s,n):Object.prototype.hasOwnProperty.call(e,t)||(e[t]=g(n))}const y={"":t=>t,x:t=>t.x,y:t=>t.y};function v(t){const e=t.split("."),i=[];let s="";for(const t of e)s+=t,s.endsWith("\\")?s=s.slice(0,-1)+".":(i.push(s),s="");return i}function M(t,e){const i=y[e]||(y[e]=function(t){const e=v(t);return t=>{for(const i of e){if(""===i)break;t=t&&t[i]}return t}}(e));return i(t)}function w(t){return t.charAt(0).toUpperCase()+t.slice(1)}const k=t=>void 0!==t,S=t=>"function"==typeof t,P=(t,e)=>{if(t.size!==e.size)return!1;for(const i of t)if(!e.has(i))return!1;return!0};function D(t){return"mouseup"===t.type||"click"===t.type||"contextmenu"===t.type}const C=Math.PI,O=2*C,A=O+C,T=Number.POSITIVE_INFINITY,L=C/180,E=C/2,R=C/4,I=2*C/3,z=Math.log10,F=Math.sign;function V(t,e,i){return Math.abs(t-e)<i}function B(t){const e=Math.round(t);t=V(t,e,t/1e3)?e:t;const i=Math.pow(10,Math.floor(z(t))),s=t/i;return(s<=1?1:s<=2?2:s<=5?5:10)*i}function W(t){const e=[],i=Math.sqrt(t);let s;for(s=1;s<i;s++)t%s==0&&(e.push(s),e.push(t/s));return i===(0|i)&&e.push(i),e.sort(((t,e)=>t-e)).pop(),e}function N(t){return!function(t){return"symbol"==typeof t||"object"==typeof t&&null!==t&&!(Symbol.toPrimitive in t||"toString"in t||"valueOf"in t)}(t)&&!isNaN(parseFloat(t))&&isFinite(t)}function H(t,e){const i=Math.round(t);return i-e<=t&&i+e>=t}function j(t,e,i){let s,n,o;for(s=0,n=t.length;s<n;s++)o=t[s][i],isNaN(o)||(e.min=Math.min(e.min,o),e.max=Math.max(e.max,o))}function $(t){return t*(C/180)}function Y(t){return t*(180/C)}function U(t){if(!a(t))return;let e=1,i=0;for(;Math.round(t*e)/e!==t;)e*=10,i++;return i}function X(t,e){const i=e.x-t.x,s=e.y-t.y,n=Math.sqrt(i*i+s*s);let o=Math.atan2(s,i);return o<-.5*C&&(o+=O),{angle:o,distance:n}}function q(t,e){return Math.sqrt(Math.pow(e.x-t.x,2)+Math.pow(e.y-t.y,2))}function K(t,e){return(t-e+A)%O-C}function G(t){return(t%O+O)%O}function J(t,e,i,s){const n=G(t),o=G(e),a=G(i),r=G(o-n),l=G(a-n),h=G(n-o),c=G(n-a);return n===o||n===a||s&&o===a||r>l&&h<c}function Z(t,e,i){return Math.max(e,Math.min(i,t))}function Q(t){return Z(t,-32768,32767)}function tt(t,e,i,s=1e-6){return t>=Math.min(e,i)-s&&t<=Math.max(e,i)+s}function et(t,e,i){i=i||(i=>t[i]<e);let s,n=t.length-1,o=0;for(;n-o>1;)s=o+n>>1,i(s)?o=s:n=s;return{lo:o,hi:n}}const it=(t,e,i,s)=>et(t,i,s?s=>{const n=t[s][e];return n<i||n===i&&t[s+1][e]===i}:s=>t[s][e]<i),st=(t,e,i)=>et(t,i,(s=>t[s][e]>=i));function nt(t,e,i){let s=0,n=t.length;for(;s<n&&t[s]<e;)s++;for(;n>s&&t[n-1]>i;)n--;return s>0||n<t.length?t.slice(s,n):t}const ot=["push","pop","shift","splice","unshift"];function at(t,e){t._chartjs?t._chartjs.listeners.push(e):(Object.defineProperty(t,"_chartjs",{configurable:!0,enumerable:!1,value:{listeners:[e]}}),ot.forEach((e=>{const i="_onData"+w(e),s=t[e];Object.defineProperty(t,e,{configurable:!0,enumerable:!1,value(...e){const n=s.apply(this,e);return t._chartjs.listeners.forEach((t=>{"function"==typeof t[i]&&t[i](...e)})),n}})})))}function rt(t,e){const i=t._chartjs;if(!i)return;const s=i.listeners,n=s.indexOf(e);-1!==n&&s.splice(n,1),s.length>0||(ot.forEach((e=>{delete t[e]})),delete t._chartjs)}function lt(t){const e=new Set(t);return e.size===t.length?t:Array.from(e)}const ht="undefined"==typeof window?function(t){return t()}:window.requestAnimationFrame;function ct(t,e){let i=[],s=!1;return function(...n){i=n,s||(s=!0,ht.call(window,(()=>{s=!1,t.apply(e,i)})))}}function dt(t,e){let i;return function(...s){return e?(clearTimeout(i),i=setTimeout(t,e,s)):t.apply(this,s),e}}const ut=t=>"start"===t?"left":"end"===t?"right":"center",ft=(t,e,i)=>"start"===t?e:"end"===t?i:(e+i)/2,gt=(t,e,i,s)=>t===(s?"left":"right")?i:"center"===t?(e+i)/2:e;function pt(t,e,i){const n=e.length;let o=0,a=n;if(t._sorted){const{iScale:r,vScale:l,_parsed:h}=t,c=t.dataset&&t.dataset.options?t.dataset.options.spanGaps:null,d=r.axis,{min:u,max:f,minDefined:g,maxDefined:p}=r.getUserBounds();if(g){if(o=Math.min(it(h,d,u).lo,i?n:it(e,d,r.getPixelForValue(u)).lo),c){const t=h.slice(0,o+1).reverse().findIndex((t=>!s(t[l.axis])));o-=Math.max(0,t)}o=Z(o,0,n-1)}if(p){let t=Math.max(it(h,r.axis,f,!0).hi+1,i?0:it(e,d,r.getPixelForValue(f),!0).hi+1);if(c){const e=h.slice(t-1).findIndex((t=>!s(t[l.axis])));t+=Math.max(0,e)}a=Z(t,o,n)-o}else a=n-o}return{start:o,count:a}}function mt(t){const{xScale:e,yScale:i,_scaleRanges:s}=t,n={xmin:e.min,xmax:e.max,ymin:i.min,ymax:i.max};if(!s)return t._scaleRanges=n,!0;const o=s.xmin!==e.min||s.xmax!==e.max||s.ymin!==i.min||s.ymax!==i.max;return Object.assign(s,n),o}class xt{constructor(){this._request=null,this._charts=new Map,this._running=!1,this._lastDate=void 0}_notify(t,e,i,s){const n=e.listeners[s],o=e.duration;n.forEach((s=>s({chart:t,initial:e.initial,numSteps:o,currentStep:Math.min(i-e.start,o)})))}_refresh(){this._request||(this._running=!0,this._request=ht.call(window,(()=>{this._update(),this._request=null,this._running&&this._refresh()})))}_update(t=Date.now()){let e=0;this._charts.forEach(((i,s)=>{if(!i.running||!i.items.length)return;const n=i.items;let o,a=n.length-1,r=!1;for(;a>=0;--a)o=n[a],o._active?(o._total>i.duration&&(i.duration=o._total),o.tick(t),r=!0):(n[a]=n[n.length-1],n.pop());r&&(s.draw(),this._notify(s,i,t,"progress")),n.length||(i.running=!1,this._notify(s,i,t,"complete"),i.initial=!1),e+=n.length})),this._lastDate=t,0===e&&(this._running=!1)}_getAnims(t){const e=this._charts;let i=e.get(t);return i||(i={running:!1,initial:!0,items:[],listeners:{complete:[],progress:[]}},e.set(t,i)),i}listen(t,e,i){this._getAnims(t).listeners[e].push(i)}add(t,e){e&&e.length&&this._getAnims(t).items.push(...e)}has(t){return this._getAnims(t).items.length>0}start(t){const e=this._charts.get(t);e&&(e.running=!0,e.start=Date.now(),e.duration=e.items.reduce(((t,e)=>Math.max(t,e._duration)),0),this._refresh())}running(t){if(!this._running)return!1;const e=this._charts.get(t);return!!(e&&e.running&&e.items.length)}stop(t){const e=this._charts.get(t);if(!e||!e.items.length)return;const i=e.items;let s=i.length-1;for(;s>=0;--s)i[s].cancel();e.items=[],this._notify(t,e,Date.now(),"complete")}remove(t){return this._charts.delete(t)}}var bt=new xt;
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */function _t(t){return t+.5|0}const yt=(t,e,i)=>Math.max(Math.min(t,i),e);function vt(t){return yt(_t(2.55*t),0,255)}function Mt(t){return yt(_t(255*t),0,255)}function wt(t){return yt(_t(t/2.55)/100,0,1)}function kt(t){return yt(_t(100*t),0,100)}const St={0:0,1:1,2:2,3:3,4:4,5:5,6:6,7:7,8:8,9:9,A:10,B:11,C:12,D:13,E:14,F:15,a:10,b:11,c:12,d:13,e:14,f:15},Pt=[..."0123456789ABCDEF"],Dt=t=>Pt[15&t],Ct=t=>Pt[(240&t)>>4]+Pt[15&t],Ot=t=>(240&t)>>4==(15&t);function At(t){var e=(t=>Ot(t.r)&&Ot(t.g)&&Ot(t.b)&&Ot(t.a))(t)?Dt:Ct;return t?"#"+e(t.r)+e(t.g)+e(t.b)+((t,e)=>t<255?e(t):"")(t.a,e):void 0}const Tt=/^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;function Lt(t,e,i){const s=e*Math.min(i,1-i),n=(e,n=(e+t/30)%12)=>i-s*Math.max(Math.min(n-3,9-n,1),-1);return[n(0),n(8),n(4)]}function Et(t,e,i){const s=(s,n=(s+t/60)%6)=>i-i*e*Math.max(Math.min(n,4-n,1),0);return[s(5),s(3),s(1)]}function Rt(t,e,i){const s=Lt(t,1,.5);let n;for(e+i>1&&(n=1/(e+i),e*=n,i*=n),n=0;n<3;n++)s[n]*=1-e-i,s[n]+=e;return s}function It(t){const e=t.r/255,i=t.g/255,s=t.b/255,n=Math.max(e,i,s),o=Math.min(e,i,s),a=(n+o)/2;let r,l,h;return n!==o&&(h=n-o,l=a>.5?h/(2-n-o):h/(n+o),r=function(t,e,i,s,n){return t===n?(e-i)/s+(e<i?6:0):e===n?(i-t)/s+2:(t-e)/s+4}(e,i,s,h,n),r=60*r+.5),[0|r,l||0,a]}function zt(t,e,i,s){return(Array.isArray(e)?t(e[0],e[1],e[2]):t(e,i,s)).map(Mt)}function Ft(t,e,i){return zt(Lt,t,e,i)}function Vt(t){return(t%360+360)%360}function Bt(t){const e=Tt.exec(t);let i,s=255;if(!e)return;e[5]!==i&&(s=e[6]?vt(+e[5]):Mt(+e[5]));const n=Vt(+e[2]),o=+e[3]/100,a=+e[4]/100;return i="hwb"===e[1]?function(t,e,i){return zt(Rt,t,e,i)}(n,o,a):"hsv"===e[1]?function(t,e,i){return zt(Et,t,e,i)}(n,o,a):Ft(n,o,a),{r:i[0],g:i[1],b:i[2],a:s}}const Wt={x:"dark",Z:"light",Y:"re",X:"blu",W:"gr",V:"medium",U:"slate",A:"ee",T:"ol",S:"or",B:"ra",C:"lateg",D:"ights",R:"in",Q:"turquois",E:"hi",P:"ro",O:"al",N:"le",M:"de",L:"yello",F:"en",K:"ch",G:"arks",H:"ea",I:"ightg",J:"wh"},Nt={OiceXe:"f0f8ff",antiquewEte:"faebd7",aqua:"ffff",aquamarRe:"7fffd4",azuY:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"0",blanKedOmond:"ffebcd",Xe:"ff",XeviTet:"8a2be2",bPwn:"a52a2a",burlywood:"deb887",caMtXe:"5f9ea0",KartYuse:"7fff00",KocTate:"d2691e",cSO:"ff7f50",cSnflowerXe:"6495ed",cSnsilk:"fff8dc",crimson:"dc143c",cyan:"ffff",xXe:"8b",xcyan:"8b8b",xgTMnPd:"b8860b",xWay:"a9a9a9",xgYF:"6400",xgYy:"a9a9a9",xkhaki:"bdb76b",xmagFta:"8b008b",xTivegYF:"556b2f",xSange:"ff8c00",xScEd:"9932cc",xYd:"8b0000",xsOmon:"e9967a",xsHgYF:"8fbc8f",xUXe:"483d8b",xUWay:"2f4f4f",xUgYy:"2f4f4f",xQe:"ced1",xviTet:"9400d3",dAppRk:"ff1493",dApskyXe:"bfff",dimWay:"696969",dimgYy:"696969",dodgerXe:"1e90ff",fiYbrick:"b22222",flSOwEte:"fffaf0",foYstWAn:"228b22",fuKsia:"ff00ff",gaRsbSo:"dcdcdc",ghostwEte:"f8f8ff",gTd:"ffd700",gTMnPd:"daa520",Way:"808080",gYF:"8000",gYFLw:"adff2f",gYy:"808080",honeyMw:"f0fff0",hotpRk:"ff69b4",RdianYd:"cd5c5c",Rdigo:"4b0082",ivSy:"fffff0",khaki:"f0e68c",lavFMr:"e6e6fa",lavFMrXsh:"fff0f5",lawngYF:"7cfc00",NmoncEffon:"fffacd",ZXe:"add8e6",ZcSO:"f08080",Zcyan:"e0ffff",ZgTMnPdLw:"fafad2",ZWay:"d3d3d3",ZgYF:"90ee90",ZgYy:"d3d3d3",ZpRk:"ffb6c1",ZsOmon:"ffa07a",ZsHgYF:"20b2aa",ZskyXe:"87cefa",ZUWay:"778899",ZUgYy:"778899",ZstAlXe:"b0c4de",ZLw:"ffffe0",lime:"ff00",limegYF:"32cd32",lRF:"faf0e6",magFta:"ff00ff",maPon:"800000",VaquamarRe:"66cdaa",VXe:"cd",VScEd:"ba55d3",VpurpN:"9370db",VsHgYF:"3cb371",VUXe:"7b68ee",VsprRggYF:"fa9a",VQe:"48d1cc",VviTetYd:"c71585",midnightXe:"191970",mRtcYam:"f5fffa",mistyPse:"ffe4e1",moccasR:"ffe4b5",navajowEte:"ffdead",navy:"80",Tdlace:"fdf5e6",Tive:"808000",TivedBb:"6b8e23",Sange:"ffa500",SangeYd:"ff4500",ScEd:"da70d6",pOegTMnPd:"eee8aa",pOegYF:"98fb98",pOeQe:"afeeee",pOeviTetYd:"db7093",papayawEp:"ffefd5",pHKpuff:"ffdab9",peru:"cd853f",pRk:"ffc0cb",plum:"dda0dd",powMrXe:"b0e0e6",purpN:"800080",YbeccapurpN:"663399",Yd:"ff0000",Psybrown:"bc8f8f",PyOXe:"4169e1",saddNbPwn:"8b4513",sOmon:"fa8072",sandybPwn:"f4a460",sHgYF:"2e8b57",sHshell:"fff5ee",siFna:"a0522d",silver:"c0c0c0",skyXe:"87ceeb",UXe:"6a5acd",UWay:"708090",UgYy:"708090",snow:"fffafa",sprRggYF:"ff7f",stAlXe:"4682b4",tan:"d2b48c",teO:"8080",tEstN:"d8bfd8",tomato:"ff6347",Qe:"40e0d0",viTet:"ee82ee",JHt:"f5deb3",wEte:"ffffff",wEtesmoke:"f5f5f5",Lw:"ffff00",LwgYF:"9acd32"};let Ht;function jt(t){Ht||(Ht=function(){const t={},e=Object.keys(Nt),i=Object.keys(Wt);let s,n,o,a,r;for(s=0;s<e.length;s++){for(a=r=e[s],n=0;n<i.length;n++)o=i[n],r=r.replace(o,Wt[o]);o=parseInt(Nt[a],16),t[r]=[o>>16&255,o>>8&255,255&o]}return t}(),Ht.transparent=[0,0,0,0]);const e=Ht[t.toLowerCase()];return e&&{r:e[0],g:e[1],b:e[2],a:4===e.length?e[3]:255}}const $t=/^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;const Yt=t=>t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055,Ut=t=>t<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4);function Xt(t,e,i){if(t){let s=It(t);s[e]=Math.max(0,Math.min(s[e]+s[e]*i,0===e?360:1)),s=Ft(s),t.r=s[0],t.g=s[1],t.b=s[2]}}function qt(t,e){return t?Object.assign(e||{},t):t}function Kt(t){var e={r:0,g:0,b:0,a:255};return Array.isArray(t)?t.length>=3&&(e={r:t[0],g:t[1],b:t[2],a:255},t.length>3&&(e.a=Mt(t[3]))):(e=qt(t,{r:0,g:0,b:0,a:1})).a=Mt(e.a),e}function Gt(t){return"r"===t.charAt(0)?function(t){const e=$t.exec(t);let i,s,n,o=255;if(e){if(e[7]!==i){const t=+e[7];o=e[8]?vt(t):yt(255*t,0,255)}return i=+e[1],s=+e[3],n=+e[5],i=255&(e[2]?vt(i):yt(i,0,255)),s=255&(e[4]?vt(s):yt(s,0,255)),n=255&(e[6]?vt(n):yt(n,0,255)),{r:i,g:s,b:n,a:o}}}(t):Bt(t)}class Jt{constructor(t){if(t instanceof Jt)return t;const e=typeof t;let i;var s,n,o;"object"===e?i=Kt(t):"string"===e&&(o=(s=t).length,"#"===s[0]&&(4===o||5===o?n={r:255&17*St[s[1]],g:255&17*St[s[2]],b:255&17*St[s[3]],a:5===o?17*St[s[4]]:255}:7!==o&&9!==o||(n={r:St[s[1]]<<4|St[s[2]],g:St[s[3]]<<4|St[s[4]],b:St[s[5]]<<4|St[s[6]],a:9===o?St[s[7]]<<4|St[s[8]]:255})),i=n||jt(t)||Gt(t)),this._rgb=i,this._valid=!!i}get valid(){return this._valid}get rgb(){var t=qt(this._rgb);return t&&(t.a=wt(t.a)),t}set rgb(t){this._rgb=Kt(t)}rgbString(){return this._valid?(t=this._rgb)&&(t.a<255?`rgba(${t.r}, ${t.g}, ${t.b}, ${wt(t.a)})`:`rgb(${t.r}, ${t.g}, ${t.b})`):void 0;var t}hexString(){return this._valid?At(this._rgb):void 0}hslString(){return this._valid?function(t){if(!t)return;const e=It(t),i=e[0],s=kt(e[1]),n=kt(e[2]);return t.a<255?`hsla(${i}, ${s}%, ${n}%, ${wt(t.a)})`:`hsl(${i}, ${s}%, ${n}%)`}(this._rgb):void 0}mix(t,e){if(t){const i=this.rgb,s=t.rgb;let n;const o=e===n?.5:e,a=2*o-1,r=i.a-s.a,l=((a*r==-1?a:(a+r)/(1+a*r))+1)/2;n=1-l,i.r=255&l*i.r+n*s.r+.5,i.g=255&l*i.g+n*s.g+.5,i.b=255&l*i.b+n*s.b+.5,i.a=o*i.a+(1-o)*s.a,this.rgb=i}return this}interpolate(t,e){return t&&(this._rgb=function(t,e,i){const s=Ut(wt(t.r)),n=Ut(wt(t.g)),o=Ut(wt(t.b));return{r:Mt(Yt(s+i*(Ut(wt(e.r))-s))),g:Mt(Yt(n+i*(Ut(wt(e.g))-n))),b:Mt(Yt(o+i*(Ut(wt(e.b))-o))),a:t.a+i*(e.a-t.a)}}(this._rgb,t._rgb,e)),this}clone(){return new Jt(this.rgb)}alpha(t){return this._rgb.a=Mt(t),this}clearer(t){return this._rgb.a*=1-t,this}greyscale(){const t=this._rgb,e=_t(.3*t.r+.59*t.g+.11*t.b);return t.r=t.g=t.b=e,this}opaquer(t){return this._rgb.a*=1+t,this}negate(){const t=this._rgb;return t.r=255-t.r,t.g=255-t.g,t.b=255-t.b,this}lighten(t){return Xt(this._rgb,2,t),this}darken(t){return Xt(this._rgb,2,-t),this}saturate(t){return Xt(this._rgb,1,t),this}desaturate(t){return Xt(this._rgb,1,-t),this}rotate(t){return function(t,e){var i=It(t);i[0]=Vt(i[0]+e),i=Ft(i),t.r=i[0],t.g=i[1],t.b=i[2]}(this._rgb,t),this}}function Zt(t){if(t&&"object"==typeof t){const e=t.toString();return"[object CanvasPattern]"===e||"[object CanvasGradient]"===e}return!1}function Qt(t){return Zt(t)?t:new Jt(t)}function te(t){return Zt(t)?t:new Jt(t).saturate(.5).darken(.1).hexString()}const ee=["x","y","borderWidth","radius","tension"],ie=["color","borderColor","backgroundColor"];const se=new Map;function ne(t,e,i){return function(t,e){e=e||{};const i=t+JSON.stringify(e);let s=se.get(i);return s||(s=new Intl.NumberFormat(t,e),se.set(i,s)),s}(e,i).format(t)}const oe={values:t=>n(t)?t:""+t,numeric(t,e,i){if(0===t)return"0";const s=this.chart.options.locale;let n,o=t;if(i.length>1){const e=Math.max(Math.abs(i[0].value),Math.abs(i[i.length-1].value));(e<1e-4||e>1e15)&&(n="scientific"),o=function(t,e){let i=e.length>3?e[2].value-e[1].value:e[1].value-e[0].value;Math.abs(i)>=1&&t!==Math.floor(t)&&(i=t-Math.floor(t));return i}(t,i)}const a=z(Math.abs(o)),r=isNaN(a)?1:Math.max(Math.min(-1*Math.floor(a),20),0),l={notation:n,minimumFractionDigits:r,maximumFractionDigits:r};return Object.assign(l,this.options.ticks.format),ne(t,s,l)},logarithmic(t,e,i){if(0===t)return"0";const s=i[e].significand||t/Math.pow(10,Math.floor(z(t)));return[1,2,3,5,10,15].includes(s)||e>.8*i.length?oe.numeric.call(this,t,e,i):""}};var ae={formatters:oe};const re=Object.create(null),le=Object.create(null);function he(t,e){if(!e)return t;const i=e.split(".");for(let e=0,s=i.length;e<s;++e){const s=i[e];t=t[s]||(t[s]=Object.create(null))}return t}function ce(t,e,i){return"string"==typeof e?x(he(t,e),i):x(he(t,""),e)}class de{constructor(t,e){this.animation=void 0,this.backgroundColor="rgba(0,0,0,0.1)",this.borderColor="rgba(0,0,0,0.1)",this.color="#666",this.datasets={},this.devicePixelRatio=t=>t.chart.platform.getDevicePixelRatio(),this.elements={},this.events=["mousemove","mouseout","click","touchstart","touchmove"],this.font={family:"'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",size:12,style:"normal",lineHeight:1.2,weight:null},this.hover={},this.hoverBackgroundColor=(t,e)=>te(e.backgroundColor),this.hoverBorderColor=(t,e)=>te(e.borderColor),this.hoverColor=(t,e)=>te(e.color),this.indexAxis="x",this.interaction={mode:"nearest",intersect:!0,includeInvisible:!1},this.maintainAspectRatio=!0,this.onHover=null,this.onClick=null,this.parsing=!0,this.plugins={},this.responsive=!0,this.scale=void 0,this.scales={},this.showLine=!0,this.drawActiveElementsOnTop=!0,this.describe(t),this.apply(e)}set(t,e){return ce(this,t,e)}get(t){return he(this,t)}describe(t,e){return ce(le,t,e)}override(t,e){return ce(re,t,e)}route(t,e,i,s){const n=he(this,t),a=he(this,i),r="_"+e;Object.defineProperties(n,{[r]:{value:n[e],writable:!0},[e]:{enumerable:!0,get(){const t=this[r],e=a[s];return o(t)?Object.assign({},e,t):l(t,e)},set(t){this[r]=t}}})}apply(t){t.forEach((t=>t(this)))}}var ue=new de({_scriptable:t=>!t.startsWith("on"),_indexable:t=>"events"!==t,hover:{_fallback:"interaction"},interaction:{_scriptable:!1,_indexable:!1}},[function(t){t.set("animation",{delay:void 0,duration:1e3,easing:"easeOutQuart",fn:void 0,from:void 0,loop:void 0,to:void 0,type:void 0}),t.describe("animation",{_fallback:!1,_indexable:!1,_scriptable:t=>"onProgress"!==t&&"onComplete"!==t&&"fn"!==t}),t.set("animations",{colors:{type:"color",properties:ie},numbers:{type:"number",properties:ee}}),t.describe("animations",{_fallback:"animation"}),t.set("transitions",{active:{animation:{duration:400}},resize:{animation:{duration:0}},show:{animations:{colors:{from:"transparent"},visible:{type:"boolean",duration:0}}},hide:{animations:{colors:{to:"transparent"},visible:{type:"boolean",easing:"linear",fn:t=>0|t}}}})},function(t){t.set("layout",{autoPadding:!0,padding:{top:0,right:0,bottom:0,left:0}})},function(t){t.set("scale",{display:!0,offset:!1,reverse:!1,beginAtZero:!1,bounds:"ticks",clip:!0,grace:0,grid:{display:!0,lineWidth:1,drawOnChartArea:!0,drawTicks:!0,tickLength:8,tickWidth:(t,e)=>e.lineWidth,tickColor:(t,e)=>e.color,offset:!1},border:{display:!0,dash:[],dashOffset:0,width:1},title:{display:!1,text:"",padding:{top:4,bottom:4}},ticks:{minRotation:0,maxRotation:50,mirror:!1,textStrokeWidth:0,textStrokeColor:"",padding:3,display:!0,autoSkip:!0,autoSkipPadding:3,labelOffset:0,callback:ae.formatters.values,minor:{},major:{},align:"center",crossAlign:"near",showLabelBackdrop:!1,backdropColor:"rgba(255, 255, 255, 0.75)",backdropPadding:2}}),t.route("scale.ticks","color","","color"),t.route("scale.grid","color","","borderColor"),t.route("scale.border","color","","borderColor"),t.route("scale.title","color","","color"),t.describe("scale",{_fallback:!1,_scriptable:t=>!t.startsWith("before")&&!t.startsWith("after")&&"callback"!==t&&"parser"!==t,_indexable:t=>"borderDash"!==t&&"tickBorderDash"!==t&&"dash"!==t}),t.describe("scales",{_fallback:"scale"}),t.describe("scale.ticks",{_scriptable:t=>"backdropPadding"!==t&&"callback"!==t,_indexable:t=>"backdropPadding"!==t})}]);function fe(){return"undefined"!=typeof window&&"undefined"!=typeof document}function ge(t){let e=t.parentNode;return e&&"[object ShadowRoot]"===e.toString()&&(e=e.host),e}function pe(t,e,i){let s;return"string"==typeof t?(s=parseInt(t,10),-1!==t.indexOf("%")&&(s=s/100*e.parentNode[i])):s=t,s}const me=t=>t.ownerDocument.defaultView.getComputedStyle(t,null);function xe(t,e){return me(t).getPropertyValue(e)}const be=["top","right","bottom","left"];function _e(t,e,i){const s={};i=i?"-"+i:"";for(let n=0;n<4;n++){const o=be[n];s[o]=parseFloat(t[e+"-"+o+i])||0}return s.width=s.left+s.right,s.height=s.top+s.bottom,s}const ye=(t,e,i)=>(t>0||e>0)&&(!i||!i.shadowRoot);function ve(t,e){if("native"in t)return t;const{canvas:i,currentDevicePixelRatio:s}=e,n=me(i),o="border-box"===n.boxSizing,a=_e(n,"padding"),r=_e(n,"border","width"),{x:l,y:h,box:c}=function(t,e){const i=t.touches,s=i&&i.length?i[0]:t,{offsetX:n,offsetY:o}=s;let a,r,l=!1;if(ye(n,o,t.target))a=n,r=o;else{const t=e.getBoundingClientRect();a=s.clientX-t.left,r=s.clientY-t.top,l=!0}return{x:a,y:r,box:l}}(t,i),d=a.left+(c&&r.left),u=a.top+(c&&r.top);let{width:f,height:g}=e;return o&&(f-=a.width+r.width,g-=a.height+r.height),{x:Math.round((l-d)/f*i.width/s),y:Math.round((h-u)/g*i.height/s)}}const Me=t=>Math.round(10*t)/10;function we(t,e,i,s){const n=me(t),o=_e(n,"margin"),a=pe(n.maxWidth,t,"clientWidth")||T,r=pe(n.maxHeight,t,"clientHeight")||T,l=function(t,e,i){let s,n;if(void 0===e||void 0===i){const o=t&&ge(t);if(o){const t=o.getBoundingClientRect(),a=me(o),r=_e(a,"border","width"),l=_e(a,"padding");e=t.width-l.width-r.width,i=t.height-l.height-r.height,s=pe(a.maxWidth,o,"clientWidth"),n=pe(a.maxHeight,o,"clientHeight")}else e=t.clientWidth,i=t.clientHeight}return{width:e,height:i,maxWidth:s||T,maxHeight:n||T}}(t,e,i);let{width:h,height:c}=l;if("content-box"===n.boxSizing){const t=_e(n,"border","width"),e=_e(n,"padding");h-=e.width+t.width,c-=e.height+t.height}h=Math.max(0,h-o.width),c=Math.max(0,s?h/s:c-o.height),h=Me(Math.min(h,a,l.maxWidth)),c=Me(Math.min(c,r,l.maxHeight)),h&&!c&&(c=Me(h/2));return(void 0!==e||void 0!==i)&&s&&l.height&&c>l.height&&(c=l.height,h=Me(Math.floor(c*s))),{width:h,height:c}}function ke(t,e,i){const s=e||1,n=Me(t.height*s),o=Me(t.width*s);t.height=Me(t.height),t.width=Me(t.width);const a=t.canvas;return a.style&&(i||!a.style.height&&!a.style.width)&&(a.style.height=`${t.height}px`,a.style.width=`${t.width}px`),(t.currentDevicePixelRatio!==s||a.height!==n||a.width!==o)&&(t.currentDevicePixelRatio=s,a.height=n,a.width=o,t.ctx.setTransform(s,0,0,s,0,0),!0)}const Se=function(){let t=!1;try{const e={get passive(){return t=!0,!1}};fe()&&(window.addEventListener("test",null,e),window.removeEventListener("test",null,e))}catch(t){}return t}();function Pe(t,e){const i=xe(t,e),s=i&&i.match(/^(\d+)(\.\d+)?px$/);return s?+s[1]:void 0}function De(t){return!t||s(t.size)||s(t.family)?null:(t.style?t.style+" ":"")+(t.weight?t.weight+" ":"")+t.size+"px "+t.family}function Ce(t,e,i,s,n){let o=e[n];return o||(o=e[n]=t.measureText(n).width,i.push(n)),o>s&&(s=o),s}function Oe(t,e,i,s){let o=(s=s||{}).data=s.data||{},a=s.garbageCollect=s.garbageCollect||[];s.font!==e&&(o=s.data={},a=s.garbageCollect=[],s.font=e),t.save(),t.font=e;let r=0;const l=i.length;let h,c,d,u,f;for(h=0;h<l;h++)if(u=i[h],null==u||n(u)){if(n(u))for(c=0,d=u.length;c<d;c++)f=u[c],null==f||n(f)||(r=Ce(t,o,a,r,f))}else r=Ce(t,o,a,r,u);t.restore();const g=a.length/2;if(g>i.length){for(h=0;h<g;h++)delete o[a[h]];a.splice(0,g)}return r}function Ae(t,e,i){const s=t.currentDevicePixelRatio,n=0!==i?Math.max(i/2,.5):0;return Math.round((e-n)*s)/s+n}function Te(t,e){(e||t)&&((e=e||t.getContext("2d")).save(),e.resetTransform(),e.clearRect(0,0,t.width,t.height),e.restore())}function Le(t,e,i,s){Ee(t,e,i,s,null)}function Ee(t,e,i,s,n){let o,a,r,l,h,c,d,u;const f=e.pointStyle,g=e.rotation,p=e.radius;let m=(g||0)*L;if(f&&"object"==typeof f&&(o=f.toString(),"[object HTMLImageElement]"===o||"[object HTMLCanvasElement]"===o))return t.save(),t.translate(i,s),t.rotate(m),t.drawImage(f,-f.width/2,-f.height/2,f.width,f.height),void t.restore();if(!(isNaN(p)||p<=0)){switch(t.beginPath(),f){default:n?t.ellipse(i,s,n/2,p,0,0,O):t.arc(i,s,p,0,O),t.closePath();break;case"triangle":c=n?n/2:p,t.moveTo(i+Math.sin(m)*c,s-Math.cos(m)*p),m+=I,t.lineTo(i+Math.sin(m)*c,s-Math.cos(m)*p),m+=I,t.lineTo(i+Math.sin(m)*c,s-Math.cos(m)*p),t.closePath();break;case"rectRounded":h=.516*p,l=p-h,a=Math.cos(m+R)*l,d=Math.cos(m+R)*(n?n/2-h:l),r=Math.sin(m+R)*l,u=Math.sin(m+R)*(n?n/2-h:l),t.arc(i-d,s-r,h,m-C,m-E),t.arc(i+u,s-a,h,m-E,m),t.arc(i+d,s+r,h,m,m+E),t.arc(i-u,s+a,h,m+E,m+C),t.closePath();break;case"rect":if(!g){l=Math.SQRT1_2*p,c=n?n/2:l,t.rect(i-c,s-l,2*c,2*l);break}m+=R;case"rectRot":d=Math.cos(m)*(n?n/2:p),a=Math.cos(m)*p,r=Math.sin(m)*p,u=Math.sin(m)*(n?n/2:p),t.moveTo(i-d,s-r),t.lineTo(i+u,s-a),t.lineTo(i+d,s+r),t.lineTo(i-u,s+a),t.closePath();break;case"crossRot":m+=R;case"cross":d=Math.cos(m)*(n?n/2:p),a=Math.cos(m)*p,r=Math.sin(m)*p,u=Math.sin(m)*(n?n/2:p),t.moveTo(i-d,s-r),t.lineTo(i+d,s+r),t.moveTo(i+u,s-a),t.lineTo(i-u,s+a);break;case"star":d=Math.cos(m)*(n?n/2:p),a=Math.cos(m)*p,r=Math.sin(m)*p,u=Math.sin(m)*(n?n/2:p),t.moveTo(i-d,s-r),t.lineTo(i+d,s+r),t.moveTo(i+u,s-a),t.lineTo(i-u,s+a),m+=R,d=Math.cos(m)*(n?n/2:p),a=Math.cos(m)*p,r=Math.sin(m)*p,u=Math.sin(m)*(n?n/2:p),t.moveTo(i-d,s-r),t.lineTo(i+d,s+r),t.moveTo(i+u,s-a),t.lineTo(i-u,s+a);break;case"line":a=n?n/2:Math.cos(m)*p,r=Math.sin(m)*p,t.moveTo(i-a,s-r),t.lineTo(i+a,s+r);break;case"dash":t.moveTo(i,s),t.lineTo(i+Math.cos(m)*(n?n/2:p),s+Math.sin(m)*p);break;case!1:t.closePath()}t.fill(),e.borderWidth>0&&t.stroke()}}function Re(t,e,i){return i=i||.5,!e||t&&t.x>e.left-i&&t.x<e.right+i&&t.y>e.top-i&&t.y<e.bottom+i}function Ie(t,e){t.save(),t.beginPath(),t.rect(e.left,e.top,e.right-e.left,e.bottom-e.top),t.clip()}function ze(t){t.restore()}function Fe(t,e,i,s,n){if(!e)return t.lineTo(i.x,i.y);if("middle"===n){const s=(e.x+i.x)/2;t.lineTo(s,e.y),t.lineTo(s,i.y)}else"after"===n!=!!s?t.lineTo(e.x,i.y):t.lineTo(i.x,e.y);t.lineTo(i.x,i.y)}function Ve(t,e,i,s){if(!e)return t.lineTo(i.x,i.y);t.bezierCurveTo(s?e.cp1x:e.cp2x,s?e.cp1y:e.cp2y,s?i.cp2x:i.cp1x,s?i.cp2y:i.cp1y,i.x,i.y)}function Be(t,e,i,s,n){if(n.strikethrough||n.underline){const o=t.measureText(s),a=e-o.actualBoundingBoxLeft,r=e+o.actualBoundingBoxRight,l=i-o.actualBoundingBoxAscent,h=i+o.actualBoundingBoxDescent,c=n.strikethrough?(l+h)/2:h;t.strokeStyle=t.fillStyle,t.beginPath(),t.lineWidth=n.decorationWidth||2,t.moveTo(a,c),t.lineTo(r,c),t.stroke()}}function We(t,e){const i=t.fillStyle;t.fillStyle=e.color,t.fillRect(e.left,e.top,e.width,e.height),t.fillStyle=i}function Ne(t,e,i,o,a,r={}){const l=n(e)?e:[e],h=r.strokeWidth>0&&""!==r.strokeColor;let c,d;for(t.save(),t.font=a.string,function(t,e){e.translation&&t.translate(e.translation[0],e.translation[1]),s(e.rotation)||t.rotate(e.rotation),e.color&&(t.fillStyle=e.color),e.textAlign&&(t.textAlign=e.textAlign),e.textBaseline&&(t.textBaseline=e.textBaseline)}(t,r),c=0;c<l.length;++c)d=l[c],r.backdrop&&We(t,r.backdrop),h&&(r.strokeColor&&(t.strokeStyle=r.strokeColor),s(r.strokeWidth)||(t.lineWidth=r.strokeWidth),t.strokeText(d,i,o,r.maxWidth)),t.fillText(d,i,o,r.maxWidth),Be(t,i,o,d,r),o+=Number(a.lineHeight);t.restore()}function He(t,e){const{x:i,y:s,w:n,h:o,radius:a}=e;t.arc(i+a.topLeft,s+a.topLeft,a.topLeft,1.5*C,C,!0),t.lineTo(i,s+o-a.bottomLeft),t.arc(i+a.bottomLeft,s+o-a.bottomLeft,a.bottomLeft,C,E,!0),t.lineTo(i+n-a.bottomRight,s+o),t.arc(i+n-a.bottomRight,s+o-a.bottomRight,a.bottomRight,E,0,!0),t.lineTo(i+n,s+a.topRight),t.arc(i+n-a.topRight,s+a.topRight,a.topRight,0,-E,!0),t.lineTo(i+a.topLeft,s)}function je(t,e=[""],i,s,n=(()=>t[0])){const o=i||t;void 0===s&&(s=ti("_fallback",t));const a={[Symbol.toStringTag]:"Object",_cacheable:!0,_scopes:t,_rootScopes:o,_fallback:s,_getTarget:n,override:i=>je([i,...t],e,o,s)};return new Proxy(a,{deleteProperty:(e,i)=>(delete e[i],delete e._keys,delete t[0][i],!0),get:(i,s)=>qe(i,s,(()=>function(t,e,i,s){let n;for(const o of e)if(n=ti(Ue(o,t),i),void 0!==n)return Xe(t,n)?Ze(i,s,t,n):n}(s,e,t,i))),getOwnPropertyDescriptor:(t,e)=>Reflect.getOwnPropertyDescriptor(t._scopes[0],e),getPrototypeOf:()=>Reflect.getPrototypeOf(t[0]),has:(t,e)=>ei(t).includes(e),ownKeys:t=>ei(t),set(t,e,i){const s=t._storage||(t._storage=n());return t[e]=s[e]=i,delete t._keys,!0}})}function $e(t,e,i,s){const a={_cacheable:!1,_proxy:t,_context:e,_subProxy:i,_stack:new Set,_descriptors:Ye(t,s),setContext:e=>$e(t,e,i,s),override:n=>$e(t.override(n),e,i,s)};return new Proxy(a,{deleteProperty:(e,i)=>(delete e[i],delete t[i],!0),get:(t,e,i)=>qe(t,e,(()=>function(t,e,i){const{_proxy:s,_context:a,_subProxy:r,_descriptors:l}=t;let h=s[e];S(h)&&l.isScriptable(e)&&(h=function(t,e,i,s){const{_proxy:n,_context:o,_subProxy:a,_stack:r}=i;if(r.has(t))throw new Error("Recursion detected: "+Array.from(r).join("->")+"->"+t);r.add(t);let l=e(o,a||s);r.delete(t),Xe(t,l)&&(l=Ze(n._scopes,n,t,l));return l}(e,h,t,i));n(h)&&h.length&&(h=function(t,e,i,s){const{_proxy:n,_context:a,_subProxy:r,_descriptors:l}=i;if(void 0!==a.index&&s(t))return e[a.index%e.length];if(o(e[0])){const i=e,s=n._scopes.filter((t=>t!==i));e=[];for(const o of i){const i=Ze(s,n,t,o);e.push($e(i,a,r&&r[t],l))}}return e}(e,h,t,l.isIndexable));Xe(e,h)&&(h=$e(h,a,r&&r[e],l));return h}(t,e,i))),getOwnPropertyDescriptor:(e,i)=>e._descriptors.allKeys?Reflect.has(t,i)?{enumerable:!0,configurable:!0}:void 0:Reflect.getOwnPropertyDescriptor(t,i),getPrototypeOf:()=>Reflect.getPrototypeOf(t),has:(e,i)=>Reflect.has(t,i),ownKeys:()=>Reflect.ownKeys(t),set:(e,i,s)=>(t[i]=s,delete e[i],!0)})}function Ye(t,e={scriptable:!0,indexable:!0}){const{_scriptable:i=e.scriptable,_indexable:s=e.indexable,_allKeys:n=e.allKeys}=t;return{allKeys:n,scriptable:i,indexable:s,isScriptable:S(i)?i:()=>i,isIndexable:S(s)?s:()=>s}}const Ue=(t,e)=>t?t+w(e):e,Xe=(t,e)=>o(e)&&"adapters"!==t&&(null===Object.getPrototypeOf(e)||e.constructor===Object);function qe(t,e,i){if(Object.prototype.hasOwnProperty.call(t,e)||"constructor"===e)return t[e];const s=i();return t[e]=s,s}function Ke(t,e,i){return S(t)?t(e,i):t}const Ge=(t,e)=>!0===t?e:"string"==typeof t?M(e,t):void 0;function Je(t,e,i,s,n){for(const o of e){const e=Ge(i,o);if(e){t.add(e);const o=Ke(e._fallback,i,n);if(void 0!==o&&o!==i&&o!==s)return o}else if(!1===e&&void 0!==s&&i!==s)return null}return!1}function Ze(t,e,i,s){const a=e._rootScopes,r=Ke(e._fallback,i,s),l=[...t,...a],h=new Set;h.add(s);let c=Qe(h,l,i,r||i,s);return null!==c&&((void 0===r||r===i||(c=Qe(h,l,r,c,s),null!==c))&&je(Array.from(h),[""],a,r,(()=>function(t,e,i){const s=t._getTarget();e in s||(s[e]={});const a=s[e];if(n(a)&&o(i))return i;return a||{}}(e,i,s))))}function Qe(t,e,i,s,n){for(;i;)i=Je(t,e,i,s,n);return i}function ti(t,e){for(const i of e){if(!i)continue;const e=i[t];if(void 0!==e)return e}}function ei(t){let e=t._keys;return e||(e=t._keys=function(t){const e=new Set;for(const i of t)for(const t of Object.keys(i).filter((t=>!t.startsWith("_"))))e.add(t);return Array.from(e)}(t._scopes)),e}function ii(t,e,i,s){const{iScale:n}=t,{key:o="r"}=this._parsing,a=new Array(s);let r,l,h,c;for(r=0,l=s;r<l;++r)h=r+i,c=e[h],a[r]={r:n.parse(M(c,o),h)};return a}const si=Number.EPSILON||1e-14,ni=(t,e)=>e<t.length&&!t[e].skip&&t[e],oi=t=>"x"===t?"y":"x";function ai(t,e,i,s){const n=t.skip?e:t,o=e,a=i.skip?e:i,r=q(o,n),l=q(a,o);let h=r/(r+l),c=l/(r+l);h=isNaN(h)?0:h,c=isNaN(c)?0:c;const d=s*h,u=s*c;return{previous:{x:o.x-d*(a.x-n.x),y:o.y-d*(a.y-n.y)},next:{x:o.x+u*(a.x-n.x),y:o.y+u*(a.y-n.y)}}}function ri(t,e="x"){const i=oi(e),s=t.length,n=Array(s).fill(0),o=Array(s);let a,r,l,h=ni(t,0);for(a=0;a<s;++a)if(r=l,l=h,h=ni(t,a+1),l){if(h){const t=h[e]-l[e];n[a]=0!==t?(h[i]-l[i])/t:0}o[a]=r?h?F(n[a-1])!==F(n[a])?0:(n[a-1]+n[a])/2:n[a-1]:n[a]}!function(t,e,i){const s=t.length;let n,o,a,r,l,h=ni(t,0);for(let c=0;c<s-1;++c)l=h,h=ni(t,c+1),l&&h&&(V(e[c],0,si)?i[c]=i[c+1]=0:(n=i[c]/e[c],o=i[c+1]/e[c],r=Math.pow(n,2)+Math.pow(o,2),r<=9||(a=3/Math.sqrt(r),i[c]=n*a*e[c],i[c+1]=o*a*e[c])))}(t,n,o),function(t,e,i="x"){const s=oi(i),n=t.length;let o,a,r,l=ni(t,0);for(let h=0;h<n;++h){if(a=r,r=l,l=ni(t,h+1),!r)continue;const n=r[i],c=r[s];a&&(o=(n-a[i])/3,r[`cp1${i}`]=n-o,r[`cp1${s}`]=c-o*e[h]),l&&(o=(l[i]-n)/3,r[`cp2${i}`]=n+o,r[`cp2${s}`]=c+o*e[h])}}(t,o,e)}function li(t,e,i){return Math.max(Math.min(t,i),e)}function hi(t,e,i,s,n){let o,a,r,l;if(e.spanGaps&&(t=t.filter((t=>!t.skip))),"monotone"===e.cubicInterpolationMode)ri(t,n);else{let i=s?t[t.length-1]:t[0];for(o=0,a=t.length;o<a;++o)r=t[o],l=ai(i,r,t[Math.min(o+1,a-(s?0:1))%a],e.tension),r.cp1x=l.previous.x,r.cp1y=l.previous.y,r.cp2x=l.next.x,r.cp2y=l.next.y,i=r}e.capBezierPoints&&function(t,e){let i,s,n,o,a,r=Re(t[0],e);for(i=0,s=t.length;i<s;++i)a=o,o=r,r=i<s-1&&Re(t[i+1],e),o&&(n=t[i],a&&(n.cp1x=li(n.cp1x,e.left,e.right),n.cp1y=li(n.cp1y,e.top,e.bottom)),r&&(n.cp2x=li(n.cp2x,e.left,e.right),n.cp2y=li(n.cp2y,e.top,e.bottom)))}(t,i)}const ci=t=>0===t||1===t,di=(t,e,i)=>-Math.pow(2,10*(t-=1))*Math.sin((t-e)*O/i),ui=(t,e,i)=>Math.pow(2,-10*t)*Math.sin((t-e)*O/i)+1,fi={linear:t=>t,easeInQuad:t=>t*t,easeOutQuad:t=>-t*(t-2),easeInOutQuad:t=>(t/=.5)<1?.5*t*t:-.5*(--t*(t-2)-1),easeInCubic:t=>t*t*t,easeOutCubic:t=>(t-=1)*t*t+1,easeInOutCubic:t=>(t/=.5)<1?.5*t*t*t:.5*((t-=2)*t*t+2),easeInQuart:t=>t*t*t*t,easeOutQuart:t=>-((t-=1)*t*t*t-1),easeInOutQuart:t=>(t/=.5)<1?.5*t*t*t*t:-.5*((t-=2)*t*t*t-2),easeInQuint:t=>t*t*t*t*t,easeOutQuint:t=>(t-=1)*t*t*t*t+1,easeInOutQuint:t=>(t/=.5)<1?.5*t*t*t*t*t:.5*((t-=2)*t*t*t*t+2),easeInSine:t=>1-Math.cos(t*E),easeOutSine:t=>Math.sin(t*E),easeInOutSine:t=>-.5*(Math.cos(C*t)-1),easeInExpo:t=>0===t?0:Math.pow(2,10*(t-1)),easeOutExpo:t=>1===t?1:1-Math.pow(2,-10*t),easeInOutExpo:t=>ci(t)?t:t<.5?.5*Math.pow(2,10*(2*t-1)):.5*(2-Math.pow(2,-10*(2*t-1))),easeInCirc:t=>t>=1?t:-(Math.sqrt(1-t*t)-1),easeOutCirc:t=>Math.sqrt(1-(t-=1)*t),easeInOutCirc:t=>(t/=.5)<1?-.5*(Math.sqrt(1-t*t)-1):.5*(Math.sqrt(1-(t-=2)*t)+1),easeInElastic:t=>ci(t)?t:di(t,.075,.3),easeOutElastic:t=>ci(t)?t:ui(t,.075,.3),easeInOutElastic(t){const e=.1125;return ci(t)?t:t<.5?.5*di(2*t,e,.45):.5+.5*ui(2*t-1,e,.45)},easeInBack(t){const e=1.70158;return t*t*((e+1)*t-e)},easeOutBack(t){const e=1.70158;return(t-=1)*t*((e+1)*t+e)+1},easeInOutBack(t){let e=1.70158;return(t/=.5)<1?t*t*((1+(e*=1.525))*t-e)*.5:.5*((t-=2)*t*((1+(e*=1.525))*t+e)+2)},easeInBounce:t=>1-fi.easeOutBounce(1-t),easeOutBounce(t){const e=7.5625,i=2.75;return t<1/i?e*t*t:t<2/i?e*(t-=1.5/i)*t+.75:t<2.5/i?e*(t-=2.25/i)*t+.9375:e*(t-=2.625/i)*t+.984375},easeInOutBounce:t=>t<.5?.5*fi.easeInBounce(2*t):.5*fi.easeOutBounce(2*t-1)+.5};function gi(t,e,i,s){return{x:t.x+i*(e.x-t.x),y:t.y+i*(e.y-t.y)}}function pi(t,e,i,s){return{x:t.x+i*(e.x-t.x),y:"middle"===s?i<.5?t.y:e.y:"after"===s?i<1?t.y:e.y:i>0?e.y:t.y}}function mi(t,e,i,s){const n={x:t.cp2x,y:t.cp2y},o={x:e.cp1x,y:e.cp1y},a=gi(t,n,i),r=gi(n,o,i),l=gi(o,e,i),h=gi(a,r,i),c=gi(r,l,i);return gi(h,c,i)}const xi=/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/,bi=/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;function _i(t,e){const i=(""+t).match(xi);if(!i||"normal"===i[1])return 1.2*e;switch(t=+i[2],i[3]){case"px":return t;case"%":t/=100}return e*t}const yi=t=>+t||0;function vi(t,e){const i={},s=o(e),n=s?Object.keys(e):e,a=o(t)?s?i=>l(t[i],t[e[i]]):e=>t[e]:()=>t;for(const t of n)i[t]=yi(a(t));return i}function Mi(t){return vi(t,{top:"y",right:"x",bottom:"y",left:"x"})}function wi(t){return vi(t,["topLeft","topRight","bottomLeft","bottomRight"])}function ki(t){const e=Mi(t);return e.width=e.left+e.right,e.height=e.top+e.bottom,e}function Si(t,e){t=t||{},e=e||ue.font;let i=l(t.size,e.size);"string"==typeof i&&(i=parseInt(i,10));let s=l(t.style,e.style);s&&!(""+s).match(bi)&&(console.warn('Invalid font style specified: "'+s+'"'),s=void 0);const n={family:l(t.family,e.family),lineHeight:_i(l(t.lineHeight,e.lineHeight),i),size:i,style:s,weight:l(t.weight,e.weight),string:""};return n.string=De(n),n}function Pi(t,e,i,s){let o,a,r,l=!0;for(o=0,a=t.length;o<a;++o)if(r=t[o],void 0!==r&&(void 0!==e&&"function"==typeof r&&(r=r(e),l=!1),void 0!==i&&n(r)&&(r=r[i%r.length],l=!1),void 0!==r))return s&&!l&&(s.cacheable=!1),r}function Di(t,e,i){const{min:s,max:n}=t,o=c(e,(n-s)/2),a=(t,e)=>i&&0===t?0:t+e;return{min:a(s,-Math.abs(o)),max:a(n,o)}}function Ci(t,e){return Object.assign(Object.create(t),e)}function Oi(t,e,i){return t?function(t,e){return{x:i=>t+t+e-i,setWidth(t){e=t},textAlign:t=>"center"===t?t:"right"===t?"left":"right",xPlus:(t,e)=>t-e,leftForLtr:(t,e)=>t-e}}(e,i):{x:t=>t,setWidth(t){},textAlign:t=>t,xPlus:(t,e)=>t+e,leftForLtr:(t,e)=>t}}function Ai(t,e){let i,s;"ltr"!==e&&"rtl"!==e||(i=t.canvas.style,s=[i.getPropertyValue("direction"),i.getPropertyPriority("direction")],i.setProperty("direction",e,"important"),t.prevTextDirection=s)}function Ti(t,e){void 0!==e&&(delete t.prevTextDirection,t.canvas.style.setProperty("direction",e[0],e[1]))}function Li(t){return"angle"===t?{between:J,compare:K,normalize:G}:{between:tt,compare:(t,e)=>t-e,normalize:t=>t}}function Ei({start:t,end:e,count:i,loop:s,style:n}){return{start:t%i,end:e%i,loop:s&&(e-t+1)%i==0,style:n}}function Ri(t,e,i){if(!i)return[t];const{property:s,start:n,end:o}=i,a=e.length,{compare:r,between:l,normalize:h}=Li(s),{start:c,end:d,loop:u,style:f}=function(t,e,i){const{property:s,start:n,end:o}=i,{between:a,normalize:r}=Li(s),l=e.length;let h,c,{start:d,end:u,loop:f}=t;if(f){for(d+=l,u+=l,h=0,c=l;h<c&&a(r(e[d%l][s]),n,o);++h)d--,u--;d%=l,u%=l}return u<d&&(u+=l),{start:d,end:u,loop:f,style:t.style}}(t,e,i),g=[];let p,m,x,b=!1,_=null;const y=()=>b||l(n,x,p)&&0!==r(n,x),v=()=>!b||0===r(o,p)||l(o,x,p);for(let t=c,i=c;t<=d;++t)m=e[t%a],m.skip||(p=h(m[s]),p!==x&&(b=l(p,n,o),null===_&&y()&&(_=0===r(p,n)?t:i),null!==_&&v()&&(g.push(Ei({start:_,end:t,loop:u,count:a,style:f})),_=null),i=t,x=p));return null!==_&&g.push(Ei({start:_,end:d,loop:u,count:a,style:f})),g}function Ii(t,e){const i=[],s=t.segments;for(let n=0;n<s.length;n++){const o=Ri(s[n],t.points,e);o.length&&i.push(...o)}return i}function zi(t,e){const i=t.points,s=t.options.spanGaps,n=i.length;if(!n)return[];const o=!!t._loop,{start:a,end:r}=function(t,e,i,s){let n=0,o=e-1;if(i&&!s)for(;n<e&&!t[n].skip;)n++;for(;n<e&&t[n].skip;)n++;for(n%=e,i&&(o+=n);o>n&&t[o%e].skip;)o--;return o%=e,{start:n,end:o}}(i,n,o,s);if(!0===s)return Fi(t,[{start:a,end:r,loop:o}],i,e);return Fi(t,function(t,e,i,s){const n=t.length,o=[];let a,r=e,l=t[e];for(a=e+1;a<=i;++a){const i=t[a%n];i.skip||i.stop?l.skip||(s=!1,o.push({start:e%n,end:(a-1)%n,loop:s}),e=r=i.stop?a:null):(r=a,l.skip&&(e=a)),l=i}return null!==r&&o.push({start:e%n,end:r%n,loop:s}),o}(i,a,r<a?r+n:r,!!t._fullLoop&&0===a&&r===n-1),i,e)}function Fi(t,e,i,s){return s&&s.setContext&&i?function(t,e,i,s){const n=t._chart.getContext(),o=Vi(t.options),{_datasetIndex:a,options:{spanGaps:r}}=t,l=i.length,h=[];let c=o,d=e[0].start,u=d;function f(t,e,s,n){const o=r?-1:1;if(t!==e){for(t+=l;i[t%l].skip;)t-=o;for(;i[e%l].skip;)e+=o;t%l!=e%l&&(h.push({start:t%l,end:e%l,loop:s,style:n}),c=n,d=e%l)}}for(const t of e){d=r?d:t.start;let e,o=i[d%l];for(u=d+1;u<=t.end;u++){const r=i[u%l];e=Vi(s.setContext(Ci(n,{type:"segment",p0:o,p1:r,p0DataIndex:(u-1)%l,p1DataIndex:u%l,datasetIndex:a}))),Bi(e,c)&&f(d,u-1,t.loop,c),o=r,c=e}d<u-1&&f(d,u-1,t.loop,c)}return h}(t,e,i,s):e}function Vi(t){return{backgroundColor:t.backgroundColor,borderCapStyle:t.borderCapStyle,borderDash:t.borderDash,borderDashOffset:t.borderDashOffset,borderJoinStyle:t.borderJoinStyle,borderWidth:t.borderWidth,borderColor:t.borderColor}}function Bi(t,e){if(!e)return!1;const i=[],s=function(t,e){return Zt(e)?(i.includes(e)||i.push(e),i.indexOf(e)):e};return JSON.stringify(t,s)!==JSON.stringify(e,s)}function Wi(t,e,i){return t.options.clip?t[i]:e[i]}function Ni(t,e){const i=e._clip;if(i.disabled)return!1;const s=function(t,e){const{xScale:i,yScale:s}=t;return i&&s?{left:Wi(i,e,"left"),right:Wi(i,e,"right"),top:Wi(s,e,"top"),bottom:Wi(s,e,"bottom")}:e}(e,t.chartArea);return{left:!1===i.left?0:s.left-(!0===i.left?0:i.left),right:!1===i.right?t.width:s.right+(!0===i.right?0:i.right),top:!1===i.top?0:s.top-(!0===i.top?0:i.top),bottom:!1===i.bottom?t.height:s.bottom+(!0===i.bottom?0:i.bottom)}}var Hi=Object.freeze({__proto__:null,HALF_PI:E,INFINITY:T,PI:C,PITAU:A,QUARTER_PI:R,RAD_PER_DEG:L,TAU:O,TWO_THIRDS_PI:I,_addGrace:Di,_alignPixel:Ae,_alignStartEnd:ft,_angleBetween:J,_angleDiff:K,_arrayUnique:lt,_attachContext:$e,_bezierCurveTo:Ve,_bezierInterpolation:mi,_boundSegment:Ri,_boundSegments:Ii,_capitalize:w,_computeSegments:zi,_createResolver:je,_decimalPlaces:U,_deprecated:function(t,e,i,s){void 0!==e&&console.warn(t+': "'+i+'" is deprecated. Please use "'+s+'" instead')},_descriptors:Ye,_elementsEqual:f,_factorize:W,_filterBetween:nt,_getParentNode:ge,_getStartAndCountOfVisiblePoints:pt,_int16Range:Q,_isBetween:tt,_isClickEvent:D,_isDomSupported:fe,_isPointInArea:Re,_limitValue:Z,_longestText:Oe,_lookup:et,_lookupByKey:it,_measureText:Ce,_merger:m,_mergerIf:_,_normalizeAngle:G,_parseObjectDataRadialScale:ii,_pointInLine:gi,_readValueToProps:vi,_rlookupByKey:st,_scaleRangesChanged:mt,_setMinAndMaxByKey:j,_splitKey:v,_steppedInterpolation:pi,_steppedLineTo:Fe,_textX:gt,_toLeftRightCenter:ut,_updateBezierControlPoints:hi,addRoundedRectPath:He,almostEquals:V,almostWhole:H,callback:d,clearCanvas:Te,clipArea:Ie,clone:g,color:Qt,createContext:Ci,debounce:dt,defined:k,distanceBetweenPoints:q,drawPoint:Le,drawPointLegend:Ee,each:u,easingEffects:fi,finiteOrDefault:r,fontString:function(t,e,i){return e+" "+t+"px "+i},formatNumber:ne,getAngleFromPoint:X,getDatasetClipArea:Ni,getHoverColor:te,getMaximumSize:we,getRelativePosition:ve,getRtlAdapter:Oi,getStyle:xe,isArray:n,isFinite:a,isFunction:S,isNullOrUndef:s,isNumber:N,isObject:o,isPatternOrGradient:Zt,listenArrayEvents:at,log10:z,merge:x,mergeIf:b,niceNum:B,noop:e,overrideTextDirection:Ai,readUsedSize:Pe,renderText:Ne,requestAnimFrame:ht,resolve:Pi,resolveObjectKey:M,restoreTextDirection:Ti,retinaScale:ke,setsEqual:P,sign:F,splineCurve:ai,splineCurveMonotone:ri,supportsEventListenerOptions:Se,throttled:ct,toDegrees:Y,toDimension:c,toFont:Si,toFontString:De,toLineHeight:_i,toPadding:ki,toPercentage:h,toRadians:$,toTRBL:Mi,toTRBLCorners:wi,uid:i,unclipArea:ze,unlistenArrayEvents:rt,valueOrDefault:l});function ji(t,e,i,n){const{controller:o,data:a,_sorted:r}=t,l=o._cachedMeta.iScale,h=t.dataset&&t.dataset.options?t.dataset.options.spanGaps:null;if(l&&e===l.axis&&"r"!==e&&r&&a.length){const r=l._reversePixels?st:it;if(!n){const n=r(a,e,i);if(h){const{vScale:e}=o._cachedMeta,{_parsed:i}=t,a=i.slice(0,n.lo+1).reverse().findIndex((t=>!s(t[e.axis])));n.lo-=Math.max(0,a);const r=i.slice(n.hi).findIndex((t=>!s(t[e.axis])));n.hi+=Math.max(0,r)}return n}if(o._sharedOptions){const t=a[0],s="function"==typeof t.getRange&&t.getRange(e);if(s){const t=r(a,e,i-s),n=r(a,e,i+s);return{lo:t.lo,hi:n.hi}}}}return{lo:0,hi:a.length-1}}function $i(t,e,i,s,n){const o=t.getSortedVisibleDatasetMetas(),a=i[e];for(let t=0,i=o.length;t<i;++t){const{index:i,data:r}=o[t],{lo:l,hi:h}=ji(o[t],e,a,n);for(let t=l;t<=h;++t){const e=r[t];e.skip||s(e,i,t)}}}function Yi(t,e,i,s,n){const o=[];if(!n&&!t.isPointInArea(e))return o;return $i(t,i,e,(function(i,a,r){(n||Re(i,t.chartArea,0))&&i.inRange(e.x,e.y,s)&&o.push({element:i,datasetIndex:a,index:r})}),!0),o}function Ui(t,e,i,s,n,o){let a=[];const r=function(t){const e=-1!==t.indexOf("x"),i=-1!==t.indexOf("y");return function(t,s){const n=e?Math.abs(t.x-s.x):0,o=i?Math.abs(t.y-s.y):0;return Math.sqrt(Math.pow(n,2)+Math.pow(o,2))}}(i);let l=Number.POSITIVE_INFINITY;return $i(t,i,e,(function(i,h,c){const d=i.inRange(e.x,e.y,n);if(s&&!d)return;const u=i.getCenterPoint(n);if(!(!!o||t.isPointInArea(u))&&!d)return;const f=r(e,u);f<l?(a=[{element:i,datasetIndex:h,index:c}],l=f):f===l&&a.push({element:i,datasetIndex:h,index:c})})),a}function Xi(t,e,i,s,n,o){return o||t.isPointInArea(e)?"r"!==i||s?Ui(t,e,i,s,n,o):function(t,e,i,s){let n=[];return $i(t,i,e,(function(t,i,o){const{startAngle:a,endAngle:r}=t.getProps(["startAngle","endAngle"],s),{angle:l}=X(t,{x:e.x,y:e.y});J(l,a,r)&&n.push({element:t,datasetIndex:i,index:o})})),n}(t,e,i,n):[]}function qi(t,e,i,s,n){const o=[],a="x"===i?"inXRange":"inYRange";let r=!1;return $i(t,i,e,((t,s,l)=>{t[a]&&t[a](e[i],n)&&(o.push({element:t,datasetIndex:s,index:l}),r=r||t.inRange(e.x,e.y,n))})),s&&!r?[]:o}var Ki={evaluateInteractionItems:$i,modes:{index(t,e,i,s){const n=ve(e,t),o=i.axis||"x",a=i.includeInvisible||!1,r=i.intersect?Yi(t,n,o,s,a):Xi(t,n,o,!1,s,a),l=[];return r.length?(t.getSortedVisibleDatasetMetas().forEach((t=>{const e=r[0].index,i=t.data[e];i&&!i.skip&&l.push({element:i,datasetIndex:t.index,index:e})})),l):[]},dataset(t,e,i,s){const n=ve(e,t),o=i.axis||"xy",a=i.includeInvisible||!1;let r=i.intersect?Yi(t,n,o,s,a):Xi(t,n,o,!1,s,a);if(r.length>0){const e=r[0].datasetIndex,i=t.getDatasetMeta(e).data;r=[];for(let t=0;t<i.length;++t)r.push({element:i[t],datasetIndex:e,index:t})}return r},point:(t,e,i,s)=>Yi(t,ve(e,t),i.axis||"xy",s,i.includeInvisible||!1),nearest(t,e,i,s){const n=ve(e,t),o=i.axis||"xy",a=i.includeInvisible||!1;return Xi(t,n,o,i.intersect,s,a)},x:(t,e,i,s)=>qi(t,ve(e,t),"x",i.intersect,s),y:(t,e,i,s)=>qi(t,ve(e,t),"y",i.intersect,s)}};const Gi=["left","top","right","bottom"];function Ji(t,e){return t.filter((t=>t.pos===e))}function Zi(t,e){return t.filter((t=>-1===Gi.indexOf(t.pos)&&t.box.axis===e))}function Qi(t,e){return t.sort(((t,i)=>{const s=e?i:t,n=e?t:i;return s.weight===n.weight?s.index-n.index:s.weight-n.weight}))}function ts(t,e){const i=function(t){const e={};for(const i of t){const{stack:t,pos:s,stackWeight:n}=i;if(!t||!Gi.includes(s))continue;const o=e[t]||(e[t]={count:0,placed:0,weight:0,size:0});o.count++,o.weight+=n}return e}(t),{vBoxMaxWidth:s,hBoxMaxHeight:n}=e;let o,a,r;for(o=0,a=t.length;o<a;++o){r=t[o];const{fullSize:a}=r.box,l=i[r.stack],h=l&&r.stackWeight/l.weight;r.horizontal?(r.width=h?h*s:a&&e.availableWidth,r.height=n):(r.width=s,r.height=h?h*n:a&&e.availableHeight)}return i}function es(t,e,i,s){return Math.max(t[i],e[i])+Math.max(t[s],e[s])}function is(t,e){t.top=Math.max(t.top,e.top),t.left=Math.max(t.left,e.left),t.bottom=Math.max(t.bottom,e.bottom),t.right=Math.max(t.right,e.right)}function ss(t,e,i,s){const{pos:n,box:a}=i,r=t.maxPadding;if(!o(n)){i.size&&(t[n]-=i.size);const e=s[i.stack]||{size:0,count:1};e.size=Math.max(e.size,i.horizontal?a.height:a.width),i.size=e.size/e.count,t[n]+=i.size}a.getPadding&&is(r,a.getPadding());const l=Math.max(0,e.outerWidth-es(r,t,"left","right")),h=Math.max(0,e.outerHeight-es(r,t,"top","bottom")),c=l!==t.w,d=h!==t.h;return t.w=l,t.h=h,i.horizontal?{same:c,other:d}:{same:d,other:c}}function ns(t,e){const i=e.maxPadding;function s(t){const s={left:0,top:0,right:0,bottom:0};return t.forEach((t=>{s[t]=Math.max(e[t],i[t])})),s}return s(t?["left","right"]:["top","bottom"])}function os(t,e,i,s){const n=[];let o,a,r,l,h,c;for(o=0,a=t.length,h=0;o<a;++o){r=t[o],l=r.box,l.update(r.width||e.w,r.height||e.h,ns(r.horizontal,e));const{same:a,other:d}=ss(e,i,r,s);h|=a&&n.length,c=c||d,l.fullSize||n.push(r)}return h&&os(n,e,i,s)||c}function as(t,e,i,s,n){t.top=i,t.left=e,t.right=e+s,t.bottom=i+n,t.width=s,t.height=n}function rs(t,e,i,s){const n=i.padding;let{x:o,y:a}=e;for(const r of t){const t=r.box,l=s[r.stack]||{count:1,placed:0,weight:1},h=r.stackWeight/l.weight||1;if(r.horizontal){const s=e.w*h,o=l.size||t.height;k(l.start)&&(a=l.start),t.fullSize?as(t,n.left,a,i.outerWidth-n.right-n.left,o):as(t,e.left+l.placed,a,s,o),l.start=a,l.placed+=s,a=t.bottom}else{const s=e.h*h,a=l.size||t.width;k(l.start)&&(o=l.start),t.fullSize?as(t,o,n.top,a,i.outerHeight-n.bottom-n.top):as(t,o,e.top+l.placed,a,s),l.start=o,l.placed+=s,o=t.right}}e.x=o,e.y=a}var ls={addBox(t,e){t.boxes||(t.boxes=[]),e.fullSize=e.fullSize||!1,e.position=e.position||"top",e.weight=e.weight||0,e._layers=e._layers||function(){return[{z:0,draw(t){e.draw(t)}}]},t.boxes.push(e)},removeBox(t,e){const i=t.boxes?t.boxes.indexOf(e):-1;-1!==i&&t.boxes.splice(i,1)},configure(t,e,i){e.fullSize=i.fullSize,e.position=i.position,e.weight=i.weight},update(t,e,i,s){if(!t)return;const n=ki(t.options.layout.padding),o=Math.max(e-n.width,0),a=Math.max(i-n.height,0),r=function(t){const e=function(t){const e=[];let i,s,n,o,a,r;for(i=0,s=(t||[]).length;i<s;++i)n=t[i],({position:o,options:{stack:a,stackWeight:r=1}}=n),e.push({index:i,box:n,pos:o,horizontal:n.isHorizontal(),weight:n.weight,stack:a&&o+a,stackWeight:r});return e}(t),i=Qi(e.filter((t=>t.box.fullSize)),!0),s=Qi(Ji(e,"left"),!0),n=Qi(Ji(e,"right")),o=Qi(Ji(e,"top"),!0),a=Qi(Ji(e,"bottom")),r=Zi(e,"x"),l=Zi(e,"y");return{fullSize:i,leftAndTop:s.concat(o),rightAndBottom:n.concat(l).concat(a).concat(r),chartArea:Ji(e,"chartArea"),vertical:s.concat(n).concat(l),horizontal:o.concat(a).concat(r)}}(t.boxes),l=r.vertical,h=r.horizontal;u(t.boxes,(t=>{"function"==typeof t.beforeLayout&&t.beforeLayout()}));const c=l.reduce(((t,e)=>e.box.options&&!1===e.box.options.display?t:t+1),0)||1,d=Object.freeze({outerWidth:e,outerHeight:i,padding:n,availableWidth:o,availableHeight:a,vBoxMaxWidth:o/2/c,hBoxMaxHeight:a/2}),f=Object.assign({},n);is(f,ki(s));const g=Object.assign({maxPadding:f,w:o,h:a,x:n.left,y:n.top},n),p=ts(l.concat(h),d);os(r.fullSize,g,d,p),os(l,g,d,p),os(h,g,d,p)&&os(l,g,d,p),function(t){const e=t.maxPadding;function i(i){const s=Math.max(e[i]-t[i],0);return t[i]+=s,s}t.y+=i("top"),t.x+=i("left"),i("right"),i("bottom")}(g),rs(r.leftAndTop,g,d,p),g.x+=g.w,g.y+=g.h,rs(r.rightAndBottom,g,d,p),t.chartArea={left:g.left,top:g.top,right:g.left+g.w,bottom:g.top+g.h,height:g.h,width:g.w},u(r.chartArea,(e=>{const i=e.box;Object.assign(i,t.chartArea),i.update(g.w,g.h,{left:0,top:0,right:0,bottom:0})}))}};class hs{acquireContext(t,e){}releaseContext(t){return!1}addEventListener(t,e,i){}removeEventListener(t,e,i){}getDevicePixelRatio(){return 1}getMaximumSize(t,e,i,s){return e=Math.max(0,e||t.width),i=i||t.height,{width:e,height:Math.max(0,s?Math.floor(e/s):i)}}isAttached(t){return!0}updateConfig(t){}}class cs extends hs{acquireContext(t){return t&&t.getContext&&t.getContext("2d")||null}updateConfig(t){t.options.animation=!1}}const ds="$chartjs",us={touchstart:"mousedown",touchmove:"mousemove",touchend:"mouseup",pointerenter:"mouseenter",pointerdown:"mousedown",pointermove:"mousemove",pointerup:"mouseup",pointerleave:"mouseout",pointerout:"mouseout"},fs=t=>null===t||""===t;const gs=!!Se&&{passive:!0};function ps(t,e,i){t&&t.canvas&&t.canvas.removeEventListener(e,i,gs)}function ms(t,e){for(const i of t)if(i===e||i.contains(e))return!0}function xs(t,e,i){const s=t.canvas,n=new MutationObserver((t=>{let e=!1;for(const i of t)e=e||ms(i.addedNodes,s),e=e&&!ms(i.removedNodes,s);e&&i()}));return n.observe(document,{childList:!0,subtree:!0}),n}function bs(t,e,i){const s=t.canvas,n=new MutationObserver((t=>{let e=!1;for(const i of t)e=e||ms(i.removedNodes,s),e=e&&!ms(i.addedNodes,s);e&&i()}));return n.observe(document,{childList:!0,subtree:!0}),n}const _s=new Map;let ys=0;function vs(){const t=window.devicePixelRatio;t!==ys&&(ys=t,_s.forEach(((e,i)=>{i.currentDevicePixelRatio!==t&&e()})))}function Ms(t,e,i){const s=t.canvas,n=s&&ge(s);if(!n)return;const o=ct(((t,e)=>{const s=n.clientWidth;i(t,e),s<n.clientWidth&&i()}),window),a=new ResizeObserver((t=>{const e=t[0],i=e.contentRect.width,s=e.contentRect.height;0===i&&0===s||o(i,s)}));return a.observe(n),function(t,e){_s.size||window.addEventListener("resize",vs),_s.set(t,e)}(t,o),a}function ws(t,e,i){i&&i.disconnect(),"resize"===e&&function(t){_s.delete(t),_s.size||window.removeEventListener("resize",vs)}(t)}function ks(t,e,i){const s=t.canvas,n=ct((e=>{null!==t.ctx&&i(function(t,e){const i=us[t.type]||t.type,{x:s,y:n}=ve(t,e);return{type:i,chart:e,native:t,x:void 0!==s?s:null,y:void 0!==n?n:null}}(e,t))}),t);return function(t,e,i){t&&t.addEventListener(e,i,gs)}(s,e,n),n}class Ss extends hs{acquireContext(t,e){const i=t&&t.getContext&&t.getContext("2d");return i&&i.canvas===t?(function(t,e){const i=t.style,s=t.getAttribute("height"),n=t.getAttribute("width");if(t[ds]={initial:{height:s,width:n,style:{display:i.display,height:i.height,width:i.width}}},i.display=i.display||"block",i.boxSizing=i.boxSizing||"border-box",fs(n)){const e=Pe(t,"width");void 0!==e&&(t.width=e)}if(fs(s))if(""===t.style.height)t.height=t.width/(e||2);else{const e=Pe(t,"height");void 0!==e&&(t.height=e)}}(t,e),i):null}releaseContext(t){const e=t.canvas;if(!e[ds])return!1;const i=e[ds].initial;["height","width"].forEach((t=>{const n=i[t];s(n)?e.removeAttribute(t):e.setAttribute(t,n)}));const n=i.style||{};return Object.keys(n).forEach((t=>{e.style[t]=n[t]})),e.width=e.width,delete e[ds],!0}addEventListener(t,e,i){this.removeEventListener(t,e);const s=t.$proxies||(t.$proxies={}),n={attach:xs,detach:bs,resize:Ms}[e]||ks;s[e]=n(t,e,i)}removeEventListener(t,e){const i=t.$proxies||(t.$proxies={}),s=i[e];if(!s)return;({attach:ws,detach:ws,resize:ws}[e]||ps)(t,e,s),i[e]=void 0}getDevicePixelRatio(){return window.devicePixelRatio}getMaximumSize(t,e,i,s){return we(t,e,i,s)}isAttached(t){const e=t&&ge(t);return!(!e||!e.isConnected)}}function Ps(t){return!fe()||"undefined"!=typeof OffscreenCanvas&&t instanceof OffscreenCanvas?cs:Ss}var Ds=Object.freeze({__proto__:null,BasePlatform:hs,BasicPlatform:cs,DomPlatform:Ss,_detectPlatform:Ps});const Cs="transparent",Os={boolean:(t,e,i)=>i>.5?e:t,color(t,e,i){const s=Qt(t||Cs),n=s.valid&&Qt(e||Cs);return n&&n.valid?n.mix(s,i).hexString():e},number:(t,e,i)=>t+(e-t)*i};class As{constructor(t,e,i,s){const n=e[i];s=Pi([t.to,s,n,t.from]);const o=Pi([t.from,n,s]);this._active=!0,this._fn=t.fn||Os[t.type||typeof o],this._easing=fi[t.easing]||fi.linear,this._start=Math.floor(Date.now()+(t.delay||0)),this._duration=this._total=Math.floor(t.duration),this._loop=!!t.loop,this._target=e,this._prop=i,this._from=o,this._to=s,this._promises=void 0}active(){return this._active}update(t,e,i){if(this._active){this._notify(!1);const s=this._target[this._prop],n=i-this._start,o=this._duration-n;this._start=i,this._duration=Math.floor(Math.max(o,t.duration)),this._total+=n,this._loop=!!t.loop,this._to=Pi([t.to,e,s,t.from]),this._from=Pi([t.from,s,e])}}cancel(){this._active&&(this.tick(Date.now()),this._active=!1,this._notify(!1))}tick(t){const e=t-this._start,i=this._duration,s=this._prop,n=this._from,o=this._loop,a=this._to;let r;if(this._active=n!==a&&(o||e<i),!this._active)return this._target[s]=a,void this._notify(!0);e<0?this._target[s]=n:(r=e/i%2,r=o&&r>1?2-r:r,r=this._easing(Math.min(1,Math.max(0,r))),this._target[s]=this._fn(n,a,r))}wait(){const t=this._promises||(this._promises=[]);return new Promise(((e,i)=>{t.push({res:e,rej:i})}))}_notify(t){const e=t?"res":"rej",i=this._promises||[];for(let t=0;t<i.length;t++)i[t][e]()}}class Ts{constructor(t,e){this._chart=t,this._properties=new Map,this.configure(e)}configure(t){if(!o(t))return;const e=Object.keys(ue.animation),i=this._properties;Object.getOwnPropertyNames(t).forEach((s=>{const a=t[s];if(!o(a))return;const r={};for(const t of e)r[t]=a[t];(n(a.properties)&&a.properties||[s]).forEach((t=>{t!==s&&i.has(t)||i.set(t,r)}))}))}_animateOptions(t,e){const i=e.options,s=function(t,e){if(!e)return;let i=t.options;if(!i)return void(t.options=e);i.$shared&&(t.options=i=Object.assign({},i,{$shared:!1,$animations:{}}));return i}(t,i);if(!s)return[];const n=this._createAnimations(s,i);return i.$shared&&function(t,e){const i=[],s=Object.keys(e);for(let e=0;e<s.length;e++){const n=t[s[e]];n&&n.active()&&i.push(n.wait())}return Promise.all(i)}(t.options.$animations,i).then((()=>{t.options=i}),(()=>{})),n}_createAnimations(t,e){const i=this._properties,s=[],n=t.$animations||(t.$animations={}),o=Object.keys(e),a=Date.now();let r;for(r=o.length-1;r>=0;--r){const l=o[r];if("$"===l.charAt(0))continue;if("options"===l){s.push(...this._animateOptions(t,e));continue}const h=e[l];let c=n[l];const d=i.get(l);if(c){if(d&&c.active()){c.update(d,h,a);continue}c.cancel()}d&&d.duration?(n[l]=c=new As(d,t,l,h),s.push(c)):t[l]=h}return s}update(t,e){if(0===this._properties.size)return void Object.assign(t,e);const i=this._createAnimations(t,e);return i.length?(bt.add(this._chart,i),!0):void 0}}function Ls(t,e){const i=t&&t.options||{},s=i.reverse,n=void 0===i.min?e:0,o=void 0===i.max?e:0;return{start:s?o:n,end:s?n:o}}function Es(t,e){const i=[],s=t._getSortedDatasetMetas(e);let n,o;for(n=0,o=s.length;n<o;++n)i.push(s[n].index);return i}function Rs(t,e,i,s={}){const n=t.keys,o="single"===s.mode;let r,l,h,c;if(null===e)return;let d=!1;for(r=0,l=n.length;r<l;++r){if(h=+n[r],h===i){if(d=!0,s.all)continue;break}c=t.values[h],a(c)&&(o||0===e||F(e)===F(c))&&(e+=c)}return d||s.all?e:0}function Is(t,e){const i=t&&t.options.stacked;return i||void 0===i&&void 0!==e.stack}function zs(t,e,i){const s=t[e]||(t[e]={});return s[i]||(s[i]={})}function Fs(t,e,i,s){for(const n of e.getMatchingVisibleMetas(s).reverse()){const e=t[n.index];if(i&&e>0||!i&&e<0)return n.index}return null}function Vs(t,e){const{chart:i,_cachedMeta:s}=t,n=i._stacks||(i._stacks={}),{iScale:o,vScale:a,index:r}=s,l=o.axis,h=a.axis,c=function(t,e,i){return`${t.id}.${e.id}.${i.stack||i.type}`}(o,a,s),d=e.length;let u;for(let t=0;t<d;++t){const i=e[t],{[l]:o,[h]:d}=i;u=(i._stacks||(i._stacks={}))[h]=zs(n,c,o),u[r]=d,u._top=Fs(u,a,!0,s.type),u._bottom=Fs(u,a,!1,s.type);(u._visualValues||(u._visualValues={}))[r]=d}}function Bs(t,e){const i=t.scales;return Object.keys(i).filter((t=>i[t].axis===e)).shift()}function Ws(t,e){const i=t.controller.index,s=t.vScale&&t.vScale.axis;if(s){e=e||t._parsed;for(const t of e){const e=t._stacks;if(!e||void 0===e[s]||void 0===e[s][i])return;delete e[s][i],void 0!==e[s]._visualValues&&void 0!==e[s]._visualValues[i]&&delete e[s]._visualValues[i]}}}const Ns=t=>"reset"===t||"none"===t,Hs=(t,e)=>e?t:Object.assign({},t);class js{static defaults={};static datasetElementType=null;static dataElementType=null;constructor(t,e){this.chart=t,this._ctx=t.ctx,this.index=e,this._cachedDataOpts={},this._cachedMeta=this.getMeta(),this._type=this._cachedMeta.type,this.options=void 0,this._parsing=!1,this._data=void 0,this._objectData=void 0,this._sharedOptions=void 0,this._drawStart=void 0,this._drawCount=void 0,this.enableOptionSharing=!1,this.supportsDecimation=!1,this.$context=void 0,this._syncList=[],this.datasetElementType=new.target.datasetElementType,this.dataElementType=new.target.dataElementType,this.initialize()}initialize(){const t=this._cachedMeta;this.configure(),this.linkScales(),t._stacked=Is(t.vScale,t),this.addElements(),this.options.fill&&!this.chart.isPluginEnabled("filler")&&console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options")}updateIndex(t){this.index!==t&&Ws(this._cachedMeta),this.index=t}linkScales(){const t=this.chart,e=this._cachedMeta,i=this.getDataset(),s=(t,e,i,s)=>"x"===t?e:"r"===t?s:i,n=e.xAxisID=l(i.xAxisID,Bs(t,"x")),o=e.yAxisID=l(i.yAxisID,Bs(t,"y")),a=e.rAxisID=l(i.rAxisID,Bs(t,"r")),r=e.indexAxis,h=e.iAxisID=s(r,n,o,a),c=e.vAxisID=s(r,o,n,a);e.xScale=this.getScaleForId(n),e.yScale=this.getScaleForId(o),e.rScale=this.getScaleForId(a),e.iScale=this.getScaleForId(h),e.vScale=this.getScaleForId(c)}getDataset(){return this.chart.data.datasets[this.index]}getMeta(){return this.chart.getDatasetMeta(this.index)}getScaleForId(t){return this.chart.scales[t]}_getOtherScale(t){const e=this._cachedMeta;return t===e.iScale?e.vScale:e.iScale}reset(){this._update("reset")}_destroy(){const t=this._cachedMeta;this._data&&rt(this._data,this),t._stacked&&Ws(t)}_dataCheck(){const t=this.getDataset(),e=t.data||(t.data=[]),i=this._data;if(o(e)){const t=this._cachedMeta;this._data=function(t,e){const{iScale:i,vScale:s}=e,n="x"===i.axis?"x":"y",o="x"===s.axis?"x":"y",a=Object.keys(t),r=new Array(a.length);let l,h,c;for(l=0,h=a.length;l<h;++l)c=a[l],r[l]={[n]:c,[o]:t[c]};return r}(e,t)}else if(i!==e){if(i){rt(i,this);const t=this._cachedMeta;Ws(t),t._parsed=[]}e&&Object.isExtensible(e)&&at(e,this),this._syncList=[],this._data=e}}addElements(){const t=this._cachedMeta;this._dataCheck(),this.datasetElementType&&(t.dataset=new this.datasetElementType)}buildOrUpdateElements(t){const e=this._cachedMeta,i=this.getDataset();let s=!1;this._dataCheck();const n=e._stacked;e._stacked=Is(e.vScale,e),e.stack!==i.stack&&(s=!0,Ws(e),e.stack=i.stack),this._resyncElements(t),(s||n!==e._stacked)&&(Vs(this,e._parsed),e._stacked=Is(e.vScale,e))}configure(){const t=this.chart.config,e=t.datasetScopeKeys(this._type),i=t.getOptionScopes(this.getDataset(),e,!0);this.options=t.createResolver(i,this.getContext()),this._parsing=this.options.parsing,this._cachedDataOpts={}}parse(t,e){const{_cachedMeta:i,_data:s}=this,{iScale:a,_stacked:r}=i,l=a.axis;let h,c,d,u=0===t&&e===s.length||i._sorted,f=t>0&&i._parsed[t-1];if(!1===this._parsing)i._parsed=s,i._sorted=!0,d=s;else{d=n(s[t])?this.parseArrayData(i,s,t,e):o(s[t])?this.parseObjectData(i,s,t,e):this.parsePrimitiveData(i,s,t,e);const a=()=>null===c[l]||f&&c[l]<f[l];for(h=0;h<e;++h)i._parsed[h+t]=c=d[h],u&&(a()&&(u=!1),f=c);i._sorted=u}r&&Vs(this,d)}parsePrimitiveData(t,e,i,s){const{iScale:n,vScale:o}=t,a=n.axis,r=o.axis,l=n.getLabels(),h=n===o,c=new Array(s);let d,u,f;for(d=0,u=s;d<u;++d)f=d+i,c[d]={[a]:h||n.parse(l[f],f),[r]:o.parse(e[f],f)};return c}parseArrayData(t,e,i,s){const{xScale:n,yScale:o}=t,a=new Array(s);let r,l,h,c;for(r=0,l=s;r<l;++r)h=r+i,c=e[h],a[r]={x:n.parse(c[0],h),y:o.parse(c[1],h)};return a}parseObjectData(t,e,i,s){const{xScale:n,yScale:o}=t,{xAxisKey:a="x",yAxisKey:r="y"}=this._parsing,l=new Array(s);let h,c,d,u;for(h=0,c=s;h<c;++h)d=h+i,u=e[d],l[h]={x:n.parse(M(u,a),d),y:o.parse(M(u,r),d)};return l}getParsed(t){return this._cachedMeta._parsed[t]}getDataElement(t){return this._cachedMeta.data[t]}applyStack(t,e,i){const s=this.chart,n=this._cachedMeta,o=e[t.axis];return Rs({keys:Es(s,!0),values:e._stacks[t.axis]._visualValues},o,n.index,{mode:i})}updateRangeFromParsed(t,e,i,s){const n=i[e.axis];let o=null===n?NaN:n;const a=s&&i._stacks[e.axis];s&&a&&(s.values=a,o=Rs(s,n,this._cachedMeta.index)),t.min=Math.min(t.min,o),t.max=Math.max(t.max,o)}getMinMax(t,e){const i=this._cachedMeta,s=i._parsed,n=i._sorted&&t===i.iScale,o=s.length,r=this._getOtherScale(t),l=((t,e,i)=>t&&!e.hidden&&e._stacked&&{keys:Es(i,!0),values:null})(e,i,this.chart),h={min:Number.POSITIVE_INFINITY,max:Number.NEGATIVE_INFINITY},{min:c,max:d}=function(t){const{min:e,max:i,minDefined:s,maxDefined:n}=t.getUserBounds();return{min:s?e:Number.NEGATIVE_INFINITY,max:n?i:Number.POSITIVE_INFINITY}}(r);let u,f;function g(){f=s[u];const e=f[r.axis];return!a(f[t.axis])||c>e||d<e}for(u=0;u<o&&(g()||(this.updateRangeFromParsed(h,t,f,l),!n));++u);if(n)for(u=o-1;u>=0;--u)if(!g()){this.updateRangeFromParsed(h,t,f,l);break}return h}getAllParsedValues(t){const e=this._cachedMeta._parsed,i=[];let s,n,o;for(s=0,n=e.length;s<n;++s)o=e[s][t.axis],a(o)&&i.push(o);return i}getMaxOverflow(){return!1}getLabelAndValue(t){const e=this._cachedMeta,i=e.iScale,s=e.vScale,n=this.getParsed(t);return{label:i?""+i.getLabelForValue(n[i.axis]):"",value:s?""+s.getLabelForValue(n[s.axis]):""}}_update(t){const e=this._cachedMeta;this.update(t||"default"),e._clip=function(t){let e,i,s,n;return o(t)?(e=t.top,i=t.right,s=t.bottom,n=t.left):e=i=s=n=t,{top:e,right:i,bottom:s,left:n,disabled:!1===t}}(l(this.options.clip,function(t,e,i){if(!1===i)return!1;const s=Ls(t,i),n=Ls(e,i);return{top:n.end,right:s.end,bottom:n.start,left:s.start}}(e.xScale,e.yScale,this.getMaxOverflow())))}update(t){}draw(){const t=this._ctx,e=this.chart,i=this._cachedMeta,s=i.data||[],n=e.chartArea,o=[],a=this._drawStart||0,r=this._drawCount||s.length-a,l=this.options.drawActiveElementsOnTop;let h;for(i.dataset&&i.dataset.draw(t,n,a,r),h=a;h<a+r;++h){const e=s[h];e.hidden||(e.active&&l?o.push(e):e.draw(t,n))}for(h=0;h<o.length;++h)o[h].draw(t,n)}getStyle(t,e){const i=e?"active":"default";return void 0===t&&this._cachedMeta.dataset?this.resolveDatasetElementOptions(i):this.resolveDataElementOptions(t||0,i)}getContext(t,e,i){const s=this.getDataset();let n;if(t>=0&&t<this._cachedMeta.data.length){const e=this._cachedMeta.data[t];n=e.$context||(e.$context=function(t,e,i){return Ci(t,{active:!1,dataIndex:e,parsed:void 0,raw:void 0,element:i,index:e,mode:"default",type:"data"})}(this.getContext(),t,e)),n.parsed=this.getParsed(t),n.raw=s.data[t],n.index=n.dataIndex=t}else n=this.$context||(this.$context=function(t,e){return Ci(t,{active:!1,dataset:void 0,datasetIndex:e,index:e,mode:"default",type:"dataset"})}(this.chart.getContext(),this.index)),n.dataset=s,n.index=n.datasetIndex=this.index;return n.active=!!e,n.mode=i,n}resolveDatasetElementOptions(t){return this._resolveElementOptions(this.datasetElementType.id,t)}resolveDataElementOptions(t,e){return this._resolveElementOptions(this.dataElementType.id,e,t)}_resolveElementOptions(t,e="default",i){const s="active"===e,n=this._cachedDataOpts,o=t+"-"+e,a=n[o],r=this.enableOptionSharing&&k(i);if(a)return Hs(a,r);const l=this.chart.config,h=l.datasetElementScopeKeys(this._type,t),c=s?[`${t}Hover`,"hover",t,""]:[t,""],d=l.getOptionScopes(this.getDataset(),h),u=Object.keys(ue.elements[t]),f=l.resolveNamedOptions(d,u,(()=>this.getContext(i,s,e)),c);return f.$shared&&(f.$shared=r,n[o]=Object.freeze(Hs(f,r))),f}_resolveAnimations(t,e,i){const s=this.chart,n=this._cachedDataOpts,o=`animation-${e}`,a=n[o];if(a)return a;let r;if(!1!==s.options.animation){const s=this.chart.config,n=s.datasetAnimationScopeKeys(this._type,e),o=s.getOptionScopes(this.getDataset(),n);r=s.createResolver(o,this.getContext(t,i,e))}const l=new Ts(s,r&&r.animations);return r&&r._cacheable&&(n[o]=Object.freeze(l)),l}getSharedOptions(t){if(t.$shared)return this._sharedOptions||(this._sharedOptions=Object.assign({},t))}includeOptions(t,e){return!e||Ns(t)||this.chart._animationsDisabled}_getSharedOptions(t,e){const i=this.resolveDataElementOptions(t,e),s=this._sharedOptions,n=this.getSharedOptions(i),o=this.includeOptions(e,n)||n!==s;return this.updateSharedOptions(n,e,i),{sharedOptions:n,includeOptions:o}}updateElement(t,e,i,s){Ns(s)?Object.assign(t,i):this._resolveAnimations(e,s).update(t,i)}updateSharedOptions(t,e,i){t&&!Ns(e)&&this._resolveAnimations(void 0,e).update(t,i)}_setStyle(t,e,i,s){t.active=s;const n=this.getStyle(e,s);this._resolveAnimations(e,i,s).update(t,{options:!s&&this.getSharedOptions(n)||n})}removeHoverStyle(t,e,i){this._setStyle(t,i,"active",!1)}setHoverStyle(t,e,i){this._setStyle(t,i,"active",!0)}_removeDatasetHoverStyle(){const t=this._cachedMeta.dataset;t&&this._setStyle(t,void 0,"active",!1)}_setDatasetHoverStyle(){const t=this._cachedMeta.dataset;t&&this._setStyle(t,void 0,"active",!0)}_resyncElements(t){const e=this._data,i=this._cachedMeta.data;for(const[t,e,i]of this._syncList)this[t](e,i);this._syncList=[];const s=i.length,n=e.length,o=Math.min(n,s);o&&this.parse(0,o),n>s?this._insertElements(s,n-s,t):n<s&&this._removeElements(n,s-n)}_insertElements(t,e,i=!0){const s=this._cachedMeta,n=s.data,o=t+e;let a;const r=t=>{for(t.length+=e,a=t.length-1;a>=o;a--)t[a]=t[a-e]};for(r(n),a=t;a<o;++a)n[a]=new this.dataElementType;this._parsing&&r(s._parsed),this.parse(t,e),i&&this.updateElements(n,t,e,"reset")}updateElements(t,e,i,s){}_removeElements(t,e){const i=this._cachedMeta;if(this._parsing){const s=i._parsed.splice(t,e);i._stacked&&Ws(i,s)}i.data.splice(t,e)}_sync(t){if(this._parsing)this._syncList.push(t);else{const[e,i,s]=t;this[e](i,s)}this.chart._dataChanges.push([this.index,...t])}_onDataPush(){const t=arguments.length;this._sync(["_insertElements",this.getDataset().data.length-t,t])}_onDataPop(){this._sync(["_removeElements",this._cachedMeta.data.length-1,1])}_onDataShift(){this._sync(["_removeElements",0,1])}_onDataSplice(t,e){e&&this._sync(["_removeElements",t,e]);const i=arguments.length-2;i&&this._sync(["_insertElements",t,i])}_onDataUnshift(){this._sync(["_insertElements",0,arguments.length])}}class $s{static defaults={};static defaultRoutes=void 0;x;y;active=!1;options;$animations;tooltipPosition(t){const{x:e,y:i}=this.getProps(["x","y"],t);return{x:e,y:i}}hasValue(){return N(this.x)&&N(this.y)}getProps(t,e){const i=this.$animations;if(!e||!i)return this;const s={};return t.forEach((t=>{s[t]=i[t]&&i[t].active()?i[t]._to:this[t]})),s}}function Ys(t,e){const i=t.options.ticks,n=function(t){const e=t.options.offset,i=t._tickSize(),s=t._length/i+(e?0:1),n=t._maxLength/i;return Math.floor(Math.min(s,n))}(t),o=Math.min(i.maxTicksLimit||n,n),a=i.major.enabled?function(t){const e=[];let i,s;for(i=0,s=t.length;i<s;i++)t[i].major&&e.push(i);return e}(e):[],r=a.length,l=a[0],h=a[r-1],c=[];if(r>o)return function(t,e,i,s){let n,o=0,a=i[0];for(s=Math.ceil(s),n=0;n<t.length;n++)n===a&&(e.push(t[n]),o++,a=i[o*s])}(e,c,a,r/o),c;const d=function(t,e,i){const s=function(t){const e=t.length;let i,s;if(e<2)return!1;for(s=t[0],i=1;i<e;++i)if(t[i]-t[i-1]!==s)return!1;return s}(t),n=e.length/i;if(!s)return Math.max(n,1);const o=W(s);for(let t=0,e=o.length-1;t<e;t++){const e=o[t];if(e>n)return e}return Math.max(n,1)}(a,e,o);if(r>0){let t,i;const n=r>1?Math.round((h-l)/(r-1)):null;for(Us(e,c,d,s(n)?0:l-n,l),t=0,i=r-1;t<i;t++)Us(e,c,d,a[t],a[t+1]);return Us(e,c,d,h,s(n)?e.length:h+n),c}return Us(e,c,d),c}function Us(t,e,i,s,n){const o=l(s,0),a=Math.min(l(n,t.length),t.length);let r,h,c,d=0;for(i=Math.ceil(i),n&&(r=n-s,i=r/Math.floor(r/i)),c=o;c<0;)d++,c=Math.round(o+d*i);for(h=Math.max(o,0);h<a;h++)h===c&&(e.push(t[h]),d++,c=Math.round(o+d*i))}const Xs=(t,e,i)=>"top"===e||"left"===e?t[e]+i:t[e]-i,qs=(t,e)=>Math.min(e||t,t);function Ks(t,e){const i=[],s=t.length/e,n=t.length;let o=0;for(;o<n;o+=s)i.push(t[Math.floor(o)]);return i}function Gs(t,e,i){const s=t.ticks.length,n=Math.min(e,s-1),o=t._startPixel,a=t._endPixel,r=1e-6;let l,h=t.getPixelForTick(n);if(!(i&&(l=1===s?Math.max(h-o,a-h):0===e?(t.getPixelForTick(1)-h)/2:(h-t.getPixelForTick(n-1))/2,h+=n<e?l:-l,h<o-r||h>a+r)))return h}function Js(t){return t.drawTicks?t.tickLength:0}function Zs(t,e){if(!t.display)return 0;const i=Si(t.font,e),s=ki(t.padding);return(n(t.text)?t.text.length:1)*i.lineHeight+s.height}function Qs(t,e,i){let s=ut(t);return(i&&"right"!==e||!i&&"right"===e)&&(s=(t=>"left"===t?"right":"right"===t?"left":t)(s)),s}class tn extends $s{constructor(t){super(),this.id=t.id,this.type=t.type,this.options=void 0,this.ctx=t.ctx,this.chart=t.chart,this.top=void 0,this.bottom=void 0,this.left=void 0,this.right=void 0,this.width=void 0,this.height=void 0,this._margins={left:0,right:0,top:0,bottom:0},this.maxWidth=void 0,this.maxHeight=void 0,this.paddingTop=void 0,this.paddingBottom=void 0,this.paddingLeft=void 0,this.paddingRight=void 0,this.axis=void 0,this.labelRotation=void 0,this.min=void 0,this.max=void 0,this._range=void 0,this.ticks=[],this._gridLineItems=null,this._labelItems=null,this._labelSizes=null,this._length=0,this._maxLength=0,this._longestTextCache={},this._startPixel=void 0,this._endPixel=void 0,this._reversePixels=!1,this._userMax=void 0,this._userMin=void 0,this._suggestedMax=void 0,this._suggestedMin=void 0,this._ticksLength=0,this._borderValue=0,this._cache={},this._dataLimitsCached=!1,this.$context=void 0}init(t){this.options=t.setContext(this.getContext()),this.axis=t.axis,this._userMin=this.parse(t.min),this._userMax=this.parse(t.max),this._suggestedMin=this.parse(t.suggestedMin),this._suggestedMax=this.parse(t.suggestedMax)}parse(t,e){return t}getUserBounds(){let{_userMin:t,_userMax:e,_suggestedMin:i,_suggestedMax:s}=this;return t=r(t,Number.POSITIVE_INFINITY),e=r(e,Number.NEGATIVE_INFINITY),i=r(i,Number.POSITIVE_INFINITY),s=r(s,Number.NEGATIVE_INFINITY),{min:r(t,i),max:r(e,s),minDefined:a(t),maxDefined:a(e)}}getMinMax(t){let e,{min:i,max:s,minDefined:n,maxDefined:o}=this.getUserBounds();if(n&&o)return{min:i,max:s};const a=this.getMatchingVisibleMetas();for(let r=0,l=a.length;r<l;++r)e=a[r].controller.getMinMax(this,t),n||(i=Math.min(i,e.min)),o||(s=Math.max(s,e.max));return i=o&&i>s?s:i,s=n&&i>s?i:s,{min:r(i,r(s,i)),max:r(s,r(i,s))}}getPadding(){return{left:this.paddingLeft||0,top:this.paddingTop||0,right:this.paddingRight||0,bottom:this.paddingBottom||0}}getTicks(){return this.ticks}getLabels(){const t=this.chart.data;return this.options.labels||(this.isHorizontal()?t.xLabels:t.yLabels)||t.labels||[]}getLabelItems(t=this.chart.chartArea){return this._labelItems||(this._labelItems=this._computeLabelItems(t))}beforeLayout(){this._cache={},this._dataLimitsCached=!1}beforeUpdate(){d(this.options.beforeUpdate,[this])}update(t,e,i){const{beginAtZero:s,grace:n,ticks:o}=this.options,a=o.sampleSize;this.beforeUpdate(),this.maxWidth=t,this.maxHeight=e,this._margins=i=Object.assign({left:0,right:0,top:0,bottom:0},i),this.ticks=null,this._labelSizes=null,this._gridLineItems=null,this._labelItems=null,this.beforeSetDimensions(),this.setDimensions(),this.afterSetDimensions(),this._maxLength=this.isHorizontal()?this.width+i.left+i.right:this.height+i.top+i.bottom,this._dataLimitsCached||(this.beforeDataLimits(),this.determineDataLimits(),this.afterDataLimits(),this._range=Di(this,n,s),this._dataLimitsCached=!0),this.beforeBuildTicks(),this.ticks=this.buildTicks()||[],this.afterBuildTicks();const r=a<this.ticks.length;this._convertTicksToLabels(r?Ks(this.ticks,a):this.ticks),this.configure(),this.beforeCalculateLabelRotation(),this.calculateLabelRotation(),this.afterCalculateLabelRotation(),o.display&&(o.autoSkip||"auto"===o.source)&&(this.ticks=Ys(this,this.ticks),this._labelSizes=null,this.afterAutoSkip()),r&&this._convertTicksToLabels(this.ticks),this.beforeFit(),this.fit(),this.afterFit(),this.afterUpdate()}configure(){let t,e,i=this.options.reverse;this.isHorizontal()?(t=this.left,e=this.right):(t=this.top,e=this.bottom,i=!i),this._startPixel=t,this._endPixel=e,this._reversePixels=i,this._length=e-t,this._alignToPixels=this.options.alignToPixels}afterUpdate(){d(this.options.afterUpdate,[this])}beforeSetDimensions(){d(this.options.beforeSetDimensions,[this])}setDimensions(){this.isHorizontal()?(this.width=this.maxWidth,this.left=0,this.right=this.width):(this.height=this.maxHeight,this.top=0,this.bottom=this.height),this.paddingLeft=0,this.paddingTop=0,this.paddingRight=0,this.paddingBottom=0}afterSetDimensions(){d(this.options.afterSetDimensions,[this])}_callHooks(t){this.chart.notifyPlugins(t,this.getContext()),d(this.options[t],[this])}beforeDataLimits(){this._callHooks("beforeDataLimits")}determineDataLimits(){}afterDataLimits(){this._callHooks("afterDataLimits")}beforeBuildTicks(){this._callHooks("beforeBuildTicks")}buildTicks(){return[]}afterBuildTicks(){this._callHooks("afterBuildTicks")}beforeTickToLabelConversion(){d(this.options.beforeTickToLabelConversion,[this])}generateTickLabels(t){const e=this.options.ticks;let i,s,n;for(i=0,s=t.length;i<s;i++)n=t[i],n.label=d(e.callback,[n.value,i,t],this)}afterTickToLabelConversion(){d(this.options.afterTickToLabelConversion,[this])}beforeCalculateLabelRotation(){d(this.options.beforeCalculateLabelRotation,[this])}calculateLabelRotation(){const t=this.options,e=t.ticks,i=qs(this.ticks.length,t.ticks.maxTicksLimit),s=e.minRotation||0,n=e.maxRotation;let o,a,r,l=s;if(!this._isVisible()||!e.display||s>=n||i<=1||!this.isHorizontal())return void(this.labelRotation=s);const h=this._getLabelSizes(),c=h.widest.width,d=h.highest.height,u=Z(this.chart.width-c,0,this.maxWidth);o=t.offset?this.maxWidth/i:u/(i-1),c+6>o&&(o=u/(i-(t.offset?.5:1)),a=this.maxHeight-Js(t.grid)-e.padding-Zs(t.title,this.chart.options.font),r=Math.sqrt(c*c+d*d),l=Y(Math.min(Math.asin(Z((h.highest.height+6)/o,-1,1)),Math.asin(Z(a/r,-1,1))-Math.asin(Z(d/r,-1,1)))),l=Math.max(s,Math.min(n,l))),this.labelRotation=l}afterCalculateLabelRotation(){d(this.options.afterCalculateLabelRotation,[this])}afterAutoSkip(){}beforeFit(){d(this.options.beforeFit,[this])}fit(){const t={width:0,height:0},{chart:e,options:{ticks:i,title:s,grid:n}}=this,o=this._isVisible(),a=this.isHorizontal();if(o){const o=Zs(s,e.options.font);if(a?(t.width=this.maxWidth,t.height=Js(n)+o):(t.height=this.maxHeight,t.width=Js(n)+o),i.display&&this.ticks.length){const{first:e,last:s,widest:n,highest:o}=this._getLabelSizes(),r=2*i.padding,l=$(this.labelRotation),h=Math.cos(l),c=Math.sin(l);if(a){const e=i.mirror?0:c*n.width+h*o.height;t.height=Math.min(this.maxHeight,t.height+e+r)}else{const e=i.mirror?0:h*n.width+c*o.height;t.width=Math.min(this.maxWidth,t.width+e+r)}this._calculatePadding(e,s,c,h)}}this._handleMargins(),a?(this.width=this._length=e.width-this._margins.left-this._margins.right,this.height=t.height):(this.width=t.width,this.height=this._length=e.height-this._margins.top-this._margins.bottom)}_calculatePadding(t,e,i,s){const{ticks:{align:n,padding:o},position:a}=this.options,r=0!==this.labelRotation,l="top"!==a&&"x"===this.axis;if(this.isHorizontal()){const a=this.getPixelForTick(0)-this.left,h=this.right-this.getPixelForTick(this.ticks.length-1);let c=0,d=0;r?l?(c=s*t.width,d=i*e.height):(c=i*t.height,d=s*e.width):"start"===n?d=e.width:"end"===n?c=t.width:"inner"!==n&&(c=t.width/2,d=e.width/2),this.paddingLeft=Math.max((c-a+o)*this.width/(this.width-a),0),this.paddingRight=Math.max((d-h+o)*this.width/(this.width-h),0)}else{let i=e.height/2,s=t.height/2;"start"===n?(i=0,s=t.height):"end"===n&&(i=e.height,s=0),this.paddingTop=i+o,this.paddingBottom=s+o}}_handleMargins(){this._margins&&(this._margins.left=Math.max(this.paddingLeft,this._margins.left),this._margins.top=Math.max(this.paddingTop,this._margins.top),this._margins.right=Math.max(this.paddingRight,this._margins.right),this._margins.bottom=Math.max(this.paddingBottom,this._margins.bottom))}afterFit(){d(this.options.afterFit,[this])}isHorizontal(){const{axis:t,position:e}=this.options;return"top"===e||"bottom"===e||"x"===t}isFullSize(){return this.options.fullSize}_convertTicksToLabels(t){let e,i;for(this.beforeTickToLabelConversion(),this.generateTickLabels(t),e=0,i=t.length;e<i;e++)s(t[e].label)&&(t.splice(e,1),i--,e--);this.afterTickToLabelConversion()}_getLabelSizes(){let t=this._labelSizes;if(!t){const e=this.options.ticks.sampleSize;let i=this.ticks;e<i.length&&(i=Ks(i,e)),this._labelSizes=t=this._computeLabelSizes(i,i.length,this.options.ticks.maxTicksLimit)}return t}_computeLabelSizes(t,e,i){const{ctx:o,_longestTextCache:a}=this,r=[],l=[],h=Math.floor(e/qs(e,i));let c,d,f,g,p,m,x,b,_,y,v,M=0,w=0;for(c=0;c<e;c+=h){if(g=t[c].label,p=this._resolveTickFontOptions(c),o.font=m=p.string,x=a[m]=a[m]||{data:{},gc:[]},b=p.lineHeight,_=y=0,s(g)||n(g)){if(n(g))for(d=0,f=g.length;d<f;++d)v=g[d],s(v)||n(v)||(_=Ce(o,x.data,x.gc,_,v),y+=b)}else _=Ce(o,x.data,x.gc,_,g),y=b;r.push(_),l.push(y),M=Math.max(_,M),w=Math.max(y,w)}!function(t,e){u(t,(t=>{const i=t.gc,s=i.length/2;let n;if(s>e){for(n=0;n<s;++n)delete t.data[i[n]];i.splice(0,s)}}))}(a,e);const k=r.indexOf(M),S=l.indexOf(w),P=t=>({width:r[t]||0,height:l[t]||0});return{first:P(0),last:P(e-1),widest:P(k),highest:P(S),widths:r,heights:l}}getLabelForValue(t){return t}getPixelForValue(t,e){return NaN}getValueForPixel(t){}getPixelForTick(t){const e=this.ticks;return t<0||t>e.length-1?null:this.getPixelForValue(e[t].value)}getPixelForDecimal(t){this._reversePixels&&(t=1-t);const e=this._startPixel+t*this._length;return Q(this._alignToPixels?Ae(this.chart,e,0):e)}getDecimalForPixel(t){const e=(t-this._startPixel)/this._length;return this._reversePixels?1-e:e}getBasePixel(){return this.getPixelForValue(this.getBaseValue())}getBaseValue(){const{min:t,max:e}=this;return t<0&&e<0?e:t>0&&e>0?t:0}getContext(t){const e=this.ticks||[];if(t>=0&&t<e.length){const i=e[t];return i.$context||(i.$context=function(t,e,i){return Ci(t,{tick:i,index:e,type:"tick"})}(this.getContext(),t,i))}return this.$context||(this.$context=Ci(this.chart.getContext(),{scale:this,type:"scale"}))}_tickSize(){const t=this.options.ticks,e=$(this.labelRotation),i=Math.abs(Math.cos(e)),s=Math.abs(Math.sin(e)),n=this._getLabelSizes(),o=t.autoSkipPadding||0,a=n?n.widest.width+o:0,r=n?n.highest.height+o:0;return this.isHorizontal()?r*i>a*s?a/i:r/s:r*s<a*i?r/i:a/s}_isVisible(){const t=this.options.display;return"auto"!==t?!!t:this.getMatchingVisibleMetas().length>0}_computeGridLineItems(t){const e=this.axis,i=this.chart,s=this.options,{grid:n,position:a,border:r}=s,h=n.offset,c=this.isHorizontal(),d=this.ticks.length+(h?1:0),u=Js(n),f=[],g=r.setContext(this.getContext()),p=g.display?g.width:0,m=p/2,x=function(t){return Ae(i,t,p)};let b,_,y,v,M,w,k,S,P,D,C,O;if("top"===a)b=x(this.bottom),w=this.bottom-u,S=b-m,D=x(t.top)+m,O=t.bottom;else if("bottom"===a)b=x(this.top),D=t.top,O=x(t.bottom)-m,w=b+m,S=this.top+u;else if("left"===a)b=x(this.right),M=this.right-u,k=b-m,P=x(t.left)+m,C=t.right;else if("right"===a)b=x(this.left),P=t.left,C=x(t.right)-m,M=b+m,k=this.left+u;else if("x"===e){if("center"===a)b=x((t.top+t.bottom)/2+.5);else if(o(a)){const t=Object.keys(a)[0],e=a[t];b=x(this.chart.scales[t].getPixelForValue(e))}D=t.top,O=t.bottom,w=b+m,S=w+u}else if("y"===e){if("center"===a)b=x((t.left+t.right)/2);else if(o(a)){const t=Object.keys(a)[0],e=a[t];b=x(this.chart.scales[t].getPixelForValue(e))}M=b-m,k=M-u,P=t.left,C=t.right}const A=l(s.ticks.maxTicksLimit,d),T=Math.max(1,Math.ceil(d/A));for(_=0;_<d;_+=T){const t=this.getContext(_),e=n.setContext(t),s=r.setContext(t),o=e.lineWidth,a=e.color,l=s.dash||[],d=s.dashOffset,u=e.tickWidth,g=e.tickColor,p=e.tickBorderDash||[],m=e.tickBorderDashOffset;y=Gs(this,_,h),void 0!==y&&(v=Ae(i,y,o),c?M=k=P=C=v:w=S=D=O=v,f.push({tx1:M,ty1:w,tx2:k,ty2:S,x1:P,y1:D,x2:C,y2:O,width:o,color:a,borderDash:l,borderDashOffset:d,tickWidth:u,tickColor:g,tickBorderDash:p,tickBorderDashOffset:m}))}return this._ticksLength=d,this._borderValue=b,f}_computeLabelItems(t){const e=this.axis,i=this.options,{position:s,ticks:a}=i,r=this.isHorizontal(),l=this.ticks,{align:h,crossAlign:c,padding:d,mirror:u}=a,f=Js(i.grid),g=f+d,p=u?-d:g,m=-$(this.labelRotation),x=[];let b,_,y,v,M,w,k,S,P,D,C,O,A="middle";if("top"===s)w=this.bottom-p,k=this._getXAxisLabelAlignment();else if("bottom"===s)w=this.top+p,k=this._getXAxisLabelAlignment();else if("left"===s){const t=this._getYAxisLabelAlignment(f);k=t.textAlign,M=t.x}else if("right"===s){const t=this._getYAxisLabelAlignment(f);k=t.textAlign,M=t.x}else if("x"===e){if("center"===s)w=(t.top+t.bottom)/2+g;else if(o(s)){const t=Object.keys(s)[0],e=s[t];w=this.chart.scales[t].getPixelForValue(e)+g}k=this._getXAxisLabelAlignment()}else if("y"===e){if("center"===s)M=(t.left+t.right)/2-g;else if(o(s)){const t=Object.keys(s)[0],e=s[t];M=this.chart.scales[t].getPixelForValue(e)}k=this._getYAxisLabelAlignment(f).textAlign}"y"===e&&("start"===h?A="top":"end"===h&&(A="bottom"));const T=this._getLabelSizes();for(b=0,_=l.length;b<_;++b){y=l[b],v=y.label;const t=a.setContext(this.getContext(b));S=this.getPixelForTick(b)+a.labelOffset,P=this._resolveTickFontOptions(b),D=P.lineHeight,C=n(v)?v.length:1;const e=C/2,i=t.color,o=t.textStrokeColor,h=t.textStrokeWidth;let d,f=k;if(r?(M=S,"inner"===k&&(f=b===_-1?this.options.reverse?"left":"right":0===b?this.options.reverse?"right":"left":"center"),O="top"===s?"near"===c||0!==m?-C*D+D/2:"center"===c?-T.highest.height/2-e*D+D:-T.highest.height+D/2:"near"===c||0!==m?D/2:"center"===c?T.highest.height/2-e*D:T.highest.height-C*D,u&&(O*=-1),0===m||t.showLabelBackdrop||(M+=D/2*Math.sin(m))):(w=S,O=(1-C)*D/2),t.showLabelBackdrop){const e=ki(t.backdropPadding),i=T.heights[b],s=T.widths[b];let n=O-e.top,o=0-e.left;switch(A){case"middle":n-=i/2;break;case"bottom":n-=i}switch(k){case"center":o-=s/2;break;case"right":o-=s;break;case"inner":b===_-1?o-=s:b>0&&(o-=s/2)}d={left:o,top:n,width:s+e.width,height:i+e.height,color:t.backdropColor}}x.push({label:v,font:P,textOffset:O,options:{rotation:m,color:i,strokeColor:o,strokeWidth:h,textAlign:f,textBaseline:A,translation:[M,w],backdrop:d}})}return x}_getXAxisLabelAlignment(){const{position:t,ticks:e}=this.options;if(-$(this.labelRotation))return"top"===t?"left":"right";let i="center";return"start"===e.align?i="left":"end"===e.align?i="right":"inner"===e.align&&(i="inner"),i}_getYAxisLabelAlignment(t){const{position:e,ticks:{crossAlign:i,mirror:s,padding:n}}=this.options,o=t+n,a=this._getLabelSizes().widest.width;let r,l;return"left"===e?s?(l=this.right+n,"near"===i?r="left":"center"===i?(r="center",l+=a/2):(r="right",l+=a)):(l=this.right-o,"near"===i?r="right":"center"===i?(r="center",l-=a/2):(r="left",l=this.left)):"right"===e?s?(l=this.left+n,"near"===i?r="right":"center"===i?(r="center",l-=a/2):(r="left",l-=a)):(l=this.left+o,"near"===i?r="left":"center"===i?(r="center",l+=a/2):(r="right",l=this.right)):r="right",{textAlign:r,x:l}}_computeLabelArea(){if(this.options.ticks.mirror)return;const t=this.chart,e=this.options.position;return"left"===e||"right"===e?{top:0,left:this.left,bottom:t.height,right:this.right}:"top"===e||"bottom"===e?{top:this.top,left:0,bottom:this.bottom,right:t.width}:void 0}drawBackground(){const{ctx:t,options:{backgroundColor:e},left:i,top:s,width:n,height:o}=this;e&&(t.save(),t.fillStyle=e,t.fillRect(i,s,n,o),t.restore())}getLineWidthForValue(t){const e=this.options.grid;if(!this._isVisible()||!e.display)return 0;const i=this.ticks.findIndex((e=>e.value===t));if(i>=0){return e.setContext(this.getContext(i)).lineWidth}return 0}drawGrid(t){const e=this.options.grid,i=this.ctx,s=this._gridLineItems||(this._gridLineItems=this._computeGridLineItems(t));let n,o;const a=(t,e,s)=>{s.width&&s.color&&(i.save(),i.lineWidth=s.width,i.strokeStyle=s.color,i.setLineDash(s.borderDash||[]),i.lineDashOffset=s.borderDashOffset,i.beginPath(),i.moveTo(t.x,t.y),i.lineTo(e.x,e.y),i.stroke(),i.restore())};if(e.display)for(n=0,o=s.length;n<o;++n){const t=s[n];e.drawOnChartArea&&a({x:t.x1,y:t.y1},{x:t.x2,y:t.y2},t),e.drawTicks&&a({x:t.tx1,y:t.ty1},{x:t.tx2,y:t.ty2},{color:t.tickColor,width:t.tickWidth,borderDash:t.tickBorderDash,borderDashOffset:t.tickBorderDashOffset})}}drawBorder(){const{chart:t,ctx:e,options:{border:i,grid:s}}=this,n=i.setContext(this.getContext()),o=i.display?n.width:0;if(!o)return;const a=s.setContext(this.getContext(0)).lineWidth,r=this._borderValue;let l,h,c,d;this.isHorizontal()?(l=Ae(t,this.left,o)-o/2,h=Ae(t,this.right,a)+a/2,c=d=r):(c=Ae(t,this.top,o)-o/2,d=Ae(t,this.bottom,a)+a/2,l=h=r),e.save(),e.lineWidth=n.width,e.strokeStyle=n.color,e.beginPath(),e.moveTo(l,c),e.lineTo(h,d),e.stroke(),e.restore()}drawLabels(t){if(!this.options.ticks.display)return;const e=this.ctx,i=this._computeLabelArea();i&&Ie(e,i);const s=this.getLabelItems(t);for(const t of s){const i=t.options,s=t.font;Ne(e,t.label,0,t.textOffset,s,i)}i&&ze(e)}drawTitle(){const{ctx:t,options:{position:e,title:i,reverse:s}}=this;if(!i.display)return;const a=Si(i.font),r=ki(i.padding),l=i.align;let h=a.lineHeight/2;"bottom"===e||"center"===e||o(e)?(h+=r.bottom,n(i.text)&&(h+=a.lineHeight*(i.text.length-1))):h+=r.top;const{titleX:c,titleY:d,maxWidth:u,rotation:f}=function(t,e,i,s){const{top:n,left:a,bottom:r,right:l,chart:h}=t,{chartArea:c,scales:d}=h;let u,f,g,p=0;const m=r-n,x=l-a;if(t.isHorizontal()){if(f=ft(s,a,l),o(i)){const t=Object.keys(i)[0],s=i[t];g=d[t].getPixelForValue(s)+m-e}else g="center"===i?(c.bottom+c.top)/2+m-e:Xs(t,i,e);u=l-a}else{if(o(i)){const t=Object.keys(i)[0],s=i[t];f=d[t].getPixelForValue(s)-x+e}else f="center"===i?(c.left+c.right)/2-x+e:Xs(t,i,e);g=ft(s,r,n),p="left"===i?-E:E}return{titleX:f,titleY:g,maxWidth:u,rotation:p}}(this,h,e,l);Ne(t,i.text,0,0,a,{color:i.color,maxWidth:u,rotation:f,textAlign:Qs(l,e,s),textBaseline:"middle",translation:[c,d]})}draw(t){this._isVisible()&&(this.drawBackground(),this.drawGrid(t),this.drawBorder(),this.drawTitle(),this.drawLabels(t))}_layers(){const t=this.options,e=t.ticks&&t.ticks.z||0,i=l(t.grid&&t.grid.z,-1),s=l(t.border&&t.border.z,0);return this._isVisible()&&this.draw===tn.prototype.draw?[{z:i,draw:t=>{this.drawBackground(),this.drawGrid(t),this.drawTitle()}},{z:s,draw:()=>{this.drawBorder()}},{z:e,draw:t=>{this.drawLabels(t)}}]:[{z:e,draw:t=>{this.draw(t)}}]}getMatchingVisibleMetas(t){const e=this.chart.getSortedVisibleDatasetMetas(),i=this.axis+"AxisID",s=[];let n,o;for(n=0,o=e.length;n<o;++n){const o=e[n];o[i]!==this.id||t&&o.type!==t||s.push(o)}return s}_resolveTickFontOptions(t){return Si(this.options.ticks.setContext(this.getContext(t)).font)}_maxDigits(){const t=this._resolveTickFontOptions(0).lineHeight;return(this.isHorizontal()?this.width:this.height)/t}}class en{constructor(t,e,i){this.type=t,this.scope=e,this.override=i,this.items=Object.create(null)}isForType(t){return Object.prototype.isPrototypeOf.call(this.type.prototype,t.prototype)}register(t){const e=Object.getPrototypeOf(t);let i;(function(t){return"id"in t&&"defaults"in t})(e)&&(i=this.register(e));const s=this.items,n=t.id,o=this.scope+"."+n;if(!n)throw new Error("class does not have id: "+t);return n in s||(s[n]=t,function(t,e,i){const s=x(Object.create(null),[i?ue.get(i):{},ue.get(e),t.defaults]);ue.set(e,s),t.defaultRoutes&&function(t,e){Object.keys(e).forEach((i=>{const s=i.split("."),n=s.pop(),o=[t].concat(s).join("."),a=e[i].split("."),r=a.pop(),l=a.join(".");ue.route(o,n,l,r)}))}(e,t.defaultRoutes);t.descriptors&&ue.describe(e,t.descriptors)}(t,o,i),this.override&&ue.override(t.id,t.overrides)),o}get(t){return this.items[t]}unregister(t){const e=this.items,i=t.id,s=this.scope;i in e&&delete e[i],s&&i in ue[s]&&(delete ue[s][i],this.override&&delete re[i])}}class sn{constructor(){this.controllers=new en(js,"datasets",!0),this.elements=new en($s,"elements"),this.plugins=new en(Object,"plugins"),this.scales=new en(tn,"scales"),this._typedRegistries=[this.controllers,this.scales,this.elements]}add(...t){this._each("register",t)}remove(...t){this._each("unregister",t)}addControllers(...t){this._each("register",t,this.controllers)}addElements(...t){this._each("register",t,this.elements)}addPlugins(...t){this._each("register",t,this.plugins)}addScales(...t){this._each("register",t,this.scales)}getController(t){return this._get(t,this.controllers,"controller")}getElement(t){return this._get(t,this.elements,"element")}getPlugin(t){return this._get(t,this.plugins,"plugin")}getScale(t){return this._get(t,this.scales,"scale")}removeControllers(...t){this._each("unregister",t,this.controllers)}removeElements(...t){this._each("unregister",t,this.elements)}removePlugins(...t){this._each("unregister",t,this.plugins)}removeScales(...t){this._each("unregister",t,this.scales)}_each(t,e,i){[...e].forEach((e=>{const s=i||this._getRegistryForType(e);i||s.isForType(e)||s===this.plugins&&e.id?this._exec(t,s,e):u(e,(e=>{const s=i||this._getRegistryForType(e);this._exec(t,s,e)}))}))}_exec(t,e,i){const s=w(t);d(i["before"+s],[],i),e[t](i),d(i["after"+s],[],i)}_getRegistryForType(t){for(let e=0;e<this._typedRegistries.length;e++){const i=this._typedRegistries[e];if(i.isForType(t))return i}return this.plugins}_get(t,e,i){const s=e.get(t);if(void 0===s)throw new Error('"'+t+'" is not a registered '+i+".");return s}}var nn=new sn;class on{constructor(){this._init=void 0}notify(t,e,i,s){if("beforeInit"===e&&(this._init=this._createDescriptors(t,!0),this._notify(this._init,t,"install")),void 0===this._init)return;const n=s?this._descriptors(t).filter(s):this._descriptors(t),o=this._notify(n,t,e,i);return"afterDestroy"===e&&(this._notify(n,t,"stop"),this._notify(this._init,t,"uninstall"),this._init=void 0),o}_notify(t,e,i,s){s=s||{};for(const n of t){const t=n.plugin;if(!1===d(t[i],[e,s,n.options],t)&&s.cancelable)return!1}return!0}invalidate(){s(this._cache)||(this._oldCache=this._cache,this._cache=void 0)}_descriptors(t){if(this._cache)return this._cache;const e=this._cache=this._createDescriptors(t);return this._notifyStateChanges(t),e}_createDescriptors(t,e){const i=t&&t.config,s=l(i.options&&i.options.plugins,{}),n=function(t){const e={},i=[],s=Object.keys(nn.plugins.items);for(let t=0;t<s.length;t++)i.push(nn.getPlugin(s[t]));const n=t.plugins||[];for(let t=0;t<n.length;t++){const s=n[t];-1===i.indexOf(s)&&(i.push(s),e[s.id]=!0)}return{plugins:i,localIds:e}}(i);return!1!==s||e?function(t,{plugins:e,localIds:i},s,n){const o=[],a=t.getContext();for(const r of e){const e=r.id,l=an(s[e],n);null!==l&&o.push({plugin:r,options:rn(t.config,{plugin:r,local:i[e]},l,a)})}return o}(t,n,s,e):[]}_notifyStateChanges(t){const e=this._oldCache||[],i=this._cache,s=(t,e)=>t.filter((t=>!e.some((e=>t.plugin.id===e.plugin.id))));this._notify(s(e,i),t,"stop"),this._notify(s(i,e),t,"start")}}function an(t,e){return e||!1!==t?!0===t?{}:t:null}function rn(t,{plugin:e,local:i},s,n){const o=t.pluginScopeKeys(e),a=t.getOptionScopes(s,o);return i&&e.defaults&&a.push(e.defaults),t.createResolver(a,n,[""],{scriptable:!1,indexable:!1,allKeys:!0})}function ln(t,e){const i=ue.datasets[t]||{};return((e.datasets||{})[t]||{}).indexAxis||e.indexAxis||i.indexAxis||"x"}function hn(t){if("x"===t||"y"===t||"r"===t)return t}function cn(t,...e){if(hn(t))return t;for(const s of e){const e=s.axis||("top"===(i=s.position)||"bottom"===i?"x":"left"===i||"right"===i?"y":void 0)||t.length>1&&hn(t[0].toLowerCase());if(e)return e}var i;throw new Error(`Cannot determine type of '${t}' axis. Please provide 'axis' or 'position' option.`)}function dn(t,e,i){if(i[e+"AxisID"]===t)return{axis:e}}function un(t,e){const i=re[t.type]||{scales:{}},s=e.scales||{},n=ln(t.type,e),a=Object.create(null);return Object.keys(s).forEach((e=>{const r=s[e];if(!o(r))return console.error(`Invalid scale configuration for scale: ${e}`);if(r._proxy)return console.warn(`Ignoring resolver passed as options for scale: ${e}`);const l=cn(e,r,function(t,e){if(e.data&&e.data.datasets){const i=e.data.datasets.filter((e=>e.xAxisID===t||e.yAxisID===t));if(i.length)return dn(t,"x",i[0])||dn(t,"y",i[0])}return{}}(e,t),ue.scales[r.type]),h=function(t,e){return t===e?"_index_":"_value_"}(l,n),c=i.scales||{};a[e]=b(Object.create(null),[{axis:l},r,c[l],c[h]])})),t.data.datasets.forEach((i=>{const n=i.type||t.type,o=i.indexAxis||ln(n,e),r=(re[n]||{}).scales||{};Object.keys(r).forEach((t=>{const e=function(t,e){let i=t;return"_index_"===t?i=e:"_value_"===t&&(i="x"===e?"y":"x"),i}(t,o),n=i[e+"AxisID"]||e;a[n]=a[n]||Object.create(null),b(a[n],[{axis:e},s[n],r[t]])}))})),Object.keys(a).forEach((t=>{const e=a[t];b(e,[ue.scales[e.type],ue.scale])})),a}function fn(t){const e=t.options||(t.options={});e.plugins=l(e.plugins,{}),e.scales=un(t,e)}function gn(t){return(t=t||{}).datasets=t.datasets||[],t.labels=t.labels||[],t}const pn=new Map,mn=new Set;function xn(t,e){let i=pn.get(t);return i||(i=e(),pn.set(t,i),mn.add(i)),i}const bn=(t,e,i)=>{const s=M(e,i);void 0!==s&&t.add(s)};class _n{constructor(t){this._config=function(t){return(t=t||{}).data=gn(t.data),fn(t),t}(t),this._scopeCache=new Map,this._resolverCache=new Map}get platform(){return this._config.platform}get type(){return this._config.type}set type(t){this._config.type=t}get data(){return this._config.data}set data(t){this._config.data=gn(t)}get options(){return this._config.options}set options(t){this._config.options=t}get plugins(){return this._config.plugins}update(){const t=this._config;this.clearCache(),fn(t)}clearCache(){this._scopeCache.clear(),this._resolverCache.clear()}datasetScopeKeys(t){return xn(t,(()=>[[`datasets.${t}`,""]]))}datasetAnimationScopeKeys(t,e){return xn(`${t}.transition.${e}`,(()=>[[`datasets.${t}.transitions.${e}`,`transitions.${e}`],[`datasets.${t}`,""]]))}datasetElementScopeKeys(t,e){return xn(`${t}-${e}`,(()=>[[`datasets.${t}.elements.${e}`,`datasets.${t}`,`elements.${e}`,""]]))}pluginScopeKeys(t){const e=t.id;return xn(`${this.type}-plugin-${e}`,(()=>[[`plugins.${e}`,...t.additionalOptionScopes||[]]]))}_cachedScopes(t,e){const i=this._scopeCache;let s=i.get(t);return s&&!e||(s=new Map,i.set(t,s)),s}getOptionScopes(t,e,i){const{options:s,type:n}=this,o=this._cachedScopes(t,i),a=o.get(e);if(a)return a;const r=new Set;e.forEach((e=>{t&&(r.add(t),e.forEach((e=>bn(r,t,e)))),e.forEach((t=>bn(r,s,t))),e.forEach((t=>bn(r,re[n]||{},t))),e.forEach((t=>bn(r,ue,t))),e.forEach((t=>bn(r,le,t)))}));const l=Array.from(r);return 0===l.length&&l.push(Object.create(null)),mn.has(e)&&o.set(e,l),l}chartOptionScopes(){const{options:t,type:e}=this;return[t,re[e]||{},ue.datasets[e]||{},{type:e},ue,le]}resolveNamedOptions(t,e,i,s=[""]){const o={$shared:!0},{resolver:a,subPrefixes:r}=yn(this._resolverCache,t,s);let l=a;if(function(t,e){const{isScriptable:i,isIndexable:s}=Ye(t);for(const o of e){const e=i(o),a=s(o),r=(a||e)&&t[o];if(e&&(S(r)||vn(r))||a&&n(r))return!0}return!1}(a,e)){o.$shared=!1;l=$e(a,i=S(i)?i():i,this.createResolver(t,i,r))}for(const t of e)o[t]=l[t];return o}createResolver(t,e,i=[""],s){const{resolver:n}=yn(this._resolverCache,t,i);return o(e)?$e(n,e,void 0,s):n}}function yn(t,e,i){let s=t.get(e);s||(s=new Map,t.set(e,s));const n=i.join();let o=s.get(n);if(!o){o={resolver:je(e,i),subPrefixes:i.filter((t=>!t.toLowerCase().includes("hover")))},s.set(n,o)}return o}const vn=t=>o(t)&&Object.getOwnPropertyNames(t).some((e=>S(t[e])));const Mn=["top","bottom","left","right","chartArea"];function wn(t,e){return"top"===t||"bottom"===t||-1===Mn.indexOf(t)&&"x"===e}function kn(t,e){return function(i,s){return i[t]===s[t]?i[e]-s[e]:i[t]-s[t]}}function Sn(t){const e=t.chart,i=e.options.animation;e.notifyPlugins("afterRender"),d(i&&i.onComplete,[t],e)}function Pn(t){const e=t.chart,i=e.options.animation;d(i&&i.onProgress,[t],e)}function Dn(t){return fe()&&"string"==typeof t?t=document.getElementById(t):t&&t.length&&(t=t[0]),t&&t.canvas&&(t=t.canvas),t}const Cn={},On=t=>{const e=Dn(t);return Object.values(Cn).filter((t=>t.canvas===e)).pop()};function An(t,e,i){const s=Object.keys(t);for(const n of s){const s=+n;if(s>=e){const o=t[n];delete t[n],(i>0||s>e)&&(t[s+i]=o)}}}class Tn{static defaults=ue;static instances=Cn;static overrides=re;static registry=nn;static version="4.5.1";static getChart=On;static register(...t){nn.add(...t),Ln()}static unregister(...t){nn.remove(...t),Ln()}constructor(t,e){const s=this.config=new _n(e),n=Dn(t),o=On(n);if(o)throw new Error("Canvas is already in use. Chart with ID '"+o.id+"' must be destroyed before the canvas with ID '"+o.canvas.id+"' can be reused.");const a=s.createResolver(s.chartOptionScopes(),this.getContext());this.platform=new(s.platform||Ps(n)),this.platform.updateConfig(s);const r=this.platform.acquireContext(n,a.aspectRatio),l=r&&r.canvas,h=l&&l.height,c=l&&l.width;this.id=i(),this.ctx=r,this.canvas=l,this.width=c,this.height=h,this._options=a,this._aspectRatio=this.aspectRatio,this._layers=[],this._metasets=[],this._stacks=void 0,this.boxes=[],this.currentDevicePixelRatio=void 0,this.chartArea=void 0,this._active=[],this._lastEvent=void 0,this._listeners={},this._responsiveListeners=void 0,this._sortedMetasets=[],this.scales={},this._plugins=new on,this.$proxies={},this._hiddenIndices={},this.attached=!1,this._animationsDisabled=void 0,this.$context=void 0,this._doResize=dt((t=>this.update(t)),a.resizeDelay||0),this._dataChanges=[],Cn[this.id]=this,r&&l?(bt.listen(this,"complete",Sn),bt.listen(this,"progress",Pn),this._initialize(),this.attached&&this.update()):console.error("Failed to create chart: can't acquire context from the given item")}get aspectRatio(){const{options:{aspectRatio:t,maintainAspectRatio:e},width:i,height:n,_aspectRatio:o}=this;return s(t)?e&&o?o:n?i/n:null:t}get data(){return this.config.data}set data(t){this.config.data=t}get options(){return this._options}set options(t){this.config.options=t}get registry(){return nn}_initialize(){return this.notifyPlugins("beforeInit"),this.options.responsive?this.resize():ke(this,this.options.devicePixelRatio),this.bindEvents(),this.notifyPlugins("afterInit"),this}clear(){return Te(this.canvas,this.ctx),this}stop(){return bt.stop(this),this}resize(t,e){bt.running(this)?this._resizeBeforeDraw={width:t,height:e}:this._resize(t,e)}_resize(t,e){const i=this.options,s=this.canvas,n=i.maintainAspectRatio&&this.aspectRatio,o=this.platform.getMaximumSize(s,t,e,n),a=i.devicePixelRatio||this.platform.getDevicePixelRatio(),r=this.width?"resize":"attach";this.width=o.width,this.height=o.height,this._aspectRatio=this.aspectRatio,ke(this,a,!0)&&(this.notifyPlugins("resize",{size:o}),d(i.onResize,[this,o],this),this.attached&&this._doResize(r)&&this.render())}ensureScalesHaveIDs(){u(this.options.scales||{},((t,e)=>{t.id=e}))}buildOrUpdateScales(){const t=this.options,e=t.scales,i=this.scales,s=Object.keys(i).reduce(((t,e)=>(t[e]=!1,t)),{});let n=[];e&&(n=n.concat(Object.keys(e).map((t=>{const i=e[t],s=cn(t,i),n="r"===s,o="x"===s;return{options:i,dposition:n?"chartArea":o?"bottom":"left",dtype:n?"radialLinear":o?"category":"linear"}})))),u(n,(e=>{const n=e.options,o=n.id,a=cn(o,n),r=l(n.type,e.dtype);void 0!==n.position&&wn(n.position,a)===wn(e.dposition)||(n.position=e.dposition),s[o]=!0;let h=null;if(o in i&&i[o].type===r)h=i[o];else{h=new(nn.getScale(r))({id:o,type:r,ctx:this.ctx,chart:this}),i[h.id]=h}h.init(n,t)})),u(s,((t,e)=>{t||delete i[e]})),u(i,(t=>{ls.configure(this,t,t.options),ls.addBox(this,t)}))}_updateMetasets(){const t=this._metasets,e=this.data.datasets.length,i=t.length;if(t.sort(((t,e)=>t.index-e.index)),i>e){for(let t=e;t<i;++t)this._destroyDatasetMeta(t);t.splice(e,i-e)}this._sortedMetasets=t.slice(0).sort(kn("order","index"))}_removeUnreferencedMetasets(){const{_metasets:t,data:{datasets:e}}=this;t.length>e.length&&delete this._stacks,t.forEach(((t,i)=>{0===e.filter((e=>e===t._dataset)).length&&this._destroyDatasetMeta(i)}))}buildOrUpdateControllers(){const t=[],e=this.data.datasets;let i,s;for(this._removeUnreferencedMetasets(),i=0,s=e.length;i<s;i++){const s=e[i];let n=this.getDatasetMeta(i);const o=s.type||this.config.type;if(n.type&&n.type!==o&&(this._destroyDatasetMeta(i),n=this.getDatasetMeta(i)),n.type=o,n.indexAxis=s.indexAxis||ln(o,this.options),n.order=s.order||0,n.index=i,n.label=""+s.label,n.visible=this.isDatasetVisible(i),n.controller)n.controller.updateIndex(i),n.controller.linkScales();else{const e=nn.getController(o),{datasetElementType:s,dataElementType:a}=ue.datasets[o];Object.assign(e,{dataElementType:nn.getElement(a),datasetElementType:s&&nn.getElement(s)}),n.controller=new e(this,i),t.push(n.controller)}}return this._updateMetasets(),t}_resetElements(){u(this.data.datasets,((t,e)=>{this.getDatasetMeta(e).controller.reset()}),this)}reset(){this._resetElements(),this.notifyPlugins("reset")}update(t){const e=this.config;e.update();const i=this._options=e.createResolver(e.chartOptionScopes(),this.getContext()),s=this._animationsDisabled=!i.animation;if(this._updateScales(),this._checkEventBindings(),this._updateHiddenIndices(),this._plugins.invalidate(),!1===this.notifyPlugins("beforeUpdate",{mode:t,cancelable:!0}))return;const n=this.buildOrUpdateControllers();this.notifyPlugins("beforeElementsUpdate");let o=0;for(let t=0,e=this.data.datasets.length;t<e;t++){const{controller:e}=this.getDatasetMeta(t),i=!s&&-1===n.indexOf(e);e.buildOrUpdateElements(i),o=Math.max(+e.getMaxOverflow(),o)}o=this._minPadding=i.layout.autoPadding?o:0,this._updateLayout(o),s||u(n,(t=>{t.reset()})),this._updateDatasets(t),this.notifyPlugins("afterUpdate",{mode:t}),this._layers.sort(kn("z","_idx"));const{_active:a,_lastEvent:r}=this;r?this._eventHandler(r,!0):a.length&&this._updateHoverStyles(a,a,!0),this.render()}_updateScales(){u(this.scales,(t=>{ls.removeBox(this,t)})),this.ensureScalesHaveIDs(),this.buildOrUpdateScales()}_checkEventBindings(){const t=this.options,e=new Set(Object.keys(this._listeners)),i=new Set(t.events);P(e,i)&&!!this._responsiveListeners===t.responsive||(this.unbindEvents(),this.bindEvents())}_updateHiddenIndices(){const{_hiddenIndices:t}=this,e=this._getUniformDataChanges()||[];for(const{method:i,start:s,count:n}of e){An(t,s,"_removeElements"===i?-n:n)}}_getUniformDataChanges(){const t=this._dataChanges;if(!t||!t.length)return;this._dataChanges=[];const e=this.data.datasets.length,i=e=>new Set(t.filter((t=>t[0]===e)).map(((t,e)=>e+","+t.splice(1).join(",")))),s=i(0);for(let t=1;t<e;t++)if(!P(s,i(t)))return;return Array.from(s).map((t=>t.split(","))).map((t=>({method:t[1],start:+t[2],count:+t[3]})))}_updateLayout(t){if(!1===this.notifyPlugins("beforeLayout",{cancelable:!0}))return;ls.update(this,this.width,this.height,t);const e=this.chartArea,i=e.width<=0||e.height<=0;this._layers=[],u(this.boxes,(t=>{i&&"chartArea"===t.position||(t.configure&&t.configure(),this._layers.push(...t._layers()))}),this),this._layers.forEach(((t,e)=>{t._idx=e})),this.notifyPlugins("afterLayout")}_updateDatasets(t){if(!1!==this.notifyPlugins("beforeDatasetsUpdate",{mode:t,cancelable:!0})){for(let t=0,e=this.data.datasets.length;t<e;++t)this.getDatasetMeta(t).controller.configure();for(let e=0,i=this.data.datasets.length;e<i;++e)this._updateDataset(e,S(t)?t({datasetIndex:e}):t);this.notifyPlugins("afterDatasetsUpdate",{mode:t})}}_updateDataset(t,e){const i=this.getDatasetMeta(t),s={meta:i,index:t,mode:e,cancelable:!0};!1!==this.notifyPlugins("beforeDatasetUpdate",s)&&(i.controller._update(e),s.cancelable=!1,this.notifyPlugins("afterDatasetUpdate",s))}render(){!1!==this.notifyPlugins("beforeRender",{cancelable:!0})&&(bt.has(this)?this.attached&&!bt.running(this)&&bt.start(this):(this.draw(),Sn({chart:this})))}draw(){let t;if(this._resizeBeforeDraw){const{width:t,height:e}=this._resizeBeforeDraw;this._resizeBeforeDraw=null,this._resize(t,e)}if(this.clear(),this.width<=0||this.height<=0)return;if(!1===this.notifyPlugins("beforeDraw",{cancelable:!0}))return;const e=this._layers;for(t=0;t<e.length&&e[t].z<=0;++t)e[t].draw(this.chartArea);for(this._drawDatasets();t<e.length;++t)e[t].draw(this.chartArea);this.notifyPlugins("afterDraw")}_getSortedDatasetMetas(t){const e=this._sortedMetasets,i=[];let s,n;for(s=0,n=e.length;s<n;++s){const n=e[s];t&&!n.visible||i.push(n)}return i}getSortedVisibleDatasetMetas(){return this._getSortedDatasetMetas(!0)}_drawDatasets(){if(!1===this.notifyPlugins("beforeDatasetsDraw",{cancelable:!0}))return;const t=this.getSortedVisibleDatasetMetas();for(let e=t.length-1;e>=0;--e)this._drawDataset(t[e]);this.notifyPlugins("afterDatasetsDraw")}_drawDataset(t){const e=this.ctx,i={meta:t,index:t.index,cancelable:!0},s=Ni(this,t);!1!==this.notifyPlugins("beforeDatasetDraw",i)&&(s&&Ie(e,s),t.controller.draw(),s&&ze(e),i.cancelable=!1,this.notifyPlugins("afterDatasetDraw",i))}isPointInArea(t){return Re(t,this.chartArea,this._minPadding)}getElementsAtEventForMode(t,e,i,s){const n=Ki.modes[e];return"function"==typeof n?n(this,t,i,s):[]}getDatasetMeta(t){const e=this.data.datasets[t],i=this._metasets;let s=i.filter((t=>t&&t._dataset===e)).pop();return s||(s={type:null,data:[],dataset:null,controller:null,hidden:null,xAxisID:null,yAxisID:null,order:e&&e.order||0,index:t,_dataset:e,_parsed:[],_sorted:!1},i.push(s)),s}getContext(){return this.$context||(this.$context=Ci(null,{chart:this,type:"chart"}))}getVisibleDatasetCount(){return this.getSortedVisibleDatasetMetas().length}isDatasetVisible(t){const e=this.data.datasets[t];if(!e)return!1;const i=this.getDatasetMeta(t);return"boolean"==typeof i.hidden?!i.hidden:!e.hidden}setDatasetVisibility(t,e){this.getDatasetMeta(t).hidden=!e}toggleDataVisibility(t){this._hiddenIndices[t]=!this._hiddenIndices[t]}getDataVisibility(t){return!this._hiddenIndices[t]}_updateVisibility(t,e,i){const s=i?"show":"hide",n=this.getDatasetMeta(t),o=n.controller._resolveAnimations(void 0,s);k(e)?(n.data[e].hidden=!i,this.update()):(this.setDatasetVisibility(t,i),o.update(n,{visible:i}),this.update((e=>e.datasetIndex===t?s:void 0)))}hide(t,e){this._updateVisibility(t,e,!1)}show(t,e){this._updateVisibility(t,e,!0)}_destroyDatasetMeta(t){const e=this._metasets[t];e&&e.controller&&e.controller._destroy(),delete this._metasets[t]}_stop(){let t,e;for(this.stop(),bt.remove(this),t=0,e=this.data.datasets.length;t<e;++t)this._destroyDatasetMeta(t)}destroy(){this.notifyPlugins("beforeDestroy");const{canvas:t,ctx:e}=this;this._stop(),this.config.clearCache(),t&&(this.unbindEvents(),Te(t,e),this.platform.releaseContext(e),this.canvas=null,this.ctx=null),delete Cn[this.id],this.notifyPlugins("afterDestroy")}toBase64Image(...t){return this.canvas.toDataURL(...t)}bindEvents(){this.bindUserEvents(),this.options.responsive?this.bindResponsiveEvents():this.attached=!0}bindUserEvents(){const t=this._listeners,e=this.platform,i=(i,s)=>{e.addEventListener(this,i,s),t[i]=s},s=(t,e,i)=>{t.offsetX=e,t.offsetY=i,this._eventHandler(t)};u(this.options.events,(t=>i(t,s)))}bindResponsiveEvents(){this._responsiveListeners||(this._responsiveListeners={});const t=this._responsiveListeners,e=this.platform,i=(i,s)=>{e.addEventListener(this,i,s),t[i]=s},s=(i,s)=>{t[i]&&(e.removeEventListener(this,i,s),delete t[i])},n=(t,e)=>{this.canvas&&this.resize(t,e)};let o;const a=()=>{s("attach",a),this.attached=!0,this.resize(),i("resize",n),i("detach",o)};o=()=>{this.attached=!1,s("resize",n),this._stop(),this._resize(0,0),i("attach",a)},e.isAttached(this.canvas)?a():o()}unbindEvents(){u(this._listeners,((t,e)=>{this.platform.removeEventListener(this,e,t)})),this._listeners={},u(this._responsiveListeners,((t,e)=>{this.platform.removeEventListener(this,e,t)})),this._responsiveListeners=void 0}updateHoverStyle(t,e,i){const s=i?"set":"remove";let n,o,a,r;for("dataset"===e&&(n=this.getDatasetMeta(t[0].datasetIndex),n.controller["_"+s+"DatasetHoverStyle"]()),a=0,r=t.length;a<r;++a){o=t[a];const e=o&&this.getDatasetMeta(o.datasetIndex).controller;e&&e[s+"HoverStyle"](o.element,o.datasetIndex,o.index)}}getActiveElements(){return this._active||[]}setActiveElements(t){const e=this._active||[],i=t.map((({datasetIndex:t,index:e})=>{const i=this.getDatasetMeta(t);if(!i)throw new Error("No dataset found at index "+t);return{datasetIndex:t,element:i.data[e],index:e}}));!f(i,e)&&(this._active=i,this._lastEvent=null,this._updateHoverStyles(i,e))}notifyPlugins(t,e,i){return this._plugins.notify(this,t,e,i)}isPluginEnabled(t){return 1===this._plugins._cache.filter((e=>e.plugin.id===t)).length}_updateHoverStyles(t,e,i){const s=this.options.hover,n=(t,e)=>t.filter((t=>!e.some((e=>t.datasetIndex===e.datasetIndex&&t.index===e.index)))),o=n(e,t),a=i?t:n(t,e);o.length&&this.updateHoverStyle(o,s.mode,!1),a.length&&s.mode&&this.updateHoverStyle(a,s.mode,!0)}_eventHandler(t,e){const i={event:t,replay:e,cancelable:!0,inChartArea:this.isPointInArea(t)},s=e=>(e.options.events||this.options.events).includes(t.native.type);if(!1===this.notifyPlugins("beforeEvent",i,s))return;const n=this._handleEvent(t,e,i.inChartArea);return i.cancelable=!1,this.notifyPlugins("afterEvent",i,s),(n||i.changed)&&this.render(),this}_handleEvent(t,e,i){const{_active:s=[],options:n}=this,o=e,a=this._getActiveElements(t,s,i,o),r=D(t),l=function(t,e,i,s){return i&&"mouseout"!==t.type?s?e:t:null}(t,this._lastEvent,i,r);i&&(this._lastEvent=null,d(n.onHover,[t,a,this],this),r&&d(n.onClick,[t,a,this],this));const h=!f(a,s);return(h||e)&&(this._active=a,this._updateHoverStyles(a,s,e)),this._lastEvent=l,h}_getActiveElements(t,e,i,s){if("mouseout"===t.type)return[];if(!i)return e;const n=this.options.hover;return this.getElementsAtEventForMode(t,n.mode,n,s)}}function Ln(){return u(Tn.instances,(t=>t._plugins.invalidate()))}function En(){throw new Error("This method is not implemented: Check that a complete date adapter is provided.")}class Rn{static override(t){Object.assign(Rn.prototype,t)}options;constructor(t){this.options=t||{}}init(){}formats(){return En()}parse(){return En()}format(){return En()}add(){return En()}diff(){return En()}startOf(){return En()}endOf(){return En()}}var In={_date:Rn};function zn(t){const e=t.iScale,i=function(t,e){if(!t._cache.$bar){const i=t.getMatchingVisibleMetas(e);let s=[];for(let e=0,n=i.length;e<n;e++)s=s.concat(i[e].controller.getAllParsedValues(t));t._cache.$bar=lt(s.sort(((t,e)=>t-e)))}return t._cache.$bar}(e,t.type);let s,n,o,a,r=e._length;const l=()=>{32767!==o&&-32768!==o&&(k(a)&&(r=Math.min(r,Math.abs(o-a)||r)),a=o)};for(s=0,n=i.length;s<n;++s)o=e.getPixelForValue(i[s]),l();for(a=void 0,s=0,n=e.ticks.length;s<n;++s)o=e.getPixelForTick(s),l();return r}function Fn(t,e,i,s){return n(t)?function(t,e,i,s){const n=i.parse(t[0],s),o=i.parse(t[1],s),a=Math.min(n,o),r=Math.max(n,o);let l=a,h=r;Math.abs(a)>Math.abs(r)&&(l=r,h=a),e[i.axis]=h,e._custom={barStart:l,barEnd:h,start:n,end:o,min:a,max:r}}(t,e,i,s):e[i.axis]=i.parse(t,s),e}function Vn(t,e,i,s){const n=t.iScale,o=t.vScale,a=n.getLabels(),r=n===o,l=[];let h,c,d,u;for(h=i,c=i+s;h<c;++h)u=e[h],d={},d[n.axis]=r||n.parse(a[h],h),l.push(Fn(u,d,o,h));return l}function Bn(t){return t&&void 0!==t.barStart&&void 0!==t.barEnd}function Wn(t,e,i,s){let n=e.borderSkipped;const o={};if(!n)return void(t.borderSkipped=o);if(!0===n)return void(t.borderSkipped={top:!0,right:!0,bottom:!0,left:!0});const{start:a,end:r,reverse:l,top:h,bottom:c}=function(t){let e,i,s,n,o;return t.horizontal?(e=t.base>t.x,i="left",s="right"):(e=t.base<t.y,i="bottom",s="top"),e?(n="end",o="start"):(n="start",o="end"),{start:i,end:s,reverse:e,top:n,bottom:o}}(t);"middle"===n&&i&&(t.enableBorderRadius=!0,(i._top||0)===s?n=h:(i._bottom||0)===s?n=c:(o[Nn(c,a,r,l)]=!0,n=h)),o[Nn(n,a,r,l)]=!0,t.borderSkipped=o}function Nn(t,e,i,s){var n,o,a;return s?(a=i,t=Hn(t=(n=t)===(o=e)?a:n===a?o:n,i,e)):t=Hn(t,e,i),t}function Hn(t,e,i){return"start"===t?e:"end"===t?i:t}function jn(t,{inflateAmount:e},i){t.inflateAmount="auto"===e?1===i?.33:0:e}class $n extends js{static id="doughnut";static defaults={datasetElementType:!1,dataElementType:"arc",animation:{animateRotate:!0,animateScale:!1},animations:{numbers:{type:"number",properties:["circumference","endAngle","innerRadius","outerRadius","startAngle","x","y","offset","borderWidth","spacing"]}},cutout:"50%",rotation:0,circumference:360,radius:"100%",spacing:0,indexAxis:"r"};static descriptors={_scriptable:t=>"spacing"!==t,_indexable:t=>"spacing"!==t&&!t.startsWith("borderDash")&&!t.startsWith("hoverBorderDash")};static overrides={aspectRatio:1,plugins:{legend:{labels:{generateLabels(t){const e=t.data,{labels:{pointStyle:i,textAlign:s,color:n,useBorderRadius:o,borderRadius:a}}=t.legend.options;return e.labels.length&&e.datasets.length?e.labels.map(((e,r)=>{const l=t.getDatasetMeta(0).controller.getStyle(r);return{text:e,fillStyle:l.backgroundColor,fontColor:n,hidden:!t.getDataVisibility(r),lineDash:l.borderDash,lineDashOffset:l.borderDashOffset,lineJoin:l.borderJoinStyle,lineWidth:l.borderWidth,strokeStyle:l.borderColor,textAlign:s,pointStyle:i,borderRadius:o&&(a||l.borderRadius),index:r}})):[]}},onClick(t,e,i){i.chart.toggleDataVisibility(e.index),i.chart.update()}}}};constructor(t,e){super(t,e),this.enableOptionSharing=!0,this.innerRadius=void 0,this.outerRadius=void 0,this.offsetX=void 0,this.offsetY=void 0}linkScales(){}parse(t,e){const i=this.getDataset().data,s=this._cachedMeta;if(!1===this._parsing)s._parsed=i;else{let n,a,r=t=>+i[t];if(o(i[t])){const{key:t="value"}=this._parsing;r=e=>+M(i[e],t)}for(n=t,a=t+e;n<a;++n)s._parsed[n]=r(n)}}_getRotation(){return $(this.options.rotation-90)}_getCircumference(){return $(this.options.circumference)}_getRotationExtents(){let t=O,e=-O;for(let i=0;i<this.chart.data.datasets.length;++i)if(this.chart.isDatasetVisible(i)&&this.chart.getDatasetMeta(i).type===this._type){const s=this.chart.getDatasetMeta(i).controller,n=s._getRotation(),o=s._getCircumference();t=Math.min(t,n),e=Math.max(e,n+o)}return{rotation:t,circumference:e-t}}update(t){const e=this.chart,{chartArea:i}=e,s=this._cachedMeta,n=s.data,o=this.getMaxBorderWidth()+this.getMaxOffset(n)+this.options.spacing,a=Math.max((Math.min(i.width,i.height)-o)/2,0),r=Math.min(h(this.options.cutout,a),1),l=this._getRingWeight(this.index),{circumference:d,rotation:u}=this._getRotationExtents(),{ratioX:f,ratioY:g,offsetX:p,offsetY:m}=function(t,e,i){let s=1,n=1,o=0,a=0;if(e<O){const r=t,l=r+e,h=Math.cos(r),c=Math.sin(r),d=Math.cos(l),u=Math.sin(l),f=(t,e,s)=>J(t,r,l,!0)?1:Math.max(e,e*i,s,s*i),g=(t,e,s)=>J(t,r,l,!0)?-1:Math.min(e,e*i,s,s*i),p=f(0,h,d),m=f(E,c,u),x=g(C,h,d),b=g(C+E,c,u);s=(p-x)/2,n=(m-b)/2,o=-(p+x)/2,a=-(m+b)/2}return{ratioX:s,ratioY:n,offsetX:o,offsetY:a}}(u,d,r),x=(i.width-o)/f,b=(i.height-o)/g,_=Math.max(Math.min(x,b)/2,0),y=c(this.options.radius,_),v=(y-Math.max(y*r,0))/this._getVisibleDatasetWeightTotal();this.offsetX=p*y,this.offsetY=m*y,s.total=this.calculateTotal(),this.outerRadius=y-v*this._getRingWeightOffset(this.index),this.innerRadius=Math.max(this.outerRadius-v*l,0),this.updateElements(n,0,n.length,t)}_circumference(t,e){const i=this.options,s=this._cachedMeta,n=this._getCircumference();return e&&i.animation.animateRotate||!this.chart.getDataVisibility(t)||null===s._parsed[t]||s.data[t].hidden?0:this.calculateCircumference(s._parsed[t]*n/O)}updateElements(t,e,i,s){const n="reset"===s,o=this.chart,a=o.chartArea,r=o.options.animation,l=(a.left+a.right)/2,h=(a.top+a.bottom)/2,c=n&&r.animateScale,d=c?0:this.innerRadius,u=c?0:this.outerRadius,{sharedOptions:f,includeOptions:g}=this._getSharedOptions(e,s);let p,m=this._getRotation();for(p=0;p<e;++p)m+=this._circumference(p,n);for(p=e;p<e+i;++p){const e=this._circumference(p,n),i=t[p],o={x:l+this.offsetX,y:h+this.offsetY,startAngle:m,endAngle:m+e,circumference:e,outerRadius:u,innerRadius:d};g&&(o.options=f||this.resolveDataElementOptions(p,i.active?"active":s)),m+=e,this.updateElement(i,p,o,s)}}calculateTotal(){const t=this._cachedMeta,e=t.data;let i,s=0;for(i=0;i<e.length;i++){const n=t._parsed[i];null===n||isNaN(n)||!this.chart.getDataVisibility(i)||e[i].hidden||(s+=Math.abs(n))}return s}calculateCircumference(t){const e=this._cachedMeta.total;return e>0&&!isNaN(t)?O*(Math.abs(t)/e):0}getLabelAndValue(t){const e=this._cachedMeta,i=this.chart,s=i.data.labels||[],n=ne(e._parsed[t],i.options.locale);return{label:s[t]||"",value:n}}getMaxBorderWidth(t){let e=0;const i=this.chart;let s,n,o,a,r;if(!t)for(s=0,n=i.data.datasets.length;s<n;++s)if(i.isDatasetVisible(s)){o=i.getDatasetMeta(s),t=o.data,a=o.controller;break}if(!t)return 0;for(s=0,n=t.length;s<n;++s)r=a.resolveDataElementOptions(s),"inner"!==r.borderAlign&&(e=Math.max(e,r.borderWidth||0,r.hoverBorderWidth||0));return e}getMaxOffset(t){let e=0;for(let i=0,s=t.length;i<s;++i){const t=this.resolveDataElementOptions(i);e=Math.max(e,t.offset||0,t.hoverOffset||0)}return e}_getRingWeightOffset(t){let e=0;for(let i=0;i<t;++i)this.chart.isDatasetVisible(i)&&(e+=this._getRingWeight(i));return e}_getRingWeight(t){return Math.max(l(this.chart.data.datasets[t].weight,1),0)}_getVisibleDatasetWeightTotal(){return this._getRingWeightOffset(this.chart.data.datasets.length)||1}}class Yn extends js{static id="polarArea";static defaults={dataElementType:"arc",animation:{animateRotate:!0,animateScale:!0},animations:{numbers:{type:"number",properties:["x","y","startAngle","endAngle","innerRadius","outerRadius"]}},indexAxis:"r",startAngle:0};static overrides={aspectRatio:1,plugins:{legend:{labels:{generateLabels(t){const e=t.data;if(e.labels.length&&e.datasets.length){const{labels:{pointStyle:i,color:s}}=t.legend.options;return e.labels.map(((e,n)=>{const o=t.getDatasetMeta(0).controller.getStyle(n);return{text:e,fillStyle:o.backgroundColor,strokeStyle:o.borderColor,fontColor:s,lineWidth:o.borderWidth,pointStyle:i,hidden:!t.getDataVisibility(n),index:n}}))}return[]}},onClick(t,e,i){i.chart.toggleDataVisibility(e.index),i.chart.update()}}},scales:{r:{type:"radialLinear",angleLines:{display:!1},beginAtZero:!0,grid:{circular:!0},pointLabels:{display:!1},startAngle:0}}};constructor(t,e){super(t,e),this.innerRadius=void 0,this.outerRadius=void 0}getLabelAndValue(t){const e=this._cachedMeta,i=this.chart,s=i.data.labels||[],n=ne(e._parsed[t].r,i.options.locale);return{label:s[t]||"",value:n}}parseObjectData(t,e,i,s){return ii.bind(this)(t,e,i,s)}update(t){const e=this._cachedMeta.data;this._updateRadius(),this.updateElements(e,0,e.length,t)}getMinMax(){const t=this._cachedMeta,e={min:Number.POSITIVE_INFINITY,max:Number.NEGATIVE_INFINITY};return t.data.forEach(((t,i)=>{const s=this.getParsed(i).r;!isNaN(s)&&this.chart.getDataVisibility(i)&&(s<e.min&&(e.min=s),s>e.max&&(e.max=s))})),e}_updateRadius(){const t=this.chart,e=t.chartArea,i=t.options,s=Math.min(e.right-e.left,e.bottom-e.top),n=Math.max(s/2,0),o=(n-Math.max(i.cutoutPercentage?n/100*i.cutoutPercentage:1,0))/t.getVisibleDatasetCount();this.outerRadius=n-o*this.index,this.innerRadius=this.outerRadius-o}updateElements(t,e,i,s){const n="reset"===s,o=this.chart,a=o.options.animation,r=this._cachedMeta.rScale,l=r.xCenter,h=r.yCenter,c=r.getIndexAngle(0)-.5*C;let d,u=c;const f=360/this.countVisibleElements();for(d=0;d<e;++d)u+=this._computeAngle(d,s,f);for(d=e;d<e+i;d++){const e=t[d];let i=u,g=u+this._computeAngle(d,s,f),p=o.getDataVisibility(d)?r.getDistanceFromCenterForValue(this.getParsed(d).r):0;u=g,n&&(a.animateScale&&(p=0),a.animateRotate&&(i=g=c));const m={x:l,y:h,innerRadius:0,outerRadius:p,startAngle:i,endAngle:g,options:this.resolveDataElementOptions(d,e.active?"active":s)};this.updateElement(e,d,m,s)}}countVisibleElements(){const t=this._cachedMeta;let e=0;return t.data.forEach(((t,i)=>{!isNaN(this.getParsed(i).r)&&this.chart.getDataVisibility(i)&&e++})),e}_computeAngle(t,e,i){return this.chart.getDataVisibility(t)?$(this.resolveDataElementOptions(t,e).angle||i):0}}var Un=Object.freeze({__proto__:null,BarController:class extends js{static id="bar";static defaults={datasetElementType:!1,dataElementType:"bar",categoryPercentage:.8,barPercentage:.9,grouped:!0,animations:{numbers:{type:"number",properties:["x","y","base","width","height"]}}};static overrides={scales:{_index_:{type:"category",offset:!0,grid:{offset:!0}},_value_:{type:"linear",beginAtZero:!0}}};parsePrimitiveData(t,e,i,s){return Vn(t,e,i,s)}parseArrayData(t,e,i,s){return Vn(t,e,i,s)}parseObjectData(t,e,i,s){const{iScale:n,vScale:o}=t,{xAxisKey:a="x",yAxisKey:r="y"}=this._parsing,l="x"===n.axis?a:r,h="x"===o.axis?a:r,c=[];let d,u,f,g;for(d=i,u=i+s;d<u;++d)g=e[d],f={},f[n.axis]=n.parse(M(g,l),d),c.push(Fn(M(g,h),f,o,d));return c}updateRangeFromParsed(t,e,i,s){super.updateRangeFromParsed(t,e,i,s);const n=i._custom;n&&e===this._cachedMeta.vScale&&(t.min=Math.min(t.min,n.min),t.max=Math.max(t.max,n.max))}getMaxOverflow(){return 0}getLabelAndValue(t){const e=this._cachedMeta,{iScale:i,vScale:s}=e,n=this.getParsed(t),o=n._custom,a=Bn(o)?"["+o.start+", "+o.end+"]":""+s.getLabelForValue(n[s.axis]);return{label:""+i.getLabelForValue(n[i.axis]),value:a}}initialize(){this.enableOptionSharing=!0,super.initialize();this._cachedMeta.stack=this.getDataset().stack}update(t){const e=this._cachedMeta;this.updateElements(e.data,0,e.data.length,t)}updateElements(t,e,i,n){const o="reset"===n,{index:a,_cachedMeta:{vScale:r}}=this,l=r.getBasePixel(),h=r.isHorizontal(),c=this._getRuler(),{sharedOptions:d,includeOptions:u}=this._getSharedOptions(e,n);for(let f=e;f<e+i;f++){const e=this.getParsed(f),i=o||s(e[r.axis])?{base:l,head:l}:this._calculateBarValuePixels(f),g=this._calculateBarIndexPixels(f,c),p=(e._stacks||{})[r.axis],m={horizontal:h,base:i.base,enableBorderRadius:!p||Bn(e._custom)||a===p._top||a===p._bottom,x:h?i.head:g.center,y:h?g.center:i.head,height:h?g.size:Math.abs(i.size),width:h?Math.abs(i.size):g.size};u&&(m.options=d||this.resolveDataElementOptions(f,t[f].active?"active":n));const x=m.options||t[f].options;Wn(m,x,p,a),jn(m,x,c.ratio),this.updateElement(t[f],f,m,n)}}_getStacks(t,e){const{iScale:i}=this._cachedMeta,n=i.getMatchingVisibleMetas(this._type).filter((t=>t.controller.options.grouped)),o=i.options.stacked,a=[],r=this._cachedMeta.controller.getParsed(e),l=r&&r[i.axis],h=t=>{const e=t._parsed.find((t=>t[i.axis]===l)),n=e&&e[t.vScale.axis];if(s(n)||isNaN(n))return!0};for(const i of n)if((void 0===e||!h(i))&&((!1===o||-1===a.indexOf(i.stack)||void 0===o&&void 0===i.stack)&&a.push(i.stack),i.index===t))break;return a.length||a.push(void 0),a}_getStackCount(t){return this._getStacks(void 0,t).length}_getAxisCount(){return this._getAxis().length}getFirstScaleIdForIndexAxis(){const t=this.chart.scales,e=this.chart.options.indexAxis;return Object.keys(t).filter((i=>t[i].axis===e)).shift()}_getAxis(){const t={},e=this.getFirstScaleIdForIndexAxis();for(const i of this.chart.data.datasets)t[l("x"===this.chart.options.indexAxis?i.xAxisID:i.yAxisID,e)]=!0;return Object.keys(t)}_getStackIndex(t,e,i){const s=this._getStacks(t,i),n=void 0!==e?s.indexOf(e):-1;return-1===n?s.length-1:n}_getRuler(){const t=this.options,e=this._cachedMeta,i=e.iScale,s=[];let n,o;for(n=0,o=e.data.length;n<o;++n)s.push(i.getPixelForValue(this.getParsed(n)[i.axis],n));const a=t.barThickness;return{min:a||zn(e),pixels:s,start:i._startPixel,end:i._endPixel,stackCount:this._getStackCount(),scale:i,grouped:t.grouped,ratio:a?1:t.categoryPercentage*t.barPercentage}}_calculateBarValuePixels(t){const{_cachedMeta:{vScale:e,_stacked:i,index:n},options:{base:o,minBarLength:a}}=this,r=o||0,l=this.getParsed(t),h=l._custom,c=Bn(h);let d,u,f=l[e.axis],g=0,p=i?this.applyStack(e,l,i):f;p!==f&&(g=p-f,p=f),c&&(f=h.barStart,p=h.barEnd-h.barStart,0!==f&&F(f)!==F(h.barEnd)&&(g=0),g+=f);const m=s(o)||c?g:o;let x=e.getPixelForValue(m);if(d=this.chart.getDataVisibility(t)?e.getPixelForValue(g+p):x,u=d-x,Math.abs(u)<a){u=function(t,e,i){return 0!==t?F(t):(e.isHorizontal()?1:-1)*(e.min>=i?1:-1)}(u,e,r)*a,f===r&&(x-=u/2);const t=e.getPixelForDecimal(0),s=e.getPixelForDecimal(1),o=Math.min(t,s),h=Math.max(t,s);x=Math.max(Math.min(x,h),o),d=x+u,i&&!c&&(l._stacks[e.axis]._visualValues[n]=e.getValueForPixel(d)-e.getValueForPixel(x))}if(x===e.getPixelForValue(r)){const t=F(u)*e.getLineWidthForValue(r)/2;x+=t,u-=t}return{size:u,base:x,head:d,center:d+u/2}}_calculateBarIndexPixels(t,e){const i=e.scale,n=this.options,o=n.skipNull,a=l(n.maxBarThickness,1/0);let r,h;const c=this._getAxisCount();if(e.grouped){const i=o?this._getStackCount(t):e.stackCount,d="flex"===n.barThickness?function(t,e,i,s){const n=e.pixels,o=n[t];let a=t>0?n[t-1]:null,r=t<n.length-1?n[t+1]:null;const l=i.categoryPercentage;null===a&&(a=o-(null===r?e.end-e.start:r-o)),null===r&&(r=o+o-a);const h=o-(o-Math.min(a,r))/2*l;return{chunk:Math.abs(r-a)/2*l/s,ratio:i.barPercentage,start:h}}(t,e,n,i*c):function(t,e,i,n){const o=i.barThickness;let a,r;return s(o)?(a=e.min*i.categoryPercentage,r=i.barPercentage):(a=o*n,r=1),{chunk:a/n,ratio:r,start:e.pixels[t]-a/2}}(t,e,n,i*c),u="x"===this.chart.options.indexAxis?this.getDataset().xAxisID:this.getDataset().yAxisID,f=this._getAxis().indexOf(l(u,this.getFirstScaleIdForIndexAxis())),g=this._getStackIndex(this.index,this._cachedMeta.stack,o?t:void 0)+f;r=d.start+d.chunk*g+d.chunk/2,h=Math.min(a,d.chunk*d.ratio)}else r=i.getPixelForValue(this.getParsed(t)[i.axis],t),h=Math.min(a,e.min*e.ratio);return{base:r-h/2,head:r+h/2,center:r,size:h}}draw(){const t=this._cachedMeta,e=t.vScale,i=t.data,s=i.length;let n=0;for(;n<s;++n)null===this.getParsed(n)[e.axis]||i[n].hidden||i[n].draw(this._ctx)}},BubbleController:class extends js{static id="bubble";static defaults={datasetElementType:!1,dataElementType:"point",animations:{numbers:{type:"number",properties:["x","y","borderWidth","radius"]}}};static overrides={scales:{x:{type:"linear"},y:{type:"linear"}}};initialize(){this.enableOptionSharing=!0,super.initialize()}parsePrimitiveData(t,e,i,s){const n=super.parsePrimitiveData(t,e,i,s);for(let t=0;t<n.length;t++)n[t]._custom=this.resolveDataElementOptions(t+i).radius;return n}parseArrayData(t,e,i,s){const n=super.parseArrayData(t,e,i,s);for(let t=0;t<n.length;t++){const s=e[i+t];n[t]._custom=l(s[2],this.resolveDataElementOptions(t+i).radius)}return n}parseObjectData(t,e,i,s){const n=super.parseObjectData(t,e,i,s);for(let t=0;t<n.length;t++){const s=e[i+t];n[t]._custom=l(s&&s.r&&+s.r,this.resolveDataElementOptions(t+i).radius)}return n}getMaxOverflow(){const t=this._cachedMeta.data;let e=0;for(let i=t.length-1;i>=0;--i)e=Math.max(e,t[i].size(this.resolveDataElementOptions(i))/2);return e>0&&e}getLabelAndValue(t){const e=this._cachedMeta,i=this.chart.data.labels||[],{xScale:s,yScale:n}=e,o=this.getParsed(t),a=s.getLabelForValue(o.x),r=n.getLabelForValue(o.y),l=o._custom;return{label:i[t]||"",value:"("+a+", "+r+(l?", "+l:"")+")"}}update(t){const e=this._cachedMeta.data;this.updateElements(e,0,e.length,t)}updateElements(t,e,i,s){const n="reset"===s,{iScale:o,vScale:a}=this._cachedMeta,{sharedOptions:r,includeOptions:l}=this._getSharedOptions(e,s),h=o.axis,c=a.axis;for(let d=e;d<e+i;d++){const e=t[d],i=!n&&this.getParsed(d),u={},f=u[h]=n?o.getPixelForDecimal(.5):o.getPixelForValue(i[h]),g=u[c]=n?a.getBasePixel():a.getPixelForValue(i[c]);u.skip=isNaN(f)||isNaN(g),l&&(u.options=r||this.resolveDataElementOptions(d,e.active?"active":s),n&&(u.options.radius=0)),this.updateElement(e,d,u,s)}}resolveDataElementOptions(t,e){const i=this.getParsed(t);let s=super.resolveDataElementOptions(t,e);s.$shared&&(s=Object.assign({},s,{$shared:!1}));const n=s.radius;return"active"!==e&&(s.radius=0),s.radius+=l(i&&i._custom,n),s}},DoughnutController:$n,LineController:class extends js{static id="line";static defaults={datasetElementType:"line",dataElementType:"point",showLine:!0,spanGaps:!1};static overrides={scales:{_index_:{type:"category"},_value_:{type:"linear"}}};initialize(){this.enableOptionSharing=!0,this.supportsDecimation=!0,super.initialize()}update(t){const e=this._cachedMeta,{dataset:i,data:s=[],_dataset:n}=e,o=this.chart._animationsDisabled;let{start:a,count:r}=pt(e,s,o);this._drawStart=a,this._drawCount=r,mt(e)&&(a=0,r=s.length),i._chart=this.chart,i._datasetIndex=this.index,i._decimated=!!n._decimated,i.points=s;const l=this.resolveDatasetElementOptions(t);this.options.showLine||(l.borderWidth=0),l.segment=this.options.segment,this.updateElement(i,void 0,{animated:!o,options:l},t),this.updateElements(s,a,r,t)}updateElements(t,e,i,n){const o="reset"===n,{iScale:a,vScale:r,_stacked:l,_dataset:h}=this._cachedMeta,{sharedOptions:c,includeOptions:d}=this._getSharedOptions(e,n),u=a.axis,f=r.axis,{spanGaps:g,segment:p}=this.options,m=N(g)?g:Number.POSITIVE_INFINITY,x=this.chart._animationsDisabled||o||"none"===n,b=e+i,_=t.length;let y=e>0&&this.getParsed(e-1);for(let i=0;i<_;++i){const g=t[i],_=x?g:{};if(i<e||i>=b){_.skip=!0;continue}const v=this.getParsed(i),M=s(v[f]),w=_[u]=a.getPixelForValue(v[u],i),k=_[f]=o||M?r.getBasePixel():r.getPixelForValue(l?this.applyStack(r,v,l):v[f],i);_.skip=isNaN(w)||isNaN(k)||M,_.stop=i>0&&Math.abs(v[u]-y[u])>m,p&&(_.parsed=v,_.raw=h.data[i]),d&&(_.options=c||this.resolveDataElementOptions(i,g.active?"active":n)),x||this.updateElement(g,i,_,n),y=v}}getMaxOverflow(){const t=this._cachedMeta,e=t.dataset,i=e.options&&e.options.borderWidth||0,s=t.data||[];if(!s.length)return i;const n=s[0].size(this.resolveDataElementOptions(0)),o=s[s.length-1].size(this.resolveDataElementOptions(s.length-1));return Math.max(i,n,o)/2}draw(){const t=this._cachedMeta;t.dataset.updateControlPoints(this.chart.chartArea,t.iScale.axis),super.draw()}},PieController:class extends $n{static id="pie";static defaults={cutout:0,rotation:0,circumference:360,radius:"100%"}},PolarAreaController:Yn,RadarController:class extends js{static id="radar";static defaults={datasetElementType:"line",dataElementType:"point",indexAxis:"r",showLine:!0,elements:{line:{fill:"start"}}};static overrides={aspectRatio:1,scales:{r:{type:"radialLinear"}}};getLabelAndValue(t){const e=this._cachedMeta.vScale,i=this.getParsed(t);return{label:e.getLabels()[t],value:""+e.getLabelForValue(i[e.axis])}}parseObjectData(t,e,i,s){return ii.bind(this)(t,e,i,s)}update(t){const e=this._cachedMeta,i=e.dataset,s=e.data||[],n=e.iScale.getLabels();if(i.points=s,"resize"!==t){const e=this.resolveDatasetElementOptions(t);this.options.showLine||(e.borderWidth=0);const o={_loop:!0,_fullLoop:n.length===s.length,options:e};this.updateElement(i,void 0,o,t)}this.updateElements(s,0,s.length,t)}updateElements(t,e,i,s){const n=this._cachedMeta.rScale,o="reset"===s;for(let a=e;a<e+i;a++){const e=t[a],i=this.resolveDataElementOptions(a,e.active?"active":s),r=n.getPointPositionForValue(a,this.getParsed(a).r),l=o?n.xCenter:r.x,h=o?n.yCenter:r.y,c={x:l,y:h,angle:r.angle,skip:isNaN(l)||isNaN(h),options:i};this.updateElement(e,a,c,s)}}},ScatterController:class extends js{static id="scatter";static defaults={datasetElementType:!1,dataElementType:"point",showLine:!1,fill:!1};static overrides={interaction:{mode:"point"},scales:{x:{type:"linear"},y:{type:"linear"}}};getLabelAndValue(t){const e=this._cachedMeta,i=this.chart.data.labels||[],{xScale:s,yScale:n}=e,o=this.getParsed(t),a=s.getLabelForValue(o.x),r=n.getLabelForValue(o.y);return{label:i[t]||"",value:"("+a+", "+r+")"}}update(t){const e=this._cachedMeta,{data:i=[]}=e,s=this.chart._animationsDisabled;let{start:n,count:o}=pt(e,i,s);if(this._drawStart=n,this._drawCount=o,mt(e)&&(n=0,o=i.length),this.options.showLine){this.datasetElementType||this.addElements();const{dataset:n,_dataset:o}=e;n._chart=this.chart,n._datasetIndex=this.index,n._decimated=!!o._decimated,n.points=i;const a=this.resolveDatasetElementOptions(t);a.segment=this.options.segment,this.updateElement(n,void 0,{animated:!s,options:a},t)}else this.datasetElementType&&(delete e.dataset,this.datasetElementType=!1);this.updateElements(i,n,o,t)}addElements(){const{showLine:t}=this.options;!this.datasetElementType&&t&&(this.datasetElementType=this.chart.registry.getElement("line")),super.addElements()}updateElements(t,e,i,n){const o="reset"===n,{iScale:a,vScale:r,_stacked:l,_dataset:h}=this._cachedMeta,c=this.resolveDataElementOptions(e,n),d=this.getSharedOptions(c),u=this.includeOptions(n,d),f=a.axis,g=r.axis,{spanGaps:p,segment:m}=this.options,x=N(p)?p:Number.POSITIVE_INFINITY,b=this.chart._animationsDisabled||o||"none"===n;let _=e>0&&this.getParsed(e-1);for(let c=e;c<e+i;++c){const e=t[c],i=this.getParsed(c),p=b?e:{},y=s(i[g]),v=p[f]=a.getPixelForValue(i[f],c),M=p[g]=o||y?r.getBasePixel():r.getPixelForValue(l?this.applyStack(r,i,l):i[g],c);p.skip=isNaN(v)||isNaN(M)||y,p.stop=c>0&&Math.abs(i[f]-_[f])>x,m&&(p.parsed=i,p.raw=h.data[c]),u&&(p.options=d||this.resolveDataElementOptions(c,e.active?"active":n)),b||this.updateElement(e,c,p,n),_=i}this.updateSharedOptions(d,n,c)}getMaxOverflow(){const t=this._cachedMeta,e=t.data||[];if(!this.options.showLine){let t=0;for(let i=e.length-1;i>=0;--i)t=Math.max(t,e[i].size(this.resolveDataElementOptions(i))/2);return t>0&&t}const i=t.dataset,s=i.options&&i.options.borderWidth||0;if(!e.length)return s;const n=e[0].size(this.resolveDataElementOptions(0)),o=e[e.length-1].size(this.resolveDataElementOptions(e.length-1));return Math.max(s,n,o)/2}}});function Xn(t,e,i,s){const n=vi(t.options.borderRadius,["outerStart","outerEnd","innerStart","innerEnd"]);const o=(i-e)/2,a=Math.min(o,s*e/2),r=t=>{const e=(i-Math.min(o,t))*s/2;return Z(t,0,Math.min(o,e))};return{outerStart:r(n.outerStart),outerEnd:r(n.outerEnd),innerStart:Z(n.innerStart,0,a),innerEnd:Z(n.innerEnd,0,a)}}function qn(t,e,i,s){return{x:i+t*Math.cos(e),y:s+t*Math.sin(e)}}function Kn(t,e,i,s,n,o){const{x:a,y:r,startAngle:l,pixelMargin:h,innerRadius:c}=e,d=Math.max(e.outerRadius+s+i-h,0),u=c>0?c+s+i+h:0;let f=0;const g=n-l;if(s){const t=((c>0?c-s:0)+(d>0?d-s:0))/2;f=(g-(0!==t?g*t/(t+s):g))/2}const p=(g-Math.max(.001,g*d-i/C)/d)/2,m=l+p+f,x=n-p-f,{outerStart:b,outerEnd:_,innerStart:y,innerEnd:v}=Xn(e,u,d,x-m),M=d-b,w=d-_,k=m+b/M,S=x-_/w,P=u+y,D=u+v,O=m+y/P,A=x-v/D;if(t.beginPath(),o){const e=(k+S)/2;if(t.arc(a,r,d,k,e),t.arc(a,r,d,e,S),_>0){const e=qn(w,S,a,r);t.arc(e.x,e.y,_,S,x+E)}const i=qn(D,x,a,r);if(t.lineTo(i.x,i.y),v>0){const e=qn(D,A,a,r);t.arc(e.x,e.y,v,x+E,A+Math.PI)}const s=(x-v/u+(m+y/u))/2;if(t.arc(a,r,u,x-v/u,s,!0),t.arc(a,r,u,s,m+y/u,!0),y>0){const e=qn(P,O,a,r);t.arc(e.x,e.y,y,O+Math.PI,m-E)}const n=qn(M,m,a,r);if(t.lineTo(n.x,n.y),b>0){const e=qn(M,k,a,r);t.arc(e.x,e.y,b,m-E,k)}}else{t.moveTo(a,r);const e=Math.cos(k)*d+a,i=Math.sin(k)*d+r;t.lineTo(e,i);const s=Math.cos(S)*d+a,n=Math.sin(S)*d+r;t.lineTo(s,n)}t.closePath()}function Gn(t,e,i,s,n){const{fullCircles:o,startAngle:a,circumference:r,options:l}=e,{borderWidth:h,borderJoinStyle:c,borderDash:d,borderDashOffset:u,borderRadius:f}=l,g="inner"===l.borderAlign;if(!h)return;t.setLineDash(d||[]),t.lineDashOffset=u,g?(t.lineWidth=2*h,t.lineJoin=c||"round"):(t.lineWidth=h,t.lineJoin=c||"bevel");let p=e.endAngle;if(o){Kn(t,e,i,s,p,n);for(let e=0;e<o;++e)t.stroke();isNaN(r)||(p=a+(r%O||O))}g&&function(t,e,i){const{startAngle:s,pixelMargin:n,x:o,y:a,outerRadius:r,innerRadius:l}=e;let h=n/r;t.beginPath(),t.arc(o,a,r,s-h,i+h),l>n?(h=n/l,t.arc(o,a,l,i+h,s-h,!0)):t.arc(o,a,n,i+E,s-E),t.closePath(),t.clip()}(t,e,p),l.selfJoin&&p-a>=C&&0===f&&"miter"!==c&&function(t,e,i){const{startAngle:s,x:n,y:o,outerRadius:a,innerRadius:r,options:l}=e,{borderWidth:h,borderJoinStyle:c}=l,d=Math.min(h/a,G(s-i));if(t.beginPath(),t.arc(n,o,a-h/2,s+d/2,i-d/2),r>0){const e=Math.min(h/r,G(s-i));t.arc(n,o,r+h/2,i-e/2,s+e/2,!0)}else{const e=Math.min(h/2,a*G(s-i));if("round"===c)t.arc(n,o,e,i-C/2,s+C/2,!0);else if("bevel"===c){const a=2*e*e,r=-a*Math.cos(i+C/2)+n,l=-a*Math.sin(i+C/2)+o,h=a*Math.cos(s+C/2)+n,c=a*Math.sin(s+C/2)+o;t.lineTo(r,l),t.lineTo(h,c)}}t.closePath(),t.moveTo(0,0),t.rect(0,0,t.canvas.width,t.canvas.height),t.clip("evenodd")}(t,e,p),o||(Kn(t,e,i,s,p,n),t.stroke())}function Jn(t,e,i=e){t.lineCap=l(i.borderCapStyle,e.borderCapStyle),t.setLineDash(l(i.borderDash,e.borderDash)),t.lineDashOffset=l(i.borderDashOffset,e.borderDashOffset),t.lineJoin=l(i.borderJoinStyle,e.borderJoinStyle),t.lineWidth=l(i.borderWidth,e.borderWidth),t.strokeStyle=l(i.borderColor,e.borderColor)}function Zn(t,e,i){t.lineTo(i.x,i.y)}function Qn(t,e,i={}){const s=t.length,{start:n=0,end:o=s-1}=i,{start:a,end:r}=e,l=Math.max(n,a),h=Math.min(o,r),c=n<a&&o<a||n>r&&o>r;return{count:s,start:l,loop:e.loop,ilen:h<l&&!c?s+h-l:h-l}}function to(t,e,i,s){const{points:n,options:o}=e,{count:a,start:r,loop:l,ilen:h}=Qn(n,i,s),c=function(t){return t.stepped?Fe:t.tension||"monotone"===t.cubicInterpolationMode?Ve:Zn}(o);let d,u,f,{move:g=!0,reverse:p}=s||{};for(d=0;d<=h;++d)u=n[(r+(p?h-d:d))%a],u.skip||(g?(t.moveTo(u.x,u.y),g=!1):c(t,f,u,p,o.stepped),f=u);return l&&(u=n[(r+(p?h:0))%a],c(t,f,u,p,o.stepped)),!!l}function eo(t,e,i,s){const n=e.points,{count:o,start:a,ilen:r}=Qn(n,i,s),{move:l=!0,reverse:h}=s||{};let c,d,u,f,g,p,m=0,x=0;const b=t=>(a+(h?r-t:t))%o,_=()=>{f!==g&&(t.lineTo(m,g),t.lineTo(m,f),t.lineTo(m,p))};for(l&&(d=n[b(0)],t.moveTo(d.x,d.y)),c=0;c<=r;++c){if(d=n[b(c)],d.skip)continue;const e=d.x,i=d.y,s=0|e;s===u?(i<f?f=i:i>g&&(g=i),m=(x*m+e)/++x):(_(),t.lineTo(e,i),u=s,x=0,f=g=i),p=i}_()}function io(t){const e=t.options,i=e.borderDash&&e.borderDash.length;return!(t._decimated||t._loop||e.tension||"monotone"===e.cubicInterpolationMode||e.stepped||i)?eo:to}const so="function"==typeof Path2D;function no(t,e,i,s){so&&!e.options.segment?function(t,e,i,s){let n=e._path;n||(n=e._path=new Path2D,e.path(n,i,s)&&n.closePath()),Jn(t,e.options),t.stroke(n)}(t,e,i,s):function(t,e,i,s){const{segments:n,options:o}=e,a=io(e);for(const r of n)Jn(t,o,r.style),t.beginPath(),a(t,e,r,{start:i,end:i+s-1})&&t.closePath(),t.stroke()}(t,e,i,s)}class oo extends $s{static id="line";static defaults={borderCapStyle:"butt",borderDash:[],borderDashOffset:0,borderJoinStyle:"miter",borderWidth:3,capBezierPoints:!0,cubicInterpolationMode:"default",fill:!1,spanGaps:!1,stepped:!1,tension:0};static defaultRoutes={backgroundColor:"backgroundColor",borderColor:"borderColor"};static descriptors={_scriptable:!0,_indexable:t=>"borderDash"!==t&&"fill"!==t};constructor(t){super(),this.animated=!0,this.options=void 0,this._chart=void 0,this._loop=void 0,this._fullLoop=void 0,this._path=void 0,this._points=void 0,this._segments=void 0,this._decimated=!1,this._pointsUpdated=!1,this._datasetIndex=void 0,t&&Object.assign(this,t)}updateControlPoints(t,e){const i=this.options;if((i.tension||"monotone"===i.cubicInterpolationMode)&&!i.stepped&&!this._pointsUpdated){const s=i.spanGaps?this._loop:this._fullLoop;hi(this._points,i,t,s,e),this._pointsUpdated=!0}}set points(t){this._points=t,delete this._segments,delete this._path,this._pointsUpdated=!1}get points(){return this._points}get segments(){return this._segments||(this._segments=zi(this,this.options.segment))}first(){const t=this.segments,e=this.points;return t.length&&e[t[0].start]}last(){const t=this.segments,e=this.points,i=t.length;return i&&e[t[i-1].end]}interpolate(t,e){const i=this.options,s=t[e],n=this.points,o=Ii(this,{property:e,start:s,end:s});if(!o.length)return;const a=[],r=function(t){return t.stepped?pi:t.tension||"monotone"===t.cubicInterpolationMode?mi:gi}(i);let l,h;for(l=0,h=o.length;l<h;++l){const{start:h,end:c}=o[l],d=n[h],u=n[c];if(d===u){a.push(d);continue}const f=r(d,u,Math.abs((s-d[e])/(u[e]-d[e])),i.stepped);f[e]=t[e],a.push(f)}return 1===a.length?a[0]:a}pathSegment(t,e,i){return io(this)(t,this,e,i)}path(t,e,i){const s=this.segments,n=io(this);let o=this._loop;e=e||0,i=i||this.points.length-e;for(const a of s)o&=n(t,this,a,{start:e,end:e+i-1});return!!o}draw(t,e,i,s){const n=this.options||{};(this.points||[]).length&&n.borderWidth&&(t.save(),no(t,this,i,s),t.restore()),this.animated&&(this._pointsUpdated=!1,this._path=void 0)}}function ao(t,e,i,s){const n=t.options,{[i]:o}=t.getProps([i],s);return Math.abs(e-o)<n.radius+n.hitRadius}function ro(t,e){const{x:i,y:s,base:n,width:o,height:a}=t.getProps(["x","y","base","width","height"],e);let r,l,h,c,d;return t.horizontal?(d=a/2,r=Math.min(i,n),l=Math.max(i,n),h=s-d,c=s+d):(d=o/2,r=i-d,l=i+d,h=Math.min(s,n),c=Math.max(s,n)),{left:r,top:h,right:l,bottom:c}}function lo(t,e,i,s){return t?0:Z(e,i,s)}function ho(t){const e=ro(t),i=e.right-e.left,s=e.bottom-e.top,n=function(t,e,i){const s=t.options.borderWidth,n=t.borderSkipped,o=Mi(s);return{t:lo(n.top,o.top,0,i),r:lo(n.right,o.right,0,e),b:lo(n.bottom,o.bottom,0,i),l:lo(n.left,o.left,0,e)}}(t,i/2,s/2),a=function(t,e,i){const{enableBorderRadius:s}=t.getProps(["enableBorderRadius"]),n=t.options.borderRadius,a=wi(n),r=Math.min(e,i),l=t.borderSkipped,h=s||o(n);return{topLeft:lo(!h||l.top||l.left,a.topLeft,0,r),topRight:lo(!h||l.top||l.right,a.topRight,0,r),bottomLeft:lo(!h||l.bottom||l.left,a.bottomLeft,0,r),bottomRight:lo(!h||l.bottom||l.right,a.bottomRight,0,r)}}(t,i/2,s/2);return{outer:{x:e.left,y:e.top,w:i,h:s,radius:a},inner:{x:e.left+n.l,y:e.top+n.t,w:i-n.l-n.r,h:s-n.t-n.b,radius:{topLeft:Math.max(0,a.topLeft-Math.max(n.t,n.l)),topRight:Math.max(0,a.topRight-Math.max(n.t,n.r)),bottomLeft:Math.max(0,a.bottomLeft-Math.max(n.b,n.l)),bottomRight:Math.max(0,a.bottomRight-Math.max(n.b,n.r))}}}}function co(t,e,i,s){const n=null===e,o=null===i,a=t&&!(n&&o)&&ro(t,s);return a&&(n||tt(e,a.left,a.right))&&(o||tt(i,a.top,a.bottom))}function uo(t,e){t.rect(e.x,e.y,e.w,e.h)}function fo(t,e,i={}){const s=t.x!==i.x?-e:0,n=t.y!==i.y?-e:0,o=(t.x+t.w!==i.x+i.w?e:0)-s,a=(t.y+t.h!==i.y+i.h?e:0)-n;return{x:t.x+s,y:t.y+n,w:t.w+o,h:t.h+a,radius:t.radius}}var go=Object.freeze({__proto__:null,ArcElement:class extends $s{static id="arc";static defaults={borderAlign:"center",borderColor:"#fff",borderDash:[],borderDashOffset:0,borderJoinStyle:void 0,borderRadius:0,borderWidth:2,offset:0,spacing:0,angle:void 0,circular:!0,selfJoin:!1};static defaultRoutes={backgroundColor:"backgroundColor"};static descriptors={_scriptable:!0,_indexable:t=>"borderDash"!==t};circumference;endAngle;fullCircles;innerRadius;outerRadius;pixelMargin;startAngle;constructor(t){super(),this.options=void 0,this.circumference=void 0,this.startAngle=void 0,this.endAngle=void 0,this.innerRadius=void 0,this.outerRadius=void 0,this.pixelMargin=0,this.fullCircles=0,t&&Object.assign(this,t)}inRange(t,e,i){const s=this.getProps(["x","y"],i),{angle:n,distance:o}=X(s,{x:t,y:e}),{startAngle:a,endAngle:r,innerRadius:h,outerRadius:c,circumference:d}=this.getProps(["startAngle","endAngle","innerRadius","outerRadius","circumference"],i),u=(this.options.spacing+this.options.borderWidth)/2,f=l(d,r-a),g=J(n,a,r)&&a!==r,p=f>=O||g,m=tt(o,h+u,c+u);return p&&m}getCenterPoint(t){const{x:e,y:i,startAngle:s,endAngle:n,innerRadius:o,outerRadius:a}=this.getProps(["x","y","startAngle","endAngle","innerRadius","outerRadius"],t),{offset:r,spacing:l}=this.options,h=(s+n)/2,c=(o+a+l+r)/2;return{x:e+Math.cos(h)*c,y:i+Math.sin(h)*c}}tooltipPosition(t){return this.getCenterPoint(t)}draw(t){const{options:e,circumference:i}=this,s=(e.offset||0)/4,n=(e.spacing||0)/2,o=e.circular;if(this.pixelMargin="inner"===e.borderAlign?.33:0,this.fullCircles=i>O?Math.floor(i/O):0,0===i||this.innerRadius<0||this.outerRadius<0)return;t.save();const a=(this.startAngle+this.endAngle)/2;t.translate(Math.cos(a)*s,Math.sin(a)*s);const r=s*(1-Math.sin(Math.min(C,i||0)));t.fillStyle=e.backgroundColor,t.strokeStyle=e.borderColor,function(t,e,i,s,n){const{fullCircles:o,startAngle:a,circumference:r}=e;let l=e.endAngle;if(o){Kn(t,e,i,s,l,n);for(let e=0;e<o;++e)t.fill();isNaN(r)||(l=a+(r%O||O))}Kn(t,e,i,s,l,n),t.fill()}(t,this,r,n,o),Gn(t,this,r,n,o),t.restore()}},BarElement:class extends $s{static id="bar";static defaults={borderSkipped:"start",borderWidth:0,borderRadius:0,inflateAmount:"auto",pointStyle:void 0};static defaultRoutes={backgroundColor:"backgroundColor",borderColor:"borderColor"};constructor(t){super(),this.options=void 0,this.horizontal=void 0,this.base=void 0,this.width=void 0,this.height=void 0,this.inflateAmount=void 0,t&&Object.assign(this,t)}draw(t){const{inflateAmount:e,options:{borderColor:i,backgroundColor:s}}=this,{inner:n,outer:o}=ho(this),a=(r=o.radius).topLeft||r.topRight||r.bottomLeft||r.bottomRight?He:uo;var r;t.save(),o.w===n.w&&o.h===n.h||(t.beginPath(),a(t,fo(o,e,n)),t.clip(),a(t,fo(n,-e,o)),t.fillStyle=i,t.fill("evenodd")),t.beginPath(),a(t,fo(n,e)),t.fillStyle=s,t.fill(),t.restore()}inRange(t,e,i){return co(this,t,e,i)}inXRange(t,e){return co(this,t,null,e)}inYRange(t,e){return co(this,null,t,e)}getCenterPoint(t){const{x:e,y:i,base:s,horizontal:n}=this.getProps(["x","y","base","horizontal"],t);return{x:n?(e+s)/2:e,y:n?i:(i+s)/2}}getRange(t){return"x"===t?this.width/2:this.height/2}},LineElement:oo,PointElement:class extends $s{static id="point";parsed;skip;stop;static defaults={borderWidth:1,hitRadius:1,hoverBorderWidth:1,hoverRadius:4,pointStyle:"circle",radius:3,rotation:0};static defaultRoutes={backgroundColor:"backgroundColor",borderColor:"borderColor"};constructor(t){super(),this.options=void 0,this.parsed=void 0,this.skip=void 0,this.stop=void 0,t&&Object.assign(this,t)}inRange(t,e,i){const s=this.options,{x:n,y:o}=this.getProps(["x","y"],i);return Math.pow(t-n,2)+Math.pow(e-o,2)<Math.pow(s.hitRadius+s.radius,2)}inXRange(t,e){return ao(this,t,"x",e)}inYRange(t,e){return ao(this,t,"y",e)}getCenterPoint(t){const{x:e,y:i}=this.getProps(["x","y"],t);return{x:e,y:i}}size(t){let e=(t=t||this.options||{}).radius||0;e=Math.max(e,e&&t.hoverRadius||0);return 2*(e+(e&&t.borderWidth||0))}draw(t,e){const i=this.options;this.skip||i.radius<.1||!Re(this,e,this.size(i)/2)||(t.strokeStyle=i.borderColor,t.lineWidth=i.borderWidth,t.fillStyle=i.backgroundColor,Le(t,i,this.x,this.y))}getRange(){const t=this.options||{};return t.radius+t.hitRadius}}});function po(t,e,i,s){const n=t.indexOf(e);if(-1===n)return((t,e,i,s)=>("string"==typeof e?(i=t.push(e)-1,s.unshift({index:i,label:e})):isNaN(e)&&(i=null),i))(t,e,i,s);return n!==t.lastIndexOf(e)?i:n}function mo(t){const e=this.getLabels();return t>=0&&t<e.length?e[t]:t}function xo(t,e,{horizontal:i,minRotation:s}){const n=$(s),o=(i?Math.sin(n):Math.cos(n))||.001,a=.75*e*(""+t).length;return Math.min(e/o,a)}class bo extends tn{constructor(t){super(t),this.start=void 0,this.end=void 0,this._startValue=void 0,this._endValue=void 0,this._valueRange=0}parse(t,e){return s(t)||("number"==typeof t||t instanceof Number)&&!isFinite(+t)?null:+t}handleTickRangeOptions(){const{beginAtZero:t}=this.options,{minDefined:e,maxDefined:i}=this.getUserBounds();let{min:s,max:n}=this;const o=t=>s=e?s:t,a=t=>n=i?n:t;if(t){const t=F(s),e=F(n);t<0&&e<0?a(0):t>0&&e>0&&o(0)}if(s===n){let e=0===n?1:Math.abs(.05*n);a(n+e),t||o(s-e)}this.min=s,this.max=n}getTickLimit(){const t=this.options.ticks;let e,{maxTicksLimit:i,stepSize:s}=t;return s?(e=Math.ceil(this.max/s)-Math.floor(this.min/s)+1,e>1e3&&(console.warn(`scales.${this.id}.ticks.stepSize: ${s} would result generating up to ${e} ticks. Limiting to 1000.`),e=1e3)):(e=this.computeTickLimit(),i=i||11),i&&(e=Math.min(i,e)),e}computeTickLimit(){return Number.POSITIVE_INFINITY}buildTicks(){const t=this.options,e=t.ticks;let i=this.getTickLimit();i=Math.max(2,i);const n=function(t,e){const i=[],{bounds:n,step:o,min:a,max:r,precision:l,count:h,maxTicks:c,maxDigits:d,includeBounds:u}=t,f=o||1,g=c-1,{min:p,max:m}=e,x=!s(a),b=!s(r),_=!s(h),y=(m-p)/(d+1);let v,M,w,k,S=B((m-p)/g/f)*f;if(S<1e-14&&!x&&!b)return[{value:p},{value:m}];k=Math.ceil(m/S)-Math.floor(p/S),k>g&&(S=B(k*S/g/f)*f),s(l)||(v=Math.pow(10,l),S=Math.ceil(S*v)/v),"ticks"===n?(M=Math.floor(p/S)*S,w=Math.ceil(m/S)*S):(M=p,w=m),x&&b&&o&&H((r-a)/o,S/1e3)?(k=Math.round(Math.min((r-a)/S,c)),S=(r-a)/k,M=a,w=r):_?(M=x?a:M,w=b?r:w,k=h-1,S=(w-M)/k):(k=(w-M)/S,k=V(k,Math.round(k),S/1e3)?Math.round(k):Math.ceil(k));const P=Math.max(U(S),U(M));v=Math.pow(10,s(l)?P:l),M=Math.round(M*v)/v,w=Math.round(w*v)/v;let D=0;for(x&&(u&&M!==a?(i.push({value:a}),M<a&&D++,V(Math.round((M+D*S)*v)/v,a,xo(a,y,t))&&D++):M<a&&D++);D<k;++D){const t=Math.round((M+D*S)*v)/v;if(b&&t>r)break;i.push({value:t})}return b&&u&&w!==r?i.length&&V(i[i.length-1].value,r,xo(r,y,t))?i[i.length-1].value=r:i.push({value:r}):b&&w!==r||i.push({value:w}),i}({maxTicks:i,bounds:t.bounds,min:t.min,max:t.max,precision:e.precision,step:e.stepSize,count:e.count,maxDigits:this._maxDigits(),horizontal:this.isHorizontal(),minRotation:e.minRotation||0,includeBounds:!1!==e.includeBounds},this._range||this);return"ticks"===t.bounds&&j(n,this,"value"),t.reverse?(n.reverse(),this.start=this.max,this.end=this.min):(this.start=this.min,this.end=this.max),n}configure(){const t=this.ticks;let e=this.min,i=this.max;if(super.configure(),this.options.offset&&t.length){const s=(i-e)/Math.max(t.length-1,1)/2;e-=s,i+=s}this._startValue=e,this._endValue=i,this._valueRange=i-e}getLabelForValue(t){return ne(t,this.chart.options.locale,this.options.ticks.format)}}class _o extends bo{static id="linear";static defaults={ticks:{callback:ae.formatters.numeric}};determineDataLimits(){const{min:t,max:e}=this.getMinMax(!0);this.min=a(t)?t:0,this.max=a(e)?e:1,this.handleTickRangeOptions()}computeTickLimit(){const t=this.isHorizontal(),e=t?this.width:this.height,i=$(this.options.ticks.minRotation),s=(t?Math.sin(i):Math.cos(i))||.001,n=this._resolveTickFontOptions(0);return Math.ceil(e/Math.min(40,n.lineHeight/s))}getPixelForValue(t){return null===t?NaN:this.getPixelForDecimal((t-this._startValue)/this._valueRange)}getValueForPixel(t){return this._startValue+this.getDecimalForPixel(t)*this._valueRange}}const yo=t=>Math.floor(z(t)),vo=(t,e)=>Math.pow(10,yo(t)+e);function Mo(t){return 1===t/Math.pow(10,yo(t))}function wo(t,e,i){const s=Math.pow(10,i),n=Math.floor(t/s);return Math.ceil(e/s)-n}function ko(t,{min:e,max:i}){e=r(t.min,e);const s=[],n=yo(e);let o=function(t,e){let i=yo(e-t);for(;wo(t,e,i)>10;)i++;for(;wo(t,e,i)<10;)i--;return Math.min(i,yo(t))}(e,i),a=o<0?Math.pow(10,Math.abs(o)):1;const l=Math.pow(10,o),h=n>o?Math.pow(10,n):0,c=Math.round((e-h)*a)/a,d=Math.floor((e-h)/l/10)*l*10;let u=Math.floor((c-d)/Math.pow(10,o)),f=r(t.min,Math.round((h+d+u*Math.pow(10,o))*a)/a);for(;f<i;)s.push({value:f,major:Mo(f),significand:u}),u>=10?u=u<15?15:20:u++,u>=20&&(o++,u=2,a=o>=0?1:a),f=Math.round((h+d+u*Math.pow(10,o))*a)/a;const g=r(t.max,f);return s.push({value:g,major:Mo(g),significand:u}),s}class So extends tn{static id="logarithmic";static defaults={ticks:{callback:ae.formatters.logarithmic,major:{enabled:!0}}};constructor(t){super(t),this.start=void 0,this.end=void 0,this._startValue=void 0,this._valueRange=0}parse(t,e){const i=bo.prototype.parse.apply(this,[t,e]);if(0!==i)return a(i)&&i>0?i:null;this._zero=!0}determineDataLimits(){const{min:t,max:e}=this.getMinMax(!0);this.min=a(t)?Math.max(0,t):null,this.max=a(e)?Math.max(0,e):null,this.options.beginAtZero&&(this._zero=!0),this._zero&&this.min!==this._suggestedMin&&!a(this._userMin)&&(this.min=t===vo(this.min,0)?vo(this.min,-1):vo(this.min,0)),this.handleTickRangeOptions()}handleTickRangeOptions(){const{minDefined:t,maxDefined:e}=this.getUserBounds();let i=this.min,s=this.max;const n=e=>i=t?i:e,o=t=>s=e?s:t;i===s&&(i<=0?(n(1),o(10)):(n(vo(i,-1)),o(vo(s,1)))),i<=0&&n(vo(s,-1)),s<=0&&o(vo(i,1)),this.min=i,this.max=s}buildTicks(){const t=this.options,e=ko({min:this._userMin,max:this._userMax},this);return"ticks"===t.bounds&&j(e,this,"value"),t.reverse?(e.reverse(),this.start=this.max,this.end=this.min):(this.start=this.min,this.end=this.max),e}getLabelForValue(t){return void 0===t?"0":ne(t,this.chart.options.locale,this.options.ticks.format)}configure(){const t=this.min;super.configure(),this._startValue=z(t),this._valueRange=z(this.max)-z(t)}getPixelForValue(t){return void 0!==t&&0!==t||(t=this.min),null===t||isNaN(t)?NaN:this.getPixelForDecimal(t===this.min?0:(z(t)-this._startValue)/this._valueRange)}getValueForPixel(t){const e=this.getDecimalForPixel(t);return Math.pow(10,this._startValue+e*this._valueRange)}}function Po(t){const e=t.ticks;if(e.display&&t.display){const t=ki(e.backdropPadding);return l(e.font&&e.font.size,ue.font.size)+t.height}return 0}function Do(t,e,i,s,n){return t===s||t===n?{start:e-i/2,end:e+i/2}:t<s||t>n?{start:e-i,end:e}:{start:e,end:e+i}}function Co(t){const e={l:t.left+t._padding.left,r:t.right-t._padding.right,t:t.top+t._padding.top,b:t.bottom-t._padding.bottom},i=Object.assign({},e),s=[],o=[],a=t._pointLabels.length,r=t.options.pointLabels,l=r.centerPointLabels?C/a:0;for(let u=0;u<a;u++){const a=r.setContext(t.getPointLabelContext(u));o[u]=a.padding;const f=t.getPointPosition(u,t.drawingArea+o[u],l),g=Si(a.font),p=(h=t.ctx,c=g,d=n(d=t._pointLabels[u])?d:[d],{w:Oe(h,c.string,d),h:d.length*c.lineHeight});s[u]=p;const m=G(t.getIndexAngle(u)+l),x=Math.round(Y(m));Oo(i,e,m,Do(x,f.x,p.w,0,180),Do(x,f.y,p.h,90,270))}var h,c,d;t.setCenterPoint(e.l-i.l,i.r-e.r,e.t-i.t,i.b-e.b),t._pointLabelItems=function(t,e,i){const s=[],n=t._pointLabels.length,o=t.options,{centerPointLabels:a,display:r}=o.pointLabels,l={extra:Po(o)/2,additionalAngle:a?C/n:0};let h;for(let o=0;o<n;o++){l.padding=i[o],l.size=e[o];const n=Ao(t,o,l);s.push(n),"auto"===r&&(n.visible=To(n,h),n.visible&&(h=n))}return s}(t,s,o)}function Oo(t,e,i,s,n){const o=Math.abs(Math.sin(i)),a=Math.abs(Math.cos(i));let r=0,l=0;s.start<e.l?(r=(e.l-s.start)/o,t.l=Math.min(t.l,e.l-r)):s.end>e.r&&(r=(s.end-e.r)/o,t.r=Math.max(t.r,e.r+r)),n.start<e.t?(l=(e.t-n.start)/a,t.t=Math.min(t.t,e.t-l)):n.end>e.b&&(l=(n.end-e.b)/a,t.b=Math.max(t.b,e.b+l))}function Ao(t,e,i){const s=t.drawingArea,{extra:n,additionalAngle:o,padding:a,size:r}=i,l=t.getPointPosition(e,s+n+a,o),h=Math.round(Y(G(l.angle+E))),c=function(t,e,i){90===i||270===i?t-=e/2:(i>270||i<90)&&(t-=e);return t}(l.y,r.h,h),d=function(t){if(0===t||180===t)return"center";if(t<180)return"left";return"right"}(h),u=function(t,e,i){"right"===i?t-=e:"center"===i&&(t-=e/2);return t}(l.x,r.w,d);return{visible:!0,x:l.x,y:c,textAlign:d,left:u,top:c,right:u+r.w,bottom:c+r.h}}function To(t,e){if(!e)return!0;const{left:i,top:s,right:n,bottom:o}=t;return!(Re({x:i,y:s},e)||Re({x:i,y:o},e)||Re({x:n,y:s},e)||Re({x:n,y:o},e))}function Lo(t,e,i){const{left:n,top:o,right:a,bottom:r}=i,{backdropColor:l}=e;if(!s(l)){const i=wi(e.borderRadius),s=ki(e.backdropPadding);t.fillStyle=l;const h=n-s.left,c=o-s.top,d=a-n+s.width,u=r-o+s.height;Object.values(i).some((t=>0!==t))?(t.beginPath(),He(t,{x:h,y:c,w:d,h:u,radius:i}),t.fill()):t.fillRect(h,c,d,u)}}function Eo(t,e,i,s){const{ctx:n}=t;if(i)n.arc(t.xCenter,t.yCenter,e,0,O);else{let i=t.getPointPosition(0,e);n.moveTo(i.x,i.y);for(let o=1;o<s;o++)i=t.getPointPosition(o,e),n.lineTo(i.x,i.y)}}class Ro extends bo{static id="radialLinear";static defaults={display:!0,animate:!0,position:"chartArea",angleLines:{display:!0,lineWidth:1,borderDash:[],borderDashOffset:0},grid:{circular:!1},startAngle:0,ticks:{showLabelBackdrop:!0,callback:ae.formatters.numeric},pointLabels:{backdropColor:void 0,backdropPadding:2,display:!0,font:{size:10},callback:t=>t,padding:5,centerPointLabels:!1}};static defaultRoutes={"angleLines.color":"borderColor","pointLabels.color":"color","ticks.color":"color"};static descriptors={angleLines:{_fallback:"grid"}};constructor(t){super(t),this.xCenter=void 0,this.yCenter=void 0,this.drawingArea=void 0,this._pointLabels=[],this._pointLabelItems=[]}setDimensions(){const t=this._padding=ki(Po(this.options)/2),e=this.width=this.maxWidth-t.width,i=this.height=this.maxHeight-t.height;this.xCenter=Math.floor(this.left+e/2+t.left),this.yCenter=Math.floor(this.top+i/2+t.top),this.drawingArea=Math.floor(Math.min(e,i)/2)}determineDataLimits(){const{min:t,max:e}=this.getMinMax(!1);this.min=a(t)&&!isNaN(t)?t:0,this.max=a(e)&&!isNaN(e)?e:0,this.handleTickRangeOptions()}computeTickLimit(){return Math.ceil(this.drawingArea/Po(this.options))}generateTickLabels(t){bo.prototype.generateTickLabels.call(this,t),this._pointLabels=this.getLabels().map(((t,e)=>{const i=d(this.options.pointLabels.callback,[t,e],this);return i||0===i?i:""})).filter(((t,e)=>this.chart.getDataVisibility(e)))}fit(){const t=this.options;t.display&&t.pointLabels.display?Co(this):this.setCenterPoint(0,0,0,0)}setCenterPoint(t,e,i,s){this.xCenter+=Math.floor((t-e)/2),this.yCenter+=Math.floor((i-s)/2),this.drawingArea-=Math.min(this.drawingArea/2,Math.max(t,e,i,s))}getIndexAngle(t){return G(t*(O/(this._pointLabels.length||1))+$(this.options.startAngle||0))}getDistanceFromCenterForValue(t){if(s(t))return NaN;const e=this.drawingArea/(this.max-this.min);return this.options.reverse?(this.max-t)*e:(t-this.min)*e}getValueForDistanceFromCenter(t){if(s(t))return NaN;const e=t/(this.drawingArea/(this.max-this.min));return this.options.reverse?this.max-e:this.min+e}getPointLabelContext(t){const e=this._pointLabels||[];if(t>=0&&t<e.length){const i=e[t];return function(t,e,i){return Ci(t,{label:i,index:e,type:"pointLabel"})}(this.getContext(),t,i)}}getPointPosition(t,e,i=0){const s=this.getIndexAngle(t)-E+i;return{x:Math.cos(s)*e+this.xCenter,y:Math.sin(s)*e+this.yCenter,angle:s}}getPointPositionForValue(t,e){return this.getPointPosition(t,this.getDistanceFromCenterForValue(e))}getBasePosition(t){return this.getPointPositionForValue(t||0,this.getBaseValue())}getPointLabelPosition(t){const{left:e,top:i,right:s,bottom:n}=this._pointLabelItems[t];return{left:e,top:i,right:s,bottom:n}}drawBackground(){const{backgroundColor:t,grid:{circular:e}}=this.options;if(t){const i=this.ctx;i.save(),i.beginPath(),Eo(this,this.getDistanceFromCenterForValue(this._endValue),e,this._pointLabels.length),i.closePath(),i.fillStyle=t,i.fill(),i.restore()}}drawGrid(){const t=this.ctx,e=this.options,{angleLines:i,grid:s,border:n}=e,o=this._pointLabels.length;let a,r,l;if(e.pointLabels.display&&function(t,e){const{ctx:i,options:{pointLabels:s}}=t;for(let n=e-1;n>=0;n--){const e=t._pointLabelItems[n];if(!e.visible)continue;const o=s.setContext(t.getPointLabelContext(n));Lo(i,o,e);const a=Si(o.font),{x:r,y:l,textAlign:h}=e;Ne(i,t._pointLabels[n],r,l+a.lineHeight/2,a,{color:o.color,textAlign:h,textBaseline:"middle"})}}(this,o),s.display&&this.ticks.forEach(((t,e)=>{if(0!==e||0===e&&this.min<0){r=this.getDistanceFromCenterForValue(t.value);const i=this.getContext(e),a=s.setContext(i),l=n.setContext(i);!function(t,e,i,s,n){const o=t.ctx,a=e.circular,{color:r,lineWidth:l}=e;!a&&!s||!r||!l||i<0||(o.save(),o.strokeStyle=r,o.lineWidth=l,o.setLineDash(n.dash||[]),o.lineDashOffset=n.dashOffset,o.beginPath(),Eo(t,i,a,s),o.closePath(),o.stroke(),o.restore())}(this,a,r,o,l)}})),i.display){for(t.save(),a=o-1;a>=0;a--){const s=i.setContext(this.getPointLabelContext(a)),{color:n,lineWidth:o}=s;o&&n&&(t.lineWidth=o,t.strokeStyle=n,t.setLineDash(s.borderDash),t.lineDashOffset=s.borderDashOffset,r=this.getDistanceFromCenterForValue(e.reverse?this.min:this.max),l=this.getPointPosition(a,r),t.beginPath(),t.moveTo(this.xCenter,this.yCenter),t.lineTo(l.x,l.y),t.stroke())}t.restore()}}drawBorder(){}drawLabels(){const t=this.ctx,e=this.options,i=e.ticks;if(!i.display)return;const s=this.getIndexAngle(0);let n,o;t.save(),t.translate(this.xCenter,this.yCenter),t.rotate(s),t.textAlign="center",t.textBaseline="middle",this.ticks.forEach(((s,a)=>{if(0===a&&this.min>=0&&!e.reverse)return;const r=i.setContext(this.getContext(a)),l=Si(r.font);if(n=this.getDistanceFromCenterForValue(this.ticks[a].value),r.showLabelBackdrop){t.font=l.string,o=t.measureText(s.label).width,t.fillStyle=r.backdropColor;const e=ki(r.backdropPadding);t.fillRect(-o/2-e.left,-n-l.size/2-e.top,o+e.width,l.size+e.height)}Ne(t,s.label,0,-n,l,{color:r.color,strokeColor:r.textStrokeColor,strokeWidth:r.textStrokeWidth})})),t.restore()}drawTitle(){}}const Io={millisecond:{common:!0,size:1,steps:1e3},second:{common:!0,size:1e3,steps:60},minute:{common:!0,size:6e4,steps:60},hour:{common:!0,size:36e5,steps:24},day:{common:!0,size:864e5,steps:30},week:{common:!1,size:6048e5,steps:4},month:{common:!0,size:2628e6,steps:12},quarter:{common:!1,size:7884e6,steps:4},year:{common:!0,size:3154e7}},zo=Object.keys(Io);function Fo(t,e){return t-e}function Vo(t,e){if(s(e))return null;const i=t._adapter,{parser:n,round:o,isoWeekday:r}=t._parseOpts;let l=e;return"function"==typeof n&&(l=n(l)),a(l)||(l="string"==typeof n?i.parse(l,n):i.parse(l)),null===l?null:(o&&(l="week"!==o||!N(r)&&!0!==r?i.startOf(l,o):i.startOf(l,"isoWeek",r)),+l)}function Bo(t,e,i,s){const n=zo.length;for(let o=zo.indexOf(t);o<n-1;++o){const t=Io[zo[o]],n=t.steps?t.steps:Number.MAX_SAFE_INTEGER;if(t.common&&Math.ceil((i-e)/(n*t.size))<=s)return zo[o]}return zo[n-1]}function Wo(t,e,i){if(i){if(i.length){const{lo:s,hi:n}=et(i,e);t[i[s]>=e?i[s]:i[n]]=!0}}else t[e]=!0}function No(t,e,i){const s=[],n={},o=e.length;let a,r;for(a=0;a<o;++a)r=e[a],n[r]=a,s.push({value:r,major:!1});return 0!==o&&i?function(t,e,i,s){const n=t._adapter,o=+n.startOf(e[0].value,s),a=e[e.length-1].value;let r,l;for(r=o;r<=a;r=+n.add(r,1,s))l=i[r],l>=0&&(e[l].major=!0);return e}(t,s,n,i):s}class Ho extends tn{static id="time";static defaults={bounds:"data",adapters:{},time:{parser:!1,unit:!1,round:!1,isoWeekday:!1,minUnit:"millisecond",displayFormats:{}},ticks:{source:"auto",callback:!1,major:{enabled:!1}}};constructor(t){super(t),this._cache={data:[],labels:[],all:[]},this._unit="day",this._majorUnit=void 0,this._offsets={},this._normalized=!1,this._parseOpts=void 0}init(t,e={}){const i=t.time||(t.time={}),s=this._adapter=new In._date(t.adapters.date);s.init(e),b(i.displayFormats,s.formats()),this._parseOpts={parser:i.parser,round:i.round,isoWeekday:i.isoWeekday},super.init(t),this._normalized=e.normalized}parse(t,e){return void 0===t?null:Vo(this,t)}beforeLayout(){super.beforeLayout(),this._cache={data:[],labels:[],all:[]}}determineDataLimits(){const t=this.options,e=this._adapter,i=t.time.unit||"day";let{min:s,max:n,minDefined:o,maxDefined:r}=this.getUserBounds();function l(t){o||isNaN(t.min)||(s=Math.min(s,t.min)),r||isNaN(t.max)||(n=Math.max(n,t.max))}o&&r||(l(this._getLabelBounds()),"ticks"===t.bounds&&"labels"===t.ticks.source||l(this.getMinMax(!1))),s=a(s)&&!isNaN(s)?s:+e.startOf(Date.now(),i),n=a(n)&&!isNaN(n)?n:+e.endOf(Date.now(),i)+1,this.min=Math.min(s,n-1),this.max=Math.max(s+1,n)}_getLabelBounds(){const t=this.getLabelTimestamps();let e=Number.POSITIVE_INFINITY,i=Number.NEGATIVE_INFINITY;return t.length&&(e=t[0],i=t[t.length-1]),{min:e,max:i}}buildTicks(){const t=this.options,e=t.time,i=t.ticks,s="labels"===i.source?this.getLabelTimestamps():this._generate();"ticks"===t.bounds&&s.length&&(this.min=this._userMin||s[0],this.max=this._userMax||s[s.length-1]);const n=this.min,o=nt(s,n,this.max);return this._unit=e.unit||(i.autoSkip?Bo(e.minUnit,this.min,this.max,this._getLabelCapacity(n)):function(t,e,i,s,n){for(let o=zo.length-1;o>=zo.indexOf(i);o--){const i=zo[o];if(Io[i].common&&t._adapter.diff(n,s,i)>=e-1)return i}return zo[i?zo.indexOf(i):0]}(this,o.length,e.minUnit,this.min,this.max)),this._majorUnit=i.major.enabled&&"year"!==this._unit?function(t){for(let e=zo.indexOf(t)+1,i=zo.length;e<i;++e)if(Io[zo[e]].common)return zo[e]}(this._unit):void 0,this.initOffsets(s),t.reverse&&o.reverse(),No(this,o,this._majorUnit)}afterAutoSkip(){this.options.offsetAfterAutoskip&&this.initOffsets(this.ticks.map((t=>+t.value)))}initOffsets(t=[]){let e,i,s=0,n=0;this.options.offset&&t.length&&(e=this.getDecimalForValue(t[0]),s=1===t.length?1-e:(this.getDecimalForValue(t[1])-e)/2,i=this.getDecimalForValue(t[t.length-1]),n=1===t.length?i:(i-this.getDecimalForValue(t[t.length-2]))/2);const o=t.length<3?.5:.25;s=Z(s,0,o),n=Z(n,0,o),this._offsets={start:s,end:n,factor:1/(s+1+n)}}_generate(){const t=this._adapter,e=this.min,i=this.max,s=this.options,n=s.time,o=n.unit||Bo(n.minUnit,e,i,this._getLabelCapacity(e)),a=l(s.ticks.stepSize,1),r="week"===o&&n.isoWeekday,h=N(r)||!0===r,c={};let d,u,f=e;if(h&&(f=+t.startOf(f,"isoWeek",r)),f=+t.startOf(f,h?"day":o),t.diff(i,e,o)>1e5*a)throw new Error(e+" and "+i+" are too far apart with stepSize of "+a+" "+o);const g="data"===s.ticks.source&&this.getDataTimestamps();for(d=f,u=0;d<i;d=+t.add(d,a,o),u++)Wo(c,d,g);return d!==i&&"ticks"!==s.bounds&&1!==u||Wo(c,d,g),Object.keys(c).sort(Fo).map((t=>+t))}getLabelForValue(t){const e=this._adapter,i=this.options.time;return i.tooltipFormat?e.format(t,i.tooltipFormat):e.format(t,i.displayFormats.datetime)}format(t,e){const i=this.options.time.displayFormats,s=this._unit,n=e||i[s];return this._adapter.format(t,n)}_tickFormatFunction(t,e,i,s){const n=this.options,o=n.ticks.callback;if(o)return d(o,[t,e,i],this);const a=n.time.displayFormats,r=this._unit,l=this._majorUnit,h=r&&a[r],c=l&&a[l],u=i[e],f=l&&c&&u&&u.major;return this._adapter.format(t,s||(f?c:h))}generateTickLabels(t){let e,i,s;for(e=0,i=t.length;e<i;++e)s=t[e],s.label=this._tickFormatFunction(s.value,e,t)}getDecimalForValue(t){return null===t?NaN:(t-this.min)/(this.max-this.min)}getPixelForValue(t){const e=this._offsets,i=this.getDecimalForValue(t);return this.getPixelForDecimal((e.start+i)*e.factor)}getValueForPixel(t){const e=this._offsets,i=this.getDecimalForPixel(t)/e.factor-e.end;return this.min+i*(this.max-this.min)}_getLabelSize(t){const e=this.options.ticks,i=this.ctx.measureText(t).width,s=$(this.isHorizontal()?e.maxRotation:e.minRotation),n=Math.cos(s),o=Math.sin(s),a=this._resolveTickFontOptions(0).size;return{w:i*n+a*o,h:i*o+a*n}}_getLabelCapacity(t){const e=this.options.time,i=e.displayFormats,s=i[e.unit]||i.millisecond,n=this._tickFormatFunction(t,0,No(this,[t],this._majorUnit),s),o=this._getLabelSize(n),a=Math.floor(this.isHorizontal()?this.width/o.w:this.height/o.h)-1;return a>0?a:1}getDataTimestamps(){let t,e,i=this._cache.data||[];if(i.length)return i;const s=this.getMatchingVisibleMetas();if(this._normalized&&s.length)return this._cache.data=s[0].controller.getAllParsedValues(this);for(t=0,e=s.length;t<e;++t)i=i.concat(s[t].controller.getAllParsedValues(this));return this._cache.data=this.normalize(i)}getLabelTimestamps(){const t=this._cache.labels||[];let e,i;if(t.length)return t;const s=this.getLabels();for(e=0,i=s.length;e<i;++e)t.push(Vo(this,s[e]));return this._cache.labels=this._normalized?t:this.normalize(t)}normalize(t){return lt(t.sort(Fo))}}function jo(t,e,i){let s,n,o,a,r=0,l=t.length-1;i?(e>=t[r].pos&&e<=t[l].pos&&({lo:r,hi:l}=it(t,"pos",e)),({pos:s,time:o}=t[r]),({pos:n,time:a}=t[l])):(e>=t[r].time&&e<=t[l].time&&({lo:r,hi:l}=it(t,"time",e)),({time:s,pos:o}=t[r]),({time:n,pos:a}=t[l]));const h=n-s;return h?o+(a-o)*(e-s)/h:o}var $o=Object.freeze({__proto__:null,CategoryScale:class extends tn{static id="category";static defaults={ticks:{callback:mo}};constructor(t){super(t),this._startValue=void 0,this._valueRange=0,this._addedLabels=[]}init(t){const e=this._addedLabels;if(e.length){const t=this.getLabels();for(const{index:i,label:s}of e)t[i]===s&&t.splice(i,1);this._addedLabels=[]}super.init(t)}parse(t,e){if(s(t))return null;const i=this.getLabels();return((t,e)=>null===t?null:Z(Math.round(t),0,e))(e=isFinite(e)&&i[e]===t?e:po(i,t,l(e,t),this._addedLabels),i.length-1)}determineDataLimits(){const{minDefined:t,maxDefined:e}=this.getUserBounds();let{min:i,max:s}=this.getMinMax(!0);"ticks"===this.options.bounds&&(t||(i=0),e||(s=this.getLabels().length-1)),this.min=i,this.max=s}buildTicks(){const t=this.min,e=this.max,i=this.options.offset,s=[];let n=this.getLabels();n=0===t&&e===n.length-1?n:n.slice(t,e+1),this._valueRange=Math.max(n.length-(i?0:1),1),this._startValue=this.min-(i?.5:0);for(let i=t;i<=e;i++)s.push({value:i});return s}getLabelForValue(t){return mo.call(this,t)}configure(){super.configure(),this.isHorizontal()||(this._reversePixels=!this._reversePixels)}getPixelForValue(t){return"number"!=typeof t&&(t=this.parse(t)),null===t?NaN:this.getPixelForDecimal((t-this._startValue)/this._valueRange)}getPixelForTick(t){const e=this.ticks;return t<0||t>e.length-1?null:this.getPixelForValue(e[t].value)}getValueForPixel(t){return Math.round(this._startValue+this.getDecimalForPixel(t)*this._valueRange)}getBasePixel(){return this.bottom}},LinearScale:_o,LogarithmicScale:So,RadialLinearScale:Ro,TimeScale:Ho,TimeSeriesScale:class extends Ho{static id="timeseries";static defaults=Ho.defaults;constructor(t){super(t),this._table=[],this._minPos=void 0,this._tableRange=void 0}initOffsets(){const t=this._getTimestampsForTable(),e=this._table=this.buildLookupTable(t);this._minPos=jo(e,this.min),this._tableRange=jo(e,this.max)-this._minPos,super.initOffsets(t)}buildLookupTable(t){const{min:e,max:i}=this,s=[],n=[];let o,a,r,l,h;for(o=0,a=t.length;o<a;++o)l=t[o],l>=e&&l<=i&&s.push(l);if(s.length<2)return[{time:e,pos:0},{time:i,pos:1}];for(o=0,a=s.length;o<a;++o)h=s[o+1],r=s[o-1],l=s[o],Math.round((h+r)/2)!==l&&n.push({time:l,pos:o/(a-1)});return n}_generate(){const t=this.min,e=this.max;let i=super.getDataTimestamps();return i.includes(t)&&i.length||i.splice(0,0,t),i.includes(e)&&1!==i.length||i.push(e),i.sort(((t,e)=>t-e))}_getTimestampsForTable(){let t=this._cache.all||[];if(t.length)return t;const e=this.getDataTimestamps(),i=this.getLabelTimestamps();return t=e.length&&i.length?this.normalize(e.concat(i)):e.length?e:i,t=this._cache.all=t,t}getDecimalForValue(t){return(jo(this._table,t)-this._minPos)/this._tableRange}getValueForPixel(t){const e=this._offsets,i=this.getDecimalForPixel(t)/e.factor-e.end;return jo(this._table,i*this._tableRange+this._minPos,!0)}}});const Yo=["rgb(54, 162, 235)","rgb(255, 99, 132)","rgb(255, 159, 64)","rgb(255, 205, 86)","rgb(75, 192, 192)","rgb(153, 102, 255)","rgb(201, 203, 207)"],Uo=Yo.map((t=>t.replace("rgb(","rgba(").replace(")",", 0.5)")));function Xo(t){return Yo[t%Yo.length]}function qo(t){return Uo[t%Uo.length]}function Ko(t){let e=0;return(i,s)=>{const n=t.getDatasetMeta(s).controller;n instanceof $n?e=function(t,e){return t.backgroundColor=t.data.map((()=>Xo(e++))),e}(i,e):n instanceof Yn?e=function(t,e){return t.backgroundColor=t.data.map((()=>qo(e++))),e}(i,e):n&&(e=function(t,e){return t.borderColor=Xo(e),t.backgroundColor=qo(e),++e}(i,e))}}function Go(t){let e;for(e in t)if(t[e].borderColor||t[e].backgroundColor)return!0;return!1}var Jo={id:"colors",defaults:{enabled:!0,forceOverride:!1},beforeLayout(t,e,i){if(!i.enabled)return;const{data:{datasets:s},options:n}=t.config,{elements:o}=n,a=Go(s)||(r=n)&&(r.borderColor||r.backgroundColor)||o&&Go(o)||"rgba(0,0,0,0.1)"!==ue.borderColor||"rgba(0,0,0,0.1)"!==ue.backgroundColor;var r;if(!i.forceOverride&&a)return;const l=Ko(t);s.forEach(l)}};function Zo(t){if(t._decimated){const e=t._data;delete t._decimated,delete t._data,Object.defineProperty(t,"data",{configurable:!0,enumerable:!0,writable:!0,value:e})}}function Qo(t){t.data.datasets.forEach((t=>{Zo(t)}))}var ta={id:"decimation",defaults:{algorithm:"min-max",enabled:!1},beforeElementsUpdate:(t,e,i)=>{if(!i.enabled)return void Qo(t);const n=t.width;t.data.datasets.forEach(((e,o)=>{const{_data:a,indexAxis:r}=e,l=t.getDatasetMeta(o),h=a||e.data;if("y"===Pi([r,t.options.indexAxis]))return;if(!l.controller.supportsDecimation)return;const c=t.scales[l.xAxisID];if("linear"!==c.type&&"time"!==c.type)return;if(t.options.parsing)return;let{start:d,count:u}=function(t,e){const i=e.length;let s,n=0;const{iScale:o}=t,{min:a,max:r,minDefined:l,maxDefined:h}=o.getUserBounds();return l&&(n=Z(it(e,o.axis,a).lo,0,i-1)),s=h?Z(it(e,o.axis,r).hi+1,n,i)-n:i-n,{start:n,count:s}}(l,h);if(u<=(i.threshold||4*n))return void Zo(e);let f;switch(s(a)&&(e._data=h,delete e.data,Object.defineProperty(e,"data",{configurable:!0,enumerable:!0,get:function(){return this._decimated},set:function(t){this._data=t}})),i.algorithm){case"lttb":f=function(t,e,i,s,n){const o=n.samples||s;if(o>=i)return t.slice(e,e+i);const a=[],r=(i-2)/(o-2);let l=0;const h=e+i-1;let c,d,u,f,g,p=e;for(a[l++]=t[p],c=0;c<o-2;c++){let s,n=0,o=0;const h=Math.floor((c+1)*r)+1+e,m=Math.min(Math.floor((c+2)*r)+1,i)+e,x=m-h;for(s=h;s<m;s++)n+=t[s].x,o+=t[s].y;n/=x,o/=x;const b=Math.floor(c*r)+1+e,_=Math.min(Math.floor((c+1)*r)+1,i)+e,{x:y,y:v}=t[p];for(u=f=-1,s=b;s<_;s++)f=.5*Math.abs((y-n)*(t[s].y-v)-(y-t[s].x)*(o-v)),f>u&&(u=f,d=t[s],g=s);a[l++]=d,p=g}return a[l++]=t[h],a}(h,d,u,n,i);break;case"min-max":f=function(t,e,i,n){let o,a,r,l,h,c,d,u,f,g,p=0,m=0;const x=[],b=e+i-1,_=t[e].x,y=t[b].x-_;for(o=e;o<e+i;++o){a=t[o],r=(a.x-_)/y*n,l=a.y;const e=0|r;if(e===h)l<f?(f=l,c=o):l>g&&(g=l,d=o),p=(m*p+a.x)/++m;else{const i=o-1;if(!s(c)&&!s(d)){const e=Math.min(c,d),s=Math.max(c,d);e!==u&&e!==i&&x.push({...t[e],x:p}),s!==u&&s!==i&&x.push({...t[s],x:p})}o>0&&i!==u&&x.push(t[i]),x.push(a),h=e,m=0,f=g=l,c=d=u=o}}return x}(h,d,u,n);break;default:throw new Error(`Unsupported decimation algorithm '${i.algorithm}'`)}e._decimated=f}))},destroy(t){Qo(t)}};function ea(t,e,i,s){if(s)return;let n=e[t],o=i[t];return"angle"===t&&(n=G(n),o=G(o)),{property:t,start:n,end:o}}function ia(t,e,i){for(;e>t;e--){const t=i[e];if(!isNaN(t.x)&&!isNaN(t.y))break}return e}function sa(t,e,i,s){return t&&e?s(t[i],e[i]):t?t[i]:e?e[i]:0}function na(t,e){let i=[],s=!1;return n(t)?(s=!0,i=t):i=function(t,e){const{x:i=null,y:s=null}=t||{},n=e.points,o=[];return e.segments.forEach((({start:t,end:e})=>{e=ia(t,e,n);const a=n[t],r=n[e];null!==s?(o.push({x:a.x,y:s}),o.push({x:r.x,y:s})):null!==i&&(o.push({x:i,y:a.y}),o.push({x:i,y:r.y}))})),o}(t,e),i.length?new oo({points:i,options:{tension:0},_loop:s,_fullLoop:s}):null}function oa(t){return t&&!1!==t.fill}function aa(t,e,i){let s=t[e].fill;const n=[e];let o;if(!i)return s;for(;!1!==s&&-1===n.indexOf(s);){if(!a(s))return s;if(o=t[s],!o)return!1;if(o.visible)return s;n.push(s),s=o.fill}return!1}function ra(t,e,i){const s=function(t){const e=t.options,i=e.fill;let s=l(i&&i.target,i);void 0===s&&(s=!!e.backgroundColor);if(!1===s||null===s)return!1;if(!0===s)return"origin";return s}(t);if(o(s))return!isNaN(s.value)&&s;let n=parseFloat(s);return a(n)&&Math.floor(n)===n?function(t,e,i,s){"-"!==t&&"+"!==t||(i=e+i);if(i===e||i<0||i>=s)return!1;return i}(s[0],e,n,i):["origin","start","end","stack","shape"].indexOf(s)>=0&&s}function la(t,e,i){const s=[];for(let n=0;n<i.length;n++){const o=i[n],{first:a,last:r,point:l}=ha(o,e,"x");if(!(!l||a&&r))if(a)s.unshift(l);else if(t.push(l),!r)break}t.push(...s)}function ha(t,e,i){const s=t.interpolate(e,i);if(!s)return{};const n=s[i],o=t.segments,a=t.points;let r=!1,l=!1;for(let t=0;t<o.length;t++){const e=o[t],s=a[e.start][i],h=a[e.end][i];if(tt(n,s,h)){r=n===s,l=n===h;break}}return{first:r,last:l,point:s}}class ca{constructor(t){this.x=t.x,this.y=t.y,this.radius=t.radius}pathSegment(t,e,i){const{x:s,y:n,radius:o}=this;return e=e||{start:0,end:O},t.arc(s,n,o,e.end,e.start,!0),!i.bounds}interpolate(t){const{x:e,y:i,radius:s}=this,n=t.angle;return{x:e+Math.cos(n)*s,y:i+Math.sin(n)*s,angle:n}}}function da(t){const{chart:e,fill:i,line:s}=t;if(a(i))return function(t,e){const i=t.getDatasetMeta(e),s=i&&t.isDatasetVisible(e);return s?i.dataset:null}(e,i);if("stack"===i)return function(t){const{scale:e,index:i,line:s}=t,n=[],o=s.segments,a=s.points,r=function(t,e){const i=[],s=t.getMatchingVisibleMetas("line");for(let t=0;t<s.length;t++){const n=s[t];if(n.index===e)break;n.hidden||i.unshift(n.dataset)}return i}(e,i);r.push(na({x:null,y:e.bottom},s));for(let t=0;t<o.length;t++){const e=o[t];for(let t=e.start;t<=e.end;t++)la(n,a[t],r)}return new oo({points:n,options:{}})}(t);if("shape"===i)return!0;const n=function(t){const e=t.scale||{};if(e.getPointPositionForValue)return function(t){const{scale:e,fill:i}=t,s=e.options,n=e.getLabels().length,a=s.reverse?e.max:e.min,r=function(t,e,i){let s;return s="start"===t?i:"end"===t?e.options.reverse?e.min:e.max:o(t)?t.value:e.getBaseValue(),s}(i,e,a),l=[];if(s.grid.circular){const t=e.getPointPositionForValue(0,a);return new ca({x:t.x,y:t.y,radius:e.getDistanceFromCenterForValue(r)})}for(let t=0;t<n;++t)l.push(e.getPointPositionForValue(t,r));return l}(t);return function(t){const{scale:e={},fill:i}=t,s=function(t,e){let i=null;return"start"===t?i=e.bottom:"end"===t?i=e.top:o(t)?i=e.getPixelForValue(t.value):e.getBasePixel&&(i=e.getBasePixel()),i}(i,e);if(a(s)){const t=e.isHorizontal();return{x:t?s:null,y:t?null:s}}return null}(t)}(t);return n instanceof ca?n:na(n,s)}function ua(t,e,i){const s=da(e),{chart:n,index:o,line:a,scale:r,axis:l}=e,h=a.options,c=h.fill,d=h.backgroundColor,{above:u=d,below:f=d}=c||{},g=n.getDatasetMeta(o),p=Ni(n,g);s&&a.points.length&&(Ie(t,i),function(t,e){const{line:i,target:s,above:n,below:o,area:a,scale:r,clip:l}=e,h=i._loop?"angle":e.axis;t.save();let c=o;o!==n&&("x"===h?(fa(t,s,a.top),pa(t,{line:i,target:s,color:n,scale:r,property:h,clip:l}),t.restore(),t.save(),fa(t,s,a.bottom)):"y"===h&&(ga(t,s,a.left),pa(t,{line:i,target:s,color:o,scale:r,property:h,clip:l}),t.restore(),t.save(),ga(t,s,a.right),c=n));pa(t,{line:i,target:s,color:c,scale:r,property:h,clip:l}),t.restore()}(t,{line:a,target:s,above:u,below:f,area:i,scale:r,axis:l,clip:p}),ze(t))}function fa(t,e,i){const{segments:s,points:n}=e;let o=!0,a=!1;t.beginPath();for(const r of s){const{start:s,end:l}=r,h=n[s],c=n[ia(s,l,n)];o?(t.moveTo(h.x,h.y),o=!1):(t.lineTo(h.x,i),t.lineTo(h.x,h.y)),a=!!e.pathSegment(t,r,{move:a}),a?t.closePath():t.lineTo(c.x,i)}t.lineTo(e.first().x,i),t.closePath(),t.clip()}function ga(t,e,i){const{segments:s,points:n}=e;let o=!0,a=!1;t.beginPath();for(const r of s){const{start:s,end:l}=r,h=n[s],c=n[ia(s,l,n)];o?(t.moveTo(h.x,h.y),o=!1):(t.lineTo(i,h.y),t.lineTo(h.x,h.y)),a=!!e.pathSegment(t,r,{move:a}),a?t.closePath():t.lineTo(i,c.y)}t.lineTo(i,e.first().y),t.closePath(),t.clip()}function pa(t,e){const{line:i,target:s,property:n,color:o,scale:a,clip:r}=e,l=function(t,e,i){const s=t.segments,n=t.points,o=e.points,a=[];for(const t of s){let{start:s,end:r}=t;r=ia(s,r,n);const l=ea(i,n[s],n[r],t.loop);if(!e.segments){a.push({source:t,target:l,start:n[s],end:n[r]});continue}const h=Ii(e,l);for(const e of h){const s=ea(i,o[e.start],o[e.end],e.loop),r=Ri(t,n,s);for(const t of r)a.push({source:t,target:e,start:{[i]:sa(l,s,"start",Math.max)},end:{[i]:sa(l,s,"end",Math.min)}})}}return a}(i,s,n);for(const{source:e,target:h,start:c,end:d}of l){const{style:{backgroundColor:l=o}={}}=e,u=!0!==s;t.save(),t.fillStyle=l,ma(t,a,r,u&&ea(n,c,d)),t.beginPath();const f=!!i.pathSegment(t,e);let g;if(u){f?t.closePath():xa(t,s,d,n);const e=!!s.pathSegment(t,h,{move:f,reverse:!0});g=f&&e,g||xa(t,s,c,n)}t.closePath(),t.fill(g?"evenodd":"nonzero"),t.restore()}}function ma(t,e,i,s){const n=e.chart.chartArea,{property:o,start:a,end:r}=s||{};if("x"===o||"y"===o){let e,s,l,h;"x"===o?(e=a,s=n.top,l=r,h=n.bottom):(e=n.left,s=a,l=n.right,h=r),t.beginPath(),i&&(e=Math.max(e,i.left),l=Math.min(l,i.right),s=Math.max(s,i.top),h=Math.min(h,i.bottom)),t.rect(e,s,l-e,h-s),t.clip()}}function xa(t,e,i,s){const n=e.interpolate(i,s);n&&t.lineTo(n.x,n.y)}var ba={id:"filler",afterDatasetsUpdate(t,e,i){const s=(t.data.datasets||[]).length,n=[];let o,a,r,l;for(a=0;a<s;++a)o=t.getDatasetMeta(a),r=o.dataset,l=null,r&&r.options&&r instanceof oo&&(l={visible:t.isDatasetVisible(a),index:a,fill:ra(r,a,s),chart:t,axis:o.controller.options.indexAxis,scale:o.vScale,line:r}),o.$filler=l,n.push(l);for(a=0;a<s;++a)l=n[a],l&&!1!==l.fill&&(l.fill=aa(n,a,i.propagate))},beforeDraw(t,e,i){const s="beforeDraw"===i.drawTime,n=t.getSortedVisibleDatasetMetas(),o=t.chartArea;for(let e=n.length-1;e>=0;--e){const i=n[e].$filler;i&&(i.line.updateControlPoints(o,i.axis),s&&i.fill&&ua(t.ctx,i,o))}},beforeDatasetsDraw(t,e,i){if("beforeDatasetsDraw"!==i.drawTime)return;const s=t.getSortedVisibleDatasetMetas();for(let e=s.length-1;e>=0;--e){const i=s[e].$filler;oa(i)&&ua(t.ctx,i,t.chartArea)}},beforeDatasetDraw(t,e,i){const s=e.meta.$filler;oa(s)&&"beforeDatasetDraw"===i.drawTime&&ua(t.ctx,s,t.chartArea)},defaults:{propagate:!0,drawTime:"beforeDatasetDraw"}};const _a=(t,e)=>{let{boxHeight:i=e,boxWidth:s=e}=t;return t.usePointStyle&&(i=Math.min(i,e),s=t.pointStyleWidth||Math.min(s,e)),{boxWidth:s,boxHeight:i,itemHeight:Math.max(e,i)}};class ya extends $s{constructor(t){super(),this._added=!1,this.legendHitBoxes=[],this._hoveredItem=null,this.doughnutMode=!1,this.chart=t.chart,this.options=t.options,this.ctx=t.ctx,this.legendItems=void 0,this.columnSizes=void 0,this.lineWidths=void 0,this.maxHeight=void 0,this.maxWidth=void 0,this.top=void 0,this.bottom=void 0,this.left=void 0,this.right=void 0,this.height=void 0,this.width=void 0,this._margins=void 0,this.position=void 0,this.weight=void 0,this.fullSize=void 0}update(t,e,i){this.maxWidth=t,this.maxHeight=e,this._margins=i,this.setDimensions(),this.buildLabels(),this.fit()}setDimensions(){this.isHorizontal()?(this.width=this.maxWidth,this.left=this._margins.left,this.right=this.width):(this.height=this.maxHeight,this.top=this._margins.top,this.bottom=this.height)}buildLabels(){const t=this.options.labels||{};let e=d(t.generateLabels,[this.chart],this)||[];t.filter&&(e=e.filter((e=>t.filter(e,this.chart.data)))),t.sort&&(e=e.sort(((e,i)=>t.sort(e,i,this.chart.data)))),this.options.reverse&&e.reverse(),this.legendItems=e}fit(){const{options:t,ctx:e}=this;if(!t.display)return void(this.width=this.height=0);const i=t.labels,s=Si(i.font),n=s.size,o=this._computeTitleHeight(),{boxWidth:a,itemHeight:r}=_a(i,n);let l,h;e.font=s.string,this.isHorizontal()?(l=this.maxWidth,h=this._fitRows(o,n,a,r)+10):(h=this.maxHeight,l=this._fitCols(o,s,a,r)+10),this.width=Math.min(l,t.maxWidth||this.maxWidth),this.height=Math.min(h,t.maxHeight||this.maxHeight)}_fitRows(t,e,i,s){const{ctx:n,maxWidth:o,options:{labels:{padding:a}}}=this,r=this.legendHitBoxes=[],l=this.lineWidths=[0],h=s+a;let c=t;n.textAlign="left",n.textBaseline="middle";let d=-1,u=-h;return this.legendItems.forEach(((t,f)=>{const g=i+e/2+n.measureText(t.text).width;(0===f||l[l.length-1]+g+2*a>o)&&(c+=h,l[l.length-(f>0?0:1)]=0,u+=h,d++),r[f]={left:0,top:u,row:d,width:g,height:s},l[l.length-1]+=g+a})),c}_fitCols(t,e,i,s){const{ctx:n,maxHeight:o,options:{labels:{padding:a}}}=this,r=this.legendHitBoxes=[],l=this.columnSizes=[],h=o-t;let c=a,d=0,u=0,f=0,g=0;return this.legendItems.forEach(((t,o)=>{const{itemWidth:p,itemHeight:m}=function(t,e,i,s,n){const o=function(t,e,i,s){let n=t.text;n&&"string"!=typeof n&&(n=n.reduce(((t,e)=>t.length>e.length?t:e)));return e+i.size/2+s.measureText(n).width}(s,t,e,i),a=function(t,e,i){let s=t;"string"!=typeof e.text&&(s=va(e,i));return s}(n,s,e.lineHeight);return{itemWidth:o,itemHeight:a}}(i,e,n,t,s);o>0&&u+m+2*a>h&&(c+=d+a,l.push({width:d,height:u}),f+=d+a,g++,d=u=0),r[o]={left:f,top:u,col:g,width:p,height:m},d=Math.max(d,p),u+=m+a})),c+=d,l.push({width:d,height:u}),c}adjustHitBoxes(){if(!this.options.display)return;const t=this._computeTitleHeight(),{legendHitBoxes:e,options:{align:i,labels:{padding:s},rtl:n}}=this,o=Oi(n,this.left,this.width);if(this.isHorizontal()){let n=0,a=ft(i,this.left+s,this.right-this.lineWidths[n]);for(const r of e)n!==r.row&&(n=r.row,a=ft(i,this.left+s,this.right-this.lineWidths[n])),r.top+=this.top+t+s,r.left=o.leftForLtr(o.x(a),r.width),a+=r.width+s}else{let n=0,a=ft(i,this.top+t+s,this.bottom-this.columnSizes[n].height);for(const r of e)r.col!==n&&(n=r.col,a=ft(i,this.top+t+s,this.bottom-this.columnSizes[n].height)),r.top=a,r.left+=this.left+s,r.left=o.leftForLtr(o.x(r.left),r.width),a+=r.height+s}}isHorizontal(){return"top"===this.options.position||"bottom"===this.options.position}draw(){if(this.options.display){const t=this.ctx;Ie(t,this),this._draw(),ze(t)}}_draw(){const{options:t,columnSizes:e,lineWidths:i,ctx:s}=this,{align:n,labels:o}=t,a=ue.color,r=Oi(t.rtl,this.left,this.width),h=Si(o.font),{padding:c}=o,d=h.size,u=d/2;let f;this.drawTitle(),s.textAlign=r.textAlign("left"),s.textBaseline="middle",s.lineWidth=.5,s.font=h.string;const{boxWidth:g,boxHeight:p,itemHeight:m}=_a(o,d),x=this.isHorizontal(),b=this._computeTitleHeight();f=x?{x:ft(n,this.left+c,this.right-i[0]),y:this.top+c+b,line:0}:{x:this.left+c,y:ft(n,this.top+b+c,this.bottom-e[0].height),line:0},Ai(this.ctx,t.textDirection);const _=m+c;this.legendItems.forEach(((y,v)=>{s.strokeStyle=y.fontColor,s.fillStyle=y.fontColor;const M=s.measureText(y.text).width,w=r.textAlign(y.textAlign||(y.textAlign=o.textAlign)),k=g+u+M;let S=f.x,P=f.y;r.setWidth(this.width),x?v>0&&S+k+c>this.right&&(P=f.y+=_,f.line++,S=f.x=ft(n,this.left+c,this.right-i[f.line])):v>0&&P+_>this.bottom&&(S=f.x=S+e[f.line].width+c,f.line++,P=f.y=ft(n,this.top+b+c,this.bottom-e[f.line].height));if(function(t,e,i){if(isNaN(g)||g<=0||isNaN(p)||p<0)return;s.save();const n=l(i.lineWidth,1);if(s.fillStyle=l(i.fillStyle,a),s.lineCap=l(i.lineCap,"butt"),s.lineDashOffset=l(i.lineDashOffset,0),s.lineJoin=l(i.lineJoin,"miter"),s.lineWidth=n,s.strokeStyle=l(i.strokeStyle,a),s.setLineDash(l(i.lineDash,[])),o.usePointStyle){const a={radius:p*Math.SQRT2/2,pointStyle:i.pointStyle,rotation:i.rotation,borderWidth:n},l=r.xPlus(t,g/2);Ee(s,a,l,e+u,o.pointStyleWidth&&g)}else{const o=e+Math.max((d-p)/2,0),a=r.leftForLtr(t,g),l=wi(i.borderRadius);s.beginPath(),Object.values(l).some((t=>0!==t))?He(s,{x:a,y:o,w:g,h:p,radius:l}):s.rect(a,o,g,p),s.fill(),0!==n&&s.stroke()}s.restore()}(r.x(S),P,y),S=gt(w,S+g+u,x?S+k:this.right,t.rtl),function(t,e,i){Ne(s,i.text,t,e+m/2,h,{strikethrough:i.hidden,textAlign:r.textAlign(i.textAlign)})}(r.x(S),P,y),x)f.x+=k+c;else if("string"!=typeof y.text){const t=h.lineHeight;f.y+=va(y,t)+c}else f.y+=_})),Ti(this.ctx,t.textDirection)}drawTitle(){const t=this.options,e=t.title,i=Si(e.font),s=ki(e.padding);if(!e.display)return;const n=Oi(t.rtl,this.left,this.width),o=this.ctx,a=e.position,r=i.size/2,l=s.top+r;let h,c=this.left,d=this.width;if(this.isHorizontal())d=Math.max(...this.lineWidths),h=this.top+l,c=ft(t.align,c,this.right-d);else{const e=this.columnSizes.reduce(((t,e)=>Math.max(t,e.height)),0);h=l+ft(t.align,this.top,this.bottom-e-t.labels.padding-this._computeTitleHeight())}const u=ft(a,c,c+d);o.textAlign=n.textAlign(ut(a)),o.textBaseline="middle",o.strokeStyle=e.color,o.fillStyle=e.color,o.font=i.string,Ne(o,e.text,u,h,i)}_computeTitleHeight(){const t=this.options.title,e=Si(t.font),i=ki(t.padding);return t.display?e.lineHeight+i.height:0}_getLegendItemAt(t,e){let i,s,n;if(tt(t,this.left,this.right)&&tt(e,this.top,this.bottom))for(n=this.legendHitBoxes,i=0;i<n.length;++i)if(s=n[i],tt(t,s.left,s.left+s.width)&&tt(e,s.top,s.top+s.height))return this.legendItems[i];return null}handleEvent(t){const e=this.options;if(!function(t,e){if(("mousemove"===t||"mouseout"===t)&&(e.onHover||e.onLeave))return!0;if(e.onClick&&("click"===t||"mouseup"===t))return!0;return!1}(t.type,e))return;const i=this._getLegendItemAt(t.x,t.y);if("mousemove"===t.type||"mouseout"===t.type){const o=this._hoveredItem,a=(n=i,null!==(s=o)&&null!==n&&s.datasetIndex===n.datasetIndex&&s.index===n.index);o&&!a&&d(e.onLeave,[t,o,this],this),this._hoveredItem=i,i&&!a&&d(e.onHover,[t,i,this],this)}else i&&d(e.onClick,[t,i,this],this);var s,n}}function va(t,e){return e*(t.text?t.text.length:0)}var Ma={id:"legend",_element:ya,start(t,e,i){const s=t.legend=new ya({ctx:t.ctx,options:i,chart:t});ls.configure(t,s,i),ls.addBox(t,s)},stop(t){ls.removeBox(t,t.legend),delete t.legend},beforeUpdate(t,e,i){const s=t.legend;ls.configure(t,s,i),s.options=i},afterUpdate(t){const e=t.legend;e.buildLabels(),e.adjustHitBoxes()},afterEvent(t,e){e.replay||t.legend.handleEvent(e.event)},defaults:{display:!0,position:"top",align:"center",fullSize:!0,reverse:!1,weight:1e3,onClick(t,e,i){const s=e.datasetIndex,n=i.chart;n.isDatasetVisible(s)?(n.hide(s),e.hidden=!0):(n.show(s),e.hidden=!1)},onHover:null,onLeave:null,labels:{color:t=>t.chart.options.color,boxWidth:40,padding:10,generateLabels(t){const e=t.data.datasets,{labels:{usePointStyle:i,pointStyle:s,textAlign:n,color:o,useBorderRadius:a,borderRadius:r}}=t.legend.options;return t._getSortedDatasetMetas().map((t=>{const l=t.controller.getStyle(i?0:void 0),h=ki(l.borderWidth);return{text:e[t.index].label,fillStyle:l.backgroundColor,fontColor:o,hidden:!t.visible,lineCap:l.borderCapStyle,lineDash:l.borderDash,lineDashOffset:l.borderDashOffset,lineJoin:l.borderJoinStyle,lineWidth:(h.width+h.height)/4,strokeStyle:l.borderColor,pointStyle:s||l.pointStyle,rotation:l.rotation,textAlign:n||l.textAlign,borderRadius:a&&(r||l.borderRadius),datasetIndex:t.index}}),this)}},title:{color:t=>t.chart.options.color,display:!1,position:"center",text:""}},descriptors:{_scriptable:t=>!t.startsWith("on"),labels:{_scriptable:t=>!["generateLabels","filter","sort"].includes(t)}}};class wa extends $s{constructor(t){super(),this.chart=t.chart,this.options=t.options,this.ctx=t.ctx,this._padding=void 0,this.top=void 0,this.bottom=void 0,this.left=void 0,this.right=void 0,this.width=void 0,this.height=void 0,this.position=void 0,this.weight=void 0,this.fullSize=void 0}update(t,e){const i=this.options;if(this.left=0,this.top=0,!i.display)return void(this.width=this.height=this.right=this.bottom=0);this.width=this.right=t,this.height=this.bottom=e;const s=n(i.text)?i.text.length:1;this._padding=ki(i.padding);const o=s*Si(i.font).lineHeight+this._padding.height;this.isHorizontal()?this.height=o:this.width=o}isHorizontal(){const t=this.options.position;return"top"===t||"bottom"===t}_drawArgs(t){const{top:e,left:i,bottom:s,right:n,options:o}=this,a=o.align;let r,l,h,c=0;return this.isHorizontal()?(l=ft(a,i,n),h=e+t,r=n-i):("left"===o.position?(l=i+t,h=ft(a,s,e),c=-.5*C):(l=n-t,h=ft(a,e,s),c=.5*C),r=s-e),{titleX:l,titleY:h,maxWidth:r,rotation:c}}draw(){const t=this.ctx,e=this.options;if(!e.display)return;const i=Si(e.font),s=i.lineHeight/2+this._padding.top,{titleX:n,titleY:o,maxWidth:a,rotation:r}=this._drawArgs(s);Ne(t,e.text,0,0,i,{color:e.color,maxWidth:a,rotation:r,textAlign:ut(e.align),textBaseline:"middle",translation:[n,o]})}}var ka={id:"title",_element:wa,start(t,e,i){!function(t,e){const i=new wa({ctx:t.ctx,options:e,chart:t});ls.configure(t,i,e),ls.addBox(t,i),t.titleBlock=i}(t,i)},stop(t){const e=t.titleBlock;ls.removeBox(t,e),delete t.titleBlock},beforeUpdate(t,e,i){const s=t.titleBlock;ls.configure(t,s,i),s.options=i},defaults:{align:"center",display:!1,font:{weight:"bold"},fullSize:!0,padding:10,position:"top",text:"",weight:2e3},defaultRoutes:{color:"color"},descriptors:{_scriptable:!0,_indexable:!1}};const Sa=new WeakMap;var Pa={id:"subtitle",start(t,e,i){const s=new wa({ctx:t.ctx,options:i,chart:t});ls.configure(t,s,i),ls.addBox(t,s),Sa.set(t,s)},stop(t){ls.removeBox(t,Sa.get(t)),Sa.delete(t)},beforeUpdate(t,e,i){const s=Sa.get(t);ls.configure(t,s,i),s.options=i},defaults:{align:"center",display:!1,font:{weight:"normal"},fullSize:!0,padding:0,position:"top",text:"",weight:1500},defaultRoutes:{color:"color"},descriptors:{_scriptable:!0,_indexable:!1}};const Da={average(t){if(!t.length)return!1;let e,i,s=new Set,n=0,o=0;for(e=0,i=t.length;e<i;++e){const i=t[e].element;if(i&&i.hasValue()){const t=i.tooltipPosition();s.add(t.x),n+=t.y,++o}}if(0===o||0===s.size)return!1;return{x:[...s].reduce(((t,e)=>t+e))/s.size,y:n/o}},nearest(t,e){if(!t.length)return!1;let i,s,n,o=e.x,a=e.y,r=Number.POSITIVE_INFINITY;for(i=0,s=t.length;i<s;++i){const s=t[i].element;if(s&&s.hasValue()){const t=q(e,s.getCenterPoint());t<r&&(r=t,n=s)}}if(n){const t=n.tooltipPosition();o=t.x,a=t.y}return{x:o,y:a}}};function Ca(t,e){return e&&(n(e)?Array.prototype.push.apply(t,e):t.push(e)),t}function Oa(t){return("string"==typeof t||t instanceof String)&&t.indexOf("\n")>-1?t.split("\n"):t}function Aa(t,e){const{element:i,datasetIndex:s,index:n}=e,o=t.getDatasetMeta(s).controller,{label:a,value:r}=o.getLabelAndValue(n);return{chart:t,label:a,parsed:o.getParsed(n),raw:t.data.datasets[s].data[n],formattedValue:r,dataset:o.getDataset(),dataIndex:n,datasetIndex:s,element:i}}function Ta(t,e){const i=t.chart.ctx,{body:s,footer:n,title:o}=t,{boxWidth:a,boxHeight:r}=e,l=Si(e.bodyFont),h=Si(e.titleFont),c=Si(e.footerFont),d=o.length,f=n.length,g=s.length,p=ki(e.padding);let m=p.height,x=0,b=s.reduce(((t,e)=>t+e.before.length+e.lines.length+e.after.length),0);if(b+=t.beforeBody.length+t.afterBody.length,d&&(m+=d*h.lineHeight+(d-1)*e.titleSpacing+e.titleMarginBottom),b){m+=g*(e.displayColors?Math.max(r,l.lineHeight):l.lineHeight)+(b-g)*l.lineHeight+(b-1)*e.bodySpacing}f&&(m+=e.footerMarginTop+f*c.lineHeight+(f-1)*e.footerSpacing);let _=0;const y=function(t){x=Math.max(x,i.measureText(t).width+_)};return i.save(),i.font=h.string,u(t.title,y),i.font=l.string,u(t.beforeBody.concat(t.afterBody),y),_=e.displayColors?a+2+e.boxPadding:0,u(s,(t=>{u(t.before,y),u(t.lines,y),u(t.after,y)})),_=0,i.font=c.string,u(t.footer,y),i.restore(),x+=p.width,{width:x,height:m}}function La(t,e,i,s){const{x:n,width:o}=i,{width:a,chartArea:{left:r,right:l}}=t;let h="center";return"center"===s?h=n<=(r+l)/2?"left":"right":n<=o/2?h="left":n>=a-o/2&&(h="right"),function(t,e,i,s){const{x:n,width:o}=s,a=i.caretSize+i.caretPadding;return"left"===t&&n+o+a>e.width||"right"===t&&n-o-a<0||void 0}(h,t,e,i)&&(h="center"),h}function Ea(t,e,i){const s=i.yAlign||e.yAlign||function(t,e){const{y:i,height:s}=e;return i<s/2?"top":i>t.height-s/2?"bottom":"center"}(t,i);return{xAlign:i.xAlign||e.xAlign||La(t,e,i,s),yAlign:s}}function Ra(t,e,i,s){const{caretSize:n,caretPadding:o,cornerRadius:a}=t,{xAlign:r,yAlign:l}=i,h=n+o,{topLeft:c,topRight:d,bottomLeft:u,bottomRight:f}=wi(a);let g=function(t,e){let{x:i,width:s}=t;return"right"===e?i-=s:"center"===e&&(i-=s/2),i}(e,r);const p=function(t,e,i){let{y:s,height:n}=t;return"top"===e?s+=i:s-="bottom"===e?n+i:n/2,s}(e,l,h);return"center"===l?"left"===r?g+=h:"right"===r&&(g-=h):"left"===r?g-=Math.max(c,u)+n:"right"===r&&(g+=Math.max(d,f)+n),{x:Z(g,0,s.width-e.width),y:Z(p,0,s.height-e.height)}}function Ia(t,e,i){const s=ki(i.padding);return"center"===e?t.x+t.width/2:"right"===e?t.x+t.width-s.right:t.x+s.left}function za(t){return Ca([],Oa(t))}function Fa(t,e){const i=e&&e.dataset&&e.dataset.tooltip&&e.dataset.tooltip.callbacks;return i?t.override(i):t}const Va={beforeTitle:e,title(t){if(t.length>0){const e=t[0],i=e.chart.data.labels,s=i?i.length:0;if(this&&this.options&&"dataset"===this.options.mode)return e.dataset.label||"";if(e.label)return e.label;if(s>0&&e.dataIndex<s)return i[e.dataIndex]}return""},afterTitle:e,beforeBody:e,beforeLabel:e,label(t){if(this&&this.options&&"dataset"===this.options.mode)return t.label+": "+t.formattedValue||t.formattedValue;let e=t.dataset.label||"";e&&(e+=": ");const i=t.formattedValue;return s(i)||(e+=i),e},labelColor(t){const e=t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);return{borderColor:e.borderColor,backgroundColor:e.backgroundColor,borderWidth:e.borderWidth,borderDash:e.borderDash,borderDashOffset:e.borderDashOffset,borderRadius:0}},labelTextColor(){return this.options.bodyColor},labelPointStyle(t){const e=t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);return{pointStyle:e.pointStyle,rotation:e.rotation}},afterLabel:e,afterBody:e,beforeFooter:e,footer:e,afterFooter:e};function Ba(t,e,i,s){const n=t[e].call(i,s);return void 0===n?Va[e].call(i,s):n}class Wa extends $s{static positioners=Da;constructor(t){super(),this.opacity=0,this._active=[],this._eventPosition=void 0,this._size=void 0,this._cachedAnimations=void 0,this._tooltipItems=[],this.$animations=void 0,this.$context=void 0,this.chart=t.chart,this.options=t.options,this.dataPoints=void 0,this.title=void 0,this.beforeBody=void 0,this.body=void 0,this.afterBody=void 0,this.footer=void 0,this.xAlign=void 0,this.yAlign=void 0,this.x=void 0,this.y=void 0,this.height=void 0,this.width=void 0,this.caretX=void 0,this.caretY=void 0,this.labelColors=void 0,this.labelPointStyles=void 0,this.labelTextColors=void 0}initialize(t){this.options=t,this._cachedAnimations=void 0,this.$context=void 0}_resolveAnimations(){const t=this._cachedAnimations;if(t)return t;const e=this.chart,i=this.options.setContext(this.getContext()),s=i.enabled&&e.options.animation&&i.animations,n=new Ts(this.chart,s);return s._cacheable&&(this._cachedAnimations=Object.freeze(n)),n}getContext(){return this.$context||(this.$context=(t=this.chart.getContext(),e=this,i=this._tooltipItems,Ci(t,{tooltip:e,tooltipItems:i,type:"tooltip"})));var t,e,i}getTitle(t,e){const{callbacks:i}=e,s=Ba(i,"beforeTitle",this,t),n=Ba(i,"title",this,t),o=Ba(i,"afterTitle",this,t);let a=[];return a=Ca(a,Oa(s)),a=Ca(a,Oa(n)),a=Ca(a,Oa(o)),a}getBeforeBody(t,e){return za(Ba(e.callbacks,"beforeBody",this,t))}getBody(t,e){const{callbacks:i}=e,s=[];return u(t,(t=>{const e={before:[],lines:[],after:[]},n=Fa(i,t);Ca(e.before,Oa(Ba(n,"beforeLabel",this,t))),Ca(e.lines,Ba(n,"label",this,t)),Ca(e.after,Oa(Ba(n,"afterLabel",this,t))),s.push(e)})),s}getAfterBody(t,e){return za(Ba(e.callbacks,"afterBody",this,t))}getFooter(t,e){const{callbacks:i}=e,s=Ba(i,"beforeFooter",this,t),n=Ba(i,"footer",this,t),o=Ba(i,"afterFooter",this,t);let a=[];return a=Ca(a,Oa(s)),a=Ca(a,Oa(n)),a=Ca(a,Oa(o)),a}_createItems(t){const e=this._active,i=this.chart.data,s=[],n=[],o=[];let a,r,l=[];for(a=0,r=e.length;a<r;++a)l.push(Aa(this.chart,e[a]));return t.filter&&(l=l.filter(((e,s,n)=>t.filter(e,s,n,i)))),t.itemSort&&(l=l.sort(((e,s)=>t.itemSort(e,s,i)))),u(l,(e=>{const i=Fa(t.callbacks,e);s.push(Ba(i,"labelColor",this,e)),n.push(Ba(i,"labelPointStyle",this,e)),o.push(Ba(i,"labelTextColor",this,e))})),this.labelColors=s,this.labelPointStyles=n,this.labelTextColors=o,this.dataPoints=l,l}update(t,e){const i=this.options.setContext(this.getContext()),s=this._active;let n,o=[];if(s.length){const t=Da[i.position].call(this,s,this._eventPosition);o=this._createItems(i),this.title=this.getTitle(o,i),this.beforeBody=this.getBeforeBody(o,i),this.body=this.getBody(o,i),this.afterBody=this.getAfterBody(o,i),this.footer=this.getFooter(o,i);const e=this._size=Ta(this,i),a=Object.assign({},t,e),r=Ea(this.chart,i,a),l=Ra(i,a,r,this.chart);this.xAlign=r.xAlign,this.yAlign=r.yAlign,n={opacity:1,x:l.x,y:l.y,width:e.width,height:e.height,caretX:t.x,caretY:t.y}}else 0!==this.opacity&&(n={opacity:0});this._tooltipItems=o,this.$context=void 0,n&&this._resolveAnimations().update(this,n),t&&i.external&&i.external.call(this,{chart:this.chart,tooltip:this,replay:e})}drawCaret(t,e,i,s){const n=this.getCaretPosition(t,i,s);e.lineTo(n.x1,n.y1),e.lineTo(n.x2,n.y2),e.lineTo(n.x3,n.y3)}getCaretPosition(t,e,i){const{xAlign:s,yAlign:n}=this,{caretSize:o,cornerRadius:a}=i,{topLeft:r,topRight:l,bottomLeft:h,bottomRight:c}=wi(a),{x:d,y:u}=t,{width:f,height:g}=e;let p,m,x,b,_,y;return"center"===n?(_=u+g/2,"left"===s?(p=d,m=p-o,b=_+o,y=_-o):(p=d+f,m=p+o,b=_-o,y=_+o),x=p):(m="left"===s?d+Math.max(r,h)+o:"right"===s?d+f-Math.max(l,c)-o:this.caretX,"top"===n?(b=u,_=b-o,p=m-o,x=m+o):(b=u+g,_=b+o,p=m+o,x=m-o),y=b),{x1:p,x2:m,x3:x,y1:b,y2:_,y3:y}}drawTitle(t,e,i){const s=this.title,n=s.length;let o,a,r;if(n){const l=Oi(i.rtl,this.x,this.width);for(t.x=Ia(this,i.titleAlign,i),e.textAlign=l.textAlign(i.titleAlign),e.textBaseline="middle",o=Si(i.titleFont),a=i.titleSpacing,e.fillStyle=i.titleColor,e.font=o.string,r=0;r<n;++r)e.fillText(s[r],l.x(t.x),t.y+o.lineHeight/2),t.y+=o.lineHeight+a,r+1===n&&(t.y+=i.titleMarginBottom-a)}}_drawColorBox(t,e,i,s,n){const a=this.labelColors[i],r=this.labelPointStyles[i],{boxHeight:l,boxWidth:h}=n,c=Si(n.bodyFont),d=Ia(this,"left",n),u=s.x(d),f=l<c.lineHeight?(c.lineHeight-l)/2:0,g=e.y+f;if(n.usePointStyle){const e={radius:Math.min(h,l)/2,pointStyle:r.pointStyle,rotation:r.rotation,borderWidth:1},i=s.leftForLtr(u,h)+h/2,o=g+l/2;t.strokeStyle=n.multiKeyBackground,t.fillStyle=n.multiKeyBackground,Le(t,e,i,o),t.strokeStyle=a.borderColor,t.fillStyle=a.backgroundColor,Le(t,e,i,o)}else{t.lineWidth=o(a.borderWidth)?Math.max(...Object.values(a.borderWidth)):a.borderWidth||1,t.strokeStyle=a.borderColor,t.setLineDash(a.borderDash||[]),t.lineDashOffset=a.borderDashOffset||0;const e=s.leftForLtr(u,h),i=s.leftForLtr(s.xPlus(u,1),h-2),r=wi(a.borderRadius);Object.values(r).some((t=>0!==t))?(t.beginPath(),t.fillStyle=n.multiKeyBackground,He(t,{x:e,y:g,w:h,h:l,radius:r}),t.fill(),t.stroke(),t.fillStyle=a.backgroundColor,t.beginPath(),He(t,{x:i,y:g+1,w:h-2,h:l-2,radius:r}),t.fill()):(t.fillStyle=n.multiKeyBackground,t.fillRect(e,g,h,l),t.strokeRect(e,g,h,l),t.fillStyle=a.backgroundColor,t.fillRect(i,g+1,h-2,l-2))}t.fillStyle=this.labelTextColors[i]}drawBody(t,e,i){const{body:s}=this,{bodySpacing:n,bodyAlign:o,displayColors:a,boxHeight:r,boxWidth:l,boxPadding:h}=i,c=Si(i.bodyFont);let d=c.lineHeight,f=0;const g=Oi(i.rtl,this.x,this.width),p=function(i){e.fillText(i,g.x(t.x+f),t.y+d/2),t.y+=d+n},m=g.textAlign(o);let x,b,_,y,v,M,w;for(e.textAlign=o,e.textBaseline="middle",e.font=c.string,t.x=Ia(this,m,i),e.fillStyle=i.bodyColor,u(this.beforeBody,p),f=a&&"right"!==m?"center"===o?l/2+h:l+2+h:0,y=0,M=s.length;y<M;++y){for(x=s[y],b=this.labelTextColors[y],e.fillStyle=b,u(x.before,p),_=x.lines,a&&_.length&&(this._drawColorBox(e,t,y,g,i),d=Math.max(c.lineHeight,r)),v=0,w=_.length;v<w;++v)p(_[v]),d=c.lineHeight;u(x.after,p)}f=0,d=c.lineHeight,u(this.afterBody,p),t.y-=n}drawFooter(t,e,i){const s=this.footer,n=s.length;let o,a;if(n){const r=Oi(i.rtl,this.x,this.width);for(t.x=Ia(this,i.footerAlign,i),t.y+=i.footerMarginTop,e.textAlign=r.textAlign(i.footerAlign),e.textBaseline="middle",o=Si(i.footerFont),e.fillStyle=i.footerColor,e.font=o.string,a=0;a<n;++a)e.fillText(s[a],r.x(t.x),t.y+o.lineHeight/2),t.y+=o.lineHeight+i.footerSpacing}}drawBackground(t,e,i,s){const{xAlign:n,yAlign:o}=this,{x:a,y:r}=t,{width:l,height:h}=i,{topLeft:c,topRight:d,bottomLeft:u,bottomRight:f}=wi(s.cornerRadius);e.fillStyle=s.backgroundColor,e.strokeStyle=s.borderColor,e.lineWidth=s.borderWidth,e.beginPath(),e.moveTo(a+c,r),"top"===o&&this.drawCaret(t,e,i,s),e.lineTo(a+l-d,r),e.quadraticCurveTo(a+l,r,a+l,r+d),"center"===o&&"right"===n&&this.drawCaret(t,e,i,s),e.lineTo(a+l,r+h-f),e.quadraticCurveTo(a+l,r+h,a+l-f,r+h),"bottom"===o&&this.drawCaret(t,e,i,s),e.lineTo(a+u,r+h),e.quadraticCurveTo(a,r+h,a,r+h-u),"center"===o&&"left"===n&&this.drawCaret(t,e,i,s),e.lineTo(a,r+c),e.quadraticCurveTo(a,r,a+c,r),e.closePath(),e.fill(),s.borderWidth>0&&e.stroke()}_updateAnimationTarget(t){const e=this.chart,i=this.$animations,s=i&&i.x,n=i&&i.y;if(s||n){const i=Da[t.position].call(this,this._active,this._eventPosition);if(!i)return;const o=this._size=Ta(this,t),a=Object.assign({},i,this._size),r=Ea(e,t,a),l=Ra(t,a,r,e);s._to===l.x&&n._to===l.y||(this.xAlign=r.xAlign,this.yAlign=r.yAlign,this.width=o.width,this.height=o.height,this.caretX=i.x,this.caretY=i.y,this._resolveAnimations().update(this,l))}}_willRender(){return!!this.opacity}draw(t){const e=this.options.setContext(this.getContext());let i=this.opacity;if(!i)return;this._updateAnimationTarget(e);const s={width:this.width,height:this.height},n={x:this.x,y:this.y};i=Math.abs(i)<.001?0:i;const o=ki(e.padding),a=this.title.length||this.beforeBody.length||this.body.length||this.afterBody.length||this.footer.length;e.enabled&&a&&(t.save(),t.globalAlpha=i,this.drawBackground(n,t,s,e),Ai(t,e.textDirection),n.y+=o.top,this.drawTitle(n,t,e),this.drawBody(n,t,e),this.drawFooter(n,t,e),Ti(t,e.textDirection),t.restore())}getActiveElements(){return this._active||[]}setActiveElements(t,e){const i=this._active,s=t.map((({datasetIndex:t,index:e})=>{const i=this.chart.getDatasetMeta(t);if(!i)throw new Error("Cannot find a dataset at index "+t);return{datasetIndex:t,element:i.data[e],index:e}})),n=!f(i,s),o=this._positionChanged(s,e);(n||o)&&(this._active=s,this._eventPosition=e,this._ignoreReplayEvents=!0,this.update(!0))}handleEvent(t,e,i=!0){if(e&&this._ignoreReplayEvents)return!1;this._ignoreReplayEvents=!1;const s=this.options,n=this._active||[],o=this._getActiveElements(t,n,e,i),a=this._positionChanged(o,t),r=e||!f(o,n)||a;return r&&(this._active=o,(s.enabled||s.external)&&(this._eventPosition={x:t.x,y:t.y},this.update(!0,e))),r}_getActiveElements(t,e,i,s){const n=this.options;if("mouseout"===t.type)return[];if(!s)return e.filter((t=>this.chart.data.datasets[t.datasetIndex]&&void 0!==this.chart.getDatasetMeta(t.datasetIndex).controller.getParsed(t.index)));const o=this.chart.getElementsAtEventForMode(t,n.mode,n,i);return n.reverse&&o.reverse(),o}_positionChanged(t,e){const{caretX:i,caretY:s,options:n}=this,o=Da[n.position].call(this,t,e);return!1!==o&&(i!==o.x||s!==o.y)}}var Na={id:"tooltip",_element:Wa,positioners:Da,afterInit(t,e,i){i&&(t.tooltip=new Wa({chart:t,options:i}))},beforeUpdate(t,e,i){t.tooltip&&t.tooltip.initialize(i)},reset(t,e,i){t.tooltip&&t.tooltip.initialize(i)},afterDraw(t){const e=t.tooltip;if(e&&e._willRender()){const i={tooltip:e};if(!1===t.notifyPlugins("beforeTooltipDraw",{...i,cancelable:!0}))return;e.draw(t.ctx),t.notifyPlugins("afterTooltipDraw",i)}},afterEvent(t,e){if(t.tooltip){const i=e.replay;t.tooltip.handleEvent(e.event,i,e.inChartArea)&&(e.changed=!0)}},defaults:{enabled:!0,external:null,position:"average",backgroundColor:"rgba(0,0,0,0.8)",titleColor:"#fff",titleFont:{weight:"bold"},titleSpacing:2,titleMarginBottom:6,titleAlign:"left",bodyColor:"#fff",bodySpacing:2,bodyFont:{},bodyAlign:"left",footerColor:"#fff",footerSpacing:2,footerMarginTop:6,footerFont:{weight:"bold"},footerAlign:"left",padding:6,caretPadding:2,caretSize:5,cornerRadius:6,boxHeight:(t,e)=>e.bodyFont.size,boxWidth:(t,e)=>e.bodyFont.size,multiKeyBackground:"#fff",displayColors:!0,boxPadding:0,borderColor:"rgba(0,0,0,0)",borderWidth:0,animation:{duration:400,easing:"easeOutQuart"},animations:{numbers:{type:"number",properties:["x","y","width","height","caretX","caretY"]},opacity:{easing:"linear",duration:200}},callbacks:Va},defaultRoutes:{bodyFont:"font",footerFont:"font",titleFont:"font"},descriptors:{_scriptable:t=>"filter"!==t&&"itemSort"!==t&&"external"!==t,_indexable:!1,callbacks:{_scriptable:!1,_indexable:!1},animation:{_fallback:!1},animations:{_fallback:"animation"}},additionalOptionScopes:["interaction"]};return Tn.register(Un,$o,go,t),Tn.helpers={...Hi},Tn._adapters=In,Tn.Animation=As,Tn.Animations=Ts,Tn.animator=bt,Tn.controllers=nn.controllers.items,Tn.DatasetController=js,Tn.Element=$s,Tn.elements=go,Tn.Interaction=Ki,Tn.layouts=ls,Tn.platforms=Ds,Tn.Scale=tn,Tn.Ticks=ae,Object.assign(Tn,Un,$o,go,t,Ds),Tn.Chart=Tn,"undefined"!=typeof window&&(window.Chart=Tn),Tn}));
//# sourceMappingURL=chart.umd.min.js.map

}

/**
 * PhoenixKit JavaScript Bundle
 * ============================================================================
 *
 * A single self-contained file with all PhoenixKit JavaScript functionality.
 * Import directly from deps - updates automatically with package updates.
 *
 * SETUP: Add to your assets/js/app.js:
 *
 *   import "../../deps/phoenix_kit/priv/static/assets/phoenix_kit.js"
 *
 *   let liveSocket = new LiveSocket("/live", Socket, {
 *     hooks: { ...window.PhoenixKitHooks, ...Hooks },
 *     // ... other options
 *   })
 *
 * TABLE OF CONTENTS:
 * ============================================================================
 *   1. SORTABLE MODULE ................ Drag-and-drop grid reordering
 *   2. COOKIE CONSENT MODULE .......... GDPR/CCPA compliant consent management
 *   3. UTILITY HOOKS .................. ResetSelect, TimeAgo
 *   4. FLASH AUTO-DISMISS HOOK ........ Auto-dismiss flash messages
 *   5. EMAIL CHARTS HOOK .............. Chart.js email dashboard charts
 *
 * HOOKS PROVIDED:
 *   - SortableGrid .... Drag-and-drop reorderable grid/list
 *   - CookieConsent ... Cookie consent banner and preferences modal
 *   - ResetSelect ..... Reset select element to first option on event
 *   - TimeAgo ......... Client-side relative time updates
 *   - LanguageSwitcherSearch ... Client-side language filtering for dropdown
 *   - LanguageSwitcherPosition . Auto-position dropdown based on viewport space
 *   - PreserveScroll ........... Preserve scroll position during LiveView updates
 *   - FlashAutoDismiss ......... Auto-dismiss flash messages with progress bar
 *   - TableCardView ............ Card/table view toggle with localStorage
 *   - TableFit ................. Drop low-priority table columns that do not fit
 *   - EmailCharts .............. Chart.js delivery trend and engagement charts
 *
 * @version 2.0.0
 * @license MIT
 */

(function() {
  "use strict";

  // Prevent double initialization
  if (window.PhoenixKitInitialized) return;
  window.PhoenixKitInitialized = true;

  // ============================================================================
  // WEBSOCKET TRANSPORT CACHE CLEARING
  // ============================================================================
  //
  // Phoenix LiveView caches transport fallback preferences in browser storage.
  // If WebSocket fails once, Phoenix remembers this and uses LongPoll for all
  // subsequent page loads, even after the WebSocket issue is fixed.
  //
  // This clears the cached preference on every page load to ensure WebSocket
  // is always tried first, providing much better performance when available.
  //
  // See: https://hexdocs.pm/phoenix_live_view/Phoenix.LiveView.Socket.html
  //
  // ============================================================================

  (function clearPhoenixTransportCache() {
    try {
      // Clear the transport fallback cache. Phoenix stores the sticky
      // longpoll flag under `phx:fallback:<transport>` — a "phx:"-prefixed
      // key — and the old filter here EXCLUDED everything "phx:"-prefixed
      // on the theory that those are PhoenixKit's own (phx:theme). So this
      // code never cleared the one key it exists for, and a browser that
      // fell back once (a slow dev load was enough) stayed on longpoll for
      // the life of the tab: laggy, and prone to full-page reloads when a
      // longpoll POST died mid-flight — which read as "the page refreshed
      // itself and ate my work". Target the fallback keys BY NAME and
      // keep excluding the rest of the phx:* namespace.
      function isTransportKey(k) {
        return k.startsWith('phx:fallback:') ||
          (k.includes('phx') && !k.startsWith('phx:'));
      }
      var lsKeys = Object.keys(localStorage).filter(isTransportKey);
      if (lsKeys.length > 0) {
        console.debug("[PhoenixKit] Clearing cached transport preferences from localStorage:", lsKeys);
        lsKeys.forEach(function(k) { localStorage.removeItem(k); });
      }

      // Same for sessionStorage — which is where Phoenix actually keeps
      // the fallback flag (getSession/storeSession).
      var ssKeys = Object.keys(sessionStorage).filter(isTransportKey);
      if (ssKeys.length > 0) {
        console.debug("[PhoenixKit] Clearing cached transport preferences from sessionStorage:", ssKeys);
        ssKeys.forEach(function(k) { sessionStorage.removeItem(k); });
      }
    } catch (e) {
      // Storage might be unavailable in some contexts (e.g., private browsing)
      console.debug("[PhoenixKit] Could not clear transport cache:", e);
    }
  })();

  // Initialize hooks collection
  window.PhoenixKitHooks = window.PhoenixKitHooks || {};

  // ============================================================================
  // SHARED LIBRARY LOADER
  // ============================================================================
  //
  // Every lazily-loaded library (Fresco, Tessera, Etcher, Leaf, SortableJS,
  // Panzoom, wavesurfer) loads through `loadLibrary`, which replaced six
  // copied loaders whose only failure report was a console.error (see
  // dev_docs/plans/2026-10-07-self-hosted-viewer-libraries.md, Part A).
  //
  //   - A pre-imported library wins: `check()` is asked first.
  //   - One in-flight attempt per library; every waiter settles either way.
  //   - Success means `check()` passes after onload, not just a 200.
  //   - A failed script may retry (LIBRARY_MAX_ATTEMPTS per page); a failed
  //     module import() is terminal for the document.
  //   - Final failures go to window.__pkLibFailures and a `pk:library-failed`
  //     event, which the admin-only LibraryLoadNotice shows.
  //
  // A script error has no HTTP status, so failures are "load" unless a
  // matching, enforced `securitypolicyviolation` makes them "csp" — and that
  // event may arrive after onerror, so it can refine an earlier failure.
  // ----------------------------------------------------------------------------

  // Where the libraries live: next to this bundle, in lib/ (the compiler
  // vendors them there — PhoenixKit.Install.ViewerLibraries). Captured NOW,
  // while the bundle evaluates: document.currentScript is gone in every later
  // callback. A host that bundles this file into its own app.js (where
  // currentScript is the wrong file) sets window.PHOENIX_KIT_LIB_BASE.
  var PK_SCRIPT_SRC = (document.currentScript && document.currentScript.src) || "";

  function pkLibBase() {
    if (window.PHOENIX_KIT_LIB_BASE) return String(window.PHOENIX_KIT_LIB_BASE).replace(/\/?$/, "/");
    if (!PK_SCRIPT_SRC) return null;
    return PK_SCRIPT_SRC.split(/[?#]/)[0].replace(/[^\/]*$/, "") + "lib/";
  }

  // The file names come from the install facts (window.PHOENIX_KIT_LIBS,
  // written by the compiler into phoenix_kit_modules.js), looked up when a
  // library is first needed — that file loads after this one. No facts, no
  // guess: a version guessed in the browser could mismatch the server's half
  // and quietly stop honouring its API, so the failure is reported instead.
  function pkLibUrls(key) {
    var facts = window.PHOENIX_KIT_LIBS;
    var entry = facts && facts[key];
    var base = pkLibBase();
    if (!entry || !entry.file || !base) return null;
    // `?vsn=` is what makes Plug.Static send the one-year immutable cache header;
    // the file name already carries the version and content hash, so it is only
    // the switch, never a cache key.
    // A script's src resolves against the document, but import() resolves
    // against this bundle. Normalize a host's relative base once so both
    // loaders fetch the same file (especially wavesurfer's ES module).
    return { local: pkLibNormalize(base + entry.file + "?vsn=d"), cdn: entry.cdn || null };
  }

  var LIBRARY_MAX_ATTEMPTS = 2;
  var pkLibInflight = {};
  var pkLibAttempts = {};
  var pkLibPending = []; // { name, url, origin } for in-flight attempts
  var pkLibFailures = window.__pkLibFailures = window.__pkLibFailures || {};

  function pkLibNormalize(url) {
    try { return new URL(url, window.location.href).href; } catch (_) { return String(url || ""); }
  }

  function pkLibOrigin(url) {
    try { return new URL(url, window.location.href).origin; } catch (_) { return ""; }
  }

  function pkLibAnnounce(name) {
    var f = pkLibFailures[name];
    if (!f) return;
    var cause = f.reason === "csp"
      ? "blocked by the page's Content-Security-Policy (" + (f.directive || "script-src") + ")"
      : f.reason === "facts"
        ? "has no file: PhoenixKit's install facts (window.PHOENIX_KIT_LIBS) are missing or do not name it"
        : "could not be loaded or run (network, a missing file, or an error in the file)";
    console.error("[PhoenixKit] The " + name + " library " + cause + ": " + f.url +
      ". Features that need it are unavailable on this page. " +
      (f.reason === "csp"
        ? "Check that the page's policy allows " + (pkLibOrigin(f.url) || f.url) + "."
        : "Check the network, and that the host build vendors PhoenixKit's JavaScript " +
          "(:phoenix_kit_js_sources in compilers, or mix phoenix_kit.update)."));
    try {
      window.dispatchEvent(new CustomEvent("pk:library-failed", {
        detail: { name: name, url: f.url, reason: f.reason, directive: f.directive || null }
      }));
    } catch (_) { /* very old browsers: the console line above still stands */ }
  }

  function pkLibFail(name, url, reason, directive) {
    var prev = pkLibFailures[name];
    // Already recorded with at least this much evidence: nothing new to say.
    if (prev && prev.url === url && (prev.reason === "csp" || reason !== "csp")) return;
    pkLibFailures[name] = { url: url, reason: reason, directive: directive || null };
    pkLibAnnounce(name);
  }

  // Matches a violation to one of our attempts by full URL, or by origin when
  // the browser stripped the blocked URI to one; anything else is ignored.
  if (!window.__pkLibCspListener) {
    window.__pkLibCspListener = true;
    document.addEventListener("securitypolicyviolation", function(e) {
      if (e.disposition === "report") return;
      var blocked = e.blockedURI || "";
      // "inline", "eval", "data", "blob", "" and the like are keywords, not
      // URLs: resolved against the page they would read as the page's own
      // origin and pin a same-origin library failure on an unrelated violation.
      if (!/^[a-z][a-z0-9+.-]*:\/\//i.test(blocked)) return;
      var full = pkLibNormalize(blocked);
      var origin = pkLibOrigin(blocked);
      var directive = e.effectiveDirective || e.violatedDirective || null;
      var candidates = pkLibPending.concat(Object.keys(pkLibFailures).map(function(n) {
        return { name: n, url: pkLibFailures[n].url };
      }));
      for (var i = 0; i < candidates.length; i++) {
        var c = candidates[i];
        var cFull = pkLibNormalize(c.url);
        var match = cFull === full ||
          (origin && blocked.indexOf("/", blocked.indexOf("//") + 2) === -1 && pkLibOrigin(c.url) === origin);
        if (!match) continue;
        if (pkLibFailures[c.name]) {
          pkLibFail(c.name, c.url, "csp", directive);
        } else {
          c.csp = directive || "script-src";
        }
        return;
      }
    }, true);
  }

  // `opts.check()` — true once the library is usable (its global/hook).
  // `opts.module` — load with dynamic import() and resolve with the module.
  function loadLibrary(name, url, opts) {
    opts = opts || {};
    var check = opts.check || function() { return false; };

    if (!opts.module && check()) return Promise.resolve();
    if (pkLibInflight[name]) return pkLibInflight[name];

    if (opts.module && pkLibFailures[name] && pkLibFailures[name].terminal) {
      return Promise.reject(new Error(name + " failed to load earlier on this page"));
    }
    var attempts = pkLibAttempts[name] = (pkLibAttempts[name] || 0) + 1;
    if (!opts.module && attempts > LIBRARY_MAX_ATTEMPTS) {
      return Promise.reject(new Error(name + " failed to load"));
    }

    var attempt = { name: name, url: url, csp: null };
    pkLibPending.push(attempt);
    function settled() {
      pkLibPending = pkLibPending.filter(function(a) { return a !== attempt; });
      delete pkLibInflight[name];
    }

    var p;
    var urls = [url].concat(opts.fallback && opts.fallback !== url ? [opts.fallback] : []);
    if (opts.module) {
      // Same order as a script: the local copy, then an opted-in CDN once.
      var importAt = function(i) {
        attempt.url = urls[i];
        attempt.csp = null;
        return import(urls[i]).then(function(mod) {
          settled();
          delete pkLibFailures[name];
          return mod;
        }, function(err) {
          if (i + 1 < urls.length) return importAt(i + 1);
          settled();
          pkLibFail(name, urls[i], attempt.csp ? "csp" : "load", attempt.csp);
          if (pkLibFailures[name]) pkLibFailures[name].terminal = true;
          throw err;
        });
      };
      p = importAt(0);
    } else {
      // The local file first; the CDN only when the host opted in (the facts
      // name one). One failure report, after the last permitted attempt — a
      // failed local load rescued by the fallback leaves no alert behind.
      p = new Promise(function(resolve, reject) {
        function tryUrl(i) {
          var current = urls[i];
          attempt.url = current;
          attempt.csp = null;
          var script = document.createElement("script");
          script.src = current;
          function failed(reason) {
            // Removed so a later attempt (a remount, a reconnect) can try anew.
            script.remove();
            if (i + 1 < urls.length) { tryUrl(i + 1); return; }
            settled();
            pkLibFail(name, current, reason, attempt.csp);
            reject(new Error(name + " failed to load"));
          }
          script.onload = function() {
            if (check()) {
              settled();
              delete pkLibFailures[name];
              resolve();
            } else {
              failed("load");
            }
          };
          script.onerror = function() { failed(attempt.csp ? "csp" : "load"); };
          document.head.appendChild(script);
        }
        tryUrl(0);
      });
    }
    pkLibInflight[name] = p;
    return p;
  }

  // A vendored library by its key in window.PHOENIX_KIT_LIBS. A pre-imported
  // copy still wins; with no facts there is nothing to load and the failure
  // says so (the notice tells the host to recompile or run phoenix_kit.update).
  function loadVendored(name, key, opts) {
    opts = opts || {};
    if (opts.check && opts.check()) return Promise.resolve();
    var urls = pkLibUrls(key);
    if (!urls) {
      pkLibFail(name, "lib/" + key, "facts");
      return Promise.reject(new Error(name + ": no install facts name its file"));
    }
    return loadLibrary(name, urls.local, Object.assign({}, opts, { fallback: urls.cdn }));
  }

  // A hook that loads its library (`load()` chains any dependencies), then
  // becomes the library's own hook. One destroyed while loading never
  // mounts late.
  function lazyHook(load, pick) {
    return {
      mounted: function() {
        var self = this;
        self.__pkGone = false;
        load().then(function() {
          if (self.__pkGone) return;
          var real = pick();
          if (!real) return;
          Object.keys(real).forEach(function(key) {
            if (key !== "mounted") self[key] = real[key];
          });
          if (typeof real.mounted === "function") real.mounted.call(self);
        }, function() {
          // Already reported by loadLibrary; the feature stays unavailable.
        });
      },
      destroyed: function() {
        this.__pkGone = true;
      }
    };
  }

  // Loaders other blocks depend on (Tessera and Etcher wait for Fresco).
  var pkLoaders = {};

  window.PhoenixKitLibraries = {
    load: loadLibrary,
    loadVendored: loadVendored,
    urls: pkLibUrls,
    lazyHook: lazyHook,
    failures: pkLibFailures
  };

  // LibraryLoadNotice — fills the admin-only shell rendered beside the flash
  // group, from failures already recorded and from `pk:library-failed`. The
  // copy follows the evidence (CSP from another origin, CSP on this origin,
  // or "could not load", cause unknown); text goes in as textContent only.
  // Dismissal lasts the session, per library and URL.
  var LIB_NOTICE_KEY = "pk:library-notice:dismissed";

  function libNoticeDismissed() {
    try { return JSON.parse(sessionStorage.getItem(LIB_NOTICE_KEY) || "[]"); } catch (_) { return []; }
  }

  window.PhoenixKitHooks.LibraryLoadNotice = {
    mounted() {
      var self = this;
      this._onFailed = function() { self._render(); };
      window.addEventListener("pk:library-failed", this._onFailed);
      var dismiss = this.el.querySelector("[data-notice-dismiss]");
      if (dismiss) {
        dismiss.addEventListener("click", function() {
          var seen = libNoticeDismissed().concat(self._shown || []);
          try { sessionStorage.setItem(LIB_NOTICE_KEY, JSON.stringify(seen)); } catch (_) {}
          self.el.hidden = true;
        });
      }
      this._render();
    },

    destroyed() {
      window.removeEventListener("pk:library-failed", this._onFailed);
    },

    _render() {
      var el = this.el;
      var failures = window.__pkLibFailures || {};
      var dismissed = libNoticeDismissed();
      var names = Object.keys(failures).filter(function(name) {
        return dismissed.indexOf(name + "|" + failures[name].url) === -1;
      });
      this._shown = names.map(function(name) { return name + "|" + failures[name].url; });
      if (!names.length) { el.hidden = true; return; }

      var d = el.dataset;
      el.querySelector("[data-notice-title]").textContent = d.title || "";
      el.querySelector("[data-notice-audience]").textContent = d.audience || "";
      var list = el.querySelector("[data-notice-list]");
      list.textContent = "";
      names.forEach(function(name) {
        var f = failures[name];
        var origin = "";
        try { origin = new URL(f.url, window.location.href).origin; } catch (_) {}
        var text;
        if (f.reason === "csp") {
          text = (origin === window.location.origin ? d.cspSelf : d.cspOther) || "";
          text = text.replace("%{directive}", f.directive || "script-src").replace("%{origin}", origin);
        } else if (f.reason === "facts") {
          text = d.facts || "";
        } else {
          text = d.load || "";
        }
        var li = document.createElement("li");
        var strong = document.createElement("strong");
        strong.textContent = name + ": ";
        var reason = document.createElement("span");
        reason.textContent = text + " ";
        var url = document.createElement("code");
        url.style.wordBreak = "break-all";
        url.style.fontSize = "0.75em";
        url.textContent = f.url;
        li.appendChild(strong);
        li.appendChild(reason);
        li.appendChild(url);
        list.appendChild(li);
      });
      el.hidden = false;
    }
  };

  // ============================================================================
  // FRESCO DAISYUI THEME INTEGRATION
  // ============================================================================
  //
  // Map Fresco's six --fresco-* custom properties to daisyUI tokens so any
  // viewer that opts into `theme={:inherit}` follows whichever daisyUI theme
  // is active on <html>. Injected here (not in a stylesheet) because
  // phoenix_kit's app.css isn't necessarily loaded by every parent app —
  // the JS bundle, however, always is.
  //
  // base-200 / base-300 read as light grays on light themes and dark grays
  // on dark themes, so nav buttons render as subtle chips on either side.
  // Using --color-neutral here would give near-black chips on every theme,
  // which fights with the typical light/dark expectation.
  // ============================================================================

  (function injectFrescoDaisyUIStyles() {
    try {
      if (document.querySelector("style[data-phoenix-kit-fresco]")) return;
      var style = document.createElement("style");
      style.setAttribute("data-phoenix-kit-fresco", "");
      style.textContent = [
        ".fresco-viewer[data-fresco-theme=\"inherit\"] {",
        "  --fresco-bg: var(--color-base-100);",
        "  --fresco-grid-dot: var(--color-base-300);",
        "  --fresco-nav-bg: var(--color-base-200);",
        "  --fresco-nav-bg-hover: var(--color-base-300);",
        "  --fresco-nav-fg: var(--color-base-content);",
        "  --fresco-nav-focus: var(--color-primary);",
        "}"
      ].join("\n");
      (document.head || document.documentElement).appendChild(style);
    } catch (e) {
      console.debug("[PhoenixKit] Fresco theme injection failed:", e);
    }
  })();


  // ============================================================================
  // 1. SORTABLE MODULE
  // ============================================================================
  //
  // Provides drag-and-drop reordering for grids and lists.
  // Loads SortableJS (the host's vendored copy, see ViewerLibraries) when first used.
  //
  // Usage in LiveView template:
  //   <div id="my-grid" phx-hook="SortableGrid" data-sortable-event="reorder_items">
  //     <div class="sortable-item" data-id="1">Item 1</div>
  //     <div class="sortable-item" data-id="2">Item 2</div>
  //   </div>
  //
  // Handle in LiveView:
  //   def handle_event("reorder_items", %{"ordered_ids" => ids}, socket)
  //
  // ============================================================================

  (function() {
    if (window.PhoenixKitSortable) return;
    window.PhoenixKitSortable = true;

    // ---------------------------------------------------------------------------
    // Configuration
    // ---------------------------------------------------------------------------

    var stylesInjected = false;

    // ---------------------------------------------------------------------------
    // Style Injection
    // ---------------------------------------------------------------------------

    function injectStyles() {
      if (stylesInjected) return;
      stylesInjected = true;

      var style = document.createElement("style");
      style.textContent = [
        ".sortable-ghost { opacity: 0.5; }",
        ".sortable-chosen { outline: 2px solid oklch(var(--p)); outline-offset: 2px; }",
        ".sortable-drag { box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05); }",
        "@keyframes pk-sortable-wiggle { 0%, 100% { transform: rotate(0deg); } 25% { transform: rotate(-1.5deg); } 75% { transform: rotate(1.5deg); } }",
        ".pk-sortable-wiggle { animation: pk-sortable-wiggle 0.4s ease-in-out infinite; }",
        ".pk-sortable-wiggle:nth-child(even) { animation-delay: 0.1s; }",
        ".pk-sortable-wiggle:nth-child(3n) { animation-delay: 0.2s; }",
        "@media (prefers-reduced-motion: reduce) { .pk-sortable-wiggle { animation: none; } }",
        // Selected-card indicator. The `<.table_default>` card view is
        // opaque to consumers (no per-item selected attr), so we lean
        // on :has() to paint any sortable card whose internal checkbox
        // is checked. Stronger than a flat tint: bumped bg + 4px
        // primary left border mirroring the table row treatment so
        // selection is unambiguous at a glance. Specificity (0,3,0) +
        // injection-after-Tailwind in source order means this wins
        // over `bg-base-200` without `!important`.
        ".sortable-item.card:has(input[type=\"checkbox\"]:checked) { background-color: oklch(var(--p) / 0.15); box-shadow: inset 4px 0 0 0 oklch(var(--p)); }",
        // Reorder result flash — green on success, red on failure.
        // The hook applies the class transiently after the LV emits a
        // sortable:flash push_event. We overlay a pseudo-element
        // (::after) instead of animating background-color directly,
        // so cards with their own bg (e.g. bg-base-200) don't briefly
        // become transparent during the keyframe interpolation and
        // bleed the page bg through.
        ".pk-sortable-flash-ok, .pk-sortable-flash-err { position: relative; }",
        ".pk-sortable-flash-ok::after, .pk-sortable-flash-err::after { content: ''; position: absolute; inset: 0; pointer-events: none; border-radius: inherit; z-index: 1; }",
        "@keyframes pk-sortable-flash-ok { 0% { background-color: rgba(34, 197, 94, 0); } 15% { background-color: rgba(34, 197, 94, 0.35); } 100% { background-color: rgba(34, 197, 94, 0); } }",
        "@keyframes pk-sortable-flash-err { 0% { background-color: rgba(239, 68, 68, 0); } 15% { background-color: rgba(239, 68, 68, 0.35); } 100% { background-color: rgba(239, 68, 68, 0); } }",
        ".pk-sortable-flash-ok::after { animation: pk-sortable-flash-ok 1.1s ease-out; }",
        ".pk-sortable-flash-err::after { animation: pk-sortable-flash-err 1.1s ease-out; }",
        "@media (prefers-reduced-motion: reduce) { .pk-sortable-flash-ok::after, .pk-sortable-flash-err::after { animation: none; } }",
        // Every sortable_handle consumer restricts drag-initiation to this
        // class — without `touch-action: none` on it, iOS/Android treat the
        // first touchmove as a page-scroll gesture and claim it before
        // SortableJS's (forceFallback) touch handling ever sees it, so drag
        // silently never starts on a touch device. `-webkit-user-select` /
        // `user-select: none` stop a long-press from opening the text/image
        // selection UI instead of dragging. Purely behavioral — no padding
        // or sizing here, since some consumers (table_default's <td>
        // handle) already size their own tap target and a blanket margin
        // hack would be a no-op-or-worse on a table cell.
        ".pk-drag-handle { touch-action: none; -webkit-user-select: none; user-select: none; }"
      ].join("\n");
      document.head.appendChild(style);
    }

    // ---------------------------------------------------------------------------
    // Loading (the host's vendored copy)
    // ---------------------------------------------------------------------------

    // Through the shared loader; the callback runs only once SortableJS is
    // usable. A failure is reported there, and the list stays unsortable.
    function loadSortableJS(callback) {
      loadVendored("SortableJS", "sortable", {
        check: function() { return typeof window.Sortable === "function"; }
      }).then(callback, function() {});
    }

    // ---------------------------------------------------------------------------
    // SortableGrid Hook
    // ---------------------------------------------------------------------------

    window.PhoenixKitHooks.SortableGrid = {
      mounted: function() {
        var self = this;

        // Server-driven flash: the LV pushes `sortable:flash` after each
        // reorder attempt with `{uuid, status: "ok" | "error"}`. We
        // find the row by `data-id` and apply a transient highlight
        // class. Idempotent — the offsetWidth read forces a reflow so
        // re-flashing the same row restarts the animation.
        this.handleEvent("sortable:flash", function(payload) {
          if (!payload || !payload.uuid) return;
          // Apply to *every* element with the data-id — table view and
          // card view each render the same item, so both DOM nodes
          // need the class. Whichever is currently visible (md:
          // breakpoint controls it) animates in front of the user.
          var items = document.querySelectorAll(
            '[data-id="' + payload.uuid + '"]'
          );
          if (!items.length) return;
          // Explicit map — treat anything that isn't "ok" or "error" as
          // a typo on the server side and bail rather than silently
          // falling into the err-class branch.
          var cls =
            payload.status === "ok"
              ? "pk-sortable-flash-ok"
              : payload.status === "error"
                ? "pk-sortable-flash-err"
                : null;
          if (!cls) return;
          items.forEach(function(item) {
            item.classList.remove(
              "pk-sortable-flash-ok",
              "pk-sortable-flash-err"
            );
            // Force reflow so a second consecutive flash re-runs the
            // keyframes on this element.
            void item.offsetWidth;
            item.classList.add(cls);
          });
          setTimeout(function() {
            items.forEach(function(item) {
              item.classList.remove(cls);
            });
          }, 1200);
        });

        loadSortableJS(function() {
          setTimeout(function() {
            self.initSortable();
          }, 100);
        });
      },

      updated: function() {
        if (this.sortable) {
          var currentItems = this.el.querySelectorAll(".sortable-item[data-id]");
          if (currentItems.length !== this._itemCount) {
            this.sortable.destroy();
            this.initSortable();
          }
        }
      },

      destroyed: function() {
        if (this.sortable) {
          this.sortable.destroy();
          this.sortable = null;
        }
      },

      initSortable: function() {
        var self = this;
        var container = this.el;
        var eventName = container.dataset.sortableEvent || "reorder_items";
        var hideSource = container.dataset.sortableHideSource === "true";
        var groupName = container.dataset.sortableGroup;
        // Optional drag-handle selector. When set, SortableJS only initiates
        // a drag when the pointer is over a descendant matching this selector
        // — the rest of the .sortable-item is non-draggable surface (clicks,
        // text selection, button presses pass through normally). Unset →
        // backward-compatible whole-item drag.
        var handleSelector = container.dataset.sortableHandle;

        injectStyles();

        this._itemCount = container.querySelectorAll(".sortable-item[data-id]").length;

        // Helper: read all data-sortable-scope-* attrs off an element and
        // turn them into a `{key: value}` map. dataset already gives
        // camelCase keys; we just strip the "sortableScope" prefix and
        // lowercase the first letter.
        var readScope = function(el) {
          var out = {};
          for (var key in el.dataset) {
            if (key.indexOf("sortableScope") === 0 && key.length > "sortableScope".length) {
              var fieldName = key.substring("sortableScope".length);
              fieldName = fieldName.charAt(0).toLowerCase() + fieldName.slice(1);
              out[fieldName] = el.dataset[key];
            }
          }
          return out;
        };

        // `pushEventTo` routes to the LiveComponent named by the selector;
        // plain `pushEvent` reaches only the host LiveView. LiveView consumers
        // omit `data-sortable-target`, so they keep the original behavior.
        var emitReorder = function(targetSelector, ev, payload) {
          if (targetSelector) {
            self.pushEventTo(targetSelector, ev, payload);
          } else {
            self.pushEvent(ev, payload);
          }
        };

        // SortableJS `group` controls which sortables can exchange items.
        // - String form: simple shared group (any matching name accepts/donates).
        // - Object form: {name, pull: true, put: true} when consumer needs
        //   explicit cross-container behavior. We keep it as a plain string
        //   here; the default pull/put = true is what cross-container DnD
        //   needs.
        var sortableOpts = {
          animation: 150,
          draggable: ".sortable-item",
          filter: ".sortable-ignore",
          forceFallback: true,
          fallbackOnBody: true,
          ghostClass: "sortable-ghost",
          chosenClass: "sortable-chosen",
          dragClass: "sortable-drag",
          // Lock <tr> cell widths before drag — when SortableJS clones
          // the row to <body> for the drag preview (forceFallback +
          // fallbackOnBody), the <tr> loses its <table> ancestor and
          // each <td> collapses to its content width. Snapshot the
          // computed widths and pin them inline so the floating row
          // keeps its column layout. Restore on drag end.
          onChoose: function(evt) {
            var item = evt.item;
            if (item && item.tagName === "TR") {
              item._pkCellWidths = [];
              var cells = item.children;
              for (var i = 0; i < cells.length; i++) {
                item._pkCellWidths.push(cells[i].style.width);
                cells[i].style.width = cells[i].offsetWidth + "px";
              }
            }
          },
          onUnchoose: function(evt) {
            var item = evt.item;
            if (item && item.tagName === "TR" && item._pkCellWidths) {
              var cells = item.children;
              for (var i = 0; i < cells.length && i < item._pkCellWidths.length; i++) {
                cells[i].style.width = item._pkCellWidths[i];
              }
              delete item._pkCellWidths;
            }
          },
          onStart: function() {
            if (hideSource) {
              setTimeout(function() {
                var fallback = document.querySelector("body > .sortable-fallback");
                if (fallback) fallback.style.display = "none";
              }, 0);
            }
          },
          // onEnd assumes the hook has exclusive control over the
          // .sortable-item nodes inside its container — i.e. the LV
          // owns this DOM subtree. If a third-party script ever
          // injects nodes with `class="sortable-item" data-id=...`
          // alongside ours, those IDs will be picked up by the
          // querySelectorAll below; the LV handler should then
          // reject unknown IDs at the server side. Trust your own DOM.
          //
          // The whole body is wrapped in try/catch so a single bad
          // dataset value (e.g. corrupt JSON in a custom scope attr,
          // or a missing source container after a fast unmount) flashes
          // a console error instead of leaving SortableJS in a half-
          // initialized state with the LV unable to reorder again.
          onEnd: function(evt) {
            try {
              var fromContainer = evt.from;
              var toContainer = evt.to;
              var crossContainer = fromContainer !== toContainer;

              // The destination container's items reflect the new ordering;
              // the source's lost one but its remaining order is preserved
              // by SortableJS, so we don't need a server reorder there.
              var destItems = toContainer.querySelectorAll(".sortable-item[data-id]");
              var orderedIds = Array.from(destItems).map(function(el) {
                return el.dataset.id;
              });

              // `moved_id` is always included so the LV can push back
               // a sortable:flash event keyed to the just-moved row.
              var payload = {
                ordered_ids: orderedIds,
                moved_id: evt.item.dataset.id
              };
              var destScope = readScope(toContainer);
              for (var k in destScope) payload[k] = destScope[k];

              if (crossContainer) {
                var fromScope = readScope(fromContainer);
                for (var k2 in fromScope) {
                  // Capitalize first letter so `categoryUuid` becomes
                  // `fromCategoryUuid` (camelCase preserved).
                  var capped = k2.charAt(0).toUpperCase() + k2.slice(1);
                  payload["from" + capped] = fromScope[k2];
                }
                // Use the destination's event name so the LV handler is
                // co-located with the table the item ended up in.
                var destEvent = toContainer.dataset.sortableEvent || eventName;
                emitReorder(toContainer.dataset.sortableTarget, destEvent, payload);
              } else {
                emitReorder(container.dataset.sortableTarget, eventName, payload);
              }
            } catch (err) {
              console.error("PhoenixKitHooks.SortableGrid.onEnd failed:", err);
            }
          }
        };

        if (groupName) {
          sortableOpts.group = groupName;
        }

        if (handleSelector) {
          sortableOpts.handle = handleSelector;
        }

        this.sortable = window.Sortable.create(container, sortableOpts);
      }
    };
  })();


  // ============================================================================
  // 1.5. MEDIA IMAGE ZOOM HOOK
  // ============================================================================
  //
  // Lazy-loads Panzoom (the host's vendored copy, like SortableJS above) and
  // attaches it to a given <img> via the MediaImageZoom hook. Used by the
  // MediaBrowser modal viewer so users can wheel/pinch/double-tap zoom and
  // drag-pan the original image. The hook is only mounted on image files
  // (the modal's cond branch for non-images doesn't render the <img> tag).
  //
  // ============================================================================

  (function() {
    if (window.PhoenixKitMediaZoom) return;
    window.PhoenixKitMediaZoom = true;

    // Through the shared loader; see loadSortableJS.
    function loadPanzoom(callback) {
      loadVendored("Panzoom", "panzoom", {
        check: function() { return typeof window.Panzoom === "function"; }
      }).then(callback, function() {});
    }

    window.PhoenixKitHooks.MediaImageZoom = {
      mounted: function() {
        var self = this;
        loadPanzoom(function() {
          // The element may have been swapped out (e.g. user closed the modal
          // or stepped to another file) while Panzoom was downloading.
          if (!self.el.isConnected) return;

          self.panzoom = window.Panzoom(self.el, {
            maxScale: 8,
            minScale: 1,
            contain: "outside",
            cursor: "grab"
          });

          // Wheel listener attaches to the parent so the cursor doesn't have
          // to land on the image itself. zoomWithWheel calls preventDefault,
          // stopping the wheel event from scrolling the page underneath.
          self._parent = self.el.parentElement;
          if (self._parent) {
            self._wheelHandler = function(e) {
              if (self.panzoom) self.panzoom.zoomWithWheel(e);
            };
            self._parent.addEventListener("wheel", self._wheelHandler);
          }
        });
      },

      destroyed: function() {
        if (this._parent && this._wheelHandler) {
          this._parent.removeEventListener("wheel", this._wheelHandler);
        }
        if (this.panzoom) {
          try { this.panzoom.destroy(); } catch (e) { /* ignore */ }
          this.panzoom = null;
        }
      }
    };
  })();


  // ============================================================================
  // 2. COOKIE CONSENT MODULE
  // ============================================================================
  //
  // GDPR/CCPA compliant cookie consent management with:
  // - Configurable consent frameworks (GDPR, CCPA, etc.)
  // - Google Consent Mode v2 integration
  // - Script blocking/unblocking by category
  // - Cross-tab synchronization
  // - Customizable UI with banner and modal
  //
  // Usage: The module auto-initializes by fetching config from the server.
  // Or use the CookieConsent hook with data attributes on an element.
  //
  // ============================================================================

  (function() {
    if (window.PhoenixKitConsent) return;

    // ---------------------------------------------------------------------------
    // Constants & Configuration
    // ---------------------------------------------------------------------------

    var STORAGE_KEY = "pk_consent";
    var VERSION_KEY = "pk_consent_version";
    var CATEGORIES = ["necessary", "analytics", "marketing", "preferences"];
    var OPT_IN_FRAMEWORKS = ["gdpr", "uk_gdpr", "lgpd", "pipeda"];

    var PhoenixKitConsent = {
      initialized: false,
      config: {
        frameworks: [],
        policyVersion: "1.0",
        googleConsentMode: false,
        iconPosition: "bottom-right",
        showIcon: false,
        cookiePolicyUrl: "/legal/cookie-policy",
        privacyPolicyUrl: "/legal/privacy-policy"
      },
      consent: null,
      elements: { root: null, icon: null, banner: null, modal: null }
    };

    // ---------------------------------------------------------------------------
    // Utility Functions
    // ---------------------------------------------------------------------------

    function log(message, data) {
      if (typeof console !== "undefined" && console.debug) {
        console.debug("[PhoenixKit:Consent] " + message, data || "");
      }
    }

    function getConfigEndpoint() {
      // PHOENIX_KIT_PREFIX is emitted by the phoenix_kit_js_sources compiler.
      // The "/phoenix_kit" fallback is for a host that predates it — which is
      // exactly how a custom-prefix install ended up requesting a path that
      // does not exist on it.
      var prefix = window.PHOENIX_KIT_PREFIX || "/phoenix_kit";
      // Handle case when prefix is "/" to avoid double slash (//api/...)
      if (prefix === "/") {
        return "/api/consent-config";
      }
      return prefix + "/api/consent-config";
    }

    function isOptInMode() {
      var frameworks = PhoenixKitConsent.config.frameworks;
      for (var i = 0; i < OPT_IN_FRAMEWORKS.length; i++) {
        if (frameworks.indexOf(OPT_IN_FRAMEWORKS[i]) !== -1) return true;
      }
      return false;
    }

    // ---------------------------------------------------------------------------
    // Storage Functions
    // ---------------------------------------------------------------------------

    function loadConsent() {
      try {
        var stored = localStorage.getItem(STORAGE_KEY);
        if (stored) return JSON.parse(stored);
      } catch (e) {
        log("Could not load consent", e);
      }
      return null;
    }

    function saveConsent(consent) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
        localStorage.setItem(VERSION_KEY, PhoenixKitConsent.config.policyVersion);
        log("Consent saved", consent);
      } catch (e) {
        log("Could not save consent", e);
      }
    }

    function getStoredVersion() {
      try {
        return localStorage.getItem(VERSION_KEY);
      } catch (e) {
        return null;
      }
    }

    function shouldShowBanner() {
      var stored = loadConsent();
      var storedVersion = getStoredVersion();
      var currentVersion = PhoenixKitConsent.config.policyVersion;
      var consentMode = PhoenixKitConsent.config.consentMode;

      if (consentMode === "notice") return !stored;
      if (!stored || storedVersion !== currentVersion) return true;
      return false;
    }

    // ---------------------------------------------------------------------------
    // Cross-Tab Synchronization
    // ---------------------------------------------------------------------------

    function setupCrossTabSync() {
      window.addEventListener("storage", function(e) {
        if (e.key === STORAGE_KEY && e.newValue) {
          try {
            var newConsent = JSON.parse(e.newValue);
            PhoenixKitConsent.consent = newConsent;
            applyConsent(newConsent);
            updateUI();
            log("Cross-tab sync: consent updated");
          } catch (err) {
            log("Cross-tab sync error", err);
          }
        }
      });
    }

    // ---------------------------------------------------------------------------
    // Google Consent Mode v2 Integration
    // ---------------------------------------------------------------------------

    function initGoogleConsentMode() {
      if (!PhoenixKitConsent.config.googleConsentMode) return;

      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }

      gtag("consent", "default", {
        "ad_storage": "denied",
        "analytics_storage": "denied",
        "ad_user_data": "denied",
        "ad_personalization": "denied",
        "personalization_storage": "denied",
        "functionality_storage": "granted",
        "security_storage": "granted",
        "wait_for_update": 500
      });
      gtag("set", "ads_data_redaction", true);
      gtag("set", "url_passthrough", true);

      log("Google Consent Mode v2 initialized");
    }

    function updateGoogleConsent(consent) {
      if (!PhoenixKitConsent.config.googleConsentMode) return;

      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }

      gtag("consent", "update", {
        "analytics_storage": consent.analytics ? "granted" : "denied",
        "ad_storage": consent.marketing ? "granted" : "denied",
        "ad_user_data": consent.marketing ? "granted" : "denied",
        "ad_personalization": consent.marketing ? "granted" : "denied",
        "personalization_storage": consent.preferences ? "granted" : "denied"
      });

      log("Google Consent Mode updated", consent);
    }

    function resetGoogleConsentMode() {
      if (typeof window.dataLayer === "undefined") return;

      function gtag() { window.dataLayer.push(arguments); }
      gtag("consent", "update", {
        "ad_storage": "granted",
        "analytics_storage": "granted",
        "ad_user_data": "granted",
        "ad_personalization": "granted",
        "personalization_storage": "granted",
        "functionality_storage": "granted",
        "security_storage": "granted"
      });

      log("Google Consent Mode reset to granted (widget disabled)");
    }

    // ---------------------------------------------------------------------------
    // Script Blocking/Unblocking
    // ---------------------------------------------------------------------------

    function blockScripts() {
      var scripts = document.querySelectorAll("script[data-consent-category]");
      scripts.forEach(function(script) {
        var category = script.getAttribute("data-consent-category");
        if (category !== "necessary") {
          script.setAttribute("type", "text/plain");
          script.setAttribute("data-blocked", "true");
        }
      });
      log("Non-essential scripts blocked");
    }

    function unblockScripts(category) {
      var scripts = document.querySelectorAll(
        'script[data-consent-category="' + category + '"][data-blocked="true"]'
      );
      scripts.forEach(function(script) {
        var newScript = document.createElement("script");
        Array.from(script.attributes).forEach(function(attr) {
          if (attr.name !== "type" && attr.name !== "data-blocked") {
            newScript.setAttribute(attr.name, attr.value);
          }
        });
        if (script.src) {
          newScript.src = script.src;
        } else {
          newScript.textContent = script.textContent;
        }
        script.parentNode.replaceChild(newScript, script);
      });
      if (scripts.length > 0) {
        log("Scripts unblocked for category: " + category);
      }
    }

    function applyConsent(consent) {
      CATEGORIES.forEach(function(category) {
        if (consent[category]) unblockScripts(category);
      });
      updateGoogleConsent(consent);
      window.dispatchEvent(new CustomEvent("phx:consent-updated", {
        detail: { consent: consent }
      }));
    }

    // ---------------------------------------------------------------------------
    // UI Helper Functions
    // ---------------------------------------------------------------------------

    function getIconPositionClass(position) {
      switch (position) {
        case "bottom-left": return "bottom: 1rem; left: 1rem;";
        case "top-left": return "top: 1rem; left: 1rem;";
        case "top-right": return "top: 1rem; right: 1rem;";
        default: return "bottom: 1rem; right: 1rem;";
      }
    }

    function createCategoryHTML(id, icon, name, description, required) {
      var checkedAttr = required ? ' checked disabled' : '';
      var requiredBadge = required
        ? '<span class="badge badge-ghost badge-xs" style="margin-left:0.5rem">Required</span>'
        : '';

      return '<div class="pk-category-card" style="border-radius:0.75rem;padding:1rem;margin-bottom:0.75rem">' +
        '<div style="display:flex;align-items:flex-start;justify-content:space-between;gap:0.75rem">' +
          '<div style="display:flex;align-items:flex-start;gap:0.75rem;flex:1">' +
            '<span style="font-size:1.25rem">' + icon + '</span>' +
            '<div>' +
              '<div style="display:flex;align-items:center">' +
                '<span style="font-weight:500;font-size:0.875rem;color:var(--pk-text)">' + name + '</span>' +
                requiredBadge +
              '</div>' +
              '<p style="font-size:0.75rem;color:var(--pk-text-muted);margin:0.25rem 0 0 0">' + description + '</p>' +
            '</div>' +
          '</div>' +
          '<label style="position:relative;display:inline-flex;cursor:pointer;flex-shrink:0">' +
            '<input type="checkbox" id="pk-consent-' + id + '" class="toggle toggle-primary toggle-sm" data-category="' + id + '"' + checkedAttr + '>' +
          '</label>' +
        '</div>' +
      '</div>';
    }

    // ---------------------------------------------------------------------------
    // Widget HTML Generation
    // ---------------------------------------------------------------------------

    function createWidgetHTML(config) {
      var showIcon = isOptInMode();
      var iconStyle = getIconPositionClass(config.icon_position || config.iconPosition);
      var cookiePolicyUrl = config.cookie_policy_url || '/legal/cookie-policy';
      var privacyPolicyUrl = config.privacy_policy_url || '/legal/privacy-policy';

      // CSS Styles
      var styles = '<style>' +
        '.pk-consent-widget{' +
          '--pk-bg:oklch(var(--b1));' +
          '--pk-bg-alt:oklch(var(--b2));' +
          '--pk-border:oklch(var(--b3));' +
          '--pk-text:oklch(var(--bc));' +
          '--pk-text-muted:oklch(var(--bc)/0.6);' +
          '--pk-primary:oklch(var(--p));' +
          '--pk-primary-content:oklch(var(--pc));' +
          '--pk-primary-soft:oklch(var(--p)/0.1);' +
          '--pk-primary-glow:oklch(var(--p)/0.4);' +
          '--pk-shadow:0 8px 32px oklch(var(--bc)/0.12);' +
        '}' +
        '@keyframes pk-breathe{' +
          '0%,100%{box-shadow:0 0 0 0 var(--pk-primary-glow),0 4px 12px oklch(var(--bc)/0.15)}' +
          '50%{box-shadow:0 0 0 8px transparent,0 4px 16px oklch(var(--bc)/0.2)}' +
        '}' +
        '@keyframes pk-slide-up{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}' +
        '@keyframes pk-fade-in{from{opacity:0}to{opacity:1}}' +
        '.pk-floating-icon{' +
          'animation:pk-breathe 3s ease-in-out infinite;' +
          'transition:transform 0.2s cubic-bezier(0.34,1.56,0.64,1),box-shadow 0.2s ease' +
        '}' +
        '.pk-floating-icon:hover{' +
          'transform:scale(1.1);' +
          'animation:none;' +
          'box-shadow:0 0 0 4px var(--pk-primary-glow),0 8px 24px oklch(var(--bc)/0.25)' +
        '}' +
        '.pk-floating-icon:active{transform:scale(0.95)}' +
        '.pk-banner{animation:pk-slide-up 0.4s cubic-bezier(0.16,1,0.3,1) forwards}' +
        '.pk-modal-backdrop{animation:pk-fade-in 0.2s ease forwards}' +
        '.pk-modal-content{animation:pk-slide-up 0.3s cubic-bezier(0.16,1,0.3,1) forwards}' +
        '.pk-glass{' +
          'background:oklch(var(--b1)/0.95);' +
          'backdrop-filter:blur(20px) saturate(180%);' +
          '-webkit-backdrop-filter:blur(20px) saturate(180%);' +
          'border:1px solid var(--pk-border);' +
          'box-shadow:var(--pk-shadow)' +
        '}' +
        '.pk-category-card{' +
          'transition:all 0.2s ease;' +
          'background:var(--pk-bg-alt);' +
          'border:1px solid var(--pk-border)' +
        '}' +
        '.pk-category-card:hover{transform:translateY(-2px);box-shadow:0 4px 12px oklch(var(--bc)/0.1)}' +
        '.pk-toggle-track{background:var(--pk-border);transition:background 0.2s}' +
        '.pk-toggle-track.active{background:var(--pk-primary)}' +
        '.pk-toggle-thumb{background:var(--pk-bg);box-shadow:0 1px 3px oklch(var(--bc)/0.2)}' +
      '</style>';

      // Floating Icon (only shown in opt-in mode)
      var iconHTML = showIcon
        ? '<button id="pk-consent-icon" type="button" onclick="window.PhoenixKitConsent.openPreferences()" ' +
            'class="pk-floating-icon pk-glass" ' +
            'style="position:fixed;z-index:50;width:3rem;height:3rem;border-radius:9999px;display:flex;align-items:center;justify-content:center;cursor:pointer;background:var(--pk-primary);' + iconStyle + '" ' +
            'aria-label="Cookie preferences" title="Cookie preferences">' +
            '<svg style="width:1.5rem;height:1.5rem;color:var(--pk-primary-content)" viewBox="0 0 24 24" fill="currentColor">' +
              '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>' +
            '</svg>' +
          '</button>'
        : '';

      // Cookie icon SVG (reused in banner and modal)
      var cookieIconSVG = '<svg style="width:1.25rem;height:1.25rem;color:var(--pk-primary)" viewBox="0 0 24 24" fill="currentColor">' +
        '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93z"/>' +
      '</svg>';

      // Shield icon SVG for modal header
      var shieldIconSVG = '<svg style="width:1.25rem;height:1.25rem;color:var(--pk-primary)" viewBox="0 0 24 24" fill="currentColor">' +
        '<path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>' +
      '</svg>';

      // Close icon SVG
      var closeIconSVG = '<svg style="width:1.25rem;height:1.25rem" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">' +
        '<path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>' +
      '</svg>';

      // Banner HTML
      var bannerHTML = '<div id="pk-consent-banner" class="pk-banner pk-glass" ' +
        'style="position:fixed;bottom:0;left:0;right:0;z-index:50;display:none;border-radius:0" ' +
        'role="dialog" aria-label="Cookie consent" aria-hidden="true">' +
        '<div style="max-width:64rem;margin:0 auto;padding:1rem 1.5rem">' +
          '<div style="display:flex;flex-wrap:wrap;align-items:center;gap:1rem">' +
            '<div style="flex:1;display:flex;align-items:flex-start;gap:0.75rem;min-width:200px">' +
              '<div style="flex-shrink:0;width:2.5rem;height:2.5rem;border-radius:9999px;background:var(--pk-primary-soft);display:flex;align-items:center;justify-content:center">' +
                cookieIconSVG +
              '</div>' +
              '<div>' +
                '<h3 style="font-weight:600;font-size:0.875rem;margin:0;color:var(--pk-text)">We value your privacy</h3>' +
                '<p style="font-size:0.75rem;color:var(--pk-text-muted);margin:0.25rem 0 0 0">' +
                  'We use cookies to enhance your experience. ' +
                  '<a href="' + cookiePolicyUrl + '" style="color:var(--pk-primary);text-decoration:underline" target="_blank">Cookie Policy</a>' +
                '</p>' +
              '</div>' +
            '</div>' +
            '<div style="display:flex;gap:0.5rem;flex-wrap:wrap">' +
              '<button type="button" onclick="window.PhoenixKitConsent.openPreferences()" class="btn btn-ghost btn-sm" style="font-size:0.75rem">Customize</button>' +
              '<button type="button" onclick="window.PhoenixKitConsent.rejectAll()" class="btn btn-outline btn-sm" style="font-size:0.75rem">Reject</button>' +
              '<button type="button" onclick="window.PhoenixKitConsent.acceptAll()" class="btn btn-primary btn-sm" style="font-size:0.75rem">Accept All</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

      // Modal HTML
      var modalHTML = '<div id="pk-consent-modal" ' +
        'style="position:fixed;inset:0;z-index:100;display:none" ' +
        'role="dialog" aria-modal="true" aria-label="Cookie preferences">' +
        '<div class="pk-modal-backdrop" onclick="window.PhoenixKitConsent.closePreferences()" ' +
          'style="position:absolute;inset:0;background:oklch(var(--bc)/0.4);backdrop-filter:blur(4px)"></div>' +
        '<div style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;padding:1rem;pointer-events:none">' +
          '<div class="pk-modal-content pk-glass" style="width:100%;max-width:28rem;max-height:85vh;overflow:hidden;border-radius:1rem;pointer-events:auto">' +
            // Modal Header
            '<div style="display:flex;align-items:center;justify-content:space-between;padding:1rem 1.5rem;border-bottom:1px solid var(--pk-border)">' +
              '<div style="display:flex;align-items:center;gap:0.75rem;flex:1">' +
                '<div style="width:2.5rem;height:2.5rem;border-radius:9999px;background:var(--pk-primary-soft);display:flex;align-items:center;justify-content:center">' +
                  shieldIconSVG +
                '</div>' +
                '<div>' +
                  '<h2 style="font-weight:600;font-size:1.125rem;margin:0;color:var(--pk-text)">Privacy Preferences</h2>' +
                  '<p style="font-size:0.75rem;color:var(--pk-text-muted);margin:0">Manage your cookie settings</p>' +
                '</div>' +
              '</div>' +
              '<button type="button" onclick="window.PhoenixKitConsent.closePreferences()" class="btn btn-ghost btn-sm btn-circle" aria-label="Close">' +
                closeIconSVG +
              '</button>' +
            '</div>' +
            // Modal Body - Category Cards
            '<div style="padding:1rem 1.5rem;overflow-y:auto;max-height:50vh">' +
              createCategoryHTML("necessary", "🔒", "Essential", "Required for core functionality. Cannot be disabled.", true) +
              createCategoryHTML("analytics", "📊", "Analytics", "Help us understand how you use our site.") +
              createCategoryHTML("marketing", "📢", "Marketing", "Used for personalized advertising.") +
              createCategoryHTML("preferences", "⚙️", "Preferences", "Remember your settings and preferences.") +
            '</div>' +
            // Modal Footer
            '<div style="padding:1rem 1.5rem;border-top:1px solid var(--pk-border);background:var(--pk-bg-alt)">' +
              '<div style="display:flex;flex-wrap:wrap;align-items:center;gap:0.75rem">' +
                '<div style="font-size:0.75rem;color:var(--pk-text-muted)">' +
                  '<a href="' + privacyPolicyUrl + '" style="color:inherit;text-decoration:underline" target="_blank">Privacy Policy</a>' +
                  ' • ' +
                  '<a href="' + cookiePolicyUrl + '" style="color:inherit;text-decoration:underline" target="_blank">Cookie Policy</a>' +
                '</div>' +
                '<div style="margin-left:auto;display:flex;gap:0.5rem">' +
                  '<button type="button" onclick="window.PhoenixKitConsent.rejectAll()" class="btn btn-ghost btn-sm" style="font-size:0.75rem">Reject All</button>' +
                  '<button type="button" onclick="window.PhoenixKitConsent.savePreferences()" class="btn btn-primary btn-sm" style="font-size:0.75rem">Save Preferences</button>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

      return '<div id="pk-consent-root" class="pk-consent-widget">' +
        styles + iconHTML + bannerHTML + modalHTML +
      '</div>';
    }

    // ---------------------------------------------------------------------------
    // UI Show/Hide Functions
    // ---------------------------------------------------------------------------

    function injectWidget(config) {
      var existing = document.getElementById("pk-consent-root");
      if (existing) existing.remove();

      var container = document.createElement("div");
      container.innerHTML = createWidgetHTML(config);
      document.body.appendChild(container.firstChild);

      log("Widget injected into DOM");
    }

    function showBanner() {
      var banner = document.getElementById("pk-consent-banner");
      if (banner) {
        banner.style.display = "block";
        banner.setAttribute("aria-hidden", "false");
      }
    }

    function hideBanner() {
      var banner = document.getElementById("pk-consent-banner");
      if (banner) {
        banner.style.display = "none";
        banner.setAttribute("aria-hidden", "true");
      }
    }

    function showIcon() {
      var icon = document.getElementById("pk-consent-icon");
      if (icon && isOptInMode()) {
        icon.style.display = "flex";
        icon.style.opacity = "1";
      }
    }

    function hideIcon() {
      var icon = document.getElementById("pk-consent-icon");
      if (icon) {
        icon.style.opacity = "0";
      }
    }

    function showModal() {
      var modal = document.getElementById("pk-consent-modal");
      if (modal) {
        modal.style.display = "block";
        hideBanner();
        setTimeout(function() {
          var firstButton = modal.querySelector("button");
          if (firstButton) firstButton.focus();
        }, 100);
      }
    }

    function hideModal() {
      var modal = document.getElementById("pk-consent-modal");
      if (modal) {
        modal.style.display = "none";
      }
    }

    function updateCheckboxes() {
      var consent = PhoenixKitConsent.consent || {};
      CATEGORIES.forEach(function(category) {
        var checkbox = document.getElementById("pk-consent-" + category);
        if (checkbox && !checkbox.disabled) {
          checkbox.checked = !!consent[category];
        }
      });
    }

    function readCheckboxes() {
      var preferences = { necessary: true };
      CATEGORIES.forEach(function(category) {
        if (category === "necessary") return;
        var checkbox = document.getElementById("pk-consent-" + category);
        preferences[category] = checkbox ? checkbox.checked : false;
      });
      return preferences;
    }

    function updateUI() {
      if (shouldShowBanner()) {
        showBanner();
        hideIcon();
      } else {
        hideBanner();
        showIcon();
      }
      updateCheckboxes();
    }

    // ---------------------------------------------------------------------------
    // Public API
    // ---------------------------------------------------------------------------

    PhoenixKitConsent.acceptAll = function() {
      var consent = {
        necessary: true,
        analytics: true,
        marketing: true,
        preferences: true,
        timestamp: new Date().toISOString()
      };
      PhoenixKitConsent.consent = consent;
      saveConsent(consent);
      applyConsent(consent);
      hideBanner();
      hideModal();
      showIcon();
      log("All cookies accepted");
    };

    PhoenixKitConsent.rejectAll = function() {
      var consent = {
        necessary: true,
        analytics: false,
        marketing: false,
        preferences: false,
        timestamp: new Date().toISOString()
      };
      PhoenixKitConsent.consent = consent;
      saveConsent(consent);
      applyConsent(consent);
      hideBanner();
      hideModal();
      showIcon();
      log("Non-essential cookies rejected");
    };

    PhoenixKitConsent.savePreferences = function() {
      var preferences = readCheckboxes();
      preferences.timestamp = new Date().toISOString();
      PhoenixKitConsent.consent = preferences;
      saveConsent(preferences);
      applyConsent(preferences);
      hideModal();
      showIcon();
      log("Preferences saved", preferences);
    };

    PhoenixKitConsent.openPreferences = function() {
      updateCheckboxes();
      showModal();
      log("Preferences modal opened");
    };

    PhoenixKitConsent.closePreferences = function() {
      hideModal();
      log("Preferences modal closed");
    };

    PhoenixKitConsent.getConsent = function() {
      return PhoenixKitConsent.consent;
    };

    PhoenixKitConsent.hasConsent = function(category) {
      return PhoenixKitConsent.consent && !!PhoenixKitConsent.consent[category];
    };

    PhoenixKitConsent.revokeConsent = function() {
      try {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem(VERSION_KEY);
        PhoenixKitConsent.consent = null;
        updateUI();
        log("Consent revoked");
      } catch (e) {
        log("Could not revoke consent", e);
      }
    };

    // ---------------------------------------------------------------------------
    // Initialization Functions
    // ---------------------------------------------------------------------------

    function initFromConfig(config) {
      if (config.should_show === false) {
        log("Widget hidden (user authenticated or disabled)");
        return;
      }

      PhoenixKitConsent.config = {
        frameworks: config.frameworks || [],
        consentMode: config.consent_mode || "strict",
        policyVersion: config.policy_version || "1.0",
        googleConsentMode: config.google_consent_mode || false,
        iconPosition: config.icon_position || "bottom-right",
        showIcon: config.show_icon || false,
        cookiePolicyUrl: config.cookie_policy_url || "/legal/cookie-policy",
        privacyPolicyUrl: config.privacy_policy_url || "/legal/privacy-policy"
      };

      injectWidget(config);

      PhoenixKitConsent.elements = {
        root: document.getElementById("pk-consent-root"),
        icon: document.getElementById("pk-consent-icon"),
        banner: document.getElementById("pk-consent-banner"),
        modal: document.getElementById("pk-consent-modal")
      };

      if (PhoenixKitConsent.config.consentMode === "strict") {
        initGoogleConsentMode();
      }

      setupCrossTabSync();

      var stored = loadConsent();
      if (stored) {
        PhoenixKitConsent.consent = stored;
        applyConsent(stored);
      } else if (isOptInMode() && PhoenixKitConsent.config.consentMode === "strict") {
        blockScripts();
      }

      updateUI();

      document.addEventListener("keydown", function(e) {
        if (e.key === "Escape") hideModal();
      });

      PhoenixKitConsent.initialized = true;
      log("Initialized with config", PhoenixKitConsent.config);
    }

    function initFromElement(rootElement) {
      var config = {
        frameworks: JSON.parse(rootElement.dataset.frameworks || "[]"),
        consent_mode: rootElement.dataset.consentMode || "strict",
        policy_version: rootElement.dataset.policyVersion || "1.0",
        google_consent_mode: rootElement.dataset.googleConsentMode === "true",
        icon_position: rootElement.dataset.iconPosition || "bottom-right",
        show_icon: rootElement.dataset.showIcon === "true",
        cookie_policy_url: rootElement.dataset.cookiePolicyUrl || "/legal/cookie-policy",
        privacy_policy_url: rootElement.dataset.privacyPolicyUrl || "/legal/privacy-policy"
      };

      PhoenixKitConsent.config = {
        frameworks: config.frameworks,
        consentMode: config.consent_mode,
        policyVersion: config.policy_version,
        googleConsentMode: config.google_consent_mode,
        iconPosition: config.icon_position,
        showIcon: config.show_icon,
        cookiePolicyUrl: config.cookie_policy_url,
        privacyPolicyUrl: config.privacy_policy_url
      };

      PhoenixKitConsent.elements = {
        root: rootElement,
        icon: document.getElementById("pk-consent-icon"),
        banner: document.getElementById("pk-consent-banner"),
        modal: document.getElementById("pk-consent-modal")
      };

      if (PhoenixKitConsent.config.consentMode === "strict") {
        initGoogleConsentMode();
      }

      setupCrossTabSync();

      var stored = loadConsent();
      if (stored) {
        PhoenixKitConsent.consent = stored;
        applyConsent(stored);
      } else if (isOptInMode() && PhoenixKitConsent.config.consentMode === "strict") {
        blockScripts();
      }

      updateUI();

      document.addEventListener("keydown", function(e) {
        if (e.key === "Escape") hideModal();
      });

      PhoenixKitConsent.initialized = true;
      log("Initialized from element", PhoenixKitConsent.config);
    }

    function fetchConfigAndInit() {
      // Set by the phoenix_kit_js_sources compiler. When phoenix_kit_legal is
      // not installed there is nothing to fetch, so skip the round-trip
      // entirely rather than making one request per page load to be told 204.
      if (window.PHOENIX_KIT_CONSENT_AVAILABLE === false) {
        log("Legal module not installed; consent widget unavailable");
        return;
      }

      fetch(getConfigEndpoint(), { credentials: "same-origin" })
        .then(function(response) {
          // 204 = no Legal module. It carries no body ON PURPOSE: a body
          // saying consent is disabled would be read as a live config by
          // bundles vendored before this endpoint existed, and they respond by
          // calling resetGoogleConsentMode() — GRANTING every category on an
          // install that never opted into consent management at all. Treat it
          // as "nothing to do" and touch nothing.
          if (response.status === 204) return null;
          if (!response.ok) {
            throw new Error("Config endpoint returned " + response.status);
          }
          return response.json();
        })
        .then(function(config) {
          if (!config) return;
          if (config.enabled && config.should_show !== false) {
            initFromConfig(config);
          } else {
            log("Consent widget is disabled");
            resetGoogleConsentMode();
          }
        })
        .catch(function(err) {
          log("Could not fetch config (widget disabled or endpoint unavailable)", err);
        });
    }

    // ---------------------------------------------------------------------------
    // CookieConsent Hook
    // ---------------------------------------------------------------------------

    window.PhoenixKitHooks.CookieConsent = {
      mounted: function() {
        if (!PhoenixKitConsent.initialized) {
          initFromElement(this.el);
        }
      },
      destroyed: function() {
        PhoenixKitConsent.initialized = false;
      }
    };

    // ---------------------------------------------------------------------------
    // Export & Auto-Initialize
    // ---------------------------------------------------------------------------

    window.PhoenixKitConsent = PhoenixKitConsent;

    document.addEventListener("DOMContentLoaded", function() {
      var existingRoot = document.getElementById("pk-consent-root");
      if (existingRoot) {
        log("Widget already in DOM, waiting for LiveView hook");
        return;
      }
      fetchConfigAndInit();
    });
  })();


  // ============================================================================
  // 3. UTILITY HOOKS
  // ============================================================================
  //
  // Small, focused hooks for common UI interactions.
  //
  // ============================================================================

  // ---------------------------------------------------------------------------
  // TimezoneOffset Hook
  // ---------------------------------------------------------------------------
  //
  // Fills a hidden input with the browser's UTC offset in hours (e.g. "2",
  // "-5.5") on mount, so a new account starts with a timezone instead of
  // "Not set" — the server has no way to know the visitor's timezone on its
  // own. Rounded to the nearest quarter hour to match the offsets PhoenixKit
  // actually offers (whole and half/45-minute zones like UTC+5:30, +5:45).
  // Never overwrites a value the server already rendered (e.g. re-render
  // after a validation error), and the field pairs with phx-update="ignore"
  // so LiveView leaves it alone after this first mount.
  //
  // Usage in LiveView template:
  //   <input type="hidden" name="user[user_timezone]" phx-hook="TimezoneOffset" phx-update="ignore" />
  // ---------------------------------------------------------------------------

  window.PhoenixKitHooks.TimezoneOffset = {
    mounted() {
      if (this.el.value) return;
      var offsetHours = -new Date().getTimezoneOffset() / 60;
      var rounded = Math.round(offsetHours * 4) / 4;
      this.el.value = String(rounded);
    }
  };

  // ---------------------------------------------------------------------------
  // TimezoneDetector Hook
  // ---------------------------------------------------------------------------
  //
  // Reports the browser's IANA zone (e.g. "Europe/Warsaw") and its current UTC
  // offset to the LiveView, so the profile can say what it detected and warn
  // when the saved zone disagrees.
  //
  // Sends on mount and whenever the timezone select changes, as a plain
  // pushEvent rather than by injecting hidden inputs into the form the way the
  // original did — the form is owned by LiveView, and appending fields to it
  // from outside is how this stopped working the first time.
  //
  // Usage in LiveView template:
  //   <div id="..." phx-hook="TimezoneDetector" phx-target={@myself}>
  // ---------------------------------------------------------------------------

  window.PhoenixKitHooks.TimezoneDetector = {
    mounted() {
      this.report();
      this.el.addEventListener("change", () => this.report());
    },

    report() {
      var name = null;
      try {
        name = Intl.DateTimeFormat().resolvedOptions().timeZone;
      } catch (_) {
        // Very old browsers have no Intl timezone support. Nothing to report;
        // the server simply never shows a detected zone.
      }
      if (!name) return;

      var payload = {
        name: name,
        offset: String(-new Date().getTimezoneOffset() / 60)
      };
      var event = this.el.dataset.event || "phoenix_kit:timezone_detected";

      // Two mount points, one hook. In the layout there is no phx-target and
      // the event goes to the LiveView, where an attached handle_event hook
      // picks it up for every page. On the profile it targets the settings
      // LiveComponent, which owns the picker and the warning.
      // Wrapped: a hook can mount during a reconnect or a back/forward cache
      // restore, before the channel this pushes over is joined. Reporting a
      // timezone is a courtesy — it must never surface as an error to someone
      // who was only navigating.
      try {
        if (this.el.getAttribute("phx-target")) {
          this.pushEventTo(this.el, event, payload);
        } else {
          this.pushEvent(event, payload);
        }
      } catch (_) {
        // Next mount reports again.
      }
    }
  };

  // ---------------------------------------------------------------------------
  // ResetSelect Hook
  // ---------------------------------------------------------------------------
  //
  // Resets a select element to its first option when triggered by a server event.
  //
  // Usage in LiveView template:
  //   <select id="my-select" phx-hook="ResetSelect">...</select>
  //
  // Trigger from server:
  //   push_event(socket, "reset_select", %{id: "my-select"})
  //
  // ---------------------------------------------------------------------------

  window.PhoenixKitHooks.ResetSelect = {
    mounted() {
      this.handleEvent("reset_select", ({ id }) => {
        if (this.el.id === id) {
          this.el.selectedIndex = 0;
        }
      });
    }
  };

  // ---------------------------------------------------------------------------
  // PhoenixKitUrlState Hook
  // ---------------------------------------------------------------------------
  //
  // Carries list state (search / filters / sort / page) in the address bar for
  // a LiveView that cannot use push_patch.
  //
  // Why it exists: push_patch requires handle_params/3 to be exported, and
  // exporting it makes a LiveView impossible to embed with live_render/3. An
  // embeddable list therefore has to drive the URL from the client instead.
  //
  // Rendered by PhoenixKitWeb.Live.UrlState.url_state_sync/1 when the LiveView
  // declares `mode: :history`; nothing else should mount it by hand.
  //
  // Three jobs:
  //   1. on connect, report the query the page was opened with — an embedded
  //      LiveView receives :not_mounted_at_router instead of params, so this is
  //      the only way it can learn its own state;
  //   2. rewrite the address bar when the server pushes a new query;
  //   3. report Back and Forward, which is what makes history navigation work
  //      without a router.
  //
  // Only the query is exchanged. The path stays client-side deliberately: an
  // embedded LiveView has no idea which page it is on.
  //
  // ---------------------------------------------------------------------------

  window.PhoenixKitHooks.PhoenixKitUrlState = {
    mounted() {
      this.pushEvent("phoenix_kit_url_state", { query: window.location.search });

      // Keep the ref: handleEvent registers on the LiveSocket, not on the
      // element, so without removeHandleEvent in destroyed() every remount of
      // this hook leaves another live callback behind and one server push runs
      // the history write N times.
      this.pkHandleRef = this.handleEvent("phoenix_kit_url_state", ({ query, replace }) => {
        var next = window.location.pathname + (query ? "?" + query : "");

        // Nothing moved — recording it would put a duplicate in the history
        // stack and make one Back press look like it did nothing.
        if (next === window.location.pathname + window.location.search) return;

        if (replace) {
          window.history.replaceState({}, "", next);
        } else {
          window.history.pushState({}, "", next);
        }
      });

      this.pkOnPopState = function () {
        this.pushEvent("phoenix_kit_url_state", { query: window.location.search });
      }.bind(this);

      window.addEventListener("popstate", this.pkOnPopState);
    },

    destroyed() {
      if (this.pkOnPopState) {
        window.removeEventListener("popstate", this.pkOnPopState);
        this.pkOnPopState = null;
      }

      if (this.pkHandleRef) {
        this.removeHandleEvent(this.pkHandleRef);
        this.pkHandleRef = null;
      }
    }
  };

  // ---------------------------------------------------------------------------
  // PopupLink Hook
  // ---------------------------------------------------------------------------
  //
  // Opens a same-origin link in a named popup instead of navigating the page.
  // Nothing about it is OAuth-specific — connect_account_button/1 is simply its
  // first consumer. Replaces an inline onclick= (CSP-hostile, and the kit
  // removed inline handlers everywhere else for the same reason).
  //
  // The element is a real <a href>, so this degrades correctly: with JS off, or
  // when the popup is blocked, the browser performs the normal full-page
  // navigation rather than dead-ending on a cancelled click.
  //
  // Geometry and window name come from data attributes so nothing is
  // interpolated into a script string.
  //
  // Usage:
  //   <a href="/oauth/start" phx-hook="PopupLink"
  //      data-window-name="oauth-connect" data-window-width="480"
  //      data-window-height="680">Connect</a>
  //
  // ---------------------------------------------------------------------------

  // Pure: should this click be turned into a popup at all? A user asking for a
  // new tab (middle-click, cmd/ctrl-click) or a handler that already claimed
  // the event must be left alone.
  function shouldOpenPopup(event) {
    if (!event) return false;
    if (event.defaultPrevented) return false;
    if (typeof event.button === "number" && event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    return true;
  }

  // Pure: window.open feature string, centred on the screen the browser window
  // is actually on. screenLeft/Top describe the WINDOW, so a multi-monitor
  // setup needs them as the origin — centring on innerWidth alone throws the
  // popup onto the primary display.
  function popupFeatures(width, height, view) {
    var v = view || {};
    var w = Math.max(1, parseInt(width, 10) || 480);
    var h = Math.max(1, parseInt(height, 10) || 680);

    var originX = v.screenLeft !== undefined ? v.screenLeft : (v.screenX || 0);
    var originY = v.screenTop !== undefined ? v.screenTop : (v.screenY || 0);
    var outerW = v.outerWidth || w;
    var outerH = v.outerHeight || h;

    // Clamp the OFFSET, not the final coordinate: a monitor left of, or above,
    // the primary one has negative screen coordinates, and flooring those at 0
    // threw the popup back onto the primary display.
    var left = Math.round(originX + Math.max(0, (outerW - w) / 2));
    var top = Math.round(originY + Math.max(0, (outerH - h) / 2));

    return (
      "width=" + w + ",height=" + h + ",left=" + left + ",top=" + top +
      ",menubar=no,toolbar=no,location=yes,status=no,resizable=yes,scrollbars=yes"
    );
  }

  // Pure: is this link one we may open in a popup at all? The popup keeps its
  // `window.opener`, so a cross-origin target would hand that reference away.
  // The Elixir component enforces this too, but the bundle is copied verbatim
  // into host apps and the hook is a public name — a host wiring it onto an
  // arbitrary <a> must not be able to bypass the rule.
  function sameOrigin(href, base) {
    // A non-string href would otherwise be stringified and resolved as a
    // RELATIVE path ("undefined"), which lands back on our own origin and
    // quietly passes the check.
    if (typeof href !== "string" || href === "") return false;

    try {
      return new URL(href, base).origin === new URL(base).origin;
    } catch (_err) {
      return false;
    }
  }

  window.PhoenixKitHooks.PopupLink = {
    mounted() {
      this.onClick = (event) => {
        if (!shouldOpenPopup(event)) return;

        var el = this.el;
        if (!sameOrigin(el.href, window.location.href)) return;

        var name = el.dataset.windowName || "oauth-connect";
        var features = popupFeatures(el.dataset.windowWidth, el.dataset.windowHeight, window);

        var popup;
        try {
          popup = window.open(el.href, name, features);
        } catch (_err) {
          popup = null;
        }

        // Blocked or failed → let the click through so the plain href still
        // starts the flow full-page. Cancelling here unconditionally is what
        // made the old inline onclick a dead button behind a popup blocker.
        // Some blockers hand back a window that is already closed, and others
        // return one whose `closed` is undefined — treat both as blocked.
        if (!popup || popup.closed || typeof popup.closed === "undefined") return;

        event.preventDefault();
        try {
          popup.focus();
        } catch (_err) {
          /* focus is best-effort; a blocked focus must not break the flow */
        }
      };

      this.el.addEventListener("click", this.onClick);
    },

    destroyed() {
      if (this.onClick) {
        this.el.removeEventListener("click", this.onClick);
        this.onClick = null;
      }
    }
  };

  // Exported for the Node test harness (test/js); harmless in a browser.
  if (typeof module === "object" && module.exports) {
    module.exports.shouldOpenPopup = shouldOpenPopup;
    module.exports.popupFeatures = popupFeatures;
    module.exports.sameOrigin = sameOrigin;
  }

  // ---------------------------------------------------------------------------
  // MarkdownEditor
  //
  // Drives the core MarkdownEditor LiveComponent's textarea: cursor tracking,
  // list auto-continue, formatting-toolbar actions (data-md-action), insert /
  // prompt-insert pushed from the server (handleEvent), collaborative
  // set-content sync, and unsaved-changes browser-exit protection.
  //
  // Replaces the component's former inline <script> + inline onclick/onmousedown
  // handlers. Those broke under a strict Content-Security-Policy (a nonce never
  // authorizes inline event-handler attributes, and an absent nonce blocks the
  // <script>) and were unreliable on LiveView navigation (a patched-in <script>
  // never re-executes). A hook always mounts on navigation and needs no inline
  // script, so the editor now behaves like every other PhoenixKit feature.
  // ---------------------------------------------------------------------------
  window.PhoenixKitHooks.MarkdownEditor = {
    mounted() {
      this.globalId = this.el.dataset.globalId;
      this.protectNavigation = this.el.dataset.protectNavigation === "true";
      this.lastCursorPosition = 0;
      this.dirty = false;
      this._acquireTextarea();

      // Reaching here means JS + the hook ran — reveal the toolbar(s), which are
      // hidden by default so JS-dependent buttons never show as dead controls.
      this._revealToolbars();

      // Handle formatting-toolbar actions on mousedown, NOT click. preventDefault
      // on mousedown stops focus moving to the button, so the textarea keeps its
      // selection — a click would collapse the selection before we read it, so
      // bold/italic/link would wrap the wrong range. This is the same reason the
      // old markup used inline onmousedown="event.preventDefault()".
      this._onMouseDown = (e) => this._handleToolbarMouseDown(e);
      this.el.addEventListener("mousedown", this._onMouseDown);

      // Server -> client commands. push_event from a LiveComponent fans out to
      // EVERY MarkdownEditor hook on the page, so filter by global_id before
      // acting (a page can host more than one editor).
      this.handleEvent("markdown-editor-insert", ({ global_id, text }) => {
        if (global_id === this.globalId) this._insertAtCursor(text);
      });
      this.handleEvent("markdown-editor-prompt-insert", ({ global_id, prompt, template }) => {
        if (global_id !== this.globalId) return;
        const value = window.prompt(prompt || "");
        if (value && value.trim()) {
          this._insertAtCursor((template || "%{value}").replace("%{value}", value.trim()));
        }
      });
      this.handleEvent("set-content", ({ global_id, content }) => {
        // No global_id → legacy broadcast to the page's editor (back-compat).
        if (global_id && global_id !== this.globalId) return;
        if (!this.textarea || this.textarea.value === content) return;
        // Don't clobber the textarea mid-keystroke (collaborative spectators are
        // read-only, so this is a safety net rather than a common path).
        if (document.activeElement === this.textarea) return;
        this.textarea.value = content;
        this.lastCursorPosition = content ? content.length : 0;
        this.dirty = false;
      });
      // Browser-exit protection for unsaved changes.
      if (this.protectNavigation) {
        this._beforeUnload = (e) => {
          if (this._hasUnsavedChanges()) {
            e.preventDefault();
            e.returnValue = "";
            return "";
          }
        };
        window.addEventListener("beforeunload", this._beforeUnload);
      }
    },

    updated() {
      // morphdom usually preserves the textarea node (stable id), but re-acquire
      // defensively in case it was replaced. Re-reveal the toolbar in case a
      // re-render of the toolbar block restored its default `hidden` class.
      this._acquireTextarea();
      this._revealToolbars();
      // Trust the server once it reports a saved state — otherwise the local
      // `dirty` flag stays true for the page's life after the first keystroke
      // (only set-content clears it, which not every host pushes)
      // and the beforeunload guard fires a bogus "unsaved changes" prompt post-save.
      if (this.el.dataset.saveStatus === "saved") this.dirty = false;
    },

    destroyed() {
      if (this._beforeUnload) window.removeEventListener("beforeunload", this._beforeUnload);
    },

    // --- internals ---------------------------------------------------------

    _revealToolbars() {
      this.el.querySelectorAll("[data-md-toolbar]").forEach((t) => t.classList.remove("hidden"));
    },

    _acquireTextarea() {
      const ta = this.el.querySelector("textarea");
      if (ta === this.textarea) return;
      this.textarea = ta;
      if (!ta) return;
      ta.addEventListener("blur", () => { this.lastCursorPosition = ta.selectionStart; });
      ta.addEventListener("select", () => { this.lastCursorPosition = ta.selectionStart; });
      ta.addEventListener("click", () => { this.lastCursorPosition = ta.selectionStart; });
      ta.addEventListener("keyup", () => { this.lastCursorPosition = ta.selectionStart; });
      ta.addEventListener("input", () => { this.dirty = true; });
      ta.addEventListener("keydown", (e) => this._handleEnter(e));
    },

    _hasUnsavedChanges() {
      const status = this.el.dataset.saveStatus;
      return this.dirty || status === "unsaved" || status === "saving";
    },

    // Mirror the textarea's phx-keyup binding so LiveView sees the new value.
    _notifyChange() {
      this.dirty = true;
      if (this.textarea) {
        this.textarea.dispatchEvent(new KeyboardEvent("keyup", { bubbles: true }));
      }
    },

    _insertAtCursor(text) {
      const ta = this.textarea;
      if (!ta || text == null) return;
      const start = Math.min(this.lastCursorPosition || 0, ta.value.length);
      ta.value = ta.value.substring(0, start) + text + ta.value.substring(start);
      const pos = start + text.length;
      ta.selectionStart = ta.selectionEnd = pos;
      this.lastCursorPosition = pos;
      ta.focus();
      this._notifyChange();
    },

    _wrap(prefix, suffix) {
      const ta = this.textarea;
      if (!ta) return;
      const start = ta.selectionStart;
      const end = ta.selectionEnd;
      const selected = ta.value.substring(start, end);
      const before = ta.value.substring(0, start);
      const after = ta.value.substring(end);
      if (selected.length > 0) {
        ta.value = before + prefix + selected + suffix + after;
        ta.selectionStart = start + prefix.length;
        ta.selectionEnd = end + prefix.length;
      } else {
        const placeholder = "text";
        ta.value = before + prefix + placeholder + suffix + after;
        ta.selectionStart = start + prefix.length;
        ta.selectionEnd = start + prefix.length + placeholder.length;
      }
      ta.focus();
      this.lastCursorPosition = ta.selectionEnd;
      this._notifyChange();
    },

    _linePrefix(prefix) {
      const ta = this.textarea;
      if (!ta) return;
      const start = ta.selectionStart;
      const lineStart = ta.value.lastIndexOf("\n", start - 1) + 1;
      ta.value = ta.value.substring(0, lineStart) + prefix + ta.value.substring(lineStart);
      const pos = start + prefix.length;
      ta.selectionStart = ta.selectionEnd = pos;
      this.lastCursorPosition = pos;
      ta.focus();
      this._notifyChange();
    },

    _link() {
      const ta = this.textarea;
      if (!ta) return;
      const url = window.prompt("Enter URL:");
      if (!url || !url.trim()) return;
      const start = ta.selectionStart;
      const end = ta.selectionEnd;
      const selected = ta.value.substring(start, end);
      const linkText = selected.length > 0 ? selected : "link text";
      ta.value =
        ta.value.substring(0, start) +
        "[" + linkText + "](" + url.trim() + ")" +
        ta.value.substring(end);
      const pos = start + linkText.length + url.trim().length + 4;
      ta.selectionStart = ta.selectionEnd = pos;
      this.lastCursorPosition = pos;
      ta.focus();
      this._notifyChange();
    },

    _handleToolbarMouseDown(e) {
      if (e.button !== 0) return;
      const toolbar = e.target.closest("[data-md-toolbar]");
      if (!toolbar || !this.el.contains(toolbar)) return;
      // Keep the textarea focused/selected through the button press.
      e.preventDefault();
      const btn = e.target.closest("[data-md-action]");
      if (!btn) return;
      switch (btn.dataset.mdAction) {
        case "wrap":
          this._wrap(btn.dataset.mdPrefix || "", btn.dataset.mdSuffix || "");
          break;
        case "line-prefix":
          this._linePrefix(btn.dataset.mdPrefix || "");
          break;
        case "insert":
          this._insertAtCursor(btn.dataset.mdText || "");
          break;
        case "link":
          this._link();
          break;
      }
    },

    _handleEnter(e) {
      if (e.key !== "Enter") return;
      const ta = this.textarea;
      const pos = ta.selectionStart;
      const value = ta.value;
      const lineStart = value.lastIndexOf("\n", pos - 1) + 1;
      const lineEnd = value.indexOf("\n", pos);
      const currentLine = value.substring(lineStart, lineEnd === -1 ? value.length : lineEnd);
      // Only auto-continue when the cursor is at the end of the line.
      if (pos - lineStart < currentLine.length) return;

      const bulletMatch = currentLine.match(/^(\s*)(-|\*|\+)\s(.*)$/);
      if (bulletMatch) {
        e.preventDefault();
        const [, indent, marker, content] = bulletMatch;
        this._continueList(ta, value, pos, lineStart, content, indent + marker + " ");
        return;
      }
      const numberMatch = currentLine.match(/^(\s*)(\d+)\.\s(.*)$/);
      if (numberMatch) {
        e.preventDefault();
        const [, indent, num, content] = numberMatch;
        const next = parseInt(num, 10) + 1;
        this._continueList(ta, value, pos, lineStart, content, indent + next + ". ");
      }
    },

    _continueList(ta, value, pos, lineStart, content, marker) {
      if (content.trim() === "") {
        // Empty list item — remove the marker instead of continuing.
        ta.value = value.substring(0, lineStart) + value.substring(pos);
        ta.selectionStart = ta.selectionEnd = lineStart;
      } else {
        const insertion = "\n" + marker;
        ta.value = value.substring(0, pos) + insertion + value.substring(pos);
        ta.selectionStart = ta.selectionEnd = pos + insertion.length;
      }
      this.lastCursorPosition = ta.selectionStart;
      this._notifyChange();
    }
  };

  // ---------------------------------------------------------------------------
  // SelectOnMount
  //
  // Focuses an input and selects all of its current value on mount. Use
  // for inline-rename inputs and similar type-to-replace flows where
  // JS.focus() alone leaves the cursor at the end and forces the user
  // to reach for the mouse / select-all shortcut before retyping.
  // ---------------------------------------------------------------------------
  window.PhoenixKitHooks.SelectOnMount = {
    mounted() {
      this.el.focus();
      this.el.select();
    }
  };

  // ---------------------------------------------------------------------------
  // AnnotationComposerPosition
  //
  // Positions the MediaBrowser's floating annotation-composer popover
  // directly above the shape it belongs to (falling back to below if
  // there's no room above, then clamping to the viewer container).
  //
  // The popover's element id encodes the annotation uuid as suffix
  // ("annotation-composer-popover-<uuid>"); Etcher tags each shape's
  // root SVG element with the same uuid via `data-uuid`. The hook
  // queries for that element and uses its bounding rect to compute
  // the popover's left/top in the parent container's coordinate space.
  //
  // Etcher 0.3's bulk `annotations-changed` event doesn't carry an
  // anchor for newly-drawn shapes (the old per-op `etcher:created`
  // emitted `anchor_x`/`anchor_y`), so the server can no longer seed
  // container-space coords. Reading the shape's DOM rect on the client
  // sidesteps the need for any image-to-screen math server-side and
  // keeps positioning correct after pan/zoom.
  //
  // Re-runs on mount, server-driven updates, and window resize. An 8px
  // margin keeps the popover from touching the container edge.
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // ViewerKeydown — global keydown shortcut handler for the media viewer
  // modal, with two filters that the stock `phx-window-keydown` can't
  // express:
  //
  //   1. Only Escape / ArrowLeft / ArrowRight reach the server. Letter
  //      keys typed into the annotation composer no longer fire the
  //      modal's nav handler and spam the LV logs.
  //   2. Even the navigation keys are suppressed when focus is inside an
  //      <input> / <textarea> / contenteditable so the arrow keys can
  //      move the text caret without flipping the modal to the next
  //      image while the user is typing.
  //
  // Pushes to the hook element's component so the existing
  // `handle_event "viewer_keydown"` clauses keep working unchanged.
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // ViewerPaneFit — the stacked pane holds the picture's shape, not a guess.
  //
  // A portrait popup stacks: picture on top, details docked under it. The pane
  // is sized by `aspect-ratio: var(--pk-pane-aspect)` rather than by a share
  // of the popup's height, so the popup ends up as tall as the picture plus
  // the panel instead of 90vh of mostly empty canvas.
  //
  // The server renders that variable from the file's own width and height,
  // which is right for the picture as uploaded and is what makes the FIRST
  // paint correct. It is not always right about what gets painted: the viewer
  // opens on a burned copy wherever one exists, and a burn is not always
  // composed at the picture's ratio — a 1.69 photograph with a 1.33 burn gets
  // a pane too wide for it and a band of empty canvas down each side.
  //
  // So the prediction is corrected from the bitmap on screen, once it is
  // decoded. That element is the truth about rotation, edits and whatever the
  // burn did, and reading `naturalWidth` off it costs nothing.
  // ---------------------------------------------------------------------------

  window.PhoenixKitHooks.ViewerPaneFit = {
    mounted() { this._fit(); },
    updated() { this._fit(); },

    // Is the picture standing on its side? Fresco turns it by transforming
    // the stage, so the answer is in the matrix rather than in a class:
    // matrix(a, b, …) is a·cosθ and a·sinθ scaled alike, so |a| < |b| is a
    // quarter turn at any zoom. Panning changes only the translation and so
    // cannot flip the answer.
    _turned(stage) {
      if (!stage) return false;
      const m = /^matrix\(([^)]+)\)/.exec(getComputedStyle(stage).transform || "");
      if (!m) return false;
      const parts = m[1].split(",").map(Number);
      return Math.abs(parts[0]) < Math.abs(parts[1]);
    },

    _fit() {
      const pane = this.el.querySelector("[data-viewer-pane]");
      if (!pane) return;
      const img = pane.querySelector("img");
      if (!img) return;
      const self = this;
      const stage = img.closest(".fresco-stage") || img.parentElement;

      const apply = function() {
        if (!(img.naturalWidth > 0 && img.naturalHeight > 0)) return;
        // The shape ON SCREEN — the same swap the server applies to a stored
        // rotation and the stand-in applies to the card's own class.
        const turned = self._turned(stage) ||
          /(^|\s|-)rotate-(90|270)\b/.test(img.className);
        const w = turned ? img.naturalHeight : img.naturalWidth;
        const h = turned ? img.naturalWidth : img.naturalHeight;
        const value = w + " / " + h;
        // Written only when it changes: the observer below fires on every
        // frame of a pan, and each write is a style recalculation.
        if (value === self._last) return;
        self._last = value;
        pane.style.setProperty("--pk-pane-aspect", value);
      };

      // Cached bitmaps are already decoded on mount (the grid painted this
      // one), and the viewer's ladder climbs small → large while it is open,
      // so this listens as well as reading: `load` fires again on each rung,
      // and a rung of a different shape would otherwise stay mispredicted.
      if (img.complete) apply();
      if (this._img !== img) {
        if (this._img && this._apply) this._img.removeEventListener("load", this._apply);
        img.addEventListener("load", apply);
        this._img = img;
        this._apply = apply;
      }

      // Rotating is Fresco's own doing and patches nothing, so `updated()`
      // never fires for it. Without this the pane keeps the shape it had and
      // a turned picture is fitted into a slot the wrong way round — 216px
      // wide where it could be the full width of the popup.
      if (stage && this._stage !== stage && typeof MutationObserver === "function") {
        if (this._obs) this._obs.disconnect();
        this._obs = new MutationObserver(apply);
        this._obs.observe(stage, { attributes: true, attributeFilter: ["style", "class"] });
        this._stage = stage;
      }
    },

    destroyed() {
      if (this._img && this._apply) this._img.removeEventListener("load", this._apply);
      if (this._obs) this._obs.disconnect();
    }
  };

  // ---------------------------------------------------------------------------
  // InstantViewer — put the picture on screen on the click, not on the reply.
  //
  // Opening the viewer is a server round trip: the modal does not exist in the
  // DOM until LiveView sends it back. The server's part of that is ~2ms, so on
  // a fast connection it reads as a small hitch and on a slow one as a wait,
  // and in both cases the thing you clicked is a picture the browser ALREADY
  // HAS — the grid painted it.
  //
  // So this paints it immediately, full size, behind a backdrop, and gets out
  // of the way when the real viewer arrives. Nothing here talks to the server
  // or changes what gets opened; it is the same bitmap the card is showing,
  // scaled up, for the length of one round trip.
  //
  // Listens on the document in the CAPTURE phase so it runs before LiveView
  // sends the event, which is the whole point — a listener that waited its turn
  // would be racing the thing it exists to hide.
  // ---------------------------------------------------------------------------

  window.PhoenixKitHooks.InstantViewer = {
    mounted() {
      const self = this;
      const el = self.el;

      // Hidden until a click, and never left showing: `_hide` is called by the
      // real viewer's arrival, by a click that turns out not to open one, and
      // by a timeout — see below for why all three are needed.
      self._hide = function() {
        self._stepping = false;
        el.style.display = "none";
        const img = el.querySelector("img");
        if (img) {
          img.removeAttribute("src");
          // Drop the swapped box a rotated stand-in needed, or the next
          // open inherits a sideways frame.
          img.style.width = "";
          img.style.height = "";
        }
        // Undo the see-through state (below) so the next open starts as a
        // full stand-in again: its own backdrop, an opaque box, a visible
        // skeleton pane.
        el.style.backgroundColor = "";
        el.style.removeProperty("--pk-pane-aspect");
        const box = el.querySelector(".modal-box");
        if (box) box.style.backgroundColor = "";
        const pane = el.querySelector('[data-pane="sidebar"]');
        if (pane) pane.style.visibility = "";
        if (self._timer) { clearTimeout(self._timer); self._timer = null; }
        if (self._closeGrace) { clearTimeout(self._closeGrace); self._closeGrace = null; }
        self._loadingPill(false);
      };

      // The stand-in's "Loading full quality…" pill: up a beat after the
      // stand-in shows (a hand-over inside that beat never flashes it), gone
      // the instant the stand-in goes. The real viewer's pill takes over from
      // there for any sharper rung still on its way.
      self._loadingPill = function(on) {
        const pill = el.querySelector("[data-standin-loading]");
        if (self._pillTimer) { clearTimeout(self._pillTimer); self._pillTimer = null; }
        if (!pill) return;
        if (on) {
          self._pillTimer = setTimeout(function() {
            self._pillTimer = null;
            pill.style.opacity = "1";
          }, 300);
        } else {
          // No fade needed: the stand-in itself is display:none by now.
          pill.style.opacity = "0";
        }
      };
      self._hide();

      // Paint a bitmap into the stand-in and show it — shared by the two
      // triggers: opening from a grid card, and stepping prev/next inside
      // the viewer (whose neighbour bitmaps the warm has already cached).
      // `aspect` is the picture's own ratio ("3000 / 2000"), or null when
      // nobody could say. A portrait popup sizes the picture pane to it
      // instead of to a share of the popup's height, so the stand-in has to
      // predict it along with the sidebar: a stand-in that guessed square
      // for a panorama would hand over by resizing the whole box, which is
      // the jump this exists to prevent. Null leaves the last one in place —
      // a neighbour is usually shaped like the picture you are looking at,
      // and the real viewer corrects it either way.
      self._show = function(src, rotationClass, aspect) {
        const shown = el.querySelector("img");
        if (!shown) return;
        if (aspect) el.style.setProperty("--pk-pane-aspect", aspect);

        // Predict the layout the real viewer is about to use: image column
        // alone, or image + info sidebar — which is open by default, so
        // painting the image over the full popup and shrinking it when the
        // sidebar mounts is its own flash. The last viewer seen this
        // session is the best predictor (the user may have toggled the
        // sidebar inside it); before any viewer has opened, the
        // server-rendered pref decides.
        const pane = el.querySelector('[data-pane="sidebar"]');
        if (pane) {
          const open = self._sidebarWasOpen !== undefined
            ? self._sidebarWasOpen
            : el.dataset.sidebarOpen === "true";
          pane.style.display = open ? "" : "none";
          pane.style.visibility = "";
        }
        el.style.backgroundColor = "";
        const box = el.querySelector(".modal-box");
        if (box) box.style.backgroundColor = "";

        shown.setAttribute("src", src);
        shown.className = shown.dataset.baseClass +
          " " + (rotationClass || "");

        // A quarter turn needs the box turned with it. `object-contain`
        // fits the picture to the element BEFORE the transform, so
        // rotating a wide element 90° leaves a wide picture standing on
        // its side: far too tall for the column, clipped left and right,
        // and enormously magnified — which is exactly the "strange
        // stretched image" this fixes. Sizing the element to the column's
        // height × width first means the fit happens against the box the
        // picture will actually occupy, and the rotation then lands it
        // square in the column. The flex centring keeps it centred, and
        // the rotation turns about its own centre.
        //
        // Shown FIRST, measured second: the stand-in rests at
        // `display:none`, and a frame inside a hidden element measures
        // 0 × 0 — so measuring before the reveal skipped the fit on every
        // open from the grid, which is the case this exists for. The read
        // forces one layout and nothing paints in between. The box is
        // cleared before it is measured, so a frame that cannot be
        // measured falls back to the class-driven size rather than keeping
        // the previous picture's.
        shown.style.width = "";
        shown.style.height = "";
        el.style.display = "";

        var quarter = /rotate-(90|270)/.test(rotationClass || "");
        var frame = shown.parentNode;
        if (quarter && frame && frame.getBoundingClientRect) {
          var fr = frame.getBoundingClientRect();
          if (fr.width && fr.height) {
            shown.style.width = fr.height + "px";
            shown.style.height = fr.width + "px";
          }
        }

        // A trigger that opens nothing — a stale uuid, a server error, a
        // connection that drops between here and there — must not leave a
        // picture stuck over the page. The real viewer normally clears this
        // in well under a second.
        if (self._timer) clearTimeout(self._timer);
        self._timer = setTimeout(self._hide, 8000);
        self._loadingPill(true);
      };

      self._onClick = function(e) {
        // Stepping inside the viewer: the chevron buttons. The neighbour's
        // warmed small paints immediately, blurred, so the press reads as
        // motion instead of the viewer freezing on the old image.
        const step = e.target.closest && e.target.closest('[phx-click="step_viewer"]');
        if (step) {
          // The viewer the press is in: a page can hold two browsers (a picker
          // beside another), and the first viewer in the document may be the
          // other one's.
          const own = step.closest && step.closest('[id$="-viewer-modal"]');
          const modal = own || document.querySelector('[id$="-viewer-modal"]');
          const d = (modal && modal.dataset) || {};
          const dir = step.getAttribute("phx-value-dir");
          const src = dir === "prev" ? d.stepPrevSrc : d.stepNextSrc;
          const rot = dir === "prev" ? d.stepPrevRot : d.stepNextRot;
          const asp = dir === "prev" ? d.stepPrevAspect : d.stepNextAspect;
          if (src) {
            self._stepping = true;
            self._show(src, rot || "", asp || null);
          }
          return;
        }

        const card = e.target.closest && e.target.closest('[phx-click="click_file"]');
        if (!card) return;
        // Only this browser's own cards: a page can hold two (a picker opened
        // beside another), and each has a stand-in of its own.
        const browser = el.parentElement;
        if (browser && !browser.contains(card)) return;
        // Select mode turns the same click into a checkbox toggle, and a
        // picker's click may open nothing at all. The browser marks which it
        // is, so this can stay out of both.
        if (el.dataset.armed !== "true") return;

        const img = card.querySelector("img");
        const src = img && img.getAttribute("src");
        if (!src) return;

        // Carry the card's rotation across, or a sideways photo would flip
        // upright for a moment and then turn back.
        const rot = (img.className.match(/rotate-\d+/) || [""])[0];

        // The grid already decoded this bitmap, so its true shape is a
        // property read — no load, no round trip. A quarter turn swaps the
        // axes here exactly as it does server-side.
        let aspect = null;
        if (img.naturalWidth > 0 && img.naturalHeight > 0) {
          const turned = /rotate-(90|270)\b/.test(rot);
          aspect = turned
            ? img.naturalHeight + " / " + img.naturalWidth
            : img.naturalWidth + " / " + img.naturalHeight;
        }
        self._show(src, rot, aspect);
      };
      document.addEventListener("click", self._onClick, true);

      // Keyboard steps announce themselves from ViewerKeydown (which owns
      // the arrow keys and the modal's neighbour data).
      self._onStep = function(e) {
        const d = e && e.detail;
        if (!d || !d.src) return;
        self._stepping = true;
        self._show(d.src, d.rotation || "", d.aspect || null);
      };
      window.addEventListener("pk:viewer-step", self._onStep);

      // Start the viewer's downloads BEFORE the click. Opening fetches
      // `small` and then `large` — a third of a megabyte that used to
      // start moving only after the round trip. A pointer rests on a card
      // for a beat before the button goes down, which is enough head
      // start for the fetches to be in cache (immutable, so the browser
      // serves them without revalidating) by the time the viewer asks.
      // pointerdown is the backstop for touch, where there is no hover.
      // Each URL is fetched once per page; a miss costs nothing extra —
      // it is the same download the click was about to start anyway.
      self._prefetched = {};
      self._prefetch = function(e) {
        const card = e.target.closest && e.target.closest('[phx-click="click_file"]');
        if (!card || !card.dataset) return;
        for (const key of ["prefetchSmall", "prefetchLarge"]) {
          const url = card.dataset[key];
          if (!url || self._prefetched[url]) continue;
          self._prefetched[url] = true;
          new Image().src = url;
        }
      };
      // pointerover, not pointerenter: only the former bubbles.
      document.addEventListener("pointerover", self._prefetch, true);
      document.addEventListener("pointerdown", self._prefetch, true);

      // The real viewer says when it is up. Nothing else can: the modal is a
      // different LiveComponent that this hook has no reference to, so it
      // hands its own element over in the event.
      //
      // Mounting is not the same moment as being PAINTED, and the difference
      // is visible: the card shows `thumbnail_annotated` where the viewer
      // loads `small`, so the two are usually different URLs and the real one
      // is not in cache. Hiding on mount would swap the blurred picture for an
      // empty box and then paint — the flash this whole hook exists to remove.
      // So hold on until the real bitmap is actually on screen.
      self._onReady = function(e) {
        self._stepping = false;
        // The viewer is (still) here — a mid-step close signal that was
        // waiting to take the stand-in down was the old one's teardown
        // after all.
        if (self._closeGrace) { clearTimeout(self._closeGrace); self._closeGrace = null; }
        const root = e && e.detail && e.detail.el;

        // Remember the layout this viewer actually used, so the NEXT
        // stand-in predicts it right even after the user toggles the
        // sidebar mid-session — the server-rendered pref cannot follow
        // that, its assign never refreshes on a toggle.
        if (root && root.querySelector) {
          self._sidebarWasOpen = !!root.querySelector("[data-viewer-sidebar]");
        }

        // Nothing to hand over — the viewer opened without the stand-in
        // (select-mode click, a card with no image).
        if (el.style.display === "none") return;

        // No element to align with (defensive) — just get out of the way.
        if (!root || !root.querySelector) { self._hide(); return; }

        // The real modal mounts UNDER this stand-in (the stand-in carries
        // z-index 1000 against .modal's 999) and its sidebar content is
        // ready NOW — only its image is still in flight. So turn the
        // stand-in into a window: its own backdrop, box, and skeleton pane
        // go transparent, leaving just the blurry image column floating
        // exactly over the real modal's identical — and still empty —
        // image column. The real sidebar shows through immediately, and
        // the empty column never shows at all.
        //
        // The darkness swaps in the same frame: the real .modal-open
        // paints its own 40% black as the stand-in's goes transparent —
        // exactly one dark layer at every moment, no doubling and no dip.
        // Both transitions are off (the stand-in's inline in the markup),
        // or daisyUI's 0.3s background fade would turn the swap into a
        // visible dip.
        if (root.style) root.style.transition = "none";
        el.style.backgroundColor = "transparent";
        const box = el.querySelector(".modal-box");
        if (box) box.style.backgroundColor = "transparent";
        const pane = el.querySelector('[data-pane="sidebar"]');
        if (pane) {
          // The real layout is here, so truth replaces prediction: on a
          // mispredicted open the blurry column snaps to the right width
          // now rather than covering the real sidebar until the image
          // loads. visibility (not display) keeps the column's ground.
          pane.style.display = self._sidebarWasOpen ? "" : "none";
          pane.style.visibility = "hidden";
        }

        const real = root.querySelector("img");
        // No image to wait for, or already decoded (same URL as the card, or
        // a warm cache) — hand over now.
        if (!real || real.complete) { self._hide(); return; }

        const done = function() {
          real.removeEventListener("load", done);
          real.removeEventListener("error", done);
          self._hide();
        };
        // `error` too: a broken image must not leave the stand-in up pretending
        // the picture loaded. The 8s fallback still covers anything that fires
        // neither.
        real.addEventListener("load", done);
        real.addEventListener("error", done);
      };
      window.addEventListener("pk:viewer-open", self._onReady);

      // Escape (or anything else) can close the viewer while the hold is
      // still waiting on the image — the modal is torn out from under the
      // floating blurry column, which would otherwise hang over the grid
      // until the fallback timer. The viewer announces its teardown.
      self._onClosed = function() {
        // A step tears the OLD viewer down on its way to the new one —
        // that teardown must not kill the stand-in that exists to bridge
        // it. But a REAL close mid-step (Escape, or a backdrop click that
        // fell through this pointer-events-none overlay onto the actual
        // modal) must: ignoring it outright left the blur orphaned over
        // a viewer that was already gone, until the fallback timer. The
        // two are indistinguishable here, so give the replacement viewer
        // a beat to announce itself — pk:viewer-open cancels the hide —
        // and take the blur down when nothing does.
        if (self._stepping) {
          if (self._closeGrace) clearTimeout(self._closeGrace);
          self._closeGrace = setTimeout(self._hide, 400);
          return;
        }
        self._hide();
      };
      window.addEventListener("pk:viewer-closed", self._onClosed);
    },

    destroyed() {
      document.removeEventListener("click", this._onClick, true);
      document.removeEventListener("pointerover", this._prefetch, true);
      document.removeEventListener("pointerdown", this._prefetch, true);
      window.removeEventListener("pk:viewer-open", this._onReady);
      window.removeEventListener("pk:viewer-closed", this._onClosed);
      window.removeEventListener("pk:viewer-step", this._onStep);
      if (this._timer) { clearTimeout(this._timer); this._timer = null; }
      if (this._pillTimer) { clearTimeout(this._pillTimer); this._pillTimer = null; }
    }
  };

  // RemovalModal — the media browser's removal dialog (the removal guard's
  // confirmation, or the list of places a file is in use). The element carries
  // `popover="manual"`: shown as a popover it sits in the browser's top layer,
  // above an open viewer and above a host's <dialog>. Escape closes THIS
  // dialog and nothing under it: the key is taken in the capture phase, before
  // the viewer's or the host dialog's own listener sees it.
  window.PhoenixKitHooks.RemovalModal = {
    mounted() {
      const self = this;
      self._showPopover = function() {
        const el = self.el;
        if (!el.hasAttribute || !el.hasAttribute("popover") || typeof el.showPopover !== "function") return;
        let open = false;
        try { open = el.matches(":popover-open"); } catch (_e) { open = false; }
        if (!open) {
          try { el.showPopover(); } catch (_e) { /* not connected, or already shown */ }
        }
      };
      self._showPopover();
      // Focusable things inside the dialog: Tab goes round them and never
      // reaches the page (or the viewer) underneath.
      function focusables() {
        const all = (self.el.querySelectorAll && self.el.querySelectorAll("a[href], button")) || [];
        return Array.prototype.filter.call(all, function(n) { return !n.disabled; });
      }
      self._onKey = function(e) {
        if (e.key === "Tab") {
          const list = focusables();
          e.preventDefault();
          if (!list.length) return;
          const first = list[0];
          const last = list[list.length - 1];
          const active = document.activeElement;
          const inside = !!(active && self.el.contains && self.el.contains(active));
          if (!inside || (e.shiftKey && active === first)) {
            (e.shiftKey && inside ? last : first).focus();
          } else if (!e.shiftKey && active === last) {
            first.focus();
          } else {
            const i = list.indexOf(active);
            list[e.shiftKey ? i - 1 : i + 1].focus();
          }
          return;
        }
        // The viewer under the dialog must not step while it asks about a file.
        if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        if (e.key !== "Escape") return;
        e.preventDefault();
        e.stopPropagation();
        self.pushEventTo(self.el, "removal_cancel", { token: (self.el.dataset && self.el.dataset.token) || "" });
      };
      window.addEventListener("keydown", self._onKey, true);
      // Keyboard focus goes to the dialog's safe button, not a destructive one.
      const cancel = self.el.querySelector && self.el.querySelector("[id$='-removal-cancel']");
      if (cancel && typeof cancel.focus === "function") cancel.focus();
    },
    updated() {
      if (this._showPopover) this._showPopover();
    },
    destroyed() {
      if (this._onKey) {
        window.removeEventListener("keydown", this._onKey, true);
        this._onKey = null;
      }
    }
  };

  window.PhoenixKitHooks.ViewerKeydown = {
    mounted() {
      const self = this;
      // A picker's viewer carries `popover` (see MediaBrowser's browser
      // template): shown as a popover it sits in the browser's top layer, so
      // a host modal's transformed box — the containing block of anything
      // `position: fixed` inside it — cannot clip it, and it paints above
      // the host's <dialog>. `manual`: no light dismiss and no Escape of its
      // own; the key handler below owns Escape. A browser without the
      // Popover API has no `showPopover` and keeps the popup where it is.
      // Again from updated(): a patch must not leave it hidden.
      self._showPopover = function() {
        const el = self.el;
        if (!el.hasAttribute || !el.hasAttribute("popover") || typeof el.showPopover !== "function") return;
        let open = false;
        try { open = el.matches(":popover-open"); } catch (_e) { open = false; }
        if (!open) {
          try { el.showPopover(); } catch (_e) { /* not connected, or already shown */ }
        }
      };
      self._showPopover();
      // Tell the stand-in the real viewer is here. It needs the element to
      // find the image and wait for it to paint — mounted is not painted.
      window.dispatchEvent(new CustomEvent("pk:viewer-open", { detail: { el: self.el } }));

      // Warm the NEIGHBOURS' small + large while this image is being looked
      // at. An arrow press remounts the viewer on the next file, and its
      // small + large variants used to start downloading only then — that
      // download was the whole wait between pressing → and seeing the
      // picture. The files are served immutable, so a warmed URL is a cache
      // hit; each is fetched once per page (the map is module-level and
      // shared across remounts).
      //
      // Three manners, because a warm is a favour to the NEXT press and must
      // never cost the picture on screen anything:
      //   - it waits until the current picture has settled (its sharper
      //     version is in and the canvas has been quiet a moment), so the
      //     warm never races the download the person is actually waiting on;
      //   - it runs at low fetch priority;
      //   - it does not run at all on data-saver or a 2G/3G line.
      //
      // Originals are NOT warmed here: whether a multi-MB original is worth
      // fetching depends on the screen, the line and which way the person is
      // stepping — high-end viewing, which a module decides. Core announces
      // the neighbours once settled (`pk:viewer-neighbours`) and
      // phoenix_kit_photos listens.
      window.__pkWarmedUrls = window.__pkWarmedUrls || {};
      var SETTLE_QUIET_MS = 600;
      var SETTLE_MAX_MS = 4000;
      // Calls `done` once the canvas image is loaded and nothing has loaded
      // for SETTLE_QUIET_MS (Tessera climbs rungs, each a load), or after
      // SETTLE_MAX_MS whatever happens. Returns a cancel function.
      function afterSettled(root, done) {
        var finished = false, quiet = null, cap = null;
        function stop() {
          finished = true;
          clearTimeout(quiet);
          clearTimeout(cap);
          document.removeEventListener("load", poke, true);
          document.removeEventListener("error", poke, true);
        }
        function finish() { if (finished) return; stop(); done(); }
        function poke() {
          if (finished) return;
          clearTimeout(quiet);
          var img = root.querySelector && root.querySelector("img[data-fresco-canvas-img]");
          // No canvas yet, or its picture still arriving: its own load /
          // error event pokes again.
          if (!img || (img.getAttribute && img.getAttribute("src") && !img.complete)) return;
          quiet = setTimeout(finish, SETTLE_QUIET_MS);
        }
        document.addEventListener("load", poke, true);
        document.addEventListener("error", poke, true);
        cap = setTimeout(finish, SETTLE_MAX_MS);
        poke();
        return stop;
      }
      function warmAllowed() {
        var c = (typeof navigator !== "undefined" && navigator.connection) || null;
        if (!c) return true;
        return !(c.saveData || /(^|-)[23]g$/.test(c.effectiveType || ""));
      }
      function warmUrl(url) {
        if (!url || window.__pkWarmedUrls[url]) return;
        window.__pkWarmedUrls[url] = true;
        var im = new Image();
        try { im.fetchPriority = "low"; } catch (_e) { /* older browsers */ }
        im.src = url;
      }
      // Factored so updated() can re-run it: a step PATCHES this modal in
      // place (its id is stable), so mounted() fires once per open. Each
      // step rewrites the dataset with the new neighbours; warming again
      // from here keeps the NEXT press as instant as the first.
      self._direction = "";
      function neighbours(raw) {
        try { return JSON.parse(raw || "{}") || {}; } catch (_e) { return {}; }
      }
      self._warm = function() {
        if (self._cancelWarm) self._cancelWarm();
        var n = neighbours(self.el && self.el.dataset && self.el.dataset.neighbors);
        self._cancelWarm = afterSettled(self.el, function() {
          self._cancelWarm = null;
          if (!warmAllowed()) return;
          // The way the person is heading: the next photo until they step
          // back. Only that side's `large` is worth a speculative fetch;
          // both sides' `open` (small — tens of KB) is, because it is what a
          // step paints at once while the rest arrives. The side just left
          // is already in the cache.
          var ahead = self._direction === "prev" ? "prev" : "next";
          var behind = ahead === "prev" ? "next" : "prev";
          warmUrl(n[ahead] && n[ahead].open);
          warmUrl(n[behind] && n[behind].open);
          warmUrl(n[ahead] && n[ahead].large);
          // For a module deciding on originals (phoenix_kit_photos): what
          // each neighbour offers, and the viewer's box in device terms so
          // it can work out how many pixels the picture will really light —
          // a portrait photo in a wide column is narrow.
          var column = self.el.querySelector('[id^="pk-annotation-actions-"]');
          window.dispatchEvent(new CustomEvent("pk:viewer-neighbours", {
            detail: {
              prev: n.prev ? { original: n.prev.original || "", aspect: n.prev.aspect || "" } : null,
              next: n.next ? { original: n.next.original || "", aspect: n.next.aspect || "" } : null,
              direction: self._direction,
              box: {
                width: (column && column.clientWidth) || window.innerWidth || 0,
                height: (column && column.clientHeight) || window.innerHeight || 0,
                dpr: window.devicePixelRatio || 1
              }
            }
          }));
        });
      };
      self._warm();
      // An open modal <dialog> that does not hold this viewer was opened
      // over it (one opened from inside the viewer, or after it): the key
      // is that dialog's.
      function dialogAbove(el) {
        const dialogs = (document.querySelectorAll && document.querySelectorAll("dialog")) || [];
        for (let i = 0; i < dialogs.length; i++) {
          const d = dialogs[i];
          let modal;
          try { modal = d.matches(":modal"); } catch (_e) { modal = !!d.open; }
          if (modal && !(d.contains && d.contains(el))) return true;
        }
        return false;
      }
      self._handler = function(e) {
        if (e.key !== "Escape" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
        // The media browser's removal dialog is open over this viewer: the
        // arrows are not for the viewer underneath, which stays on the file
        // the dialog is asking about.
        if (e.key !== "Escape" && (document.querySelector && document.querySelector("[data-removal-state]"))) return;
        if (e.key === "Escape" && self.el.hasAttribute && self.el.hasAttribute("popover")) {
          if (dialogAbove(self.el)) return;
          // A picker's viewer is the top layer, so Escape closes the viewer
          // alone. The host <dialog> holding the picker would take the same
          // key as its own close request; cancelling the keydown cancels
          // that request (the dialog gets no `cancel`), and so does an
          // Escape typed in a field of the viewer, which closes nothing.
          // Any other viewer leaves the key to the page, as it always did.
          e.preventDefault();
        }
        const t = document.activeElement;
        if (t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" ||
                  t.isContentEditable === true)) return;
        // Announce the step so the stand-in can paint the neighbour's
        // warmed bitmap NOW — blurred, in the final geometry — instead of
        // the viewer freezing on the current image until the next one's
        // pixels arrive. src comes off this modal's own data attributes;
        // empty (edge of the list, a video) means no stand-in, and the
        // step behaves as before.
        if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
          self._direction = e.key === "ArrowLeft" ? "prev" : "next";
          const d = self.el.dataset || {};
          const src = e.key === "ArrowLeft" ? d.stepPrevSrc : d.stepNextSrc;
          const rot = e.key === "ArrowLeft" ? d.stepPrevRot : d.stepNextRot;
          const asp = e.key === "ArrowLeft" ? d.stepPrevAspect : d.stepNextAspect;
          if (src) {
            window.dispatchEvent(new CustomEvent("pk:viewer-step", {
              detail: { src: src, rotation: rot || "", aspect: asp || "" }
            }));
          }
        }
        self.pushEventTo(self.el, "viewer_keydown", { key: e.key });
      };
      document.addEventListener("keydown", self._handler);

      // The on-screen chevrons step too: the side being stepped towards is the
      // one whose large variant is warmed, whichever way the step was made.
      self._onChevron = function(e) {
        const btn = e.target && e.target.closest && e.target.closest('[phx-click="step_viewer"]');
        const dir = btn && btn.getAttribute("phx-value-dir");
        if (dir === "prev" || dir === "next") self._direction = dir;
      };
      self.el.addEventListener("click", self._onChevron, true);
    },

    // A step does NOT remount this hook — the modal's id is stable, so
    // LiveView patches it in place and only the canvas child (file uuid
    // in its id) remounts. mounted() above is therefore once per OPEN,
    // and the stand-in a step had painted waited on a pk:viewer-open
    // that never came: it sat opaque over the new image for the full
    // fallback timeout, which read as the step being slow — and as the
    // popup refusing to close, since the click-off had actually closed
    // the real viewer somewhere under the blur. Re-announcing from here
    // gives a step the same hand-off as an open: see-through at once,
    // gone when the new image paints. Extra firings from unrelated
    // patches (sidebar toggle, a comment) are harmless — with the
    // stand-in hidden the listener only refreshes its layout prediction.
    updated() {
      if (this._showPopover) this._showPopover();
      window.dispatchEvent(new CustomEvent("pk:viewer-open", { detail: { el: this.el } }));
      // …and the dataset now names the NEW neighbours.
      if (this._warm) this._warm();
    },

    destroyed() {
      // The stand-in may be holding a blurry overlay over this modal,
      // waiting for an image that is now never going to load.
      window.dispatchEvent(new CustomEvent("pk:viewer-closed"));
      if (this._handler) {
        document.removeEventListener("keydown", this._handler);
        this._handler = null;
      }
      if (this._onChevron) {
        this.el.removeEventListener("click", this._onChevron, true);
        this._onChevron = null;
      }
      if (this._cancelWarm) {
        this._cancelWarm();
        this._cancelWarm = null;
      }
    }
  };

  // ---------------------------------------------------------------------------
  // MediaViewerDialog — opens the media viewer (`MediaViewer` LiveComponent) as a
  // native <dialog> via showModal(), so it renders in the browser top layer.
  //
  // The top layer escapes ALL ancestor stacking contexts and z-index, fixing the
  // case where a deeply-nested viewer (e.g. inside a documents tab) is overlapped
  // by parent-page elements with a higher z-index.
  //
  // The server owns the open/closed lifecycle (the component is mounted only
  // while a preview is open). The hook pushes `viewer_keydown` events so the
  // existing MediaViewer `handle_event "viewer_keydown"` clauses keep working.
  // ---------------------------------------------------------------------------

  window.PhoenixKitHooks.MediaViewerDialog = {
    mounted() {
      const self = this;

      if (typeof this.el.showModal === "function" && !this.el.open) {
        this.el.showModal();
      }

      // Native Escape / programmatic cancel — route to the server so it stays
      // the single source of truth for whether the viewer is open.
      self._onCancel = function(e) {
        e.preventDefault();
        self.pushEventTo(self.el, "viewer_keydown", { key: "Escape" });
      };

      // Arrow-key navigation; suppressed while focus is in a text field.
      self._onKey = function(e) {
        if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
        if ((document.querySelector && document.querySelector("[data-removal-state]"))) return;
        const t = document.activeElement;
        if (t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" ||
                  t.isContentEditable)) return;
        self.pushEventTo(self.el, "viewer_keydown", { key: e.key });
      };

      this.el.addEventListener("cancel", self._onCancel);
      this.el.addEventListener("keydown", self._onKey);
    },
    // Re-assert open state after LiveView patches children (e.g. prev/next step).
    // The <dialog> opening tag has only stable attrs so morphdom rarely touches it,
    // but this guard mirrors PkDialog._sync and removes the asymmetry between the
    // two hooks.
    updated() {
      if (!this.el.open && typeof this.el.showModal === "function") this.el.showModal();
    },
    destroyed() {
      if (this._onCancel) this.el.removeEventListener("cancel", this._onCancel);
      if (this._onKey) this.el.removeEventListener("keydown", this._onKey);
      if (this.el.open) this.el.close();
    }
  };

  // ---------------------------------------------------------------------------
  // PkDialog — generic native <dialog> controller for server-driven modals.
  //
  // Renders the modal in the browser top layer (showModal()), so it is immune to
  // ancestor stacking contexts / z-index — fixes modals being overlapped by
  // parent-page elements. The dialog also covers the FULL visual viewport
  // (top-layer rendering bypasses the daisyUI `scrollbar-gutter: stable` trick
  // that previously left a 15px gap on the right of `<div class="modal">`).
  //
  //   data-show        "true" / "false" — desired open state (synced each update)
  //   data-close-event event pushed to the component on Escape / cancel / backdrop
  //   data-closeable   "false" → Escape + backdrop click are no-ops (modal still
  //                    closable only via an explicit action button). Default:
  //                    closeable.
  //   data-close-guard "confirm" (what `<.modal>` renders by default) → once a
  //                    submittable form inside THIS dialog has been typed
  //                    into, the first Escape or backdrop click is refused
  //                    with a nudge of the box and only a second one within
  //                    a few seconds closes. See "Unsaved input" above.
  //                    "input" → while a submittable form (`form[phx-submit]`)
  //                    inside THIS dialog holds a field that differs from its
  //                    default value, Escape + backdrop are no-ops on the
  //                    client — before the server hears of the edit; a
  //                    debounced change event and an Esc inside the debounce
  //                    window would otherwise discard the text. Recomputed on
  //                    every input event and every server patch, so it lets
  //                    go the moment the form is saved, reset, or re-rendered
  //                    with the value (the server's data-closeable is the
  //                    authority from then on) — never a latch. Filter /
  //                    search forms (phx-change only, role="search",
  //                    type="search") do not count.
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // PkShiftEnter — gives an input a second Enter.
  //
  // Plain Enter in a text input is the browser's implicit submission: it
  // presses the form's FIRST submit button. Shift+Enter submits exactly the
  // same way, so a form cannot tell "add" from "add and start the next"
  // without help. This hook makes Shift+Enter click the element named by
  // `data-shift-enter-click` (a selector — typically a second submit button
  // carrying `name`/`value`, which LiveView then includes as the submitter)
  // and leaves plain Enter alone. Never fires during IME composition.
  //
  //   <input phx-hook="PkShiftEnter" data-shift-enter-click="#add-next" …>
  //   <button type="submit">Add</button>                       ← Enter
  //   <button type="submit" id="add-next" name="then" value="next">Add & next</button>
  // ---------------------------------------------------------------------------
  function shiftEnter(e) {
    return !!e && e.key === "Enter" && e.shiftKey === true && !e.isComposing &&
      !e.metaKey && !e.ctrlKey && !e.altKey;
  }

  if (typeof module === "object" && module.exports) {
    module.exports.shiftEnter = shiftEnter;
  }

  window.PhoenixKitHooks.PkShiftEnter = {
    mounted() {
      const self = this;
      self._onKeydown = function(e) {
        if (!shiftEnter(e)) return;
        const selector = self.el.dataset.shiftEnterClick;
        if (!selector) return;
        const target = document.querySelector(selector);
        if (!target) return;
        e.preventDefault();
        target.click();
      };
      this.el.addEventListener("keydown", self._onKeydown);
    },
    destroyed() {
      if (this._onKeydown) this.el.removeEventListener("keydown", this._onKeydown);
    }
  };

  // ---------------------------------------------------------------------------
  // PkUrlMirror — keeps the address bar on the element's `data-url`.
  //
  // For a LiveView that switches views in place but cannot export
  // handle_params/3 (an embeddable LV — LiveView refuses to mount one with
  // that callback outside a router route). The server renders the canonical
  // URL of the current view into `data-url`; on every mount/update the hook
  // `replaceState`s to it when it differs. Replace, never push: a pushed
  // entry would be a foreign history state that LiveView's popstate handler
  // treats as live navigation into a callback that does not exist. Back /
  // forward therefore leave the page, as before; copy / reload / deep links
  // land on the view that was showing.
  //
  //   <div id="tabs" phx-hook="PkUrlMirror" data-url="/admin/projects/1/tasks/board">
  // ---------------------------------------------------------------------------
  // Only a root-relative PATH is honoured: not a network-path reference
  // ("//host", "/\\host" — same-origin-looking, other-origin-going), not
  // anything with control characters, not a fragment (the comparison
  // below never sees the hash, so a fragment would re-fire on every
  // update). Codex, 2026-09-05.
  function urlMirrorTarget(dataset, current) {
    const url = dataset && dataset.url;
    if (typeof url !== "string" || url === "" || url.charAt(0) !== "/") return null;
    if (url.charAt(1) === "/" || url.charAt(1) === "\\") return null;
    if (/[\u0000-\u001f\u007f#]/.test(url)) return null;
    if (url === current) return null;
    return url;
  }

  if (typeof module === "object" && module.exports) {
    module.exports.urlMirrorTarget = urlMirrorTarget;
  }

  window.PhoenixKitHooks.PkUrlMirror = {
    mounted() { this._sync(); },
    updated() { this._sync(); },
    _sync() {
      const current = window.location.pathname + window.location.search;
      const target = urlMirrorTarget(this.el.dataset, current);
      if (target === null) return;
      try {
        window.history.replaceState(window.history.state, "", target);
      } catch (_e) {
        // A cross-origin or otherwise refused URL: leave the address bar alone.
      }
    }
  };

  // ---------------------------------------------------------------------------
  // PkHashHighlight — lights the element the URL fragment names.
  //
  // The CSS `:target` variant only follows a fragment the browser itself
  // navigated to: a page reached through `push_navigate` (a bell notice, for
  // one) is entered by `history.pushState`, which leaves `:target` unset. The
  // hook sets `data-highlight` on the element inside its root whose id the
  // fragment names, on mount, after every patch and on `hashchange`; the
  // markup styles it (`data-[highlight]:ring-2`) next to `target:ring-2` for
  // pages loaded directly.
  //
  //   <div id="page" phx-hook="PkHashHighlight"> <div id="item-1" …> </div>
  // ---------------------------------------------------------------------------
  function hashTargetId(hash) {
    if (typeof hash !== "string" || hash.length < 2 || hash.charAt(0) !== "#") return null;
    try { return decodeURIComponent(hash.slice(1)); } catch (_e) { return null; }
  }

  if (typeof module === "object" && module.exports) {
    module.exports.hashTargetId = hashTargetId;
  }

  window.PhoenixKitHooks.PkHashHighlight = {
    mounted() {
      const self = this;
      self._onHashChange = function() { self._mark(); };
      window.addEventListener("hashchange", self._onHashChange);
      self._mark();
    },
    updated() { this._mark(); },
    destroyed() { window.removeEventListener("hashchange", this._onHashChange); },
    _mark() {
      const id = hashTargetId(window.location.hash);
      this.el.querySelectorAll("[data-highlight]").forEach(function(el) {
        if (el.id !== id) el.removeAttribute("data-highlight");
      });
      if (id === null) return;
      const target = document.getElementById(id);
      if (target && this.el.contains(target)) target.setAttribute("data-highlight", "");
    }
  };

  // ---------------------------------------------------------------------------
  // PkDateInput — the hook behind `<.date_input>` (core/date_input.ex): a
  // visible text input in the site's date format plus a real
  // `<input type="date" data-date-value>` that carries the caller's name and
  // the ISO value. The server renders the native date input as the visible
  // control (what a page with no LiveView keeps); `enhance` swaps the roles.
  // See the component's moduledoc for the contract.
  //
  // The pure parts (format table, parser, formatter) are exported for
  // test/js/date_input.test.cjs.
  // ---------------------------------------------------------------------------
  var DATE_ORDERS = {
    "Y-m-d": "ymd",
    "m/d/Y": "mdy",
    "d/m/Y": "dmy",
    "d.m.Y": "dmy",
    "d-m-Y": "dmy",
    "F j, Y": "mdy"
  };
  var DATE_MONTHS = ["January", "February", "March", "April", "May", "June", "July",
    "August", "September", "October", "November", "December"];

  // Same fallback as PhoenixKit.Utils.Date.format_date/2 for an unknown format.
  function dateOrder(format) {
    return DATE_ORDERS[format] || "ymd";
  }

  function pad2(n) {
    return (n < 10 ? "0" : "") + n;
  }

  function pad4(n) {
    return ("000" + n).slice(-4);
  }

  // The real calendar date, or null (31.02, month 13, year 0).
  function validYmd(y, m, d) {
    if (!(y >= 1 && m >= 1 && m <= 12 && d >= 1 && d <= 31)) return null;
    var dt = new Date(Date.UTC(2000, 0, 1));
    dt.setUTCFullYear(y, m - 1, d);
    if (dt.getUTCFullYear() !== y || dt.getUTCMonth() !== m - 1 || dt.getUTCDate() !== d) return null;
    return pad4(y) + "-" + pad2(m) + "-" + pad2(d);
  }

  function monthFromName(token) {
    var t = token.toLowerCase();
    if (t.length < 3) return 0;
    for (var i = 0; i < 12; i++) {
      var name = DATE_MONTHS[i].toLowerCase();
      if (name === t || (t.length === 3 && name.slice(0, 3) === t)) return i + 1;
    }
    return 0;
  }

  // Two digits take the century that puts the date within 50 years before
  // to 49 after today (2026: 76 → 1976, 75 → 2075, 85 → 1985, 30 → 2030).
  function yearFromToken(token, todayYear) {
    if (!/^\d+$/.test(token)) return 0;
    if (token.length === 4) return parseInt(token, 10);
    if (token.length !== 2) return 0;
    var yy = parseInt(token, 10);
    var base = todayYear - 50;
    return yy + 100 * Math.ceil((base - yy) / 100);
  }

  function todayYearOf(today) {
    var m = /^(\d{4})-/.exec(String(today || ""));
    return m ? parseInt(m[1], 10) : new Date().getFullYear();
  }

  function isYearPart(order, idx) {
    return order === "ymd" ? idx === 0 : idx === 2;
  }

  function assembleDate(order, parts) {
    if (order === "ymd") return { y: parts[0], m: parts[1], d: parts[2] };
    if (order === "mdy") return { m: parts[0], d: parts[1], y: parts[2] };
    return { d: parts[0], m: parts[1], y: parts[2] };
  }

  // What a date input's `value` is for an attribute text: the date itself when
  // it is a real `YYYY-MM-DD`, else "" (the browser's sanitising).
  function isoOrEmpty(text) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(text || ""));
    return m ? validYmd(+m[1], +m[2], +m[3]) || "" : "";
  }

  // Text → "YYYY-MM-DD", or null when it is not a date (or lies outside
  // min/max, which are ISO strings). `today` (ISO) anchors two-digit years. Never throws; empty text is the caller's
  // business (it clears the field).
  function checkDateText(text, format, min, max, today) {
    var s = String(text == null ? "" : text).trim();
    if (s === "") return { error: "format" };
    var order = dateOrder(format);
    var ty = todayYearOf(today);
    var iso = null;
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);

    if (m) {
      iso = validYmd(+m[1], +m[2], +m[3]);
    } else if (/^\d+$/.test(s)) {
      // Digits only: ddmmyyyy / ddmmyy in the format's order.
      var cuts;
      if (s.length === 8) cuts = order === "ymd" ? [4, 2, 2] : [2, 2, 4];
      else if (s.length === 6) cuts = [2, 2, 2];
      else return { error: "format" };
      var nums = [];
      var at = 0;
      for (var i = 0; i < 3; i++) {
        var part = s.slice(at, at + cuts[i]);
        at += cuts[i];
        nums.push(isYearPart(order, i) ? yearFromToken(part, ty) : parseInt(part, 10));
      }
      var a = assembleDate(order, nums);
      iso = validYmd(a.y, a.m, a.d);
    } else {
      var tokens = s.split(/[.\/\-\s,]+/).filter(Boolean);
      if (tokens.length !== 3) return { error: "format" };
      var namePos = format === "F j, Y" ? 0 : -1;
      var vals = [];
      for (var j = 0; j < 3; j++) {
        var tok = tokens[j];
        if (isYearPart(order, j)) vals.push(yearFromToken(tok, ty));
        else if (j === namePos && /^[A-Za-z]+$/.test(tok)) vals.push(monthFromName(tok));
        else if (/^\d{1,2}$/.test(tok)) vals.push(parseInt(tok, 10));
        else return { error: "format" };
      }
      var b = assembleDate(order, vals);
      iso = validYmd(b.y, b.m, b.d);
    }

    if (iso === null) return { error: "format" };
    if ((min && iso < min) || (max && iso > max)) return { error: "range" };
    return { iso: iso };
  }

  // Text → "YYYY-MM-DD", or null when it is not an acceptable date.
  function parseDateText(text, format, min, max, today) {
    return checkDateText(text, format, min, max, today).iso || null;
  }

  // "YYYY-MM-DD" → text in the site format (`F` is the English month name,
  // as the server renders it); "" for anything that is not an ISO date.
  function formatDateIso(iso, format) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ""));
    if (!m) return "";
    var y = m[1];
    var mo = m[2];
    var d = m[3];
    switch (format) {
      case "m/d/Y": return mo + "/" + d + "/" + y;
      case "d/m/Y": return d + "/" + mo + "/" + y;
      case "d.m.Y": return d + "." + mo + "." + y;
      case "d-m-Y": return d + "-" + mo + "-" + y;
      case "F j, Y": return DATE_MONTHS[+mo - 1] + " " + (+d) + ", " + y;
      default: return y + "-" + mo + "-" + d;
    }
  }

  // Where the calendar popup goes: under the field, flipped above it when
  // the room below is short and the room above is enough, kept inside the
  // viewport sideways. `anchor` is the field's rect, `size` the popup's,
  // `view` the viewport's; all in CSS pixels.
  function popupPlacement(anchor, size, view) {
    var gap = 4;
    var top = anchor.bottom + gap;
    if (top + size.height > view.height && anchor.top - gap - size.height >= 0) {
      top = anchor.top - gap - size.height;
    }
    // No room on either side: keep as much of it as fits on screen.
    if (top + size.height > view.height) top = Math.max(gap, Math.min(top, view.height - size.height - gap));
    var left = Math.max(gap, Math.min(anchor.left, view.width - size.width - gap));
    return { top: top, left: left };
  }

  // The grid is Gregorian whatever the language's default calendar is (`th`,
  // `ar-SA`, `fa`): without it the month and year headings would not match.
  function calendarLocale(tag) {
    tag = tag || "en";
    return /-u-/i.test(tag) ? tag : tag + "-u-ca-gregory";
  }

  if (typeof module === "object" && module.exports) {
    module.exports.calendarLocale = calendarLocale;
    module.exports.popupPlacement = popupPlacement;
    module.exports.dateOrder = dateOrder;
    module.exports.parseDateText = parseDateText;
    module.exports.checkDateText = checkDateText;
    module.exports.formatDateIso = formatDateIso;
  }

  var warnedNoUtilities = false;

  window.PhoenixKitHooks.PkDateInput = {
    mounted() {
      var self = this;
      var t = this.textEl();
      this.baseText = t.value;
      this.lastIso = this.valueEl().value;
      this.rejected = null;
      this.pendingSync = false;
      this.gone = false;
      this.serverAttr = this.valueEl().getAttribute("value");
      this.enhance(true);

      this.onEvent = function(e) { self.handle(e); };
      ["input", "change", "click", "mousedown", "keydown", "focusin", "focusout"].forEach(function(type) {
        self.el.addEventListener(type, self.onEvent);
      });

      // The owning form is the value element's (`form="…"` goes to it).
      this.form = this.valueEl().form;
      this.onReset = function() {
        // The browser restored both fields' defaults; make them agree again.
        setTimeout(function() { self.syncText(); }, 0);
      };
      if (this.form) this.form.addEventListener("reset", this.onReset);

      // A date picked in the native input before the socket connected: the
      // server has not heard of it, the text is still the old date. A browser
      // sanitises a non-ISO `value` to "", so the default to compare with is
      // the sanitised one: a value the server echoed as given (`03.05.2024`)
      // is not a pick.
      var v = this.valueEl();
      var pick = v.value !== isoOrEmpty(v.defaultValue);
      // A half-edited native control (`badInput`) holds no date yet: not a pick.
      if (pick && v.validity && v.validity.badInput) pick = false;
      if (pick && v.value === "" && this.el.dataset.required === "true") {
        // Emptied during the connect window, on a required field: that is not
        // a value. Keep the server's date (put back into the date input) and say so.
        v.value = isoOrEmpty(v.defaultValue);
        this.reject("format");
      } else if (pick) {
        this.syncText();
        v.dispatchEvent(new Event("input", { bubbles: true }));
      } else if (t.value !== t.defaultValue) {
        // Text that differs from what the server rendered was typed before the
        // socket connected. Still typing in it: leave it to blur/Enter (a
        // partial `16.10.20` must not be committed under the caret).
        if (document.activeElement === t) this.baseText = t.defaultValue;
        else this.commit();
      } else if (v.value === "" && t.value.trim() !== "") {
        this.adoptStored();
      }
      this.refresh();

      // `autofocus` sits on the text field, which was `hidden` when the
      // browser looked for something to focus. The socket connects after the
      // person may have started typing elsewhere: take the focus only when
      // nothing holds it (the date input's own focus went to the text field in
      // `enhance`).
      var active = document.activeElement;
      if (t.hasAttribute("autofocus") && (!active || active === document.body)) t.focus();
    },

    // The server echoed a stored value the date input cannot hold (`03.05.2024`,
    // a changeset's bad input): the text shows it, the date input is empty, and
    // a save would erase it without a word. A text that is a date in the site
    // format is taken into the date input (no event: the server has it); any
    // other is marked, so the person corrects or clears it. A field nobody can
    // edit is not marked.
    adoptStored() {
      var t = this.textEl();
      var v = this.valueEl();
      var res = this.check(t.value);
      if (!res.error) {
        v.value = res.iso;
        this.lastIso = res.iso;
      } else if (!(t.matches && t.matches(":disabled")) && !t.readOnly) {
        this.reject(res.error);
      }
    },

    updated() {
      var v = this.valueEl();
      var t = this.textEl();
      if (!v || !t) return;
      var focused = document.activeElement === t;
      // The server's own value (the attribute): a stored text the date input
      // cannot hold sanitises to "" however the server moves it.
      var attr = v.getAttribute("value");
      var attrMoved = attr !== this.serverAttr;
      this.serverAttr = attr;
      // The echo of the value the hook itself sent is not the server moving it.
      if (attrMoved && (attr || "") === this.sentIso) attrMoved = false;
      var stored = !!attr && isoOrEmpty(attr) === "";
      // The same stored text again: keep the date taken from it at mount.
      if (stored && !attrMoved && v.value === "" && this.lastIso) v.value = this.lastIso;
      var changed = v.value !== this.lastIso || attrMoved;
      this.lastIso = v.value;

      if (changed) {
        // The server moved the date: it wins over rejected text.
        this.rejected = null;
        if (focused) this.pendingSync = true;
        else if (stored) this.adoptStored();
        else this.syncText();
      } else if (this.rejected && !focused) {
        // A patch rewrote the field from the server's (unchanged) date: the
        // rejected text is what the person should still see.
        t.value = this.rejected.text;
      }
      // A patch also rewrites every attribute the server rendered.
      this.refresh();
    },

    destroyed() {
      this.gone = true;
      this.closePopup(false);
      if (this.form) this.form.removeEventListener("reset", this.onReset);
    },

    // The server renders the native date input as the visible control and the
    // text field `hidden`. From here on the text field is the control and the
    // date input is its invisible value element: the wrapper's `data-enhanced`
    // flips the classes, and `required` moves to the text field (a `required`
    // control that is not displayed would block the form's submit). A patch
    // puts the server's markup back, so `refresh` does this again.
    enhance(atMount) {
      var t = this.textEl();
      var v = this.valueEl();
      if (!t || !v || this.degraded) return;
      this.el.setAttribute("data-enhanced", "");
      if (atMount) {
        // A host stylesheet without the swap utilities leaves the text field
        // undisplayed: keep the browser's date input (visible, focusable,
        // `required`) instead of an invisible one.
        var css = typeof window.getComputedStyle === "function" ? window.getComputedStyle(t) : null;
        if (css && css.display === "none") {
          this.el.removeAttribute("data-enhanced");
          this.degraded = true;
          if (!warnedNoUtilities && typeof console !== "undefined") console.warn("PkDateInput: the stylesheet lacks the group-data-[enhanced] utilities; rebuild the CSS. Using the browser's date input.");
          warnedNoUtilities = true;
          return;
        }
        // Sticky across patches: morphdom would strip a plain attribute the
        // server does not render, and the text field would blink away.
        if (typeof this.js === "function") this.js().setAttribute(this.el, "data-enhanced", "");
      }
      v.setAttribute("tabindex", "-1");
      v.setAttribute("aria-hidden", "true");
      v.removeAttribute("required");
      t.required = this.el.dataset.required === "true";
      // The date input that was displayed (and focused) until now is invisible
      // from here on: the keystrokes go to the field the person sees. Only at
      // mount: later it holds the focus for its own picker.
      if (atMount && document.activeElement === v) t.focus();
    },

    textEl() { return this.el.querySelector("[data-date-text]"); },
    valueEl() { return this.el.querySelector("[data-date-value]"); },
    format() { return this.el.dataset.format || "Y-m-d"; },

    check(raw) {
      var d = this.el.dataset;
      return checkDateText(raw, this.format(), d.min, d.max, d.today);
    },

    handle(e) {
      var text = this.textEl();
      var value = this.valueEl();
      var target = e.target;

      // Escape with the calendar open closes only the calendar: the event
      // must not reach a PkDialog / modal around the field.
      if (e.type === "keydown" && e.key === "Escape" && this.popupOpen()) {
        e.preventDefault();
        e.stopPropagation();
        this.closePopup(true);
        return;
      }

      // Focus left the component (Tab past the calendar): the popup goes too.
      if (e.type === "focusout" && this.popupOpen() &&
          e.relatedTarget && !this.el.contains(e.relatedTarget)) {
        this.closePopup(false);
      }

      if (target === text) {
        if (e.type === "input" || e.type === "change") {
          // The visible text never talks to LiveView.
          e.stopPropagation();
          this.toggleClear();
        } else if (e.type === "focusin") {
          this.baseText = text.value;
        } else if (e.type === "focusout") {
          this.onTextBlur();
        } else if (e.type === "keydown") {
          this.onTextKeydown(e);
        }
        return;
      }

      if (target === value) {
        // The native picker (or our own commit) changed the value element.
        if (e.type === "input" || e.type === "change") this.syncText();
        return;
      }

      var clear = target.closest && target.closest("[data-clear]");
      if (clear && this.el.contains(clear)) {
        if (e.type === "mousedown") e.preventDefault();
        else if (e.type === "click") this.clear();
        return;
      }

      var open = target.closest && target.closest("[data-open]");
      if (open && this.el.contains(open) && e.type === "click") {
        this.open();
        return;
      }

      if (e.type !== "click" || !target.closest) return;
      if (target.closest("[data-popup-today]")) this.pick(this.el.dataset.today);
      else if (target.closest("[data-popup-clear]")) {
        this.clear();
        this.closePopup(true);
      }
    },

    onTextBlur() {
      var text = this.textEl();
      if (this.pendingSync && text.value === this.baseText) {
        // The server changed the date while the field was focused.
        this.pendingSync = false;
        this.syncText();
        return;
      }
      if (text.value !== this.baseText) this.commit();
    },

    onTextKeydown(e) {
      if (e.key === "Enter" && !e.isComposing) {
        var ok = this.commit();
        var form = this.form;
        // Submit stays natural for a phx-submit form; in a phx-change-only
        // form LiveView would turn it into a native POST.
        if (!ok || !form || !form.hasAttribute("phx-submit")) e.preventDefault();
      } else if (e.key === "ArrowDown" && e.altKey) {
        e.preventDefault();
        this.open();
      }
    },

    // Parse the text and, when it is a (different) date, hand it to the form.
    // Returns false only for text that is not accepted.
    commit() {
      var text = this.textEl();
      if (this.pendingSync && text.value === this.baseText) {
        this.pendingSync = false;
        this.syncText();
        return true;
      }
      this.pendingSync = false;
      var raw = text.value.trim();
      if (raw === "") {
        // Emptying a required field is not a value: keep the date.
        if (text.required) {
          this.reject("format");
          return false;
        }
        this.setValue("");
        this.accept();
        this.baseText = text.value;
        this.toggleClear();
        return true;
      }
      var res = this.check(raw);
      if (res.error) {
        this.reject(res.error);
        return false;
      }
      this.setValue(res.iso);
      this.syncText();
      return true;
    },

    setValue(iso) {
      var v = this.valueEl();
      if (!v || v.value === iso) return;
      v.value = iso;
      this.lastIso = iso;
      this.sentIso = iso;
      v.dispatchEvent(new Event("input", { bubbles: true }));
    },

    clear() {
      var text = this.textEl();
      text.value = "";
      this.setValue("");
      this.accept();
      this.baseText = "";
      this.pendingSync = false;
      this.toggleClear();
      text.focus();
    },

    // Visible text := the value element's date, in the site format.
    syncText() {
      var text = this.textEl();
      var v = this.valueEl();
      if (!text || !v) return;
      text.value = formatDateIso(v.value, this.format());
      this.baseText = text.value;
      this.pendingSync = false;
      this.accept();
      this.toggleClear();
    },

    // The calendar button. Phones get the browser's own picker on the value
    // element; so does a desktop where the calendar cannot load. With no
    // showPicker (or one that throws) the calendar is the way, and failing
    // that the focus stays in the text field.
    open() {
      var v = this.valueEl();
      var text = this.textEl();
      if (!v || v.disabled) return;
      if (this.popupOpen()) {
        this.closePopup(true);
        return;
      }
      // What was typed counts before the calendar reads the date.
      if (text && text.value !== this.baseText) this.commit();
      var popup = this.popupEl();
      var canNative = typeof v.showPicker === "function";
      var canPopup = !!popup && typeof popup.showPopover === "function";
      var coarse = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
      if (coarse && canNative) this.tryNative(canPopup);
      else if (canPopup) this.openPopup(canNative);
      else if (canNative) this.tryNative(false);
      else this.focusText();
    },

    focusText() {
      var t = this.textEl();
      if (t) t.focus();
    },

    // The browser's picker; if it throws, the calendar (when there is one).
    tryNative(thenPopup) {
      try {
        this.valueEl().showPicker();
      } catch (_e) {
        if (thenPopup) this.openPopup(false);
        else this.focusText();
      }
    },

    // Load Cally and show it; on a failed load the browser's picker when
    // `nativeOnFail`, else the text field keeps the focus.
    openPopup(nativeOnFail) {
      var self = this;
      this.loadCally().then(function() {
        if (self.gone || !self.el.isConnected) return;
        self.showPopup();
      }, function() {
        if (self.gone) return;
        if (!window.__pkDateCallyWarned) {
          window.__pkDateCallyWarned = true;
          console.warn("[PhoenixKit] date_input: the calendar failed to load; using the browser's date picker.");
        }
        if (nativeOnFail) self.tryNative(false);
        else self.focusText();
      });
    },

    loadCally() {
      return loadVendored("Cally", "cally", {
        module: true,
        check: function() {
          return !!(window.customElements && window.customElements.get("calendar-date"));
        }
      });
    },

    popupEl() { return this.el.querySelector("[data-popup]"); },

    popupOpen() {
      var popup = this.popupEl();
      try {
        return !!popup && popup.matches(":popover-open");
      } catch (_e) {
        return false;
      }
    },

    calendarEl() {
      var popup = this.popupEl();
      return popup && popup.querySelector("calendar-date");
    },

    // The server rendered the calendar into a <template> (strings included);
    // the first open clones it into the ignored popup container.
    buildPopup(popup) {
      var self = this;
      var tpl = this.el.querySelector("[data-popup-template]");
      if (!tpl) return false;
      popup.appendChild(tpl.content.cloneNode(true));
      var cal = popup.querySelector("calendar-date");
      if (!cal) return false;
      cal.setAttribute("locale", calendarLocale(this.el.dataset.locale));
      cal.setAttribute("first-day-of-week", this.el.dataset.weekStart || "1");
      if (this.el.dataset.today) cal.setAttribute("today", this.el.dataset.today);
      // `change` does not bubble out of Cally: listen on the element.
      cal.addEventListener("change", function(e) { self.pick(e.target.value); });
      return true;
    },

    showPopup() {
      var self = this;
      var popup = this.popupEl();
      if (!popup || this.popupOpen()) return;
      if (!this.calendarEl() && !this.buildPopup(popup)) {
        this.focusText();
        return;
      }
      var cal = this.calendarEl();
      var d = this.el.dataset;
      var v = this.valueEl().value;
      if (v) cal.setAttribute("value", v);
      else cal.removeAttribute("value");
      if (d.min) cal.setAttribute("min", d.min);
      else cal.removeAttribute("min");
      if (d.max) cal.setAttribute("max", d.max);
      else cal.removeAttribute("max");
      this.syncFooter(popup);
      // Cally pins the month it was last paged to; start on the date's.
      cal.focusedDate = v || d.today || undefined;

      // Hidden until placed: the first frames would otherwise show it at the
      // viewport's origin.
      popup.style.visibility = "hidden";
      popup.showPopover();
      this.setExpanded(true);
      this.bindClosers();
      // Cally renders its shadow DOM asynchronously: measure after it has.
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          if (!self.popupOpen()) return;
          self.position();
          popup.style.visibility = "";
          if (typeof cal.focus === "function") cal.focus();
        });
      });
    },

    // The footer buttons live in a <template> LiveView never patches, so they
    // follow the wrapper's `data-*` each time the calendar opens: "Today" is
    // off when today lies outside min/max, "Clear" shows for a clearable field.
    syncFooter(popup) {
      var d = this.el.dataset;
      var today = popup.querySelector("[data-popup-today]");
      var clear = popup.querySelector("[data-popup-clear]");
      if (today) today.disabled = parseDateText(d.today, "Y-m-d", d.min, d.max) === null;
      if (clear) clear.classList.toggle("hidden", d.clearable !== "true");
    },

    position() {
      var popup = this.popupEl();
      var spot = popupPlacement(
        this.el.getBoundingClientRect(),
        { width: popup.offsetWidth, height: popup.offsetHeight },
        { width: document.documentElement.clientWidth, height: document.documentElement.clientHeight }
      );
      popup.style.top = spot.top + "px";
      popup.style.left = spot.left + "px";
    },

    // A day picked in the calendar, or "Today".
    pick(iso) {
      var ok = parseDateText(iso, "Y-m-d", this.el.dataset.min, this.el.dataset.max);
      if (ok === null) return;
      this.setValue(ok);
      this.syncText();
      this.closePopup(true);
    },

    bindClosers() {
      var self = this;
      var popup = this.popupEl();
      var close = function() { self.closePopup(false); };
      var dialog = this.el.closest("dialog");
      this.closers = [
        [document, "pointerdown", function(e) {
          if (popup.contains(e.target)) return;
          if (e.target.closest && e.target.closest("[data-open]") && self.el.contains(e.target)) return;
          self.closePopup(false);
        }, true],
        // A scroll of the page or of an ancestor of the field moves the field
        // away from the popup; an unrelated panel scrolling does not.
        [window, "scroll", function(e) {
          var t = e.target;
          if (popup.contains(t)) return;
          if (t === document || t === document.documentElement || (t.contains && t.contains(self.el))) close();
        }, true],
        [window, "resize", close, false],
        [window, "pagehide", close, false]
      ];
      if (dialog) this.closers.push([dialog, "close", close, false]);
      this.closers.forEach(function(c) { c[0].addEventListener(c[1], c[2], c[3]); });
      // Cally's own height changes (a 6-week month): keep it clear of the field.
      if (typeof ResizeObserver === "function") {
        this.resizer = new ResizeObserver(function() {
          if (self.popupOpen() && popup.style.visibility !== "hidden") self.position();
        });
        this.resizer.observe(popup);
      }
    },

    closePopup(refocus) {
      if (this.closers) {
        this.closers.forEach(function(c) { c[0].removeEventListener(c[1], c[2], c[3]); });
        this.closers = null;
      }
      if (this.resizer) {
        this.resizer.disconnect();
        this.resizer = null;
      }
      var popup = this.popupEl();
      if (popup && this.popupOpen()) {
        try { popup.hidePopover(); } catch (_e) { /* already closed */ }
      }
      this.setExpanded(false);
      if (refocus) {
        var t = this.textEl();
        if (t) t.focus();
      }
    },

    setExpanded(open) {
      var btn = this.el.querySelector("[data-open]");
      if (btn) btn.setAttribute("aria-expanded", open ? "true" : "false");
    },

    toggleClear() {
      var btn = this.el.querySelector("[data-clear]");
      var text = this.textEl();
      if (btn && text) btn.classList.toggle("hidden", text.value === "");
    },

    // The text was refused: remember it (a patch may rewrite the field) and mark it.
    reject(reason) {
      this.rejected = { text: this.textEl().value, reason: reason };
      this.markInvalid();
    },

    // The text is, or became, the date: forget any refusal.
    accept() {
      this.rejected = null;
      this.markValid();
    },

    markInvalid() {
      var t = this.textEl();
      var d = this.el.dataset;
      var expected = (this.rejected && this.rejected.reason === "range" && d.rangeMessage) || d.expected || "";
      t.setCustomValidity(expected || "invalid");
      t.setAttribute("aria-invalid", "true");
      t.classList.add("input-error");
      if (expected) {
        var cur = t.getAttribute("title");
        if (!this.ownTitle(cur)) this.callerTitle = cur;
        t.setAttribute("title", expected);
      }
      this.say(expected);
    },

    // Is this title one the hook wrote (rather than the caller's)?
    ownTitle(title) {
      var d = this.el.dataset;
      return title == null || title === d.expected || title === d.rangeMessage;
    },

    // The rejection hint is a live region: a screen reader announces the text
    // that appears in it, and the text input points at it (aria-describedby).
    say(message) {
      var hint = this.el.querySelector("[data-date-hint]");
      if (hint && hint.textContent !== message) hint.textContent = message;
    },

    markValid() {
      var t = this.textEl();
      if (!t) return;
      t.setCustomValidity("");
      if (this.ownTitle(t.getAttribute("title"))) {
        if (this.callerTitle != null) t.setAttribute("title", this.callerTitle);
        else t.removeAttribute("title");
      }
      this.say("");
      // Errors the server rendered stay.
      if (!t.hasAttribute("data-has-errors")) {
        t.removeAttribute("aria-invalid");
        t.classList.remove("input-error");
      }
    },

    // After a patch: put back the marks only the hook knows about.
    refresh() {
      var t = this.textEl();
      if (!t) return;
      this.enhance();
      if (this.rejected) this.markInvalid();
      else this.markValid();
      this.toggleClear();
      this.setExpanded(this.popupOpen());
    }
  };

  // ---------------------------------------------------------------------------
  // PkCheckboxIndeterminate — applies the `indeterminate` property to a
  // checkbox based on `data-indeterminate="true"`. HTML has no attribute
  // form of `indeterminate`, so a small hook is needed to read the dataset
  // and assign the JS property after every LV patch.
  // ---------------------------------------------------------------------------

  window.PhoenixKitHooks.PkCheckboxIndeterminate = {
    _apply() {
      this.el.indeterminate = this.el.dataset.indeterminate === "true";
    },
    mounted() { this._apply(); },
    updated() { this._apply(); }
  };

  // ---------------------------------------------------------------------------
  // BulkSelectScope — client-side bulk-select state for admin tables.
  //
  // The hook owns the selection set in the browser; the server only learns
  // about it at action time (when the user clicks an action button). This
  // makes per-checkbox toggles feel instant — no round-trip on every click.
  //
  // Markup contract (inside the hook root element):
  //
  //   data-bulk-total="N"                   on the root, total row count
  //                                         (drives the header's
  //                                         all-selected check)
  //
  //   data-bulk-role="select-all"           the header checkbox. Click
  //                                         toggles every row to match.
  //
  //   data-bulk-role="row"
  //   data-uuid="<row-uuid>"                a per-row checkbox.
  //
  //   data-bulk-action="<lv-event>"         on a button: clicking pushes
  //                                         <lv-event> to the LV with
  //                                         `{ uuids: [...] }` payload. Pair
  //                                         with `data-confirm="..."` for a
  //                                         native confirm() prompt before
  //                                         the event fires (cancelling
  //                                         stops the click here — the
  //                                         event is never pushed). This
  //                                         hook always calls preventDefault
  //                                         on the click, which would
  //                                         otherwise make phoenix_html's
  //                                         own data-confirm handling never
  //                                         run (it bails out early when
  //                                         the event is already
  //                                         defaultPrevented), so this hook
  //                                         handles data-confirm itself.
  //
  //   data-bulk-clear                       on a button: pure client-side
  //                                         clear (uncheck all + reset).
  //
  //   data-bulk-count                       text content gets set to the
  //                                         current selected count.
  //
  //   data-bulk-show="has-selection"        element shown only when
  //                                         count > 0 (hidden otherwise).
  //   data-bulk-show="no-selection"         inverse: shown only when count
  //                                         is 0.
  //
  //   data-bulk-swap="<css-selector>"       on the ROOT: an element OUTSIDE
  //                                         this scope, hidden while the
  //                                         scope holds a selection. For the
  //                                         page toolbar that sits ABOVE a
  //                                         list — a `data-bulk-show` inside
  //                                         the scope cannot reach it, and
  //                                         revealing the action bar without
  //                                         hiding something pushes every row
  //                                         DOWN, so the next click lands on
  //                                         the wrong checkbox (boss via Max,
  //                                         2026-09-20: measured at 52px, more
  //                                         than a row). The bar takes the
  //                                         toolbar's place instead, and the
  //                                         rows do not move. Several scopes
  //                                         on one page may name the same
  //                                         toolbar: it stays hidden while ANY
  //                                         of them has a selection, which is
  //                                         why this restores by re-asking the
  //                                         others rather than by remembering.
  //
  //   data-bulk-text-template="…%{count}…"  element's textContent is
  //                                         re-rendered from the template
  //                                         each time the count changes
  //                                         (%{count} → current count).
  //
  //   data-bulk-label-empty / -selected     button label flips between
  //                                         the two strings based on
  //                                         count (selected supports
  //                                         %{count} interpolation).
  // ---------------------------------------------------------------------------

  // Does any live scope still stand in for this toolbar? Asked of every
  // scope naming it — a page can have several over one toolbar, and clearing
  // one must not restore a toolbar another's action bar is still occupying.
  function anyScopeClaims(selector) {
    return Array.prototype.some.call(
      document.querySelectorAll("[data-bulk-swap]"),
      function (scope) {
        return scope.dataset.bulkSwap === selector && (scope._pkBulkCount || 0) > 0;
      }
    );
  }

  if (typeof module === "object" && module.exports) {
    module.exports.anyScopeClaims = anyScopeClaims;
  }

  window.PhoenixKitHooks.BulkSelectScope = {
    // Hides the toolbar this scope replaces while it holds a selection.
    //
    // A page can carry several scopes (the catalogue's categories AND its
    // items) over ONE toolbar, so "should it be hidden" is asked of every
    // scope naming it, not remembered here: restoring from a private flag
    // would un-hide the toolbar the moment one list cleared, while the
    // other still had rows selected and its action bar on screen.
    _syncSwap(count) {
      // Publish this scope's live count on the ELEMENT before reading the
      // others, so every scope answers from the same place and the result
      // does not depend on which hook ran last.
      //
      // A count, not the row checkboxes. Selection lives in each hook's Set,
      // and the server re-renders every checkbox UNCHECKED — so a scope that
      // has just been patched reads as empty from the DOM until its own
      // `updated()` restores it. A sibling syncing in that window would then
      // un-hide a toolbar whose action bar is still on screen, and the rows
      // jump: the exact regression this exists to prevent (grok, zai and
      // vibe all landed on this independently, 2026-09-20).
      //
      // A property rather than an attribute: morphdom rewrites attributes it
      // rendered and would strip this one on the next patch, which is how the
      // dialog `open` attribute bit earlier the same night.
      this.el._pkBulkCount = count;

      const selector = this.el.dataset.bulkSwap;
      if (!selector) return;

      let target;
      try {
        target = document.querySelector(selector);
      } catch (_e) {
        return; // a malformed selector must not take the page down
      }
      if (!target) return;

      target.style.display = anyScopeClaims(selector) ? "none" : "";
    },
    destroyed() {
      // A scope can be patched away mid-selection (the list empties, a filter
      // removes it). Its count leaves with it, and the toolbar it was
      // standing in for has to come back — otherwise the page keeps a hidden
      // toolbar and no action bar, with nothing left to restore it (codex,
      // 2026-09-20).
      this.el._pkBulkCount = 0;

      const selector = this.el.dataset.bulkSwap;
      if (!selector) return;

      try {
        const target = document.querySelector(selector);
        if (target) target.style.display = anyScopeClaims(selector) ? "none" : "";
      } catch (_e) {
        // malformed selector — nothing to restore
      }
    },
    mounted() {
      this.selected = new Set();
      this._readFromDom();
      this._wire();
      this._sync();
    },
    updated() {
      // LV may have re-rendered the row set (filter, reload, delete,
      // reorder, apply_reorder, load_more). The server always renders
      // checkboxes unchecked — selection lives in this hook's in-
      // memory Set, NOT in the markup. So we restore from the Set
      // against whatever rows are in the DOM now, and prune uuids
      // whose rows are no longer present (filtered, deleted).
      //
      // Always assign `checked` explicitly (true OR false) — never
      // skip the false case. Morphdom can reuse input nodes whose
      // `dataset.uuid` changed (row swapped under the same node), and
      // a stale `checked=true` left over from that reuse would render
      // a phantom selection that this.selected doesn't actually own.
      const surviving = new Set();
      this.el.querySelectorAll('[data-bulk-role="row"]').forEach((r) => {
        const uuid = r.dataset.uuid;
        const want = !!(uuid && this.selected.has(uuid));
        r.checked = want;
        if (want) surviving.add(uuid);
      });
      this.selected = surviving;
      this._wire();
      this._sync();
    },
    _readFromDom() {
      // Initial mount: read whatever is already checked in the markup.
      // Used only by mounted(); updated() restores from the in-memory
      // Set instead so selection survives LV re-renders.
      this.selected.clear();
      this.el.querySelectorAll('[data-bulk-role="row"]').forEach((r) => {
        if (r.checked && r.dataset.uuid) this.selected.add(r.dataset.uuid);
      });
    },
    _wire() {
      const self = this;
      const header = this.el.querySelector('[data-bulk-role="select-all"]');
      if (header && !header._pkBulkWired) {
        header.addEventListener("click", function() { self._onHeaderClick(header); });
        header._pkBulkWired = true;
      }
      this.el.querySelectorAll('[data-bulk-role="row"]').forEach(function(r) {
        if (r._pkBulkWired) return;
        r.addEventListener("click", function() { self._onRowClick(r); });
        r._pkBulkWired = true;
      });
      this.el.querySelectorAll("[data-bulk-action]").forEach(function(btn) {
        if (btn._pkBulkWired) return;
        btn.addEventListener("click", function(e) { self._onActionClick(e, btn); });
        btn._pkBulkWired = true;
      });
      this.el.querySelectorAll("[data-bulk-clear]").forEach(function(btn) {
        if (btn._pkBulkWired) return;
        btn.addEventListener("click", function() { self._clearAll(); });
        btn._pkBulkWired = true;
      });
    },
    _onHeaderClick(header) {
      const rows = this.el.querySelectorAll('[data-bulk-role="row"]');
      const self = this;
      if (header.checked) {
        rows.forEach(function(r) {
          r.checked = true;
          if (r.dataset.uuid) self.selected.add(r.dataset.uuid);
        });
      } else {
        rows.forEach(function(r) { r.checked = false; });
        this.selected.clear();
      }
      this._sync();
    },
    _onRowClick(input) {
      const uuid = input.dataset.uuid;
      if (!uuid) return;
      if (input.checked) this.selected.add(uuid);
      else this.selected.delete(uuid);
      this._sync();
    },
    _onActionClick(e, btn) {
      e.preventDefault();
      const event = btn.dataset.bulkAction;
      if (!event) return;

      // Honor `data-confirm` ourselves: this handler already called
      // `e.preventDefault()` above, and phoenix_html's own window-level
      // click listener bails out early via `if (e.defaultPrevented) return;`
      // — so a button carrying both `data-confirm` and `data-bulk-action`
      // would otherwise never show the native confirm dialog and the
      // action would fire immediately with no prompt.
      const confirmMessage = btn.dataset.confirm;
      if (confirmMessage && !window.confirm(confirmMessage)) return;

      // If the button is paired with a kept-in-DOM dialog, open it
      // locally BEFORE pushing the event. The server still gets the
      // payload + flips its `@show_*_modal` assign for state sync,
      // but the user sees the modal instantly instead of waiting
      // for the round-trip.
      const dialogId = btn.dataset.bulkOpensDialog;
      if (dialogId) {
        const dialog = document.getElementById(dialogId);
        if (dialog && !dialog.open && typeof dialog.showModal === "function") {
          dialog.showModal();
        }
      }

      this.pushEventTo(this.el, event, { uuids: Array.from(this.selected) });
    },
    _clearAll() {
      this.el.querySelectorAll('[data-bulk-role="row"]').forEach(function(r) {
        r.checked = false;
      });
      this.selected.clear();
      this._sync();
    },
    _sync() {
      const total = parseInt(this.el.dataset.bulkTotal || "0", 10);
      const count = this.selected.size;

      const header = this.el.querySelector('[data-bulk-role="select-all"]');
      if (header) {
        header.checked = count > 0 && count === total;
        header.indeterminate = count > 0 && count < total;
      }

      this.el.querySelectorAll("[data-bulk-count]").forEach(function(el) {
        el.textContent = String(count);
      });

      this.el.querySelectorAll("[data-bulk-text-template]").forEach(function(el) {
        el.textContent = el.dataset.bulkTextTemplate.replace("%{count}", String(count));
      });

      this.el.querySelectorAll("[data-bulk-show]").forEach(function(el) {
        const mode = el.dataset.bulkShow;
        const visible =
          mode === "has-selection" ? count > 0 :
          mode === "no-selection" ? count === 0 :
          mode === "has-multiple" ? count > 1 :
          // count is 0 OR > 1 — used by reorder-like buttons whose
          // single-row case is a no-op (count=1 hides the button).
          mode === "not-single" ? count !== 1 : true;
        el.style.display = visible ? "" : "none";
      });

      this._syncSwap(count);

      // Label flip: requires at least the `selected` variant. The
      // `empty` variant is optional — when absent, count <= 1 leaves
      // the server-rendered initial text in place (which is fine,
      // since a button without label-empty is also typically gated
      // to hide at low counts via data-bulk-show).
      //
      // Threshold is `> 1`, not `> 0`: a one-row "Reorder selected"
      // is a no-op (permuting a single row leaves it where it was),
      // and "Delete 1 selected" reads identically to bare "Delete".
      // Showing the empty label at count=1 keeps the button label
      // honest about what's actually going to happen.
      this.el.querySelectorAll("[data-bulk-label-selected]").forEach(function(el) {
        const empty = el.dataset.bulkLabelEmpty;
        const label = count > 1
          ? el.dataset.bulkLabelSelected.replace("%{count}", String(count))
          : empty;
        if (label === undefined) return;
        // Only swap the text node so we don't blow away icon children.
        let updated = false;
        for (const node of el.childNodes) {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== "") {
            node.textContent = label;
            updated = true;
            break;
          }
        }
        if (!updated) el.appendChild(document.createTextNode(label));
      });
    }
  };

  // Resolves the push target that OWNS `el`: the numeric CID of the nearest
  // LiveComponent ancestor, or null when nothing but the LiveView is above it.
  // pushEventTo with an ELEMENT resolves the target from that element's
  // phx-target attribute — which the elements here (a <dialog>, a load-more
  // sentinel) don't carry, so the push silently landed on the host LiveView.
  // The numeric CID is a first-class target in LiveView's `withinTargets`.
  //
  // The search stops at a nested LiveView root: a [data-phx-component] on the
  // far side of one belongs to a DIFFERENT view, and its cid means nothing to
  // this hook's socket. Whichever boundary is nearer wins.
  function ownerComponentCid(el) {
    if (!el || typeof el.closest !== "function") return null;
    const scope = el.closest("[data-phx-component],[data-phx-session]");
    if (!scope || !scope.hasAttribute("data-phx-component")) return null;
    const cid = parseInt(scope.getAttribute("data-phx-component"), 10);
    return Number.isNaN(cid) ? null : cid;
  }

  // Pushes `event` to whoever owns `el` — its LiveComponent when there is one,
  // the LiveView otherwise. `hook` is any object with LiveView's pushEvent /
  // pushEventTo (a hook, or another hook acting on a stacked child's behalf).
  function pushToOwner(hook, el, event, payload) {
    const cid = ownerComponentCid(el);
    if (cid === null) {
      hook.pushEvent(event, payload || {});
    } else {
      hook.pushEventTo(cid, event, payload || {});
    }
  }

  // True when an `input` event's target belongs to a submittable form of
  // THIS dialog — not a nested dialog's, not a filter/search form's. The
  // cheap pre-check behind PkDialog's `data-close-guard="input"`; the
  // decision itself is `guardedDirty` below.
  function guardedInput(dialog, target) {
    if (!dialog || !target || typeof target.closest !== "function") return false;
    if (target.closest("dialog") !== dialog) return false;
    if (target.type === "search" || target.closest("form[role=search]")) return false;
    return !!target.closest("form[phx-submit]");
  }

  // Does a field of a submittable form of THIS dialog differ from its
  // default (the value the server rendered)? Checkboxes/radios by
  // checkedness, selects by selection, everything else by value. A
  // search field never counts. This is what "holds unsaved input" means
  // on the client: a form the server re-rendered with the typed value, or
  // reset after a save, reads clean again — no latch to get stuck on.
  function fieldDirty(el) {
    if (!el || !el.name || el.disabled) return false;
    const type = (el.type || "").toLowerCase();
    if (type === "hidden" || type === "submit" || type === "button" || type === "search") return false;
    if (el.closest && el.closest("form[role=search]")) return false;
    if (type === "checkbox" || type === "radio") return el.checked !== el.defaultChecked;
    if (el.tagName === "SELECT") {
      for (const o of Array.from(el.options || [])) if (o.selected !== o.defaultSelected) return true;
      return false;
    }
    if (typeof el.value === "string" && typeof el.defaultValue === "string") {
      return el.value !== el.defaultValue;
    }
    return false;
  }

  function guardedDirty(dialog) {
    if (!dialog || typeof dialog.querySelectorAll !== "function") return false;
    for (const form of Array.from(dialog.querySelectorAll("form[phx-submit]"))) {
      if (form.closest && form.closest("dialog") !== dialog) continue;
      for (const el of Array.from(form.elements || [])) if (fieldDirty(el)) return true;
    }
    return false;
  }

  // The `phx-value-*` attributes of an element as an event payload — the
  // same convention LiveView applies to `phx-click`, so a hook-driven
  // element (PkDialog's close) can carry identifiers exactly like a
  // clicked button would (`phx-value-frame-ref` → `{"frame-ref": …}`).
  // Elements without any such attribute yield `{}`, the pre-existing
  // payload, so every current consumer is unaffected.
  function phxValuePayload(el) {
    const payload = {};
    if (!el || !el.attributes) return payload;
    for (const attr of Array.from(el.attributes)) {
      if (attr.name.startsWith("phx-value-")) {
        payload[attr.name.slice("phx-value-".length)] = attr.value;
      }
    }
    return payload;
  }

  if (typeof module === "object" && module.exports) {
    module.exports.ownerComponentCid = ownerComponentCid;
    module.exports.pushToOwner = pushToOwner;
    module.exports.phxValuePayload = phxValuePayload;
    module.exports.guardedInput = guardedInput;
    module.exports.guardedDirty = guardedDirty;
  }

  // Returns true if the given <dialog> is in the browser's top layer
  // (was opened via showModal()). Uses the `:modal` pseudo-class as
  // the truth source, with a graceful fallback to the `open`
  // attribute for older engines that lack `:modal` support.
  function isDialogOpenInBrowser(el) {
    if (!el || typeof el.matches !== "function") return false;
    try {
      return el.matches(":modal");
    } catch (_e) {
      // `matches()` throws SyntaxError on the `:modal` selector when
      // the engine doesn't recognise it (pre-2022 browsers). The
      // fallback loses fidelity to morphdom-strip cases but is the
      // best we can do without the pseudo-class.
      return !!el.open;
    }
  }

  if (typeof module === "object" && module.exports) {
    module.exports.isDialogOpenInBrowser = isDialogOpenInBrowser;
  }

  // True when a click on a dialog is a click on its backdrop: the press AND
  // the release must both land on the <dialog> element itself. The browser
  // dispatches a click to the nearest common ancestor of the two, so a drag
  // that starts inside the box and is let go past its edge — selecting the
  // text of a field, pulling a textarea's resize grip — also arrives with the
  // dialog as its target, and closed the modal under the user's cursor with
  // whatever they had typed. So does the opposite drag, from the backdrop
  // into the box, which is why the click's own target proves nothing and the
  // release is checked separately.
  function backdropClick(dialog, pressTarget, releaseTarget, clickTarget) {
    return !!dialog && pressTarget === dialog && releaseTarget === dialog && clickTarget === dialog;
  }

  // Keeps the size a user dragged a <textarea> to. The resize grip writes
  // inline `height`/`width`, which the server never rendered, so the next
  // LiveView patch drops the `style` attribute and the field snaps back to
  // its default size mid-edit. A press on a textarea that leaves its inline
  // size changed is a resize; from then on the size is put back whenever a
  // patch takes it away. Bound once on the document, so every textarea is
  // covered — core's components, a module's own markup, inside a dialog or
  // not — with nothing to opt into.
  function textareaSizeChanged(before, after) {
    return !!before && !!after && (before.height !== after.height || before.width !== after.width);
  }

  function inlineSize(el) {
    return { height: el.style.height || "", width: el.style.width || "" };
  }

  // Sizes by element id, for a textarea that is REPLACED rather than patched
  // — a language switch re-mounts every translatable field. The replacement
  // carries the same id and takes the size its predecessor was dragged to.
  // The document is only watched once something has actually been resized.
  const keptSizesById = {};
  let replacementObserver = null;

  function adoptKeptSize(el) {
    if (!el || el.tagName !== "TEXTAREA" || !el.id || el._pkKeptSize) return;
    const size = keptSizesById[el.id];
    if (!size) return;
    el.style.height = size.height;
    el.style.width = size.width;
    keepTextareaSize(el, size);
  }

  function watchForReplacements() {
    if (replacementObserver || typeof MutationObserver !== "function" || !document.body) return;
    replacementObserver = new MutationObserver(function(records) {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.tagName === "TEXTAREA") adoptKeptSize(node);
          else if (node.querySelectorAll) node.querySelectorAll("textarea[id]").forEach(adoptKeptSize);
        }
      }
    });
    replacementObserver.observe(document.body, { childList: true, subtree: true });
  }

  function keepTextareaSize(el, size) {
    el._pkKeptSize = size;
    if (el.id) {
      keptSizesById[el.id] = size;
      watchForReplacements();
    }
    if (el._pkSizeObserver || typeof MutationObserver !== "function") return;
    el._pkSizeObserver = new MutationObserver(function() {
      const kept = el._pkKeptSize;
      // Mid-drag the browser is the one writing the style; leave it alone.
      if (!kept || el._pkResizing) return;
      if (el.style.height !== kept.height) el.style.height = kept.height;
      if (el.style.width !== kept.width) el.style.width = kept.width;
    });
    el._pkSizeObserver.observe(el, { attributes: true, attributeFilter: ["style"] });
  }

  if (typeof document !== "undefined" && document.addEventListener && !window.__pkTextareaSizeBound) {
    window.__pkTextareaSizeBound = true;
    document.addEventListener("pointerdown", function(e) {
      const el = e.target;
      if (!el || el.tagName !== "TEXTAREA") return;
      const before = inlineSize(el);
      el._pkResizing = true;
      const done = function() {
        window.removeEventListener("pointerup", done, true);
        window.removeEventListener("pointercancel", done, true);
        window.removeEventListener("pointermove", released, true);
        el._pkResizing = false;
        const after = inlineSize(el);
        if (textareaSizeChanged(before, after)) keepTextareaSize(el, after);
      };
      // A button let go outside the window may never deliver its pointerup.
      // The first move that reports no button down ends the press instead, or
      // the field would stay "mid-drag" and the next patch would take its size.
      const released = function(move) { if (move.buttons === 0) done(); };
      window.addEventListener("pointerup", done, true);
      window.addEventListener("pointercancel", done, true);
      window.addEventListener("pointermove", released, true);
    }, true);
  }

  // The same drag, caught for everything that is not a PkDialog. A press that
  // begins in a text field and is released outside it — a selection dragged
  // past the field's edge — is dispatched as a click on their common ancestor:
  // a wrapper carrying `phx-click` (a hand-rolled modal's backdrop, a row or
  // card that opens something) then fires and takes the half-typed text with
  // it. Nobody means that gesture as a click on the ancestor, so it is
  // stopped before any handler sees it. Only pointer clicks count: a keyboard
  // activation reports `detail` 0 and has no press to compare against.
  function textEntryField(el) {
    if (!el || !el.tagName) return false;
    if (el.isContentEditable) return true;
    if (el.tagName === "TEXTAREA") return true;
    if (el.tagName !== "INPUT") return false;
    const type = (el.type || "text").toLowerCase();
    return ["text", "search", "email", "url", "tel", "password", "number"].indexOf(type) !== -1;
  }

  function strayFieldClick(pressTarget, clickTarget, detail) {
    if (!pressTarget || !clickTarget || !detail) return false;
    if (pressTarget === clickTarget) return false;
    if (!textEntryField(pressTarget)) return false;
    return typeof clickTarget.contains === "function" && clickTarget.contains(pressTarget);
  }

  if (typeof document !== "undefined" && document.addEventListener && !window.__pkStrayClickBound) {
    window.__pkStrayClickBound = true;
    let pressedOn = null;
    document.addEventListener("pointerdown", function(e) { pressedOn = e.target; }, true);
    document.addEventListener("click", function(e) {
      const pressed = pressedOn;
      pressedOn = null;
      if (strayFieldClick(pressed, e.target, e.detail)) e.stopPropagation();
    }, true);
  }

  // --- Unsaved input -------------------------------------------------------
  //
  // A modal holding a form the user has typed into does not close on the
  // first Escape or backdrop click: the attempt is refused with a nudge of
  // the box, and only a second one within a few seconds goes through. One
  // stray click or key no longer costs a filled-in form, and nobody is ever
  // trapped — the modal's own Cancel / ✕ / Save are untouched, and so is a
  // deliberate second try.
  //
  // "Typed into" is a flag set by a real input/change event in a submittable
  // form, not a comparison with the rendered values: a form with `phx-change`
  // is re-rendered with what was typed after every keystroke, and would read
  // clean again the moment the server answered.
  const DISCARD_WINDOW_MS = 4000;
  // The same Escape reaches a stacked dialog twice (its own cancel and the
  // parent's relay); anything this close to the refusal is that same attempt.
  const SAME_ATTEMPT_MS = 250;

  function discardAttempt(lastRefusedAt, now) {
    if (!lastRefusedAt) return "refuse";
    const since = now - lastRefusedAt;
    if (since < SAME_ATTEMPT_MS) return "same";
    return since <= DISCARD_WINDOW_MS ? "allow" : "refuse";
  }

  function nudgeBox(box) {
    if (!box || typeof box.animate !== "function") return;
    const still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const frames = still
      ? [{ opacity: 1 }, { opacity: 0.6 }, { opacity: 1 }]
      : [
          { transform: "translateX(0)" },
          { transform: "translateX(-8px)" },
          { transform: "translateX(8px)" },
          { transform: "translateX(-4px)" },
          { transform: "translateX(0)" }
        ];
    box.animate(frames, { duration: 220, easing: "ease-in-out" });
  }

  // Refuses or allows one close attempt on `holder`, an object carrying the
  // `_pkTouched` / `_pkRefusedAt` state. True means: do not close.
  function refuseUnsavedClose(holder, box) {
    if (!holder || !holder._pkTouched) return false;
    const verdict = discardAttempt(holder._pkRefusedAt, Date.now());
    if (verdict === "allow") {
      holder._pkTouched = false;
      holder._pkRefusedAt = 0;
      return false;
    }
    if (verdict === "refuse") {
      holder._pkRefusedAt = Date.now();
      nudgeBox(box);
    }
    return true;
  }

  // The same protection for a modal that is NOT a PkDialog: daisyUI's
  // class-driven shape, `.modal.modal-open` around a `.modal-box` and a
  // `.modal-backdrop`, closed by a `phx-click` on the backdrop and often a
  // `phx-window-keydown` for Escape. Those are plain LiveView bindings, so the
  // attempt is stopped here, in the capture phase, before LiveView's own
  // window listeners hear it.
  function classModalOf(el) {
    if (!el || typeof el.closest !== "function") return null;
    const dialog = el.closest("dialog");
    if (dialog && dialog.getAttribute("phx-hook") === "PkDialog") return null;
    const modal = el.closest(".modal-open");
    if (!modal || modal.getAttribute("phx-hook") === "PkDialog") return null;
    return modal;
  }

  function submittableField(target) {
    if (!target || typeof target.closest !== "function") return false;
    if (target.type === "search" || target.closest("form[role=search]")) return false;
    return !!target.closest("form[phx-submit]");
  }

  if (typeof document !== "undefined" && document.addEventListener && !window.__pkUnsavedGuardBound) {
    window.__pkUnsavedGuardBound = true;
    const touch = function(e) {
      if (e.isTrusted === false || !submittableField(e.target)) return;
      const modal = classModalOf(e.target);
      if (modal) modal._pkTouched = true;
    };
    document.addEventListener("input", touch, true);
    document.addEventListener("change", touch, true);
    // Submission may fail validation or persistence. Only a confirmed save
    // clears the guard: an add-another flow can dispatch this on its modal
    // after the server reports success, for either modal implementation.
    document.addEventListener("pk:dialog-saved", function(e) {
      const target = e.target;
      if (!target || typeof target.closest !== "function") return;
      const modal = target.closest("dialog") || classModalOf(target);
      if (modal) {
        modal._pkTouched = false;
        modal._pkRefusedAt = 0;
      }
    }, true);
    window.addEventListener("phx:pk:dialog-saved", function(e) {
      const id = e.detail && e.detail.id;
      if (typeof id !== "string" || !id) return;
      const modal = document.getElementById(id);
      if (modal) {
        modal._pkTouched = false;
        modal._pkRefusedAt = 0;
      }
    });
    document.addEventListener("click", function(e) {
      const backdrop = e.target && e.target.closest && e.target.closest(".modal-backdrop");
      if (!backdrop) return;
      const modal = classModalOf(backdrop);
      if (modal && refuseUnsavedClose(modal, modal.querySelector(".modal-box"))) {
        e.stopPropagation();
        e.preventDefault();
      }
    }, true);
    document.addEventListener("keydown", function(e) {
      if (e.key !== "Escape") return;
      // Escape that only dismisses an input method's candidate list is not a
      // request to close anything; a `phx-window-keydown` binding cannot tell.
      if (e.isComposing) { e.stopPropagation(); return; }
      // A native dialog lives above every CSS modal in the browser's top
      // layer, and need not carry .modal-open. Its own cancel handler decides.
      if (Array.from(document.querySelectorAll("dialog")).some(isDialogOpenInBrowser)) return;
      // Only the topmost modal answers an Escape. A touched modal underneath an
      // untouched (or PkDialog) one must not swallow the key meant to close the
      // one on top.
      const open = document.querySelectorAll(".modal-open");
      const modal = open[open.length - 1];
      if (!modal || modal.getAttribute("phx-hook") === "PkDialog" || !modal._pkTouched) return;
      if (refuseUnsavedClose(modal, modal.querySelector(".modal-box"))) {
        e.stopPropagation();
        e.preventDefault();
      }
    }, true);
  }

  if (typeof module === "object" && module.exports) {
    module.exports.backdropClick = backdropClick;
    module.exports.textareaSizeChanged = textareaSizeChanged;
    module.exports.strayFieldClick = strayFieldClick;
    module.exports.discardAttempt = discardAttempt;
  }

  // ---------------------------------------------------------------------------
  // TableLocalSearch Hook
  // ---------------------------------------------------------------------------
  //
  // Client-instant narrowing for list tables that use <.search_toolbar>:
  // while the debounced server round-trip is in flight, rows are hidden
  // locally so the filter feels immediate. The server response stays
  // authoritative — its patch replaces the row set, and `updated()`
  // re-applies the live query so the two never fight.
  //
  // Attach to an element wrapping BOTH the search input and the rows:
  //
  //   <div id="..." phx-hook="TableLocalSearch"
  //        data-local-search-enabled={to_string(@all_rows_loaded?)}>
  //     <.search_toolbar ... />
  //     ...rows carrying a lowercase data-search="haystack" attribute...
  //     <p data-local-search-empty class="hidden">No matches</p>
  //   </div>
  //
  // When `data-local-search-enabled` != "true" (the row set is incomplete
  // because server pagination is in play), the hook does nothing — hiding
  // only the loaded rows would falsely report "no matches" for rows that
  // live beyond the current page. The server search covers that case.
  window.PhoenixKitHooks.TableLocalSearch = {
    mounted() {
      this._onInput = (e) => {
        const input = this._input();
        if (!input || e.target !== input) return;
        this._apply();
      };
      this.el.addEventListener("input", this._onInput);
    },
    updated() {
      // A server patch landed (authoritative row set) — re-apply the
      // current query so re-added rows don't flash unfiltered, and so
      // client-added `hidden` classes get reconciled with server truth.
      this._apply();
    },
    destroyed() {
      this.el.removeEventListener("input", this._onInput);
    },
    _input() {
      return this.el.querySelector('input[name="search"]');
    },
    _apply() {
      if (this.el.dataset.localSearchEnabled !== "true") return;
      const input = this._input();
      const q = ((input && input.value) || "").trim().toLowerCase();
      let visible = 0;
      this.el.querySelectorAll("[data-search]").forEach((row) => {
        const match = q === "" || (row.dataset.search || "").includes(q);
        row.classList.toggle("hidden", !match);
        if (match) visible += 1;
      });
      const empty = this.el.querySelector("[data-local-search-empty]");
      if (empty) empty.classList.toggle("hidden", !(q !== "" && visible === 0));
    }
  };

  // ---------------------------------------------------------------------------
  // AdminSidebarScroll — keep the admin menu's scroll position across
  // navigations.
  // ---------------------------------------------------------------------------
  //
  // Every sidebar navigation rebuilds the sidebar DOM: a live redirect
  // replaces the whole main container, and cross-live_session navigation
  // (each feature module has its own session) is a full page reload. Both
  // reset the menu's scrollTop to 0 — on short screens most of the menu
  // lives below the fold, so the user loses their place on every click.
  //
  // Design (per the sidebar-scroll design review):
  //   * scroll position is client/viewport state — it is saved to
  //     sessionStorage (per-tab) and restored, never sent to the server;
  //   * SAVE: one document-level capture listener (scroll doesn't bubble,
  //     but it does capture), rAF-throttled, plus flushes on
  //     phx:page-loading-start and pagehide so the final position right
  //     before a navigation is never lost. Document/window listeners
  //     survive live redirects, so there is nothing to re-bind or clean up.
  //   * RESTORE: the AdminSidebarScroll hook's mounted() — which re-fires
  //     on every live redirect because the container is replaced — runs
  //     synchronously with the DOM patch, before paint (no flash at 0).
  //     Full page loads restore at DOMContentLoaded, before the LiveView
  //     socket connects.
  //   * CORRECTION: when nothing is saved (fresh tab, deep link) or the
  //     restored offset leaves the current page's [aria-current="page"]
  //     link off-screen (menu shape changed: permissions, locale, module
  //     set), center the active link instead. Direct scrollTop math, not
  //     scrollIntoView — the latter can scroll ancestor containers too.
  (function () {
    const EL_ID = "pk-admin-sidebar";
    const KEY = "phoenix_kit:admin:sidebar:scroll";

    function readSaved() {
      try {
        const v = sessionStorage.getItem(KEY);
        if (v == null) return null;
        const n = parseInt(v, 10);
        return isNaN(n) ? null : n;
      } catch (_e) {
        return null;
      }
    }

    function save(el) {
      try {
        sessionStorage.setItem(KEY, String(Math.round(el.scrollTop)));
      } catch (_e) {
        // Storage unavailable (private browsing etc.) — degrade to the
        // active-item fallback on the next load.
      }
    }

    function restore(el) {
      const max = Math.max(0, el.scrollHeight - el.clientHeight);
      const saved = readSaved();
      if (saved != null) {
        el.scrollTop = Math.min(saved, max);
      }

      const active = el.querySelector('[aria-current="page"]');
      if (!active) return;
      const er = el.getBoundingClientRect();
      const ar = active.getBoundingClientRect();
      const visible = ar.top >= er.top && ar.bottom <= er.bottom;
      if (saved == null || !visible) {
        const target = el.scrollTop + (ar.top - er.top) - (el.clientHeight - ar.height) / 2;
        el.scrollTop = Math.min(Math.max(0, target), max);
      }
    }

    // Save side — bound once per full page load, element-independent.
    let saveQueued = false;
    document.addEventListener(
      "scroll",
      function (e) {
        const el = e.target;
        if (!el || el.id !== EL_ID || saveQueued) return;
        saveQueued = true;
        requestAnimationFrame(function () {
          saveQueued = false;
          const live = document.getElementById(EL_ID);
          if (live) save(live);
        });
      },
      { capture: true, passive: true }
    );

    function flush() {
      const el = document.getElementById(EL_ID);
      if (el) save(el);
    }
    window.addEventListener("phx:page-loading-start", flush);
    window.addEventListener("pagehide", flush);

    // Restore on full page loads (before the socket connects).
    function early() {
      const el = document.getElementById(EL_ID);
      if (el) restore(el);
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", early);
    } else {
      early();
    }

    // Restore on live redirects (mounted re-fires on the fresh container,
    // pre-paint). Idempotent with the early restore on full loads.
    window.PhoenixKitHooks.AdminSidebarScroll = {
      mounted() {
        restore(this.el);
      }
    };
  })();

  // NOTE: no scrollbar-gutter games here. Old daisyUI (5.0.x) reserved a
  // scrollbar gutter unconditionally while a modal was open, and this hook
  // used to counter it with an inline `scrollbar-gutter: auto` override —
  // which traded the phantom right-edge strip on non-scrolling pages for a
  // ~15px content reflow on pages that DO scroll (classic-scrollbar users saw
  // the scrollbar pop in/out around every modal). daisyUI >= 5.1 reserves the
  // gutter only when the page really has a scrollbar (rootscrollgutter.css),
  // which handles both page types correctly — PhoenixKit pins such a version
  // (see PhoenixKit.Install.DaisyUI), so the override is gone. Don't re-add it.
  window.PhoenixKitHooks.PkDialog = {
    _isCloseable() {
      if (this._guardTripped) return false;
      return this.el.dataset.closeable !== "false";
    },
    // data-close-guard="confirm" (the default): true when this Escape or
    // backdrop click is the first attempt on a form that has been typed into.
    _refuseUnsaved() {
      if (this.el.dataset.closeGuard !== "confirm") return false;
      return refuseUnsavedClose(this.el, this.el.querySelector(".modal-box"));
    },
    _forgetUnsaved() {
      this.el._pkTouched = false;
      this.el._pkRefusedAt = 0;
    },
    // A dialog in the top layer whose `open` attribute has gone missing still
    // LOOKS open but behaves as closed: the Escape close steps and `close()`
    // both return early, so no `close` event fires and `_onClose` never pushes
    // the server's close event — the modal vanishes from the screen while the
    // server still believes it is open, and re-opens on the next patch. The
    // server deliberately never renders `open` (see the note in `modal/1`:
    // showModal() throws on a dialog that already carries it), so morphdom
    // strips the attribute on every patch and this guard is the only thing
    // that puts it back before a close.
    _restoreOpenAttr() {
      if (!this.el.open && isDialogOpenInBrowser(this.el)) {
        this.el.setAttribute("open", "");
      }
    },
    _pushClose() {
      const ev = this.el.dataset.closeEvent;
      if (!ev) return;
      // Route to the LiveComponent that OWNS the dialog — a component-owned
      // modal's close event landed on the host LV instead (2026-08-31 — the
      // item selector's stacked details popup never closed on Esc; the
      // selector itself only "closed" because the misrouted event hit the
      // host). LV-owned dialogs have no component ancestor and keep routing
      // to the LV. See `pushToOwner`. The payload is the dialog's own
      // `phx-value-*` attributes (a stacked popup host stamps its frame
      // reference there so a close can be matched against the top frame).
      pushToOwner(this, this.el, ev, phxValuePayload(this.el));
    },
    _sync() {
      // `data-show` drives visibility for keep_in_dom modals. Conditional
      // modals (rendered only when @show=true) get the same attribute
      // value, so this works for both paths.
      // Absent attribute defaults to "true" so a consumer that doesn't
      // set data-show (legacy callers) keeps the original mount-opens
      // behavior.
      const wantOpen = this.el.dataset.show !== "false";
      // `:modal` matches whenever the dialog is in the browser's top
      // layer (showModal was called). This is the truth source — `el.open`
      // is just the reflected attribute, which Phoenix LV's DOM patcher
      // strips on re-render if it wasn't in the server template (the
      // browser added it via showModal(), the server didn't). Using
      // `:modal` keeps state in sync even after that attribute gets
      // stripped on a patch.
      //
      // `:modal` is a relatively new CSS pseudo-class (Chrome 105+,
      // Safari 15.6+, Firefox 117+). On browsers that have `matches()`
      // but not `:modal` it throws SyntaxError, which would break the
      // hook entirely — fall back to the `open` attribute so older
      // engines degrade to the pre-fix behavior rather than crash.
      const isOpenForBrowser = isDialogOpenInBrowser(this.el);
      if (
        wantOpen &&
        !isOpenForBrowser &&
        typeof this.el.showModal === "function"
      ) {
        this._forgetUnsaved();
        this.el.showModal();
      } else if (wantOpen && isOpenForBrowser) {
        // Dialog is in the top layer but the `open` attribute may have
        // been stripped by Phoenix LV's DOM patch (the server template
        // doesn't include `open=""` — the browser added it when
        // showModal() ran). CSS treats `dialog:not([open])` as
        // `display: none`, so the dialog becomes invisible AND
        // uninteractable while still blocking clicks elsewhere from
        // the top layer. Restore the attribute so the dialog renders.
        if (!this.el.open) {
          this.el.setAttribute("open", "");
        }
      } else if (!wantOpen && isOpenForBrowser) {
        // LV-driven close. If morphdom stripped the `open` attr after
        // the external showModal, restore it so close() can actually
        // release the top layer (close() needs `open` to fire 'close'
        // and detach from the top layer on every UA).
        if (!this.el.open) {
          this.el.setAttribute("open", "");
        }
        // Mark the close as LV-initiated so _onClose skips the echo
        // push (LV already knows data-show=false).
        this._closeFromLV = true;
        this._forgetUnsaved();
        this.el.close();
      }
    },
    mounted() {
      const self = this;
      this._closeFromLV = false;

      self._onCancel = function(e) {
        if (!self._isCloseable()) { e.preventDefault(); return; }
        // Escape's close steps do nothing without the `open` attribute, and
        // then no `close` event reaches `_onClose` to push the server's close.
        self._restoreOpenAttr();
        // A child dialog is stacked open INSIDE this one (the item
        // selector's product-details popup is the shipped case). Esc
        // must close only the TOP popup — but Chromium groups the close
        // watchers of dialogs whose showModal() ran without user
        // activation (ours run from LiveView patches), so a single Esc
        // fires 'cancel' on EVERY dialog in the group (2026-08-31: "Esc
        // closes both popups, but only top one needs to go"). Keep THIS
        // dialog open and RELAY the close request to the deepest stacked
        // child in its own semantics: a synthetic cancelable 'cancel',
        // then close() unless the child prevented it (a server-driven
        // child prevents and pushes its own event). preventDefault alone
        // is not enough — Chromium stops the grouped chain at the first
        // prevented watcher, so the child's own cancel never fires
        // (verified: neither popup closed).
        // Match by the browser's own notion of "open" (:modal), not the
        // `open` attribute — morphdom can strip the attribute between a
        // patch and the next _sync, and `dialog[open]` would miss the
        // child in that window (2026-08-31 external review). DOM order
        // stands in for top-layer order; the shipped stacks nest one
        // child, where the two agree.
        const stacked = Array.prototype.filter.call(
          self.el.querySelectorAll("dialog"),
          isDialogOpenInBrowser
        );
        if (stacked.length > 0) {
          e.preventDefault();
          const top = stacked[stacked.length - 1];
          // The child holds unsaved input of its own: its guard decides.
          if (top._pkRefuseUnsaved && top._pkRefuseUnsaved()) return;
          // Drive the child's SERVER close directly (its data-close-event
          // to its owning component by CID) and close its element for the
          // instant visual — relying on the child's own 'close' echo
          // proved fragile (the queued close event was observed not to
          // fire at all in this stack). Flag the child so its own
          // 'close' handler, when the event DOES fire, skips the echo
          // push — otherwise a non-idempotent close event (a toggle)
          // would fire twice (2026-08-31 external review).
          const closeEv = top.dataset && top.dataset.closeEvent;
          // The child's OWN cancel handler now pushes its close too (see
          // "Escape on THIS dialog" below). When the grouped chain reaches
          // the child before this parent, a fresh stamp says that push has
          // already gone out — pushing again would double-fire a
          // non-idempotent close event, the very thing the stamp guards.
          const childPushed =
            top._pkStackClosePushedAt &&
            Date.now() - top._pkStackClosePushedAt < 1000;
          if (closeEv && !childPushed) {
            // Stamped, not flagged: the child's own 'close' handler clears
            // this, but that handler is exactly what was observed not to
            // run here — a boolean would then suppress the child's NEXT
            // genuine close for the life of the element, leaving a dialog
            // the server never hears about (and re-opens on the next
            // patch). A stamp self-heals.
            top._pkStackClosePushedAt = Date.now();
            pushToOwner(self, top, closeEv, phxValuePayload(top));
          }
          top.close();
          return;
        }
        // Escape on THIS dialog. `cancel` is the only event we can rely on:
        // Chromium dismisses a close-watcher dialog — one whose showModal()
        // ran without user activation, which is every server-driven modal
        // here — WITHOUT ever firing `close` (measured on a live page,
        // 2026-09-20: cancel fires with `open` still set, the dialog leaves
        // the top layer, and no close event is dispatched; the same shape
        // the stacked note above records). `_onClose` therefore never runs,
        // the hook never pushes `on_close`, and the server goes on believing
        // the modal is open — re-opening it on the next patch. Push here,
        // and stamp the element so a `close` that DOES arrive (an explicit
        // close() from the backdrop path, or destroyed()) skips the echo.
        if (self._refuseUnsaved()) { e.preventDefault(); return; }
        self._forgetUnsaved();
        self.el._pkStackClosePushedAt = Date.now();
        self._pushClose();
      };
      // 'close' fires for our own el.close() in destroyed(), the backdrop
      // click (via _onClick → el.close()) and form `method="dialog"`
      // submits. It does NOT reliably fire for Escape — see `_onCancel`.
      self._onClose = function() {
        // `_pkStackClosePushedAt` is stamped by a stacked PARENT dialog that
        // already pushed this dialog's close event during a grouped cancel —
        // echoing here would double-fire the server handler. `close()` queues
        // its event as a task, so a real echo lands immediately; anything
        // older is a stamp whose close event never arrived and must not
        // suppress this close.
        const stackPushed =
          self.el._pkStackClosePushedAt &&
          Date.now() - self.el._pkStackClosePushedAt < 1000;
        if (!self._closeFromLV && !stackPushed) self._pushClose();
        self._forgetUnsaved();
        // Reset both now that the close event has been fully processed. The
        // next user-initiated close (Esc, backdrop) will fall through to the
        // echo push as intended.
        self._closeFromLV = false;
        self.el._pkStackClosePushedAt = 0;
      };
      // Backdrop click: a click event whose target is the <dialog> itself
      // (rather than a descendant) means the user clicked outside the
      // modal-box on the ::backdrop surface. Children stop propagation
      // naturally because event.target lands on them, not on the dialog.
      // The press and the release must both have landed there too — see
      // `backdropClick`. A release outside the dialog never reaches these
      // listeners, which leaves the release unset and the click refused.
      self._pressTarget = null;
      self._releaseTarget = null;
      self._onPointerDown = function(e) {
        self._pressTarget = e.target;
        self._releaseTarget = null;
      };
      self._onPointerUp = function(e) { self._releaseTarget = e.target; };
      self._onClick = function(e) {
        const pressTarget = self._pressTarget;
        const releaseTarget = self._releaseTarget;
        self._pressTarget = null;
        self._releaseTarget = null;
        if (!backdropClick(self.el, pressTarget, releaseTarget, e.target) || !self._isCloseable()) return;
        if (self._refuseUnsaved()) return;
        // Same reason as the Escape path: `close()` is a no-op, and fires no
        // `close` event, on a top-layer dialog whose `open` attribute is gone.
        self._restoreOpenAttr();
        self.el.close();
      };
      this.el.addEventListener("cancel", self._onCancel);
      this.el.addEventListener("close", self._onClose);
      this.el.addEventListener("pointerdown", self._onPointerDown);
      this.el.addEventListener("pointerup", self._onPointerUp);

      // data-close-guard="confirm": remember that a submittable form of THIS
      // dialog was typed into. Kept on the element so a stacked parent's
      // Escape relay can ask the child (`_pkRefuseUnsaved`).
      self._onTouch = function(e) {
        if (e.isTrusted === false) return;
        if (guardedInput(self.el, e.target)) self.el._pkTouched = true;
      };
      this.el.addEventListener("input", self._onTouch);
      this.el.addEventListener("change", self._onTouch);
      this.el._pkRefuseUnsaved = function() { return self._refuseUnsaved(); };
      this.el.addEventListener("click", self._onClick);

      // data-close-guard="input": see the header comment. Local state only —
      // the server's data-closeable remains the source of truth once it
      // arrives; this covers the round trip (and a debounce window) before it.
      // Recomputed, never latched: a frame whose LiveView never reports
      // dirtiness (a page with a plain submit form) must not lose Esc for
      // good after one keystroke (the sweep, 2026-09-05).
      self._guardTripped = false;
      if (self.el.dataset.closeGuard === "input") {
        self._onInput = function(e) {
          if (guardedInput(self.el, e.target)) self._guardTripped = guardedDirty(self.el);
        };
        this.el.addEventListener("input", self._onInput);
      }

      // Instant client-side open: a trigger can dispatch this custom
      // event (Phoenix.LiveView.JS.dispatch("pk:dialog-show", to: "#id"))
      // ALONGSIDE its server push, so the dialog appears the same frame
      // as the click while the server round-trip fills the content in.
      // The subsequent LV patch (data-show=true) finds the dialog already
      // open and no-ops; server-driven close keeps working unchanged.
      self._onShowEvent = function() {
        if (
          !isDialogOpenInBrowser(self.el) &&
          typeof self.el.showModal === "function"
        ) {
          self.el.showModal();
        }
      };
      this.el.addEventListener("pk:dialog-show", self._onShowEvent);

      // Server-initiated close for a dialog that was opened CLIENT-side
      // (pk:dialog-show) but whose content the server declined to load —
      // without this, an error path that never flips data-show would
      // leave the skeleton dialog open forever. LV removes hook
      // handleEvent listeners automatically on destroy.
      this.handleEvent("pk:dialog-close", function(payload) {
        if (payload && payload.id && payload.id !== self.el.id) return;
        if (isDialogOpenInBrowser(self.el)) {
          if (!self.el.open) self.el.setAttribute("open", "");
          self._closeFromLV = true;
          self.el.close();
        }
      });

      this._sync();
    },
    updated() {
      // Every server patch re-reads the forms: a save/reset renders them
      // clean, a re-render with the typed value makes data-closeable the
      // authority — either way the local guard lets go.
      if (this.el.dataset.closeGuard === "input") {
        this._guardTripped = guardedDirty(this.el);
      }
      this._sync();
    },
    destroyed() {
      // LV is removing the element. Tell _onClose not to echo a close
      // event back (LV already initiated this).
      this._closeFromLV = true;
      // Close the dialog so the browser releases it from the top layer.
      // Use the same "is the browser holding this dialog open?" predicate
      // as `_sync()` — `el.open` alone is unreliable when morphdom stripped
      // the attribute earlier. Restore `open` first if needed so `close()`
      // can release the top layer cleanly.
      if (isDialogOpenInBrowser(this.el)) {
        if (!this.el.open) this.el.setAttribute("open", "");
        this.el.close();
      }
      if (this._onCancel) this.el.removeEventListener("cancel", this._onCancel);
      if (this._onClose) this.el.removeEventListener("close", this._onClose);
      if (this._onClick) this.el.removeEventListener("click", this._onClick);
      if (this._onPointerDown) this.el.removeEventListener("pointerdown", this._onPointerDown);
      if (this._onPointerUp) this.el.removeEventListener("pointerup", this._onPointerUp);
      if (this._onTouch) {
        this.el.removeEventListener("input", this._onTouch);
        this.el.removeEventListener("change", this._onTouch);
      }
      if (this._onShowEvent) this.el.removeEventListener("pk:dialog-show", this._onShowEvent);
      if (this._onInput) this.el.removeEventListener("input", this._onInput);
    }
  };

  // PkDialogTrigger — makes a REGION instant-open a kept-in-DOM PkDialog.
  // Attach to a container whose descendants push server events that end in
  // a modal (e.g. a calendar grid where event/date clicks open an editor):
  //
  //   <div phx-hook="PkDialogTrigger" id="grid"
  //        data-dialog="my-modal"
  //        data-trigger=".cal-event, .cal-day-cell">
  //
  // On click it finds the closest [phx-click] ancestor — the SAME element
  // LiveView will hand the event to — and, if that element matches
  // data-trigger, dispatches pk:dialog-show to the dialog so it opens in
  // the same frame while the server round-trip fills the content in.
  // Elements with their own phx-click that don't match (a "+N more" link)
  // correctly don't open the dialog.
  window.PhoenixKitHooks.PkDialogTrigger = {
    mounted() {
      this._onTriggerClick = (e) => {
        var sel = this.el.dataset.trigger;
        var dlg = document.getElementById(this.el.dataset.dialog);
        if (!sel || !dlg) return;
        var clickEl = e.target.closest("[phx-click]");
        if (clickEl && this.el.contains(clickEl) && clickEl.matches(sel)) {
          dlg.dispatchEvent(new CustomEvent("pk:dialog-show"));
        }
      };
      this.el.addEventListener("click", this._onTriggerClick);
    },
    destroyed() {
      this.el.removeEventListener("click", this._onTriggerClick);
    }
  };

  // PkDialogDraft — preserves an in-progress form across a LiveView RECONNECT
  // (a websocket drop, e.g. on flaky/slow internet). A reconnect re-mounts the
  // LiveView with fresh assigns, so a modal driven by a server flag collapses
  // and the typed data is lost — LiveView's native form recovery can't help
  // because the form isn't rendered after remount (a skeleton is). This hook
  // keeps a live snapshot of the form in a JS variable (memory only — cleared
  // on close and on unload, so a tab close / refresh is NOT preserved, by
  // design) and, once reconnected, pushes it back so the server rebuilds the
  // modal exactly where the user left off.
  //
  // Attach to a STABLE element that is always rendered (NOT the <dialog>,
  // which already carries PkDialog and whose body is conditionally rendered):
  //   <div phx-hook="PkDialogDraft" id="…"
  //        data-draft-form="calendar-event-form"   (the <form> id to snapshot)
  //        data-draft-restore-event="restore_event_draft"
  //        data-draft-scope="#calendar-event-modal" (where owner/tz inputs live,
  //                                                   outside the <form>)
  //        data-draft-active="true|false"           (server: modal open + editable)
  //        data-draft-key="new|<uuid>">             (which event)
  var pkDialogDrafts = {};
  var pkWasDisconnected = false;
  if (typeof window !== "undefined") {
    window.addEventListener("phx:disconnected", function () {
      pkWasDisconnected = true;
    });
  }

  window.PhoenixKitHooks.PkDialogDraft = {
    mounted() {
      var self = this;
      this.formId = this.el.dataset.draftForm;
      this.restoreEvent = this.el.dataset.draftRestoreEvent || "restore_draft";
      this.scopeSel = this.el.dataset.draftScope;

      this._snapshot = function () {
        if (self.el.dataset.draftActive !== "true") {
          delete pkDialogDrafts[self.el.id];
          return;
        }
        var form = document.getElementById(self.formId);
        if (!form) return;
        var ev = {};
        new FormData(form).forEach(function (v, k) {
          var m = k.match(/^event\[(.+)\]$/);
          if (m) ev[m[1]] = v;
        });
        // owner / owner_tz_entry live OUTSIDE the <form> (in the modal box)
        var scope = self.scopeSel ? document.querySelector(self.scopeSel) : document;
        var owner = scope && scope.querySelector('[name="owner"]');
        var ownerTz = scope && scope.querySelector('[name="owner_tz_entry"]');
        pkDialogDrafts[self.el.id] = {
          key: self.el.dataset.draftKey || "new",
          event: ev,
          owner: owner ? owner.value : null,
          owner_tz_entry: ownerTz && ownerTz.checked ? "true" : null,
        };
      };

      this._onInput = function () {
        self._snapshot();
      };
      // capture on every edit (bubbles up from the form's inputs)
      document.addEventListener("input", this._onInput, true);
      document.addEventListener("change", this._onInput, true);

      this._onUnload = function () {
        delete pkDialogDrafts[self.el.id];
      };
      window.addEventListener("beforeunload", this._onUnload);

      // Reconnect restore: mounted() runs again after a reconnect re-mount.
      // If we were disconnected and still hold a draft, hand it back so the
      // server can reopen the modal with the user's data.
      this._maybeRestore();
    },

    updated() {
      // The server closed the modal on a live connection — saved, cancelled
      // or dismissed. The draft is finished with: left in place, the next
      // reconnect would hand it back and reopen a modal the user had closed,
      // or one whose contents were already saved. After a reconnect the flag
      // also reads "false", but that is the re-mount, and the draft is
      // exactly what `_maybeRestore` is about to use.
      if (!pkWasDisconnected && this.el.dataset.draftActive !== "true") {
        delete pkDialogDrafts[this.el.id];
      }
      this._maybeRestore();
    },

    _maybeRestore() {
      if (!pkWasDisconnected) return;
      var draft = pkDialogDrafts[this.el.id];
      if (!draft) {
        pkWasDisconnected = false;
        return;
      }
      // only restore into a modal the server hasn't already reopened
      if (this.el.dataset.draftActive === "true") return;
      pkWasDisconnected = false;
      this.pushEvent(this.restoreEvent, draft);
    },

    destroyed() {
      document.removeEventListener("input", this._onInput, true);
      document.removeEventListener("change", this._onInput, true);
      window.removeEventListener("beforeunload", this._onUnload);
    },
  };

  // ---------------------------------------------------------------------------
  // ---------------------------------------------------------------------------
  // AnnotationBurn — keep a copy of the picture with the markup drawn into it
  //
  // The variants a file serves are the picture as uploaded. That is the right
  // thing for an editor and the wrong thing for everywhere else: a grid card,
  // a link someone pastes into a chat, a right-click → Copy Image all show
  // the picture WITHOUT the arrows and measurements that are the reason it
  // was annotated. This burns the annotations in and stores the result over
  // those variants, so the markup travels with the picture.
  //
  // It composes in the BROWSER. The alternative — drawing the shapes again
  // on the server — means a second renderer that has to agree with the first
  // about fonts, label plates, spline smoothing and stroke geometry forever,
  // and every disagreement shows up as a thumbnail that does not match the
  // drawing. Composing from the live overlay is exact by construction: it is
  // the same SVG the user was just looking at. (`Etcher.Raster` stays the
  // server-side path for backfill, where an approximation is the right
  // trade because nobody has the picture open.)
  //
  // When it runs: the end of an editing session — switching Etcher off,
  // closing the viewer, or stepping to another file. All three are "I am
  // done with this" and none should be blocking, so the burn runs in the
  // background with a line of text to say it is happening.
  // ---------------------------------------------------------------------------

  // Properties that carry the look. A serialised SVG cannot see the page's
  // stylesheet, so whatever is not copied onto the element is lost.
  var BURN_STYLE_PROPS = [
    "fill", "fill-opacity", "fill-rule", "stroke", "stroke-width", "stroke-opacity",
    "stroke-dasharray", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit",
    "opacity", "color", "font-family", "font-size", "font-weight", "font-style",
    "letter-spacing", "text-anchor", "dominant-baseline", "paint-order", "visibility",
    "mix-blend-mode", "filter", "transform", "transform-origin", "display"
  ];

  // Chrome: things you grab, things that only say "this one is selected",
  // and things still being drawn. None of it belongs in the picture.
  //
  // `.etcher-text-editor` is the inline label editor — a <foreignObject>
  // with a live <textarea> over the shape being typed into. Closing or
  // stepping the viewer burns in capture phase, BEFORE Etcher's own
  // click-outside commit can take the editor down, so without this a
  // burn taken mid-edit rendered the input box — placeholder text,
  // borders and all — into the stored copy. The committed label (when
  // there is one) is the <text> the shape itself carries; the editor is
  // only ever the form control.
  var BURN_CHROME = [
    ".etcher-handle", ".etcher-grab", ".etcher-handle-line", ".etcher-handle-midpoint",
    ".etcher-handle-edge", ".etcher-connector-hit", ".etcher-connector-dot",
    ".etcher-title-handle", ".etcher-snap-guide", ".etcher-marquee", ".is-draft",
    ".etcher-badge", ".etcher-text-editor"
  ];

  // Momentary looks, suspended while the styles are read and restored in the
  // same frame: the ring on whatever the cursor happens to be over should not
  // set in the picture.
  var BURN_STATE = ["is-hovered", "is-selected", "is-editing", "is-dragging", "is-close-target"];

  // A drawing written the same way every time, whatever order the keys
  // arrive in.
  //
  // A shape just drawn carries `{x, y, w, h}`; the same shape read back
  // after a round trip through the database carries `{h, w, x, y}` — same
  // numbers, different order, and `JSON.stringify` writes what it is given.
  // Comparing those two strings says "changed" about a drawing nobody
  // touched, which is one needless full-resolution render per visit.
  function burnCanonical(v) {
    if (Array.isArray(v)) return "[" + v.map(burnCanonical).join(",") + "]";
    if (v && typeof v === "object") {
      return "{" + Object.keys(v).sort().map(function(k) {
        return JSON.stringify(k) + ":" + burnCanonical(v[k]);
      }).join(",") + "}";
    }
    return JSON.stringify(v === undefined ? null : v);
  }

  // A cheap, stable hash of the drawing (FNV-1a, 32-bit, hex). Not a
  // security property — just a short thing to compare, computed the same
  // way on the way out and on the way back in.
  function burnHash(str) {
    var h = 0x811c9dc5;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
    }
    return h.toString(16);
  }

  function burnNote(text, ms) {
    var el = document.getElementById("pk-burn-note");
    if (!el) {
      el = document.createElement("div");
      el.id = "pk-burn-note";
      el.className =
        "fixed left-1/2 -translate-x-1/2 top-6 z-[9999] px-4 py-2 rounded-lg shadow-lg " +
        "bg-base-300 text-base-content text-sm";
      document.body.appendChild(el);
    }
    el.textContent = text;
    clearTimeout(el._t);
    if (ms) el._t = setTimeout(function() { el.remove(); }, ms);
    return el;
  }

  // The viewer's image→screen mapping, from three image points. An X-only
  // delta is 0 at 90°/270° and negative at 180°, which used to abandon the
  // burn; `s` is the (positive) scale and cos/sin are the image +X axis in
  // screen space. The burned pixels stay in image space — the viewer
  // reapplies `initial_rotation` when it shows them.
  function burnViewAffine(p0, px, py, rect) {
    if (!p0 || !px || !py || !rect) return null;
    var vx = px.x - p0.x, vy = px.y - p0.y;
    var s = Math.hypot(vx, vy) / 1000;
    if (!(s > 0)) return null;
    return {
      s: s,
      cos: vx / (1000 * s),
      sin: vy / (1000 * s),
      tx: p0.x - rect.left,
      ty: p0.y - rect.top
    };
  }

  // Container px (the overlay's own space) → image px.
  function burnContainerToImage(ax, x, y) {
    var dx = x - ax.tx, dy = y - ax.ty;
    return {
      x: (dx * ax.cos + dy * ax.sin) / ax.s,
      y: (-dx * ax.sin + dy * ax.cos) / ax.s
    };
  }

  // Whether `el` is chrome or sits inside chrome — what the copy below cuts.
  function burnIsChrome(el) {
    for (var i = 0; i < BURN_CHROME.length; i++) {
      if (el.closest && el.closest(BURN_CHROME[i])) return true;
    }
    return false;
  }

  // The box the burned picture spans, in image px: the W×H picture plus
  // every piece of ink the copy keeps. `els` are the overlay's shapes and
  // their descendants; `toImage(x, y)` maps a client point into image px.
  //
  // Only leaves with a size are measured, and nothing that is, or sits
  // inside, chrome. A group's own box is the union of its children's, empty
  // ones included: a dimension's label group (`.etcher-title-group`) keeps
  // a 0×0 leader at the overlay's origin, so the group reached up to the
  // viewer's top-left corner. Burning in live mode stretched the canvas by
  // the whole margin above the picture — the taller the viewer, the bigger
  // — and a landscape photo came back portrait, squeezed into its bottom
  // third under a blank block. Chrome (handles, hit areas, a shape still
  // being drawn — Escape burns before Etcher drops a draft, this hook
  // listens in the capture phase) is cut from the copy, so it must not
  // size the canvas either.
  function burnInkBounds(els, toImage, W, H) {
    var b = { minX: 0, minY: 0, maxX: W, maxY: H };
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.firstElementChild || burnIsChrome(el)) continue;
      var r = el.getBoundingClientRect();
      if (!r.width && !r.height) continue;
      [[r.left, r.top], [r.right, r.top], [r.right, r.bottom], [r.left, r.bottom]]
        .forEach(function(corner) {
          var p = toImage(corner[0], corner[1]);
          if (p.x < b.minX) b.minX = p.x;
          if (p.y < b.minY) b.minY = p.y;
          if (p.x > b.maxX) b.maxX = p.x;
          if (p.y > b.maxY) b.maxY = p.y;
        });
    }
    return b;
  }

  // SVG matrix mapping container px into the output bitmap (image px × k,
  // cropped to the union that starts at minX/minY).
  function burnSvgMatrix(ax, k, minX, minY) {
    var m = k / ax.s;
    return [
      m * ax.cos,
      -m * ax.sin,
      m * ax.sin,
      m * ax.cos,
      m * (-ax.cos * ax.tx - ax.sin * ax.ty) - minX * k,
      m * (ax.sin * ax.tx - ax.cos * ax.ty) - minY * k
    ];
  }

  // Everything the render needs, taken while the overlay is still on screen.
  // Split from the render so a burn survives the viewer closing underneath
  // it: by the time anything out here hears about a close, the DOM being
  // composed is already gone.
  function burnCapturePlan(host) {
    if (!host) return null;
    var handle = window.Fresco && window.Fresco.viewerFor && window.Fresco.viewerFor(host.id);
    var img = host.querySelector("img[data-fresco-canvas-img]");
    var svg = host.querySelector(".etcher-overlay svg");
    if (!handle || !img || !svg) return null;

    var W = parseFloat(img.dataset.canvasWidth) || img.naturalWidth;
    var H = parseFloat(img.dataset.canvasHeight) || img.naturalHeight;
    if (!(W > 0 && H > 0)) return null;

    // The widest rung the page knows about — Tessera lists them, signed URLs
    // and all — so the burn is made from the original rather than from
    // whatever the viewer happened to have loaded.
    var sourceUrl = img.getAttribute("src");
    var sourceWidth = img.naturalWidth || W;
    // This picture's own ladder. A document-wide lookup would compose
    // another canvas's source into this file.
    var column = host.closest("[id^='pk-annotation-actions-']") || host.parentElement;
    var listEl = column && column.querySelector("[data-sources]");
    if (listEl) {
      try {
        (JSON.parse(listEl.getAttribute("data-sources")) || []).forEach(function(s) {
          if (s && s.url && s.width > sourceWidth) { sourceUrl = s.url; sourceWidth = s.width; }
        });
      } catch (_) { /* malformed list → the on-screen picture stands */ }
    }
    // Never past the picture's own pixels. The ladder lists each rung at
    // its configured box (large = 1920), not at the size it really came out
    // — a 500px picture's "large" is 500px — so a small picture was composed
    // at nearly four times its size: the burned copy then opened at 100% as
    // a huge image beside the original's true-size one, and a clean burn of
    // it no longer matched the picture it was made from. The canvas width
    // IS the picture's natural width.
    sourceWidth = Math.min(sourceWidth, W);
    var k = sourceWidth / W;

    // The overlay is laid out in CONTAINER px. Three image points recover
    // the full affine, rotation included — two points on X cannot see a
    // quarter turn.
    var rect = host.getBoundingClientRect();
    var ax = burnViewAffine(
      handle.imageToScreen({ x: 0, y: 0 }),
      handle.imageToScreen({ x: 1000, y: 0 }),
      handle.imageToScreen({ x: 0, y: 1000 }),
      rect
    );
    if (!ax) return null;

    // Etcher lets you draw past the edges of the picture, and that ink is as
    // much a part of the markup as the rest — an arrow pointing in from the
    // margin, a note written beside the photo. The output is the union of
    // the picture and everything drawn.
    var ink = burnInkBounds(
      svg.querySelectorAll(".etcher-shape, .etcher-shape *"),
      function(x, y) { return burnContainerToImage(ax, x - rect.left, y - rect.top); },
      W, H
    );
    var minX = Math.floor(ink.minX), minY = Math.floor(ink.minY);
    var maxX = Math.ceil(ink.maxX), maxY = Math.ceil(ink.maxY);

    // Transitions off for the read. The selected and hovered looks fade
    // out (a text's box, for one, eases its stroke over 120ms), so with
    // them running the styles read below would be the look's first frame
    // of fading — and a text that happened to be selected when the session
    // ended was stored with its blue selection box drawn round it.
    var stillStyle = document.createElement("style");
    stillStyle.textContent = ".pk-burn-still, .pk-burn-still * { transition: none !important; }";
    document.head.appendChild(stillStyle);
    svg.classList.add("pk-burn-still");

    var suspended = [];
    var clone, live, copy;
    try {
      svg.querySelectorAll("." + BURN_STATE.join(", .")).forEach(function(el) {
        var had = BURN_STATE.filter(function(c) { return el.classList.contains(c); });
        if (had.length) {
          suspended.push([el, had]);
          had.forEach(function(c) { el.classList.remove(c); });
        }
      });

      clone = svg.cloneNode(true);
      live = [svg].concat(Array.prototype.slice.call(svg.querySelectorAll("*")));
      copy = [clone].concat(Array.prototype.slice.call(clone.querySelectorAll("*")));
      for (var i = 0; i < live.length; i++) {
        var cs = getComputedStyle(live[i]);
        var css = "";
        for (var p = 0; p < BURN_STYLE_PROPS.length; p++) {
          var v = cs.getPropertyValue(BURN_STYLE_PROPS[p]);
          if (v && v !== "normal" && v !== "auto") css += BURN_STYLE_PROPS[p] + ":" + v + ";";
        }
        copy[i].setAttribute("style", css);
        copy[i].removeAttribute("class");
      }
    } finally {
      suspended.forEach(function(pair) {
        pair[1].forEach(function(c) { pair[0].classList.add(c); });
      });
      svg.classList.remove("pk-burn-still");
      if (stillStyle.parentNode) stillStyle.parentNode.removeChild(stillStyle);
    }
    BURN_CHROME.forEach(function(sel) {
      live.forEach(function(el, idx) {
        if (el.matches && el.matches(sel) && copy[idx] && copy[idx].remove) copy[idx].remove();
      });
    });

    var NS = "http://www.w3.org/2000/svg";
    var out = { w: Math.round((maxX - minX) * k), h: Math.round((maxY - minY) * k) };
    var g = document.createElementNS(NS, "g");
    g.setAttribute("transform", "matrix(" + burnSvgMatrix(ax, k, minX, minY).join(",") + ")");
    while (clone.firstChild) g.appendChild(clone.firstChild);
    clone.appendChild(g);
    clone.setAttribute("xmlns", NS);
    clone.setAttribute("width", out.w);
    clone.setAttribute("height", out.h);
    clone.setAttribute("viewBox", "0 0 " + out.w + " " + out.h);
    clone.removeAttribute("style");

    var viewer = host.closest(".fresco-viewer") || host;
    var bg = getComputedStyle(viewer).backgroundColor;

    return {
      svgText: new XMLSerializer().serializeToString(clone),
      sourceUrl: sourceUrl,
      out: out,
      picture: { w: W * k, h: H * k, x: -minX * k, y: -minY * k },
      background: bg && bg !== "rgba(0, 0, 0, 0)" ? bg : "#ffffff"
    };
  }

  // No DOM of the viewer's needed from here on — the plan holds everything.
  function burnRender(plan) {
    var format = plan.format || "jpeg";
    // An animation's frames only exist on the server: the burn sent for it
    // is the markup alone, on a transparent canvas, with the picture's place
    // in it sent alongside (see `burnUpload`).
    var markupOnly = format === "gif";
    return new Promise(function(resolve, reject) {
      function compose(picture) {
        var overlay = new Image();
        overlay.onload = function() {
          var canvas = document.createElement("canvas");
          canvas.width = plan.out.w;
          canvas.height = plan.out.h;
          var ctx = canvas.getContext("2d");
          ctx.imageSmoothingQuality = "high";
          // JPEG has no alpha: every pixel the picture does not cover would
          // encode as black without this. Every other format keeps what
          // the picture doesn't cover see-through.
          if (format === "jpeg") {
            ctx.fillStyle = plan.background;
            ctx.fillRect(0, 0, plan.out.w, plan.out.h);
          }
          if (picture) {
            ctx.drawImage(picture, plan.picture.x, plan.picture.y, plan.picture.w, plan.picture.h);
          }
          ctx.drawImage(overlay, 0, 0, plan.out.w, plan.out.h);
          // A browser that cannot encode WebP hands back a PNG; the server
          // re-encodes either way.
          var type = format === "jpeg" ? "image/jpeg" : format === "webp" ? "image/webp" : "image/png";
          canvas.toBlob(function(blob) {
            blob ? resolve(blob) : reject(new Error("the browser produced no image"));
          }, type, 0.9);
        };
        overlay.onerror = function() { reject(new Error("the markup did not rasterise")); };
        overlay.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(plan.svgText);
      }
      if (markupOnly) { compose(null); return; }
      var picture = new Image();
      picture.onload = function() { compose(picture); };
      picture.onerror = function() { reject(new Error("the picture did not load")); };
      picture.src = plan.sourceUrl;
    });
  }

  function burnUpload(uuid, blob, variants, sourceVersion, fingerprint, plan) {
    var body = new FormData();
    var ext = blob.type === "image/png" ? "png" : blob.type === "image/webp" ? "webp" : "jpg";
    body.append("image", blob, "burn." + ext);
    // A markup-only burn says where the picture goes in it.
    if (plan && plan.format === "gif") {
      body.append("canvas_w", plan.out.w);
      body.append("canvas_h", plan.out.h);
      body.append("picture_x", plan.picture.x);
      body.append("picture_y", plan.picture.y);
      body.append("picture_w", plan.picture.w);
      body.append("picture_h", plan.picture.h);
    }
    body.append("variants", variants);
    if (sourceVersion) body.append("source_version", sourceVersion);
    // Recorded against the stored copy, so the next visit can tell whether
    // this drawing has already been burned.
    if (fingerprint) body.append("fingerprint", fingerprint);
    var csrf = document.querySelector("meta[name='csrf-token']");
    // Same prefix derivation the consent widget uses: PHOENIX_KIT_PREFIX is
    // emitted by the js_sources compiler, and the literal is the fallback
    // for a host that predates it.
    var prefix = window.PHOENIX_KIT_PREFIX || "/phoenix_kit";
    if (prefix === "/") prefix = "";

    return fetch(prefix + "/api/files/" + uuid + "/burn", {
      method: "POST",
      body: body,
      headers: csrf ? { "x-csrf-token": csrf.getAttribute("content") } : {},
      credentials: "same-origin"
    }).then(function(res) {
      return res.json().catch(function() { return {}; }).then(function(json) {
        if (!res.ok) throw new Error(json.message || res.status + " " + res.statusText);
        return json;
      });
    });
  }

  window.PhoenixKitHooks.AnnotationBurn = {
    mounted() {
      var self = this;
      this._uuid = this.el.dataset.fileUuid;
      // thumbnail = list rows, burned = grid cards (card-sized),
      // burned_large = the copy this viewer opens with. small/medium/large
      // are the editor's own ladder; burning those draws the shapes twice.
      this._variants = this.el.dataset.burnVariants || "thumbnail,burned,burned_large";
      this._host = function() {
        var column = self.el.closest("[id^='pk-annotation-actions-']");
        return column && column.querySelector('[phx-hook="FrescoCanvas"]');
      };
      // What the STORED burn was made from. The comparison is against this,
      // not against a baseline taken at mount: Etcher hydrates its shapes
      // after the hook mounts, so a mount-time baseline reads an empty
      // drawing and makes the first close look like a change — burning a
      // full-resolution copy of a picture nobody touched.
      this._burned = this.el.dataset.burnFingerprint || null;
      this._running = false;
      this._pending = null;
      this._inFlight = null;

      this._allowCopy();

      // The pencil goes in Fresco's own nav rail, beside fullscreen and
      // zoom, through the rail's own API. An absolutely-positioned button
      // of ours lands ON TOP of that rail instead of in it: technically
      // clickable, invisible to a person, and covering fullscreen.
      this._addModeButton();

      // Switching Etcher off ends an editing session.
      this._onMode = function(e) {
        if (e.detail && e.detail.annotationMode) return;

        // Etcher off means done editing, so: render what was drawn (only
        // if it changed), and go back to the burned picture. Capture
        // happens here, before the canvas is replaced and the overlay
        // being composed goes with it.
        self.burnIfChanged();

        if (self.el.dataset.burnMode !== "true" && self.el.dataset.hasBurn === "true") {
          self.pushEventTo(self.el, "toggle_burn_mode", {});
        }
      };
      document.addEventListener("etcher:mode-changed", this._onMode);

      // Came here from the pencil in the burned view: the live layer is up
      // now, so turn Etcher on — that press meant "let me draw", not "show
      // me the shapes".
      if (this.el.dataset.autoAnnotate === "true") this._armEtcher();

      // So does closing the viewer, and stepping to the neighbour: an arrow
      // or a chevron remounts the viewer on the next file and tears this
      // overlay down. Caught on the way IN, while the overlay is still
      // there to compose from. A keystroke into a field is not a step.
      this._onClosing = function(e) {
        var t = e.target;
        var typing = t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" ||
                           t.isContentEditable === true);
        var stepping = !typing && (
          (e.type === "keydown" && (e.key === "ArrowLeft" || e.key === "ArrowRight") &&
            !(document.querySelector && document.querySelector("[data-removal-state]"))) ||
          (e.type === "pointerdown" && t && t.closest && t.closest('[phx-click="step_viewer"]'))
        );
        var closing =
          (e.type === "keydown" && e.key === "Escape") ||
          (t && t.closest && (t.closest('[phx-click="close_viewer"]') || t.closest(".modal-backdrop")));
        if (closing || stepping) self.burnIfChanged();
      };
      document.addEventListener("pointerdown", this._onClosing, true);
      document.addEventListener("keydown", this._onClosing, true);
    },

    // The viewer's own nav buttons, on whichever canvas is up:
    //
    // - The pencil: picture ⇄ editor. The burn is one flat picture with
    //   the markup already in it; the live layer is the picture with
    //   shapes you can select and edit over the top. Only one of them
    //   can be on screen, so this is the switch between them rather
    //   than a visibility toggle. Offered on the burned picture and on
    //   the clean one; in the editor, Etcher's own pencil is the one on
    //   screen.
    // - The eye: markup shown ⇄ the clean original. Hiding the etchings
    //   cannot be a client-side flip — on the burned picture the markup
    //   is baked into the bitmap — so the press asks the server to swap
    //   the canvas for the picture with nothing in it. From the editor
    //   it also ends the session: the drawing is composed for the burn
    //   first, while the overlay still exists. Deliberately not
    //   persisted: every open starts with the markup showing.
    //
    // The one surface that gets neither is a read-only live layer (no
    // burn to show, nothing to edit): Etcher's own :visibility eye is
    // there, and hiding the locked overlay is the whole job.
    _addModeButton() {
      var self = this;

      var burned = this.el.dataset.burnMode === "true";
      var hidden = this.el.dataset.etchingsHidden === "true";
      var canAnnotate = this.el.dataset.canAnnotate === "true";
      if (!burned && !hidden && !canAnnotate) return;

      var frescoId = this.el.dataset.frescoId;
      var handle = window.Fresco && window.Fresco.viewerFor && window.Fresco.viewerFor(frescoId);

      // Fresco mounts its canvas on its own schedule; if the handle is not
      // there yet, wait for it to announce itself.
      if (!handle) {
        if (window.Fresco && window.Fresco.onViewerReady) {
          window.Fresco.onViewerReady(frescoId, function() { self._addModeButton(); });
        }
        return;
      }

      // Already on THIS nav: nothing to do. On a different one — the mode
      // flipped, so the canvas and its whole nav were replaced — drop the
      // stale handles and append to the new rail.
      if (this._modeButtonFor === frescoId && (this._pencilButton || this._eyeButton)) return;
      if (this._modeButton) {
        try { this._modeButton(); } catch (_) {}
        this._modeButton = null;
      }
      if (this._pencilButton) {
        try { this._pencilButton(); } catch (_) {}
        this._pencilButton = null;
      }
      if (this._eyeButton) {
        try { this._eyeButton(); } catch (_) {}
        this._eyeButton = null;
      }

      var pencil =
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" ' +
        'stroke-width="1.5" stroke="currentColor" aria-hidden="true">' +
        '<path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652' +
        'L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125"/></svg>';

      var eye =
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" ' +
        'stroke-width="1.5" stroke="currentColor" aria-hidden="true">' +
        '<path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5' +
        'c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"/>' +
        '<path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/></svg>';

      var eyeSlash =
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" ' +
        'stroke-width="1.5" stroke="currentColor" aria-hidden="true">' +
        '<path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5' +
        'c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1' +
        '-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243' +
        'm4.242 4.242L9.88 9.88"/></svg>';

      this._modeButtonFor = frescoId;

      // The nav leads with the pencil, then the eye — by Fresco slot, the
      // same numbers Etcher's own pair uses (pencil 0, its chevron 1, eye 2),
      // so the row reads the same on the finished picture and in the editor,
      // and the pencil is at the end of the row the "more" button is not.
      // Everyone gets the eye, drawer or not: seeing the picture under the
      // markup is a viewing affordance, not an editing one.
      //
      // Pressed in the editor (!burned && !hidden), the session ends —
      // so the drawing is composed for the burn HERE, before the server
      // replaces the canvas and the overlay being composed goes with it.
      // Same capture discipline as _onMode and _onClosing.
      this._eyeButton = handle.appendNavButton(
        hidden ? eyeSlash : eye,
        hidden ? "Show annotations" : "Hide annotations",
        function() {
          if (!burned && !hidden) self.burnIfChanged();
          self.pushEventTo(self.el, "toggle_etchings", {});
        },
        { slot: 2 }
      );

      // The pencil IS the mode. On, you are in the editor — the picture
      // with a live layer over it. Off, you are looking at a finished
      // picture (burned or clean). The eye never arms the tools; the
      // pencil is how you ask to work, from either picture.
      //
      // On the finished pictures there is no Etcher to own a pencil, so
      // this is ours; in the editor Etcher's own is the one on screen,
      // and switching it off brings the burned picture back (`_onMode`).
      if ((burned || hidden) && canAnnotate) {
        this._pencilButton = handle.appendNavButton(pencil, "Annotate", function() {
          self.pushEventTo(self.el, "toggle_burn_mode", { annotate: true });
        }, { slot: 0 });
      }
    },

    // The mode flip replaces the canvas (its id changes, so LiveView mounts
    // a fresh one) but patches this element in place — so the rail the eye
    // was on is gone and the new one has no eye until this runs.
    // The burned picture and the live layer are the same drawing on two
    // canvases of different extents: the burn spans the picture AND every
    // bit of ink past its edges, the live canvas just the picture, with the
    // ink drawn around it. Each opened on its own fit, so switching the
    // pencil on or off moved the picture — left, right, left — whenever
    // anything was drawn beside it. Instead the switch carries the view:
    // where the picture-plus-ink frame sat on screen before the patch is
    // where it sits after, zoom and all.
    beforeUpdate() {
      this._viewCarry = this._captureFrame();
    },

    updated() {
      this._addModeButton();
      this._allowCopy();
      if (this.el.dataset.autoAnnotate === "true") this._armEtcher();
      var carry = this._viewCarry;
      this._viewCarry = null;
      if (carry && carry.from !== this.el.dataset.frescoId) this._applyFrame(carry);
    },

    // The frame in a canvas's own units: a burn's whole extent; on the live
    // layer the picture plus the ink, measured the way the burn measures
    // it (`burnInkBounds`), so the two describe the same piece of drawing.
    // Null for the clean picture, and for a turned view.
    _frameOf(id) {
      var handle = window.Fresco && window.Fresco.viewerFor && window.Fresco.viewerFor(id);
      var host = document.getElementById(id);
      if (!handle || !host || !handle.fitBounds || !handle.imageToScreen || !handle.screenToImage) return null;
      if (handle.getRotation && handle.getRotation()) return null;
      var W = parseFloat(host.dataset.canvasWidth), H = parseFloat(host.dataset.canvasHeight);
      if (!(W > 0 && H > 0)) return null;
      if (id.indexOf("media-burn-") === 0) return { handle: handle, x: 0, y: 0, w: W, h: H };
      if (id.indexOf("media-zoom-") !== 0) return null;
      var svg = host.querySelector(".etcher-overlay svg");
      var b = svg
        ? burnInkBounds(svg.querySelectorAll(".etcher-shape, .etcher-shape *"),
            function(x, y) { return handle.screenToImage({ x: x, y: y }); }, W, H)
        : { minX: 0, minY: 0, maxX: W, maxY: H };
      return { handle: handle, x: b.minX, y: b.minY, w: b.maxX - b.minX, h: b.maxY - b.minY };
    },

    _captureFrame() {
      var id = this.el.dataset.frescoId;
      var f = id && this._frameOf(id);
      if (!f) return null;
      var a = f.handle.imageToScreen({ x: f.x, y: f.y });
      var b = f.handle.imageToScreen({ x: f.x + f.w, y: f.y + f.h });
      return { from: id, x: a.x, y: a.y, w: b.x - a.x, h: b.y - a.y };
    },

    // Put the new canvas's frame where the old one's was. Its own fit is
    // kept off screen until then — the live layer's frame is only known
    // once Etcher has drawn its shapes — and given up on after a moment.
    _applyFrame(carry, tries) {
      var self = this;
      var id = this.el.dataset.frescoId;
      var host = document.getElementById(id);
      var left = tries == null ? 30 : tries;
      if (!host) return;
      if (left === 30) host.style.visibility = "hidden";
      var reveal = function() { host.style.visibility = ""; };
      var live = id.indexOf("media-zoom-") === 0;
      var ready = window.Fresco && window.Fresco.viewerFor && window.Fresco.viewerFor(id) &&
        (!live || (window.Etcher && window.Etcher.layerFor && window.Etcher.layerFor(id) &&
                   host.querySelector(".etcher-overlay svg")));
      if (!ready) {
        if (left > 0) setTimeout(function() { self._applyFrame(carry, left - 1); }, 30);
        else reveal();
        return;
      }
      requestAnimationFrame(function() {
        if (self.el.dataset.frescoId !== id) { reveal(); return; }
        var f = self._frameOf(id);
        if (f && f.w > 0 && f.h > 0 && carry.w > 0 && carry.h > 0) {
          // The view as a rectangle of this canvas: the viewport, seen from
          // the old frame, carried into the new one. Fitting it puts the
          // frame exactly where it was.
          var c = host.getBoundingClientRect();
          var kx = f.w / carry.w, ky = f.h / carry.h;
          f.handle.fitBounds({
            x: f.x + (c.left - carry.x) * kx,
            y: f.y + (c.top - carry.y) * ky,
            width: c.width * kx,
            height: c.height * ky
          });
        }
        requestAnimationFrame(reveal);
      });
    },

    // Right-click → Copy image, on the burned picture — and on the clean
    // original the eye swaps in (copying the picture without the markup
    // is what the eye is FOR).
    //
    // Fresco sets `pointer-events: none` on its stage images so a drag
    // anywhere over the picture pans instead of dragging the bitmap. That
    // also means a right-click never lands ON the image, so the browser
    // offers no Copy image / Save image at all — the menu is for the div
    // underneath. In the burned and plain views there is nothing to drag
    // and nothing drawn over the picture, so the image can take its own
    // context menu; panning is unaffected, because Fresco listens on the
    // container these bubble to.
    _allowCopy(tries) {
      var self = this;
      var left = tries == null ? 20 : tries;
      var finished = this.el.dataset.burnMode === "true" ||
                     this.el.dataset.etchingsHidden === "true";
      var host = document.getElementById(this.el.dataset.frescoId);
      var img = host && host.querySelector("img[data-fresco-canvas-img]");

      if (!img) {
        if (left > 0) setTimeout(function() { self._allowCopy(left - 1); }, 150);
        return;
      }
      // Live view: leave Fresco's rule alone. The picture there is the
      // plain one anyway — copying it would leave the markup behind.
      img.style.pointerEvents = finished ? "auto" : "";
    },

    // Etcher mounts with the canvas it decorates, which may be a moment
    // behind this patch; retry briefly rather than miss the arming.
    _armEtcher(tries) {
      var self = this;
      var left = tries == null ? 20 : tries;
      var layer = window.Etcher && window.Etcher.layerFor &&
                  window.Etcher.layerFor(this.el.dataset.frescoId);

      if (layer && typeof layer.setMode === "function") {
        if (!layer.getMode()) layer.setMode(true);
        return;
      }
      if (left > 0) setTimeout(function() { self._armEtcher(left - 1); }, 150);
    },

    destroyed() {
      [this._modeButton, this._pencilButton, this._eyeButton].forEach(function(off) {
        if (typeof off === "function") {
          try { off(); } catch (_) {}
        }
      });
      this._modeButton = null;
      this._pencilButton = null;
      this._eyeButton = null;
      this._modeButtonFor = null;
      document.removeEventListener("etcher:mode-changed", this._onMode);
      document.removeEventListener("pointerdown", this._onClosing, true);
      document.removeEventListener("keydown", this._onClosing, true);
    },

    // What the drawing IS, as far as a burn cares. Compared against the
    // state the last one was made from, so ending a session in which
    // nothing was drawn re-renders nothing.
    _signature() {
      var host = this._host && this._host();
      var layer = host && window.Etcher && window.Etcher.layerFor &&
                  window.Etcher.layerFor(host.id);
      if (!layer || typeof layer.getShapes !== "function") return null;
      try {
        // Sorted by uuid as well: the order shapes come back in is the
        // server's business, not a change to the drawing.
        return (layer.getShapes() || [])
          .map(function(s) {
            return burnCanonical([s.uuid, s.kind, s.geometry, s.style, s.metadata, s.title]);
          })
          .sort()
          .join("");
      } catch (_) {
        return null;
      }
    },

    burnIfChanged() {
      if (!this._uuid) return;
      // A burn re-renders the drawing and stores it: part of an editing
      // session. A viewer that cannot draw — a readonly MediaBrowser embed,
      // or any viewer mounted with `can_annotate: false` — must not write on
      // its way out, and a visitor the endpoint would refuse must not be
      // shown "Could not update the burned image" for merely closing it.
      if (this.el.dataset.canAnnotate !== "true") return;
      var now = this._signature();
      // `null` is "Etcher has not hydrated yet": nothing to compare, and
      // nothing worth rendering from a drawing that is not on screen.
      //
      // An EMPTY board is `""`, which is a different answer to a different
      // question — and a falsy one, so testing truthiness here swallowed
      // it. That is what made rubbing out the last shape the one edit a
      // burn never noticed: the copy on file kept the markup, the card
      // kept showing it, and the fix was to draw something else. The rule
      // below is the one that decides what an empty board means; it could
      // not be reached from here.
      if (now == null) return;

      // Nothing drawn and nothing burned — a picture opened and closed.
      // A picture whose last shape was just rubbed out has a burn on file
      // and does not match this, so it goes on to render the clean one.
      // "A burn on file" is asked of the page too, not only of the
      // fingerprint: a copy whose fingerprint never reached this page is
      // still a copy with the old markup in it.
      if (now === "" && !this._burned && this.el.dataset.hasBurn !== "true") return;

      var fingerprint = burnHash(now);
      // The stored copy was made from exactly this drawing. Re-rendering it
      // would cost a full-resolution compose and an upload to produce the
      // same bytes.
      if (fingerprint === this._burned) return;
      // …and so was the one on the wire. Turning Etcher off ends the
      // session once, but the canvas swap that follows tears the layer
      // down, and a teardown turns the mode off again — a second
      // session-end for the same drawing, arriving before the first
      // upload has answered and while `_burned` still names the old copy.
      // It composed and uploaded the whole picture a second time.
      if (fingerprint === this._inFlight) return;

      var plan = burnCapturePlan(this._host());
      if (!plan) return;
      // How the burn is kept, decided by the server from the stored file:
      //   "png"  — a see-through picture, transparency kept;
      //   "webp" — a photo: small, and a margin the markup opens up past the
      //            picture's edges stays see-through instead of white;
      //   "gif"  — an animation: only the markup is sent, and the server
      //            draws it onto every frame so the burn still plays.
      // Missing (an older page): the JPEG it always was.
      plan.format = this.el.dataset.burnFormat || "jpeg";

      var pending = {
        fingerprint: fingerprint,
        plan: plan,
        version: this.el.dataset.sourceVersion || ""
      };

      // Take the plan NOW. A second session-end while a burn is uploading
      // used to be remembered as a flag and recaptured when the upload
      // finished — by which point closing the viewer had already removed
      // the overlay, so the drawing made in between never landed.
      if (this._running) {
        this._pending = pending;
        return;
      }
      this._start(pending);
    },

    _start(pending) {
      var self = this;
      this._running = true;
      this._pending = null;
      this._inFlight = pending.fingerprint;
      burnNote("Updating the burned image…");

      burnRender(pending.plan)
        .then(function(blob) {
          return burnUpload(self._uuid, blob, self._variants, pending.version,
                            pending.fingerprint, pending.plan);
        })
        .then(function(res) {
          // What the stored copy is now made from. Held only after the
          // store succeeded: a failed burn leaves the old fingerprint, so
          // the next session end knows it is still stale.
          self._burned = pending.fingerprint;
          self._refresh(res.written || []);

          // Tell the viewer a burn was stored, so the burned view it shows
          // next is this one. Without it the canvas keeps the URL it
          // mounted with — the previous rendering, until a page reload.
          // Only the slot is named: the viewer reads the stored instance
          // (URL, size, version) itself rather than trusting these.
          var written = res.written || [];
          var made = written.find(function(v) { return v.variant === "burned_large"; }) ||
                     written.find(function(v) { return v.variant === "burned"; });
          if (made) {
            self.pushEventTo(self.el, "burn_stored", {
              variant: made.variant,
              fingerprint: pending.fingerprint
            });
          }

          burnNote("Burned image updated", 3500);
        })
        .catch(function(err) {
          // The session is over either way; say so, and leave the stored
          // fingerprint alone so the next attempt still knows it is stale.
          burnNote("Could not update the burned image: " + (err && err.message || err), 6000);
        })
        .then(function() {
          self._running = false;
          self._inFlight = null;
          var next = self._pending;
          self._pending = null;
          if (next) self._start(next);
        });
    },

    // Every picture on the page showing a variant this replaced. The
    // viewer's own image is left alone: it still has the live shapes drawn
    // over it, and swapping it for the burned copy would draw them twice.
    _refresh(written) {
      var host = this._host && this._host();
      var uuid = this._uuid;
      written.forEach(function(v) {
        var marker = "/file/" + uuid + "/" + v.variant + "/";
        document.querySelectorAll("img").forEach(function(img) {
          var src = img.getAttribute("src") || "";
          if (src.indexOf(marker) !== -1 && !(host && host.contains(img))) {
            img.setAttribute("src", v.url);
          }
        });
      });
    }
  };

  // EtcherTooltipActions
  //
  // Routes Etcher's `etcher:tooltip-action` CustomEvent (a tooltip button
  // press — the tooltip swallows raw clicks, so Etcher 0.13 re-dispatches
  // them on the layer host, bubbling). Sits on the viewer column that wraps
  // the canvas + layer:
  //   pk-reply → pushEventTo the owning LiveComponent ("annotation_reply"),
  //              which ensures the shape's master comment and opens the
  //              body-only reply popup.
  //   pk-edit  → pure client-side: layer.editLabel(uuid) opens Etcher's
  //              inline label editor, same as double-clicking the shape.
  // ---------------------------------------------------------------------------
  window.PhoenixKitHooks.EtcherTooltipActions = {
    mounted() {
      var self = this;
      this._onTooltipAction = function(e) {
        var d = (e && e.detail) || {};
        if (!d.uuid) return;
        if (d.action === "pk-reply") {
          self.pushEventTo(self.el, "annotation_reply", { uuid: d.uuid });
        } else if (d.action === "pk-edit") {
          var layer = window.Etcher && window.Etcher.layerFor &&
                      window.Etcher.layerFor(d.fresco_id);
          if (layer && typeof layer.editLabel === "function") layer.editLabel(d.uuid);
        } else if (d.action === "pk-view") {
          // Take the user to the shape's thread: the sidebar comment cards
          // carry data-annotation-uuid (CommentsComponent), same document.
          var card = document.querySelector(
            '[data-annotation-uuid="' + d.uuid + '"]'
          );
          if (card) {
            card.scrollIntoView({ behavior: "smooth", block: "center" });
            card.style.transition = "box-shadow 200ms ease";
            card.style.boxShadow = "0 0 0 2px #3b82f6";
            setTimeout(function() { card.style.boxShadow = ""; }, 1600);
          }
        }
      };
      this.el.addEventListener("etcher:tooltip-action", this._onTooltipAction);
    },
    destroyed() {
      if (this._onTooltipAction) {
        this.el.removeEventListener("etcher:tooltip-action", this._onTooltipAction);
      }
    }
  };

  window.PhoenixKitHooks.AnnotationComposerPosition = {
    mounted() {
      this._reposition = () => this.reposition();
      this.reposition();
      window.addEventListener("resize", this._reposition);
    },

    updated() {
      this.reposition();
    },

    destroyed() {
      window.removeEventListener("resize", this._reposition);
    },

    reposition() {
      const el = this.el;
      const container = el.parentElement;
      if (!container) return;

      const margin = 8;
      const popW = el.offsetWidth;
      const popH = el.offsetHeight;
      const cw = container.clientWidth;
      const ch = container.clientHeight;

      // Try to anchor to the associated shape. Element id is
      // `annotation-composer-popover-<uuid>`; Etcher renders shapes
      // with the matching `data-uuid`.
      const uuid = el.dataset.annotationUuid || el.id.replace(/^annotation-composer-popover-/, "");
      const shapeEl = uuid
        ? document.querySelector('[data-uuid="' + uuid + '"]')
        : null;

      let left;
      let top;

      if (shapeEl) {
        const shapeRect = shapeEl.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        // Center horizontally on the shape; place bottom-of-popover
        // `margin` px above the shape's top.
        const shapeCenterX = shapeRect.left + shapeRect.width / 2 - containerRect.left;
        const shapeTopY = shapeRect.top - containerRect.top;

        left = shapeCenterX - popW / 2;
        top = shapeTopY - popH - margin;

        // No room above → flip below the shape.
        if (top < margin) {
          top = shapeRect.bottom - containerRect.top + margin;
        }
      } else {
        // Fall back to whatever the server seeded (or zero).
        left = parseFloat(el.style.left) || 0;
        top = parseFloat(el.style.top) || 0;
      }

      // Clamp horizontally: keep right edge inside the container, then
      // keep left edge inside. Order matters when the popover is wider
      // than the container — `Math.max(margin, …)` wins, leaving the
      // popover flush-left with a margin.
      const maxLeft = cw - popW - margin;
      if (left > maxLeft) left = maxLeft;
      if (left < margin) left = margin;

      // Same for vertical. If the popover doesn't fit (popover taller
      // than the container), it pins to the top with a margin.
      const maxTop = ch - popH - margin;
      if (top > maxTop) top = maxTop;
      if (top < margin) top = margin;

      el.style.left = `${left}px`;
      el.style.top = `${top}px`;
    }
  };

  // ---------------------------------------------------------------------------
  // CopyToClipboard Hook
  // ---------------------------------------------------------------------------
  //
  // Mount on a button. The button must have `data-copy-target` pointing
  // at a CSS selector for the element whose value should be copied
  // (typically a sibling `<input>`). Optional: an inner element with
  // `data-copy-feedback` whose `hidden` class is toggled briefly to
  // show "Copied!" feedback, and an inner element with `data-copy-idle`
  // whose `hidden` class is the inverse so only one shows at a time.
  //
  // Usage in LiveView template:
  //   <button phx-hook="CopyToClipboard"
  //           id="copy-foo"
  //           data-copy-target="#field-foo"
  //           type="button">
  //     <span data-copy-idle>Copy</span>
  //     <span data-copy-feedback class="hidden">Copied!</span>
  //   </button>
  //
  // ---------------------------------------------------------------------------

  window.PhoenixKitHooks.CopyToClipboard = {
    mounted() {
      const targetSelector = this.el.getAttribute("data-copy-target");
      if (!targetSelector) return;

      this.handler = async (e) => {
        e.preventDefault();
        const target = document.querySelector(targetSelector);
        if (!target) return;
        const value = target.value !== undefined ? target.value : target.textContent;
        if (!value) return;

        try {
          await navigator.clipboard.writeText(value);
        } catch (_err) {
          // Fallback for older browsers or insecure contexts: select the
          // input and execCommand("copy"). Best-effort; if both paths
          // fail we just bail without feedback.
          if (target.select) {
            const masked = target.type === "password";
            if (masked) target.type = "text";
            target.select();
            try { document.execCommand("copy"); } catch (_) {}
            if (masked) target.type = "password";
            window.getSelection && window.getSelection().removeAllRanges();
          }
        }

        const idle = this.el.querySelector("[data-copy-idle]");
        const feedback = this.el.querySelector("[data-copy-feedback]");
        if (idle) idle.classList.add("hidden");
        if (feedback) feedback.classList.remove("hidden");

        clearTimeout(this.feedbackTimer);
        this.feedbackTimer = setTimeout(() => {
          if (idle) idle.classList.remove("hidden");
          if (feedback) feedback.classList.add("hidden");
        }, 1500);
      };

      this.el.addEventListener("click", this.handler);
    },
    destroyed() {
      clearTimeout(this.feedbackTimer);
      if (this.handler) {
        this.el.removeEventListener("click", this.handler);
      }
    }
  };


  // ---------------------------------------------------------------------------
  // TimeAgo Hook
  // ---------------------------------------------------------------------------
  //
  // Displays relative time (e.g., "5m ago") and updates automatically.
  // Uses variable update intervals for efficiency:
  //   - < 1 minute: updates every second
  //   - < 1 hour: updates every 30 seconds
  //   - < 1 day: updates every 5 minutes
  //   - > 1 day: updates every hour
  //
  // Usage in LiveView template:
  //   <span phx-hook="TimeAgo" data-datetime={DateTime.to_iso8601(timestamp)}></span>
  //
  // Core's `time_ago` component no longer uses this hook: the hook writes its
  // text in English only, so on a translated page it replaced the server's
  // translated text once the page went live. The component is now rendered by
  // the server alone, in the user's language. The hook stays for hosts that
  // put `phx-hook="TimeAgo"` on their own markup.
  //
  // ---------------------------------------------------------------------------

  window.PhoenixKitHooks.TimeAgo = {
    mounted() {
      const timestamp = this.el.getAttribute("data-datetime");
      if (!timestamp) return;

      const parsed = new Date(timestamp);
      if (isNaN(parsed.getTime())) {
        console.warn("[PhoenixKit:TimeAgo] Invalid timestamp", timestamp);
        return;
      }

      this.timestamp = timestamp;
      this.parsedTime = parsed.getTime();
      this.update();
      this.scheduleUpdate();
    },

    destroyed() {
      this.clearTimer();
    },

    disconnected() {
      this.clearTimer();
    },

    reconnected() {
      if (this.timestamp) {
        this.update();
        this.scheduleUpdate();
      }
    },

    updated() {
      const newTimestamp = this.el.getAttribute("data-datetime");
      if (newTimestamp && newTimestamp !== this.timestamp) {
        const parsed = new Date(newTimestamp);
        if (isNaN(parsed.getTime())) return;

        this.timestamp = newTimestamp;
        this.parsedTime = parsed.getTime();
        this.update();
        this.scheduleUpdate();
      }
    },

    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },

    scheduleUpdate() {
      this.clearTimer();
      const interval = this.getInterval();
      this.timer = setTimeout(() => {
        this.update();
        this.scheduleUpdate();
      }, interval);
    },

    update() {
      const text = this.getRelativeTime();
      if (text && this.el.textContent !== text) {
        this.el.textContent = text;
      }
    },

    getRelativeTime() {
      const now = Date.now();
      const seconds = Math.round((now - this.parsedTime) / 1000);

      if (seconds < 0) return "just now";
      if (seconds < 60) return seconds + "s ago";

      const minutes = Math.round(seconds / 60);
      if (minutes < 60) return minutes + "m ago";

      const hours = Math.round(minutes / 60);
      if (hours < 24) return hours + "h ago";

      const days = Math.round(hours / 24);
      return days + "d ago";
    },

    getInterval() {
      const seconds = Math.round((Date.now() - this.parsedTime) / 1000);

      if (seconds < 60) return 1000;        // Update every second
      if (seconds < 3600) return 30000;     // Update every 30 seconds
      if (seconds < 86400) return 300000;   // Update every 5 minutes
      return 3600000;                        // Update every hour
    }
  };

  // ---------------------------------------------------------------------------
  // LanguageSwitcherSearch Hook
  // ---------------------------------------------------------------------------
  //
  // Provides client-side search filtering for the language switcher dropdown.
  // Filters languages by name as the user types, without server round-trips.
  //
  // Usage in LiveView template:
  //   <input phx-hook="LanguageSwitcherSearch" id="language-search-input" />
  //
  // The language items should have data-name and optionally data-native attributes:
  //   <li class="language-item" data-name="english" data-native="english">...</li>
  //
  // ---------------------------------------------------------------------------

  window.PhoenixKitHooks.LanguageSwitcherSearch = {
    mounted() {
      this.el.addEventListener("input", (e) => {
        const searchTerm = e.target.value.toLowerCase().trim();
        const container = this.el.closest(".dropdown-content") || this.el.closest(".dropdown");
        if (!container) return;

        const items = container.querySelectorAll(".language-item");

        items.forEach(item => {
          const name = (item.dataset.name || "").toLowerCase();
          const native = (item.dataset.native || "").toLowerCase();

          // Show if search term is found in name or native name
          const matches = searchTerm === "" ||
                          name.includes(searchTerm) ||
                          native.includes(searchTerm);

          item.style.display = matches ? "" : "none";
        });
      });

      // Clear search when dropdown closes
      this.el.addEventListener("blur", () => {
        // Small delay to allow click events to fire first
        setTimeout(() => {
          this.el.value = "";
          const container = this.el.closest(".dropdown-content") || this.el.closest(".dropdown");
          if (container) {
            container.querySelectorAll(".language-item").forEach(item => {
              item.style.display = "";
            });
          }
        }, 200);
      });
    }
  };

  // ---------------------------------------------------------------------------
  // ListFilter Hook
  // ---------------------------------------------------------------------------
  //
  // Client-side filter for a short list — the breadcrumb switcher's
  // (PhoenixKitWeb.Components.Core.CrumbSwitcher), or any list small enough
  // to render whole. No server round trip per keystroke.
  //
  //   <input phx-hook="ListFilter" id="…" data-filter-list="#my-list" />
  //   <ul id="my-list">
  //     <li data-filter-text="Kitchen"><a …>Kitchen</a></li>
  //     <li data-filter-empty class="hidden">No results.</li>
  //   </ul>
  //
  // Case and accents are ignored ("kasitoo" finds "Käsitöö"). Enter opens the
  // first visible match's link, ArrowDown moves into the list, and focusing
  // the input selects its text so a reopened switcher starts a new search.
  // ---------------------------------------------------------------------------

  function listFilterNormalize(s) {
    return String(s == null ? "" : s)
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  }

  function listFilterMatches(text, query) {
    var q = listFilterNormalize(query);
    return q === "" || listFilterNormalize(text).indexOf(q) !== -1;
  }

  window.PhoenixKitHooks.ListFilter = {
    mounted() {
      this._onInput = () => this.apply();
      this._onFocus = () => this.el.select();
      this._onKey = (e) => {
        // Enter that confirms an IME composition is not a pick.
        if (e.isComposing || e.keyCode === 229) return;
        var first = this.visibleItems()[0];
        var link = first && first.querySelector("a");
        if (e.key === "Enter") {
          e.preventDefault();
          if (link) link.click();
        } else if (e.key === "ArrowDown" && link) {
          e.preventDefault();
          link.focus();
        }
      };
      this.el.addEventListener("input", this._onInput);
      this.el.addEventListener("focus", this._onFocus);
      this.el.addEventListener("keydown", this._onKey);
      // A server re-render of the list strips the inline styles this hook
      // set (morphdom syncs attributes to the server's markup), showing
      // every row under a query that still reads "kitch" — and Enter would
      // then open the unfiltered first row. Re-filter whenever the list
      // changes; disconnect while filtering so our own writes don't loop.
      this._observer = new MutationObserver(() => this.apply());
      this.observe();
    },
    updated() {
      this.apply();
    },
    destroyed() {
      this.el.removeEventListener("input", this._onInput);
      this.el.removeEventListener("focus", this._onFocus);
      this.el.removeEventListener("keydown", this._onKey);
      if (this._observer) this._observer.disconnect();
    },
    observe() {
      var list = this.list();
      if (list && this._observer) {
        this._observer.observe(list, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["style", "data-filter-text"]
        });
      }
    },
    list() {
      var sel = this.el.dataset.filterList;
      return sel ? document.querySelector(sel) : null;
    },
    visibleItems() {
      var list = this.list();
      if (!list) return [];
      return Array.prototype.filter.call(
        list.querySelectorAll("[data-filter-text]"),
        function(item) { return item.style.display !== "none"; }
      );
    },
    apply() {
      var list = this.list();
      if (!list) return;
      if (this._observer) this._observer.disconnect();
      var query = this.el.value;
      var shown = 0;
      list.querySelectorAll("[data-filter-text]").forEach(function(item) {
        var match = listFilterMatches(item.dataset.filterText, query);
        var display = match ? "" : "none";
        if (item.style.display !== display) item.style.display = display;
        if (match) shown++;
      });
      var empty = list.querySelector("[data-filter-empty]");
      if (empty) empty.classList.toggle("hidden", shown > 0);
      this.observe();
    }
  };

  // ---------------------------------------------------------------------------
  // TreePickerSearch Hook
  // ---------------------------------------------------------------------------
  //
  // The search box of PhoenixKitWeb.Components.TreePicker. The query goes to
  // the component from here, not through a form's phx-change: the picker
  // often sits inside a host form, whose own phx-change and submit must not
  // see what is typed here. Typing is debounced; Enter searches at once
  // (except while an input method is still composing, where Enter confirms
  // the composition).
  //
  //   <input phx-hook="TreePickerSearch" phx-target={@myself} id="…" />
  // ---------------------------------------------------------------------------

  function treePickerEnter(e) {
    return !!e && e.key === "Enter" && !e.isComposing;
  }

  window.PhoenixKitHooks.TreePickerSearch = {
    mounted() {
      this._onInput = (e) => {
        e.stopPropagation();
        if (!e.isComposing) this.queue();
      };
      this._onChange = (e) => e.stopPropagation();
      this._onKey = (e) => {
        if (treePickerEnter(e)) {
          e.preventDefault();
          e.stopPropagation();
          this.push();
        }
      };
      this._onComposed = () => this.queue();
      this.el.addEventListener("input", this._onInput);
      this.el.addEventListener("change", this._onChange);
      this.el.addEventListener("keydown", this._onKey);
      this.el.addEventListener("compositionend", this._onComposed);
    },
    queue() {
      clearTimeout(this._timer);
      this._timer = setTimeout(() => this.push(), 200);
    },
    push() {
      clearTimeout(this._timer);
      this.pushEventTo(this.el, "search", { value: this.el.value });
    },
    destroyed() {
      clearTimeout(this._timer);
    }
  };

  if (typeof module === "object" && module.exports) {
    module.exports.treePickerEnter = treePickerEnter;
  }

  // ---------------------------------------------------------------------------
  // CrumbSwitcher Hook
  // ---------------------------------------------------------------------------
  //
  // The breadcrumb switcher's open/close bookkeeping
  // (PhoenixKitWeb.Components.Core.CrumbSwitcher). The panel opens and closes
  // through LiveView JS (PopoverPanel) from several places — the ▾, Escape, a
  // click away, picking a row — so this watches the panel rather than each
  // path:
  //   * opened → the search starts empty (a panel reused across a patch
  //     would otherwise keep the last level's query) and takes focus;
  //   * closed → focus returns to the ▾ when it was inside the panel (or
  //     dropped to the page), never when the user has moved on elsewhere;
  //   * the ▾'s aria-expanded follows the panel.
  //   * a picked row closes the panel again once the patch it triggered has
  //     landed. The row's own hide runs through a 200ms transition and the
  //     patch re-renders the header around it; on a page that re-renders a lot
  //     the panel was seen left open over the new library (Media, 2026-10-08).
  // Deliberately not done in PopoverPanel's Escape handler: every panel on a
  // page listens for Escape, so a focus move there would fire for all of them.
  // ---------------------------------------------------------------------------

  window.PhoenixKitHooks.CrumbSwitcher = {
    mounted() {
      this._open = false;
      this._picked = false;
      // Capture-phase on the element: LiveView's own link handler stops the
      // click at the window, after this has run.
      this._onClick = (e) => {
        var target = e.target;
        if (!target || !target.closest || !target.closest("[data-filter-text] a")) return;
        this._picked = true;
        clearTimeout(this._pickedTimer);
        // A pick that changes nothing never reaches updated(); do not let the
        // flag close a panel the user opens later.
        this._pickedTimer = setTimeout(() => { this._picked = false; }, 3000);
      };
      this.el.addEventListener("click", this._onClick, true);
      this._sync = () => this.sync();
      this._observer = new MutationObserver(this._sync);
      this._observer.observe(this.el, {
        attributes: true,
        subtree: true,
        attributeFilter: ["style", "class"]
      });
      this.sync();
    },
    updated() {
      if (this._picked) {
        this._picked = false;
        clearTimeout(this._pickedTimer);
        var panel = document.getElementById(this.el.dataset.panel);
        if (panel) this.js().hide(panel);
      }
      this.sync();
    },
    destroyed() {
      clearTimeout(this._pickedTimer);
      this.el.removeEventListener("click", this._onClick, true);
      if (this._observer) this._observer.disconnect();
    },
    sync() {
      var panel = document.getElementById(this.el.dataset.panel);
      var trigger = this.el.querySelector("[data-switcher-trigger]");
      if (!panel || !trigger) return;
      var open = window.getComputedStyle(panel).display !== "none";
      if (trigger.getAttribute("aria-expanded") !== String(open)) {
        trigger.setAttribute("aria-expanded", String(open));
      }
      if (open && !this._open) this.opened(panel);
      if (!open && this._open) this.closed(panel, trigger);
      this._open = open;
    },
    opened(panel) {
      var input = panel.querySelector("[data-filter-list]");
      if (!input) return;
      input.value = "";
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.focus();
    },
    closed(panel, trigger) {
      var active = document.activeElement;
      if (!active || active === document.body || panel.contains(active)) trigger.focus();
    }
  };

  // Exported for the Node test harness (test/js); harmless in a browser.
  if (typeof module === "object" && module.exports) {
    module.exports.listFilterMatches = listFilterMatches;
  }

  // ---------------------------------------------------------------------------
  // LanguageSwitcherPosition Hook
  // ---------------------------------------------------------------------------
  //
  // Automatically positions the language switcher dropdown above or below
  // based on available viewport space. Opens downward by default, switches
  // to upward when there's not enough space below.
  //
  // Usage in LiveView template:
  //   <details class="dropdown" phx-hook="LanguageSwitcherPosition">
  //     <summary>...</summary>
  //     <div class="dropdown-content">...</div>
  //   </details>
  //
  // ---------------------------------------------------------------------------

  window.PhoenixKitHooks.LanguageSwitcherPosition = {
    mounted() {
      this.el.addEventListener("toggle", (e) => {
        if (e.target.open) {
          const rect = this.el.getBoundingClientRect();
          const dropdownContent = this.el.querySelector(".dropdown-content");
          if (!dropdownContent) return;

          // Get actual or estimated content height
          const contentHeight = dropdownContent.offsetHeight || 300;
          const spaceBelow = window.innerHeight - rect.bottom;
          const spaceAbove = rect.top;

          // Remove existing position classes
          this.el.classList.remove("dropdown-top", "dropdown-bottom");

          // Add appropriate position class based on available space
          if (spaceBelow < contentHeight && spaceAbove > spaceBelow) {
            this.el.classList.add("dropdown-top");
          } else {
            this.el.classList.add("dropdown-bottom");
          }
        }
      });
    }
  };

  // ---------------------------------------------------------------------------
  // ViewportPopover Hook
  // ---------------------------------------------------------------------------
  //
  // Keeps an absolutely-positioned popover (one that drops from the bottom of
  // its anchor wrapper) inside the viewport. Clamps its max-height to the space
  // left below the anchor, and flips it to open upward when there's little room
  // below and more above. Without this, a tall editor opened low in the page
  // (e.g. an embedded media browser scrolled down) runs off the bottom of the
  // screen, leaving its footer buttons (Save) unreachable.
  //
  // Inline styles override the element's max-h / top classes; the server sets
  // no style attribute on the element, so morphdom won't clobber them on
  // re-render. Re-runs on mount, update, resize and scroll.
  // ---------------------------------------------------------------------------

  window.PhoenixKitHooks.ViewportPopover = {
    mounted() {
      this._reposition = this.position.bind(this);
      window.addEventListener("resize", this._reposition);
      window.addEventListener("scroll", this._reposition, true);
      this.position();
    },
    updated() {
      this.position();
    },
    destroyed() {
      window.removeEventListener("resize", this._reposition);
      window.removeEventListener("scroll", this._reposition, true);
    },
    position() {
      var el = this.el;
      var margin = 12;
      var anchor = el.parentElement || el;
      var ar = anchor.getBoundingClientRect();
      var spaceBelow = window.innerHeight - ar.bottom - margin;
      var spaceAbove = ar.top - margin;
      var cap = Math.round(window.innerHeight * 0.85);

      if (spaceBelow < 220 && spaceAbove > spaceBelow) {
        // More room above: flip the popover to open upward.
        el.style.top = "auto";
        el.style.bottom = "100%";
        el.style.marginTop = "0px";
        el.style.marginBottom = "0.5rem";
        el.style.maxHeight = Math.max(140, Math.min(spaceAbove, cap)) + "px";
      } else {
        el.style.bottom = "auto";
        el.style.top = "100%";
        el.style.marginBottom = "0px";
        el.style.marginTop = "0.5rem";
        el.style.maxHeight = Math.max(140, Math.min(spaceBelow, cap)) + "px";
      }
    }
  };

  // ---------------------------------------------------------------------------
  // FadeOut Hook
  // ---------------------------------------------------------------------------
  //
  // Handles smooth fade-out animations by listening for CSS animationend event
  // before notifying the server to remove the element. This prevents the race
  // condition where LiveView removes the element before the animation completes.
  //
  // Usage in LiveView template:
  //   <div id="progress-bar"
  //        phx-hook="FadeOut"
  //        data-status={@status}
  //        data-fade-event="animation_finished"
  //        class={@status == :completed && "animate-fade-out"}>
  //     ...content...
  //   </div>
  //
  // Handle in LiveView:
  //   def handle_event("animation_finished", %{"id" => id}, socket)
  //
  // ---------------------------------------------------------------------------

  window.PhoenixKitHooks.FadeOut = {
    mounted() {
      this.handleStatusChange();
    },
    updated() {
      this.handleStatusChange();
    },
    handleStatusChange() {
      const status = this.el.dataset.status;
      const eventName = this.el.dataset.fadeEvent || "animation_finished";

      if (status === "completed" || status === "exiting") {
        // Add the fade-out class if not already present
        if (!this.el.classList.contains("animate-fade-out")) {
          this.el.classList.add("animate-fade-out");
        }

        // Remove any existing listener to avoid duplicates
        if (this._animationHandler) {
          this.el.removeEventListener("animationend", this._animationHandler);
        }

        // Listen for animation to complete, then notify server
        this._animationHandler = () => {
          this.pushEvent(eventName, { id: this.el.id });
        };
        this.el.addEventListener("animationend", this._animationHandler, { once: true });
      }
    },
    destroyed() {
      if (this._animationHandler) {
        this.el.removeEventListener("animationend", this._animationHandler);
      }
    }
  };

  // ---------------------------------------------------------------------------
  // PreserveScroll Hook
  // ---------------------------------------------------------------------------
  //
  // Preserves scroll position during LiveView updates. Useful for pages with
  // toggles or interactive elements that trigger re-renders.
  //
  // Usage in LiveView template:
  //   <div id="content" phx-hook="PreserveScroll">
  //     ...content with toggles...
  //   </div>
  //
  // ---------------------------------------------------------------------------

  window.PhoenixKitHooks.PreserveScroll = {
    mounted() {
      this.scrollPosition = 0;
      this.openDetails = [];
    },
    beforeUpdate() {
      // Save scroll position
      this.scrollPosition = window.scrollY;

      // Save which details elements are open (by their index or id)
      this.openDetails = [];
      this.el.querySelectorAll("details").forEach((detail, index) => {
        if (detail.open) {
          // Use id if available, otherwise use index
          this.openDetails.push(detail.id || "idx-" + index);
        }
      });
    },
    updated() {
      // Restore scroll position
      window.scrollTo(0, this.scrollPosition);

      // Restore open state of details elements
      this.el.querySelectorAll("details").forEach((detail, index) => {
        const identifier = detail.id || "idx-" + index;
        if (this.openDetails.includes(identifier)) {
          detail.open = true;
        }
      });
    }
  };


  // ---------------------------------------------------------------------------
  // InfiniteScroll — fires a "load more" LV event when the sentinel scrolls
  // into view. Pair with the core `<.load_more infinite>` component, which
  // renders this hook plus a manual fallback button. The event name is read
  // from `data-load-more-event` (default "load_more").
  //
  // `data-cursor` is an opaque per-page marker that changes whenever a new
  // page lands. `updated()` only re-fires when it actually changes — so an
  // unrelated LV diff that happens to touch the sentinel (flash, PubSub row
  // update, sibling assign) won't spuriously trigger another load. A single
  // in-flight guard (`loading`) prevents stacking multiple pushes before the
  // server responds; the cursor change clears it on the happy path.
  //
  // The guard also has a timeout watchdog: if a load resolves WITHOUT
  // advancing the cursor (an empty/no-op page, a stale `total`, or a
  // replace-in-place list where `loaded` stays constant), the cursor-change
  // path never clears the guard. The watchdog releases it after a short
  // window so auto-load can never wedge permanently — worst case is a brief
  // stall, after which the next scroll (or the manual button) recovers.
  // ---------------------------------------------------------------------------

  window.PhoenixKitHooks.InfiniteScroll = {
    loadMoreEvent() {
      return this.el.dataset.loadMoreEvent || "load_more";
    },
    clearGuard() {
      this.loading = false;
      clearTimeout(this.loadTimer);
    },
    maybeLoad() {
      if (this.loading) return;
      this.loading = true;
      // Route to the LiveComponent that OWNS the sentinel — the old
      // pushEvent always hit the LV and made the sentinel useless inside
      // components (2026-08-31). See `pushToOwner`.
      pushToOwner(this, this.el, this.loadMoreEvent(), {});
      // Watchdog: release the guard even if the cursor never advances, so a
      // no-op load can't wedge the sentinel. The cursor-change path in
      // updated() clears it sooner on the normal (page-grew) path.
      clearTimeout(this.loadTimer);
      this.loadTimer = setTimeout(() => { this.loading = false; }, 2000);
    },
    mounted() {
      this.intersecting = false;
      this.loading = false;
      this.lastCursor = this.el.dataset.cursor;
      this.observer = new IntersectionObserver(
        (entries) => {
          this.intersecting = entries[0].isIntersecting;
          if (this.intersecting) {
            this.maybeLoad();
          }
        },
        { rootMargin: "200px" }
      );
      this.observer.observe(this.el);
    },
    updated() {
      // Only react to a genuinely new page (cursor changed), not to every
      // diff that happens to touch this element. The cursor change also means
      // the previous load resolved, so clear the in-flight guard.
      if (this.el.dataset.cursor !== this.lastCursor) {
        this.lastCursor = this.el.dataset.cursor;
        this.clearGuard();
        if (this.intersecting) {
          this.maybeLoad();
        }
      }
    },
    destroyed() {
      clearTimeout(this.loadTimer);
      if (this.observer) this.observer.disconnect();
    }
  };


  // ---------------------------------------------------------------------------
  // PageSizeAutoFit — the "Auto" option of `<.page_size_selector auto_fit>`.
  // Measures how many rows of the table named in `data-table-id` fit between
  // the table's top edge and the bottom of the viewport (minus room for the
  // pagination bar) and pushes `data-event` with the LARGEST option from
  // `data-options` that fits — so the value always lands inside the LV's
  // allowlist and the page never needs a scrollbar just for the table.
  // Active only while `data-auto="true"`; re-measures on resize (debounced)
  // and after every LV diff, but pushes only when the answer changed, so a
  // steady viewport costs nothing.
  // ---------------------------------------------------------------------------

  // Pure: the option that fits `rows` rows, clamped into the option range.
  function fitPageSize(available, rowHeight, options) {
    const sorted = options.map(Number).filter((n) => n > 0).sort((a, b) => a - b);
    if (sorted.length === 0) return null;
    if (!(rowHeight > 0)) return sorted[0];
    const rows = Math.floor(available / rowHeight);
    let fit = sorted[0];
    for (const n of sorted) if (n <= rows) fit = n;
    return fit;
  }

  window.PhoenixKitHooks.PageSizeAutoFit = {
    active() {
      return this.el.dataset.auto === "true";
    },
    measure() {
      if (!this.active()) return;
      const table = document.getElementById(this.el.dataset.tableId);
      const row = table && table.querySelector("tbody tr");
      if (!table || !row) return;
      const reserve = 96; // pagination bar + breathing room below the table
      const available = window.innerHeight - table.getBoundingClientRect().top - reserve;
      const options = (this.el.dataset.options || "").split(",");
      const size = fitPageSize(available, row.getBoundingClientRect().height, options);
      if (size === null || String(size) === this.lastPushed) return;
      this.lastPushed = String(size);
      pushToOwner(this, this.el, this.el.dataset.event || "change_per_page", {
        per_page: String(size),
        auto: "1"
      });
    },
    mounted() {
      this.lastPushed = null;
      this.onResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.measure(), 250);
      };
      window.addEventListener("resize", this.onResize);
      this.measure();
    },
    updated() {
      // A number picked by hand switches auto off: forget the last push so
      // re-enabling Auto measures afresh instead of assuming nothing moved.
      if (!this.active()) this.lastPushed = null;
      this.measure();
    },
    destroyed() {
      clearTimeout(this.resizeTimer);
      window.removeEventListener("resize", this.onResize);
    }
  };

  if (typeof module === "object" && module.exports) {
    module.exports.fitPageSize = fitPageSize;
  }


  // ============================================================================
  // 4. FLASH AUTO-DISMISS HOOK
  // ============================================================================

  window.PhoenixKitHooks.FlashAutoDismiss = {
    mounted() {
      this.duration = parseInt(this.el.dataset.dismissAfter || "5000");
      this.lastMessage = this.el.dataset.flashMessage;
      this.startTimer();

      this.el.addEventListener("mouseenter", () => this.pauseTimer());
      this.el.addEventListener("mouseleave", () => this.resumeTimer());
    },
    // A same-kind flash id (e.g. "flash-info") is a stable id — a second
    // flash of the same kind gets morphdom-patched into the SAME node
    // rather than mounted fresh, so without this the original mounted()
    // timer (already consumed, or already mid-flight) is all this message
    // ever gets: on a page like Organization settings where one save
    // after another keeps landing an :info flash, the second message can
    // sit un-timed indefinitely, or inherit a prior dismiss()'s
    // opacity:0/display:none and never even become visible. Reset both
    // the timer and whatever dismiss() left behind, every patch.
    //
    // But `@flash` is ONE Phoenix assign covering all three kinds — putting
    // or clearing a DIFFERENT kind marks the whole assign dirty and
    // re-diffs THIS node too, even though its own message never changed.
    // Unconditionally restarting here meant a flash on a page where
    // anything else touched flash state could never count down to zero.
    // `data-flash-message` fingerprints the actual text, so the timer only
    // restarts for a genuinely new message.
    updated() {
      var message = this.el.dataset.flashMessage;
      if (message === this.lastMessage) return;
      this.lastMessage = message;

      clearTimeout(this.timer);
      this.el.style.transition = "";
      this.el.style.opacity = "";
      this.el.style.transform = "";
      this.el.style.display = "";
      this.duration = parseInt(this.el.dataset.dismissAfter || "5000");
      this.startTimer();
    },
    startTimer() {
      this.remaining = this.duration;
      this.startTime = Date.now();
      var bar = this.el.querySelector("[data-flash-progress]");
      if (bar) {
        bar.style.transition = "width " + this.duration + "ms linear";
        requestAnimationFrame(function() {
          bar.style.width = "0%";
        });
      }
      var self = this;
      this.timer = setTimeout(function() { self.dismiss(); }, this.duration);
    },
    pauseTimer() {
      clearTimeout(this.timer);
      this.elapsed = Date.now() - this.startTime;
      this.remaining = this.remaining - this.elapsed;
      var bar = this.el.querySelector("[data-flash-progress]");
      if (bar) {
        var computedWidth = getComputedStyle(bar).width;
        var parentWidth = bar.parentElement ? bar.parentElement.offsetWidth : 1;
        var widthPx = parseFloat(computedWidth);
        bar.style.transition = "none";
        bar.style.width = (widthPx / parentWidth * 100) + "%";
      }
    },
    resumeTimer() {
      this.startTime = Date.now();
      var bar = this.el.querySelector("[data-flash-progress]");
      if (bar) {
        bar.style.transition = "width " + this.remaining + "ms linear";
        requestAnimationFrame(function() {
          bar.style.width = "0%";
        });
      }
      var self = this;
      this.timer = setTimeout(function() { self.dismiss(); }, this.remaining);
    },
    dismiss() {
      this.pushEvent("lv:clear-flash", {key: this.el.dataset.flashKind});
      this.el.style.transition = "opacity 200ms ease-out, transform 200ms ease-out";
      this.el.style.opacity = "0";
      this.el.style.transform = "translateX(0.5rem)";
      var el = this.el;
      setTimeout(function() {
        if (el) el.style.display = "none";
      }, 200);
    },
    destroyed() {
      clearTimeout(this.timer);
    }
  };


  // ============================================================================
  // Section: TableFit - drop the least important columns that do not fit
  // ============================================================================
  //
  // On the scroll wrapper of a `<.table_default fit>`. Header cells carry
  // `data-col-priority`; the hook hides whole columns, by position, through
  // one stylesheet in <head> — so rows that arrive later (streams, patches)
  // are already right without touching a cell, and LiveView has no attribute
  // of ours to strip. It measures the real table against the wrapper rather
  // than trusting declared widths: a badge is as wide as its translation.

  // Pure: header cells -> [{index, head, priority}]. `index` is the 1-based
  // child position the BODY cells of that column have, `head` the position
  // of the header cell itself — they differ once a header cell spans two
  // columns. A spanning header is never a candidate: hiding one position
  // would take half of it.
  function fitColumns(headers) {
    let next = 1;
    return headers.map((h, i) => {
      const span = h.colSpan > 1 ? h.colSpan : 1;
      const col = {
        index: next,
        head: i + 1,
        priority: span > 1 || h.priority === undefined ? NaN : Number(h.priority)
      };
      next += span;
      return col;
    });
  }

  // Pure: the order columns are dropped in. Highest priority number first;
  // among equals the rightmost first. Returns the columns, not positions.
  function fitEvictionOrder(cols) {
    return cols
      .filter((c) => Number.isFinite(c.priority))
      .slice()
      .sort((a, b) => b.priority - a.priority || b.index - a.index);
  }

  // Pure: what the header row looks like, as a string. The remembered
  // stylesheet is positional, so it is only put back on a table whose
  // columns are the ones it was computed for.
  function fitSignature(headers) {
    return headers
      .map((h) => (h.priority === undefined ? "" : h.priority) + (h.colSpan > 1 ? "x" + h.colSpan : ""))
      .join(",");
  }

  // An id is not always a valid CSS identifier (a leading digit — a uuid —
  // a dot, a colon), so it is escaped; the fallback is for node, which has
  // no CSS object.
  function fitEscapeId(id) {
    if (typeof CSS !== "undefined" && CSS && typeof CSS.escape === "function") {
      return CSS.escape(id);
    }
    return String(id).replace(/^(\d)/, "\\3$1 ").replace(/([^\w\s\\-])/g, "\\$1");
  }

  // Pure: the stylesheet hiding the given columns ({index, head}), plus a
  // "+N" on the last visible header cell so dropped columns do not read as missing
  // data. Header and body are addressed apart because their positions can
  // differ; a cell with a colspan (an empty-state row) is left alone.
  function fitHideCss(wrapperId, cols, headerCount) {
    if (cols.length === 0) return "";
    const id = fitEscapeId(wrapperId);
    const table = `#${id} > table`;
    const sel = cols
      .flatMap((c) => [
        `${table} > thead > tr > :nth-child(${c.head})`,
        `${table} > :not(thead) > tr > :nth-child(${c.index}):not([colspan])`
      ])
      .join(",\n");
    let badgeHead = headerCount;
    while (badgeHead > 0 && cols.some((c) => c.head === badgeHead)) badgeHead--;
    const more = badgeHead > 0 ?
      `${table} > thead > tr > :nth-child(${badgeHead})::before { content: "+${cols.length}"; ` +
      "margin-inline-end: 0.25rem; font-size: 0.6875rem; font-weight: 600; opacity: 0.6; white-space: nowrap; }" : "";
    return `@media screen {\n${sel} { display: none; }\n${more}\n}`;
  }

  window.PhoenixKitHooks.TableFit = {
    mounted() {
      // A table removed without destroyed() running leaves its stylesheet
      // behind, still hiding positions of whatever takes its id next; and
      // the component's inline script may have restored one for first paint.
      document.head
        .querySelectorAll("style[data-pk-table-fit]")
        .forEach((el) => {
          if (el.getAttribute("data-pk-table-fit") === this.el.id) el.remove();
        });
      this.styleEl = document.createElement("style");
      this.styleEl.setAttribute("data-pk-table-fit", this.el.id);
      document.head.appendChild(this.styleEl);
      this.lastWidth = -1;
      if (typeof ResizeObserver === "function") {
        this.observer = new ResizeObserver(() => {
          // Only a width change can alter what fits; a row arriving (height)
          // comes through updated().
          const w = this.el.clientWidth;
          if (w === this.lastWidth) return;
          this.fit();
        });
        this.observer.observe(this.el);
      }
      this.fit();
    },
    updated() {
      this.fit();
    },
    destroyed() {
      if (this.observer) this.observer.disconnect();
      if (this.styleEl) this.styleEl.remove();
    },
    headers() {
      const row = this.el.querySelector(":scope > table > thead > tr");
      if (!row) return [];
      return Array.from(row.children).map((th) => ({
        colSpan: th.colSpan,
        priority: th.dataset.colPriority
      }));
    },
    fit() {
      const table = this.el.querySelector(":scope > table");
      const width = this.el.clientWidth;
      // Not laid out (the card view is showing, a hidden tab): keep what we
      // had; the observer fires again when the wrapper gets a width.
      if (!table || width === 0) return;
      this.lastWidth = width;
      const headers = this.headers();
      const order = fitEvictionOrder(fitColumns(headers));
      const hidden = [];
      // All in one task: show everything, then drop columns until the table
      // stops overflowing. The browser paints only the final state.
      this.styleEl.textContent = "";
      while (table.scrollWidth > this.el.clientWidth && hidden.length < order.length) {
        hidden.push(order[hidden.length]);
        this.styleEl.textContent = fitHideCss(this.el.id, hidden, headers.length);
      }
      // For the next hard load: the component's inline script puts this back
      // before first paint, so the table does not flash its full width. Kept
      // with the header's signature — the stylesheet is positional, and the
      // same id can show other columns on another page.
      try {
        const key = "phoenix_kit:table-fit:" + this.el.id;
        if (hidden.length > 0) {
          localStorage.setItem(
            key,
            JSON.stringify({ sig: fitSignature(headers), css: this.styleEl.textContent })
          );
        } else {
          localStorage.removeItem(key);
        }
      } catch (_e) {}
    }
  };

  if (typeof module === "object" && module.exports) {
    module.exports.fitEvictionOrder = fitEvictionOrder;
    module.exports.fitHideCss = fitHideCss;
    module.exports.fitColumns = fitColumns;
    module.exports.fitEscapeId = fitEscapeId;
    module.exports.fitSignature = fitSignature;
  }

  // ============================================================================
  // Section: TableCardView - Card/Table view toggle
  // ============================================================================
  window.PhoenixKitHooks.TableCardView = {
    mounted() {
      var key = this.el.dataset.storageKey || (this.el.id + "-view");
      // "comfy" (comfortable rows — the table with more space per row and
      // larger thumbs, via the `pk-comfy` marker class) is the default; the
      // dense table and the card grid are the explicit alternatives.
      var saved = localStorage.getItem(key) || "comfy";
      this.storageKey = key;
      this.currentMode = saved;
      this.applyMode(saved);

      var self = this;
      this.el.querySelectorAll("[data-view-action]").forEach(function(btn) {
        btn.addEventListener("click", function() {
          var mode = btn.dataset.viewAction;
          localStorage.setItem(self.storageKey, mode);
          self.currentMode = mode;
          self.applyMode(mode);
          // Notify other TableCardView instances sharing the same key
          window.dispatchEvent(new CustomEvent("phx:table-view-change", {
            detail: { key: self.storageKey, mode: mode }
          }));
        });
      });

      // Listen for view changes from other instances with the same key
      this._onViewChange = function(e) {
        if (e.detail.key === self.storageKey) {
          self.currentMode = e.detail.mode;
          self.applyMode(e.detail.mode);
        }
      };
      window.addEventListener("phx:table-view-change", this._onViewChange);
    },

    updated() {
      // The LV re-render may have reset the inner divs' class attrs back
      // to their template defaults (e.g. tableEl class="hidden md:block",
      // cardEl class="md:hidden ..."). Re-apply the user's chosen mode so
      // a SortableJS drop or any other LV-driven update doesn't snap the
      // view back to the default.
      if (this.currentMode) {
        this.applyMode(this.currentMode);
      }
    },

    destroyed() {
      if (this._onViewChange) {
        window.removeEventListener("phx:table-view-change", this._onViewChange);
      }
    },

    applyMode(mode) {
      var tableEl = this.el.querySelector("[data-table-view]");
      var cardEl  = this.el.querySelector("[data-card-view]");
      var btns    = this.el.querySelectorAll("[data-view-action]");

      if (!tableEl || !cardEl) return;

      if (mode === "card") {
        tableEl.classList.add("md:hidden");
        tableEl.classList.remove("md:block");
        cardEl.classList.remove("md:hidden");
      } else {
        // "table" (compact) and "comfy" (comfortable) both show the table
        // branch; comfy additionally marks it so `[.pk-comfy_&]` utilities
        // in the table markup can widen paddings and thumbnails.
        tableEl.classList.remove("md:hidden");
        tableEl.classList.add("md:block");
        cardEl.classList.add("md:hidden");
      }
      tableEl.classList.toggle("pk-comfy", mode === "comfy");

      btns.forEach(function(b) {
        b.classList.toggle("btn-active", b.dataset.viewAction === mode);
      });
    }
  };


  // ============================================================================
  // 5. ROW MENU HOOK
  // ============================================================================
  //
  // Positions table row action dropdown menus using position: fixed to escape
  // the overflow-x-auto overflow-y-clip table container — a common DaisyUI
  // issue where dropdowns nested inside tables get clipped.
  //
  // The menu opens below the trigger by default, flips above if out of space,
  // and aligns to the right edge (shifting left if that would clip off-screen).
  // Closes on outside click, Escape key, and LiveView navigation.
  //
  // Usage in HEEX (via table_row_menu component):
  //   <.table_row_menu id={"row-menu-\#{item.uuid}"}>
  //     <.table_row_menu_link navigate={...} icon="hero-eye" label="View" />
  //     <.table_row_menu_button phx-click="delete" icon="hero-trash" label="Delete" variant="error" />
  //   </.table_row_menu>
  //
  // RIGHT-CLICK: an element flagged `data-row-menu-context` opens the row
  // menu rendered INSIDE it at the pointer (see `rowMenuFor` for why it is a
  // flag, not the menu's id). Not Core.ContextMenu, deliberately —
  // its one menu element serves every row, so it stamps `phx-value-*` and
  // cannot carry a per-row `navigate=`. This component already renders one
  // menu per row, so the items are per-row and correct as they stand; all
  // that is missing is a second way to open them.
  //
  // Where a menu of w x h opens for a pointer at (x, y). Down-right of the
  // pointer, flipping to the other side of it rather than overflowing, then
  // clamping for a menu too big to fit either way. Published on `window`
  // because Core.ContextMenu lives in a separate IIFE in this bundle and
  // needs the identical rule — two copies of it would drift.
  var MENU_POINTER_PAD = 8;

  function pointerMenuPosition(x, y, w, h, vw, vh) {
    var left = x;
    if (left + w > vw - MENU_POINTER_PAD) left = x - w;
    left = Math.max(MENU_POINTER_PAD, Math.min(left, vw - w - MENU_POINTER_PAD));

    var top = y;
    if (top + h > vh - MENU_POINTER_PAD) top = y - h;
    top = Math.max(MENU_POINTER_PAD, Math.min(top, vh - h - MENU_POINTER_PAD));

    return { left: left, top: top };
  }

  window.PhoenixKitMenus = window.PhoenixKitMenus || {};
  window.PhoenixKitMenus.pointerPosition = pointerMenuPosition;

  // One document listener serves every row menu on the page, so a table of a
  // hundred rows adds one listener, not a hundred.
  var openRowMenu = null;
  var rowMenuListening = false;

  // Android fires `contextmenu` for a long press, and the RELEASE then
  // dispatches a click on whatever the finger was on — the row's link, or
  // the ⋮ trigger, which would toggle the just-opened menu shut. Eat that one
  // click, exactly as Core.ContextMenu does after its own long press. Only
  // after a touch/pen gesture: a mouse right-click is followed by no click.
  var ROW_SWALLOW_CLICK_MS = 700;
  var swallowRowClick = false;
  var swallowRowClickTimer = null;
  var lastPointerType = "mouse";
  var lastPointerDownAt = 0;

  function onRowPointerDown(e) {
    lastPointerType = e.pointerType || "mouse";
    lastPointerDownAt = Date.now();
  }

  function armRowClickSwallow() {
    swallowRowClick = true;
    // Backstop for a release that dispatches no click at all, which would
    // otherwise eat the user's next tap — the menu item they came for.
    if (swallowRowClickTimer) clearTimeout(swallowRowClickTimer);
    swallowRowClickTimer = setTimeout(function () {
      swallowRowClickTimer = null;
      swallowRowClick = false;
    }, ROW_SWALLOW_CLICK_MS);
  }

  // Capture phase on `document`, installed before any menu's own
  // outside-click listener, so it runs first — and stops the others too:
  // the release lands OUTSIDE the menu, and the outside-click listener would
  // close it again the instant it opened.
  function onRowDocClick(e) {
    if (!swallowRowClick) return;
    swallowRowClick = false;
    if (swallowRowClickTimer) {
      clearTimeout(swallowRowClickTimer);
      swallowRowClickTimer = null;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  // Text selected inside the row is a request to copy it. Whole-row
  // right-click is the owner's call; a selection is the one case where the
  // browser's menu is plainly what was wanted.
  function selectionInside(row) {
    var sel = window.getSelection && window.getSelection();
    if (!sel || sel.isCollapsed || String(sel).trim() === "") return false;
    return row.contains(sel.anchorNode) || row.contains(sel.focusNode);
  }

  // `data-row-menu-context` is a FLAG on the row, not the menu's id: the row
  // element is usually rendered by a shared table component that never sees
  // the id its caller built for the menu in the actions slot. So the row says
  // "right-click me" and the menu is found inside it.
  //
  // The hook itself is reached through a PROPERTY on the wrapper, never an
  // attribute — LiveView's patcher strips attributes the server did not
  // render.
  function rowMenuFor(target) {
    if (!target || !target.closest) return null;
    // A field keeps the browser's menu: right-clicking the inline rename box
    // is a request to paste, and taking that away for a row menu the user
    // can still reach one pixel over would be a straight loss.
    if (target.closest("input, textarea, select, [contenteditable]:not([contenteditable=false])")) {
      return null;
    }
    var row = target.closest("[data-row-menu-context]");
    if (!row) return null;
    if (selectionInside(row)) return null;

    // This row's OWN menu. `closest` above already picked the innermost row,
    // so a wrapper that belongs to a nested row is that row's business.
    var wrappers = row.querySelectorAll("[data-row-menu-wrapper]");
    for (var i = 0; i < wrappers.length; i++) {
      if (wrappers[i].closest("[data-row-menu-context]") === row) {
        return wrappers[i]._pkRowMenu || null;
      }
    }
    return null;
  }

  function onRowContextMenu(e) {
    var hook = rowMenuFor(e.target);

    // No row here, or its menu is not rendered in this view mode: leave the
    // browser's own menu alone. Suppressing it everywhere would cost the user
    // Copy/Inspect on a page that has nothing to offer in its place. Close
    // ours first so it does not sit under the browser's — unless the
    // right-click is ON our menu, where a link item's native "Open in new
    // tab" is exactly what the user is after.
    if (!hook) {
      if (openRowMenu && !openRowMenu.menu.contains(e.target)) openRowMenu._close();
      return;
    }

    e.preventDefault();
    if (openRowMenu && openRowMenu !== hook) openRowMenu._close();

    // Only a gesture that began with a finger or pen within the last couple
    // of seconds — a long press is well under that — arms the swallow. A
    // keyboard Menu key sends no pointerdown and must not inherit a stale one.
    if (lastPointerType !== "mouse" && Date.now() - lastPointerDownAt < 2000) {
      armRowClickSwallow();
    }

    // The Menu key and Shift+F10 report the pointer at 0,0. Anchor to the ⋮
    // trigger then, rather than to the viewport's corner.
    var fromKeyboard = e.clientX === 0 && e.clientY === 0;
    hook._open(fromKeyboard ? undefined : { x: e.clientX, y: e.clientY });
  }

  function ensureRowMenuListener() {
    if (rowMenuListening) return;
    document.addEventListener("contextmenu", onRowContextMenu);
    // Registered here, before any menu opens, so it precedes every menu's own
    // capture-phase outside-click listener.
    document.addEventListener("click", onRowDocClick, true);
    document.addEventListener("pointerdown", onRowPointerDown, { capture: true, passive: true });
    rowMenuListening = true;
  }

  window.PhoenixKitHooks.RowMenu = {
    mounted() {
      this.trigger = this.el.querySelector("[data-row-menu-trigger]");
      this.menu = this.el.querySelector("[data-row-menu-content]");
      this.isOpen = false;
      // Track where the menu element originally lives so we can restore
      // it on close. We portal it to <body> while open so `position: fixed`
      // coords escape any containing block created by a `<dialog>` in the
      // top layer or any ancestor with `transform`/`contain`/`filter` (all
      // of which establish a new fixed-positioning origin). Without the
      // portal, `getBoundingClientRect()` returns viewport coords but the
      // browser applies them relative to the nearest containing block,
      // shoving the menu hundreds of pixels off-screen inside modals.
      this._homeParent = this.menu.parentNode;
      this._homeNextSibling = this.menu.nextSibling;

      // Inside a popup shown with showModal() the portal must NOT be <body>:
      // the dialog is in the top layer, which paints over everything outside
      // it, and a modal dialog makes everything outside it inert — a menu on
      // <body> is hidden behind the popup and takes no click. The portal is
      // then the open <dialog> itself (a descendant is not inert, and the
      // dialog element — unlike its transformed box — is a plain fixed
      // origin); and where the Popover API exists the menu is a manual
      // popover as well, so the top layer paints it over the dialog's own
      // content. Measured in Chrome, 2026-10-05.
      this.popover = typeof this.menu.showPopover === "function";

      // The <ul> is server-rendered without `popover`, so a patch of the row
      // while the menu is closed strips what this sets (the patcher removes
      // attributes the server did not render) — and showPopover() on an
      // element with no `popover` attribute throws. Applied again on every
      // open, so it cannot go stale.
      this._armPopover = () => {
        if (!this.popover) return;
        if (this.menu.getAttribute("popover") !== "manual") {
          this.menu.setAttribute("popover", "manual");
        }
        // The UA sheet centres a popover and gives it a border, padding and
        // colours of its own; `inset: auto` + `margin: 0` leave only ours.
        this.menu.style.inset = "auto";
        this.menu.style.margin = "0";
      };
      this._armPopover();

      // A patch strips the dialog's `open` attribute until PkDialog puts it
      // back, while the dialog is still modal — `:modal` is the truer test.
      this._portal = () => {
        var dialog = this.el.closest ? this.el.closest("dialog") : null;
        var shown = dialog && (dialog.open || (dialog.matches && dialog.matches(":modal")));
        return shown ? dialog : document.body;
      };

      this._onTriggerClick = (e) => {
        e.stopPropagation();
        this.isOpen ? this._close() : this._open();
      };

      // Checked against both `this.el` and `this.menu` — while open, the menu
      // is portaled to <body> (see `_open()`), so it's no longer a descendant
      // of `this.el`. Without the `this.menu.contains` check, tapping a menu
      // item is treated as an "outside" click: this capture-phase listener
      // fires before the item's own click handler, closes the menu, and
      // moves it back out from under <body> mid-dispatch. WebKit (desktop and
      // iPadOS Safari — the only engine on iOS/iPadOS) drops the in-flight
      // click when its target is relocated during capture, so the item's
      // action (navigate/phx-click) never runs even though other engines
      // tolerate the move and still deliver it.
      this._onOutsideClick = (e) => {
        if (!this.el.contains(e.target) && !this.menu.contains(e.target)) this._close();
      };

      this._onKeydown = (e) => {
        if (e.key === "Escape") {
          this._close();
          this.trigger.focus();
        }
        // Arrow key navigation inside menu
        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
          e.preventDefault();
          var items = Array.from(this.menu.querySelectorAll("[role='menuitem']:not([disabled])"));
          if (items.length === 0) return;
          var idx = items.indexOf(document.activeElement);
          var next = e.key === "ArrowDown"
            ? (idx + 1) % items.length
            : (idx - 1 + items.length) % items.length;
          items[next].focus();
        }
      };

      // Close when any item is clicked
      this._onMenuClick = () => { this._close(); };

      // A fixed menu does not follow the page. Scrolled, it would sit over a
      // DIFFERENT row while still acting on its own — so it closes, as
      // Core.ContextMenu's does.
      this._onScrollClose = (e) => {
        if (e && e.target && e.target !== document && this.menu.contains(e.target)) return;
        this._close();
      };

      this.trigger.addEventListener("click", this._onTriggerClick);
      this.menu.addEventListener("click", this._onMenuClick);

      // How a right-click on the row finds this hook. A property, not an
      // attribute — see `rowMenuFor`.
      this.el._pkRowMenu = this;
      ensureRowMenuListener();
    },

    updated() {
      // While open, the menu is portaled to <body>; a server diff to this
      // row makes morphdom re-create a duplicate inside the wrapper. That
      // duplicate is the CURRENT truth — an action may have gone ("Retry"
      // once an extraction succeeds) — so its items move into the menu the
      // user is looking at before it is dropped. Keeping the pre-patch items
      // would let a click fire an action the server no longer offers.
      if (this.isOpen) {
        var dup = this.el.querySelector("[data-row-menu-content]");
        if (dup && dup !== this.menu) {
          // The swap detaches the focused item, dropping focus to <body>
          // mid-navigation; put it back on the item in the same slot.
          var sel = "[role='menuitem']";
          var idx = Array.from(this.menu.querySelectorAll(sel)).indexOf(document.activeElement);
          var fresh = Array.prototype.slice.call(dup.childNodes);
          this.menu.replaceChildren.apply(this.menu, fresh);
          dup.remove();
          if (idx >= 0) {
            var items = this.menu.querySelectorAll(sel);
            var again = items[Math.min(idx, items.length - 1)];
            if (again) again.focus({ preventScroll: true });
          }
        }
      }
      // A patch that covers the dialog the menu was portaled into finds its
      // keyed <ul> and moves it back into the row — hidden again, without the
      // popover attribute and positioning. It is the same node (`dup` above is
      // not), so nothing was swapped; but the menu the user opened is gone
      // while `isOpen` still says it is there, and the next trigger click
      // would close what is not showing. Put it back where it was.
      if (this.isOpen && this._reclaimed()) this._present(this._at);
      // morphdom can hand the wrapper back as a fresh node; re-publish.
      this.el._pkRowMenu = this;
    },

    // True when an open menu is no longer showing: put back under the server's
    // `hidden` class, or (with the Popover API) no longer in the top layer.
    _reclaimed() {
      if (this.menu.classList.contains("hidden")) return true;
      return !!(this.popover && !this.menu.matches(":popover-open"));
    },

    // Portal, show and place the menu — the part of opening that a patch can
    // undo. `at` is `{x, y}` for a right-click, absent for the ⋮ trigger.
    _present(at) {
      // Portal to <body> before measuring. If the menu sits inside a
      // <dialog> or any ancestor that establishes a fixed-positioning
      // containing block, `position: fixed` coords would be interpreted
      // relative to that ancestor instead of the viewport. Moving the
      // menu to <body> makes `getBoundingClientRect()` and the resulting
      // `left`/`top` values consistent.
      var portal = this._portal();
      if (this.menu.parentNode !== portal) {
        portal.appendChild(this.menu);
      }

      var triggerRect = this.trigger.getBoundingClientRect();
      var vw = window.innerWidth;
      var vh = window.innerHeight;
      var gap = 4;

      // Show briefly to measure dimensions
      this.menu.classList.remove("hidden");
      this._armPopover();
      if (this.popover && !this.menu.matches(":popover-open")) this.menu.showPopover();
      var menuWidth = this.menu.offsetWidth || 160;
      var menuHeight = this.menu.offsetHeight || 200;

      var left;
      var top;

      if (at) {
        // Right-click: the pointer is the anchor, not the ⋮ button — which on
        // a wide table sits far to the right of where the user clicked.
        var pos = pointerMenuPosition(at.x, at.y, menuWidth, menuHeight, vw, vh);
        left = pos.left;
        top = pos.top;
      } else {
        // Horizontal: align right edge of menu with right edge of trigger
        left = triggerRect.right - menuWidth;
        if (left < 8) left = triggerRect.left;
        left = Math.max(8, Math.min(left, vw - menuWidth - 8));

        // Vertical: prefer below, flip above if not enough space
        top = triggerRect.bottom + gap;
        if (top + menuHeight > vh - 8 && triggerRect.top - menuHeight - gap > 8) {
          top = triggerRect.top - menuHeight - gap;
        }
        top = Math.max(8, Math.min(top, vh - menuHeight - 8));
      }

      this.menu.style.top = top + "px";
      this.menu.style.left = left + "px";
    },

    // `at` is `{x, y}` for a right-click, absent for the ⋮ trigger.
    _open(at) {
      this._at = at;
      this._present(at);

      this.isOpen = true;
      openRowMenu = this;
      this.trigger.setAttribute("aria-expanded", "true");

      document.addEventListener("click", this._onOutsideClick, true);
      document.addEventListener("keydown", this._onKeydown);
      document.addEventListener("scroll", this._onScrollClose, true);
      window.addEventListener("resize", this._onScrollClose);

      // Focus first item for keyboard navigation. `preventScroll`: a focus
      // that scrolled the page would fire the scroll-close just registered.
      var first = this.menu.querySelector("[role='menuitem']");
      if (first) first.focus({ preventScroll: true });
    },

    _close() {
      if (!this.isOpen) return;
      if (this.popover && this.menu.matches(":popover-open")) this.menu.hidePopover();
      this.menu.classList.add("hidden");
      this.isOpen = false;
      if (openRowMenu === this) openRowMenu = null;
      this.trigger.setAttribute("aria-expanded", "false");
      document.removeEventListener("click", this._onOutsideClick, true);
      document.removeEventListener("keydown", this._onKeydown);
      document.removeEventListener("scroll", this._onScrollClose, true);
      window.removeEventListener("resize", this._onScrollClose);

      // Restore the menu to its original location so LiveView's diff
      // patching can find it on subsequent updates. Without this the
      // menu would stay parented to <body> and LV's morphdom pass would
      // see a "missing" element inside the row and re-create it,
      // doubling the DOM and breaking the next open.
      if (this._homeParent && this.menu.parentNode !== this._homeParent) {
        if (this._homeNextSibling && this._homeNextSibling.parentNode === this._homeParent) {
          this._homeParent.insertBefore(this.menu, this._homeNextSibling);
        } else {
          this._homeParent.appendChild(this.menu);
        }
      }
    },

    destroyed() {
      this._close();
      this.trigger.removeEventListener("click", this._onTriggerClick);
      this.menu.removeEventListener("click", this._onMenuClick);
      // A row patched away mid-selection leaves its wrapper behind in some
      // paths; drop the back-reference so a stale hook is never reopened.
      if (this.el._pkRowMenu === this) this.el._pkRowMenu = null;
    }
  };


  // ============================================================================
  // 5b. ROW MENU AUTO HOOK
  // ============================================================================
  //
  // Smart auto-collapsing row menu: shows inline buttons when they fit in the
  // available space, collapses into a ⋮ dropdown when they overflow.
  // Uses ResizeObserver for dynamic detection — no fixed breakpoints.
  //
  window.PhoenixKitHooks.RowMenuAuto = {
    mounted() {
      this.inlineEl = this.el.querySelector("[data-row-menu-inline]");
      this.dropdownEl = this.el.querySelector("[data-row-menu-dropdown]");
      this.trigger = this.el.querySelector("[data-row-menu-trigger]");
      this.menu = this.el.querySelector("[data-row-menu-content]");
      this.isOpen = false;

      if (!this.inlineEl || !this.dropdownEl) return;

      // Start with both hidden
      this.inlineEl.classList.add("hidden");
      this.dropdownEl.classList.add("hidden");

      // Set up dropdown click handlers
      this._onTriggerClick = (e) => {
        e.stopPropagation();
        this.isOpen ? this._closeMenu() : this._openMenu();
      };
      this._onOutsideClick = (e) => {
        if (!this.el.contains(e.target)) this._closeMenu();
      };
      this._onKeydown = (e) => {
        if (e.key === "Escape") {
          this._closeMenu();
          if (this.trigger) this.trigger.focus();
        }
      };
      this._onMenuClick = () => { this._closeMenu(); };

      if (this.trigger) this.trigger.addEventListener("click", this._onTriggerClick);
      if (this.menu) this.menu.addEventListener("click", this._onMenuClick);

      // Listen to window resize
      this._onResize = () => this._check();
      window.addEventListener("resize", this._onResize);

      // Initial check
      this._check();
    },

    updated() {
      this._check();
    },

    _check() {
      if (!this.inlineEl || !this.dropdownEl) return;

      var table = this.el.closest("table");
      var scrollContainer = table ? table.parentElement : null;
      if (!table || !scrollContainer) {
        // Not in a table — show dropdown as fallback
        this.inlineEl.classList.add("hidden");
        this.dropdownEl.classList.remove("hidden");
        return;
      }

      // Step 1: show inline, hide dropdown
      this.inlineEl.classList.remove("hidden");
      this.dropdownEl.classList.add("hidden");

      // Step 2: check if showing inline causes the table to overflow
      if (table.scrollWidth > scrollContainer.clientWidth) {
        // Overflows — switch to dropdown
        this.inlineEl.classList.add("hidden");
        this.dropdownEl.classList.remove("hidden");
      }
      // else: fits, keep inline showing
    },

    _openMenu() {
      if (!this.menu || !this.trigger) return;

      var triggerRect = this.trigger.getBoundingClientRect();
      var vw = window.innerWidth;
      var vh = window.innerHeight;
      var gap = 4;

      this.menu.classList.remove("hidden");
      var menuWidth = this.menu.offsetWidth || 160;
      var menuHeight = this.menu.offsetHeight || 200;

      var left = triggerRect.right - menuWidth;
      if (left < 8) left = triggerRect.left;
      left = Math.max(8, Math.min(left, vw - menuWidth - 8));

      var top = triggerRect.bottom + gap;
      if (top + menuHeight > vh - 8 && triggerRect.top - menuHeight - gap > 8) {
        top = triggerRect.top - menuHeight - gap;
      }
      top = Math.max(8, Math.min(top, vh - menuHeight - 8));

      this.menu.style.top = top + "px";
      this.menu.style.left = left + "px";

      this.isOpen = true;
      this.trigger.setAttribute("aria-expanded", "true");

      document.addEventListener("click", this._onOutsideClick, true);
      document.addEventListener("keydown", this._onKeydown);
    },

    _closeMenu() {
      if (!this.isOpen || !this.menu) return;
      this.menu.classList.add("hidden");
      this.isOpen = false;
      if (this.trigger) this.trigger.setAttribute("aria-expanded", "false");
      document.removeEventListener("click", this._onOutsideClick, true);
      document.removeEventListener("keydown", this._onKeydown);
    },

    destroyed() {
      this._closeMenu();
      if (this._onResize) window.removeEventListener("resize", this._onResize);
      if (this.trigger) this.trigger.removeEventListener("click", this._onTriggerClick);
      if (this.menu) this.menu.removeEventListener("click", this._onMenuClick);
    }
  };


  // ============================================================================
  // 6. EMAIL CHARTS HOOK
  // ============================================================================
  //
  // Initializes Chart.js delivery trend and engagement charts on the email
  // metrics dashboard. Loads Chart.js dynamically so charts work on LiveView
  // navigation (inline <script> tags are not executed on DOM patching).
  //
  // Usage in template:
  //   <div id="email-charts-container" phx-hook="EmailCharts">
  //     <div id="delivery-chart-container" data-chart-data={...}>
  //       <canvas id="delivery-trend-chart" phx-update="ignore"></canvas>
  //     </div>
  //     <div id="engagement-chart-container" data-chart-data={...}>
  //       <canvas id="engagement-chart" phx-update="ignore"></canvas>
  //     </div>
  //   </div>
  //
  window.PhoenixKitHooks.EmailCharts = {
    mounted() {
      this.deliveryChart = null;
      this.engagementChart = null;
      this._initCharts();
      this.handleEvent("email-charts-update", function(data) {
        if (data.charts) { this._updateCharts(data.charts); }
      }.bind(this));
    },

    updated() {
      if (this.deliveryChart && this.engagementChart) {
        this._readAndUpdateCharts();
      }
    },

    destroyed() {
      if (this.deliveryChart) { this.deliveryChart.destroy(); this.deliveryChart = null; }
      if (this.engagementChart) { this.engagementChart.destroy(); this.engagementChart = null; }
    },

    _initCharts() {
      if (typeof Chart === "undefined") { this._showUnavailable(); return; }
      var deliveryContainer = document.getElementById("delivery-chart-container");
      var deliveryCanvas = document.getElementById("delivery-trend-chart");
      var engagementContainer = document.getElementById("engagement-chart-container");
      var engagementCanvas = document.getElementById("engagement-chart");

      if (!deliveryCanvas || !engagementCanvas) { return; }

      if (this.deliveryChart) { this.deliveryChart.destroy(); }
      if (this.engagementChart) { this.engagementChart.destroy(); }

      var deliveryData = this._parseData(deliveryContainer);
      var hasDeliveryData = deliveryData.labels && deliveryData.labels.length > 0;

      this.deliveryChart = new Chart(deliveryCanvas, {
        type: "line",
        data: hasDeliveryData ? deliveryData : {
          labels: [],
          datasets: [
            { label: "Delivered", data: [], borderColor: "rgb(34,197,94)", backgroundColor: "rgba(34,197,94,0.1)", tension: 0.1, fill: true },
            { label: "Bounced", data: [], borderColor: "rgb(239,68,68)", backgroundColor: "rgba(239,68,68,0.1)", tension: 0.1, fill: true }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: { beginAtZero: true, grid: { color: "rgba(0,0,0,0.1)" } },
            x: { grid: { color: "rgba(0,0,0,0.1)" } }
          },
          plugins: {
            legend: { position: "top" },
            tooltip: { mode: "index", intersect: false }
          }
        }
      });

      var engagementData = this._parseData(engagementContainer);
      var hasEngagementData = engagementData.labels && engagementData.labels.length > 0;

      this.engagementChart = new Chart(engagementCanvas, {
        type: "doughnut",
        data: hasEngagementData ? engagementData : {
          labels: ["Opens", "Clicks", "Bounces", "Complaints"],
          datasets: [{ data: [0, 0, 0, 0], backgroundColor: ["rgb(59,130,246)", "rgb(34,197,94)", "rgb(251,191,36)", "rgb(239,68,68)"] }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { position: "bottom" },
            tooltip: {
              callbacks: {
                label: function(context) {
                  var total = context.dataset.data.reduce(function(a, b) { return a + b; }, 0);
                  var pct = total > 0 ? ((context.parsed / total) * 100).toFixed(1) : 0;
                  return (context.label || "") + ": " + context.parsed + " (" + pct + "%)";
                }
              }
            }
          }
        }
      });
    },

    _parseData(container) {
      if (!container) { return {}; }
      try {
        var raw = container.getAttribute("data-chart-data");
        return raw ? JSON.parse(raw) : {};
      } catch(e) { return {}; }
    },

    _updateCharts(chartsData) {
      if (this.deliveryChart && chartsData.delivery_trend) {
        this.deliveryChart.data = chartsData.delivery_trend;
        this.deliveryChart.update();
      }
      if (this.engagementChart && chartsData.engagement) {
        this.engagementChart.data = chartsData.engagement;
        this.engagementChart.update();
      }
    },

    _readAndUpdateCharts() {
      var deliveryContainer = document.getElementById("delivery-chart-container");
      var engagementContainer = document.getElementById("engagement-chart-container");
      var deliveryData = this._parseData(deliveryContainer);
      var engagementData = this._parseData(engagementContainer);
      if (this.deliveryChart && deliveryData.labels) {
        this.deliveryChart.data = deliveryData;
        this.deliveryChart.update();
      }
      if (this.engagementChart && engagementData.labels) {
        this.engagementChart.data = engagementData;
        this.engagementChart.update();
      }
    },

    _showUnavailable() {
      ["delivery-chart-container", "engagement-chart-container"].forEach(function(id) {
        var container = document.getElementById(id);
        if (!container) { return; }
        var wrapper = document.createElement("div");
        wrapper.className = "flex items-center justify-center h-full text-base-content/40 text-sm gap-1";
        var text = document.createTextNode("Charts unavailable: add ");
        var code = document.createElement("code");
        code.className = "font-mono mx-1";
        code.textContent = 'import "../../deps/phoenix_kit/priv/static/assets/phoenix_kit.js"';
        var text2 = document.createTextNode(" to your app.js");
        wrapper.appendChild(text);
        wrapper.appendChild(code);
        wrapper.appendChild(text2);
        container.textContent = "";
        container.appendChild(wrapper);
      });
    }
  };


  // ============================================================================
  // LEAF EDITOR (vendored, loaded on demand)
  //
  // Loads Leaf's editor JS when the hook mounts, so a page with no editor on
  // it pays nothing. The file is the host's own copy of the INSTALLED :leaf
  // dependency (PhoenixKit.Install.ViewerLibraries), so the browser half can
  // no longer drift from the server half: there is no tag to keep in step.
  // ============================================================================

  (function() {

    function loadLeaf() {
      return loadVendored("Leaf", "leaf", {
        check: function() { return !!(window.LeafHooks && window.LeafHooks.Leaf); }
      });
    }

    // Wrapper hook that lazy-loads Leaf JS then becomes the real hook.
    window.PhoenixKitHooks.Leaf = lazyHook(loadLeaf, function() {
      return window.LeafHooks && window.LeafHooks.Leaf;
    });
  })();


  // ============================================================================
  // FRESCO (vendored, loaded on demand)
  //
  // Loads Fresco when one of its hooks mounts. The single fresco.js exports
  // all three component hooks; PhoenixKit wraps the two it uses
  // (`FrescoViewer` for plain images, `FrescoCanvas` for the annotation
  // host), so one load covers both. A host that pre-imports Fresco in its own
  // app.js short-circuits the load entirely. The file is the host's copy of
  // the installed :fresco dependency (PhoenixKit.Install.ViewerLibraries).
  // ============================================================================

  (function() {

    // Usable means the engine (window.Fresco — what Tessera and Etcher
    // attach through) AND the hooks are there, pre-imported or loaded.
    function loadFresco() {
      return loadVendored("Fresco", "fresco", {
        check: function() {
          return !!(window.Fresco && window.FrescoHooks && window.FrescoHooks.FrescoViewer);
        }
      });
    }
    pkLoaders.fresco = loadFresco;

    window.PhoenixKitHooks.FrescoViewer = lazyHook(loadFresco, function() {
      return window.FrescoHooks && window.FrescoHooks.FrescoViewer;
    });

    // FrescoCanvas — the layered scene component MediaBrowser uses to
    // host annotations (Etcher). Both hooks come out of the same fresco.js
    // bundle, so a single fetch covers either / both.
    window.PhoenixKitHooks.FrescoCanvas = lazyHook(loadFresco, function() {
      return window.FrescoHooks && window.FrescoHooks.FrescoCanvas;
    });
  })();


  // ============================================================================
  // TESSERA LAYER (vendored, loaded on demand)
  //
  // Tessera's progressive-resolution + DZI deep-zoom layer. Attaches to a
  // Fresco viewer via `fresco_id`, so it loads only after Fresco has (below).
  // Same pre-import short-circuit; the file is the host's copy of the
  // installed :tessera dependency.
  // ============================================================================

  (function() {

    // Chained through Fresco: Tessera's mounted gives up when window.Fresco
    // is absent, and two async script loads finish in either order — a fast
    // Tessera beside a slow Fresco silently lost the sharper rungs.
    function loadTessera() {
      return pkLoaders.fresco().then(function() {
        return loadVendored("Tessera", "tessera", {
          check: function() { return !!(window.TesseraHooks && window.TesseraHooks.TesseraLayer); }
        });
      });
    }

    window.PhoenixKitHooks.TesseraLayer = lazyHook(loadTessera, function() {
      return window.TesseraHooks && window.TesseraHooks.TesseraLayer;
    });
  })();


  // ============================================================================
  // ETCHER LAYER (vendored, loaded on demand)
  //
  // Etcher's annotation layer: attaches to a Fresco viewer/canvas via
  // `fresco_id` and adds the pencil toolbar, draw tools and shape
  // persistence. Same pre-import short-circuit; the file is the host's copy
  // of the installed :etcher dependency, so a toolbar hook the server is
  // wired for can no longer be missing from a stale CDN copy.
  // ============================================================================

  (function() {

    // Etcher's Customise dialog loads SortableJS itself. Point it at this
    // host's copy and turn its built-in CDN load off — in every mode, so a
    // failed local copy falls back to native drag-and-drop, never to
    // jsDelivr (Etcher >= 0.20; the `sortableUrl` is authoritative). A host
    // that opted into a CDN fallback gets it from the shared loader instead,
    // which supplies window.Sortable (Etcher prefers it) before Etcher mounts.
    // The settings themselves. A host that set its own wins. Also applied
    // once the page has parsed (below): a host that pre-imports Etcher in
    // its own app.js replaces this wrapper hook entirely, and would
    // otherwise keep Etcher's CDN load. Etcher reads both lazily and keeps
    // an existing window.Etcher when it loads, so either order works.
    function applyEtcherSortableSettings() {
      window.Etcher = window.Etcher || {};
      var urls = pkLibUrls("sortable");
      if (urls && window.Etcher.sortableUrl === undefined) window.Etcher.sortableUrl = urls.local;
      if (window.Etcher.loadSortableFromCdn === undefined) window.Etcher.loadSortableFromCdn = false;
      return urls;
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", applyEtcherSortableSettings);
    } else {
      setTimeout(applyEtcherSortableSettings, 0);
    }

    function configureEtcherSortable() {
      var urls = applyEtcherSortableSettings();
      if (urls && urls.cdn) {
        return loadVendored("SortableJS", "sortable", {
          check: function() { return typeof window.Sortable === "function"; }
        }).catch(function() { /* reported; the dialog reorders natively */ });
      }
      return Promise.resolve();
    }

    // Chained through Fresco for the same reason as Tessera: Etcher attaches
    // through window.Fresco.onReady and gives up when it is absent.
    function loadEtcher() {
      return pkLoaders.fresco().then(function() {
        var sortable = configureEtcherSortable();
        var etcher = loadVendored("Etcher", "etcher", {
          check: function() { return !!(window.EtcherHooks && window.EtcherHooks.EtcherLayer); }
        });
        return Promise.all([etcher, sortable]);
      });
    }

    window.PhoenixKitHooks.EtcherLayer = lazyHook(loadEtcher, function() {
      return window.EtcherHooks && window.EtcherHooks.EtcherLayer;
    });
  })();


  // ============================================================================
  // INTEGRATION PICKER SEARCH HOOK
  // ============================================================================

  window.PhoenixKitHooks.IntegrationPickerSearch = {
    mounted() {
      this.el.addEventListener("input", function(e) {
        var query = e.target.value.toLowerCase();
        var pickerId = e.target.dataset.pickerId;
        var picker = document.getElementById(pickerId);
        if (!picker) return;

        var cards = picker.querySelectorAll("button[data-search-text]");
        cards.forEach(function(card) {
          var text = card.getAttribute("data-search-text") || "";
          card.style.display = (query === "" || text.indexOf(query) !== -1) ? "" : "none";
        });
      });
    }
  };

  // ============================================================================
  // MEDIA DRAG & DROP HOOK
  // ============================================================================

  // Box select on the media browser: a press on empty space in the content
  // column (`[data-box-area]`) and a drag draws a box; every card it touches
  // is outlined as it goes, and on release becomes the selection
  // (`box_select`, which turns select mode on). Shift or Cmd/Ctrl adds to the
  // selection instead of replacing it. A press on a card is still that card's
  // own drag; a touch screen keeps long-press. Near the column's top or
  // bottom edge it scrolls, and the box keeps its far end where the content
  // was. Escape lets go without selecting.
  //
  // Installed on the document when this script loads rather than by the
  // MediaDragDrop hook: until LiveView connects (a second or two after a
  // reload) there is no hook, and the first box used to become a text
  // selection instead.
  function startBoxSelect(e, root) {
    var THRESHOLD = 5;
    var EDGE = 48;
    var NOT_EMPTY = "[data-draggable-file], [data-draggable-folder], button, a, input, textarea, " +
      "select, label, summary, [contenteditable], [phx-click], [role='button'], dialog, .modal, .dropdown";

    function selectables(area) {
      return Array.prototype.slice.call(
        area.querySelectorAll("[data-draggable-file], [data-draggable-folder]")
      ).filter(function(el) { return el.offsetParent; });
    }

    if (e.button !== 0 || e.pointerType === "touch") return;
    var area = e.target.closest && e.target.closest("[data-box-area]");
    if (!area || !root.contains(area)) return;
    if (e.target.closest(NOT_EMPTY)) return;

    if (root.__pkCancelBox) root.__pkCancelBox();
    var additive = e.shiftKey || e.metaKey || e.ctrlKey;
    var previousUserSelect = document.documentElement.style.userSelect;
    // Content coordinates: the press point travels with the content
    // when the column scrolls.
    var start = { x: e.clientX, y: e.clientY, scroll: area.scrollTop };
    var last = { x: e.clientX, y: e.clientY };
    var box = null, cards = null, hits = [], raf = 0, scrollRaf = 0;

    function rectNow() {
      var dy = area.scrollTop - start.scroll;
      var x1 = start.x, y1 = start.y - dy;
      return {
        left: Math.min(x1, last.x), top: Math.min(y1, last.y),
        right: Math.max(x1, last.x), bottom: Math.max(y1, last.y)
      };
    }

    function mark(el, on) {
      el.style.outline = on ? "2px solid var(--color-primary)" : "";
      el.style.outlineOffset = on ? "2px" : "";
    }

    function paint() {
      raf = 0;
      if (!box) return;
      var r = rectNow();
      var a = area.getBoundingClientRect();
      // The drawn box stays inside the column; the hit test uses the
      // whole of it, scrolled-away part included.
      var left = Math.max(r.left, a.left), top = Math.max(r.top, a.top);
      box.style.left = left + "px";
      box.style.top = top + "px";
      box.style.width = Math.max(0, Math.min(r.right, a.right) - left) + "px";
      box.style.height = Math.max(0, Math.min(r.bottom, a.bottom) - top) + "px";
      var next = cards.filter(function(el) {
        var c = el.getBoundingClientRect();
        return c.right > r.left && c.left < r.right && c.bottom > r.top && c.top < r.bottom;
      });
      hits.forEach(function(el) { if (next.indexOf(el) === -1) mark(el, false); });
      next.forEach(function(el) { if (hits.indexOf(el) === -1) mark(el, true); });
      hits = next;
    }

    function autoScroll() {
      scrollRaf = 0;
      if (!box) return;
      var a = area.getBoundingClientRect();
      var v = 0;
      if (last.y < a.top + EDGE) v = -Math.ceil((a.top + EDGE - last.y) / 4);
      else if (last.y > a.bottom - EDGE) v = Math.ceil((last.y - (a.bottom - EDGE)) / 4);
      if (!v) return;
      var before = area.scrollTop;
      area.scrollTop += v;
      if (area.scrollTop === before) return;
      paint();
      scrollRaf = requestAnimationFrame(autoScroll);
    }

    function begin() {
      cards = selectables(area);
      box = document.createElement("div");
      box.setAttribute("data-box-select-rect", "");
      box.style.cssText = "position:fixed;z-index:60;pointer-events:none;border-radius:4px;" +
        "border:1px solid var(--color-primary);" +
        "background:color-mix(in oklab, var(--color-primary) 12%, transparent);";
      document.body.appendChild(box);
      document.documentElement.style.userSelect = "none";
      try { window.getSelection().removeAllRanges(); } catch (_e) {}
    }

    function finish(commit) {
      if (root.__pkCancelBox === cancel) root.__pkCancelBox = null;
      window.removeEventListener("pointermove", onMove, true);
      window.removeEventListener("pointerup", onUp, true);
      window.removeEventListener("pointercancel", onCancel, true);
      window.removeEventListener("keydown", onKey, true);
      if (raf) cancelAnimationFrame(raf);
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      raf = scrollRaf = 0;
      if (!box) return;
      if (commit) paint();
      hits.forEach(function(el) { mark(el, false); });
      box.remove();
      box = null;
      document.documentElement.style.userSelect = previousUserSelect;
      // The click this release makes belongs to the box, not the page.
      var swallow = function(ev) { ev.stopPropagation(); ev.preventDefault(); };
      window.addEventListener("click", swallow, true);
      setTimeout(function() { window.removeEventListener("click", swallow, true); }, 0);
      if (!commit) return;
      var files = [], folders = [];
      hits.forEach(function(el) {
        if (el.dataset.draggableFile) files.push(el.dataset.draggableFile);
        else if (el.dataset.draggableFolder) folders.push(el.dataset.draggableFolder);
      });
      var payload = { files: files, folders: folders, additive: additive };
      var hook = root.__pkBoxHook;
      if (hook && hook.el === root) {
        hook.pushEventTo(root, "box_select", payload);
      } else {
        // Not connected yet: keep the cards outlined and hand the box to
        // the hook when it mounts (`setupBoxSelect`).
        var kept = hits.slice();
        kept.forEach(function(el) { mark(el, true); });
        window.__pkPendingBox = {
          root: root.id,
          payload: payload,
          unmark: function() { kept.forEach(function(el) { mark(el, false); }); }
        };
      }
    }

    function onMove(ev) {
      if (ev.pointerId !== e.pointerId) return;
      last = { x: ev.clientX, y: ev.clientY };
      if (!box) {
        if (Math.abs(last.x - start.x) < THRESHOLD && Math.abs(last.y - start.y) < THRESHOLD) return;
        begin();
      }
      ev.preventDefault();
      if (!raf) raf = requestAnimationFrame(paint);
      if (!scrollRaf) scrollRaf = requestAnimationFrame(autoScroll);
    }
    function onUp(ev) { if (ev.pointerId === e.pointerId) finish(true); }
    function onCancel(ev) { if (ev.pointerId === e.pointerId) finish(false); }
    function cancel() { finish(false); }
    function onKey(ev) {
      if (ev.key === "Escape" && box) {
        ev.preventDefault();
        ev.stopPropagation();
        finish(false);
      }
    }

    root.__pkCancelBox = cancel;
    window.addEventListener("pointermove", onMove, true);
    window.addEventListener("pointerup", onUp, true);
    window.addEventListener("pointercancel", onCancel, true);
    window.addEventListener("keydown", onKey, true);
  }

  document.addEventListener("pointerdown", function(e) {
    var root = e.target && e.target.closest && e.target.closest('[phx-hook="MediaDragDrop"]');
    if (root) startBoxSelect(e, root);
  });

  // Shift-click range select: Shift-clicking a card selects every card from
  // the anchor (the last card clicked or long-pressed while selecting) to it,
  // in the order they are on screen, added to what is selected. With nothing
  // selected yet it selects just that card, which becomes the anchor. Sent as
  // a `box_select`, so only what is on screen can be picked.
  var rangeAnchor = null; // {root, key}
  function cardKey(card) {
    return card.dataset.draggableFile ? "f:" + card.dataset.draggableFile
      : card.dataset.draggableFolder ? "d:" + card.dataset.draggableFolder : null;
  }
  function rangeCard(e) {
    var root = e.target && e.target.closest && e.target.closest('[phx-hook="MediaDragDrop"]');
    if (!root) return null;
    var card = e.target.closest("[data-draggable-file], [data-draggable-folder]");
    if (!card || !root.contains(card) || !card.closest("[data-box-area]")) return null;
    // A card's own menu and its rename / description fields keep their
    // clicks (a folder card's body is itself a button, which ranges).
    var control = e.target.closest(".dropdown, [role='menu'], [aria-haspopup], form, textarea, " +
      "input:not([type='checkbox'])");
    if (control && card.contains(control)) return null;
    return { root: root, card: card };
  }

  // Shift + press on a card would extend the page's text selection.
  document.addEventListener("pointerdown", function(e) {
    if (e.shiftKey && e.button === 0 && rangeCard(e)) e.preventDefault();
  }, true);

  document.addEventListener("click", function(e) {
    var hit = rangeCard(e);
    if (!hit) return;
    var root = hit.root, card = hit.card, key = cardKey(card);
    if (!key) return;
    if (!e.shiftKey) {
      // A plain click while selecting moves the anchor.
      if (root.querySelector('[data-selected="true"]') || root.dataset.selectionCount) {
        rangeAnchor = { root: root.id, key: key };
      }
      return;
    }
    var hook = root.__pkBoxHook;
    if (!hook || hook.el !== root) return;
    e.preventDefault();
    e.stopPropagation();
    var area = card.closest("[data-box-area]");
    var cards = Array.prototype.slice.call(
      area.querySelectorAll("[data-draggable-file], [data-draggable-folder]")
    ).filter(function(el) { return el.offsetParent; });
    var to = cards.indexOf(card);
    var from = -1;
    // Escape / Clear ends the old range even when its anchor is still on
    // screen. The next Shift-click starts a new selection at this card.
    if (!root.querySelector('[data-selected="true"]') &&
        !(parseInt(root.dataset.selectionCount || "0", 10) > 0)) rangeAnchor = null;
    if (rangeAnchor && rangeAnchor.root === root.id) {
      from = cards.findIndex(function(el) { return cardKey(el) === rangeAnchor.key; });
    }
    if (from === -1) {
      // No anchor on screen: the selected card nearest before this one,
      // else the first selected after it.
      for (var i = to - 1; i >= 0 && from === -1; i--) if (cards[i].dataset.selected === "true") from = i;
      for (var j = to + 1; j < cards.length && from === -1; j++) if (cards[j].dataset.selected === "true") from = j;
    }
    var picked = from === -1 ? [card] : cards.slice(Math.min(from, to), Math.max(from, to) + 1);
    if (from === -1) rangeAnchor = { root: root.id, key: key };
    var files = [], folders = [];
    picked.forEach(function(el) {
      if (el.dataset.draggableFile) files.push(el.dataset.draggableFile);
      else folders.push(el.dataset.draggableFolder);
    });
    hook.pushEventTo(root, "box_select", { files: files, folders: folders, additive: true });
  }, true);

  window.PhoenixKitHooks.MediaDragDrop = {
    mounted: function() {
      // View mode (grid/list) AND the sidebar folder-tree state (expanded
      // folders + collapsed flag) are both persisted server-side in the user's
      // meta and rendered on first paint. There is intentionally no
      // localStorage→push restore here anymore — that ran only after connect
      // and made the grid flash to list / the tree flash from collapsed to its
      // open positions.

      // Bulk download: server pushes a list of {url, name}; we trigger one anchor click per file
      this.handleEvent("download_files", function(data) {
        var files = (data && data.files) || [];
        files.forEach(function(f, i) {
          setTimeout(function() {
            var a = document.createElement("a");
            a.href = f.url;
            a.download = f.name || "";
            a.rel = "noopener";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }, i * 150);
        });
      });

      this.setupDragDrop();
      this.setupLongPress();
      this.setupBoxSelect();
      this.setupPickConfirm();
    },

    destroyed: function() {
      if (this.el.__pkCancelBox) this.el.__pkCancelBox();
      if (this.el.__pkBoxHook === this) this.el.__pkBoxHook = null;
      if (this._pickDblClick) this.el.removeEventListener("dblclick", this._pickDblClick);
    },

    // A single-pick picker (`data-pick-mode="single"`) confirms on a double
    // click, file-dialog style: the two clicks have picked the file already,
    // and this names it again so the server confirms exactly that one.
    // LiveView has no double-click binding, so the hook listens. Read on
    // every event, so a re-render that changes the mode needs no rewiring.
    setupPickConfirm: function() {
      var self = this;
      this._pickDblClick = function(e) {
        if (self.el.dataset.pickMode !== "single") return;
        var card = e.target && e.target.closest && e.target.closest('[phx-click="click_file"]');
        if (!card || card.closest('[phx-hook="MediaDragDrop"]') !== self.el) return;
        var uuid = card.getAttribute("phx-value-file-uuid");
        if (!uuid) return;
        self.pushEventTo(self.el, "pick_quick_confirm", { "file-uuid": uuid });
      };
      this.el.addEventListener("dblclick", this._pickDblClick);
    },

    updated: function() {
      this.setupDragDrop();
      this.setupLongPress();
    },

    // Box select (see `startBoxSelect`, outside the hook): the listener is
    // installed when the script loads, not when the hook mounts, so a box
    // drawn in the second or two before LiveView connects is not lost to a
    // text selection. A box finished before the hook exists waits here.
    setupBoxSelect: function() {
      this.el.__pkBoxHook = this;
      var pending = window.__pkPendingBox;
      if (pending && pending.root === this.el.id) {
        window.__pkPendingBox = null;
        pending.unmark();
        this.pushEventTo(this.el, "box_select", pending.payload);
      }
    },

    // Long-press (hold ~450ms without moving) on a file/folder card enters
    // select mode and selects that item — the standard touch gesture for
    // multi-select. Moving (scroll/drag) or releasing early cancels it. The
    // click that follows the release is swallowed so the item isn't also
    // opened/navigated. Native HTML5 drag is mouse-only, so this doesn't
    // fight drag-to-move on touch.
    setupLongPress: function() {
      var self = this;
      // A picker has no select mode to enter: its cards are draggable only
      // for `allow_move`, and a hold must not eat the click that picks.
      if (this.el.dataset.pickMode) return;
      var LONG_PRESS_MS = 450;
      var MOVE_TOLERANCE = 10;
      var items = this.el.querySelectorAll("[data-draggable-file], [data-draggable-folder]");
      items.forEach(function(el) {
        var fileUuid = el.dataset.draggableFile;
        var folderUuid = el.dataset.draggableFolder;
        var type = fileUuid ? "file" : "folder";
        var uuid = fileUuid || folderUuid;
        if (!uuid) return;

        el.removeEventListener("pointerdown", el._lpDown);
        el.removeEventListener("pointermove", el._lpMove);
        el.removeEventListener("pointerup", el._lpUp);
        el.removeEventListener("pointercancel", el._lpUp);
        el.removeEventListener("pointerleave", el._lpUp);
        if (el._lpClick) el.removeEventListener("click", el._lpClick, true);

        var timer = null, startX = 0, startY = 0;
        var cancel = function() { if (timer) { clearTimeout(timer); timer = null; } };

        el._lpDown = function(e) {
          if (typeof e.button === "number" && e.button !== 0) return;
          startX = e.clientX; startY = e.clientY;
          cancel();
          timer = setTimeout(function() {
            timer = null;
            el._lpFired = true;
            if (navigator.vibrate) { try { navigator.vibrate(30); } catch (_) {} }
            self.pushEventTo(self.el, "long_press_select", { type: type, uuid: uuid });
            // The held card anchors a later Shift-click range.
            rangeAnchor = { root: self.el.id, key: (type === "folder" ? "d:" : "f:") + uuid };
          }, LONG_PRESS_MS);
        };
        el._lpMove = function(e) {
          if (!timer) return;
          if (Math.abs(e.clientX - startX) > MOVE_TOLERANCE ||
              Math.abs(e.clientY - startY) > MOVE_TOLERANCE) {
            cancel();
          }
        };
        el._lpUp = function() { cancel(); };
        // Capture phase beats LiveView's window/bubble click listener, so this
        // reliably swallows the post-long-press click.
        el._lpClick = function(e) {
          if (el._lpFired) { e.preventDefault(); e.stopPropagation(); el._lpFired = false; }
        };

        el.addEventListener("pointerdown", el._lpDown);
        el.addEventListener("pointermove", el._lpMove);
        el.addEventListener("pointerup", el._lpUp);
        el.addEventListener("pointercancel", el._lpUp);
        el.addEventListener("pointerleave", el._lpUp);
        el.addEventListener("click", el._lpClick, true);
      });
    },

    setupDragDrop: function() {
      var self = this;
      var container = this.el;

      // The folder a dragged card already sits in: the drop zone around it
      // (the main area of the folder being shown, or a stack's section).
      // That zone is not a destination — dropping there leaves everything
      // where it is — so it neither lights up nor takes the drop, and the
      // same goes for every other zone naming that folder (its sidebar
      // node). A batch counts only when all of it shares one home.
      function originOf(el) {
        // A picker listing the subfolders' files shows them in the zone of the
        // folder viewed; the card says which folder it is really in.
        if (el.dataset.originFolder) return el.dataset.originFolder;
        var zone = el.parentElement && el.parentElement.closest("[data-drop-folder]");
        return zone ? zone.dataset.dropFolder : null;
      }
      // Whether this target takes nothing from the drag in hand. In a picker
      // the grid itself (`data-drop-no-bg`) takes no move: a card let go over
      // it by accident moves nothing; a folder is pointed at. The folder a
      // card is in takes none either, unless the pick has files in other
      // folders as well (`_gatherPick`): then its node gathers them.
      function declines(target) {
        if (inPicker() && target.dataset.dropNoBg !== undefined) return true;
        if (!self._dragOrigin || target.dataset.dropFolder !== self._dragOrigin) return false;
        return !self._gatherPick;
      }
      // What a drag of this card takes along. A picker's batch is its pick
      // (`data-pick-order` marks the picked cards on screen, the server holds
      // the pick and moves all of it); elsewhere it is the selection.
      function inPicker() { return !!self.el.dataset.pickMode; }
      function isSelected(el) {
        return inPicker() ? el.hasAttribute("data-pick-order") : el.dataset.selected === "true";
      }
      function selectedEls() {
        return Array.prototype.slice.call(inPicker()
          ? self.el.querySelectorAll("[data-pick-order]")
          : document.querySelectorAll('[data-selected="true"]'));
      }
      function dragOrigin(el) {
        if (!isSelected(el)) return originOf(el);
        var origin;
        var same = true;
        selectedEls().forEach(function(s) {
          var o = originOf(s);
          if (origin === undefined) origin = o;
          else if (o !== origin) same = false;
        });
        return same ? origin || null : null;
      }

      // A selection picked up shows as one: a small pile of its pictures
      // (the grabbed one on top) and a badge with how many are moving, in
      // place of the browser's snapshot of the single card under the mouse.
      function selectionGhost(e, grabbed) {
        var count = parseInt((inPicker() ? self.el.dataset.pickCount : self.el.dataset.selectionCount) || "0", 10) ||
          selectedEls().length;
        if (count < 2 || !e.dataTransfer.setDragImage) return;
        var others = selectedEls().filter(function(el) { return el !== grabbed; });
        // Pictures before folders: a pile reads as what is being carried.
        var pictured = function(el) { return el.querySelector("img") ? 0 : 1; };
        others.sort(function(a, b) { return pictured(a) - pictured(b); });
        var pile = [grabbed].concat(others).slice(0, 3);
        var SIZE = 84;
        var ghost = document.createElement("div");
        ghost.style.cssText = "position:fixed;top:-1000px;left:-1000px;width:" + (SIZE + 40) + "px;height:" +
          (SIZE + 40) + "px;pointer-events:none;z-index:9999;";
        var tilt = [0, -9, 8];
        var shift = [[0, 0], [-7, 3], [8, 5]];
        for (var i = pile.length - 1; i >= 0; i--) {
          var card = document.createElement("div");
          card.style.cssText = "position:absolute;left:16px;top:20px;width:" + SIZE + "px;height:" + SIZE + "px;" +
            "border-radius:12px;overflow:hidden;background:var(--color-base-300, #ddd);" +
            "border:2px solid var(--color-base-100, #fff);box-shadow:0 6px 16px rgba(0,0,0,0.25);" +
            "display:flex;align-items:center;justify-content:center;" +
            "transform:translate(" + shift[i][0] + "px," + shift[i][1] + "px) rotate(" + tilt[i] + "deg);";
          var src = pile[i].querySelector("img");
          if (src && (src.currentSrc || src.src)) {
            var img = document.createElement("img");
            img.src = src.currentSrc || src.src;
            img.style.cssText = "width:100%;height:100%;object-fit:cover;";
            card.appendChild(img);
          } else {
            var icon = pile[i].querySelector("svg, [class*='hero-']");
            if (icon) {
              var c = icon.cloneNode(true);
              c.style.width = "48px";
              c.style.height = "48px";
              card.appendChild(c);
            }
          }
          ghost.appendChild(card);
        }
        var badge = document.createElement("div");
        badge.textContent = String(count);
        badge.style.cssText = "position:absolute;right:6px;top:6px;min-width:28px;height:28px;padding:0 8px;" +
          "box-sizing:border-box;border-radius:14px;background:var(--color-primary, #3b82f6);" +
          "color:var(--color-primary-content, #fff);font:700 14px/28px system-ui,sans-serif;text-align:center;" +
          "box-shadow:0 2px 6px rgba(0,0,0,0.3);border:2px solid var(--color-base-100, #fff);";
        ghost.appendChild(badge);
        document.body.appendChild(ghost);
        e.dataTransfer.setDragImage(ghost, 16 + SIZE / 2, 20 + SIZE / 2);
        // The snapshot is taken now; the element is not needed after.
        setTimeout(function() { ghost.remove(); }, 0);
      }

      // Make file items draggable
      var files = container.querySelectorAll("[data-draggable-file]");
      files.forEach(function(el) {
        el.setAttribute("draggable", "true");

        el.removeEventListener("dragstart", el._dragstart);
        el._dragstart = function(e) {
          e.dataTransfer.setData("text/plain", el.dataset.draggableFile);
          e.dataTransfer.effectAllowed = "move";
          self._dragOrigin = dragOrigin(el);
          self._internalDrag = true;
          // Batch mode: if the dragged item is part of the current
          // selection, the drag moves the WHOLE selection. Marker type
          // `application/x-pk-batch` tells the drop handler to fire the
          // existing `move_selected_to_folder` event (which iterates
          // `@selected_files` + `@selected_folders` server-side) rather
          // than the single-item move. All selected items get
          // opacity-50 for visual feedback. In a picker the batch is the
          // pick, and the server (`move_selected_to_folder`) moves what it
          // holds as picked.
          if (isSelected(el)) {
            e.dataTransfer.setData("application/x-pk-batch", "1");
            self._draggedBatch = true;
            // The pick holds more than the cards on screen (files picked in
            // other folders): a drop on the node of the folder shown gathers them.
            self._gatherPick = inPicker() &&
              (parseInt(self.el.dataset.pickCount || "0", 10) || 0) > selectedEls().length;
            selectionGhost(e, el);
            setBatchVisuals(true);
          } else {
            el.classList.add("opacity-50");
          }
        };
        el.addEventListener("dragstart", el._dragstart);

        el.removeEventListener("dragend", el._dragend);
        el._dragend = function() {
          self._dragOrigin = null;
          self._gatherPick = false;
          self._internalDrag = false;
          if (self._draggedBatch) {
            setBatchVisuals(false);
            self._draggedBatch = false;
          } else {
            el.classList.remove("opacity-50");
          }
          // Clear any lingering highlight if the drag was cancelled
          // (Esc, dropped outside) while still hovering a target.
          if (self._activeDropTarget) {
            clearHighlight(self._activeDropTarget);
            self._activeDropTarget = null;
          }
        };
        el.addEventListener("dragend", el._dragend);
      });

      // Make folder rows draggable. Same payload shape as files
      // (`text/plain` carries the uuid) but with an extra marker type so
      // drop targets can branch on folder vs file at hover time —
      // dataTransfer values aren't readable on dragover, only types
      // are, so the marker is the only way to make hover-time decisions
      // like "this drop target is the dragged folder itself, suppress
      // the drop indicator." Tracked in `self._draggedFolderUuid` for
      // the dragover self-check below.
      var folders = container.querySelectorAll("[data-draggable-folder]");
      folders.forEach(function(el) {
        el.setAttribute("draggable", "true");

        el.removeEventListener("dragstart", el._folderDragstart);
        el._folderDragstart = function(e) {
          e.dataTransfer.setData("text/plain", el.dataset.draggableFolder);
          e.dataTransfer.setData("application/x-pk-folder", "1");
          e.dataTransfer.effectAllowed = "move";
          self._draggedFolderUuid = el.dataset.draggableFolder;
          self._dragOrigin = dragOrigin(el);
          self._internalDrag = true;
          // Batch mode (same logic as the file dragstart above): if
          // the folder is part of the current selection, the drag
          // represents the whole selection. The folder-marker stays
          // set so self-drop suppression in dragover still works for
          // the source folder; the batch marker takes precedence in
          // the drop handler.
          if (isSelected(el)) {
            e.dataTransfer.setData("application/x-pk-batch", "1");
            self._draggedBatch = true;
            selectionGhost(e, el);
            setBatchVisuals(true);
          } else {
            el.classList.add("opacity-50");
          }
          e.stopPropagation();
        };
        el.addEventListener("dragstart", el._folderDragstart);

        el.removeEventListener("dragend", el._folderDragend);
        el._folderDragend = function() {
          self._draggedFolderUuid = null;
          self._dragOrigin = null;
          self._internalDrag = false;
          if (self._draggedBatch) {
            setBatchVisuals(false);
            self._draggedBatch = false;
          } else {
            el.classList.remove("opacity-50");
          }
          if (self._activeDropTarget) {
            clearHighlight(self._activeDropTarget);
            self._activeDropTarget = null;
          }
        };
        el.addEventListener("dragend", el._folderDragend);
      });

      // Make folder targets droppable (grid, list rows, and sidebar).
      // Accepts both file and folder drags — the `application/x-pk-folder`
      // marker type distinguishes them. Folder-on-self drops are
      // suppressed at hover time so the user doesn't get a "yes you can
      // drop here" indicator on the very folder they're dragging.

      // Single-active-target tracking: nested drop targets (folder card
      // inside the main-area wrapper) need exclusivity — only the
      // innermost should highlight. When a new target lights up, we
      // clear the previous one. stopPropagation alone doesn't suffice
      // because the wrapper can already be highlighted before the
      // cursor enters a child and dragleave timing on the wrapper
      // varies across browsers.
      function clearHighlight(t) {
        if (!t) return;
        if (!t.dataset.dropNoBg) {
          t.classList.remove("bg-primary/10");
          if (t._origBg !== undefined) {
            t.style.backgroundColor = t._origBg;
            t._origBg = undefined;
          }
        }
        t.style.outline = "";
        t.style.outlineOffset = "";
      }

      // When the user picks up a selected item (during select_mode),
      // the drag represents the whole selection — gray out every
      // selected element so it's visually clear what's coming along.
      // Each selected file/folder element carries `data-selected="true"`
      // from heex, so a single querySelectorAll handles all four
      // rendering paths (grid/list × file/folder).
      function setBatchVisuals(active) {
        selectedEls().forEach(function(el) {
          if (active) {
            el.classList.add("opacity-50");
          } else {
            el.classList.remove("opacity-50");
          }
        });
      }

      // Files dragged in from the computer, not a card of this page.
      function fromComputer(e) {
        return !self._internalDrag && e.dataTransfer &&
          Array.prototype.indexOf.call(e.dataTransfer.types || [], "Files") !== -1;
      }

      var dropTargets = document.querySelectorAll("[data-drop-folder]");
      dropTargets.forEach(function(target) {
        target.removeEventListener("dragover", target._dragover);
        target._dragover = function(e) {
          // Files from the computer are an upload, not a move: only the zone
          // of the folder being shown (`data-drop-upload`) takes them —
          // outlined a little outside the cards, dashed — and the drop
          // carries on up to FolderDropUpload, which uploads them. Folder
          // cards and the sidebar stay dark so the outline is where they go.
          if (fromComputer(e)) {
            if (target.dataset.dropUpload !== "true") return;
            e.preventDefault();
            e.dataTransfer.dropEffect = "copy";
            if (self._activeDropTarget && self._activeDropTarget !== target) {
              clearHighlight(self._activeDropTarget);
            }
            self._activeDropTarget = target;
            target.style.outline = "2px dashed var(--color-primary)";
            target.style.outlineOffset = "6px";
            return;
          }
          // Text or a link dragged in from elsewhere is no card of this page:
          // not accepted, so it is not dropped here either.
          if (!self._internalDrag) return;
          var isFolder = e.dataTransfer.types.indexOf("application/x-pk-folder") !== -1;
          if (isFolder && target.dataset.dropFolder === self._draggedFolderUuid) {
            // Drop-on-self for a folder — skip preventDefault so the
            // browser shows the "no-drop" cursor and we don't paint the
            // accept indicator. Drop-on-descendant still slips through
            // (we can't detect descendancy in JS without the tree); the
            // server rejects it with `{:error, :cycle}`.
            return;
          }
          // The folder the dragged card is already in (see `originOf`):
          // no accept indicator, no drop.
          if (declines(target)) {
            if (self._activeDropTarget === target) {
              clearHighlight(target);
              self._activeDropTarget = null;
            }
            return;
          }
          e.preventDefault();
          e.stopPropagation();
          e.dataTransfer.dropEffect = "move";

          // Exclusivity: if a different target was lit, clear it before
          // we paint the new one. Then mark this target as active so
          // dragleave / drop know whether to release the tracker.
          if (self._activeDropTarget && self._activeDropTarget !== target) {
            clearHighlight(self._activeDropTarget);
          }
          self._activeDropTarget = target;

          // Grid/list folder cards carry an inline
          // `style="background-color: ..."` from `folder_bg_style`, which
          // beats any class-based bg (inline > class). Stash and clear
          // the inline bg so `bg-primary/10` can take effect, then add
          // the highlight outline inline.
          //
          // CSS `outline` instead of Tailwind's `ring-*`: ring uses
          // `box-shadow`, which `<tr>` elements (list view rows) don't
          // render reliably — outline works on every element type and
          // follows border-radius in modern browsers.
          //
          // `data-drop-no-bg`: opt-out for large drop surfaces (the
          // main content-area target) where a 10% primary tint over a
          // huge area is overwhelming. Outline-only there.
          if (!target.dataset.dropNoBg) {
            if (target._origBg === undefined) {
              target._origBg = target.style.backgroundColor;
            }
            target.style.backgroundColor = "";
            target.classList.add("bg-primary/10");
          }
          // Outline colour: a target may carry `data-drop-color` (a folder's
          // own colour) so the accept indicator matches the folder instead of
          // a generic blue; otherwise fall back to the primary. daisyUI 5
          // exposes the primary as a complete oklch() value in
          // `--color-primary` (not the legacy `--p` raw components), so we use
          // it directly without wrapping it in oklch().
          // `outlineOffset: -2px` insets the outline so the table's
          // `overflow-x-auto` wrapper can't clip the left/right edges
          // of list-view rows. Visually it looks like a "highlighted
          // row" instead of an outline that sticks out — same effect.
          target.style.outline = "2px solid " + (target.dataset.dropColor || "var(--color-primary)");
          target.style.outlineOffset = "-2px";
        };
        target.addEventListener("dragover", target._dragover);

        target.removeEventListener("dragleave", target._dragleave);
        target._dragleave = function() {
          clearHighlight(target);
          if (self._activeDropTarget === target) {
            self._activeDropTarget = null;
          }
        };
        target.addEventListener("dragleave", target._dragleave);

        target.removeEventListener("drop", target._drop);
        target._drop = function(e) {
          if (fromComputer(e)) {
            // Left for FolderDropUpload, further up, to upload.
            clearHighlight(target);
            if (self._activeDropTarget === target) self._activeDropTarget = null;
            return;
          }
          // Not one of this page's cards (text, a link): nothing to move.
          if (!self._internalDrag) return;
          e.preventDefault();
          e.stopPropagation();
          clearHighlight(target);
          if (self._activeDropTarget === target) {
            self._activeDropTarget = null;
          }
          var draggedUuid = e.dataTransfer.getData("text/plain");
          var dropFolderUuid = target.dataset.dropFolder;
          if (!draggedUuid || !dropFolderUuid) return;
          // Let go over the folder it came from: nothing moves, so nothing
          // is asked of the server (LiveView's page-wide dragover lets the
          // drop happen even though this zone declined it).
          if (declines(target)) return;

          var isFolder = e.dataTransfer.types.indexOf("application/x-pk-folder") !== -1;
          var isBatch = e.dataTransfer.types.indexOf("application/x-pk-batch") !== -1;
          var resolvedTarget = dropFolderUuid === "root" ? "" : dropFolderUuid;

          if (isBatch) {
            // Drag started on a selected item — move the whole
            // selection. `move_selected_to_folder` is the existing bulk
            // handler used by the move modal; it reads
            // `@selected_files` + `@selected_folders` from socket state
            // and clears them + resets select_mode after. Drag-on-self
            // for a folder in the batch is handled server-side (the
            // bulk handler skips moving a folder onto itself).
            // The same key the move dialog sends (`phx-value-folder-uuid`).
            // A picker's pick has its own event: the move dialog's
            // `move_selected_to_folder` works on what the dialog was opened for.
            self.pushEventTo(self.el, inPicker() ? "move_picked_to_folder" : "move_selected_to_folder", {
              "folder-uuid": resolvedTarget
            });
          } else if (isFolder) {
            if (draggedUuid === dropFolderUuid) return;
            self.pushEventTo(self.el, "move_folder_to_folder", {
              folder_uuid: draggedUuid,
              target_uuid: resolvedTarget
            });
          } else {
            self.pushEventTo(self.el, "move_file_to_folder", {
              file_uuid: draggedUuid,
              folder_uuid: resolvedTarget
            });
          }
        };
        target.addEventListener("drop", target._drop);
      });

      // Trash drop target — any element carrying `data-drop-trash`, looked
      // up across the document rather than inside this hook's element, so a
      // consumer can put the target in a page header. Mirrors the folder drop
      // wiring above but pushes `trash_file` / `trash_folder`, and uses
      // error-colored hover feedback so the destructive action reads as
      // different from a folder move at a glance.
      //
      // Files, folders and batches are all accepted. (This comment used to say
      // folders were refused; V119 added recursive folder trash and the
      // comment was left behind, which cost a consumer an afternoon of
      // believing it.)
      var trashTargets = document.querySelectorAll("[data-drop-trash]");
      trashTargets.forEach(function(target) {
        target.removeEventListener("dragover", target._trashDragover);
        target._trashDragover = function(e) {
          // Folders + batches are now valid drop targets — V119 added
          // recursive folder trash, and batches route to
          // `delete_selected` which handles trash vs permanent per
          // `@filter_trash`.
          e.preventDefault();
          e.dataTransfer.dropEffect = "move";
          target.classList.add("ring-2", "ring-error", "bg-error/10");
        };
        target.addEventListener("dragover", target._trashDragover);

        target.removeEventListener("dragleave", target._trashDragleave);
        target._trashDragleave = function() {
          target.classList.remove("ring-2", "ring-error", "bg-error/10");
        };
        target.addEventListener("dragleave", target._trashDragleave);

        target.removeEventListener("drop", target._trashDrop);
        target._trashDrop = function(e) {
          e.preventDefault();
          e.stopPropagation();
          target.classList.remove("ring-2", "ring-error", "bg-error/10");
          var draggedUuid = e.dataTransfer.getData("text/plain");
          if (!draggedUuid) return;

          var isFolder = e.dataTransfer.types.indexOf("application/x-pk-folder") !== -1;
          var isBatch = e.dataTransfer.types.indexOf("application/x-pk-batch") !== -1;

          if (isBatch) {
            // Reuses the bulk delete handler — it reads
            // `@selected_files` + `@selected_folders` on the server
            // and trashes (or permanent-deletes in trash view)
            // according to `@filter_trash`.
            self.pushEventTo(self.el, "delete_selected", {});
          } else if (isFolder) {
            self.pushEventTo(self.el, "trash_folder", { folder_uuid: draggedUuid });
          } else {
            self.pushEventTo(self.el, "trash_file", { file_uuid: draggedUuid });
          }
        };
        target.addEventListener("drop", target._trashDrop);
      });
    }
  };

  // ============================================================================
  // MAINTENANCE COUNTDOWN HOOK
  // ============================================================================
  // Powers the "Expected back in Xh Ym Zs" countdown on the maintenance page.
  // Reads the scheduled end time from data-end (ISO 8601), updates #countdown-value
  // every second, and shows the value from data-elapsed-text (translatable) when
  // the countdown reaches zero.

  window.PhoenixKitHooks.MaintenanceCountdown = {
    mounted() {
      this.endTime = new Date(this.el.dataset.end).getTime();
      this.timerEl = this.el.querySelector("#countdown-value");
      this.elapsedText = this.el.dataset.elapsedText || "";
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    },
    tick() {
      var diff = Math.max(0, Math.floor((this.endTime - Date.now()) / 1000));
      if (diff <= 0) {
        clearInterval(this.interval);
        if (this.timerEl) this.timerEl.textContent = this.elapsedText;
        return;
      }
      var h = Math.floor(diff / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;
      var text = "";
      if (h > 0) text += h + "h ";
      if (h > 0 || m > 0) text += m + "m ";
      text += s + "s";
      if (this.timerEl) this.timerEl.textContent = text;
    },
    destroyed() {
      if (this.interval) clearInterval(this.interval);
    }
  };

  // ============================================================================
  // EtcherReset — the browser half of "reset annotation settings"
  // ============================================================================
  //
  // Etcher keeps how-you-work answers (background dots, connector anchors,
  // which tools are on the bar, how much of the style panel is open, the
  // per-tool palettes and colours, the label defaults) in localStorage under
  // its own key: it works with no host involvement at all, and a viewer that
  // does not know who you are cannot do better. The palette and ink the
  // toolbar saves DO live on the user row, and the settings page clears
  // those server-side — this clears the other half, in the same round trip,
  // so a reset is a reset rather than a half-fix.
  //
  // Cleared, not rewritten with defaults: Etcher falls back to its own
  // defaults for anything absent, so removing the key is the honest way to
  // say "no answers of mine". A live viewer on another tab picks them up on
  // its next mount.
  // ----------------------------------------------------------------------------

  window.PhoenixKitHooks.EtcherReset = {
    mounted() {
      this.handleEvent("phoenix_kit:etcher-reset", function() {
        try {
          window.localStorage.removeItem("etcher:prefs");
        } catch (_) {
          // Private mode, storage disabled, a browser that refuses: the
          // server half still happened, and there is nothing here worth
          // interrupting the page for.
        }
      });
    }
  };

  // ============================================================================
  // ViewerSwipe — swipe left/right on a fully zoomed-out picture to step
  // ============================================================================
  //
  // Fresco announces a one-finger swipe across a picture at its fitted view as
  // a bubbling `fresco:swipe` event (zoomed in, the same drag is a pan and is
  // never announced). This sits in the viewer pane and turns it into the same
  // step the side tabs send: swipe left for the next file, right for the
  // previous one. Listening on the pane rather than a Fresco handle means a
  // canvas remount (the eye, the pencil, a new burn) needs nothing re-wired.
  //
  // Not while annotating: with the drawing tools up, a sideways drag is a
  // stroke or a grab, and losing the picture to it would be worse than the
  // swipe not working there.
  // ----------------------------------------------------------------------------

  window.PhoenixKitHooks.ViewerSwipe = {
    mounted() {
      var self = this;
      this._pane = this.el.parentElement;
      this._onSwipe = function(e) {
        var dir = e.detail && e.detail.direction === "left" ? "next" : "prev";
        if (self.el.dataset[dir === "next" ? "hasNext" : "hasPrev"] !== "true") return;
        if (self._pane.querySelector(".etcher-pencil-active")) return;
        // Only an initialized gallery in this viewer owns the swipe. Its
        // library may still be loading, or another browser may have a gallery.
        var modal = self._pane.closest('[phx-hook="ViewerKeydown"]');
        if (modal && modal._pkGallery) return;
        self.pushEventTo(self.el.dataset.target, "step_viewer", { dir: dir });
      };
      if (this._pane) this._pane.addEventListener("fresco:swipe", this._onSwipe);
    },

    destroyed() {
      if (this._pane) this._pane.removeEventListener("fresco:swipe", this._onSwipe);
    }
  };

  // ============================================================================
  // ViewerGallery — the Apple Photos way of stepping through pictures
  // ============================================================================
  //
  // Gallery mode (MediaBrowser `gallery_mode`). A drag, a swipe or a sideways
  // trackpad scroll on a picture at its opening zoom slides the next picture
  // in beside it, already decoded — Fresco.gallery draws the strip over the
  // viewer. Nothing waits on the server: once the strip settles the hook
  // names the new file (`gallery_go`), the viewer patches to it underneath,
  // and the strip hands over as soon as that viewer's picture has painted.
  // The arrow keys and the side tabs slide the same way.
  //
  // Not while annotating (a drag is a stroke there) and not zoomed in (a drag
  // is a pan): the viewer keeps those gestures, exactly as before.
  // ----------------------------------------------------------------------------

  var GALLERY_SETTLE_MS = 250;    // the strip still this long before telling the server
  var GALLERY_HOLD_MAX_MS = 8000; // the viewer never painted: stop covering it
  var GALLERY_SHARP_MAX_MS = 2500; // painted but still blurry: hand over anyway
  var GALLERY_RESEND_MS = 2000;   // no sign of the server following: ask again

  // In gallery mode the viewer is for looking at pictures, so the dot grid
  // stays away until the pencil is on — then the person's own grid setting
  // (Etcher's, which toggles `fresco--no-grid`) decides, as everywhere else.
  // Pure CSS on what is in the modal, so no state to keep in step.
  var GALLERY_SCOPE = '[phx-hook="ViewerKeydown"]:has(> [phx-hook="ViewerGallery"]):not(:has(.etcher-pencil-active)) ';
  // A tap on the picture hides the viewer's controls and the next brings
  // them back, as in Photos. The flag lives on <html>, which LiveView never
  // patches; annotating always shows them (the scope above excludes it).
  var GALLERY_CHROME = ['button[phx-click="close_viewer"]', 'button[phx-click="toggle_viewer_sidebar"]',
    "[phx-value-dir]", ".fresco-nav", ".fresco-zoom"];
  var GALLERY_GRID_CSS =
    GALLERY_SCOPE + ".fresco-viewer { background-image: none !important; }\n" +
    GALLERY_CHROME.map(function(sel) { return GALLERY_SCOPE + sel; }).join(",\n") +
    " { transition: opacity 120ms ease-out; }\n" +
    GALLERY_CHROME.map(function(sel) { return 'html[data-pk-gallery-chrome="hidden"] ' + GALLERY_SCOPE + sel; }).join(",\n") +
    " { opacity: 0 !important; visibility: hidden !important; pointer-events: none !important; }\n" +
    // Under a frozen copy (ViewerGallery `_freezeChrome`) the real controls
    // are rebuilding; they stay out of sight until the copy goes.
    'html[data-pk-chrome-frozen] ' + GALLERY_SCOPE + '.fresco-viewer .fresco-nav, ' +
    'html[data-pk-chrome-frozen] ' + GALLERY_SCOPE + '.fresco-viewer .fresco-zoom { visibility: hidden !important; }';
  var GALLERY_TAP_SLOP = 10;      // px a tap may wander
  var GALLERY_TAP_MS = 350;       // longer is a press, not a tap
  var GALLERY_DOUBLE_TAP_MS = 300; // a second tap this soon is a double-tap (zoom)

  // In now, not at mount: the rules key on markup the server already sent,
  // and a viewer opened from a link otherwise showed the dot grid for the
  // second or more before the socket connected and the hook mounted.
  function ensureGalleryCss() {
    if (document.getElementById("pk-gallery-css")) return;
    var css = document.createElement("style");
    css.id = "pk-gallery-css";
    css.textContent = GALLERY_GRID_CSS;
    (document.head || document.documentElement).appendChild(css);
  }
  ensureGalleryCss();

  var viewerGalleryHook = {
    mounted() {
      var self = this;
      ensureGalleryCss();
      if (!window.Fresco || !window.Fresco.gallery) return;
      self._modal = self.el.parentElement;
      // The strip goes in the ignored layer beside this element: a child the
      // template does not render would be dropped by the next patch.
      var layer = document.getElementById(self.el.id + "-layer") || self._modal;

      function canvasEl() {
        return self._modal && self._modal.querySelector('[phx-hook="FrescoCanvas"]');
      }
      function handle() {
        var c = canvasEl();
        return c && window.Fresco.viewerFor(c.id);
      }
      function canvasImg(c) {
        return c && c.querySelector("img[data-fresco-canvas-img]");
      }
      // The pane colour behind the picture, so the strip's gaps match it.
      function background() {
        var n = canvasEl();
        while (n && n !== document.body) {
          var bg = window.getComputedStyle(n).backgroundColor;
          if (bg && bg !== "transparent" && !/rgba\(.*,\s*0\)$/.test(bg)) return bg;
          n = n.parentElement;
        }
        return "#000";
      }
      // Where the viewer has its picture on screen, unturned.
      function currentRect() {
        var img = canvasImg(canvasEl());
        var h = handle();
        if (!img) return null;
        var r = img.getBoundingClientRect();
        var rot = h && h.getRotation ? ((((h.getRotation() || 0) % 360) + 360) % 360) : 0;
        var quarter = rot === 90 || rot === 270;
        return {
          cx: r.left + r.width / 2, cy: r.top + r.height / 2,
          w: quarter ? r.height : r.width, h: quarter ? r.width : r.height,
          rotation: rot
        };
      }

      self._gallery = window.Fresco.gallery({
        container: layer,
        getRect: function() { var c = canvasEl(); return c ? c.getBoundingClientRect() : null; },
        getTarget: canvasEl,
        background: background,
        canStart: function() {
          if (self._modal.querySelector(".etcher-pencil-active, .etcher-actionbar.is-active")) return false;
          var h = handle();
          return !h || !h.isAtHome || h.isAtHome();
        },
        getCurrentRect: currentRect,
        // The strip is drawn over the whole viewer, controls and all; still
        // copies of the controls ride above it (see `_freezeChrome`).
        onShow: function() { self._freezeChrome(); },
        onHide: function() { self._thawChrome(); },
        onChange: function(_i, item) {
          // Only once the strip has been still a moment: the viewer's
          // re-render (Fresco, Etcher, Tessera mounting) is heavy main-thread
          // work, and landing in the middle of the next swipe it stuttered.
          // The strip keeps showing the picture meanwhile, so nothing waits.
          clearTimeout(self._goTimer);
          var go = function() {
            var g = self._gallery;
            if (!g || !item || !item.key || g.currentKey() !== item.key) return;
            if (g.isBusy()) { self._goTimer = setTimeout(go, GALLERY_SETTLE_MS); return; }
            self.pushEventTo(self.el, "gallery_go", { uuid: item.key });
          };
          self._goTimer = setTimeout(go, GALLERY_SETTLE_MS);
          self._watchFor(item);
        }
      });
      self._modal._pkGallery = self._gallery;

      // Hand over once the viewer shows `key` as sharply as the strip does:
      // its canvas (the file uuid is in its id) mounted, and a picture loaded
      // with the pixels its size on screen needs. The viewer opens on the
      // small copy and climbs; handing over to that small copy read as the
      // picture snapping blurry the moment the slide finished.
      self._watchFor = function(item) {
        clearInterval(self._watch);
        var key = item && item.key;
        if (!key) return;
        var started = Date.now(), seen = 0, resent = started;
        self._watch = setInterval(function() {
          var g = self._gallery;
          if (!g || !g.isShown() || g.currentKey() !== key) { clearInterval(self._watch); return; }
          var t = Date.now();
          // Mid-gesture nothing is handed over or re-sent; the clock waits.
          if (g.isBusy()) { started = resent = t; seen = seen && t; return; }
          // Videos, PDFs and file cards have no Fresco canvas to wait for.
          // Once LiveView follows, expose their actual player or preview.
          if (item.kind !== "image" && self.el.dataset.current === key) {
            clearInterval(self._watch);
            g.hide();
            return;
          }
          var c = canvasEl();
          if (!c || c.id.indexOf(key) === -1) {
            // The server has not followed (a dropped event): ask again.
            if (t - resent > GALLERY_RESEND_MS) {
              resent = t;
              self.pushEventTo(self.el, "gallery_go", { uuid: key });
            }
            if (t - started > GALLERY_HOLD_MAX_MS) { clearInterval(self._watch); g.hide(); }
            return;
          }
          if (!seen) seen = t;
          var sharpest = 0;
          c.querySelectorAll("img[data-fresco-canvas-img]").forEach(function(im) {
            if (im.complete && im.naturalWidth > sharpest) sharpest = im.naturalWidth;
          });
          if (!sharpest) {
            if (t - seen > GALLERY_HOLD_MAX_MS) { clearInterval(self._watch); g.hide(); }
            return;
          }
          var r = currentRect();
          var need = r ? r.w * (window.devicePixelRatio || 1) : 0;
          if (item.width) need = Math.min(need, item.width);
          if (sharpest < need * 0.7 && t - seen < GALLERY_SHARP_MAX_MS) return;
          clearInterval(self._watch);
          // A frame for the viewer to lay it out, then glide onto it.
          requestAnimationFrame(function() {
            if (self._gallery !== g || !g.isShown() || g.currentKey() !== key) return;
            if (!g.release(key, currentRect())) self._watchFor(item);
          });
        }, 50);
      };

      self._load = function() {
        var data;
        try { data = JSON.parse(self.el.dataset.gallery || "{}"); } catch (_e) { data = {}; }
        self._gallery.setItems(data.items || [], data.index || 0);
      };
      self._load();

      // Arrow keys and the side tabs: the same slide. Captured on window so
      // the viewer's own step (ViewerKeydown, the tab's phx-click) does not
      // also run; when the strip cannot slide they pass through untouched.
      self._onKey = function(e) {
        if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
        if ((document.querySelector && document.querySelector("[data-removal-state]"))) return;
        if (e.metaKey || e.ctrlKey || e.altKey) return;
        var t = document.activeElement;
        if (t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable === true)) return;
        if (!self._gallery.isShown() && !self.galleryAllowed()) return;
        if (self._gallery.step(e.key === "ArrowLeft" ? -1 : 1)) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      };
      self._onTab = function(e) {
        var btn = e.target && e.target.closest && e.target.closest('[phx-click="step_viewer"]');
        if (!btn || !self._modal.contains(btn)) return;
        if (!self._gallery.isShown() && !self.galleryAllowed()) return;
        var dir = btn.getAttribute("phx-value-dir") === "prev" ? -1 : 1;
        if (self._gallery.step(dir)) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      };
      // Tap to hide / show the controls, at once either way so the tap
      // feels answered. A double-tap's second tap does not toggle back —
      // it just zooms, leaving the controls as the first tap set them.
      self._onTapDown = function(e) {
        var c = canvasEl();
        self._tap = null;
        if (!e.isPrimary || (e.pointerType === "mouse" && e.button !== 0)) return;
        if (!c || !c.contains(e.target) || !self.galleryAllowed()) return;
        if (e.target.closest && e.target.closest("button, a, input, .fresco-nav, .fresco-zoom")) return;
        self._tap = { x: e.clientX, y: e.clientY, t: Date.now(), id: e.pointerId };
      };
      self._onTapUp = function(e) {
        var tp = self._tap;
        self._tap = null;
        if (!tp || e.pointerId !== tp.id) return;
        if (Math.abs(e.clientX - tp.x) > GALLERY_TAP_SLOP || Math.abs(e.clientY - tp.y) > GALLERY_TAP_SLOP) return;
        if (Date.now() - tp.t > GALLERY_TAP_MS) return;
        if (self._tapTimer) { clearTimeout(self._tapTimer); self._tapTimer = null; return; } // the double-tap's second
        var root = document.documentElement;
        if (root.getAttribute("data-pk-gallery-chrome") === "hidden") root.removeAttribute("data-pk-gallery-chrome");
        else { root.setAttribute("data-pk-gallery-chrome", "hidden"); self._dropFrozenChrome(); }
        self._tapTimer = setTimeout(function() { self._tapTimer = null; }, GALLERY_DOUBLE_TAP_MS);
      };
      document.addEventListener("pointerdown", self._onTapDown, true);
      document.addEventListener("pointerup", self._onTapUp, true);

      self.galleryAllowed = function() {
        return !self._modal.querySelector(".etcher-pencil-active, .etcher-actionbar.is-active");
      };
      window.addEventListener("keydown", self._onKey, true);
      window.addEventListener("click", self._onTab, true);
    },

    updated() {
      if (this._load) this._load();
    },

    // The controls stay put while the picture under them changes, as in
    // Photos. The strip is drawn above the whole viewer while it runs —
    // over the toolbar, the zoom pill, the side tabs — and the next file's
    // canvas then builds a new toolbar of its own (briefly a different one:
    // the whole row before its overflow folds, the zoom pill empty). Both
    // read as the controls vanishing for a second and coming back. So from
    // the moment the strip shows, still copies of the controls sit above
    // it, exactly where the real ones are; they go once the strip has gone
    // and the new canvas's controls have settled underneath. A press goes
    // through them (and through the strip) to the real controls.
    _freezeChrome() {
      if (this._frozen) { this._frozen.thawing = false; return; }
      var modal = this._modal;
      var layer = document.getElementById(this.el.id + "-layer");
      if (!modal || !layer) return;
      if (document.documentElement.getAttribute("data-pk-gallery-chrome") === "hidden") return;
      var canvas = modal.querySelector('[phx-hook="FrescoCanvas"]');
      var picks = [];
      if (canvas) {
        picks = picks.concat(Array.prototype.slice.call(
          canvas.querySelectorAll(".fresco-nav:not(.fresco-nav-overflow), .fresco-zoom")));
      }
      picks = picks.concat(Array.prototype.slice.call(modal.querySelectorAll(
        'button[phx-click="close_viewer"], button[phx-click="toggle_viewer_sidebar"], button[phx-value-dir]')));
      var vars = canvas ? window.getComputedStyle(canvas) : null;
      var copies = [];
      picks.forEach(function(el) {
        if (!el.offsetParent) return;
        var r = el.getBoundingClientRect();
        if (!(r.width > 0 && r.height > 0)) return;
        var copy = el.cloneNode(true);
        [copy].concat(Array.prototype.slice.call(copy.querySelectorAll("*"))).forEach(function(n) {
          Array.prototype.slice.call(n.attributes).forEach(function(at) {
            if (at.name === "id" || at.name.indexOf("phx-") === 0) n.removeAttribute(at.name);
          });
        });
        if (vars && canvas.contains(el)) {
          for (var k = 0; k < vars.length; k++) {
            if (vars[k].indexOf("--") === 0) copy.style.setProperty(vars[k], vars.getPropertyValue(vars[k]));
          }
        }
        var st = copy.style;
        st.position = "fixed";
        st.left = r.left + "px"; st.top = r.top + "px";
        st.right = "auto"; st.bottom = "auto";
        st.width = r.width + "px"; st.height = r.height + "px";
        st.margin = "0"; st.transform = "none"; st.translate = "none";
        st.maxWidth = "none"; st.maxHeight = "none";
        st.zIndex = "1002";
        st.pointerEvents = "none";
        st.transition = "none";
        st.opacity = window.getComputedStyle(el).opacity;
        copy.setAttribute("aria-hidden", "true");
        copy.setAttribute("inert", "");
        copy.setAttribute("data-pk-frozen-chrome", "");
        layer.appendChild(copy);
        copies.push(copy);
      });
      if (!copies.length) return;
      this._frozen = { els: copies, thawing: false };
      document.documentElement.setAttribute("data-pk-chrome-frozen", "");
    },

    // The strip has gone: drop the copies once the canvas on screen is the
    // picture the strip ended on and its controls have held still a few
    // frames (or straight away when the swipe went back where it started).
    _thawChrome() {
      var self = this;
      var st = this._frozen;
      if (!st) return;
      st.thawing = true;
      var key = this._gallery && this._gallery.currentKey && this._gallery.currentKey();
      var started = Date.now(), seenAt = 0, lastSig = "", steady = 0;
      var tick = function() {
        if (self._frozen !== st || !st.thawing) return;
        var c = self._modal && self._modal.querySelector('[phx-hook="FrescoCanvas"]');
        var hidden = document.documentElement.getAttribute("data-pk-gallery-chrome") === "hidden";
        var done = hidden || !key || (!c && self.el.dataset.current === key) || Date.now() - started > 5000;
        if (!done && c && c.id.indexOf(key) !== -1) {
          var nav = c.querySelector(".fresco-nav:not(.fresco-nav-overflow)");
          var zoom = c.querySelector(".fresco-zoom");
          var sig = nav ? nav.querySelectorAll("button:not([hidden])").length + "|" +
            (zoom ? zoom.textContent : "") + "|" + Math.round(nav.getBoundingClientRect().width) : "";
          if (sig && (!zoom || zoom.textContent)) {
            if (!seenAt) seenAt = Date.now();
            steady = sig === lastSig ? steady + 1 : 0;
            lastSig = sig;
            done = steady >= 6 && Date.now() - seenAt > 150;
          }
        }
        if (done) self._dropFrozenChrome();
        else requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    },

    _dropFrozenChrome() {
      var st = this._frozen;
      this._frozen = null;
      document.documentElement.removeAttribute("data-pk-chrome-frozen");
      if (st) st.els.forEach(function(el) { if (el.parentNode) el.parentNode.removeChild(el); });
    },

    destroyed() {
      if (this._modal && this._modal._pkGallery === this._gallery) delete this._modal._pkGallery;
      this._dropFrozenChrome();
      clearTimeout(this._goTimer);
      clearInterval(this._watch);
      if (this._onKey) window.removeEventListener("keydown", this._onKey, true);
      if (this._onTab) window.removeEventListener("click", this._onTab, true);
      if (this._onTapDown) document.removeEventListener("pointerdown", this._onTapDown, true);
      if (this._onTapUp) document.removeEventListener("pointerup", this._onTapUp, true);
      clearTimeout(this._tapTimer);
      // The next viewer opens with its controls.
      document.documentElement.removeAttribute("data-pk-gallery-chrome");
      if (this._gallery) this._gallery.destroy();
      this._gallery = null;
    }
  };
  window.PhoenixKitHooks.ViewerGallery = lazyHook(pkLoaders.fresco, function() {
    return viewerGalleryHook;
  });

  // ============================================================================
  // ViewerHiresLoading — "Loading full quality…" while a sharper picture arrives
  // ============================================================================
  //
  // The media viewer opens on the small bitmap the grid already painted, and
  // Tessera climbs to a bigger rung once the screen asks for one. On a slow
  // line that climb can take a long time, and nothing said it was happening:
  // people sat looking at a blurry photograph wondering whether that was all
  // there was.
  //
  // Fresco swaps a rung by setting the visible <img>'s src, and the browser
  // keeps painting the old bitmap until the new one has loaded — so "a
  // sharper picture is on its way" is exactly "the canvas image's src is not
  // complete yet", and its load (or error) is "done". This watches the pane's
  // canvas image for that and shows the pill the template renders; nothing
  // in Fresco or Tessera has to know. A canvas remount (the eye, the pencil,
  // a new burn) brings a new <img>, which the observer picks up too.
  //
  // HIRES_SHOW_DELAY_MS keeps a load that finishes quickly — a cache hit, a
  // fast line — from flashing the pill for a frame.
  // ----------------------------------------------------------------------------

  var HIRES_SHOW_DELAY_MS = 300;

  window.PhoenixKitHooks.ViewerHiresLoading = {
    mounted() {
      var self = this;
      this._pane = this.el.parentElement;
      this._img = null;
      this._timer = null;
      this._onSettle = function() { self._track(); };
      this._observer = new MutationObserver(function() { self._track(); });
      if (this._pane) {
        this._observer.observe(this._pane, {
          subtree: true, childList: true, attributes: true, attributeFilter: ["src"]
        });
      }
      this._track();
    },

    destroyed() {
      if (this._observer) this._observer.disconnect();
      this._watch(null);
      clearTimeout(this._timer);
    },

    _track() {
      var img = this._pane && this._pane.querySelector("img[data-fresco-canvas-img]");
      if (img !== this._img) this._watch(img);
      this._set(!!img && !!img.getAttribute("src") && !img.complete);
    },

    _watch(img) {
      if (this._img) {
        this._img.removeEventListener("load", this._onSettle);
        this._img.removeEventListener("error", this._onSettle);
      }
      this._img = img || null;
      if (img) {
        img.addEventListener("load", this._onSettle);
        img.addEventListener("error", this._onSettle);
      }
    },

    _set(loading) {
      var self = this;
      if (loading) {
        if (this.el.dataset.state === "loading" || this._timer) return;
        this._timer = setTimeout(function() {
          self._timer = null;
          if (self._img && !self._img.complete) self._show(true);
        }, HIRES_SHOW_DELAY_MS);
      } else {
        clearTimeout(this._timer);
        this._timer = null;
        this._show(false);
      }
    },

    _show(on) {
      this.el.dataset.state = on ? "loading" : "idle";
      this.el.setAttribute("aria-hidden", on ? "false" : "true");
      if (this.el.style) this.el.style.opacity = on ? "1" : "0";
    }
  };

  // ============================================================================
  // ResumableUpload — keep picked files until the host has them, and carry on
  // ============================================================================
  //
  // A phone or tablet sends the browser to the background while a camera app
  // has the screen; the LiveView socket drops and the page remounts, and a
  // transfer that was under way is gone. Every file picked in a form that
  // carries this hook is copied into IndexedDB the moment it is chosen,
  // together with an opaque `context` the host reads at that moment (where the
  // file belongs). After a reconnect or a remount the hook offers whatever is
  // left to the server (`pk_upload_resume`), which decides per file: carry on
  // by itself (`auto`), wait for a free slot (`queued`), ask the person
  // (`ask`) or forget it (`drop`). Files to carry on are handed to the form's
  // upload through the hook's own `this.upload`.
  //
  // A record has two phases: `pending` (the server has not got all the bytes)
  // and `received` (it has; the host has not said it saved the file). It is
  // deleted only on `pk-upload-stored` or `pk-upload-rejected`, so the
  // delivery is "at least once": a file may arrive twice when the connection
  // dies between receipt and the host's answer.
  //
  // Who may carry a record on: exactly one live owner. A record is owned while
  // a Web Lock `pk-upload:<id>` is held by the page that is transferring it
  // (taken with `ifAvailable`, so the check and the claim are one step; the
  // browser frees it when the page dies, and hidden tabs' timer throttling
  // does not matter). The lock is given up on `disconnected()` — the hook
  // outlives a dropped socket, but its transfers do not — and on `destroyed()`.
  // Browsers without Web Locks fall back to a lease: the owner writes its
  // instance id and `touched` every UPLOAD_STASH_HEARTBEAT_MS, and a record
  // untouched for UPLOAD_STASH_LEASE_MS has no owner.
  //
  // Records belong to a `scope` (host-chosen, required — never the URL: a
  // sticky LiveView lives on many pages), an upload name and a user. Another
  // user's records are never shown or sent, and are removed when a hook
  // mounts under a different user and when the `data-pk-logout` control is
  // used; every record is dropped after 24 hours.
  // ----------------------------------------------------------------------------

  var UPLOAD_STASH_DB = "phoenix_kit_resumable_uploads";
  var UPLOAD_STASH_OLD_DB = "phoenix_kit_upload_stash";
  var UPLOAD_STASH_STORE = "files";
  var UPLOAD_STASH_MAX_BYTES = 250 * 1000 * 1000;
  var UPLOAD_STASH_HEARTBEAT_MS = 5000;
  var UPLOAD_STASH_LEASE_MS = 15000;
  var UPLOAD_STASH_KEEP_MS = 24 * 3600 * 1000;
  var UPLOAD_STASH_FRESH_MS = 30 * 60 * 1000;
  var UPLOAD_STASH_SCAN_MS = 250;
  var UPLOAD_STASH_SAFETY_MS = [3000, 15000];
  var UPLOAD_STASH_INPUT_WAIT_MS = 500;
  var UPLOAD_STASH_INPUT_TRIES = 10;
  var UPLOAD_STASH_LOGOUT_WAIT_MS = 500;

  // The same three things the server's `client_key` reads off an upload entry
  // — LiveView sends the File's own name, size and lastModified.
  function uploadStashKey(file) {
    return file.name + "|" + file.size + "|" + file.lastModified;
  }

  function uploadStashRecordId(scope, upload, key, seq) {
    return [scope, upload, key, seq].join("\u0000");
  }

  function uploadStashOpen() {
    return new Promise(function(resolve) {
      try {
        if (!window.indexedDB) return resolve(null);
        var req = window.indexedDB.open(UPLOAD_STASH_DB, 1);
        req.onupgradeneeded = function() {
          req.result.createObjectStore(UPLOAD_STASH_STORE, { keyPath: "id" });
        };
        req.onsuccess = function() { resolve(req.result); };
        req.onerror = function() { resolve(null); };
        req.onblocked = function() { resolve(null); };
      } catch (_) {
        resolve(null);
      }
    });
  }

  // One transaction; `fn(store)` does the work. Never rejects — the stash is a
  // safety net, and a browser refusing storage must not break uploads. Resolves
  // `{ok, result}`.
  function uploadStashRun(mode, fn) {
    return uploadStashOpen().then(function(db) {
      if (!db) return { ok: false, result: null };
      return new Promise(function(resolve) {
        try {
          var tx = db.transaction(UPLOAD_STASH_STORE, mode);
          var out = fn(tx.objectStore(UPLOAD_STASH_STORE));
          tx.oncomplete = function() { db.close(); resolve({ ok: true, result: out && out.result !== undefined ? out.result : out }); };
          tx.onerror = tx.onabort = function() { db.close(); resolve({ ok: false, result: null }); };
        } catch (_) {
          db.close();
          resolve({ ok: false, result: null });
        }
      });
    });
  }

  function uploadStashAll() {
    return uploadStashRun("readonly", function(store) { return store.getAll(); })
      .then(function(r) { return r.result || []; });
  }

  // Resolves true when the record was written.
  function uploadStashPut(record) {
    return uploadStashRun("readwrite", function(store) { store.put(record); }).then(function(r) { return r.ok; });
  }

  function uploadStashDelete(ids) {
    if (!ids.length) return Promise.resolve(true);
    return uploadStashRun("readwrite", function(store) {
      ids.forEach(function(id) { store.delete(id); });
    }).then(function(r) { return r.ok; });
  }

  // Read-modify-write of existing records in one transaction.
  function uploadStashUpdate(ids, change) {
    if (!ids.length) return Promise.resolve(true);
    return uploadStashRun("readwrite", function(store) {
      ids.forEach(function(id) {
        var req = store.get(id);
        req.onsuccess = function() {
          if (req.result) { change(req.result); store.put(req.result); }
        };
      });
    }).then(function(r) { return r.ok; });
  }

  function uploadStashClear() {
    return uploadStashRun("readwrite", function(store) { store.clear(); }).then(function(r) { return r.ok; });
  }

  // The records of one user (a multi-session stack keeps the others').
  function uploadStashClearUser(user) {
    return uploadStashAll().then(function(rows) {
      return uploadStashDelete(rows.filter(function(row) { return row.user === user; }).map(function(row) { return row.id; }));
    });
  }

  // Records written by the first version of this stash live in a database of
  // their own and are never read again.
  function uploadStashDropOldDatabase() {
    try { if (window.indexedDB) window.indexedDB.deleteDatabase(UPLOAD_STASH_OLD_DB); } catch (_) {}
  }

  function uploadStashLocks() {
    try {
      var locks = window.navigator && window.navigator.locks;
      return locks && typeof locks.request === "function" ? locks : null;
    } catch (_) {
      return null;
    }
  }

  // Is `row` free to be taken by `inst` under the lease (no Web Locks)?
  function uploadStashLeaseFree(row, inst, now) {
    return !row.owner || row.owner === inst || now - row.touched > UPLOAD_STASH_LEASE_MS;
  }

  // What the server is told about a record.
  function uploadStashItem(row, now, freshMs) {
    return {
      id: row.id, key: row.key, seq: row.seq, name: row.name, size: row.size,
      context: row.context, has_bytes: !!row.blob, state: row.state,
      attempts: row.attempts || 0, fresh: freshMs > 0 && now - row.touched <= freshMs
    };
  }

  window.PhoenixKitHooks.ResumableUpload = {
    mounted() {
      var self = this;
      this._inst = Math.random().toString(36).slice(2) + Date.now().toString(36);
      this._upload = this.el.dataset.upload || "";
      this._scope = this.el.dataset.scope || "";
      this._user = this.el.dataset.user || "";
      this._held = {};        // id -> function that gives the Web Lock up
      this._inflight = {};    // id -> true: this instance is transferring it
      this._waiting = {};     // id -> true: claimed, waiting for a slot or a click
      this._done = {};        // id -> true: received on this connection; the host will answer
      this._chain = Promise.resolve();  // received/stored/rejected are handled one at a time, in order
      this._queued = false;
      this._seen = typeof WeakSet === "function" ? new WeakSet() : null;
      this._scanning = false;
      this._rescan = false;
      this._up = true;        // the LiveView is connected (mounted means joined)
      this._safetyTimers = [];
      this._persisted = false;
      this._off = false;      // the server has no handlers for this upload: stay silent
      this._warned = false;
      this._root = this.el.dataset.watch === "parent" ? (this.el.parentElement || document.body) : this.el;

      // Capture phase on the watched root: runs before LiveView's own listener
      // on the input reads (and the drop hook replaces) the files.
      this._onPick = function(e) {
        var input = e.target;
        if (!input || input.tagName !== "INPUT" || input.type !== "file") return;
        if (!input.hasAttribute("data-phx-upload-ref")) return;
        if (input.name !== self._upload) return;
        if (!input.files || !input.files.length) return;
        self._warnForm(input);
        self._debug("pick", input.files.length);
        self._stash(Array.prototype.slice.call(input.files));
      };
      this._root.addEventListener("input", this._onPick, true);
      this._root.addEventListener("change", this._onPick, true);

      this._beat = setInterval(function() { self._heartbeat(); }, UPLOAD_STASH_HEARTBEAT_MS);

      this.handleEvent("pk-upload-received", function(p) { self._ours(p) && self._received(p.key); });
      this.handleEvent("pk-upload-stored", function(p) { self._ours(p) && self._finish(p.key, true); });
      this.handleEvent("pk-upload-rejected", function(p) { self._ours(p) && self._finish(p.key, false); });
      this.handleEvent("pk-upload-feed", function(p) { self._ours(p) && self._feedIds(p.ids || []); });
      this.handleEvent("pk-upload-drop", function(p) { self._ours(p) && self._dropIds(p.ids || []); });

      uploadStashDropOldDatabase();
      this._scanTimer = setTimeout(function() { self._scan(); }, UPLOAD_STASH_SCAN_MS);
      this._safety();
    },

    // The hook outlives a dropped socket; its transfers do not. Whatever was
    // in flight is a leftover now, and the locks that said otherwise go.
    disconnected() {
      this._up = false;
      this._clearSafety();
      this._releaseAll();
      this._inflight = {};
      this._waiting = {};
      this._done = {};
      this._queued = false;
    },

    // The form recovery LiveView does on rejoin has finished by now (it clears
    // the file input); the stash, not the input, is the source of truth.
    reconnected() {
      // Whatever was picked while the socket was down never left the browser
      // either: it is in flight no longer than the rest.
      this.disconnected();
      this._up = true;
      this._scan();
      this._safety();
    },

    destroyed() {
      clearInterval(this._beat);
      clearTimeout(this._scanTimer);
      this._clearSafety();
      if (this._root) {
        this._root.removeEventListener("input", this._onPick, true);
        this._root.removeEventListener("change", this._onPick, true);
      }
      var owned = Object.keys(this._inflight).concat(Object.keys(this._waiting));
      this._releaseAll();
      // Lease mode: say the records are free instead of making the next
      // instance wait for the lease to run out.
      if (!uploadStashLocks() && owned.length) {
        uploadStashUpdate(owned, function(row) { row.touched = 0; });
      }
    },

    _ours(payload) { return payload && payload.upload === this._upload; },

    _freshMs() {
      var ms = parseInt(this.el.dataset.freshMs, 10);
      return isNaN(ms) || ms < 0 ? UPLOAD_STASH_FRESH_MS : ms;
    },

    // The server only hears about files LiveView's own change event will carry
    // — a form without an id or `phx-change` loses them in form recovery.
    _warnForm(input) {
      if (this._warned) return;
      var form = input.form || (input.closest && input.closest("form"));
      if (!form || !form.id || !form.hasAttribute("phx-change")) {
        this._warned = true;
        if (typeof console !== "undefined") {
          console.warn("ResumableUpload: the form around the upload input needs an id and phx-change");
        }
      }
    },

    // ── ownership ───────────────────────────────────────────────────────────

    // Take a record, or find out that someone else has it. Resolves true when
    // this instance may carry it on.
    _claim(row) {
      var self = this;
      if (this._held[row.id]) return Promise.resolve(true);
      var locks = uploadStashLocks();
      if (!locks) {
        if (!uploadStashLeaseFree(row, this._inst, Date.now())) return Promise.resolve(false);
        this._held[row.id] = function() {};
        return uploadStashUpdate([row.id], function(r) { r.owner = self._inst; r.touched = Date.now(); })
          .then(function() { return true; });
      }
      return new Promise(function(resolve) {
        try {
          locks.request("pk-upload:" + row.id, { ifAvailable: true }, function(lock) {
            if (!lock) { resolve(false); return undefined; }
            return new Promise(function(release) {
              self._held[row.id] = release;
              resolve(true);
            });
          }).catch(function() { resolve(false); });
        } catch (_) {
          resolve(false);
        }
      });
    },

    _release(id) {
      var release = this._held[id];
      delete this._held[id];
      if (release) release();
    },

    _releaseAll() {
      var self = this;
      Object.keys(this._held).forEach(function(id) { self._release(id); });
    },

    // Only the lease needs it: a Web Lock says the owner is alive by itself,
    // and rewriting a record rewrites its Blob.
    _heartbeat() {
      if (uploadStashLocks()) return;
      var ids = Object.keys(this._inflight);
      if (!ids.length) return;
      var now = Date.now();
      var inst = this._inst;
      uploadStashUpdate(ids, function(row) { row.touched = now; row.owner = inst; });
    },

    // ── picking ─────────────────────────────────────────────────────────────

    _stash(files) {
      var self = this;
      var now = Date.now();
      var context = this.el.dataset.context || "";
      var fresh = files.filter(function(file) {
        if (!self._seen) return true;
        if (self._seen.has(file)) return false;
        self._seen.add(file);
        return true;
      });
      if (!fresh.length) return;

      var records = fresh.map(function(file, i) {
        var seq = now.toString(36) + "-" + i + "-" + Math.random().toString(36).slice(2, 8);
        var key = uploadStashKey(file);
        return {
          id: uploadStashRecordId(self._scope, self._upload, key, seq),
          scope: self._scope, upload: self._upload, user: self._user,
          key: key, seq: seq, name: file.name, type: file.type, size: file.size,
          lastModified: file.lastModified,
          blob: file.size <= UPLOAD_STASH_MAX_BYTES ? file : null,
          context: context, state: "pending", attempts: 0, touched: now, owner: self._inst
        };
      });

      records.forEach(function(row) {
        self._inflight[row.id] = true;
        self._claim(row);
      });
      this._persist();

      Promise.all(records.map(function(row) {
        return uploadStashPut(row).then(function(ok) {
          // Over quota: keep the record, not the bytes ("choose it again").
          if (ok || !row.blob) return;
          row.blob = null;
          return uploadStashPut(row);
        });
      })).then(function() {
        // A tablet delivers the camera's file as the tab wakes, around the
        // reconnect: a look that ran before this write found nothing, and
        // nothing else would look again.
        self._debug("stashed", records.length);
        if (self._up) self._scan();
      });

      // The server learns where each file belongs before LiveView hands it the
      // file; a send that fails (the socket is going) is covered by the
      // context that `pk_upload_resume` carries.
      if (this._off) return;
      try {
        var sent = this.pushEvent("pk_upload_pick", {
          upload: this._upload,
          items: records.map(function(row) { return { key: row.key, seq: row.seq, context: row.context }; })
        }, function(reply) { if (reply && reply.error) self._off = true; });
        if (sent && typeof sent.catch === "function") sent.catch(function() {});
      } catch (_) {}
    },

    // Looks again a little later while something unsent is in the stash: one
    // look can land before the record is written or before the socket is up.
    _safety() {
      var self = this;
      this._clearSafety();
      this._safetyTimers = UPLOAD_STASH_SAFETY_MS.map(function(ms) {
        return setTimeout(function() {
          if (!self._up || self._off) return;
          uploadStashAll().then(function(rows) {
            var unsent = self._mine(rows).some(function(row) {
              return (row.state === "pending" || row.state === "received") && !self._done[row.id];
            });
            if (unsent) self._scan();
          });
        }, ms);
      });
    },

    _clearSafety() {
      (this._safetyTimers || []).forEach(function(t) { clearTimeout(t); });
      this._safetyTimers = [];
    },

    // A trace the server logs (counts only), to read the order of events on a
    // device with no console.
    _debug(phase, n) {
      if (this._off) return;
      try {
        // LiveView 1.2 returns a promise that rejects when the socket is gone.
        var sent = this.pushEvent("pk_upload_debug", { upload: this._upload, phase: phase, n: n, connected: !!this._up });
        if (sent && typeof sent.catch === "function") sent.catch(function() {});
      } catch (_) {}
    },

    _persist() {
      if (this._persisted) return;
      this._persisted = true;
      try {
        var storage = window.navigator && window.navigator.storage;
        if (storage && typeof storage.persist === "function") storage.persist();
      } catch (_) {}
    },

    // ── the server's answers ────────────────────────────────────────────────

    _mine(rows) {
      var self = this;
      return rows.filter(function(row) {
        return row.scope === self._scope && row.upload === self._upload && row.user === self._user;
      });
    },

    _byKey(rows, key) {
      return this._mine(rows).filter(function(row) { return row.key === key; })
        .sort(function(a, b) { return a.seq < b.seq ? -1 : 1; });
    },

    // One at a time: `received` and `stored` of one file arrive together, and
    // the second must see what the first wrote.
    _enqueue(task) {
      var next = this._chain.then(task, task);
      this._chain = next.catch(function() {});
      return next;
    },

    // The server has all the bytes of one `key`.
    _received(key) {
      var self = this;
      return this._enqueue(function() {
        return uploadStashAll().then(function(rows) {
          var list = self._byKey(rows, key).filter(function(r) { return r.state === "pending"; });
          var row = list.filter(function(r) { return self._held[r.id]; })[0] || list[0];
          if (!row) return null;
          delete self._inflight[row.id];
          self._done[row.id] = true;
          self._release(row.id);
          return uploadStashUpdate([row.id], function(r) { r.state = "received"; r.touched = Date.now(); r.owner = null; });
        }).then(function() { if (self._queued) self._scan(); });
      });
    },

    // The host stored the file (`stored`), or turned it down for good, or the
    // person cancelled it (`rejected`: the browser must not carry it on).
    _finish(key, stored) {
      var self = this;
      return this._enqueue(function() {
        return uploadStashAll().then(function(rows) {
          var list = self._byKey(rows, key);
          var row = (stored ? list.filter(function(r) { return r.state === "received"; })[0] : null) ||
                    list.filter(function(r) { return self._inflight[r.id]; })[0] || list[0];
          return row ? self._forget([row.id]) : null;
        }).then(function() { if (self._queued) self._scan(); });
      });
    },

    _forget(ids) {
      var self = this;
      ids.forEach(function(id) {
        delete self._inflight[id];
        delete self._waiting[id];
        delete self._done[id];
        self._release(id);
      });
      return uploadStashDelete(ids);
    },

    _dropIds(ids) { this._forget(ids); },

    // ── looking for what a dead page left ───────────────────────────────────

    _scan() {
      var self = this;
      if (!this._upload || !this._scope || this._off) return;
      if (this._scanning) { this._rescan = true; return; }
      this._scanning = true;
      var now = Date.now();
      uploadStashAll().then(function(rows) {
        self._debug("scan", self._mine(rows).length);
        var gone = rows.filter(function(row) {
          return now - row.touched > UPLOAD_STASH_KEEP_MS || row.user !== self._user;
        }).map(function(row) { return row.id; });
        if (gone.length) uploadStashDelete(gone);

        var candidates = self._mine(rows).filter(function(row) {
          return gone.indexOf(row.id) === -1 && !self._inflight[row.id] && !self._done[row.id] &&
            (row.state === "pending" || row.state === "received");
        });
        return Promise.all(candidates.map(function(row) {
          return self._claim(row).then(function(ok) { return ok ? row : null; });
        }));
      }).then(function(claimed) {
        claimed = claimed.filter(function(row) { return row; });
        claimed.forEach(function(row) { self._waiting[row.id] = true; });
        self._scanning = false;
        if (claimed.length) self._ask(claimed);
        if (self._rescan) { self._rescan = false; self._scan(); }
      }, function() { self._scanning = false; });
    },

    _ask(rows) {
      var self = this;
      var byId = {};
      rows.forEach(function(row) { byId[row.id] = row; });
      var now = Date.now();
      var freshMs = this._freshMs();
      try {
        var sent = this.pushEvent("pk_upload_resume", {
          upload: this._upload,
          items: rows.map(function(row) { return uploadStashItem(row, now, freshMs); })
        }, function(reply) { self._answered(reply, byId); });
        if (sent && typeof sent.catch === "function") sent.catch(function() {});
      } catch (_) {}
    },

    _answered(reply, byId) {
      var self = this;
      if (reply && reply.error) { this._off = true; this._releaseAll(); this._waiting = {}; return; }
      if (!reply) return;
      var list = function(name) { return (reply[name] || []).filter(function(id) { return byId[id]; }); };
      this._queued = list("queued").length > 0;
      this._dropIds(list("drop"));
      this._feed(list("auto").map(function(id) { return byId[id]; }));
      list("queued").concat(list("ask")).forEach(function(id) { self._waiting[id] = true; });
    },

    // Files the person asked for with the button.
    _feedIds(ids) {
      var self = this;
      uploadStashAll().then(function(rows) {
        var wanted = self._mine(rows).filter(function(row) { return ids.indexOf(row.id) !== -1; });
        var lost = wanted.filter(function(row) { return !row.blob; }).map(function(row) { return row.id; });
        self._forget(lost);
        self._feed(wanted.filter(function(row) { return row.blob; }));
      });
    },

    // Hand stashed files to the form's upload, the way a pick would.
    _feed(rows) {
      var self = this;
      rows = rows.filter(function(row) { return row.blob; });
      if (!rows.length) return;
      var files = rows.map(function(row) {
        return new File([row.blob], row.name, { type: row.type, lastModified: row.lastModified });
      });
      rows.forEach(function(row) {
        delete self._waiting[row.id];
        self._inflight[row.id] = true;
      });
      uploadStashUpdate(rows.map(function(row) { return row.id; }), function(r) {
        r.attempts = (r.attempts || 0) + 1; r.touched = Date.now(); r.owner = self._inst;
      });
      this._withInput(0, function() {
        files.forEach(function(file) { self._seen && self._seen.add(file); });
        self.upload(self._upload, files);
      });
    },

    // The upload input may not be in the DOM yet right after a remount.
    _withInput(tries, run) {
      var self = this;
      var found = this._root.querySelector &&
        this._root.querySelector('input[type=file][data-phx-upload-ref][name="' + this._upload + '"]');
      if (found || tries >= UPLOAD_STASH_INPUT_TRIES) { run(); return; }
      setTimeout(function() { self._withInput(tries + 1, run); }, UPLOAD_STASH_INPUT_WAIT_MS);
    }
  };

  // Signing out removes the stashed files of the user signing out before the
  // request goes out: the stash holds file bytes, and the next person to sign
  // in must not find them. The user is the one the page's hooks were mounted
  // for (another signed-in user of a multi-session stack keeps his files); a
  // page with no hook cannot say, and everything goes. A failing IndexedDB must
  // not keep anyone signed in, and a click that opens a new tab or window is
  // left alone.
  (function() {
    var proceeding = false;
    document.addEventListener("click", function(e) {
      var el = e.target && e.target.closest ? e.target.closest("[data-pk-logout]") : null;
      if (!el || proceeding) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      e.stopPropagation();
      // The link says whose it is; failing that, a hook on the page does.
      var user = el.dataset ? el.dataset.pkLogout || "" : "";
      if (!user) {
        var hook = document.querySelector && document.querySelector('[phx-hook="ResumableUpload"][data-user]');
        user = hook && hook.dataset ? hook.dataset.user : "";
      }
      var done = false;
      var go = function() {
        if (done) return;
        done = true;
        proceeding = true;
        try { el.click(); } finally { proceeding = false; }
      };
      setTimeout(go, UPLOAD_STASH_LOGOUT_WAIT_MS);
      try { (user ? uploadStashClearUser(user) : uploadStashClear()).then(go, go); } catch (_) { go(); }
    }, true);
  })();

  // ============================================================================
  // FolderDropUpload Hook — drag files from device to upload into current folder
  // ============================================================================

  window.PhoenixKitHooks.FolderDropUpload = {
    mounted: function() {
      var self = this;
      var el = this.el;
      var dragCounter = 0;

      // The folder being shown paints its own upload outline
      // (`[data-drop-upload]`, MediaDragDrop); the ring here is for views
      // without one (all files).
      var ringed = function() { return !el.querySelector('[data-drop-upload="true"]'); };

      el.addEventListener("dragenter", function(e) {
        // Only respond to external file drags, not internal file-to-folder moves
        if (!e.dataTransfer.types.includes("Files")) return;
        e.preventDefault();
        dragCounter++;
        if (dragCounter === 1 && ringed()) {
          el.classList.add("ring-2", "ring-primary", "ring-dashed", "bg-primary/5");
        }
      });

      el.addEventListener("dragover", function(e) {
        if (!e.dataTransfer.types.includes("Files")) return;
        e.preventDefault();
        e.dataTransfer.dropEffect = "copy";
      });

      el.addEventListener("dragleave", function(e) {
        // Counted like dragenter, Files only: a card dragged about the page
        // drove it negative and the next upload's ring never showed.
        if (!e.dataTransfer.types.includes("Files")) return;
        e.preventDefault();
        dragCounter = Math.max(0, dragCounter - 1);
        if (dragCounter === 0) {
          el.classList.remove("ring-2", "ring-primary", "ring-dashed", "bg-primary/5");
        }
      });

      el.addEventListener("drop", function(e) {
        // Ignore internal drags (file-to-folder moves) — only accept device files
        var files = e.dataTransfer.files;
        if (!files || files.length === 0) return;

        e.preventDefault();
        dragCounter = 0;
        el.classList.remove("ring-2", "ring-primary", "ring-dashed", "bg-primary/5");

        // Inject files directly into the hidden upload input (no modal)
        self._pendingFiles = files;
        self._injectFiles();
      });
    },

    _injectFiles: function() {
      var self = this;
      var attempts = 0;
      var maxAttempts = 20;

      function tryInject() {
        // Walk outward to the NEAREST scope containing an upload input.
        // This used to be a hard closest(".flex-1") hop, which silently
        // broke when a second flex-1 wrapper landed between the drop area
        // and the hidden upload form: closest() resolved to the inner
        // wrapper, found no input, and every OS drop no-opped after the
        // retry loop gave up. The walk also finds the drawer's own input
        // when the drawer is open (the hidden form only renders while it
        // is closed) — same upload, either input — and stays inside this
        // browser's subtree before it ever reaches the page.
        var uploadInput = null;
        for (var scope = self.el; scope && !uploadInput; scope = scope.parentElement) {
          uploadInput = scope.querySelector("[data-phx-upload-ref]");
        }
        if (uploadInput && self._pendingFiles) {
          var dt = new DataTransfer();
          for (var i = 0; i < self._pendingFiles.length; i++) {
            dt.items.add(self._pendingFiles[i]);
          }
          uploadInput.files = dt.files;
          uploadInput.dispatchEvent(new Event("input", { bubbles: true }));
          self._pendingFiles = null;
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(tryInject, 50);
        }
      }

      tryInject();
    }
  };

  // ============================================================================
  // Etcher tooltip — comment-flavored slot overrides
  // ============================================================================
  //
  // Etcher exposes `window.Etcher.tooltipSlots` (header / body / footer)
  // for downstream consumers to customize its hover tooltip. PhoenixKit's
  // MediaBrowser flows comment-thread metadata through `metadata.comment_*`
  // keys; the three slots below translate those into the rich tooltip
  // (author header, date · count subheader, thumbnail + quoted text body)
  // that's been the PhoenixKit out-of-the-box look.
  //
  // PhoenixKit owns the tooltip layout — this assignment overwrites
  // whatever was on `window.Etcher.tooltipSlots`. Load order: when
  // phoenix_kit.js runs before etcher.js, Etcher's bootstrap honors the
  // pre-set slots (it uses `||` against defaults); when phoenix_kit.js
  // runs after, this assignment takes effect immediately. If a downstream
  // consumer wants to override these, their script must load AFTER
  // phoenix_kit.js. If Etcher never loads the only cost is a few dormant
  // fields on `window.Etcher`.
  //
  // The `comment_*` key naming is PhoenixKit's internal contract with
  // itself — Etcher knows nothing about them.

  window.Etcher = window.Etcher || {};

  var pkEscape = function(v) {
    return String(v == null ? "" : v)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  };

  // Paperclip icon used as the body-slot's attachment fallback when a
  // comment has media but no preview-able image (PDFs, audio, zips,
  // broken-image URLs).
  var pkPaperclip =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"' +
    ' stroke-width="1.5" stroke="currentColor" aria-hidden="true">' +
    '<path stroke-linecap="round" stroke-linejoin="round"' +
    ' d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13"/>' +
    "</svg>";

  function pkCapitalize(s) {
    if (!s) return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  // ============================================================================
  // Etcher live-metadata patch bridge
  // ============================================================================
  //
  // Listens for the `etcher:patch-shape` LiveView push_event emitted by
  // MediaBrowser when annotation comments are posted server-side. Calls
  // Etcher's `layerFor(fresco_id).patchShape(uuid, {metadata})` (added
  // in Etcher 0.3) so the in-DOM shape's metadata reflects the new
  // comment_* fields immediately — the tooltip shows the rich content
  // on the next hover without waiting for a layer remount.
  //
  // Why this bridge exists: <Fresco.canvas> uses `phx-update="ignore"`,
  // which freezes its `data-extensions` attribute at initial mount.
  // Server-side rebuilds of the canvas's `extensions.etcher` blob
  // don't reach the DOM, so Etcher's `handle.getExtension("etcher")`
  // keeps returning the old annotations. patchShape sidesteps that by
  // mutating Etcher's internal `self.shapes[i]` directly.
  window.addEventListener("phx:etcher:patch-shape", function(e) {
    var detail = e && e.detail;
    if (!detail || !detail.fresco_id || !detail.uuid) return;
    var layer = window.Etcher && window.Etcher.layerFor &&
                window.Etcher.layerFor(detail.fresco_id);
    if (!layer || typeof layer.patchShape !== "function") return;
    var fields = {};
    if (detail.metadata) fields.metadata = detail.metadata;
    if (detail.style) fields.style = detail.style;
    layer.patchShape(detail.uuid, fields);
  });

  // Server-driven shape removal. MediaBrowser uses this on annotation
  // composer Cancel — the user signalled the just-drawn shape was a
  // mistake, so we drop it from Etcher's local state instead of
  // leaving an untitled placeholder on the canvas. layer.deleteShape
  // pushes the deletion onto Etcher's undo stack (Cmd+Z restores) and
  // fires `etcher:annotations-changed`, which routes through the
  // server's sync_annotations to delete the DB row + cascade comments.
  window.addEventListener("phx:etcher:delete-shape", function(e) {
    var detail = e && e.detail;
    if (!detail || !detail.fresco_id || !detail.uuid) return;
    var layer = window.Etcher && window.Etcher.layerFor &&
                window.Etcher.layerFor(detail.fresco_id);
    if (!layer || typeof layer.deleteShape !== "function") return;
    layer.deleteShape(detail.uuid);
  });

  // Deep-link shape selection. A comment's "file" resource link (e.g. from the
  // comments moderation admin) can carry `?annotation=<uuid>`; MediaDetail
  // pushes `etcher:select-shape` so the shape is pinned (selected) as if the
  // user clicked it. The Etcher layer mounts asynchronously after the canvas
  // hook initializes, so retry until the layer + shape exist (give up after
  // ~6s). selectShape no-ops on readonly shapes.
  window.addEventListener("phx:etcher:select-shape", function(e) {
    var detail = e && e.detail;
    if (!detail || !detail.fresco_id || !detail.uuid) return;
    var attempts = 0;
    (function trySelect() {
      var layer = window.Etcher && window.Etcher.layerFor &&
                  window.Etcher.layerFor(detail.fresco_id);
      if (layer && typeof layer.selectShape === "function" &&
          typeof layer.getShape === "function" && layer.getShape(detail.uuid)) {
        layer.selectShape(detail.uuid);
        return;
      }
      if (attempts++ < 60) setTimeout(trySelect, 100);
    })();
  });

  window.Etcher.tooltipSlots = {
    // Header → annotation title (user-chosen label) if present;
    // otherwise the comment author; otherwise the shape kind.
    header: function(shape) {
      var m = shape.metadata || {};
      return pkEscape(m.title || m.comment_author || pkCapitalize(shape.kind));
    },

    // Footer → "May 12, 2026 · 3 comments". Date and count are both
    // optional; if neither is set the row is omitted entirely. (The
    // Reply / Edit / View actions are HEADER buttons — see
    // `window.Etcher.tooltipActions` below.)
    footer: function(shape) {
      var m = shape.metadata || {};
      var parts = [];
      if (m.comment_created_at) parts.push(pkEscape(m.comment_created_at));
      var count = m.comment_count || 0;
      if (count > 0) {
        parts.push(count + " " + (count === 1 ? "comment" : "comments"));
      }
      return parts.length ? parts.join(" · ") : null;
    },

    // Body → optional thumbnail (image or paperclip) + truncated
    // quoted text. Uses Etcher's opt-in styling primitives
    // (`.etcher-tooltip-body`, `.etcher-tooltip-thumb`,
    // `.etcher-tooltip-text`, `.etcher-tooltip-quote`).
    body: function(shape) {
      var m = shape.metadata || {};
      var text = m.comment_text || null;
      var thumb = m.comment_thumbnail_url || null;
      var hasAttachment = m.comment_has_attachment === true;

      if (!text && !thumb && !hasAttachment) return null;

      var html = '<div class="etcher-tooltip-body">';
      if (thumb) {
        html +=
          '<img class="etcher-tooltip-thumb" src="' + pkEscape(thumb) + '" alt="">';
      } else if (hasAttachment) {
        html +=
          '<span class="etcher-tooltip-thumb etcher-tooltip-thumb-icon">' +
          pkPaperclip +
          "</span>";
      }
      html += '<div class="etcher-tooltip-text">';
      if (text) {
        html += '<div class="etcher-tooltip-quote">' + pkEscape(text) + "</div>";
      }
      html += "</div></div>";
      return html;
    }
  };

  // ==========================================================================
  // Etcher tooltip header actions — Reply / Edit / View
  // ==========================================================================
  //
  // Real buttons on the tooltip's header row, next to Etcher's trash
  // (Etcher 0.13's `window.Etcher.tooltipActions`). Only on surfaces that
  // hydrate PhoenixKit's comment contract (`comment_count` present — the
  // media viewer); boards shapes carry no comment metadata and keep the
  // plain tooltip. Clicks re-dispatch as `etcher:tooltip-action`, routed by
  // the EtcherTooltipActions hook below:
  //   Reply — anyone, any persisted shape: opens the discussion flow.
  //   Edit  — non-readonly shapes: Etcher's inline label editor.
  //   View  — only when discussion exists: scrolls the sidebar to the
  //           shape's comment thread and flashes it.
  var pkTooltipIcons = {
    reply:
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"' +
      ' stroke-width="1.8" stroke="currentColor" aria-hidden="true">' +
      '<path stroke-linecap="round" stroke-linejoin="round"' +
      ' d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.068.157 2.148.279 3.238.364.466.037.893.281 1.153.671L12 20.25l2.652-3.978c.26-.39.687-.634 1.153-.67 1.09-.086 2.17-.208 3.238-.365 1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"/></svg>',
    edit:
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"' +
      ' stroke-width="1.8" stroke="currentColor" aria-hidden="true">' +
      '<path stroke-linecap="round" stroke-linejoin="round"' +
      ' d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"/></svg>',
    view:
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"' +
      ' stroke-width="1.8" stroke="currentColor" aria-hidden="true">' +
      '<path stroke-linecap="round" stroke-linejoin="round"' +
      ' d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"/>' +
      '<path stroke-linecap="round" stroke-linejoin="round"' +
      ' d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/></svg>'
  };

  window.Etcher.tooltipActions = function(shape) {
    var m = shape.metadata || {};
    if (!shape.uuid || m.comment_count == null) return [];

    var actions = [{ action: "pk-reply", title: "Reply", icon: pkTooltipIcons.reply }];
    if (!shape.readonly) {
      actions.push({ action: "pk-edit", title: "Edit label", icon: pkTooltipIcons.edit });
    }
    if ((m.comment_count || 0) > 0) {
      actions.push({ action: "pk-view", title: "View discussion", icon: pkTooltipIcons.view });
    }
    return actions;
  };

  // ---------------------------------------------------------------------------
  // StackExpand
  //
  // Stacks media view: when a folder "stack" is opened, its images fly out of
  // the pile into their grid slots (a FLIP animation). The hook sits on the
  // expanded section; on mount it finds the matching stack tile
  // ([data-stack-tile="<uuid>"]) and parks each card ([data-stack-card]) at the
  // stack's position scaled down, then releases them to their natural slots with
  // a per-card stagger. Inline styles are cleared afterwards so hover/selection
  // transforms aren't pinned. Respects prefers-reduced-motion; never throws.
  // ---------------------------------------------------------------------------
  // Persists which media stacks the user has open across refresh / navigation
  // away-and-back, in localStorage. On mount it pushes the saved open-set to
  // the LiveComponent (which reopens them); after every toggle/restore the
  // server echoes the authoritative open-set via "pk:stacks" and we persist
  // it. We persist from the server echo rather than reading the DOM because a
  // closing stack lingers briefly during its fly-back animation and would be
  // misread as still-open. Key is scoped per virtual-root so scoped browsers
  // remember independently.
  window.PhoenixKitHooks.StackMemory = {
    mounted() {
      var key = this.el.dataset.storageKey;
      var self = this;
      var el = this.el;

      var reveal = function () {
        if (self._revealT) {
          clearTimeout(self._revealT);
          self._revealT = null;
        }
        el.style.visibility = "";
      };

      this.handleEvent("pk:stacks", function (payload) {
        try {
          localStorage.setItem(key, JSON.stringify((payload && payload.uuids) || []));
        } catch (e) {
          /* private mode / quota — degrade to no-memory */
        }
        // The restore round-trip has landed (server reopened the stacks) —
        // show the already-open view in one shot.
        reveal();
      });

      var saved = [];
      try {
        saved = JSON.parse(localStorage.getItem(key) || "[]");
      } catch (e) {
        saved = [];
      }
      if (Array.isArray(saved) && saved.length) {
        // Hide the stacks body before first paint so the user never sees the
        // closed state flash open. mounted() runs before the browser paints
        // the patch, so this suppresses the intermediate "stacks closed"
        // frame; we reveal once the server echoes the reopened set. A safety
        // timeout guarantees we never leave the view stuck hidden if the echo
        // never arrives.
        el.style.visibility = "hidden";
        self._revealT = setTimeout(reveal, 600);
        this.pushEventTo(this.el, "restore_stacks", { uuids: saved });
      }
    },
    destroyed() {
      if (this._revealT) clearTimeout(this._revealT);
    }
  };

  window.PhoenixKitHooks.StackExpand = {
    mounted() {
      // Closing is driven client-side: the stack tile dispatches
      // "pk:close-stack", we play the fly-back, then tell the server to drop
      // the section. There's no phx-remove, so navigating away (opening a
      // media detail page) just leaves instantly with no animation or delay.
      this._onClose = function () {
        try {
          this.flyBack();
        } catch (e) {
          // If the animation can't run, still drop the section server-side.
          this._removeServerSide();
        }
      }.bind(this);
      this.el.addEventListener("pk:close-stack", this._onClose);

      // Only an explicitly-opened stack animates out of the pile. Restored
      // stacks (refresh / navigate-back) carry no data-animate-open, so they
      // appear instantly.
      if (this.el.dataset.animateOpen) {
        try {
          this.flyOut();
        } catch (e) {
          /* an animation must never break the page */
        }
      }
    },
    destroyed() {
      if (this._onClose) this.el.removeEventListener("pk:close-stack", this._onClose);
    },
    // Tell the LiveComponent to collapse this stack. The uuid is still in the
    // server's expanded list (the client animated first), so toggling removes
    // it. Runs after the fly-back so removal is seamless.
    _removeServerSide() {
      try {
        this.pushEventTo(this.el, "toggle_stack_expand", {
          "folder-uuid": this.el.dataset.stackFolder
        });
      } catch (e) {
        /* component may already be gone */
      }
    },
    // Shared geometry: the delta + scale to map a card to the stack pile.
    _toStack(card) {
      var folder = this.el.dataset.stackFolder;
      var stack = folder && document.querySelector('[data-stack-tile="' + folder + '"]');
      var sr = stack ? stack.getBoundingClientRect() : null;
      var cr = card.getBoundingClientRect();
      if (!sr) return { dx: 0, dy: -24, scale: 0.35 };
      return {
        dx: (sr.left + sr.width / 2) - (cr.left + cr.width / 2),
        dy: (sr.top + sr.height / 2) - (cr.top + cr.height / 2),
        scale: Math.max(0.18, Math.min(sr.width / Math.max(cr.width, 1), 0.6))
      };
    },
    // Reverse of flyOut: send each card back into the pile, collapse the
    // section, then ask the server to remove it. (No prefers-reduced-motion
    // animation, but we still remove it.)
    flyBack() {
      var self = this;
      var el = this.el;

      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        self._removeServerSide();
        return;
      }

      var cards = Array.prototype.slice.call(el.querySelectorAll("[data-stack-card]"));
      cards.forEach(function (card) {
        var t = self._toStack(card);
        var i = parseInt(card.dataset.stackCard || "0", 10);
        var delay = Math.min(i, 16) * 18;
        card.style.transformOrigin = "center center";
        card.style.willChange = "transform, opacity";
        card.style.transition =
          "transform 420ms cubic-bezier(0.4,0,1,1) " + delay + "ms, " +
          "opacity 380ms ease " + delay + "ms";
        card.style.transform =
          "translate(" + t.dx + "px," + t.dy + "px) scale(" + t.scale + ")";
        card.style.opacity = "0";
      });

      // Once the images have retreated into the pile, collapse the section's
      // height + margin to 0 so the stacks/Everything-else below slide up
      // smoothly to fill the gap, instead of jumping when LiveView removes it.
      // Deferred so the cards (which fly up out of the box) aren't clipped.
      setTimeout(function () {
        var rect = el.getBoundingClientRect();
        var mt = window.getComputedStyle(el).marginTop;
        el.style.height = rect.height + "px";
        el.style.marginTop = mt;
        el.style.overflow = "hidden";
        el.getBoundingClientRect(); // commit the fixed height before transitioning
        el.style.transition =
          "height 320ms cubic-bezier(0.4,0,0.2,1), margin-top 320ms cubic-bezier(0.4,0,0.2,1)";
        el.style.height = "0px";
        el.style.marginTop = "0px";
      }, 320);

      // Once the cards have retreated and the section has collapsed, tell the
      // server to remove it (cards ~420ms+stagger, collapse 320ms@+320ms).
      setTimeout(function () {
        self._removeServerSide();
      }, 720);
    },
    flyOut() {
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return;
      }

      var cards = Array.prototype.slice.call(this.el.querySelectorAll("[data-stack-card]"));
      if (!cards.length) return;

      var folder = this.el.dataset.stackFolder;
      var stack = folder && document.querySelector('[data-stack-tile="' + folder + '"]');
      var sr = stack ? stack.getBoundingClientRect() : null;

      // FIRST → INVERT: start every card at the stack's position, scaled down.
      cards.forEach(function (card) {
        var cr = card.getBoundingClientRect();
        var dx = 0;
        var dy = -24;
        var scale = 0.35;
        if (sr) {
          dx = (sr.left + sr.width / 2) - (cr.left + cr.width / 2);
          dy = (sr.top + sr.height / 2) - (cr.top + cr.height / 2);
          scale = Math.max(0.18, Math.min(sr.width / Math.max(cr.width, 1), 0.6));
        }
        card.style.transition = "none";
        card.style.transformOrigin = "center center";
        card.style.transform = "translate(" + dx + "px," + dy + "px) scale(" + scale + ")";
        card.style.opacity = "0";
        card.style.willChange = "transform, opacity";
      });

      // PLAY: next frame, release each card to its slot with a stagger.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          cards.forEach(function (card) {
            var i = parseInt(card.dataset.stackCard || "0", 10);
            var delay = Math.min(i, 16) * 35;
            card.style.transition =
              "transform 460ms cubic-bezier(0.2,0.7,0.3,1) " + delay + "ms, " +
              "opacity 340ms ease " + delay + "ms";
            card.style.transform = "translate(0,0) scale(1)";
            card.style.opacity = "1";
          });
        });
      });

      // Clear inline styles once the last card settles, so hover / selection
      // transforms aren't pinned by the leftover inline transform.
      var last = cards[cards.length - 1];
      var cleanup = function (e) {
        if (e && e.propertyName && e.propertyName !== "transform") return;
        cards.forEach(function (card) {
          card.style.transition = "";
          card.style.transform = "";
          card.style.transformOrigin = "";
          card.style.willChange = "";
          card.style.opacity = "";
        });
        last.removeEventListener("transitionend", cleanup);
      };
      last.addEventListener("transitionend", cleanup);
      setTimeout(cleanup, 1300);
    }
  };

  // Interactive waveform for audio files. WaveSurfer is fetched via a lazy
  // dynamic import the first time an audio file is opened in the viewer, so it
  // costs nothing on any page without audio. It renders over the native <audio>
  // element (used as both playback source and fallback), giving click-to-seek,
  // a moving play cursor, a timeline, and zoom. If the library can't load, the
  // native <audio controls> still plays.
  //
  // The module is the host's vendored copy (same origin, so a strict CSP
  // and CORS are both satisfied), its URL resolved at runtime from the
  // install facts — never a string literal a bundler would try to resolve.
  window.PhoenixKitHooks.WaveformPlayer = {
    mounted() {
      var el = this.el;
      var waveDiv = el.querySelector("[data-waveform]");
      var audioEl = el.querySelector("[data-waveform-audio]");
      var toggleBtn = el.querySelector("[data-waveform-toggle]");
      var playIcon = el.querySelector('[data-waveform-icon="play"]');
      var pauseIcon = el.querySelector('[data-waveform-icon="pause"]');
      if (!waveDiv || !audioEl) return;

      var self = this;
      self._ws = null;

      var showPlay = function (playing) {
        if (playIcon) playIcon.classList.toggle("hidden", playing);
        if (pauseIcon) pauseIcon.classList.toggle("hidden", !playing);
      };

      // Through the shared loader (a failure is recorded and reported); the
      // catch below keeps playback working.
      loadVendored("wavesurfer", "wavesurfer", { module: true })
        .then(function (mod) {
          if (self._destroyed) return;
          var WaveSurfer = mod.default;

          var ws = WaveSurfer.create({
            container: waveDiv,
            media: audioEl,
            height: 96,
            waveColor: "#94a3b8",
            progressColor: "#6366f1",
            cursorColor: "#4338ca",
            cursorWidth: 2,
            barWidth: 2,
            barGap: 1,
            barRadius: 2
          });
          self._ws = ws;

          ws.on("play", function () {
            showPlay(true);
          });
          ws.on("pause", function () {
            showPlay(false);
          });
          ws.on("finish", function () {
            showPlay(false);
          });

          if (toggleBtn) {
            toggleBtn.addEventListener("click", function () {
              try {
                ws.playPause();
              } catch (e) {
                /* not ready yet — ignore */
              }
            });
          }
        })
        .catch(function () {
          // Library unavailable (offline / CSP) — reveal the native controls so
          // playback still works, and hide the waveform + custom button.
          audioEl.controls = true;
          if (waveDiv) waveDiv.style.display = "none";
          if (toggleBtn) toggleBtn.style.display = "none";
        });
    },
    destroyed() {
      this._destroyed = true;
      try {
        if (this._ws) this._ws.destroy();
      } catch (e) {
        /* ignore */
      }
    }
  };

  // ============================================================================
  // INITIALIZATION COMPLETE
  // ============================================================================

  if (typeof console !== "undefined" && console.debug) {
    var hookCount = Object.keys(window.PhoenixKitHooks).length;
    if (hookCount > 0) {
      console.debug(
        "[PhoenixKit] Initialized with " + hookCount + " hook(s):",
        Object.keys(window.PhoenixKitHooks)
      );
    }
  }

})();

// ===========================================================================
// PhoenixKitHooks bridge — adopts any hooks exposed by sibling libraries
// (fresco, tessera, etcher) into the single `window.PhoenixKitHooks`
// namespace the parent app spreads into LiveSocket.
//
// Default setup (zero-config): the FrescoViewer / TesseraLayer /
// EtcherLayer wrapper hooks above lazy-load the host's vendored copies of
// the sibling libs on first mount, so the parent app only needs to spread
// `...window.PhoenixKitHooks` into LiveSocket:
//
//   let liveSocket = new LiveSocket("/live", Socket, {
//     hooks: { ...window.PhoenixKitHooks, ...colocatedHooks }
//   });
//
// Optional pre-import (for offline / CSP-strict / pre-bundled apps):
// import the libs in your own `app.js` before phoenix_kit.js and the
// wrappers will detect `window.{Fresco|Tessera|Etcher}Hooks` and skip
// the CDN load:
//
//   import "../../deps/fresco/priv/static/fresco.js"
//   import "../../deps/tessera/priv/static/tessera.js"
//   import "../../deps/etcher/priv/static/etcher.js"
//
// The `adopt` calls below are a defensive backstop for any sibling hook
// the wrappers above don't explicitly cover (e.g. a future hook added by
// one of the libs). No-ops when the global is missing.
// ===========================================================================

// SearchPicker — generic instant typeahead for "search a source, pick an
// entry" fields (extracted from phoenix_kit_crm's involved-parties picker).
// The dropdown is rendered and shown ENTIRELY client-side (opening, the
// optional "Add … as free text" row, spinners), so nothing visual waits on
// the server; the server only runs the actual search and returns rows via
// push_event. Rows: {kind, uuid, label, sublabel?, icon?}.
//
// Configured via data attributes on the input:
//   data-dropdown        id of the dropdown container (phx-update="ignore")
//   data-search-event    pushed as {q, limit}            (default "picker_search")
//   data-results-event   handleEvent name for rows       (default "picker_results";
//                        payload {q, results, has_more})
//   data-pick-event      pushed as {kind, uuid, label}   (default "picker_pick")
//   data-text-event      pushed as {name}; free-text row only renders when set
//   data-staged-event    handleEvent confirming a pick   (default "picker_staged")
//   data-search-on-focus when present, focusing/clicking the input runs a
//                        search immediately (empty query included) so the
//                        full list opens on click — suits short curated
//                        sources like locations
//   data-mode            "multi" (default) or "single" — single sets the
//                        input's value to the picked label client-side,
//                        dispatches an input event (so a surrounding form's
//                        phx-change sees it) and closes; no staging round-trip
//   data-t-*             translated strings (searching/add-prefix/add-suffix/
//                        adding/more/loading-more/no-matches)
(function () {
  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s == null ? "" : String(s);
    return d.innerHTML;
  }
  function escAttr(s) {
    return esc(s).replace(/"/g, "&quot;");
  }

  // Stable identity for de-duplicating rows across "Load more" pages. The
  // server may send `dedup_id` (a PERSON identity that survives a row
  // changing source/kind between pages); otherwise fall back to kind:uuid.
  function dedupKey(r) {
    return r.dedup_id != null ? "d:" + r.dedup_id : r.kind + ":" + r.uuid;
  }

  window.PhoenixKitHooks.SearchPicker = {
    mounted() {
      this.dd = document.getElementById(this.el.dataset.dropdown);
      this.target = this.el.dataset.target || this.el;
      this.mode = this.el.dataset.mode === "single" ? "single" : "multi";
      this.searchOnFocus = this.el.dataset.searchOnFocus != null;
      this.evSearch = this.el.dataset.searchEvent || "picker_search";
      this.evResults = this.el.dataset.resultsEvent || "picker_results";
      this.evPick = this.el.dataset.pickEvent || "picker_pick";
      this.evText = this.el.dataset.textEvent || null;
      this.evStaged = this.el.dataset.stagedEvent || "picker_staged";
      this.results = [];
      this.searching = false;
      this.limit = 8;
      this.hasMore = false;
      this.loadingMore = false;
      this.closeOnPick = this.el.dataset.closeOnPick != null;
      this.stacked = this.el.dataset.rowLayout === "stacked";
      // The list opens in the top layer where the Popover API exists, so an
      // overflow ancestor (a modal body) cannot clip it; the old absolute
      // positioning is the fallback.
      this.usePopover = typeof this.dd.showPopover === "function";
      // Whether the user is still asking for the list: results that arrive
      // after it was closed, or for a field nobody is in, are kept, not shown.
      this.wantOpen = false;
      this._place = () => {
        if (this._placeQueued) return;
        this._placeQueued = true;
        requestAnimationFrame(() => {
          this._placeQueued = false;
          this.place();
        });
      };
      this._dialog = this.el.closest("dialog");
      this._dialogClose = () => this.close();
      if (this._dialog) this._dialog.addEventListener("close", this._dialogClose);

      this.el.addEventListener("input", (e) => {
        if (e._pkPickerSynthetic) return;
        this.onInput();
      });
      this.el.addEventListener("keydown", (e) => this.onKeydown(e));
      // Focus moving to another element closes the list (and so drops a
      // late answer). Not when the whole window lost focus — the user is
      // coming back — and not when focus went into the list itself.
      this.el.addEventListener("blur", () => {
        setTimeout(() => {
          if (!document.hasFocus()) return;
          var active = document.activeElement;
          if (active === this.el || this.dd.contains(active)) return;
          this.close();
        }, 200);
      });
      this.el.addEventListener("focus", () => {
        // A close_on_pick picker refocuses its input after a pick; that
        // focus must not reopen the list.
        if (this._quiet) {
          this._quiet = false;
          return;
        }
        if (this.searchOnFocus) this.kickSearch();
        else if (this.el.value.trim()) {
          this.wantOpen = true;
          this.render();
        }
      });
      if (this.searchOnFocus) {
        this.el.addEventListener("click", () => {
          if (this.dd.classList.contains("hidden")) this.kickSearch();
        });
      }

      this._docClick = (e) => {
        if (!this.el.contains(e.target) && !this.dd.contains(e.target)) this.close();
      };
      document.addEventListener("click", this._docClick);

      // mousedown (not click) so a pick registers before the input's blur.
      // After a touch has been handled, the browser's late mouse events for
      // the same tap are ignored.
      this.dd.addEventListener("mousedown", (e) => {
        if (this._touchAt && Date.now() - this._touchAt < 800) {
          e.preventDefault();
          return;
        }
        this.onPick(e);
      });

      // Touch: pick when the finger lifts without having moved (a move is a
      // scroll of the list). On an iPhone with the keyboard up the tap's
      // mouse events arrive late and land on the input, so picking on
      // mousedown alone missed the first tap.
      this.dd.addEventListener(
        "touchstart",
        (e) => {
          var t = e.touches[0];
          this._touchStart = t ? { x: t.clientX, y: t.clientY } : null;
        },
        { passive: true },
      );
      this.dd.addEventListener("touchend", (e) => {
        var t = e.changedTouches[0];
        var s = this._touchStart;
        this._touchStart = null;
        if (!t || !s) return;
        if (Math.abs(t.clientX - s.x) > 10 || Math.abs(t.clientY - s.y) > 10) return;
        var target = document.elementFromPoint(t.clientX, t.clientY) || e.target;
        if (!target.closest || !target.closest("[data-pick]")) return;
        e.preventDefault();
        this._touchAt = Date.now();
        this.onPick({ target: target, preventDefault: function () {} });
      });

      this.handleEvent(this.evResults, (payload) => {
        // push_event broadcasts to every hook listening on this name — a
        // second picker sharing the event name would render our rows.
        // Servers echoing back the `id` we send get exact routing; the
        // check is skipped when absent for backwards compatibility.
        if (payload.id && payload.id !== this.el.id) return;
        if (this.stagingNow) return;
        if (this.el.value.trim() !== (payload.q || "")) return; // stale
        // Closed since the search went out (Escape, a pick, a click
        // elsewhere, or focus moved to another field — see the blur
        // listener): a slow answer must not reopen it.
        if (!this.wantOpen) return;
        var incoming = payload.results || [];

        if (this.loadingMore) {
          // "Load more" grows a per-source page, so a naive replace would
          // re-order the flattened list (new rows land BETWEEN sources) and
          // the user loses their place. APPEND only rows not already shown,
          // so everything on screen stays put and the new ones arrive at the
          // end. Dedup by `dedup_id` (a stable PERSON identity the server
          // sends) rather than kind+uuid, so a person whose row flips source
          // between pages (staff -> user once their user row enters the
          // window) isn't shown twice. Falls back to kind:uuid when the
          // server doesn't send dedup_id.
          var seen = {};
          this.results.forEach((r) => {
            seen[dedupKey(r)] = true;
          });
          incoming.forEach((r) => {
            if (!seen[dedupKey(r)]) {
              this.results.push(r);
              seen[dedupKey(r)] = true;
            }
          });
        } else {
          this.results = incoming;
        }

        this.hasMore = !!payload.has_more;
        this.searching = false;
        this.loadingMore = false;
        this.render();
      });

      this.handleEvent(this.evStaged, (payload) => {
        if (payload && payload.id && payload.id !== this.el.id) return;
        this.stagingNow = false;
        clearTimeout(this.stageT);
        this.clear();
      });
    },

    destroyed() {
      document.removeEventListener("click", this._docClick);
      if (this._dialog) this._dialog.removeEventListener("close", this._dialogClose);
      this.unfollow();
      if (this.usePopover && this.dd.matches && this.dd.matches(":popover-open")) {
        try {
          this.dd.hidePopover();
        } catch (_e) {}
      }
      clearTimeout(this.t);
      clearTimeout(this.stageT);
    },

    onInput() {
      var q = this.el.value.trim();
      if (!q && !this.searchOnFocus) {
        this.close();
        return;
      }
      this.wantOpen = true;
      this.searching = true;
      this.results = [];
      this.limit = 8;
      this.hasMore = false;
      this.loadingMore = false;
      this._restoreScroll = null;
      this.render();
      clearTimeout(this.t);
      this.t = setTimeout(() => this.search(q), 180);
    },

    search(q) {
      this.pushEventTo(this.target, this.evSearch, {
        q: q,
        limit: this.limit,
        id: this.el.id,
      });
    },

    kickSearch() {
      this.wantOpen = true;
      this.searching = true;
      this.results = [];
      this.limit = 8;
      this.hasMore = false;
      this.loadingMore = false;
      this._restoreScroll = null;
      this.render();
      clearTimeout(this.t);
      this.t = setTimeout(() => this.search(this.el.value.trim()), 100);
    },

    loadMore() {
      this.wantOpen = true;
      this.limit += 8;
      this.loadingMore = true;
      this._restoreScroll = this.scrollEl ? this.scrollEl.scrollTop : null;
      this.render();
      clearTimeout(this.t);
      this.search(this.el.value.trim());
    },

    onKeydown(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        var q = this.el.value.trim();
        if (q && this.evText && this.mode !== "single") {
          this.pushEventTo(this.target, this.evText, { name: q, id: this.el.id });
          this.staging();
        }
      } else if (e.key === "Escape") {
        // Inside a <dialog>, Escape would also close the dialog; while the
        // list is open it closes only the list.
        if (this.isOpen()) {
          e.preventDefault();
          e.stopPropagation();
        }
        this.close();
      }
    },

    onPick(e) {
      var btn = e.target.closest("[data-pick]");
      if (!btn) return;
      e.preventDefault();
      if (btn.dataset.pick === "more") {
        this.loadMore();
        return;
      }
      if (this.mode === "single") {
        // client-side value set; a synthetic input event lets a surrounding
        // form's phx-change (and its server-side value mapping) see it
        this.el.value = btn.dataset.label || "";
        var ev = new Event("input", { bubbles: true });
        ev._pkPickerSynthetic = true;
        this.el.dispatchEvent(ev);
        this.close();
        return;
      }
      if (btn.dataset.pick === "text") {
        var q = this.el.value.trim();
        if (!q || !this.evText) return;
        this.pushEventTo(this.target, this.evText, { name: q, id: this.el.id });
      } else {
        this.pushEventTo(this.target, this.evPick, {
          kind: btn.dataset.kind,
          uuid: btn.dataset.uuid,
          label: btn.dataset.label,
          id: this.el.id,
        });
      }
      this.staging();
    },

    staging() {
      this.stagingNow = true;
      clearTimeout(this.t);
      var tAdding = esc(this.el.dataset.tAdding || "Adding…");
      this.dd.innerHTML =
        '<div class="flex items-center gap-2 px-3 py-2 text-sm text-base-content/60">' +
        '<span class="loading loading-spinner loading-xs"></span>' +
        tAdding +
        "</div>";
      this.open();
      clearTimeout(this.stageT);
      this.stageT = setTimeout(() => {
        this.stagingNow = false;
        this.clear();
      }, 3000);
    },

    render() {
      var q = this.el.value.trim();
      if (!q && !this.searchOnFocus) {
        this.close();
        return;
      }
      var tSearching = esc(this.el.dataset.tSearching || "Searching…");
      var tAddPrefix = esc(this.el.dataset.tAddPrefix || "Add");
      var tAddSuffix = esc(this.el.dataset.tAddSuffix || "as text");
      var tMore = esc(this.el.dataset.tMore || "Load more");
      var tLoadingMore = esc(this.el.dataset.tLoadingMore || "Loading…");
      var tNoMatches = esc(this.el.dataset.tNoMatches || "No matches");

      var top = "";
      if (this.searching) {
        top +=
          '<div class="flex items-center gap-2 px-3 py-2 text-sm text-base-content/60 border-b border-base-200">' +
          '<span class="loading loading-spinner loading-xs"></span>' +
          tSearching +
          "</div>";
      }

      var list = "";
      this.results.forEach((r) => {
        if (this.stacked) {
          list +=
            '<button type="button" data-pick="result" data-kind="' +
            escAttr(r.kind) +
            '" data-uuid="' +
            escAttr(r.uuid) +
            '" data-label="' +
            escAttr(r.label) +
            '" class="flex items-start gap-2 w-full px-3 py-2 hover:bg-base-200 text-left cursor-pointer">' +
            '<span class="' +
            escAttr(r.icon || "hero-user") +
            ' w-4 h-4 shrink-0 mt-0.5 text-base-content/50"></span>' +
            '<span class="flex flex-col items-start min-w-0">' +
            '<span class="line-clamp-2 break-words">' +
            esc(r.label) +
            "</span>" +
            (r.sublabel
              ? '<span class="text-xs text-base-content/50 truncate max-w-full">' + esc(r.sublabel) + "</span>"
              : "") +
            "</span></button>";
          return;
        }
        list +=
          '<button type="button" data-pick="result" data-kind="' +
          escAttr(r.kind) +
          '" data-uuid="' +
          escAttr(r.uuid) +
          '" data-label="' +
          escAttr(r.label) +
          '" class="flex items-center justify-between w-full px-3 py-2 hover:bg-base-200 text-left cursor-pointer">' +
          '<span class="flex items-center gap-2 min-w-0">' +
          '<span class="' +
          escAttr(r.icon || "hero-user") +
          ' w-4 h-4 shrink-0 text-base-content/50"></span>' +
          '<span class="truncate">' +
          esc(r.label) +
          "</span></span>" +
          '<span class="text-xs text-base-content/50 shrink-0 ml-2 truncate">' +
          esc(r.sublabel || "") +
          "</span></button>";
      });
      if (!this.searching && !this.loadingMore && this.results.length === 0) {
        list +=
          '<div class="px-3 py-2 text-sm text-base-content/50">' + tNoMatches + "</div>";
      }
      if (this.loadingMore) {
        list +=
          '<div class="flex items-center justify-center gap-2 px-3 py-2 text-xs text-base-content/50">' +
          '<span class="loading loading-spinner loading-xs"></span>' +
          tLoadingMore +
          "</div>";
      } else if (this.hasMore) {
        list +=
          '<button type="button" data-pick="more" class="w-full px-3 py-2 text-xs text-center text-primary hover:bg-base-200 cursor-pointer">' +
          tMore +
          "</button>";
      }

      var bottom = "";
      if (q && this.evText && this.mode !== "single") {
        bottom =
          '<button type="button" data-pick="text" class="flex items-center gap-2 w-full px-3 py-2 hover:bg-base-200 text-left border-t border-base-200 cursor-pointer">' +
          '<span class="hero-plus-mini w-4 h-4 shrink-0 text-base-content/50"></span>' +
          "<span>" +
          tAddPrefix +
          ' "' +
          esc(q) +
          '" ' +
          tAddSuffix +
          "</span></button>";
      }

      this.dd.innerHTML =
        top + '<div data-scroll class="max-h-56 overflow-y-auto">' + list + "</div>" + bottom;

      this.scrollEl = this.dd.querySelector("[data-scroll]");
      if (this._restoreScroll != null && this.scrollEl) {
        this.scrollEl.scrollTop = this._restoreScroll;
        if (!this.loadingMore) this._restoreScroll = null;
      }
      this.open();
    },

    isOpen() {
      return !this.dd.classList.contains("hidden");
    },
    open() {
      var wasOpen = this.isOpen();
      this.dd.classList.remove("hidden");
      if (this.usePopover) {
        if (!this.dd.matches(":popover-open")) {
          try {
            this.dd.showPopover();
          } catch (_e) {
            this.usePopover = false;
          }
        }
        this.place();
        if (!wasOpen) this.follow();
      }
    },
    close() {
      this.wantOpen = false;
      this.dd.classList.add("hidden");
      this.dd.innerHTML = "";
      this.unfollow();
      if (this.usePopover && this.dd.matches(":popover-open")) {
        try {
          this.dd.hidePopover();
        } catch (_e) {}
      }
    },
    clear() {
      this.el.value = "";
      this.results = [];
      this.searching = false;
      this.stagingNow = false;
      clearTimeout(this.stageT);
      this.close();
      if (this.closeOnPick) this._quiet = true;
      this.el.focus();
    },

    // Places the top-layer list under (or over) the input, in viewport
    // coordinates. The visual viewport counts: with a phone keyboard up the
    // room below the field is what is left above the keyboard.
    place() {
      if (!this.usePopover || !this.isOpen()) return;
      var r = this.el.getBoundingClientRect();
      var vv = window.visualViewport;
      var viewBottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
      var viewTop = vv ? vv.offsetTop : 0;
      if (r.bottom < viewTop || r.top > viewBottom) {
        this.close();
        return;
      }
      var below = viewBottom - r.bottom;
      var above = r.top - viewTop;
      var up = this.el.dataset.direction === "up" || (below < 180 && above > below);
      var style = this.dd.style;
      style.position = "fixed";
      style.margin = "0";
      style.inset = "auto";
      style.left = r.left + "px";
      style.width = r.width + "px";
      if (up) {
        style.top = "auto";
        style.bottom = window.innerHeight - r.top + 4 + "px";
      } else {
        style.bottom = "auto";
        style.top = r.bottom + 4 + "px";
      }
      var scroll = this.dd.querySelector("[data-scroll]");
      if (scroll) scroll.style.maxHeight = Math.max(Math.min(224, (up ? above : below) - 48), 80) + "px";
    },
    follow() {
      window.addEventListener("scroll", this._place, true);
      window.addEventListener("resize", this._place);
      if (window.visualViewport) {
        window.visualViewport.addEventListener("resize", this._place);
        window.visualViewport.addEventListener("scroll", this._place);
      }
    },
    unfollow() {
      window.removeEventListener("scroll", this._place, true);
      window.removeEventListener("resize", this._place);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", this._place);
        window.visualViewport.removeEventListener("scroll", this._place);
      }
    },
  };
})();

// ---------------------------------------------------------------------------
// Collapse scroll keeper. Closing an expanded <details class="collapse"> near
// the bottom of the page shrinks the document; the browser clamps the scroll
// position to the new maximum and the viewport jumps upward under the reader.
// Just before the collapse, pad the document with a body spacer so it cannot
// become shorter than the reader's current position — they stay put, looking
// at the now-closed section, with blank space below the fold. Every pixel
// they then scroll up releases a pixel of that spacer (height leaving from
// entirely below the viewport is invisible), so the page works its way back
// to its natural length without ever moving underfoot.
//
// Two deliberate choices, both learned from getting it wrong first:
//
//   * Measured on the summary ACTIVATION, not the `toggle` event. By the time
//     `toggle` fires the element may already be collapsed — no animation
//     under prefers-reduced-motion — leaving nothing to measure, and that is
//     exactly the case where the jump is most jarring.
//   * Released against the READER'S SCROLLING, not the live document height.
//     Mid-collapse the document still contains the content that is on its way
//     out, so height-based math reads the spacer as unnecessary and hands it
//     back before the shrink lands — the clamp then happens anyway. Scroll
//     distance is exact and needs no animation-timing machinery.
//
// The held height goes on the layout's [data-pk-collapse-pad] element when one
// is present (PhoenixKit's admin layout marks its content column), so sticky
// sidebars and page backgrounds extend through the blank area; otherwise a
// body-level div is injected, which holds the position just as well but leaves
// the blank area outside any app chrome. Only the window-scrolled case is
// handled: inside an inner scroll container neither helps, so those bail out
// to the browser default.
(function() {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  // Extra spacer height so (scrollTop + viewport) still fits inside the
  // document after `shrink` px of content collapses away. `docHeight`
  // includes any existing spacer, so the result stacks on top of it.
  // Pure — unit-tested in test/js/collapse_space.test.cjs.
  function extraSpaceNeeded(scrollTop, viewport, docHeight, shrink) {
    var overshoot = scrollTop + viewport - (docHeight - shrink);
    return overshoot > 0 ? Math.ceil(overshoot) : 0;
  }

  // Height the spacer still needs once the reader has scrolled up away from
  // the position it was installed to protect. `highestTop` is the smallest
  // scrollTop seen since it was installed, so scrolling back down cannot
  // re-claim space that was already given up — the page only ever gets
  // shorter, and only from below the fold.
  function spacerAfterScrollUp(installedHeight, installedTop, highestTop) {
    var released = Math.max(0, installedTop - highestTop);
    return Math.max(0, installedHeight - released);
  }

  if (typeof module === "object" && module.exports) {
    module.exports.extraSpaceNeeded = extraSpaceNeeded;
    module.exports.spacerAfterScrollUp = spacerAfterScrollUp;
  }

  var spacer = null;
  var injected = false;
  var installedHeight = 0;
  var installedTop = 0;
  var highestTop = 0;

  function scrollTopNow() {
    return (document.scrollingElement || document.documentElement).scrollTop;
  }

  function metrics() {
    var el = document.scrollingElement || document.documentElement;
    return { top: el.scrollTop, view: window.innerHeight, height: el.scrollHeight };
  }

  function insideInnerScroller(el) {
    var node = el.parentElement;
    while (node && node !== document.body) {
      var oy = window.getComputedStyle(node).overflowY;
      if (oy === "auto" || oy === "scroll") return true;
      node = node.parentElement;
    }
    return false;
  }

  // The element that carries the held height. A layout that marks its content
  // column with data-pk-collapse-pad gets the space INSIDE its own chrome, so
  // sticky sidebars and page backgrounds extend through it; anything else
  // falls back to a body-level div, which holds the scroll position just as
  // well but leaves the blank area outside the app's layout.
  function ensureSpacer() {
    if (spacer && spacer.isConnected) return spacer;

    var pad = document.querySelector("[data-pk-collapse-pad]");
    if (pad) {
      spacer = pad;
      injected = false;
    } else {
      spacer = document.createElement("div");
      spacer.setAttribute("data-pk-collapse-spacer", "");
      spacer.setAttribute("aria-hidden", "true");
      spacer.style.width = "100%";
      spacer.style.flex = "0 0 auto";
      spacer.style.pointerEvents = "none";
      document.body.appendChild(spacer);
      injected = true;
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    return spacer;
  }

  function releaseSpacer() {
    if (!spacer) return;
    if (injected) spacer.remove();
    else spacer.style.height = "";
    spacer = null;
    installedHeight = 0;
    window.removeEventListener("scroll", onScroll);
  }

  function onScroll() {
    if (!spacer) return;
    var top = scrollTopNow();
    if (top < highestTop) highestTop = top;
    var next = spacerAfterScrollUp(installedHeight, installedTop, highestTop);
    if (next <= 0) releaseSpacer();
    else spacer.style.height = next + "px";
  }

  function hold(shrink) {
    var m = metrics();
    var extra = extraSpaceNeeded(m.top, m.view, m.height, shrink);
    if (extra <= 0) return;

    ensureSpacer();

    // A second close stacks onto whatever is left and re-anchors: from here
    // on, this is the position being protected.
    installedHeight = spacer.offsetHeight + extra;
    installedTop = m.top;
    highestTop = m.top;
    spacer.style.height = installedHeight + "px";
  }

  // Runs BEFORE the default action toggles the element, so the height read
  // here is the full expanded one that is about to disappear.
  function onSummaryActivate(e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var summary = target.closest("summary");
    if (!summary) return;

    var details = summary.closest("details");
    if (!details || !details.classList.contains("collapse")) return;
    if (!details.open) return; // opening: the document only grows
    if (insideInnerScroller(details)) return;

    var shrink = details.offsetHeight - summary.offsetHeight;
    if (isFinite(shrink) && shrink > 0) hold(shrink);
  }

  document.addEventListener("click", onSummaryActivate, true);
  document.addEventListener(
    "keydown",
    function(e) {
      if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
        onSummaryActivate(e);
      }
    },
    true
  );

  // Live navigation swaps the page content and resets the scroll position;
  // whatever the old page was holding open is meaningless now.
  window.addEventListener("phx:page-loading-stop", function() {
    if (spacer && scrollTopNow() <= 0) releaseSpacer();
  });
})();

// ---------------------------------------------------------------------------
// Change cue — "that choice changed something you can't see".
// Server side: PhoenixKitWeb.Components.Core.ChangeCue.push/3, whose
// moduledoc is the reference. This is the client half.
//
// The server sends only WHAT changed (element ids). It cannot decide how to
// show it, because it doesn't know what's on screen: whether a <details> is
// open is client state, and so is the scroll position. So the client
// resolves each id, walks up to its [data-change-region], and picks:
//
//   * region open   -> highlight the changed rows. Highlighting the whole
//     region tells someone already reading it nothing.
//   * region closed -> highlight the region and MARK it. Opening it replays
//     the row highlights and clears the mark.
//
// The mark, not a timer, is what makes this survive reality. A highlight
// that plays while the reader is scrolled away is simply lost, and an
// N-second memory turns "what changed in here?" into a race against a
// stopwatch. The mark waits.
//
// Won't scroll, open anything, or move focus.
(function() {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  var STYLE_ID = "pk-change-cue-style";
  var CLASS = "pk-cued";
  var REGION = "[data-change-region]";
  var DURATION = 1400;
  var MAX_TARGETS = 6;
  var ANNOUNCE_GAP = 1000;

  // Pending rows per region id. Kept off the DOM node: LiveView can replace
  // an element between the change and the reader opening it, and state on
  // the old node would go with it.
  var pending = {};
  var lastAnnounce = 0;

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent =
      "@keyframes pk-cue-pulse {" +
      "  0% { box-shadow: 0 0 0 0 var(--pk-cue-color, oklch(0.7 0.15 250 / 0.55)); }" +
      "  70% { box-shadow: 0 0 0 6px var(--pk-cue-color, oklch(0.7 0.15 250 / 0)); }" +
      "  100% { box-shadow: 0 0 0 0 var(--pk-cue-color, oklch(0.7 0.15 250 / 0)); }" +
      "}" +
      "." + CLASS + " {" +
      "  animation: pk-cue-pulse 1.4s ease-out 1;" +
      "  border-radius: 0.5rem;" +
      "}" +
      // The marker rides the region's own state, so it survives patches
      // (the region declares data-changed client-owned) and needs no
      // server round-trip to clear.
      "[data-change-region][data-changed] [data-change-marker] { display: inline-flex; }" +
      "@media (prefers-reduced-motion: reduce) {" +
      "  ." + CLASS + " { animation: none; outline: 2px solid var(--pk-cue-color, currentColor); }" +
      "}";

    document.head.appendChild(style);
  }

  function cue(el) {
    if (!el) return;

    // Restart rather than re-add: a class an element already has changes
    // nothing, so a rapid second change would look like nothing happened.
    el.classList.remove(CLASS);
    void el.offsetWidth;
    el.classList.add(CLASS);

    window.clearTimeout(el.__pkCueTimer);
    el.__pkCueTimer = window.setTimeout(function() {
      el.classList.remove(CLASS);
    }, DURATION);
  }

  function announce(text) {
    if (!text) return;

    var now = Date.now();
    if (now - lastAnnounce < ANNOUNCE_GAP) return;
    lastAnnounce = now;

    var live = document.getElementById("pk-change-cue-status");

    if (!live) {
      live = document.createElement("div");
      live.id = "pk-change-cue-status";
      live.setAttribute("role", "status");
      live.setAttribute("aria-live", "polite");
      live.setAttribute("aria-atomic", "true");
      live.className = "sr-only";
      document.body.appendChild(live);
    }

    live.textContent = text;
  }

  function onScreen(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || 0);
  }

  // Opening a long section puts most of it below the fold, so a highlight
  // down there plays to nobody — the reader opens it, sees nothing, and
  // the cue has cost them a click and told them less than nothing. Cue
  // what is on screen now, and watch the rest until they scroll to it.
  function replay(ids) {
    var waiting = [];

    ids.forEach(function(id) {
      var el = document.getElementById(id);
      if (!el) return;

      if (onScreen(el)) {
        cue(el);
      } else {
        waiting.push(el);
      }
    });

    if (!waiting.length || typeof IntersectionObserver === "undefined") return;

    var observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          cue(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.5 }
    );

    waiting.forEach(function(el) {
      observer.observe(el);
    });

    // Don't watch forever: a section left open and never scrolled to
    // shouldn't hold observers for the life of the page.
    window.setTimeout(function() {
      observer.disconnect();
    }, 30000);
  }

  // One utterance per pushed change, however many regions it touched, and
  // only for changes the reader cannot see: an open region announces
  // itself by being visible.
  function announceOnce(payload) {
    if (payload.__announced) return;
    payload.__announced = true;
    announce(payload.announce);
  }

  function markRegion(region, ids) {
    region.setAttribute("data-changed", "");

    var key = region.getAttribute("data-change-region") || region.id;
    if (!key) return;

    var held = pending[key] || [];
    // Union: a second change while still closed adds to the answer rather
    // than replacing it.
    ids.forEach(function(id) {
      if (held.indexOf(id) === -1) held.push(id);
    });

    pending[key] = held;
  }

  function apply(payload) {
    var targets = (payload.targets || []).map(function(t) {
      // Ids alone are still accepted; the grouped form carries a fallback
      // region for targets that may not exist any more.
      return typeof t === "string" ? { id: t } : t;
    });

    if (!targets.length) return;

    ensureStyle();

    var byRegion = new Map();
    var loose = [];
    // Regions whose change REMOVED the element. There is nothing left to
    // highlight, so the region itself carries the news — and nothing is
    // queued for replay, because a missing id will still be missing when
    // they open it.
    var vanished = new Set();

    targets.forEach(function(target) {
      var el = document.getElementById(target.id);

      if (!el) {
        var anchor = target.region && document.getElementById(target.region);
        if (anchor) vanished.add(anchor);
        return;
      }

      var region = el.closest(REGION);

      if (!region) {
        loose.push(el);
        return;
      }

      if (!byRegion.has(region)) byRegion.set(region, []);
      byRegion.get(region).push(target.id);
    });

    loose.forEach(cue);

    vanished.forEach(function(region) {
      // Don't double-cue a region that also has surviving targets — those
      // are handled below, and a row highlight says more than a region one.
      if (byRegion.has(region)) return;

      cue(region);

      if (region.tagName === "DETAILS" && !region.open) {
        region.setAttribute("data-changed", "");
        announceOnce(payload);
      }
    });

    byRegion.forEach(function(regionIds, region) {
      var closed = region.tagName === "DETAILS" && !region.open;

      if (closed) {
        cue(region);
        markRegion(region, regionIds);
        announceOnce(payload);
        return;
      }

      // Past a handful, individual highlights read as strobing rather than
      // as information.
      if (regionIds.length > MAX_TARGETS) {
        cue(region);
      } else {
        regionIds.forEach(function(id) {
          cue(document.getElementById(id));
        });
      }
    });
  }

  // Opening a marked region answers the question the mark raised.
  // Capture phase: `toggle` doesn't bubble.
  document.addEventListener(
    "toggle",
    function(e) {
      var region = e.target;
      if (!region || region.tagName !== "DETAILS" || !region.open) return;
      if (!region.hasAttribute("data-changed")) return;

      var key = region.getAttribute("data-change-region") || region.id;
      var ids = (key && pending[key]) || [];

      region.removeAttribute("data-changed");
      if (key) delete pending[key];
      if (!ids.length) return;

      ensureStyle();

      // Let the reveal start first, or the highlight plays against content
      // that is still zero-height. Deliberately silent for screen readers:
      // the change was already announced when it landed.
      window.setTimeout(function() {
        replay(ids.slice(0, MAX_TARGETS));
      }, 160);
    },
    true
  );

  function clearRegions(ids) {
    ids.forEach(function(id) {
      var region = document.getElementById(id);
      if (region) region.removeAttribute("data-changed");
      delete pending[id];
    });
  }

  window.addEventListener("phx:pk:change-cue", function(event) {
    var detail = event.detail || {};
    // A region whose state went back to what the reader last saw has
    // nothing to show. Without this, flipping a choice back and forth
    // leaves every section marked.
    if (detail.clear) clearRegions(detail.clear);
    apply(detail);
  });
})();

(function() {
  if (typeof window === "undefined") return;
  window.PhoenixKitHooks = window.PhoenixKitHooks || {};

  function adopt(src) {
    if (!src) return;
    Object.keys(src).forEach(function(name) {
      if (!window.PhoenixKitHooks[name]) {
        window.PhoenixKitHooks[name] = src[name];
      }
    });
  }

  adopt(window.FrescoHooks);
  adopt(window.TesseraHooks);
  adopt(window.EtcherHooks);
})();

// ---------------------------------------------------------------------------
// MentionInput — @ pings and # record links in any plain textarea.
//
// The surface this has to reach is ~70 ordinary `<textarea>` fields, not a
// rich editor, so this attaches to the field itself and owns nothing else.
// It watches for a trigger character at a word boundary, tracks the query
// the user types after it, asks the server, and renders a small list
// anchored under the caret.
//
// The server decides WHAT can be inserted; this decides only where the menu
// sits and when it closes. Everything it inserts is a complete token, so a
// half-typed mention is always just text.
//
// State is per-hook-instance, never global: several LiveViews can share a
// page, and two textareas on one page must not fight over one menu.
// ---------------------------------------------------------------------------
(function() {
  if (typeof window === "undefined") return;
  window.PhoenixKitHooks = window.PhoenixKitHooks || {};

  // A trigger only counts at the start of a word. Without this, an email
  // address turns the rest of the line into a search box.
  function triggerAt(value, caret) {
    var i = caret - 1;
    while (i >= 0) {
      var ch = value[i];
      if (ch === "@" || ch === "#") {
        var before = i === 0 ? " " : value[i - 1];
        if (/[\s(\[]/.test(before) || i === 0) {
          return { char: ch, start: i, query: value.slice(i + 1, caret) };
        }
        return null;
      }
      // A query is one short run of ordinary characters. Newlines and the
      // token's own delimiters end it, so an unclosed menu can't swallow a
      // paragraph.
      if (/[\n\r\]|]/.test(ch)) return null;
      if (caret - i > 40) return null;
      i--;
    }
    return null;
  }

  // Where a character of the textarea's value sits, in pixels from the
  // field's top-left corner (scrolling already subtracted): a hidden mirror
  // with the field's own type and box metrics holds the text up to that
  // index and a marker span from there on, so the marker lands where the
  // character does. The menu opens under the `@`/`#` itself, not under the
  // whole field.
  var MIRROR_PROPS = [
    "boxSizing", "width", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft",
    "borderTopWidth", "borderRightWidth", "borderBottomWidth", "borderLeftWidth",
    "fontFamily", "fontSize", "fontWeight", "fontStyle", "fontVariant", "letterSpacing",
    "lineHeight", "textTransform", "wordSpacing", "textIndent", "tabSize", "textRendering"
  ];

  function charBox(el, index) {
    var cs = window.getComputedStyle(el);
    var mirror = document.createElement("div");
    MIRROR_PROPS.forEach(function(prop) { mirror.style[prop] = cs[prop]; });
    mirror.style.position = "absolute";
    mirror.style.visibility = "hidden";
    mirror.style.top = "0";
    mirror.style.left = "-9999px";
    mirror.style.height = "auto";
    mirror.style.overflow = "hidden";
    mirror.style.whiteSpace = "pre-wrap";
    mirror.style.overflowWrap = "break-word";
    mirror.setAttribute("aria-hidden", "true");
    mirror.textContent = el.value.slice(0, index);
    var marker = document.createElement("span");
    marker.textContent = el.value.slice(index) || ".";
    mirror.appendChild(marker);
    document.body.appendChild(mirror);
    var lineHeight = parseFloat(cs.lineHeight);
    var box = {
      top: marker.offsetTop + (parseFloat(cs.borderTopWidth) || 0) - el.scrollTop,
      left: marker.offsetLeft + (parseFloat(cs.borderLeftWidth) || 0) - el.scrollLeft,
      height: isNaN(lineHeight) ? marker.offsetHeight || 16 : lineHeight
    };
    document.body.removeChild(mirror);
    return box;
  }

  window.PhoenixKitHooks.MentionInput = {
    mounted: function() {
      var self = this;
      this.el.setAttribute("autocomplete", "off");
      this.active = null;
      this.results = [];
      this.cursor = 0;
      this.seq = 0;

      this.menu = document.createElement("ul");
      this.menu.className =
        "pk-mention-menu menu menu-sm bg-base-100 rounded-box shadow-lg border border-base-300 " +
        "absolute z-[9999] hidden max-h-64 overflow-y-auto w-72 p-1";
      this.menu.setAttribute("role", "listbox");
      document.body.appendChild(this.menu);

      // A field inside an open <dialog> (a popup shown with showModal())
      // sits in the browser's top layer, which paints over everything
      // outside it whatever its z-index — a menu left on <body> is there,
      // open, and invisible behind the popup; and a modal dialog makes
      // everything outside it inert, so a top-layer popover on <body> is
      // painted but takes no click (measured in Chrome, 2026-10-05). The
      // menu therefore lives INSIDE the open dialog while the field is in
      // one, as a manual popover — the top layer paints it over the
      // dialog's own content, and as a dialog descendant it is not inert.
      // The dialog is LiveView's to patch, and a patch discards any node it
      // did not render: a MutationObserver puts the menu back the moment
      // that happens, before the frame is painted.
      this.popover = typeof this.menu.showPopover === "function";
      if (this.popover) {
        this.menu.setAttribute("popover", "manual");
        // The UA sheet centres a popover (inset: 0; margin: auto) and gives
        // it a border, padding and colours of its own.
        this.menu.style.inset = "auto";
        this.menu.style.margin = "0";
        this.menu.style.position = "fixed";
      }

      this.host = function() {
        var dialog = self.el.closest ? self.el.closest("dialog") : null;
        return dialog && dialog.open ? dialog : document.body;
      };

      this.mount = function() {
        var host = self.host();
        if (self.menu.parentNode !== host) host.appendChild(self.menu);
        // Viewport coordinates whenever the menu does not scroll with the
        // document: in the top layer, or inside a fixed dialog.
        self.fixed = self.popover || host !== document.body;
        if (!self.popover) self.menu.style.position = self.fixed ? "fixed" : "";
        self.observe(host);
      };

      this.observe = function(host) {
        if (self.observedHost === host) return;
        if (self.observer) self.observer.disconnect();
        self.observer = null;
        self.observedHost = host;
        if (host === document.body || typeof MutationObserver !== "function") return;
        self.observer = new MutationObserver(function() {
          if (!self.active || self.menu.parentNode === host || !host.isConnected) return;
          host.appendChild(self.menu);
          // Leaving the DOM closed the popover; back in, it reopens.
          self.show();
        });
        self.observer.observe(host, { childList: true });
      };

      this.show = function() {
        self.menu.classList.remove("hidden");
        if (self.popover && self.menu.isConnected !== false && !self.menu.matches(":popover-open")) {
          self.menu.showPopover();
        }
      };

      this.hide = function() {
        if (self.popover && self.menu.matches(":popover-open")) self.menu.hidePopover();
        self.menu.classList.add("hidden");
      };

      this.close = function() {
        self.active = null;
        self.results = [];
        self.cursor = 0;
        self.hide();
      };

      this.render = function() {
        if (!self.active || !self.results.length) {
          self.hide();
          return;
        }
        self.menu.innerHTML = "";
        self.results.forEach(function(r, idx) {
          var li = document.createElement("li");
          var a = document.createElement("a");
          a.className = idx === self.cursor ? "active" : "";
          a.setAttribute("role", "option");
          var title = document.createElement("span");
          title.className = "font-medium truncate";
          title.textContent = r.title;
          a.appendChild(title);
          if (r.subtitle) {
            var sub = document.createElement("span");
            sub.className = "text-xs opacity-60 truncate";
            sub.textContent = r.subtitle;
            a.appendChild(sub);
          }
          // mousedown, not click: click fires after blur, and blur has
          // already closed the menu by then.
          a.addEventListener("mousedown", function(e) {
            e.preventDefault();
            self.choose(idx);
          });
          li.appendChild(a);
          self.menu.appendChild(li);
        });
        // Shown first, so the menu has a size to place.
        self.mount();
        self.show();
        self.position();
      };

      // The trigger character's box in the field — overridable, so the
      // placement arithmetic can be exercised without a layout engine.
      this.anchor = function() {
        var index = self.active ? self.active.start : self.el.selectionStart || 0;
        return charBox(self.el, index);
      };

      // Under the `@`/`#` the user typed: its line's bottom, its column —
      // kept inside the field's width and the viewport, and flipped above
      // the line when there is no room below.
      this.position = function() {
        self.mount();
        var rect = self.el.getBoundingClientRect();
        var box = self.anchor();
        var scrollY = self.fixed ? 0 : window.scrollY;
        var scrollX = self.fixed ? 0 : window.scrollX;
        var viewportWidth = document.documentElement.clientWidth;
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        var width = self.menu.offsetWidth || 0;
        var height = self.menu.offsetHeight || 0;

        var lineTop = rect.top + Math.max(0, Math.min(box.top, rect.height - box.height));
        var top = lineTop + box.height + 2;
        if (viewportHeight && top + height > viewportHeight - 8 && lineTop - height - 2 >= 8) {
          top = lineTop - height - 2;
        }
        var left = rect.left + Math.max(0, Math.min(box.left, rect.width));
        var maxLeft = viewportWidth - width - 8;

        self.menu.style.top = top + scrollY + "px";
        self.menu.style.left = Math.max(8, Math.min(left, maxLeft)) + scrollX + "px";
      };

      this.choose = function(idx) {
        var r = self.results[idx];
        if (!r || !self.active) return;
        var value = self.el.value;
        var before = value.slice(0, self.active.start);
        var after = value.slice(self.el.selectionStart);
        // The server sends the finished token: building it here by
        // concatenation produced something unparseable whenever a
        // record's own name contained a `|` or a `]`.
        var token = r.token;
        if (!token) return;
        self.el.value = before + token + " " + after;
        var caret = (before + token + " ").length;
        self.el.setSelectionRange(caret, caret);
        self.close();
        // The field is inside a phx-change form; without this the server
        // never sees the inserted token and the next save writes the old
        // text back over it.
        self.el.dispatchEvent(new Event("input", { bubbles: true }));
        self.el.focus();
      };

      // The page's context for the search, from `data-mention-context`;
      // null when the field carries none or the JSON is broken.
      this.context = function() {
        var raw = self.el.dataset ? self.el.dataset.mentionContext : null;
        if (!raw) return null;
        try {
          var parsed = JSON.parse(raw);
          return parsed && typeof parsed === "object" ? parsed : null;
        } catch (_e) {
          return null;
        }
      };

      this.search = function() {
        var caret = self.el.selectionStart;
        var found = triggerAt(self.el.value, caret);
        if (!found) {
          self.close();
          return;
        }
        self.active = found;
        self.seq += 1;
        var seq = self.seq;
        self.pushEvent(
          "pk_mention_search",
          {
            kind: found.char === "@" ? "user" : "resource",
            query: found.query,
            seq: seq,
            // Where the field is: `data-mention-context` (JSON) names the
            // record the page is about, so a `#` offers what belongs with
            // it rather than everything the viewer may see.
            context: self.context()
          },
          function(reply) {
            // Out-of-order replies: the user kept typing while this one was
            // in flight, so its results describe a query that no longer
            // exists. Dropping them stops the list flickering backwards.
            if (!reply || reply.seq !== self.seq) return;
            self.results = reply.results || [];
            self.cursor = 0;
            self.render();
          }
        );
      };

      this.onInput = function() { self.search(); };

      this.onKeyDown = function(e) {
        if (!self.active || !self.results.length) {
          if (e.key === "Escape") self.close();
          return;
        }
        if (e.key === "ArrowDown") {
          e.preventDefault();
          self.cursor = (self.cursor + 1) % self.results.length;
          self.render();
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          self.cursor = (self.cursor - 1 + self.results.length) % self.results.length;
          self.render();
        } else if (e.key === "Enter" || e.key === "Tab") {
          e.preventDefault();
          self.choose(self.cursor);
        } else if (e.key === "Escape") {
          e.preventDefault();
          self.close();
        }
      };

      this.onBlur = function() { window.setTimeout(self.close, 120); };

      this.el.addEventListener("input", this.onInput);
      this.el.addEventListener("click", this.onInput);
      this.el.addEventListener("keydown", this.onKeyDown);
      this.el.addEventListener("blur", this.onBlur);
      this.repositionHandler = function() { if (self.active) self.position(); };
      window.addEventListener("scroll", this.repositionHandler, true);
      window.addEventListener("resize", this.repositionHandler);
    },

    destroyed: function() {
      // The menu lives on document.body, so it outlives the hook's element
      // unless it is taken down explicitly — a LiveView patch that replaces
      // the textarea would otherwise leave an orphan floating over the page.
      if (this.observer) this.observer.disconnect();
      if (this.menu && this.hide) this.hide();
      if (this.menu && this.menu.parentNode) this.menu.parentNode.removeChild(this.menu);
      window.removeEventListener("scroll", this.repositionHandler, true);
      window.removeEventListener("resize", this.repositionHandler);
    }
  };
})();


// ============================================================================
// UploadStats - live transfer stats under upload progress bars
// ============================================================================
//
// Attached to a text element rendered next to a LiveView upload entry's
// progress bar. The server only patches `data-progress` (0-100); everything
// shown is computed in the browser, so the numbers reflect the network as the
// user experiences it:
//
//   uploading:   "3.2 MB / 12.4 MB · 2.8 MB/s · 4s left"
//   at 100%:     "12.4 MB · Processing on server… 3s"   (tick continues while
//                the server consumes the entry and the bar sits frozen)
//
// Markup contract: id (required for hooks), data-progress={entry.progress},
// data-size={entry.client_size}, plus gettext'd labels in
// data-label-processing / data-label-left. The hook owns the element's text.
(function() {
  "use strict";

  // Decimal units, matching the Elixir-side Format.bytes(base: 1000) used in
  // the media file listings.
  function formatBytes(n) {
    if (!isFinite(n) || n < 0) n = 0;
    if (n < 1000) return Math.round(n) + " B";
    var units = ["KB", "MB", "GB", "TB"];
    var v = n;
    for (var i = 0; i < units.length; i++) {
      v = v / 1000;
      if (v < 1000 || i === units.length - 1) {
        return (v >= 100 ? String(Math.round(v)) : v.toFixed(1)) + " " + units[i];
      }
    }
  }

  function formatDuration(ms) {
    var s = Math.max(0, Math.round(ms / 1000));
    if (s < 60) return s + "s";
    var m = Math.floor(s / 60);
    if (m < 60) return m + "m " + (s % 60) + "s";
    var h = Math.floor(m / 60);
    return h + "h " + (m % 60) + "m";
  }

  // Transfer rate in bytes/sec over a trailing window. `samples` is an
  // ordered list of {t (ms), bytes} pairs. The denominator ends at `now`,
  // not at the last sample, so a stalled transfer decays toward 0 instead
  // of freezing at its last good speed.
  function windowSpeed(samples, now, windowMs) {
    windowMs = windowMs || 5000;
    if (!samples || samples.length < 2) return 0;
    var latest = samples[samples.length - 1];
    var cutoff = now - windowMs;
    // Baseline: the newest sample before `latest` that falls outside the
    // window (anchors the span as the window slides), or the oldest sample
    // we still hold. Never `latest` itself — during a hard stall every
    // sample is old, and the span must still run from real data to `now`
    // so the rate decays rather than snapping to 0.
    var base = latest;
    for (var i = samples.length - 2; i >= 0; i--) {
      base = samples[i];
      if (samples[i].t < cutoff) break;
    }
    if (base === latest) return 0;
    var seconds = (now - base.t) / 1000;
    if (seconds <= 0) return 0;
    return Math.max(0, (latest.bytes - base.bytes) / seconds);
  }

  // The whole line as a pure function of the tracked state (node-testable).
  function uploadStatsText(opts) {
    var labels = opts.labels || {};
    if (opts.doneAt != null) {
      var label = labels.processing || "Processing on server…";
      return formatBytes(opts.size) + " · " + label + " " +
        formatDuration(opts.now - opts.doneAt);
    }
    var parts = [formatBytes(opts.bytes) + " / " + formatBytes(opts.size)];
    var speed = windowSpeed(opts.samples, opts.now);
    if (speed > 0) {
      parts.push(formatBytes(speed) + "/s");
      var etaMs = (Math.max(0, opts.size - opts.bytes) / speed) * 1000;
      if (isFinite(etaMs)) parts.push(formatDuration(etaMs) + " " + (labels.left || "left"));
    }
    return parts.join(" · ");
  }

  window.PhoenixKitHooks.UploadStats = {
    mounted() {
      this.size = parseInt(this.el.dataset.size || "0", 10) || 0;
      this.samples = [];
      this.bytes = 0;
      this.doneAt = null;
      this.sample();
      var self = this;
      // The interval keeps elapsed/ETA moving between LiveView patches —
      // that is what makes a stall or a long server phase visibly tick.
      this.timer = setInterval(function() { self.render(); }, 500);
      this.render();
    },

    updated() {
      this.sample();
      this.render();
    },

    sample() {
      var progress = parseFloat(this.el.dataset.progress || "0") || 0;
      var now = Date.now();
      this.bytes = Math.round(this.size * Math.min(progress, 100) / 100);
      if (progress >= 100 && this.doneAt == null) this.doneAt = now;
      var last = this.samples[this.samples.length - 1];
      if (!last || last.bytes !== this.bytes) {
        this.samples.push({ t: now, bytes: this.bytes });
        // Progress events arrive per chunk; keep enough to cover the speed
        // window at any realistic event rate without growing unbounded.
        if (this.samples.length > 128) this.samples.shift();
      }
    },

    render() {
      this.el.textContent = uploadStatsText({
        size: this.size,
        bytes: this.bytes,
        samples: this.samples,
        now: Date.now(),
        doneAt: this.doneAt,
        labels: {
          processing: this.el.dataset.labelProcessing,
          left: this.el.dataset.labelLeft
        }
      });
    },

    destroyed() {
      clearInterval(this.timer);
    }
  };

  if (typeof module === "object" && module.exports) {
    module.exports.formatBytes = formatBytes;
    module.exports.formatDuration = formatDuration;
    module.exports.windowSpeed = windowSpeed;
    module.exports.uploadStatsText = uploadStatsText;
  }
})();

// ============================================================================
// UploadGuard - native leave-page guard while uploads are in flight
// ============================================================================
//
// Attached to an upload component's root. The server patches
// `data-active` ("true" while any upload entry exists); while active, the
// browser's own beforeunload dialog blocks an accidental refresh / tab
// close that would kill the transfer (interrupted LiveView uploads are not
// resumed). This replaces disclaimer prose with actual protection. Note it
// guards full page unloads only — LiveView patch/navigate stays free.
(function() {
  "use strict";

  window.PhoenixKitHooks = window.PhoenixKitHooks || {};

  window.PhoenixKitHooks.UploadGuard = {
    mounted() {
      var self = this;
      this.handler = function(e) {
        if (self.el.dataset.active === "true") {
          e.preventDefault();
          // Chrome requires returnValue to show the dialog; the text is
          // browser-controlled either way.
          e.returnValue = "";
        }
      };
      window.addEventListener("beforeunload", this.handler);
    },

    destroyed() {
      window.removeEventListener("beforeunload", this.handler);
    }
  };
})();


// ============================================================================
// CONTEXT MENU HOOK
// ============================================================================
//
// Desktop-style context menu: right-click (or touch-and-hold) an element the
// menu selects, and an action menu opens at the pointer.
//
// One menu element serves every row it matches — a tree of five hundred nodes
// renders one hidden <ul>, not five hundred. On open the hook finds the row
// under the pointer, copies its identifier onto every item's `phx-value-*`,
// and positions the menu. Opening costs no round-trip; the event fired
// afterwards still carries the right target.
//
// Config comes from data attributes on the hook element (see the
// Core.ContextMenu component):
//   data-context-selector       CSS selector for the rows
//   data-context-within         optional container selector
//   data-context-value-attr     row attribute holding the identifier
//   data-context-value-name     stamped as phx-value-<name>
//   data-context-label-attr     row attribute holding the menu heading
//   data-context-long-press     "false" disables the touch gesture
//   data-context-long-press-ms  hold duration, default 450
//
(function() {
  "use strict";

  window.PhoenixKitHooks = window.PhoenixKitHooks || {};

  // Every mounted menu registers here and one document-level listener serves
  // them all. That is what lets a right-click matched by two menus (a note row
  // nested inside a folder row) pick the DEEPEST match instead of letting DOM
  // order decide it.
  var menus = [];
  var listening = false;
  var openMenu = null;

  // Android fires a native `contextmenu` at the end of a long press, on top of
  // our own timer. Remember when we opened so the native one is swallowed
  // rather than reopening (and re-vibrating).
  var lastLongPressAt = 0;
  // The release after a long press dispatches a click on the row. Eat it, or
  // holding a row also activates it.
  var swallowClick = false;

  var MOVE_TOLERANCE = 10;
  var NATIVE_MENU_GRACE_MS = 800;
  var SWALLOW_CLICK_MS = 700;

  function depthOf(el) {
    var d = 0;
    while ((el = el.parentElement)) d++;
    return d;
  }

  // Where a menu of w x h opens for a pointer at (x, y) in a vw x vh viewport.
  // Down-right of the pointer by default; flips to the other side of it rather
  // than overflowing, then clamps for a menu too big to fit either way.
  //
  // One implementation, shared with RowMenu's right-click path
  // (`window.PhoenixKitMenus.pointerPosition`, defined in the hooks IIFE
  // above): a right-click menu and a row menu opened by right-click must land
  // in the same place, and a second copy of this arithmetic would drift.
  // Still a local name, and still exported, so test/js/context_menu.test.cjs
  // exercises the shared rule.
  function contextMenuPosition(x, y, w, h, vw, vh) {
    return window.PhoenixKitMenus.pointerPosition(x, y, w, h, vw, vh);
  }

  function rowFor(menu, target) {
    if (!target || !target.closest) return null;
    var row = target.closest(menu.selector);
    if (!row) return null;
    if (menu.within) {
      // closest(), not querySelector(): a class-based `within` routinely
      // matches several containers, and taking only the first left rows in
      // the others with no menu at all.
      if (!row.closest(menu.within)) return null;
    }
    return row;
  }

  function bestMatch(target) {
    var best = null;
    for (var i = 0; i < menus.length; i++) {
      var row = rowFor(menus[i], target);
      if (!row) continue;
      var d = depthOf(row);
      if (!best || d > best.depth) best = { menu: menus[i], row: row, depth: d };
    }
    return best;
  }

  function closeOpen() {
    if (openMenu) openMenu._close();
  }

  // ---- long press (touch/pen only — a mouse gets `contextmenu`) ------------

  var lpTimer = null, lpX = 0, lpY = 0, swallowTimer = null;

  function cancelLongPress() {
    if (lpTimer) { clearTimeout(lpTimer); lpTimer = null; }
  }

  function onPointerDown(e) {
    if (e.pointerType === "mouse") return;
    var m = bestMatch(e.target);
    if (!m || !m.menu.longPress) return;
    lpX = e.clientX;
    lpY = e.clientY;
    cancelLongPress();
    lpTimer = setTimeout(function() {
      lpTimer = null;
      // The hook may have been destroyed during the press (a patch, a stream
      // reset). Opening now would append a detached menu to <body> and leave
      // it there.
      if (menus.indexOf(m.menu) === -1) return;
      lastLongPressAt = Date.now();
      swallowClick = true;
      // Cleared on the click too; this is the backstop for a release that
      // dispatches no click at all, which would otherwise eat the user's
      // next tap (the menu item they came for). Tracked, so a second long
      // press inside the window cannot have its flag cleared by the first
      // press's backstop.
      if (swallowTimer) clearTimeout(swallowTimer);
      swallowTimer = setTimeout(function() {
        swallowTimer = null;
        swallowClick = false;
      }, SWALLOW_CLICK_MS);
      if (navigator.vibrate) { try { navigator.vibrate(30); } catch (_) {} }
      m.menu._open(m.row, lpX, lpY);
    }, m.menu.longPressMs);
  }

  function onPointerMove(e) {
    if (!lpTimer) return;
    if (Math.abs(e.clientX - lpX) > MOVE_TOLERANCE ||
        Math.abs(e.clientY - lpY) > MOVE_TOLERANCE) {
      cancelLongPress();
    }
  }

  // ---- document listeners --------------------------------------------------

  function onContextMenu(e) {
    cancelLongPress();
    if (openMenu && Date.now() - lastLongPressAt < NATIVE_MENU_GRACE_MS) {
      // Our own menu is already open from the long press. Gated on openMenu:
      // if it was dismissed (Escape) the grace window must not go on
      // suppressing the browser's menu with nothing shown in its place.
      e.preventDefault();
      return;
    }
    var m = bestMatch(e.target);
    if (!m) {
      // No row here. A `contextmenu` produces no click, and the mouse path
      // arms no long press, so nothing else would take the open menu down —
      // it would sit under the browser's native one.
      closeOpen();
      return;
    }
    e.preventDefault();
    m.menu._open(m.row, e.clientX, e.clientY);
  }

  // Capture phase, so this runs before an item's own click handler.
  function onDocClick(e) {
    if (swallowClick) {
      swallowClick = false;
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (!openMenu) return;
    // Tested against the menu element, not the hook element: the menu is
    // portaled to <body> while open, so it is no longer a descendant of the
    // hook. Treating an item click as "outside" would close the menu and move
    // it mid-dispatch — WebKit then drops the in-flight click and the item's
    // action never runs.
    if (!openMenu.menuEl.contains(e.target)) openMenu._close();
  }

  function onKeydown(e) {
    if (!openMenu) return;
    if (e.key === "Escape") {
      e.preventDefault();
      openMenu._close();
      return;
    }
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      var items = Array.prototype.slice.call(
        openMenu.menuEl.querySelectorAll("[role='menuitem']:not([disabled])")
      );
      if (items.length === 0) return;
      var idx = items.indexOf(document.activeElement);
      var next = e.key === "ArrowDown"
        ? (idx + 1) % items.length
        : (idx - 1 + items.length) % items.length;
      items[next].focus();
    }
  }

  function install() {
    if (listening) return;
    listening = true;
    document.addEventListener("contextmenu", onContextMenu);
    // Permanent, not tied to a menu being open: the post-long-press click has
    // to be swallowed even when the menu was closed again in between (Escape,
    // a scroll, an Android resize), or the row underneath activates — the very
    // thing the swallow exists to prevent. onDocClick no-ops when idle.
    document.addEventListener("click", onDocClick, true);
    document.addEventListener("pointerdown", onPointerDown, true);
    document.addEventListener("pointermove", onPointerMove, true);
    document.addEventListener("pointerup", cancelLongPress, true);
    document.addEventListener("pointercancel", cancelLongPress, true);
  }

  // ---- the hook ------------------------------------------------------------

  window.PhoenixKitHooks.ContextMenu = {
    mounted() {
      this.menuEl = this.el.querySelector("[data-context-menu-content]");
      if (!this.menuEl) return;
      this.labelEl = this.menuEl.querySelector("[data-context-menu-label]");
      this.isOpen = false;

      // Where the menu lives when closed, so it can be put back — LiveView's
      // diff patching has to find it there on the next update.
      this._homeParent = this.menuEl.parentNode;
      this._homeNextSibling = this.menuEl.nextSibling;

      this._readConfig();

      this._onMenuClick = () => { this._close(); };
      this.menuEl.addEventListener("click", this._onMenuClick);

      menus.push(this);
      install();
    },

    updated() {
      this._readConfig();
      // While open the menu is portaled to <body>, so morphdom re-creates a
      // duplicate in the wrapper. Drop it: the portaled node is the one
      // carrying the current stamps.
      if (this.isOpen) {
        var dup = this.el.querySelector("[data-context-menu-content]");
        if (dup && dup !== this.menuEl) dup.remove();
      }
    },

    destroyed() {
      // Cancel first: the pending timer captured this menu, so without it a
      // press in flight would open a detached menu into <body> 450ms later.
      cancelLongPress();
      this._close();
      if (this.menuEl && this._onMenuClick) {
        this.menuEl.removeEventListener("click", this._onMenuClick);
      }
      var i = menus.indexOf(this);
      if (i !== -1) menus.splice(i, 1);
    },

    _readConfig() {
      var d = this.el.dataset;
      this.selector = d.contextSelector;
      this.within = d.contextWithin || null;
      this.valueAttr = d.contextValueAttr || "data-context-value";
      // Comma-separated: a menu whose items were written against handlers that
      // spell the param differently ("folder-uuid" for one, "folder_uuid" for
      // another) stamps both rather than making the consumer add a shim clause.
      this.valueNames = (d.contextValueName || "uuid")
        .split(",")
        .map(function(n) { return n.trim(); })
        .filter(Boolean);
      this.labelAttr = d.contextLabelAttr || null;
      this.longPress = d.contextLongPress !== "false";
      this.longPressMs = parseInt(d.contextLongPressMs, 10) || 450;
    },

    // Copy the row's identifier onto every item, so the event a click fires
    // names the row that was right-clicked. LiveView reads `phx-value-*` off
    // the clicked element at click time, which is after this runs.
    _stamp(row) {
      var value = row.getAttribute(this.valueAttr);
      var items = this.menuEl.querySelectorAll("[role='menuitem']");
      for (var i = 0; i < items.length; i++) {
        for (var n = 0; n < this.valueNames.length; n++) {
          var name = "phx-value-" + this.valueNames[n];
          if (value === null) items[i].removeAttribute(name);
          else items[i].setAttribute(name, value);
        }
      }

      if (this.labelEl) {
        var label = this.labelAttr ? row.getAttribute(this.labelAttr) : null;
        if (label) {
          this.labelEl.textContent = label;
          this.labelEl.classList.remove("hidden");
        } else {
          this.labelEl.classList.add("hidden");
        }
      }
    },

    _open(row, x, y) {
      if (openMenu && openMenu !== this) openMenu._close();

      this._stamp(row);

      // Portal to <body> before measuring: inside a <dialog> or any ancestor
      // with transform/contain/filter, `position: fixed` resolves against that
      // ancestor rather than the viewport, and the menu lands off-screen.
      if (this.menuEl.parentNode !== document.body) {
        document.body.appendChild(this.menuEl);
      }
      this.menuEl.classList.remove("hidden");

      var pos = contextMenuPosition(
        x,
        y,
        this.menuEl.offsetWidth || 176,
        this.menuEl.offsetHeight || 200,
        window.innerWidth,
        window.innerHeight
      );
      this.menuEl.style.left = pos.left + "px";
      this.menuEl.style.top = pos.top + "px";

      this.isOpen = true;
      openMenu = this;

      document.addEventListener("keydown", onKeydown);
      document.addEventListener("scroll", closeOpen, true);
      window.addEventListener("resize", closeOpen);

      var first = this.menuEl.querySelector("[role='menuitem']");
      if (first) first.focus();
    },

    _close() {
      if (!this.isOpen) return;
      this.menuEl.classList.add("hidden");
      this.isOpen = false;
      if (openMenu === this) openMenu = null;

      document.removeEventListener("keydown", onKeydown);
      document.removeEventListener("scroll", closeOpen, true);
      window.removeEventListener("resize", closeOpen);

      // Put the menu back where the server rendered it, or morphdom sees a
      // missing element, re-creates it, and the next open finds a stale node.
      if (this._homeParent && this.menuEl.parentNode !== this._homeParent) {
        if (this._homeNextSibling && this._homeNextSibling.parentNode === this._homeParent) {
          this._homeParent.insertBefore(this.menuEl, this._homeNextSibling);
        } else {
          this._homeParent.appendChild(this.menuEl);
        }
      }
    }
  };

  if (typeof module === "object" && module.exports) {
    module.exports.contextMenuPosition = contextMenuPosition;
  }
})();

// ---------------------------------------------------------------------------
// AvatarCrop — the non-destructive avatar crop editor.
//
// The crop is data (focal point x/y, zoom, aspect ratio), applied as CSS by
// the server-rendered avatar component; this hook is only the editor for
// those four numbers. Drag pans the focal point, the slider and the wheel
// zoom toward it, and the end of every gesture pushes the current values to
// the owning LiveComponent (the element carries phx-target) so "Save"
// persists exactly what the preview shows.
//
// avatarCropLayout mirrors PhoenixKit.Users.AvatarCrop.layout/1 — the
// preview must use the same math the avatar later renders with, or the
// saved crop drifts from what the person approved. Change one, change both.
// ---------------------------------------------------------------------------
(function () {
  if (window.PhoenixKitAvatarCrop) return;
  window.PhoenixKitAvatarCrop = true;
  window.PhoenixKitHooks = window.PhoenixKitHooks || {};

  function clamp(v, lo, hi) {
    return Math.min(hi, Math.max(lo, v));
  }

  // The image's placement inside its square frame, in percent of the frame.
  // Mirror of PhoenixKit.Users.AvatarCrop.layout/1.
  function avatarCropLayout(crop) {
    var zoom = crop.zoom;
    var ar = crop.ar;
    var width, height;
    if (ar >= 1) {
      width = 100 * zoom * ar;
      height = 100 * zoom;
    } else {
      width = 100 * zoom;
      height = (100 * zoom) / ar;
    }
    return {
      width: width,
      height: height,
      left: clamp(50 - crop.x * width, 100 - width, 0),
      top: clamp(50 - crop.y * height, 100 - height, 0)
    };
  }

  // Focal coordinates that would render clamped are snapped back into the
  // reachable range, so a drag never has a dead zone at the edges: with the
  // image W% wide, the frame center can only sit between 50/W and 1 - 50/W
  // of the image (the whole axis collapses to 0.5 when the image just fits).
  function clampAvatarCropFocal(crop) {
    var l = avatarCropLayout(crop);
    var x = l.width <= 100 ? 0.5 : clamp(crop.x, 50 / l.width, 1 - 50 / l.width);
    var y = l.height <= 100 ? 0.5 : clamp(crop.y, 50 / l.height, 1 - 50 / l.height);
    return { x: x, y: y, zoom: crop.zoom, ar: crop.ar };
  }

  window.PhoenixKitHooks.AvatarCrop = {
    mounted() {
      var self = this;
      var maxZoom = parseFloat(this.el.dataset.maxZoom || "8");

      var stored = {};
      try {
        stored = JSON.parse(this.el.dataset.crop || "{}") || {};
      } catch (_e) {
        stored = {};
      }

      this.crop = {
        x: typeof stored.x === "number" ? stored.x : 0.5,
        y: typeof stored.y === "number" ? stored.y : 0.5,
        zoom: typeof stored.zoom === "number" ? stored.zoom : 1,
        ar: typeof stored.ar === "number" ? stored.ar : 1
      };

      this.frame = this.el.querySelector("[data-crop-frame]");
      this.img = this.el.querySelector("[data-crop-img]");
      this.slider = this.el.querySelector("[data-crop-zoom]");

      // The stored aspect ratio was captured from this same file, but the
      // image itself is the authority once it arrives — a freshly picked
      // avatar has no stored crop and starts from ar = 1 until then.
      var adoptNaturalRatio = function () {
        if (self.img.naturalWidth > 0 && self.img.naturalHeight > 0) {
          var ar = self.img.naturalWidth / self.img.naturalHeight;
          // Only bother the server when the truth differs from the stored
          // value — on a reopened editor they already match.
          if (Math.abs(ar - self.crop.ar) > 0.001) {
            self.crop.ar = ar;
            self._render();
            self._push();
          } else {
            self._render();
          }
        }
      };
      if (this.img.complete && this.img.naturalWidth > 0) {
        adoptNaturalRatio();
      } else {
        this.img.addEventListener("load", adoptNaturalRatio);
      }

      if (this.slider) {
        this.slider.value = String(this.crop.zoom);
        this.slider.addEventListener("input", function () {
          // About the frame's centre: what is in the middle stays there.
          var r = self.frame.getBoundingClientRect();
          self._zoomAt(r.left + r.width / 2, r.top + r.height / 2, parseFloat(self.slider.value) || 1);
        });
        this.slider.addEventListener("change", function () {
          self._push();
        });
      }

      // Zoom to `zoom`, keeping the image point under (clientX, clientY)
      // where it is on screen — the way a photo app zooms toward the cursor
      // or the fingers. The slider passes the frame's centre.
      this._zoomAt = function (clientX, clientY, zoom) {
        var rect = self.frame.getBoundingClientRect();
        if (!(rect.width > 0 && rect.height > 0)) return;
        var px = ((clientX - rect.left) / rect.width) * 100;
        var py = ((clientY - rect.top) / rect.height) * 100;
        var before = avatarCropLayout(self.crop);
        var u = (px - before.left) / before.width;
        var v = (py - before.top) / before.height;
        self.crop.zoom = clamp(zoom, 1, maxZoom);
        var after = avatarCropLayout(self.crop);
        self.crop.x = (50 - (px - u * after.width)) / after.width;
        self.crop.y = (50 - (py - v * after.height)) / after.height;
        self.crop = clampAvatarCropFocal(self.crop);
        if (self.slider) self.slider.value = String(self.crop.zoom);
        self._render();
      };

      // Pan by a screen distance: moving the image right means the point
      // being looked at sits further LEFT in the image.
      this._panBy = function (dx, dy, rect) {
        var l = avatarCropLayout(self.crop);
        self.crop.x -= dx / ((rect.width * l.width) / 100);
        self.crop.y -= dy / ((rect.height * l.height) / 100);
        self.crop = clampAvatarCropFocal(self.crop);
        self._render();
      };

      // One pointer pans; two (fingers on a phone) pinch to zoom about
      // their midpoint and pan as the midpoint moves.
      var pointers = {};
      var gesture = null;
      var pointerList = function () {
        return Object.keys(pointers).map(function (k) { return pointers[k]; });
      };
      var startGesture = function () {
        var list = pointerList();
        var rect = self.frame.getBoundingClientRect();
        if (list.length >= 2) {
          var a = list[0], b = list[1];
          gesture = {
            rect: rect,
            dist: Math.hypot(b.x - a.x, b.y - a.y) || 1,
            mid: { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }
          };
        } else if (list.length === 1) {
          gesture = { rect: rect, last: { x: list[0].x, y: list[0].y } };
        } else {
          gesture = null;
        }
      };
      this._onPointerDown = function (e) {
        if (e.pointerType === "mouse" && e.button !== 0) return;
        e.preventDefault();
        pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
        try { self.frame.setPointerCapture(e.pointerId); } catch (_e) {}
        self.frame.style.cursor = "grabbing";
        startGesture();
      };
      this._onPointerMove = function (e) {
        if (!pointers[e.pointerId] || !gesture) return;
        pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
        var list = pointerList();
        if (list.length >= 2 && gesture.dist) {
          var a = list[0], b = list[1];
          var dist = Math.hypot(b.x - a.x, b.y - a.y) || 1;
          var mid = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
          self._panBy(mid.x - gesture.mid.x, mid.y - gesture.mid.y, gesture.rect);
          self._zoomAt(mid.x, mid.y, self.crop.zoom * (dist / gesture.dist));
          gesture.dist = dist;
          gesture.mid = mid;
        } else if (gesture.last) {
          self._panBy(e.clientX - gesture.last.x, e.clientY - gesture.last.y, gesture.rect);
          gesture.last = { x: e.clientX, y: e.clientY };
        }
      };
      this._onPointerUp = function (e) {
        if (!pointers[e.pointerId]) return;
        delete pointers[e.pointerId];
        try {
          if (self.frame.hasPointerCapture(e.pointerId)) self.frame.releasePointerCapture(e.pointerId);
        } catch (_e) {}
        // A finger lifted mid-pinch: the other carries on panning.
        startGesture();
        if (!gesture) {
          self.frame.style.cursor = "grab";
          self._push();
        }
      };
      // A wheel notch, a trackpad scroll or a trackpad pinch (ctrlKey)
      // zooms toward the cursor, in proportion to how far it turned, so a
      // trackpad is smooth and a mouse steps.
      this._onWheel = function (e) {
        e.preventDefault();
        var dy = e.deltaY;
        if (e.deltaMode === 1) dy *= 40;
        else if (e.deltaMode === 2) dy *= 800;
        var k = Math.exp(-dy * (e.ctrlKey ? 0.01 : 0.0015));
        self._zoomAt(e.clientX, e.clientY, self.crop.zoom * k);
        clearTimeout(self._wheelTimer);
        self._wheelTimer = setTimeout(function () {
          self._push();
        }, 250);
      };

      this.frame.addEventListener("pointerdown", this._onPointerDown);
      this.frame.addEventListener("pointermove", this._onPointerMove);
      this.frame.addEventListener("pointerup", this._onPointerUp);
      this.frame.addEventListener("pointercancel", this._onPointerUp);
      this.frame.addEventListener("wheel", this._onWheel, { passive: false });

      // The wheel push is debounced, so a Save clicked inside the window
      // would persist the pre-wheel crop — and the modal's teardown would
      // cancel the pending push outright. Flushing on the Save button's
      // capture phase puts the final crop on the wire before the phx-click
      // does; same websocket, so order is guaranteed.
      this._saveBtn =
        (this.el.closest("dialog") || document).querySelector("[data-crop-save-btn]");
      this._onSaveClick = function () {
        if (self._wheelTimer) {
          clearTimeout(self._wheelTimer);
          self._wheelTimer = null;
          self._push();
        }
      };
      if (this._saveBtn) {
        this._saveBtn.addEventListener("click", this._onSaveClick, true);
      }

      this._render();
    },

    _render() {
      var l = avatarCropLayout(this.crop);
      this.img.style.width = l.width + "%";
      this.img.style.height = l.height + "%";
      this.img.style.left = l.left + "%";
      this.img.style.top = l.top + "%";
    },

    _push() {
      // phx-target on the element routes this to the owning LiveComponent.
      this.pushEventTo(this.el, "avatar_crop_changed", {
        x: this.crop.x,
        y: this.crop.y,
        zoom: this.crop.zoom,
        ar: this.crop.ar
      });
    },

    destroyed() {
      clearTimeout(this._wheelTimer);
      if (this._saveBtn) {
        this._saveBtn.removeEventListener("click", this._onSaveClick, true);
      }
      if (this.frame) {
        this.frame.removeEventListener("pointerdown", this._onPointerDown);
        this.frame.removeEventListener("pointermove", this._onPointerMove);
        this.frame.removeEventListener("pointerup", this._onPointerUp);
        this.frame.removeEventListener("pointercancel", this._onPointerUp);
        this.frame.removeEventListener("wheel", this._onWheel);
      }
    }
  };

  // Exported for the Node test harness (test/js); harmless in a browser.
  if (typeof module === "object" && module.exports) {
    module.exports.avatarCropLayout = avatarCropLayout;
    module.exports.clampAvatarCropFocal = clampAvatarCropFocal;
  }
})();

// ---------------------------------------------------------------------------
// ImageEditor — drawing on the image editor's preview.
//
// The editor (PhoenixKitWeb.Components.ImageEditor) is a complete form
// without this hook: crop and redaction areas are percentage fields. The
// hook lets you draw them instead: a drag on the preview frame becomes a
// rectangle in percent of the frame, pushed to the owning LiveComponent
// (the element carries phx-target) as "drawn". With a crop aspect chosen
// (data-aspect "w/h"), the rectangle keeps that shape.
//
// It also reports the preview's natural size: the recorded dimensions of
// an older upload are its stored pixels', which for a photo with an EXIF
// rotation are the displayed ones turned a quarter.
// ---------------------------------------------------------------------------
(function () {
  if (window.PhoenixKitImageEditor) return;
  window.PhoenixKitImageEditor = true;
  window.PhoenixKitHooks = window.PhoenixKitHooks || {};

  function clamp(v, lo, hi) {
    return Math.min(hi, Math.max(lo, v));
  }

  // The rectangle spanned by two points (percent of the frame), kept inside
  // the frame. `aspect` is [w, h] in pixels and `frame` the frame's pixel
  // size: the rectangle then has that shape, grown from `start` toward
  // `end` and shrunk (not distorted) where it would leave the frame.
  function imageEditorRect(start, end, aspect, frame) {
    var a = { x: clamp(start.x, 0, 100), y: clamp(start.y, 0, 100) };
    var b = { x: clamp(end.x, 0, 100), y: clamp(end.y, 0, 100) };

    if (!aspect || !frame) {
      return {
        x: Math.min(a.x, b.x),
        y: Math.min(a.y, b.y),
        w: Math.abs(b.x - a.x),
        h: Math.abs(b.y - a.y)
      };
    }

    var ratio = aspect[0] / aspect[1];
    var dirX = b.x < a.x ? -1 : 1;
    var dirY = b.y < a.y ? -1 : 1;
    // Room from the start point to the frame edge in the drag direction, px.
    var roomW = ((dirX < 0 ? a.x : 100 - a.x) / 100) * frame[0];
    var roomH = ((dirY < 0 ? a.y : 100 - a.y) / 100) * frame[1];

    var wPx = (Math.abs(b.x - a.x) / 100) * frame[0];
    var hPx = (Math.abs(b.y - a.y) / 100) * frame[1];
    // The larger side of the drag decides the size.
    if (wPx / ratio >= hPx) {
      hPx = wPx / ratio;
    } else {
      wPx = hPx * ratio;
    }
    // Shrink to fit, keeping the shape.
    var fit = Math.min(1, wPx > 0 ? roomW / wPx : 1, hPx > 0 ? roomH / hPx : 1);
    wPx *= fit;
    hPx *= fit;

    var w = (wPx / frame[0]) * 100;
    var h = (hPx / frame[1]) * 100;
    return {
      x: dirX < 0 ? a.x - w : a.x,
      y: dirY < 0 ? a.y - h : a.y,
      w: w,
      h: h
    };
  }

  // Whether an image of natural size `natural` shows the recorded `size`
  // turned a quarter: its shape matches the swapped size clearly better than
  // the size itself (within 2%). Square images never are.
  function imageEditorSwapped(size, natural) {
    if (!size || !natural || !natural[0] || !natural[1]) return false;
    var shown = natural[0] / natural[1];
    var recorded = size[0] / size[1];
    var turned = size[1] / size[0];
    if (Math.abs(recorded - turned) < 0.02 * turned) return false;
    return Math.abs(shown - turned) < 0.02 * turned &&
      Math.abs(shown - turned) < Math.abs(shown - recorded);
  }

  window.PhoenixKitHooks.ImageEditor = {
    mounted() {
      var self = this;

      this._onPointerDown = function (e) {
        var tool = self.el.dataset.tool;
        if (e.button !== 0) return;
        if (tool !== "crop" && tool !== "redact") return;
        if (tool === "crop" && self.el.dataset.locked === "true") return;

        e.preventDefault();
        // One layout read per gesture: the frame cannot resize mid-drag.
        self._box = self.el.getBoundingClientRect();
        self._tool = tool;
        self._start = self._point(e);
        self.el.setPointerCapture(e.pointerId);
      };
      this._onPointerMove = function (e) {
        if (!self._start) return;
        self._show(self._rect(self._point(e)));
      };
      this._onPointerUp = function (e) {
        if (!self._start) return;
        var rect = self._rect(self._point(e));
        self._start = null;
        self._show(null);
        if (self.el.hasPointerCapture(e.pointerId)) {
          self.el.releasePointerCapture(e.pointerId);
        }
        // A click, not a drag.
        if (rect.w < 0.5 || rect.h < 0.5) return;
        self.pushEventTo(self.el, "drawn", {
          tool: self._tool,
          x: rect.x,
          y: rect.y,
          w: rect.w,
          h: rect.h
        });
      };
      this._onCancel = function () {
        self._start = null;
        self._show(null);
      };

      this.el.addEventListener("pointerdown", this._onPointerDown);
      this.el.addEventListener("pointermove", this._onPointerMove);
      this.el.addEventListener("pointerup", this._onPointerUp);
      this.el.addEventListener("pointercancel", this._onCancel);

      this._onImageLoad = function () {
        self._reportSize();
      };
      this._watchImage();
    },

    updated() {
      this._watchImage();
    },

    // The server resets the recorded size on every reload of the file (a
    // save, a finished render, a retry, a revert) while morphdom keeps the
    // same <img> node. Reporting only when the node changed left the frame at
    // the unturned aspect after any of those: a stretched preview, and crop
    // and redaction rectangles drawn against the wrong frame. So every update
    // re-checks a loaded image — `_reportSize` compares against the size the
    // server currently renders and stays quiet once they agree — and the load
    // listener stays on for a `src` swapped on the same node.
    _watchImage() {
      var img = this.el.querySelector("img");
      if (img !== this._img) {
        if (this._img) this._img.removeEventListener("load", this._onImageLoad);
        this._img = img;
        if (img) img.addEventListener("load", this._onImageLoad);
      }
      if (img && img.complete && img.naturalWidth > 0) this._reportSize();
    },

    _reportSize() {
      var img = this._img;
      var size = [parseFloat(this.el.dataset.sourceWidth), parseFloat(this.el.dataset.sourceHeight)];
      if (img && imageEditorSwapped(size, [img.naturalWidth, img.naturalHeight])) {
        this.pushEventTo(this.el, "turned_source", {});
      }
    },

    _point(e) {
      var box = this._box;
      return {
        x: ((e.clientX - box.left) / box.width) * 100,
        y: ((e.clientY - box.top) / box.height) * 100
      };
    },

    _rect(end) {
      var aspect = null;
      if (this._tool === "crop" && this.el.dataset.aspect) {
        aspect = this.el.dataset.aspect.split("/").map(Number);
      }
      var frame = [
        parseFloat(this.el.dataset.frameWidth),
        parseFloat(this.el.dataset.frameHeight)
      ];
      return imageEditorRect(this._start, end, aspect, frame);
    },

    _show(rect) {
      var draft = this.el.querySelector("[data-draft]");
      if (!draft) return;
      if (!rect) {
        draft.classList.add("hidden");
        return;
      }
      draft.classList.remove("hidden");
      draft.style.left = rect.x + "%";
      draft.style.top = rect.y + "%";
      draft.style.width = rect.w + "%";
      draft.style.height = rect.h + "%";
    },

    destroyed() {
      this.el.removeEventListener("pointerdown", this._onPointerDown);
      this.el.removeEventListener("pointermove", this._onPointerMove);
      this.el.removeEventListener("pointerup", this._onPointerUp);
      this.el.removeEventListener("pointercancel", this._onCancel);
      if (this._img) this._img.removeEventListener("load", this._onImageLoad);
    }
  };

  // Exported for the Node test harness (test/js); harmless in a browser.
  if (typeof module === "object" && module.exports) {
    module.exports.imageEditorRect = imageEditorRect;
    module.exports.imageEditorSwapped = imageEditorSwapped;
  }
})();

// ---------------------------------------------------------------------------
// PkChartCrosshair — the client half of `line_chart hover={:crosshair}`
// (PhoenixKitWeb.Components.Core.Chart). The server sends the rows once and
// one entry per datum, already positioned and formatted:
//
//   {rows: [[label, colour]], points: [[left%, right%, x%, y%, x_label,
//    y_label, note, [row index]]]}
//
// so this only finds the entry under the pointer (or the keyboard's) and
// places the crosshair, the dot and the readout. The hook sits on a
// pointer-events-none layer and listens on the chart wrapper (its parent),
// because a style it set on its own element would be dropped by the next
// patch.
(function () {
  if (typeof window === "undefined") return;
  window.PhoenixKitHooks = window.PhoenixKitHooks || {};

  var STYLE_ID = "pk-chart-crosshair-style";

  // The native per-point tooltips are the no-JavaScript readout; once the
  // hook runs they would show on top of the crosshair's, so turn them off.
  function ensureStyle() {
    if (typeof document === "undefined" || document.getElementById(STYLE_ID)) return;
    var style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = "[data-pk-crosshair] svg rect[data-x]{pointer-events:none}";
    document.head.appendChild(style);
  }

  // The entry whose band holds `pct` (0–100 across the chart), or -1 where
  // no datum stands (left of the first point of a step series).
  function crosshairPick(points, pct) {
    if (!points || !points.length) return -1;
    for (var i = 0; i < points.length; i++) {
      if (pct >= points[i][0] && pct < points[i][1]) return i;
    }
    // The right edge itself belongs to the last band.
    var last = points[points.length - 1];
    if (pct >= last[1] && pct <= 100) return points.length - 1;
    return -1;
  }

  // Which side of the line the readout goes: right of it, unless that would
  // run off the chart.
  function crosshairTipSide(xPct) {
    return xPct > 55 ? "left" : "right";
  }

  // The entry a key moves to from `current` (-1 = nothing shown), or null
  // for a key the chart does not handle.
  function crosshairStep(key, current, count) {
    if (!count) return null;
    switch (key) {
      case "ArrowRight":
        return current < 0 ? 0 : Math.min(current + 1, count - 1);
      case "ArrowLeft":
        return current < 0 ? count - 1 : Math.max(current - 1, 0);
      case "Home":
        return 0;
      case "End":
        return count - 1;
      default:
        return null;
    }
  }

  // The readout as plain text, for the live region.
  function crosshairText(point, rows) {
    var parts = [];
    if (point[4]) parts.push(point[4]);
    parts.push(point[5]);
    if (point[6]) parts.push(point[6]);
    (point[7] || []).forEach(function (i) {
      if (rows[i]) parts.push(rows[i][0]);
    });
    return parts.join(", ");
  }

  function line(tag, text, className) {
    var el = document.createElement(tag);
    el.textContent = text;
    if (className) el.className = className;
    return el;
  }

  window.PhoenixKitHooks.PkChartCrosshair = {
    mounted() {
      ensureStyle();
      this.host = this.el.parentElement;
      this.lineEl = this.el.querySelector("[data-crosshair-line]");
      this.dotEl = this.el.querySelector("[data-crosshair-dot]");
      this.tipEl = this.el.querySelector("[data-crosshair-tip]");
      this.liveEl = this.el.querySelector("[data-crosshair-live]");
      this.shown = -1;

      this.onMove = (event) => this.showAt(event.clientX);
      this.onDown = (event) => {
        this.pinned = event.pointerType === "touch";
        this.showAt(event.clientX);
      };
      // A finger lifting fires pointerleave at once; a tapped readout stays
      // up until a tap elsewhere.
      this.onLeave = (event) => {
        if (!(event && event.pointerType === "touch" && this.pinned)) this.hide();
      };
      this.onCancel = () => this.hide();
      this.onOutside = (event) => {
        if (this.shown >= 0 && !this.host.contains(event.target)) this.hide();
      };
      this.onKey = (event) => {
        if (event.key === "Escape") {
          if (this.shown >= 0) {
            this.hide();
            event.stopPropagation();
          }
          return;
        }
        var next = crosshairStep(event.key, this.shown, this.data().points.length);
        if (next === null) return;
        event.preventDefault();
        this.show(next, true);
      };
      this.onBlur = () => this.hide();

      this.host.addEventListener("pointermove", this.onMove);
      this.host.addEventListener("pointerdown", this.onDown);
      this.host.addEventListener("pointerleave", this.onLeave);
      this.host.addEventListener("pointercancel", this.onCancel);
      this.host.addEventListener("keydown", this.onKey);
      this.host.addEventListener("blur", this.onBlur);
      document.addEventListener("pointerdown", this.onOutside);
    },

    updated() {
      // New data: the entry on screen may be gone or moved.
      this.cache = null;
      this.hide();
    },

    data() {
      if (!this.cache) {
        try {
          var parsed = JSON.parse(this.el.dataset.points || "{}");
          this.cache = { rows: parsed.rows || [], points: parsed.points || [] };
        } catch (_err) {
          this.cache = { rows: [], points: [] };
        }
      }
      return this.cache;
    },

    showAt(clientX) {
      var rect = this.host.getBoundingClientRect();
      if (!rect.width) return;
      var i = crosshairPick(this.data().points, ((clientX - rect.left) / rect.width) * 100);
      if (i < 0) return this.hide();
      this.show(i, false);
    },

    show(i, announce) {
      if (i === this.shown) return;
      this.shown = i;
      var data = this.data();
      var p = data.points[i];

      this.lineEl.style.left = p[2] + "%";
      this.dotEl.style.left = p[2] + "%";
      this.dotEl.style.top = p[3] + "%";

      var tip = this.tipEl;
      tip.replaceChildren();
      if (p[4]) tip.appendChild(line("div", p[4], "opacity-70"));
      tip.appendChild(line("div", p[5], "font-semibold"));
      if (p[6]) tip.appendChild(line("div", p[6], "opacity-70"));
      (p[7] || []).forEach(function (index) {
        var row = data.rows[index];
        if (!row) return;
        var el = line("div", "", "flex items-center gap-1.5");
        var swatch = document.createElement("span");
        swatch.className = "inline-block w-2 h-2 rounded-full bg-current";
        if (row[1]) swatch.style.background = row[1];
        el.appendChild(swatch);
        el.appendChild(document.createTextNode(row[0]));
        tip.appendChild(el);
      });

      tip.style.left = p[2] + "%";
      tip.style.transform =
        crosshairTipSide(p[2]) === "right" ? "translateX(8px)" : "translateX(calc(-100% - 8px))";

      this.lineEl.hidden = false;
      this.dotEl.hidden = false;
      tip.hidden = false;
      // Only a keyboard step is announced; a pointer sweeping across the
      // chart would queue one announcement per band.
      if (announce && this.liveEl) this.liveEl.textContent = crosshairText(p, data.rows);
    },

    hide() {
      this.shown = -1;
      this.pinned = false;
      if (this.lineEl) this.lineEl.hidden = true;
      if (this.dotEl) this.dotEl.hidden = true;
      if (this.tipEl) this.tipEl.hidden = true;
    },

    destroyed() {
      document.removeEventListener("pointerdown", this.onOutside);
      if (!this.host) return;
      this.host.removeEventListener("pointermove", this.onMove);
      this.host.removeEventListener("pointerdown", this.onDown);
      this.host.removeEventListener("pointerleave", this.onLeave);
      this.host.removeEventListener("pointercancel", this.onCancel);
      this.host.removeEventListener("keydown", this.onKey);
      this.host.removeEventListener("blur", this.onBlur);
    }
  };

  // Exported for the Node test harness (test/js); harmless in a browser.
  if (typeof module === "object" && module.exports) {
    module.exports.crosshairPick = crosshairPick;
    module.exports.crosshairTipSide = crosshairTipSide;
    module.exports.crosshairStep = crosshairStep;
    module.exports.crosshairText = crosshairText;
  }
})();
